webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(301);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	(function(definition){if(true){module.exports=definition();}else if(typeof define==="function"&&define.amd){define(definition);}else{mori=definition();}})(function(){return function(){
	if(typeof Math.imul == "undefined" || (Math.imul(0xffffffff,5) == 0)) {
	    Math.imul = function (a, b) {
	        var ah  = (a >>> 16) & 0xffff;
	        var al = a & 0xffff;
	        var bh  = (b >>> 16) & 0xffff;
	        var bl = b & 0xffff;
	        // the shift by 0 fixes the sign on the high part
	        // the final |0 converts the unsigned value into a signed value
	        return ((al * bl) + (((ah * bl + al * bh) << 16) >>> 0)|0);
	    }
	}
	
	var k,aa=this;
	function n(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==
	b&&"undefined"==typeof a.call)return"object";return b}var ba="closure_uid_"+(1E9*Math.random()>>>0),ca=0;function r(a,b){var c=a.split("."),d=aa;c[0]in d||!d.execScript||d.execScript("var "+c[0]);for(var e;c.length&&(e=c.shift());)c.length||void 0===b?d=d[e]?d[e]:d[e]={}:d[e]=b};function da(a){return Array.prototype.join.call(arguments,"")};function ea(a,b){for(var c in a)b.call(void 0,a[c],c,a)};function fa(a,b){null!=a&&this.append.apply(this,arguments)}fa.prototype.Za="";fa.prototype.append=function(a,b,c){this.Za+=a;if(null!=b)for(var d=1;d<arguments.length;d++)this.Za+=arguments[d];return this};fa.prototype.clear=function(){this.Za=""};fa.prototype.toString=function(){return this.Za};function ga(a,b){a.sort(b||ha)}function ia(a,b){for(var c=0;c<a.length;c++)a[c]={index:c,value:a[c]};var d=b||ha;ga(a,function(a,b){return d(a.value,b.value)||a.index-b.index});for(c=0;c<a.length;c++)a[c]=a[c].value}function ha(a,b){return a>b?1:a<b?-1:0};var ja;if("undefined"===typeof ka)var ka=function(){throw Error("No *print-fn* fn set for evaluation environment");};var la=null,ma=null;if("undefined"===typeof na)var na=null;function oa(){return new pa(null,5,[sa,!0,ua,!0,wa,!1,ya,!1,za,la],null)}function t(a){return null!=a&&!1!==a}function Aa(a){return t(a)?!1:!0}function w(a,b){return a[n(null==b?null:b)]?!0:a._?!0:!1}function Ba(a){return null==a?null:a.constructor}
	function x(a,b){var c=Ba(b),c=t(t(c)?c.Yb:c)?c.Xb:n(b);return Error(["No protocol method ",a," defined for type ",c,": ",b].join(""))}function Da(a){var b=a.Xb;return t(b)?b:""+z(a)}var Ea="undefined"!==typeof Symbol&&"function"===n(Symbol)?Symbol.Cc:"@@iterator";function Fa(a){for(var b=a.length,c=Array(b),d=0;;)if(d<b)c[d]=a[d],d+=1;else break;return c}function Ha(a){for(var b=Array(arguments.length),c=0;;)if(c<b.length)b[c]=arguments[c],c+=1;else return b}
	var Ia=function(){function a(a,b){function c(a,b){a.push(b);return a}var g=[];return A.c?A.c(c,g,b):A.call(null,c,g,b)}function b(a){return c.a(null,a)}var c=null,c=function(d,c){switch(arguments.length){case 1:return b.call(this,d);case 2:return a.call(this,0,c)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Ja={},La={};function Ma(a){if(a?a.L:a)return a.L(a);var b;b=Ma[n(null==a?null:a)];if(!b&&(b=Ma._,!b))throw x("ICounted.-count",a);return b.call(null,a)}
	function Na(a){if(a?a.J:a)return a.J(a);var b;b=Na[n(null==a?null:a)];if(!b&&(b=Na._,!b))throw x("IEmptyableCollection.-empty",a);return b.call(null,a)}var Qa={};function Ra(a,b){if(a?a.G:a)return a.G(a,b);var c;c=Ra[n(null==a?null:a)];if(!c&&(c=Ra._,!c))throw x("ICollection.-conj",a);return c.call(null,a,b)}
	var Ta={},C=function(){function a(a,b,c){if(a?a.$:a)return a.$(a,b,c);var g;g=C[n(null==a?null:a)];if(!g&&(g=C._,!g))throw x("IIndexed.-nth",a);return g.call(null,a,b,c)}function b(a,b){if(a?a.Q:a)return a.Q(a,b);var c;c=C[n(null==a?null:a)];if(!c&&(c=C._,!c))throw x("IIndexed.-nth",a);return c.call(null,a,b)}var c=null,c=function(d,c,f){switch(arguments.length){case 2:return b.call(this,d,c);case 3:return a.call(this,d,c,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),
	Ua={};function Va(a){if(a?a.N:a)return a.N(a);var b;b=Va[n(null==a?null:a)];if(!b&&(b=Va._,!b))throw x("ISeq.-first",a);return b.call(null,a)}function Wa(a){if(a?a.S:a)return a.S(a);var b;b=Wa[n(null==a?null:a)];if(!b&&(b=Wa._,!b))throw x("ISeq.-rest",a);return b.call(null,a)}
	var Xa={},Za={},$a=function(){function a(a,b,c){if(a?a.s:a)return a.s(a,b,c);var g;g=$a[n(null==a?null:a)];if(!g&&(g=$a._,!g))throw x("ILookup.-lookup",a);return g.call(null,a,b,c)}function b(a,b){if(a?a.t:a)return a.t(a,b);var c;c=$a[n(null==a?null:a)];if(!c&&(c=$a._,!c))throw x("ILookup.-lookup",a);return c.call(null,a,b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=
	a;return c}(),ab={};function bb(a,b){if(a?a.rb:a)return a.rb(a,b);var c;c=bb[n(null==a?null:a)];if(!c&&(c=bb._,!c))throw x("IAssociative.-contains-key?",a);return c.call(null,a,b)}function cb(a,b,c){if(a?a.Ka:a)return a.Ka(a,b,c);var d;d=cb[n(null==a?null:a)];if(!d&&(d=cb._,!d))throw x("IAssociative.-assoc",a);return d.call(null,a,b,c)}var db={};function eb(a,b){if(a?a.wb:a)return a.wb(a,b);var c;c=eb[n(null==a?null:a)];if(!c&&(c=eb._,!c))throw x("IMap.-dissoc",a);return c.call(null,a,b)}var fb={};
	function hb(a){if(a?a.hb:a)return a.hb(a);var b;b=hb[n(null==a?null:a)];if(!b&&(b=hb._,!b))throw x("IMapEntry.-key",a);return b.call(null,a)}function ib(a){if(a?a.ib:a)return a.ib(a);var b;b=ib[n(null==a?null:a)];if(!b&&(b=ib._,!b))throw x("IMapEntry.-val",a);return b.call(null,a)}var jb={};function kb(a,b){if(a?a.Eb:a)return a.Eb(a,b);var c;c=kb[n(null==a?null:a)];if(!c&&(c=kb._,!c))throw x("ISet.-disjoin",a);return c.call(null,a,b)}
	function lb(a){if(a?a.La:a)return a.La(a);var b;b=lb[n(null==a?null:a)];if(!b&&(b=lb._,!b))throw x("IStack.-peek",a);return b.call(null,a)}function mb(a){if(a?a.Ma:a)return a.Ma(a);var b;b=mb[n(null==a?null:a)];if(!b&&(b=mb._,!b))throw x("IStack.-pop",a);return b.call(null,a)}var nb={};function pb(a,b,c){if(a?a.Ua:a)return a.Ua(a,b,c);var d;d=pb[n(null==a?null:a)];if(!d&&(d=pb._,!d))throw x("IVector.-assoc-n",a);return d.call(null,a,b,c)}
	function qb(a){if(a?a.Ra:a)return a.Ra(a);var b;b=qb[n(null==a?null:a)];if(!b&&(b=qb._,!b))throw x("IDeref.-deref",a);return b.call(null,a)}var rb={};function sb(a){if(a?a.H:a)return a.H(a);var b;b=sb[n(null==a?null:a)];if(!b&&(b=sb._,!b))throw x("IMeta.-meta",a);return b.call(null,a)}var tb={};function ub(a,b){if(a?a.F:a)return a.F(a,b);var c;c=ub[n(null==a?null:a)];if(!c&&(c=ub._,!c))throw x("IWithMeta.-with-meta",a);return c.call(null,a,b)}
	var vb={},wb=function(){function a(a,b,c){if(a?a.O:a)return a.O(a,b,c);var g;g=wb[n(null==a?null:a)];if(!g&&(g=wb._,!g))throw x("IReduce.-reduce",a);return g.call(null,a,b,c)}function b(a,b){if(a?a.R:a)return a.R(a,b);var c;c=wb[n(null==a?null:a)];if(!c&&(c=wb._,!c))throw x("IReduce.-reduce",a);return c.call(null,a,b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();
	function xb(a,b,c){if(a?a.gb:a)return a.gb(a,b,c);var d;d=xb[n(null==a?null:a)];if(!d&&(d=xb._,!d))throw x("IKVReduce.-kv-reduce",a);return d.call(null,a,b,c)}function yb(a,b){if(a?a.A:a)return a.A(a,b);var c;c=yb[n(null==a?null:a)];if(!c&&(c=yb._,!c))throw x("IEquiv.-equiv",a);return c.call(null,a,b)}function zb(a){if(a?a.B:a)return a.B(a);var b;b=zb[n(null==a?null:a)];if(!b&&(b=zb._,!b))throw x("IHash.-hash",a);return b.call(null,a)}var Bb={};
	function Cb(a){if(a?a.D:a)return a.D(a);var b;b=Cb[n(null==a?null:a)];if(!b&&(b=Cb._,!b))throw x("ISeqable.-seq",a);return b.call(null,a)}var Db={},Eb={},Fb={};function Gb(a){if(a?a.ab:a)return a.ab(a);var b;b=Gb[n(null==a?null:a)];if(!b&&(b=Gb._,!b))throw x("IReversible.-rseq",a);return b.call(null,a)}function Hb(a,b){if(a?a.Hb:a)return a.Hb(a,b);var c;c=Hb[n(null==a?null:a)];if(!c&&(c=Hb._,!c))throw x("ISorted.-sorted-seq",a);return c.call(null,a,b)}
	function Ib(a,b,c){if(a?a.Ib:a)return a.Ib(a,b,c);var d;d=Ib[n(null==a?null:a)];if(!d&&(d=Ib._,!d))throw x("ISorted.-sorted-seq-from",a);return d.call(null,a,b,c)}function Jb(a,b){if(a?a.Gb:a)return a.Gb(a,b);var c;c=Jb[n(null==a?null:a)];if(!c&&(c=Jb._,!c))throw x("ISorted.-entry-key",a);return c.call(null,a,b)}function Kb(a){if(a?a.Fb:a)return a.Fb(a);var b;b=Kb[n(null==a?null:a)];if(!b&&(b=Kb._,!b))throw x("ISorted.-comparator",a);return b.call(null,a)}
	function Lb(a,b){if(a?a.Wb:a)return a.Wb(0,b);var c;c=Lb[n(null==a?null:a)];if(!c&&(c=Lb._,!c))throw x("IWriter.-write",a);return c.call(null,a,b)}var Mb={};function Nb(a,b,c){if(a?a.v:a)return a.v(a,b,c);var d;d=Nb[n(null==a?null:a)];if(!d&&(d=Nb._,!d))throw x("IPrintWithWriter.-pr-writer",a);return d.call(null,a,b,c)}function Ob(a){if(a?a.$a:a)return a.$a(a);var b;b=Ob[n(null==a?null:a)];if(!b&&(b=Ob._,!b))throw x("IEditableCollection.-as-transient",a);return b.call(null,a)}
	function Pb(a,b){if(a?a.Sa:a)return a.Sa(a,b);var c;c=Pb[n(null==a?null:a)];if(!c&&(c=Pb._,!c))throw x("ITransientCollection.-conj!",a);return c.call(null,a,b)}function Qb(a){if(a?a.Ta:a)return a.Ta(a);var b;b=Qb[n(null==a?null:a)];if(!b&&(b=Qb._,!b))throw x("ITransientCollection.-persistent!",a);return b.call(null,a)}function Rb(a,b,c){if(a?a.kb:a)return a.kb(a,b,c);var d;d=Rb[n(null==a?null:a)];if(!d&&(d=Rb._,!d))throw x("ITransientAssociative.-assoc!",a);return d.call(null,a,b,c)}
	function Sb(a,b){if(a?a.Jb:a)return a.Jb(a,b);var c;c=Sb[n(null==a?null:a)];if(!c&&(c=Sb._,!c))throw x("ITransientMap.-dissoc!",a);return c.call(null,a,b)}function Tb(a,b,c){if(a?a.Ub:a)return a.Ub(0,b,c);var d;d=Tb[n(null==a?null:a)];if(!d&&(d=Tb._,!d))throw x("ITransientVector.-assoc-n!",a);return d.call(null,a,b,c)}function Ub(a){if(a?a.Vb:a)return a.Vb();var b;b=Ub[n(null==a?null:a)];if(!b&&(b=Ub._,!b))throw x("ITransientVector.-pop!",a);return b.call(null,a)}
	function Vb(a,b){if(a?a.Tb:a)return a.Tb(0,b);var c;c=Vb[n(null==a?null:a)];if(!c&&(c=Vb._,!c))throw x("ITransientSet.-disjoin!",a);return c.call(null,a,b)}function Xb(a){if(a?a.Pb:a)return a.Pb();var b;b=Xb[n(null==a?null:a)];if(!b&&(b=Xb._,!b))throw x("IChunk.-drop-first",a);return b.call(null,a)}function Yb(a){if(a?a.Cb:a)return a.Cb(a);var b;b=Yb[n(null==a?null:a)];if(!b&&(b=Yb._,!b))throw x("IChunkedSeq.-chunked-first",a);return b.call(null,a)}
	function Zb(a){if(a?a.Db:a)return a.Db(a);var b;b=Zb[n(null==a?null:a)];if(!b&&(b=Zb._,!b))throw x("IChunkedSeq.-chunked-rest",a);return b.call(null,a)}function $b(a){if(a?a.Bb:a)return a.Bb(a);var b;b=$b[n(null==a?null:a)];if(!b&&(b=$b._,!b))throw x("IChunkedNext.-chunked-next",a);return b.call(null,a)}function ac(a,b){if(a?a.bb:a)return a.bb(0,b);var c;c=ac[n(null==a?null:a)];if(!c&&(c=ac._,!c))throw x("IVolatile.-vreset!",a);return c.call(null,a,b)}var bc={};
	function cc(a){if(a?a.fb:a)return a.fb(a);var b;b=cc[n(null==a?null:a)];if(!b&&(b=cc._,!b))throw x("IIterable.-iterator",a);return b.call(null,a)}function dc(a){this.qc=a;this.q=0;this.j=1073741824}dc.prototype.Wb=function(a,b){return this.qc.append(b)};function ec(a){var b=new fa;a.v(null,new dc(b),oa());return""+z(b)}
	var fc="undefined"!==typeof Math.imul&&0!==(Math.imul.a?Math.imul.a(4294967295,5):Math.imul.call(null,4294967295,5))?function(a,b){return Math.imul.a?Math.imul.a(a,b):Math.imul.call(null,a,b)}:function(a,b){var c=a&65535,d=b&65535;return c*d+((a>>>16&65535)*d+c*(b>>>16&65535)<<16>>>0)|0};function gc(a){a=fc(a,3432918353);return fc(a<<15|a>>>-15,461845907)}function hc(a,b){var c=a^b;return fc(c<<13|c>>>-13,5)+3864292196}
	function ic(a,b){var c=a^b,c=fc(c^c>>>16,2246822507),c=fc(c^c>>>13,3266489909);return c^c>>>16}var kc={},lc=0;function mc(a){255<lc&&(kc={},lc=0);var b=kc[a];if("number"!==typeof b){a:if(null!=a)if(b=a.length,0<b){for(var c=0,d=0;;)if(c<b)var e=c+1,d=fc(31,d)+a.charCodeAt(c),c=e;else{b=d;break a}b=void 0}else b=0;else b=0;kc[a]=b;lc+=1}return a=b}
	function nc(a){a&&(a.j&4194304||a.vc)?a=a.B(null):"number"===typeof a?a=(Math.floor.b?Math.floor.b(a):Math.floor.call(null,a))%2147483647:!0===a?a=1:!1===a?a=0:"string"===typeof a?(a=mc(a),0!==a&&(a=gc(a),a=hc(0,a),a=ic(a,4))):a=a instanceof Date?a.valueOf():null==a?0:zb(a);return a}
	function oc(a){var b;b=a.name;var c;a:{c=1;for(var d=0;;)if(c<b.length){var e=c+2,d=hc(d,gc(b.charCodeAt(c-1)|b.charCodeAt(c)<<16));c=e}else{c=d;break a}c=void 0}c=1===(b.length&1)?c^gc(b.charCodeAt(b.length-1)):c;b=ic(c,fc(2,b.length));a=mc(a.ba);return b^a+2654435769+(b<<6)+(b>>2)}function pc(a,b){if(a.ta===b.ta)return 0;var c=Aa(a.ba);if(t(c?b.ba:c))return-1;if(t(a.ba)){if(Aa(b.ba))return 1;c=ha(a.ba,b.ba);return 0===c?ha(a.name,b.name):c}return ha(a.name,b.name)}
	function qc(a,b,c,d,e){this.ba=a;this.name=b;this.ta=c;this.Ya=d;this.Z=e;this.j=2154168321;this.q=4096}k=qc.prototype;k.v=function(a,b){return Lb(b,this.ta)};k.B=function(){var a=this.Ya;return null!=a?a:this.Ya=a=oc(this)};k.F=function(a,b){return new qc(this.ba,this.name,this.ta,this.Ya,b)};k.H=function(){return this.Z};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return $a.c(c,this,null);case 3:return $a.c(c,this,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return $a.c(c,this,null)};a.c=function(a,c,d){return $a.c(c,this,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return $a.c(a,this,null)};k.a=function(a,b){return $a.c(a,this,b)};k.A=function(a,b){return b instanceof qc?this.ta===b.ta:!1};
	k.toString=function(){return this.ta};var rc=function(){function a(a,b){var c=null!=a?[z(a),z("/"),z(b)].join(""):b;return new qc(a,b,c,null,null)}function b(a){return a instanceof qc?a:c.a(null,a)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();
	function D(a){if(null==a)return null;if(a&&(a.j&8388608||a.mc))return a.D(null);if(a instanceof Array||"string"===typeof a)return 0===a.length?null:new F(a,0);if(w(Bb,a))return Cb(a);throw Error([z(a),z(" is not ISeqable")].join(""));}function G(a){if(null==a)return null;if(a&&(a.j&64||a.jb))return a.N(null);a=D(a);return null==a?null:Va(a)}function H(a){return null!=a?a&&(a.j&64||a.jb)?a.S(null):(a=D(a))?Wa(a):J:J}function K(a){return null==a?null:a&&(a.j&128||a.xb)?a.T(null):D(H(a))}
	var sc=function(){function a(a,b){return null==a?null==b:a===b||yb(a,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){for(;;)if(b.a(a,d))if(K(e))a=d,d=G(e),e=K(e);else return b.a(d,G(e));else return!1}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return!0;
	case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(){return!0};b.a=a;b.d=c.d;return b}();function tc(a){this.C=a}tc.prototype.next=function(){if(null!=this.C){var a=G(this.C);this.C=K(this.C);return{done:!1,value:a}}return{done:!0,value:null}};function uc(a){return new tc(D(a))}
	function vc(a,b){var c=gc(a),c=hc(0,c);return ic(c,b)}function wc(a){var b=0,c=1;for(a=D(a);;)if(null!=a)b+=1,c=fc(31,c)+nc(G(a))|0,a=K(a);else return vc(c,b)}function xc(a){var b=0,c=0;for(a=D(a);;)if(null!=a)b+=1,c=c+nc(G(a))|0,a=K(a);else return vc(c,b)}La["null"]=!0;Ma["null"]=function(){return 0};Date.prototype.A=function(a,b){return b instanceof Date&&this.toString()===b.toString()};yb.number=function(a,b){return a===b};rb["function"]=!0;sb["function"]=function(){return null};
	Ja["function"]=!0;zb._=function(a){return a[ba]||(a[ba]=++ca)};function yc(a){this.o=a;this.q=0;this.j=32768}yc.prototype.Ra=function(){return this.o};function Ac(a){return a instanceof yc}function Bc(a){return Ac(a)?L.b?L.b(a):L.call(null,a):a}function L(a){return qb(a)}
	var Cc=function(){function a(a,b,c,d){for(var l=Ma(a);;)if(d<l){var m=C.a(a,d);c=b.a?b.a(c,m):b.call(null,c,m);if(Ac(c))return qb(c);d+=1}else return c}function b(a,b,c){var d=Ma(a),l=c;for(c=0;;)if(c<d){var m=C.a(a,c),l=b.a?b.a(l,m):b.call(null,l,m);if(Ac(l))return qb(l);c+=1}else return l}function c(a,b){var c=Ma(a);if(0===c)return b.l?b.l():b.call(null);for(var d=C.a(a,0),l=1;;)if(l<c){var m=C.a(a,l),d=b.a?b.a(d,m):b.call(null,d,m);if(Ac(d))return qb(d);l+=1}else return d}var d=null,d=function(d,
	f,g,h){switch(arguments.length){case 2:return c.call(this,d,f);case 3:return b.call(this,d,f,g);case 4:return a.call(this,d,f,g,h)}throw Error("Invalid arity: "+arguments.length);};d.a=c;d.c=b;d.n=a;return d}(),Dc=function(){function a(a,b,c,d){for(var l=a.length;;)if(d<l){var m=a[d];c=b.a?b.a(c,m):b.call(null,c,m);if(Ac(c))return qb(c);d+=1}else return c}function b(a,b,c){var d=a.length,l=c;for(c=0;;)if(c<d){var m=a[c],l=b.a?b.a(l,m):b.call(null,l,m);if(Ac(l))return qb(l);c+=1}else return l}function c(a,
	b){var c=a.length;if(0===a.length)return b.l?b.l():b.call(null);for(var d=a[0],l=1;;)if(l<c){var m=a[l],d=b.a?b.a(d,m):b.call(null,d,m);if(Ac(d))return qb(d);l+=1}else return d}var d=null,d=function(d,f,g,h){switch(arguments.length){case 2:return c.call(this,d,f);case 3:return b.call(this,d,f,g);case 4:return a.call(this,d,f,g,h)}throw Error("Invalid arity: "+arguments.length);};d.a=c;d.c=b;d.n=a;return d}();function Ec(a){return a?a.j&2||a.cc?!0:a.j?!1:w(La,a):w(La,a)}
	function Fc(a){return a?a.j&16||a.Qb?!0:a.j?!1:w(Ta,a):w(Ta,a)}function Gc(a,b){this.e=a;this.m=b}Gc.prototype.ga=function(){return this.m<this.e.length};Gc.prototype.next=function(){var a=this.e[this.m];this.m+=1;return a};function F(a,b){this.e=a;this.m=b;this.j=166199550;this.q=8192}k=F.prototype;k.toString=function(){return ec(this)};k.Q=function(a,b){var c=b+this.m;return c<this.e.length?this.e[c]:null};k.$=function(a,b,c){a=b+this.m;return a<this.e.length?this.e[a]:c};k.vb=!0;
	k.fb=function(){return new Gc(this.e,this.m)};k.T=function(){return this.m+1<this.e.length?new F(this.e,this.m+1):null};k.L=function(){return this.e.length-this.m};k.ab=function(){var a=Ma(this);return 0<a?new Hc(this,a-1,null):null};k.B=function(){return wc(this)};k.A=function(a,b){return Ic.a?Ic.a(this,b):Ic.call(null,this,b)};k.J=function(){return J};k.R=function(a,b){return Dc.n(this.e,b,this.e[this.m],this.m+1)};k.O=function(a,b,c){return Dc.n(this.e,b,c,this.m)};k.N=function(){return this.e[this.m]};
	k.S=function(){return this.m+1<this.e.length?new F(this.e,this.m+1):J};k.D=function(){return this};k.G=function(a,b){return M.a?M.a(b,this):M.call(null,b,this)};F.prototype[Ea]=function(){return uc(this)};
	var Jc=function(){function a(a,b){return b<a.length?new F(a,b):null}function b(a){return c.a(a,0)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Kc=function(){function a(a,b){return Jc.a(a,b)}function b(a){return Jc.a(a,0)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+
	arguments.length);};c.b=b;c.a=a;return c}();function Hc(a,b,c){this.qb=a;this.m=b;this.k=c;this.j=32374990;this.q=8192}k=Hc.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.T=function(){return 0<this.m?new Hc(this.qb,this.m-1,null):null};k.L=function(){return this.m+1};k.B=function(){return wc(this)};k.A=function(a,b){return Ic.a?Ic.a(this,b):Ic.call(null,this,b)};k.J=function(){var a=this.k;return O.a?O.a(J,a):O.call(null,J,a)};
	k.R=function(a,b){return P.a?P.a(b,this):P.call(null,b,this)};k.O=function(a,b,c){return P.c?P.c(b,c,this):P.call(null,b,c,this)};k.N=function(){return C.a(this.qb,this.m)};k.S=function(){return 0<this.m?new Hc(this.qb,this.m-1,null):J};k.D=function(){return this};k.F=function(a,b){return new Hc(this.qb,this.m,b)};k.G=function(a,b){return M.a?M.a(b,this):M.call(null,b,this)};Hc.prototype[Ea]=function(){return uc(this)};function Lc(a){return G(K(a))}yb._=function(a,b){return a===b};
	var Nc=function(){function a(a,b){return null!=a?Ra(a,b):Ra(J,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){for(;;)if(t(e))a=b.a(a,d),d=G(e),e=K(e);else return b.a(a,d)}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 0:return Mc;case 1:return b;
	case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.l=function(){return Mc};b.b=function(a){return a};b.a=a;b.d=c.d;return b}();function Oc(a){return null==a?null:Na(a)}
	function Q(a){if(null!=a)if(a&&(a.j&2||a.cc))a=a.L(null);else if(a instanceof Array)a=a.length;else if("string"===typeof a)a=a.length;else if(w(La,a))a=Ma(a);else a:{a=D(a);for(var b=0;;){if(Ec(a)){a=b+Ma(a);break a}a=K(a);b+=1}a=void 0}else a=0;return a}
	var Pc=function(){function a(a,b,c){for(;;){if(null==a)return c;if(0===b)return D(a)?G(a):c;if(Fc(a))return C.c(a,b,c);if(D(a))a=K(a),b-=1;else return c}}function b(a,b){for(;;){if(null==a)throw Error("Index out of bounds");if(0===b){if(D(a))return G(a);throw Error("Index out of bounds");}if(Fc(a))return C.a(a,b);if(D(a)){var c=K(a),g=b-1;a=c;b=g}else throw Error("Index out of bounds");}}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,
	c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),R=function(){function a(a,b,c){if("number"!==typeof b)throw Error("index argument to nth must be a number.");if(null==a)return c;if(a&&(a.j&16||a.Qb))return a.$(null,b,c);if(a instanceof Array||"string"===typeof a)return b<a.length?a[b]:c;if(w(Ta,a))return C.a(a,b);if(a?a.j&64||a.jb||(a.j?0:w(Ua,a)):w(Ua,a))return Pc.c(a,b,c);throw Error([z("nth not supported on this type "),z(Da(Ba(a)))].join(""));}function b(a,b){if("number"!==
	typeof b)throw Error("index argument to nth must be a number");if(null==a)return a;if(a&&(a.j&16||a.Qb))return a.Q(null,b);if(a instanceof Array||"string"===typeof a)return b<a.length?a[b]:null;if(w(Ta,a))return C.a(a,b);if(a?a.j&64||a.jb||(a.j?0:w(Ua,a)):w(Ua,a))return Pc.a(a,b);throw Error([z("nth not supported on this type "),z(Da(Ba(a)))].join(""));}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+
	arguments.length);};c.a=b;c.c=a;return c}(),S=function(){function a(a,b,c){return null!=a?a&&(a.j&256||a.Rb)?a.s(null,b,c):a instanceof Array?b<a.length?a[b]:c:"string"===typeof a?b<a.length?a[b]:c:w(Za,a)?$a.c(a,b,c):c:c}function b(a,b){return null==a?null:a&&(a.j&256||a.Rb)?a.t(null,b):a instanceof Array?b<a.length?a[b]:null:"string"===typeof a?b<a.length?a[b]:null:w(Za,a)?$a.a(a,b):null}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,
	c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),Rc=function(){function a(a,b,c){if(null!=a)a=cb(a,b,c);else a:{a=[b];c=[c];b=a.length;for(var g=0,h=Ob(Qc);;)if(g<b)var l=g+1,h=h.kb(null,a[g],c[g]),g=l;else{a=Qb(h);break a}a=void 0}return a}var b=null,c=function(){function a(b,d,h,l){var m=null;if(3<arguments.length){for(var m=0,p=Array(arguments.length-3);m<p.length;)p[m]=arguments[m+3],++m;m=new F(p,0)}return c.call(this,b,d,h,m)}function c(a,d,e,l){for(;;)if(a=b.c(a,
	d,e),t(l))d=G(l),e=Lc(l),l=K(K(l));else return a}a.i=3;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=K(a);var l=G(a);a=H(a);return c(b,d,l,a)};a.d=c;return a}(),b=function(b,e,f,g){switch(arguments.length){case 3:return a.call(this,b,e,f);default:var h=null;if(3<arguments.length){for(var h=0,l=Array(arguments.length-3);h<l.length;)l[h]=arguments[h+3],++h;h=new F(l,0)}return c.d(b,e,f,h)}throw Error("Invalid arity: "+arguments.length);};b.i=3;b.f=c.f;b.c=a;b.d=c.d;return b}(),Sc=function(){function a(a,
	b){return null==a?null:eb(a,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){for(;;){if(null==a)return null;a=b.a(a,d);if(t(e))d=G(e),e=K(e);else return a}}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return b;case 2:return a.call(this,b,e);
	default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(a){return a};b.a=a;b.d=c.d;return b}();function Tc(a){var b="function"==n(a);return t(b)?b:a?t(t(null)?null:a.bc)?!0:a.yb?!1:w(Ja,a):w(Ja,a)}function Uc(a,b){this.h=a;this.k=b;this.q=0;this.j=393217}k=Uc.prototype;
	k.call=function(){function a(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra,I){a=this.h;return T.ub?T.ub(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra,I):T.call(null,a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra,I)}function b(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra){a=this;return a.h.Fa?a.h.Fa(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra)}function c(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y){a=this;return a.h.Ea?a.h.Ea(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,
	Y):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y)}function d(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N){a=this;return a.h.Da?a.h.Da(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N)}function e(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E){a=this;return a.h.Ca?a.h.Ca(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E)}function f(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B){a=this;return a.h.Ba?a.h.Ba(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B):a.h.call(null,
	b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B)}function g(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y){a=this;return a.h.Aa?a.h.Aa(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y)}function h(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v){a=this;return a.h.za?a.h.za(b,c,d,e,f,g,h,l,m,p,q,u,s,v):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v)}function l(a,b,c,d,e,f,g,h,l,m,p,q,u,s){a=this;return a.h.ya?a.h.ya(b,c,d,e,f,g,h,l,m,p,q,u,s):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s)}function m(a,b,c,d,e,f,g,h,l,m,p,q,u){a=this;
	return a.h.xa?a.h.xa(b,c,d,e,f,g,h,l,m,p,q,u):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u)}function p(a,b,c,d,e,f,g,h,l,m,p,q){a=this;return a.h.wa?a.h.wa(b,c,d,e,f,g,h,l,m,p,q):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q)}function q(a,b,c,d,e,f,g,h,l,m,p){a=this;return a.h.va?a.h.va(b,c,d,e,f,g,h,l,m,p):a.h.call(null,b,c,d,e,f,g,h,l,m,p)}function s(a,b,c,d,e,f,g,h,l,m){a=this;return a.h.Ha?a.h.Ha(b,c,d,e,f,g,h,l,m):a.h.call(null,b,c,d,e,f,g,h,l,m)}function u(a,b,c,d,e,f,g,h,l){a=this;return a.h.Ga?a.h.Ga(b,c,
	d,e,f,g,h,l):a.h.call(null,b,c,d,e,f,g,h,l)}function v(a,b,c,d,e,f,g,h){a=this;return a.h.ia?a.h.ia(b,c,d,e,f,g,h):a.h.call(null,b,c,d,e,f,g,h)}function y(a,b,c,d,e,f,g){a=this;return a.h.P?a.h.P(b,c,d,e,f,g):a.h.call(null,b,c,d,e,f,g)}function B(a,b,c,d,e,f){a=this;return a.h.r?a.h.r(b,c,d,e,f):a.h.call(null,b,c,d,e,f)}function E(a,b,c,d,e){a=this;return a.h.n?a.h.n(b,c,d,e):a.h.call(null,b,c,d,e)}function N(a,b,c,d){a=this;return a.h.c?a.h.c(b,c,d):a.h.call(null,b,c,d)}function Y(a,b,c){a=this;
	return a.h.a?a.h.a(b,c):a.h.call(null,b,c)}function ra(a,b){a=this;return a.h.b?a.h.b(b):a.h.call(null,b)}function Pa(a){a=this;return a.h.l?a.h.l():a.h.call(null)}var I=null,I=function(I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd,De,Wf,dh){switch(arguments.length){case 1:return Pa.call(this,I);case 2:return ra.call(this,I,qa);case 3:return Y.call(this,I,qa,ta);case 4:return N.call(this,I,qa,ta,va);case 5:return E.call(this,I,qa,ta,va,xa);case 6:return B.call(this,I,qa,ta,va,xa,Ca);case 7:return y.call(this,
	I,qa,ta,va,xa,Ca,Ga);case 8:return v.call(this,I,qa,ta,va,xa,Ca,Ga,Ka);case 9:return u.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa);case 10:return s.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa);case 11:return q.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya);case 12:return p.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb);case 13:return m.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob);case 14:return l.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab);case 15:return h.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,
	ob,Ab,Wb);case 16:return g.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc);case 17:return f.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc);case 18:return e.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc);case 19:return d.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd);case 20:return c.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd,De);case 21:return b.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd,De,
	Wf);case 22:return a.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd,De,Wf,dh)}throw Error("Invalid arity: "+arguments.length);};I.b=Pa;I.a=ra;I.c=Y;I.n=N;I.r=E;I.P=B;I.ia=y;I.Ga=v;I.Ha=u;I.va=s;I.wa=q;I.xa=p;I.ya=m;I.za=l;I.Aa=h;I.Ba=g;I.Ca=f;I.Da=e;I.Ea=d;I.Fa=c;I.hc=b;I.ub=a;return I}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.l=function(){return this.h.l?this.h.l():this.h.call(null)};
	k.b=function(a){return this.h.b?this.h.b(a):this.h.call(null,a)};k.a=function(a,b){return this.h.a?this.h.a(a,b):this.h.call(null,a,b)};k.c=function(a,b,c){return this.h.c?this.h.c(a,b,c):this.h.call(null,a,b,c)};k.n=function(a,b,c,d){return this.h.n?this.h.n(a,b,c,d):this.h.call(null,a,b,c,d)};k.r=function(a,b,c,d,e){return this.h.r?this.h.r(a,b,c,d,e):this.h.call(null,a,b,c,d,e)};k.P=function(a,b,c,d,e,f){return this.h.P?this.h.P(a,b,c,d,e,f):this.h.call(null,a,b,c,d,e,f)};
	k.ia=function(a,b,c,d,e,f,g){return this.h.ia?this.h.ia(a,b,c,d,e,f,g):this.h.call(null,a,b,c,d,e,f,g)};k.Ga=function(a,b,c,d,e,f,g,h){return this.h.Ga?this.h.Ga(a,b,c,d,e,f,g,h):this.h.call(null,a,b,c,d,e,f,g,h)};k.Ha=function(a,b,c,d,e,f,g,h,l){return this.h.Ha?this.h.Ha(a,b,c,d,e,f,g,h,l):this.h.call(null,a,b,c,d,e,f,g,h,l)};k.va=function(a,b,c,d,e,f,g,h,l,m){return this.h.va?this.h.va(a,b,c,d,e,f,g,h,l,m):this.h.call(null,a,b,c,d,e,f,g,h,l,m)};
	k.wa=function(a,b,c,d,e,f,g,h,l,m,p){return this.h.wa?this.h.wa(a,b,c,d,e,f,g,h,l,m,p):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p)};k.xa=function(a,b,c,d,e,f,g,h,l,m,p,q){return this.h.xa?this.h.xa(a,b,c,d,e,f,g,h,l,m,p,q):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q)};k.ya=function(a,b,c,d,e,f,g,h,l,m,p,q,s){return this.h.ya?this.h.ya(a,b,c,d,e,f,g,h,l,m,p,q,s):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s)};
	k.za=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u){return this.h.za?this.h.za(a,b,c,d,e,f,g,h,l,m,p,q,s,u):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u)};k.Aa=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v){return this.h.Aa?this.h.Aa(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v)};k.Ba=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y){return this.h.Ba?this.h.Ba(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y)};
	k.Ca=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B){return this.h.Ca?this.h.Ca(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B)};k.Da=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E){return this.h.Da?this.h.Da(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E)};
	k.Ea=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N){return this.h.Ea?this.h.Ea(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N)};k.Fa=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y){return this.h.Fa?this.h.Fa(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y)};
	k.hc=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra){var Pa=this.h;return T.ub?T.ub(Pa,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra):T.call(null,Pa,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra)};k.bc=!0;k.F=function(a,b){return new Uc(this.h,b)};k.H=function(){return this.k};function O(a,b){return Tc(a)&&!(a?a.j&262144||a.Bc||(a.j?0:w(tb,a)):w(tb,a))?new Uc(a,b):null==a?null:ub(a,b)}function Vc(a){var b=null!=a;return(b?a?a.j&131072||a.kc||(a.j?0:w(rb,a)):w(rb,a):b)?sb(a):null}
	function Wc(a){return null==a?null:lb(a)}
	var Xc=function(){function a(a,b){return null==a?null:kb(a,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){for(;;){if(null==a)return null;a=b.a(a,d);if(t(e))d=G(e),e=K(e);else return a}}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return b;case 2:return a.call(this,
	b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(a){return a};b.a=a;b.d=c.d;return b}();function Yc(a){return null==a||Aa(D(a))}function $c(a){return null==a?!1:a?a.j&8||a.tc?!0:a.j?!1:w(Qa,a):w(Qa,a)}function ad(a){return null==a?!1:a?a.j&4096||a.zc?!0:a.j?!1:w(jb,a):w(jb,a)}
	function bd(a){return a?a.j&512||a.rc?!0:a.j?!1:w(ab,a):w(ab,a)}function cd(a){return a?a.j&16777216||a.yc?!0:a.j?!1:w(Db,a):w(Db,a)}function dd(a){return null==a?!1:a?a.j&1024||a.ic?!0:a.j?!1:w(db,a):w(db,a)}function ed(a){return a?a.j&16384||a.Ac?!0:a.j?!1:w(nb,a):w(nb,a)}function fd(a){return a?a.q&512||a.sc?!0:!1:!1}function gd(a){var b=[];ea(a,function(a,b){return function(a,c){return b.push(c)}}(a,b));return b}function hd(a,b,c,d,e){for(;0!==e;)c[d]=a[b],d+=1,e-=1,b+=1}
	function id(a,b,c,d,e){b+=e-1;for(d+=e-1;0!==e;)c[d]=a[b],d-=1,e-=1,b-=1}var jd={};function kd(a){return null==a?!1:a?a.j&64||a.jb?!0:a.j?!1:w(Ua,a):w(Ua,a)}function ld(a){return a?a.j&8388608||a.mc?!0:a.j?!1:w(Bb,a):w(Bb,a)}function md(a){return t(a)?!0:!1}function nd(a,b){return S.c(a,b,jd)===jd?!1:!0}
	function od(a,b){if(a===b)return 0;if(null==a)return-1;if(null==b)return 1;if(Ba(a)===Ba(b))return a&&(a.q&2048||a.sb)?a.tb(null,b):ha(a,b);throw Error("compare on non-nil objects of different types");}
	var pd=function(){function a(a,b,c,g){for(;;){var h=od(R.a(a,g),R.a(b,g));if(0===h&&g+1<c)g+=1;else return h}}function b(a,b){var f=Q(a),g=Q(b);return f<g?-1:f>g?1:c.n(a,b,f,0)}var c=null,c=function(c,e,f,g){switch(arguments.length){case 2:return b.call(this,c,e);case 4:return a.call(this,c,e,f,g)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.n=a;return c}();
	function qd(a){return sc.a(a,od)?od:function(b,c){var d=a.a?a.a(b,c):a.call(null,b,c);return"number"===typeof d?d:t(d)?-1:t(a.a?a.a(c,b):a.call(null,c,b))?1:0}}
	var sd=function(){function a(a,b){if(D(b)){var c=rd.b?rd.b(b):rd.call(null,b),g=qd(a);ia(c,g);return D(c)}return J}function b(a){return c.a(od,a)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),td=function(){function a(a,b,c){return sd.a(function(c,f){return qd(b).call(null,a.b?a.b(c):a.call(null,c),a.b?a.b(f):a.call(null,f))},c)}function b(a,b){return c.c(a,od,
	b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),P=function(){function a(a,b,c){for(c=D(c);;)if(c){var g=G(c);b=a.a?a.a(b,g):a.call(null,b,g);if(Ac(b))return qb(b);c=K(c)}else return b}function b(a,b){var c=D(b);if(c){var g=G(c),c=K(c);return A.c?A.c(a,g,c):A.call(null,a,g,c)}return a.l?a.l():a.call(null)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,
	c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),A=function(){function a(a,b,c){return c&&(c.j&524288||c.Sb)?c.O(null,a,b):c instanceof Array?Dc.c(c,a,b):"string"===typeof c?Dc.c(c,a,b):w(vb,c)?wb.c(c,a,b):P.c(a,b,c)}function b(a,b){return b&&(b.j&524288||b.Sb)?b.R(null,a):b instanceof Array?Dc.a(b,a):"string"===typeof b?Dc.a(b,a):w(vb,b)?wb.a(b,a):P.a(a,b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,
	c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();function ud(a){return a}
	var vd=function(){function a(a,b){return function(){function c(b,e){return a.a?a.a(b,e):a.call(null,b,e)}function g(a){return b.b?b.b(a):b.call(null,a)}function h(){return a.l?a.l():a.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);case 1:return g.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};l.l=h;l.b=g;l.a=c;return l}()}function b(a){return c.a(a,ud)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,
	c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),wd=function(){function a(a,b,c,g){a=a.b?a.b(b):a.call(null,b);c=A.c(a,c,g);return a.b?a.b(c):a.call(null,c)}function b(a,b,f){return c.n(a,b,b.l?b.l():b.call(null),f)}var c=null,c=function(c,e,f,g){switch(arguments.length){case 3:return b.call(this,c,e,f);case 4:return a.call(this,c,e,f,g)}throw Error("Invalid arity: "+arguments.length);};c.c=b;c.n=a;return c}(),xd=function(){var a=null,b=function(){function b(a,
	c,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return d.call(this,a,c,h)}function d(b,c,d){return A.c(a,b+c,d)}b.i=2;b.f=function(a){var b=G(a);a=K(a);var c=G(a);a=H(a);return d(b,c,a)};b.d=d;return b}(),a=function(a,d,e){switch(arguments.length){case 0:return 0;case 1:return a;case 2:return a+d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,
	0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.l=function(){return 0};a.b=function(a){return a};a.a=function(a,b){return a+b};a.d=b.d;return a}(),yd=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a<c)if(K(d))a=c,c=G(d),d=K(d);else return c<G(d);else return!1}a.i=2;a.f=function(a){var c=
	G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 1:return!0;case 2:return a<d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.b=function(){return!0};a.a=function(a,b){return a<b};a.d=b.d;return a}(),zd=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<
	arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a<=c)if(K(d))a=c,c=G(d),d=K(d);else return c<=G(d);else return!1}a.i=2;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 1:return!0;case 2:return a<=d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+
	2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.b=function(){return!0};a.a=function(a,b){return a<=b};a.d=b.d;return a}(),Ad=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a>c)if(K(d))a=c,c=G(d),d=K(d);else return c>G(d);else return!1}a.i=2;a.f=function(a){var c=
	G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 1:return!0;case 2:return a>d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.b=function(){return!0};a.a=function(a,b){return a>b};a.d=b.d;return a}(),Bd=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<
	arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a>=c)if(K(d))a=c,c=G(d),d=K(d);else return c>=G(d);else return!1}a.i=2;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 1:return!0;case 2:return a>=d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+
	2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.b=function(){return!0};a.a=function(a,b){return a>=b};a.d=b.d;return a}();function Cd(a,b){var c=(a-a%b)/b;return 0<=c?Math.floor.b?Math.floor.b(c):Math.floor.call(null,c):Math.ceil.b?Math.ceil.b(c):Math.ceil.call(null,c)}function Dd(a){a-=a>>1&1431655765;a=(a&858993459)+(a>>2&858993459);return 16843009*(a+(a>>4)&252645135)>>24}
	function Ed(a){var b=1;for(a=D(a);;)if(a&&0<b)b-=1,a=K(a);else return a}
	var z=function(){function a(a){return null==a?"":da(a)}var b=null,c=function(){function a(b,d){var h=null;if(1<arguments.length){for(var h=0,l=Array(arguments.length-1);h<l.length;)l[h]=arguments[h+1],++h;h=new F(l,0)}return c.call(this,b,h)}function c(a,d){for(var e=new fa(b.b(a)),l=d;;)if(t(l))e=e.append(b.b(G(l))),l=K(l);else return e.toString()}a.i=1;a.f=function(a){var b=G(a);a=H(a);return c(b,a)};a.d=c;return a}(),b=function(b,e){switch(arguments.length){case 0:return"";case 1:return a.call(this,
	b);default:var f=null;if(1<arguments.length){for(var f=0,g=Array(arguments.length-1);f<g.length;)g[f]=arguments[f+1],++f;f=new F(g,0)}return c.d(b,f)}throw Error("Invalid arity: "+arguments.length);};b.i=1;b.f=c.f;b.l=function(){return""};b.b=a;b.d=c.d;return b}();function Ic(a,b){var c;if(cd(b))if(Ec(a)&&Ec(b)&&Q(a)!==Q(b))c=!1;else a:{c=D(a);for(var d=D(b);;){if(null==c){c=null==d;break a}if(null!=d&&sc.a(G(c),G(d)))c=K(c),d=K(d);else{c=!1;break a}}c=void 0}else c=null;return md(c)}
	function Fd(a,b,c,d,e){this.k=a;this.first=b;this.M=c;this.count=d;this.p=e;this.j=65937646;this.q=8192}k=Fd.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.T=function(){return 1===this.count?null:this.M};k.L=function(){return this.count};k.La=function(){return this.first};k.Ma=function(){return Wa(this)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return ub(J,this.k)};
	k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return this.first};k.S=function(){return 1===this.count?J:this.M};k.D=function(){return this};k.F=function(a,b){return new Fd(b,this.first,this.M,this.count,this.p)};k.G=function(a,b){return new Fd(this.k,b,this,this.count+1,null)};Fd.prototype[Ea]=function(){return uc(this)};function Hd(a){this.k=a;this.j=65937614;this.q=8192}k=Hd.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};
	k.T=function(){return null};k.L=function(){return 0};k.La=function(){return null};k.Ma=function(){throw Error("Can't pop empty list");};k.B=function(){return 0};k.A=function(a,b){return Ic(this,b)};k.J=function(){return this};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return null};k.S=function(){return J};k.D=function(){return null};k.F=function(a,b){return new Hd(b)};k.G=function(a,b){return new Fd(this.k,b,null,1,null)};var J=new Hd(null);
	Hd.prototype[Ea]=function(){return uc(this)};function Id(a){return a?a.j&134217728||a.xc?!0:a.j?!1:w(Fb,a):w(Fb,a)}function Jd(a){return Id(a)?Gb(a):A.c(Nc,J,a)}
	var Kd=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){var b;if(a instanceof F&&0===a.m)b=a.e;else a:{for(b=[];;)if(null!=a)b.push(a.N(null)),a=a.T(null);else break a;b=void 0}a=b.length;for(var e=J;;)if(0<a){var f=a-1,e=e.G(null,b[a-1]);a=f}else return e}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}();
	function Ld(a,b,c,d){this.k=a;this.first=b;this.M=c;this.p=d;this.j=65929452;this.q=8192}k=Ld.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.T=function(){return null==this.M?null:D(this.M)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return this.first};
	k.S=function(){return null==this.M?J:this.M};k.D=function(){return this};k.F=function(a,b){return new Ld(b,this.first,this.M,this.p)};k.G=function(a,b){return new Ld(null,b,this,this.p)};Ld.prototype[Ea]=function(){return uc(this)};function M(a,b){var c=null==b;return(c?c:b&&(b.j&64||b.jb))?new Ld(null,a,b,null):new Ld(null,a,D(b),null)}
	function Md(a,b){if(a.pa===b.pa)return 0;var c=Aa(a.ba);if(t(c?b.ba:c))return-1;if(t(a.ba)){if(Aa(b.ba))return 1;c=ha(a.ba,b.ba);return 0===c?ha(a.name,b.name):c}return ha(a.name,b.name)}function U(a,b,c,d){this.ba=a;this.name=b;this.pa=c;this.Ya=d;this.j=2153775105;this.q=4096}k=U.prototype;k.v=function(a,b){return Lb(b,[z(":"),z(this.pa)].join(""))};k.B=function(){var a=this.Ya;return null!=a?a:this.Ya=a=oc(this)+2654435769|0};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return S.a(c,this);case 3:return S.c(c,this,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return S.a(c,this)};a.c=function(a,c,d){return S.c(c,this,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return S.a(a,this)};k.a=function(a,b){return S.c(a,this,b)};k.A=function(a,b){return b instanceof U?this.pa===b.pa:!1};
	k.toString=function(){return[z(":"),z(this.pa)].join("")};function Nd(a,b){return a===b?!0:a instanceof U&&b instanceof U?a.pa===b.pa:!1}
	var Pd=function(){function a(a,b){return new U(a,b,[z(t(a)?[z(a),z("/")].join(""):null),z(b)].join(""),null)}function b(a){if(a instanceof U)return a;if(a instanceof qc){var b;if(a&&(a.q&4096||a.lc))b=a.ba;else throw Error([z("Doesn't support namespace: "),z(a)].join(""));return new U(b,Od.b?Od.b(a):Od.call(null,a),a.ta,null)}return"string"===typeof a?(b=a.split("/"),2===b.length?new U(b[0],b[1],a,null):new U(null,b[0],a,null)):null}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,
	c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();function V(a,b,c,d){this.k=a;this.cb=b;this.C=c;this.p=d;this.q=0;this.j=32374988}k=V.prototype;k.toString=function(){return ec(this)};function Qd(a){null!=a.cb&&(a.C=a.cb.l?a.cb.l():a.cb.call(null),a.cb=null);return a.C}k.H=function(){return this.k};k.T=function(){Cb(this);return null==this.C?null:K(this.C)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};
	k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){Cb(this);return null==this.C?null:G(this.C)};k.S=function(){Cb(this);return null!=this.C?H(this.C):J};k.D=function(){Qd(this);if(null==this.C)return null;for(var a=this.C;;)if(a instanceof V)a=Qd(a);else return this.C=a,D(this.C)};k.F=function(a,b){return new V(b,this.cb,this.C,this.p)};k.G=function(a,b){return M(b,this)};
	V.prototype[Ea]=function(){return uc(this)};function Rd(a,b){this.Ab=a;this.end=b;this.q=0;this.j=2}Rd.prototype.L=function(){return this.end};Rd.prototype.add=function(a){this.Ab[this.end]=a;return this.end+=1};Rd.prototype.ca=function(){var a=new Sd(this.Ab,0,this.end);this.Ab=null;return a};function Td(a){return new Rd(Array(a),0)}function Sd(a,b,c){this.e=a;this.V=b;this.end=c;this.q=0;this.j=524306}k=Sd.prototype;k.R=function(a,b){return Dc.n(this.e,b,this.e[this.V],this.V+1)};
	k.O=function(a,b,c){return Dc.n(this.e,b,c,this.V)};k.Pb=function(){if(this.V===this.end)throw Error("-drop-first of empty chunk");return new Sd(this.e,this.V+1,this.end)};k.Q=function(a,b){return this.e[this.V+b]};k.$=function(a,b,c){return 0<=b&&b<this.end-this.V?this.e[this.V+b]:c};k.L=function(){return this.end-this.V};
	var Ud=function(){function a(a,b,c){return new Sd(a,b,c)}function b(a,b){return new Sd(a,b,a.length)}function c(a){return new Sd(a,0,a.length)}var d=null,d=function(d,f,g){switch(arguments.length){case 1:return c.call(this,d);case 2:return b.call(this,d,f);case 3:return a.call(this,d,f,g)}throw Error("Invalid arity: "+arguments.length);};d.b=c;d.a=b;d.c=a;return d}();function Vd(a,b,c,d){this.ca=a;this.ra=b;this.k=c;this.p=d;this.j=31850732;this.q=1536}k=Vd.prototype;k.toString=function(){return ec(this)};
	k.H=function(){return this.k};k.T=function(){if(1<Ma(this.ca))return new Vd(Xb(this.ca),this.ra,this.k,null);var a=Cb(this.ra);return null==a?null:a};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.N=function(){return C.a(this.ca,0)};k.S=function(){return 1<Ma(this.ca)?new Vd(Xb(this.ca),this.ra,this.k,null):null==this.ra?J:this.ra};k.D=function(){return this};k.Cb=function(){return this.ca};
	k.Db=function(){return null==this.ra?J:this.ra};k.F=function(a,b){return new Vd(this.ca,this.ra,b,this.p)};k.G=function(a,b){return M(b,this)};k.Bb=function(){return null==this.ra?null:this.ra};Vd.prototype[Ea]=function(){return uc(this)};function Wd(a,b){return 0===Ma(a)?b:new Vd(a,b,null,null)}function Xd(a,b){a.add(b)}function rd(a){for(var b=[];;)if(D(a))b.push(G(a)),a=K(a);else return b}function Yd(a,b){if(Ec(a))return Q(a);for(var c=a,d=b,e=0;;)if(0<d&&D(c))c=K(c),d-=1,e+=1;else return e}
	var $d=function Zd(b){return null==b?null:null==K(b)?D(G(b)):M(G(b),Zd(K(b)))},ae=function(){function a(a,b){return new V(null,function(){var c=D(a);return c?fd(c)?Wd(Yb(c),d.a(Zb(c),b)):M(G(c),d.a(H(c),b)):b},null,null)}function b(a){return new V(null,function(){return a},null,null)}function c(){return new V(null,function(){return null},null,null)}var d=null,e=function(){function a(c,d,e){var f=null;if(2<arguments.length){for(var f=0,q=Array(arguments.length-2);f<q.length;)q[f]=arguments[f+2],++f;
	f=new F(q,0)}return b.call(this,c,d,f)}function b(a,c,e){return function q(a,b){return new V(null,function(){var c=D(a);return c?fd(c)?Wd(Yb(c),q(Zb(c),b)):M(G(c),q(H(c),b)):t(b)?q(G(b),K(b)):null},null,null)}(d.a(a,c),e)}a.i=2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),d=function(d,g,h){switch(arguments.length){case 0:return c.call(this);case 1:return b.call(this,d);case 2:return a.call(this,d,g);default:var l=null;if(2<arguments.length){for(var l=0,m=
	Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return e.d(d,g,l)}throw Error("Invalid arity: "+arguments.length);};d.i=2;d.f=e.f;d.l=c;d.b=b;d.a=a;d.d=e.d;return d}(),be=function(){function a(a,b,c,d){return M(a,M(b,M(c,d)))}function b(a,b,c){return M(a,M(b,c))}var c=null,d=function(){function a(c,d,e,m,p){var q=null;if(4<arguments.length){for(var q=0,s=Array(arguments.length-4);q<s.length;)s[q]=arguments[q+4],++q;q=new F(s,0)}return b.call(this,c,d,e,m,q)}function b(a,
	c,d,e,f){return M(a,M(c,M(d,M(e,$d(f)))))}a.i=4;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var p=G(a);a=H(a);return b(c,d,e,p,a)};a.d=b;return a}(),c=function(c,f,g,h,l){switch(arguments.length){case 1:return D(c);case 2:return M(c,f);case 3:return b.call(this,c,f,g);case 4:return a.call(this,c,f,g,h);default:var m=null;if(4<arguments.length){for(var m=0,p=Array(arguments.length-4);m<p.length;)p[m]=arguments[m+4],++m;m=new F(p,0)}return d.d(c,f,g,h,m)}throw Error("Invalid arity: "+
	arguments.length);};c.i=4;c.f=d.f;c.b=function(a){return D(a)};c.a=function(a,b){return M(a,b)};c.c=b;c.n=a;c.d=d.d;return c}();function ce(a){return Qb(a)}
	var de=function(){function a(){return Ob(Mc)}var b=null,c=function(){function a(c,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return b.call(this,c,d,l)}function b(a,c,d){for(;;)if(a=Pb(a,c),t(d))c=G(d),d=K(d);else return a}a.i=2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),b=function(b,e,f){switch(arguments.length){case 0:return a.call(this);case 1:return b;case 2:return Pb(b,
	e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.l=a;b.b=function(a){return a};b.a=function(a,b){return Pb(a,b)};b.d=c.d;return b}(),ee=function(){var a=null,b=function(){function a(c,f,g,h){var l=null;if(3<arguments.length){for(var l=0,m=Array(arguments.length-3);l<m.length;)m[l]=arguments[l+3],++l;l=new F(m,0)}return b.call(this,
	c,f,g,l)}function b(a,c,d,h){for(;;)if(a=Rb(a,c,d),t(h))c=G(h),d=Lc(h),h=K(K(h));else return a}a.i=3;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=K(a);var h=G(a);a=H(a);return b(c,g,h,a)};a.d=b;return a}(),a=function(a,d,e,f){switch(arguments.length){case 3:return Rb(a,d,e);default:var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,0)}return b.d(a,d,e,g)}throw Error("Invalid arity: "+arguments.length);};a.i=3;a.f=b.f;a.c=function(a,
	b,e){return Rb(a,b,e)};a.d=b.d;return a}(),fe=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a=Sb(a,c),t(d))c=G(d),d=K(d);else return a}a.i=2;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 2:return Sb(a,d);default:var f=null;if(2<
	arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.a=function(a,b){return Sb(a,b)};a.d=b.d;return a}(),ge=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a=Vb(a,c),t(d))c=G(d),d=K(d);
	else return a}a.i=2;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 2:return Vb(a,d);default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.a=function(a,b){return Vb(a,b)};a.d=b.d;return a}();
	function he(a,b,c){var d=D(c);if(0===b)return a.l?a.l():a.call(null);c=Va(d);var e=Wa(d);if(1===b)return a.b?a.b(c):a.b?a.b(c):a.call(null,c);var d=Va(e),f=Wa(e);if(2===b)return a.a?a.a(c,d):a.a?a.a(c,d):a.call(null,c,d);var e=Va(f),g=Wa(f);if(3===b)return a.c?a.c(c,d,e):a.c?a.c(c,d,e):a.call(null,c,d,e);var f=Va(g),h=Wa(g);if(4===b)return a.n?a.n(c,d,e,f):a.n?a.n(c,d,e,f):a.call(null,c,d,e,f);var g=Va(h),l=Wa(h);if(5===b)return a.r?a.r(c,d,e,f,g):a.r?a.r(c,d,e,f,g):a.call(null,c,d,e,f,g);var h=Va(l),
	m=Wa(l);if(6===b)return a.P?a.P(c,d,e,f,g,h):a.P?a.P(c,d,e,f,g,h):a.call(null,c,d,e,f,g,h);var l=Va(m),p=Wa(m);if(7===b)return a.ia?a.ia(c,d,e,f,g,h,l):a.ia?a.ia(c,d,e,f,g,h,l):a.call(null,c,d,e,f,g,h,l);var m=Va(p),q=Wa(p);if(8===b)return a.Ga?a.Ga(c,d,e,f,g,h,l,m):a.Ga?a.Ga(c,d,e,f,g,h,l,m):a.call(null,c,d,e,f,g,h,l,m);var p=Va(q),s=Wa(q);if(9===b)return a.Ha?a.Ha(c,d,e,f,g,h,l,m,p):a.Ha?a.Ha(c,d,e,f,g,h,l,m,p):a.call(null,c,d,e,f,g,h,l,m,p);var q=Va(s),u=Wa(s);if(10===b)return a.va?a.va(c,d,e,
	f,g,h,l,m,p,q):a.va?a.va(c,d,e,f,g,h,l,m,p,q):a.call(null,c,d,e,f,g,h,l,m,p,q);var s=Va(u),v=Wa(u);if(11===b)return a.wa?a.wa(c,d,e,f,g,h,l,m,p,q,s):a.wa?a.wa(c,d,e,f,g,h,l,m,p,q,s):a.call(null,c,d,e,f,g,h,l,m,p,q,s);var u=Va(v),y=Wa(v);if(12===b)return a.xa?a.xa(c,d,e,f,g,h,l,m,p,q,s,u):a.xa?a.xa(c,d,e,f,g,h,l,m,p,q,s,u):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u);var v=Va(y),B=Wa(y);if(13===b)return a.ya?a.ya(c,d,e,f,g,h,l,m,p,q,s,u,v):a.ya?a.ya(c,d,e,f,g,h,l,m,p,q,s,u,v):a.call(null,c,d,e,f,g,h,l,m,p,
	q,s,u,v);var y=Va(B),E=Wa(B);if(14===b)return a.za?a.za(c,d,e,f,g,h,l,m,p,q,s,u,v,y):a.za?a.za(c,d,e,f,g,h,l,m,p,q,s,u,v,y):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y);var B=Va(E),N=Wa(E);if(15===b)return a.Aa?a.Aa(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B):a.Aa?a.Aa(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B);var E=Va(N),Y=Wa(N);if(16===b)return a.Ba?a.Ba(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E):a.Ba?a.Ba(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E);var N=
	Va(Y),ra=Wa(Y);if(17===b)return a.Ca?a.Ca(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N):a.Ca?a.Ca(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N);var Y=Va(ra),Pa=Wa(ra);if(18===b)return a.Da?a.Da(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y):a.Da?a.Da(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y);ra=Va(Pa);Pa=Wa(Pa);if(19===b)return a.Ea?a.Ea(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra):a.Ea?a.Ea(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra):a.call(null,
	c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra);var I=Va(Pa);Wa(Pa);if(20===b)return a.Fa?a.Fa(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra,I):a.Fa?a.Fa(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra,I):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra,I);throw Error("Only up to 20 arguments supported on functions");}
	var T=function(){function a(a,b,c,d,e){b=be.n(b,c,d,e);c=a.i;return a.f?(d=Yd(b,c+1),d<=c?he(a,d,b):a.f(b)):a.apply(a,rd(b))}function b(a,b,c,d){b=be.c(b,c,d);c=a.i;return a.f?(d=Yd(b,c+1),d<=c?he(a,d,b):a.f(b)):a.apply(a,rd(b))}function c(a,b,c){b=be.a(b,c);c=a.i;if(a.f){var d=Yd(b,c+1);return d<=c?he(a,d,b):a.f(b)}return a.apply(a,rd(b))}function d(a,b){var c=a.i;if(a.f){var d=Yd(b,c+1);return d<=c?he(a,d,b):a.f(b)}return a.apply(a,rd(b))}var e=null,f=function(){function a(c,d,e,f,g,u){var v=null;
	if(5<arguments.length){for(var v=0,y=Array(arguments.length-5);v<y.length;)y[v]=arguments[v+5],++v;v=new F(y,0)}return b.call(this,c,d,e,f,g,v)}function b(a,c,d,e,f,g){c=M(c,M(d,M(e,M(f,$d(g)))));d=a.i;return a.f?(e=Yd(c,d+1),e<=d?he(a,e,c):a.f(c)):a.apply(a,rd(c))}a.i=5;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=K(a);var g=G(a);a=H(a);return b(c,d,e,f,g,a)};a.d=b;return a}(),e=function(e,h,l,m,p,q){switch(arguments.length){case 2:return d.call(this,e,h);case 3:return c.call(this,
	e,h,l);case 4:return b.call(this,e,h,l,m);case 5:return a.call(this,e,h,l,m,p);default:var s=null;if(5<arguments.length){for(var s=0,u=Array(arguments.length-5);s<u.length;)u[s]=arguments[s+5],++s;s=new F(u,0)}return f.d(e,h,l,m,p,s)}throw Error("Invalid arity: "+arguments.length);};e.i=5;e.f=f.f;e.a=d;e.c=c;e.n=b;e.r=a;e.d=f.d;return e}(),ie=function(){function a(a,b,c,d,e,f){var g=O,v=Vc(a);b=b.r?b.r(v,c,d,e,f):b.call(null,v,c,d,e,f);return g(a,b)}function b(a,b,c,d,e){var f=O,g=Vc(a);b=b.n?b.n(g,
	c,d,e):b.call(null,g,c,d,e);return f(a,b)}function c(a,b,c,d){var e=O,f=Vc(a);b=b.c?b.c(f,c,d):b.call(null,f,c,d);return e(a,b)}function d(a,b,c){var d=O,e=Vc(a);b=b.a?b.a(e,c):b.call(null,e,c);return d(a,b)}function e(a,b){var c=O,d;d=Vc(a);d=b.b?b.b(d):b.call(null,d);return c(a,d)}var f=null,g=function(){function a(c,d,e,f,g,h,y){var B=null;if(6<arguments.length){for(var B=0,E=Array(arguments.length-6);B<E.length;)E[B]=arguments[B+6],++B;B=new F(E,0)}return b.call(this,c,d,e,f,g,h,B)}function b(a,
	c,d,e,f,g,h){return O(a,T.d(c,Vc(a),d,e,f,Kc([g,h],0)))}a.i=6;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=K(a);var g=G(a);a=K(a);var h=G(a);a=H(a);return b(c,d,e,f,g,h,a)};a.d=b;return a}(),f=function(f,l,m,p,q,s,u){switch(arguments.length){case 2:return e.call(this,f,l);case 3:return d.call(this,f,l,m);case 4:return c.call(this,f,l,m,p);case 5:return b.call(this,f,l,m,p,q);case 6:return a.call(this,f,l,m,p,q,s);default:var v=null;if(6<arguments.length){for(var v=
	0,y=Array(arguments.length-6);v<y.length;)y[v]=arguments[v+6],++v;v=new F(y,0)}return g.d(f,l,m,p,q,s,v)}throw Error("Invalid arity: "+arguments.length);};f.i=6;f.f=g.f;f.a=e;f.c=d;f.n=c;f.r=b;f.P=a;f.d=g.d;return f}(),je=function(){function a(a,b){return!sc.a(a,b)}var b=null,c=function(){function a(c,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return b.call(this,c,d,l)}function b(a,c,d){return Aa(T.n(sc,a,c,d))}a.i=
	2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return!1;case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(){return!1};b.a=a;b.d=c.d;return b}(),qe=function ke(){"undefined"===typeof ja&&(ja=function(b,c){this.pc=
	b;this.oc=c;this.q=0;this.j=393216},ja.prototype.ga=function(){return!1},ja.prototype.next=function(){return Error("No such element")},ja.prototype.H=function(){return this.oc},ja.prototype.F=function(b,c){return new ja(this.pc,c)},ja.Yb=!0,ja.Xb="cljs.core/t12660",ja.nc=function(b){return Lb(b,"cljs.core/t12660")});return new ja(ke,new pa(null,5,[le,54,me,2998,ne,3,oe,2994,pe,"/Users/davidnolen/development/clojure/mori/out-mori-adv/cljs/core.cljs"],null))};function re(a,b){this.C=a;this.m=b}
	re.prototype.ga=function(){return this.m<this.C.length};re.prototype.next=function(){var a=this.C.charAt(this.m);this.m+=1;return a};function se(a,b){this.e=a;this.m=b}se.prototype.ga=function(){return this.m<this.e.length};se.prototype.next=function(){var a=this.e[this.m];this.m+=1;return a};var te={},ue={};function ve(a,b){this.eb=a;this.Qa=b}ve.prototype.ga=function(){this.eb===te?(this.eb=ue,this.Qa=D(this.Qa)):this.eb===this.Qa&&(this.Qa=K(this.eb));return null!=this.Qa};
	ve.prototype.next=function(){if(Aa(this.ga()))throw Error("No such element");this.eb=this.Qa;return G(this.Qa)};function we(a){if(null==a)return qe();if("string"===typeof a)return new re(a,0);if(a instanceof Array)return new se(a,0);if(a?t(t(null)?null:a.vb)||(a.yb?0:w(bc,a)):w(bc,a))return cc(a);if(ld(a))return new ve(te,a);throw Error([z("Cannot create iterator from "),z(a)].join(""));}function xe(a,b){this.fa=a;this.$b=b}
	xe.prototype.step=function(a){for(var b=this;;){if(t(function(){var c=null!=a.X;return c?b.$b.ga():c}()))if(Ac(function(){var c=b.$b.next();return b.fa.a?b.fa.a(a,c):b.fa.call(null,a,c)}()))null!=a.M&&(a.M.X=null);else continue;break}return null==a.X?null:b.fa.b?b.fa.b(a):b.fa.call(null,a)};
	function ye(a,b){var c=function(){function a(b,c){b.first=c;b.M=new ze(b.X,null,null,null);b.X=null;return b.M}function b(a){(Ac(a)?qb(a):a).X=null;return a}var c=null,c=function(c,f){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,f)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();return new xe(a.b?a.b(c):a.call(null,c),b)}function Ae(a,b,c){this.fa=a;this.Kb=b;this.ac=c}
	Ae.prototype.ga=function(){for(var a=D(this.Kb);;)if(null!=a){var b=G(a);if(Aa(b.ga()))return!1;a=K(a)}else return!0};Ae.prototype.next=function(){for(var a=this.Kb.length,b=0;;)if(b<a)this.ac[b]=this.Kb[b].next(),b+=1;else break;return Jc.a(this.ac,0)};Ae.prototype.step=function(a){for(;;){var b;b=(b=null!=a.X)?this.ga():b;if(t(b))if(Ac(T.a(this.fa,M(a,this.next()))))null!=a.M&&(a.M.X=null);else continue;break}return null==a.X?null:this.fa.b?this.fa.b(a):this.fa.call(null,a)};
	var Be=function(){function a(a,b,c){var g=function(){function a(b,c){b.first=c;b.M=new ze(b.X,null,null,null);b.X=null;return b.M}function b(a){a=Ac(a)?qb(a):a;a.X=null;return a}var c=null,c=function(c,d){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,d)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();return new Ae(a.b?a.b(g):a.call(null,g),b,c)}function b(a,b){return c.c(a,b,Array(b.length))}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,
	c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();function ze(a,b,c,d){this.X=a;this.first=b;this.M=c;this.k=d;this.q=0;this.j=31719628}k=ze.prototype;k.T=function(){null!=this.X&&Cb(this);return null==this.M?null:Cb(this.M)};k.N=function(){null!=this.X&&Cb(this);return null==this.M?null:this.first};k.S=function(){null!=this.X&&Cb(this);return null==this.M?J:this.M};
	k.D=function(){null!=this.X&&this.X.step(this);return null==this.M?null:this};k.B=function(){return wc(this)};k.A=function(a,b){return null!=Cb(this)?Ic(this,b):cd(b)&&null==D(b)};k.J=function(){return J};k.G=function(a,b){return M(b,Cb(this))};k.F=function(a,b){return new ze(this.X,this.first,this.M,b)};ze.prototype[Ea]=function(){return uc(this)};
	var Ce=function(){function a(a){return kd(a)?a:(a=D(a))?a:J}var b=null,c=function(){function a(c,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return b.call(this,c,d,l)}function b(a,c,d){d=rd(M(c,d));c=[];d=D(d);for(var e=null,m=0,p=0;;)if(p<m){var q=e.Q(null,p);c.push(we(q));p+=1}else if(d=D(d))e=d,fd(e)?(d=Yb(e),p=Zb(e),e=d,m=Q(d),d=p):(d=G(e),c.push(we(d)),d=K(e),e=null,m=0),p=0;else break;return new ze(Be.c(a,c,
	Array(c.length)),null,null,null)}a.i=2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return a.call(this,b);case 2:return new ze(ye(b,we(e)),null,null,null);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=a;b.a=function(a,b){return new ze(ye(a,
	we(b)),null,null,null)};b.d=c.d;return b}();function Ee(a,b){for(;;){if(null==D(b))return!0;var c;c=G(b);c=a.b?a.b(c):a.call(null,c);if(t(c)){c=a;var d=K(b);a=c;b=d}else return!1}}function Fe(a,b){for(;;)if(D(b)){var c;c=G(b);c=a.b?a.b(c):a.call(null,c);if(t(c))return c;c=a;var d=K(b);a=c;b=d}else return null}function Ge(a){if("number"===typeof a&&Aa(isNaN(a))&&Infinity!==a&&parseFloat(a)===parseInt(a,10))return 0===(a&1);throw Error([z("Argument must be an integer: "),z(a)].join(""));}
	function He(a){return function(){function b(b,c){return Aa(a.a?a.a(b,c):a.call(null,b,c))}function c(b){return Aa(a.b?a.b(b):a.call(null,b))}function d(){return Aa(a.l?a.l():a.call(null))}var e=null,f=function(){function b(a,d,e){var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return c.call(this,a,d,f)}function c(b,d,e){return Aa(T.n(a,b,d,e))}b.i=2;b.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};b.d=c;
	return b}(),e=function(a,e,l){switch(arguments.length){case 0:return d.call(this);case 1:return c.call(this,a);case 2:return b.call(this,a,e);default:var m=null;if(2<arguments.length){for(var m=0,p=Array(arguments.length-2);m<p.length;)p[m]=arguments[m+2],++m;m=new F(p,0)}return f.d(a,e,m)}throw Error("Invalid arity: "+arguments.length);};e.i=2;e.f=f.f;e.l=d;e.b=c;e.a=b;e.d=f.d;return e}()}
	var Ie=function(){function a(a,b,c){return function(){function d(h,l,m){h=c.c?c.c(h,l,m):c.call(null,h,l,m);h=b.b?b.b(h):b.call(null,h);return a.b?a.b(h):a.call(null,h)}function l(d,h){var l;l=c.a?c.a(d,h):c.call(null,d,h);l=b.b?b.b(l):b.call(null,l);return a.b?a.b(l):a.call(null,l)}function m(d){d=c.b?c.b(d):c.call(null,d);d=b.b?b.b(d):b.call(null,d);return a.b?a.b(d):a.call(null,d)}function p(){var d;d=c.l?c.l():c.call(null);d=b.b?b.b(d):b.call(null,d);return a.b?a.b(d):a.call(null,d)}var q=null,
	s=function(){function d(a,b,c,e){var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+3],++f;f=new F(g,0)}return h.call(this,a,b,c,f)}function h(d,l,m,p){d=T.r(c,d,l,m,p);d=b.b?b.b(d):b.call(null,d);return a.b?a.b(d):a.call(null,d)}d.i=3;d.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return h(b,c,d,a)};d.d=h;return d}(),q=function(a,b,c,e){switch(arguments.length){case 0:return p.call(this);case 1:return m.call(this,a);case 2:return l.call(this,
	a,b);case 3:return d.call(this,a,b,c);default:var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+3],++f;f=new F(g,0)}return s.d(a,b,c,f)}throw Error("Invalid arity: "+arguments.length);};q.i=3;q.f=s.f;q.l=p;q.b=m;q.a=l;q.c=d;q.d=s.d;return q}()}function b(a,b){return function(){function c(d,g,h){d=b.c?b.c(d,g,h):b.call(null,d,g,h);return a.b?a.b(d):a.call(null,d)}function d(c,g){var h=b.a?b.a(c,g):b.call(null,c,g);return a.b?a.b(h):a.call(null,h)}
	function l(c){c=b.b?b.b(c):b.call(null,c);return a.b?a.b(c):a.call(null,c)}function m(){var c=b.l?b.l():b.call(null);return a.b?a.b(c):a.call(null,c)}var p=null,q=function(){function c(a,b,e,f){var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,0)}return d.call(this,a,b,e,g)}function d(c,g,h,l){c=T.r(b,c,g,h,l);return a.b?a.b(c):a.call(null,c)}c.i=3;c.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var e=G(a);a=H(a);return d(b,
	c,e,a)};c.d=d;return c}(),p=function(a,b,e,f){switch(arguments.length){case 0:return m.call(this);case 1:return l.call(this,a);case 2:return d.call(this,a,b);case 3:return c.call(this,a,b,e);default:var p=null;if(3<arguments.length){for(var p=0,E=Array(arguments.length-3);p<E.length;)E[p]=arguments[p+3],++p;p=new F(E,0)}return q.d(a,b,e,p)}throw Error("Invalid arity: "+arguments.length);};p.i=3;p.f=q.f;p.l=m;p.b=l;p.a=d;p.c=c;p.d=q.d;return p}()}var c=null,d=function(){function a(c,d,e,m){var p=null;
	if(3<arguments.length){for(var p=0,q=Array(arguments.length-3);p<q.length;)q[p]=arguments[p+3],++p;p=new F(q,0)}return b.call(this,c,d,e,p)}function b(a,c,d,e){return function(a){return function(){function b(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return c.call(this,d)}function c(b){b=T.a(G(a),b);for(var d=K(a);;)if(d)b=G(d).call(null,b),d=K(d);else return b}b.i=0;b.f=function(a){a=D(a);return c(a)};b.d=c;return b}()}(Jd(be.n(a,
	c,d,e)))}a.i=3;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=H(a);return b(c,d,e,a)};a.d=b;return a}(),c=function(c,f,g,h){switch(arguments.length){case 0:return ud;case 1:return c;case 2:return b.call(this,c,f);case 3:return a.call(this,c,f,g);default:var l=null;if(3<arguments.length){for(var l=0,m=Array(arguments.length-3);l<m.length;)m[l]=arguments[l+3],++l;l=new F(m,0)}return d.d(c,f,g,l)}throw Error("Invalid arity: "+arguments.length);};c.i=3;c.f=d.f;c.l=function(){return ud};
	c.b=function(a){return a};c.a=b;c.c=a;c.d=d.d;return c}(),Je=function(){function a(a,b,c,d){return function(){function e(m,p,q){return a.P?a.P(b,c,d,m,p,q):a.call(null,b,c,d,m,p,q)}function p(e,m){return a.r?a.r(b,c,d,e,m):a.call(null,b,c,d,e,m)}function q(e){return a.n?a.n(b,c,d,e):a.call(null,b,c,d,e)}function s(){return a.c?a.c(b,c,d):a.call(null,b,c,d)}var u=null,v=function(){function e(a,b,c,d){var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+
	3],++f;f=new F(g,0)}return m.call(this,a,b,c,f)}function m(e,p,q,s){return T.d(a,b,c,d,e,Kc([p,q,s],0))}e.i=3;e.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return m(b,c,d,a)};e.d=m;return e}(),u=function(a,b,c,d){switch(arguments.length){case 0:return s.call(this);case 1:return q.call(this,a);case 2:return p.call(this,a,b);case 3:return e.call(this,a,b,c);default:var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+3],++f;f=
	new F(g,0)}return v.d(a,b,c,f)}throw Error("Invalid arity: "+arguments.length);};u.i=3;u.f=v.f;u.l=s;u.b=q;u.a=p;u.c=e;u.d=v.d;return u}()}function b(a,b,c){return function(){function d(e,l,m){return a.r?a.r(b,c,e,l,m):a.call(null,b,c,e,l,m)}function e(d,l){return a.n?a.n(b,c,d,l):a.call(null,b,c,d,l)}function p(d){return a.c?a.c(b,c,d):a.call(null,b,c,d)}function q(){return a.a?a.a(b,c):a.call(null,b,c)}var s=null,u=function(){function d(a,b,c,f){var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-
	3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,0)}return e.call(this,a,b,c,g)}function e(d,l,m,p){return T.d(a,b,c,d,l,Kc([m,p],0))}d.i=3;d.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return e(b,c,d,a)};d.d=e;return d}(),s=function(a,b,c,f){switch(arguments.length){case 0:return q.call(this);case 1:return p.call(this,a);case 2:return e.call(this,a,b);case 3:return d.call(this,a,b,c);default:var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-3);g<h.length;)h[g]=
	arguments[g+3],++g;g=new F(h,0)}return u.d(a,b,c,g)}throw Error("Invalid arity: "+arguments.length);};s.i=3;s.f=u.f;s.l=q;s.b=p;s.a=e;s.c=d;s.d=u.d;return s}()}function c(a,b){return function(){function c(d,e,h){return a.n?a.n(b,d,e,h):a.call(null,b,d,e,h)}function d(c,e){return a.c?a.c(b,c,e):a.call(null,b,c,e)}function e(c){return a.a?a.a(b,c):a.call(null,b,c)}function p(){return a.b?a.b(b):a.call(null,b)}var q=null,s=function(){function c(a,b,e,f){var g=null;if(3<arguments.length){for(var g=0,
	h=Array(arguments.length-3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,0)}return d.call(this,a,b,e,g)}function d(c,e,h,l){return T.d(a,b,c,e,h,Kc([l],0))}c.i=3;c.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var e=G(a);a=H(a);return d(b,c,e,a)};c.d=d;return c}(),q=function(a,b,f,g){switch(arguments.length){case 0:return p.call(this);case 1:return e.call(this,a);case 2:return d.call(this,a,b);case 3:return c.call(this,a,b,f);default:var q=null;if(3<arguments.length){for(var q=0,N=Array(arguments.length-
	3);q<N.length;)N[q]=arguments[q+3],++q;q=new F(N,0)}return s.d(a,b,f,q)}throw Error("Invalid arity: "+arguments.length);};q.i=3;q.f=s.f;q.l=p;q.b=e;q.a=d;q.c=c;q.d=s.d;return q}()}var d=null,e=function(){function a(c,d,e,f,q){var s=null;if(4<arguments.length){for(var s=0,u=Array(arguments.length-4);s<u.length;)u[s]=arguments[s+4],++s;s=new F(u,0)}return b.call(this,c,d,e,f,s)}function b(a,c,d,e,f){return function(){function b(a){var c=null;if(0<arguments.length){for(var c=0,d=Array(arguments.length-
	0);c<d.length;)d[c]=arguments[c+0],++c;c=new F(d,0)}return g.call(this,c)}function g(b){return T.r(a,c,d,e,ae.a(f,b))}b.i=0;b.f=function(a){a=D(a);return g(a)};b.d=g;return b}()}a.i=4;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=H(a);return b(c,d,e,f,a)};a.d=b;return a}(),d=function(d,g,h,l,m){switch(arguments.length){case 1:return d;case 2:return c.call(this,d,g);case 3:return b.call(this,d,g,h);case 4:return a.call(this,d,g,h,l);default:var p=null;if(4<arguments.length){for(var p=
	0,q=Array(arguments.length-4);p<q.length;)q[p]=arguments[p+4],++p;p=new F(q,0)}return e.d(d,g,h,l,p)}throw Error("Invalid arity: "+arguments.length);};d.i=4;d.f=e.f;d.b=function(a){return a};d.a=c;d.c=b;d.n=a;d.d=e.d;return d}(),Ke=function(){function a(a,b,c,d){return function(){function l(l,m,p){l=null==l?b:l;m=null==m?c:m;p=null==p?d:p;return a.c?a.c(l,m,p):a.call(null,l,m,p)}function m(d,h){var l=null==d?b:d,m=null==h?c:h;return a.a?a.a(l,m):a.call(null,l,m)}var p=null,q=function(){function l(a,
	b,c,d){var e=null;if(3<arguments.length){for(var e=0,f=Array(arguments.length-3);e<f.length;)f[e]=arguments[e+3],++e;e=new F(f,0)}return m.call(this,a,b,c,e)}function m(l,p,q,s){return T.r(a,null==l?b:l,null==p?c:p,null==q?d:q,s)}l.i=3;l.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return m(b,c,d,a)};l.d=m;return l}(),p=function(a,b,c,d){switch(arguments.length){case 2:return m.call(this,a,b);case 3:return l.call(this,a,b,c);default:var e=null;if(3<arguments.length){for(var e=
	0,f=Array(arguments.length-3);e<f.length;)f[e]=arguments[e+3],++e;e=new F(f,0)}return q.d(a,b,c,e)}throw Error("Invalid arity: "+arguments.length);};p.i=3;p.f=q.f;p.a=m;p.c=l;p.d=q.d;return p}()}function b(a,b,c){return function(){function d(h,l,m){h=null==h?b:h;l=null==l?c:l;return a.c?a.c(h,l,m):a.call(null,h,l,m)}function l(d,h){var l=null==d?b:d,m=null==h?c:h;return a.a?a.a(l,m):a.call(null,l,m)}var m=null,p=function(){function d(a,b,c,e){var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-
	3);f<g.length;)g[f]=arguments[f+3],++f;f=new F(g,0)}return h.call(this,a,b,c,f)}function h(d,l,m,p){return T.r(a,null==d?b:d,null==l?c:l,m,p)}d.i=3;d.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return h(b,c,d,a)};d.d=h;return d}(),m=function(a,b,c,e){switch(arguments.length){case 2:return l.call(this,a,b);case 3:return d.call(this,a,b,c);default:var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+3],++f;f=new F(g,0)}return p.d(a,
	b,c,f)}throw Error("Invalid arity: "+arguments.length);};m.i=3;m.f=p.f;m.a=l;m.c=d;m.d=p.d;return m}()}function c(a,b){return function(){function c(d,g,h){d=null==d?b:d;return a.c?a.c(d,g,h):a.call(null,d,g,h)}function d(c,g){var h=null==c?b:c;return a.a?a.a(h,g):a.call(null,h,g)}function l(c){c=null==c?b:c;return a.b?a.b(c):a.call(null,c)}var m=null,p=function(){function c(a,b,e,f){var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,
	0)}return d.call(this,a,b,e,g)}function d(c,g,h,l){return T.r(a,null==c?b:c,g,h,l)}c.i=3;c.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var e=G(a);a=H(a);return d(b,c,e,a)};c.d=d;return c}(),m=function(a,b,e,f){switch(arguments.length){case 1:return l.call(this,a);case 2:return d.call(this,a,b);case 3:return c.call(this,a,b,e);default:var m=null;if(3<arguments.length){for(var m=0,B=Array(arguments.length-3);m<B.length;)B[m]=arguments[m+3],++m;m=new F(B,0)}return p.d(a,b,e,m)}throw Error("Invalid arity: "+
	arguments.length);};m.i=3;m.f=p.f;m.b=l;m.a=d;m.c=c;m.d=p.d;return m}()}var d=null,d=function(d,f,g,h){switch(arguments.length){case 2:return c.call(this,d,f);case 3:return b.call(this,d,f,g);case 4:return a.call(this,d,f,g,h)}throw Error("Invalid arity: "+arguments.length);};d.a=c;d.c=b;d.n=a;return d}(),Le=function(){function a(a,b){return new V(null,function(){var f=D(b);if(f){if(fd(f)){for(var g=Yb(f),h=Q(g),l=Td(h),m=0;;)if(m<h){var p=function(){var b=C.a(g,m);return a.b?a.b(b):a.call(null,b)}();
	null!=p&&l.add(p);m+=1}else break;return Wd(l.ca(),c.a(a,Zb(f)))}h=function(){var b=G(f);return a.b?a.b(b):a.call(null,b)}();return null==h?c.a(a,H(f)):M(h,c.a(a,H(f)))}return null},null,null)}function b(a){return function(b){return function(){function c(f,g){var h=a.b?a.b(g):a.call(null,g);return null==h?f:b.a?b.a(f,h):b.call(null,f,h)}function g(a){return b.b?b.b(a):b.call(null,a)}function h(){return b.l?b.l():b.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);
	case 1:return g.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};l.l=h;l.b=g;l.a=c;return l}()}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();function Me(a){this.state=a;this.q=0;this.j=32768}Me.prototype.Ra=function(){return this.state};Me.prototype.bb=function(a,b){return this.state=b};
	var Ne=function(){function a(a,b){return function g(b,c){return new V(null,function(){var e=D(c);if(e){if(fd(e)){for(var p=Yb(e),q=Q(p),s=Td(q),u=0;;)if(u<q){var v=function(){var c=b+u,e=C.a(p,u);return a.a?a.a(c,e):a.call(null,c,e)}();null!=v&&s.add(v);u+=1}else break;return Wd(s.ca(),g(b+q,Zb(e)))}q=function(){var c=G(e);return a.a?a.a(b,c):a.call(null,b,c)}();return null==q?g(b+1,H(e)):M(q,g(b+1,H(e)))}return null},null,null)}(0,b)}function b(a){return function(b){return function(c){return function(){function g(g,
	h){var l=c.bb(0,c.Ra(null)+1),l=a.a?a.a(l,h):a.call(null,l,h);return null==l?g:b.a?b.a(g,l):b.call(null,g,l)}function h(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return h.call(this,a);case 2:return g.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};m.l=l;m.b=h;m.a=g;return m}()}(new Me(-1))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,
	c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Oe=function(){function a(a,b,c,d){return new V(null,function(){var f=D(b),q=D(c),s=D(d);if(f&&q&&s){var u=M,v;v=G(f);var y=G(q),B=G(s);v=a.c?a.c(v,y,B):a.call(null,v,y,B);f=u(v,e.n(a,H(f),H(q),H(s)))}else f=null;return f},null,null)}function b(a,b,c){return new V(null,function(){var d=D(b),f=D(c);if(d&&f){var q=M,s;s=G(d);var u=G(f);s=a.a?a.a(s,u):a.call(null,s,u);d=q(s,e.c(a,H(d),H(f)))}else d=
	null;return d},null,null)}function c(a,b){return new V(null,function(){var c=D(b);if(c){if(fd(c)){for(var d=Yb(c),f=Q(d),q=Td(f),s=0;;)if(s<f)Xd(q,function(){var b=C.a(d,s);return a.b?a.b(b):a.call(null,b)}()),s+=1;else break;return Wd(q.ca(),e.a(a,Zb(c)))}return M(function(){var b=G(c);return a.b?a.b(b):a.call(null,b)}(),e.a(a,H(c)))}return null},null,null)}function d(a){return function(b){return function(){function c(d,e){var f=a.b?a.b(e):a.call(null,e);return b.a?b.a(d,f):b.call(null,d,f)}function d(a){return b.b?
	b.b(a):b.call(null,a)}function e(){return b.l?b.l():b.call(null)}var f=null,s=function(){function c(a,b,e){var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return d.call(this,a,b,f)}function d(c,e,f){e=T.c(a,e,f);return b.a?b.a(c,e):b.call(null,c,e)}c.i=2;c.f=function(a){var b=G(a);a=K(a);var c=G(a);a=H(a);return d(b,c,a)};c.d=d;return c}(),f=function(a,b,f){switch(arguments.length){case 0:return e.call(this);case 1:return d.call(this,
	a);case 2:return c.call(this,a,b);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return s.d(a,b,g)}throw Error("Invalid arity: "+arguments.length);};f.i=2;f.f=s.f;f.l=e;f.b=d;f.a=c;f.d=s.d;return f}()}}var e=null,f=function(){function a(c,d,e,f,g){var u=null;if(4<arguments.length){for(var u=0,v=Array(arguments.length-4);u<v.length;)v[u]=arguments[u+4],++u;u=new F(v,0)}return b.call(this,c,d,e,f,u)}function b(a,c,d,
	f,g){var h=function y(a){return new V(null,function(){var b=e.a(D,a);return Ee(ud,b)?M(e.a(G,b),y(e.a(H,b))):null},null,null)};return e.a(function(){return function(b){return T.a(a,b)}}(h),h(Nc.d(g,f,Kc([d,c],0))))}a.i=4;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=H(a);return b(c,d,e,f,a)};a.d=b;return a}(),e=function(e,h,l,m,p){switch(arguments.length){case 1:return d.call(this,e);case 2:return c.call(this,e,h);case 3:return b.call(this,e,h,l);case 4:return a.call(this,
	e,h,l,m);default:var q=null;if(4<arguments.length){for(var q=0,s=Array(arguments.length-4);q<s.length;)s[q]=arguments[q+4],++q;q=new F(s,0)}return f.d(e,h,l,m,q)}throw Error("Invalid arity: "+arguments.length);};e.i=4;e.f=f.f;e.b=d;e.a=c;e.c=b;e.n=a;e.d=f.d;return e}(),Pe=function(){function a(a,b){return new V(null,function(){if(0<a){var f=D(b);return f?M(G(f),c.a(a-1,H(f))):null}return null},null,null)}function b(a){return function(b){return function(a){return function(){function c(d,g){var h=qb(a),
	l=a.bb(0,a.Ra(null)-1),h=0<h?b.a?b.a(d,g):b.call(null,d,g):d;return 0<l?h:Ac(h)?h:new yc(h)}function d(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return d.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};m.l=l;m.b=d;m.a=c;return m}()}(new Me(a))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,
	c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Qe=function(){function a(a,b){return new V(null,function(c){return function(){return c(a,b)}}(function(a,b){for(;;){var c=D(b);if(0<a&&c){var d=a-1,c=H(c);a=d;b=c}else return c}}),null,null)}function b(a){return function(b){return function(a){return function(){function c(d,g){var h=qb(a);a.bb(0,a.Ra(null)-1);return 0<h?d:b.a?b.a(d,g):b.call(null,d,g)}function d(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?
	b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return d.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};m.l=l;m.b=d;m.a=c;return m}()}(new Me(a))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Re=function(){function a(a,b){return new V(null,function(c){return function(){return c(a,
	b)}}(function(a,b){for(;;){var c=D(b),d;if(d=c)d=G(c),d=a.b?a.b(d):a.call(null,d);if(t(d))d=a,c=H(c),a=d,b=c;else return c}}),null,null)}function b(a){return function(b){return function(c){return function(){function g(g,h){var l=qb(c);if(t(t(l)?a.b?a.b(h):a.call(null,h):l))return g;ac(c,null);return b.a?b.a(g,h):b.call(null,g,h)}function h(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return h.call(this,
	a);case 2:return g.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};m.l=l;m.b=h;m.a=g;return m}()}(new Me(!0))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Se=function(){function a(a,b){return Pe.a(a,c.b(b))}function b(a){return new V(null,function(){return M(a,c.b(a))},null,null)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,
	c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Te=function(){function a(a,b){return Pe.a(a,c.b(b))}function b(a){return new V(null,function(){return M(a.l?a.l():a.call(null),c.b(a))},null,null)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Ue=function(){function a(a,c){return new V(null,function(){var f=
	D(a),g=D(c);return f&&g?M(G(f),M(G(g),b.a(H(f),H(g)))):null},null,null)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){return new V(null,function(){var c=Oe.a(D,Nc.d(e,d,Kc([a],0)));return Ee(ud,c)?ae.a(Oe.a(G,c),T.a(b,Oe.a(H,c))):null},null,null)}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),
	b=function(b,e,f){switch(arguments.length){case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.a=a;b.d=c.d;return b}(),We=function(){function a(a){return Ie.a(Oe.b(a),Ve)}var b=null,c=function(){function a(c,d){var h=null;if(1<arguments.length){for(var h=0,l=Array(arguments.length-1);h<l.length;)l[h]=arguments[h+
	1],++h;h=new F(l,0)}return b.call(this,c,h)}function b(a,c){return T.a(ae,T.c(Oe,a,c))}a.i=1;a.f=function(a){var c=G(a);a=H(a);return b(c,a)};a.d=b;return a}(),b=function(b,e){switch(arguments.length){case 1:return a.call(this,b);default:var f=null;if(1<arguments.length){for(var f=0,g=Array(arguments.length-1);f<g.length;)g[f]=arguments[f+1],++f;f=new F(g,0)}return c.d(b,f)}throw Error("Invalid arity: "+arguments.length);};b.i=1;b.f=c.f;b.b=a;b.d=c.d;return b}(),Xe=function(){function a(a,b){return new V(null,
	function(){var f=D(b);if(f){if(fd(f)){for(var g=Yb(f),h=Q(g),l=Td(h),m=0;;)if(m<h){var p;p=C.a(g,m);p=a.b?a.b(p):a.call(null,p);t(p)&&(p=C.a(g,m),l.add(p));m+=1}else break;return Wd(l.ca(),c.a(a,Zb(f)))}g=G(f);f=H(f);return t(a.b?a.b(g):a.call(null,g))?M(g,c.a(a,f)):c.a(a,f)}return null},null,null)}function b(a){return function(b){return function(){function c(f,g){return t(a.b?a.b(g):a.call(null,g))?b.a?b.a(f,g):b.call(null,f,g):f}function g(a){return b.b?b.b(a):b.call(null,a)}function h(){return b.l?
	b.l():b.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);case 1:return g.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};l.l=h;l.b=g;l.a=c;return l}()}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Ye=function(){function a(a,b){return Xe.a(He(a),b)}function b(a){return Xe.b(He(a))}
	var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();function Ze(a){var b=$e;return function d(a){return new V(null,function(){return M(a,t(b.b?b.b(a):b.call(null,a))?We.d(d,Kc([D.b?D.b(a):D.call(null,a)],0)):null)},null,null)}(a)}
	var af=function(){function a(a,b,c){return a&&(a.q&4||a.dc)?O(ce(wd.n(b,de,Ob(a),c)),Vc(a)):wd.n(b,Nc,a,c)}function b(a,b){return null!=a?a&&(a.q&4||a.dc)?O(ce(A.c(Pb,Ob(a),b)),Vc(a)):A.c(Ra,a,b):A.c(Nc,J,b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),bf=function(){function a(a,b,c,h){return new V(null,function(){var l=D(h);if(l){var m=Pe.a(a,l);return a===
	Q(m)?M(m,d.n(a,b,c,Qe.a(b,l))):Ra(J,Pe.a(a,ae.a(m,c)))}return null},null,null)}function b(a,b,c){return new V(null,function(){var h=D(c);if(h){var l=Pe.a(a,h);return a===Q(l)?M(l,d.c(a,b,Qe.a(b,h))):null}return null},null,null)}function c(a,b){return d.c(a,a,b)}var d=null,d=function(d,f,g,h){switch(arguments.length){case 2:return c.call(this,d,f);case 3:return b.call(this,d,f,g);case 4:return a.call(this,d,f,g,h)}throw Error("Invalid arity: "+arguments.length);};d.a=c;d.c=b;d.n=a;return d}(),cf=function(){function a(a,
	b,c){var g=jd;for(b=D(b);;)if(b){var h=a;if(h?h.j&256||h.Rb||(h.j?0:w(Za,h)):w(Za,h)){a=S.c(a,G(b),g);if(g===a)return c;b=K(b)}else return c}else return a}function b(a,b){return c.c(a,b,null)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),df=function(){function a(a,b,c,d,f,q){var s=R.c(b,0,null);return(b=Ed(b))?Rc.c(a,s,e.P(S.a(a,s),b,c,d,f,q)):Rc.c(a,s,
	function(){var b=S.a(a,s);return c.n?c.n(b,d,f,q):c.call(null,b,d,f,q)}())}function b(a,b,c,d,f){var q=R.c(b,0,null);return(b=Ed(b))?Rc.c(a,q,e.r(S.a(a,q),b,c,d,f)):Rc.c(a,q,function(){var b=S.a(a,q);return c.c?c.c(b,d,f):c.call(null,b,d,f)}())}function c(a,b,c,d){var f=R.c(b,0,null);return(b=Ed(b))?Rc.c(a,f,e.n(S.a(a,f),b,c,d)):Rc.c(a,f,function(){var b=S.a(a,f);return c.a?c.a(b,d):c.call(null,b,d)}())}function d(a,b,c){var d=R.c(b,0,null);return(b=Ed(b))?Rc.c(a,d,e.c(S.a(a,d),b,c)):Rc.c(a,d,function(){var b=
	S.a(a,d);return c.b?c.b(b):c.call(null,b)}())}var e=null,f=function(){function a(c,d,e,f,g,u,v){var y=null;if(6<arguments.length){for(var y=0,B=Array(arguments.length-6);y<B.length;)B[y]=arguments[y+6],++y;y=new F(B,0)}return b.call(this,c,d,e,f,g,u,y)}function b(a,c,d,f,g,h,v){var y=R.c(c,0,null);return(c=Ed(c))?Rc.c(a,y,T.d(e,S.a(a,y),c,d,f,Kc([g,h,v],0))):Rc.c(a,y,T.d(d,S.a(a,y),f,g,h,Kc([v],0)))}a.i=6;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=K(a);var g=
	G(a);a=K(a);var v=G(a);a=H(a);return b(c,d,e,f,g,v,a)};a.d=b;return a}(),e=function(e,h,l,m,p,q,s){switch(arguments.length){case 3:return d.call(this,e,h,l);case 4:return c.call(this,e,h,l,m);case 5:return b.call(this,e,h,l,m,p);case 6:return a.call(this,e,h,l,m,p,q);default:var u=null;if(6<arguments.length){for(var u=0,v=Array(arguments.length-6);u<v.length;)v[u]=arguments[u+6],++u;u=new F(v,0)}return f.d(e,h,l,m,p,q,u)}throw Error("Invalid arity: "+arguments.length);};e.i=6;e.f=f.f;e.c=d;e.n=c;
	e.r=b;e.P=a;e.d=f.d;return e}();function ef(a,b){this.u=a;this.e=b}function ff(a){return new ef(a,[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null])}function gf(a){return new ef(a.u,Fa(a.e))}function hf(a){a=a.g;return 32>a?0:a-1>>>5<<5}function jf(a,b,c){for(;;){if(0===b)return c;var d=ff(a);d.e[0]=c;c=d;b-=5}}
	var lf=function kf(b,c,d,e){var f=gf(d),g=b.g-1>>>c&31;5===c?f.e[g]=e:(d=d.e[g],b=null!=d?kf(b,c-5,d,e):jf(null,c-5,e),f.e[g]=b);return f};function mf(a,b){throw Error([z("No item "),z(a),z(" in vector of length "),z(b)].join(""));}function nf(a,b){if(b>=hf(a))return a.W;for(var c=a.root,d=a.shift;;)if(0<d)var e=d-5,c=c.e[b>>>d&31],d=e;else return c.e}function of(a,b){return 0<=b&&b<a.g?nf(a,b):mf(b,a.g)}
	var qf=function pf(b,c,d,e,f){var g=gf(d);if(0===c)g.e[e&31]=f;else{var h=e>>>c&31;b=pf(b,c-5,d.e[h],e,f);g.e[h]=b}return g},sf=function rf(b,c,d){var e=b.g-2>>>c&31;if(5<c){b=rf(b,c-5,d.e[e]);if(null==b&&0===e)return null;d=gf(d);d.e[e]=b;return d}if(0===e)return null;d=gf(d);d.e[e]=null;return d};function tf(a,b,c,d,e,f){this.m=a;this.zb=b;this.e=c;this.oa=d;this.start=e;this.end=f}tf.prototype.ga=function(){return this.m<this.end};
	tf.prototype.next=function(){32===this.m-this.zb&&(this.e=nf(this.oa,this.m),this.zb+=32);var a=this.e[this.m&31];this.m+=1;return a};function W(a,b,c,d,e,f){this.k=a;this.g=b;this.shift=c;this.root=d;this.W=e;this.p=f;this.j=167668511;this.q=8196}k=W.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return"number"===typeof b?C.c(this,b,c):c};
	k.gb=function(a,b,c){a=0;for(var d=c;;)if(a<this.g){var e=nf(this,a);c=e.length;a:{for(var f=0;;)if(f<c){var g=f+a,h=e[f],d=b.c?b.c(d,g,h):b.call(null,d,g,h);if(Ac(d)){e=d;break a}f+=1}else{e=d;break a}e=void 0}if(Ac(e))return b=e,L.b?L.b(b):L.call(null,b);a+=c;d=e}else return d};k.Q=function(a,b){return of(this,b)[b&31]};k.$=function(a,b,c){return 0<=b&&b<this.g?nf(this,b)[b&31]:c};
	k.Ua=function(a,b,c){if(0<=b&&b<this.g)return hf(this)<=b?(a=Fa(this.W),a[b&31]=c,new W(this.k,this.g,this.shift,this.root,a,null)):new W(this.k,this.g,this.shift,qf(this,this.shift,this.root,b,c),this.W,null);if(b===this.g)return Ra(this,c);throw Error([z("Index "),z(b),z(" out of bounds  [0,"),z(this.g),z("]")].join(""));};k.vb=!0;k.fb=function(){var a=this.g;return new tf(0,0,0<Q(this)?nf(this,0):null,this,0,a)};k.H=function(){return this.k};k.L=function(){return this.g};
	k.hb=function(){return C.a(this,0)};k.ib=function(){return C.a(this,1)};k.La=function(){return 0<this.g?C.a(this,this.g-1):null};
	k.Ma=function(){if(0===this.g)throw Error("Can't pop empty vector");if(1===this.g)return ub(Mc,this.k);if(1<this.g-hf(this))return new W(this.k,this.g-1,this.shift,this.root,this.W.slice(0,-1),null);var a=nf(this,this.g-2),b=sf(this,this.shift,this.root),b=null==b?uf:b,c=this.g-1;return 5<this.shift&&null==b.e[1]?new W(this.k,c,this.shift-5,b.e[0],a,null):new W(this.k,c,this.shift,b,a,null)};k.ab=function(){return 0<this.g?new Hc(this,this.g-1,null):null};
	k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){if(b instanceof W)if(this.g===Q(b))for(var c=cc(this),d=cc(b);;)if(t(c.ga())){var e=c.next(),f=d.next();if(!sc.a(e,f))return!1}else return!0;else return!1;else return Ic(this,b)};k.$a=function(){var a=this;return new vf(a.g,a.shift,function(){var b=a.root;return wf.b?wf.b(b):wf.call(null,b)}(),function(){var b=a.W;return xf.b?xf.b(b):xf.call(null,b)}())};k.J=function(){return O(Mc,this.k)};
	k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){a=0;for(var d=c;;)if(a<this.g){var e=nf(this,a);c=e.length;a:{for(var f=0;;)if(f<c){var g=e[f],d=b.a?b.a(d,g):b.call(null,d,g);if(Ac(d)){e=d;break a}f+=1}else{e=d;break a}e=void 0}if(Ac(e))return b=e,L.b?L.b(b):L.call(null,b);a+=c;d=e}else return d};k.Ka=function(a,b,c){if("number"===typeof b)return pb(this,b,c);throw Error("Vector's key for assoc must be a number.");};
	k.D=function(){if(0===this.g)return null;if(32>=this.g)return new F(this.W,0);var a;a:{a=this.root;for(var b=this.shift;;)if(0<b)b-=5,a=a.e[0];else{a=a.e;break a}a=void 0}return yf.n?yf.n(this,a,0,0):yf.call(null,this,a,0,0)};k.F=function(a,b){return new W(b,this.g,this.shift,this.root,this.W,this.p)};
	k.G=function(a,b){if(32>this.g-hf(this)){for(var c=this.W.length,d=Array(c+1),e=0;;)if(e<c)d[e]=this.W[e],e+=1;else break;d[c]=b;return new W(this.k,this.g+1,this.shift,this.root,d,null)}c=(d=this.g>>>5>1<<this.shift)?this.shift+5:this.shift;d?(d=ff(null),d.e[0]=this.root,e=jf(null,this.shift,new ef(null,this.W)),d.e[1]=e):d=lf(this,this.shift,this.root,new ef(null,this.W));return new W(this.k,this.g+1,c,d,[b],null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.Q(null,c);case 3:return this.$(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.Q(null,c)};a.c=function(a,c,d){return this.$(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.Q(null,a)};k.a=function(a,b){return this.$(null,a,b)};
	var uf=new ef(null,[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null]),Mc=new W(null,0,5,uf,[],0);W.prototype[Ea]=function(){return uc(this)};function zf(a){return Qb(A.c(Pb,Ob(Mc),a))}
	var Af=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){if(a instanceof F&&0===a.m)a:{a=a.e;var b=a.length;if(32>b)a=new W(null,b,5,uf,a,null);else{for(var e=32,f=(new W(null,32,5,uf,a.slice(0,32),null)).$a(null);;)if(e<b)var g=e+1,f=de.a(f,a[e]),e=g;else{a=Qb(f);break a}a=void 0}}else a=zf(a);return a}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}();
	function Bf(a,b,c,d,e,f){this.ha=a;this.Ja=b;this.m=c;this.V=d;this.k=e;this.p=f;this.j=32375020;this.q=1536}k=Bf.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.T=function(){if(this.V+1<this.Ja.length){var a;a=this.ha;var b=this.Ja,c=this.m,d=this.V+1;a=yf.n?yf.n(a,b,c,d):yf.call(null,a,b,c,d);return null==a?null:a}return $b(this)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(Mc,this.k)};
	k.R=function(a,b){var c=this;return Cc.a(function(){var a=c.ha,b=c.m+c.V,f=Q(c.ha);return Cf.c?Cf.c(a,b,f):Cf.call(null,a,b,f)}(),b)};k.O=function(a,b,c){var d=this;return Cc.c(function(){var a=d.ha,b=d.m+d.V,c=Q(d.ha);return Cf.c?Cf.c(a,b,c):Cf.call(null,a,b,c)}(),b,c)};k.N=function(){return this.Ja[this.V]};k.S=function(){if(this.V+1<this.Ja.length){var a;a=this.ha;var b=this.Ja,c=this.m,d=this.V+1;a=yf.n?yf.n(a,b,c,d):yf.call(null,a,b,c,d);return null==a?J:a}return Zb(this)};k.D=function(){return this};
	k.Cb=function(){return Ud.a(this.Ja,this.V)};k.Db=function(){var a=this.m+this.Ja.length;if(a<Ma(this.ha)){var b=this.ha,c=nf(this.ha,a);return yf.n?yf.n(b,c,a,0):yf.call(null,b,c,a,0)}return J};k.F=function(a,b){var c=this.ha,d=this.Ja,e=this.m,f=this.V;return yf.r?yf.r(c,d,e,f,b):yf.call(null,c,d,e,f,b)};k.G=function(a,b){return M(b,this)};k.Bb=function(){var a=this.m+this.Ja.length;if(a<Ma(this.ha)){var b=this.ha,c=nf(this.ha,a);return yf.n?yf.n(b,c,a,0):yf.call(null,b,c,a,0)}return null};
	Bf.prototype[Ea]=function(){return uc(this)};var yf=function(){function a(a,b,c,d,l){return new Bf(a,b,c,d,l,null)}function b(a,b,c,d){return new Bf(a,b,c,d,null,null)}function c(a,b,c){return new Bf(a,of(a,b),b,c,null,null)}var d=null,d=function(d,f,g,h,l){switch(arguments.length){case 3:return c.call(this,d,f,g);case 4:return b.call(this,d,f,g,h);case 5:return a.call(this,d,f,g,h,l)}throw Error("Invalid arity: "+arguments.length);};d.c=c;d.n=b;d.r=a;return d}();
	function Df(a,b,c,d,e){this.k=a;this.oa=b;this.start=c;this.end=d;this.p=e;this.j=166617887;this.q=8192}k=Df.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return"number"===typeof b?C.c(this,b,c):c};k.Q=function(a,b){return 0>b||this.end<=this.start+b?mf(b,this.end-this.start):C.a(this.oa,this.start+b)};k.$=function(a,b,c){return 0>b||this.end<=this.start+b?c:C.c(this.oa,this.start+b,c)};
	k.Ua=function(a,b,c){var d=this.start+b;a=this.k;c=Rc.c(this.oa,d,c);b=this.start;var e=this.end,d=d+1,d=e>d?e:d;return Ef.r?Ef.r(a,c,b,d,null):Ef.call(null,a,c,b,d,null)};k.H=function(){return this.k};k.L=function(){return this.end-this.start};k.La=function(){return C.a(this.oa,this.end-1)};k.Ma=function(){if(this.start===this.end)throw Error("Can't pop empty vector");var a=this.k,b=this.oa,c=this.start,d=this.end-1;return Ef.r?Ef.r(a,b,c,d,null):Ef.call(null,a,b,c,d,null)};
	k.ab=function(){return this.start!==this.end?new Hc(this,this.end-this.start-1,null):null};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(Mc,this.k)};k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){return Cc.c(this,b,c)};k.Ka=function(a,b,c){if("number"===typeof b)return pb(this,b,c);throw Error("Subvec's key for assoc must be a number.");};
	k.D=function(){var a=this;return function(b){return function d(e){return e===a.end?null:M(C.a(a.oa,e),new V(null,function(){return function(){return d(e+1)}}(b),null,null))}}(this)(a.start)};k.F=function(a,b){var c=this.oa,d=this.start,e=this.end,f=this.p;return Ef.r?Ef.r(b,c,d,e,f):Ef.call(null,b,c,d,e,f)};k.G=function(a,b){var c=this.k,d=pb(this.oa,this.end,b),e=this.start,f=this.end+1;return Ef.r?Ef.r(c,d,e,f,null):Ef.call(null,c,d,e,f,null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.Q(null,c);case 3:return this.$(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.Q(null,c)};a.c=function(a,c,d){return this.$(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.Q(null,a)};k.a=function(a,b){return this.$(null,a,b)};Df.prototype[Ea]=function(){return uc(this)};
	function Ef(a,b,c,d,e){for(;;)if(b instanceof Df)c=b.start+c,d=b.start+d,b=b.oa;else{var f=Q(b);if(0>c||0>d||c>f||d>f)throw Error("Index out of bounds");return new Df(a,b,c,d,e)}}var Cf=function(){function a(a,b,c){return Ef(null,a,b,c,null)}function b(a,b){return c.c(a,b,Q(a))}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();
	function Ff(a,b){return a===b.u?b:new ef(a,Fa(b.e))}function wf(a){return new ef({},Fa(a.e))}function xf(a){var b=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null];hd(a,0,b,0,a.length);return b}
	var Hf=function Gf(b,c,d,e){d=Ff(b.root.u,d);var f=b.g-1>>>c&31;if(5===c)b=e;else{var g=d.e[f];b=null!=g?Gf(b,c-5,g,e):jf(b.root.u,c-5,e)}d.e[f]=b;return d},Jf=function If(b,c,d){d=Ff(b.root.u,d);var e=b.g-2>>>c&31;if(5<c){b=If(b,c-5,d.e[e]);if(null==b&&0===e)return null;d.e[e]=b;return d}if(0===e)return null;d.e[e]=null;return d};function vf(a,b,c,d){this.g=a;this.shift=b;this.root=c;this.W=d;this.j=275;this.q=88}k=vf.prototype;
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};k.t=function(a,b){return $a.c(this,b,null)};
	k.s=function(a,b,c){return"number"===typeof b?C.c(this,b,c):c};k.Q=function(a,b){if(this.root.u)return of(this,b)[b&31];throw Error("nth after persistent!");};k.$=function(a,b,c){return 0<=b&&b<this.g?C.a(this,b):c};k.L=function(){if(this.root.u)return this.g;throw Error("count after persistent!");};
	k.Ub=function(a,b,c){var d=this;if(d.root.u){if(0<=b&&b<d.g)return hf(this)<=b?d.W[b&31]=c:(a=function(){return function f(a,h){var l=Ff(d.root.u,h);if(0===a)l.e[b&31]=c;else{var m=b>>>a&31,p=f(a-5,l.e[m]);l.e[m]=p}return l}}(this).call(null,d.shift,d.root),d.root=a),this;if(b===d.g)return Pb(this,c);throw Error([z("Index "),z(b),z(" out of bounds for TransientVector of length"),z(d.g)].join(""));}throw Error("assoc! after persistent!");};
	k.Vb=function(){if(this.root.u){if(0===this.g)throw Error("Can't pop empty vector");if(1===this.g)this.g=0;else if(0<(this.g-1&31))this.g-=1;else{var a;a:if(a=this.g-2,a>=hf(this))a=this.W;else{for(var b=this.root,c=b,d=this.shift;;)if(0<d)c=Ff(b.u,c.e[a>>>d&31]),d-=5;else{a=c.e;break a}a=void 0}b=Jf(this,this.shift,this.root);b=null!=b?b:new ef(this.root.u,[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
	null,null,null,null]);5<this.shift&&null==b.e[1]?(this.root=Ff(this.root.u,b.e[0]),this.shift-=5):this.root=b;this.g-=1;this.W=a}return this}throw Error("pop! after persistent!");};k.kb=function(a,b,c){if("number"===typeof b)return Tb(this,b,c);throw Error("TransientVector's key for assoc! must be a number.");};
	k.Sa=function(a,b){if(this.root.u){if(32>this.g-hf(this))this.W[this.g&31]=b;else{var c=new ef(this.root.u,this.W),d=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null];d[0]=b;this.W=d;if(this.g>>>5>1<<this.shift){var d=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],e=this.shift+
	5;d[0]=this.root;d[1]=jf(this.root.u,this.shift,c);this.root=new ef(this.root.u,d);this.shift=e}else this.root=Hf(this,this.shift,this.root,c)}this.g+=1;return this}throw Error("conj! after persistent!");};k.Ta=function(){if(this.root.u){this.root.u=null;var a=this.g-hf(this),b=Array(a);hd(this.W,0,b,0,a);return new W(null,this.g,this.shift,this.root,b,null)}throw Error("persistent! called twice");};function Kf(a,b,c,d){this.k=a;this.ea=b;this.sa=c;this.p=d;this.q=0;this.j=31850572}k=Kf.prototype;
	k.toString=function(){return ec(this)};k.H=function(){return this.k};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.N=function(){return G(this.ea)};k.S=function(){var a=K(this.ea);return a?new Kf(this.k,a,this.sa,null):null==this.sa?Na(this):new Kf(this.k,this.sa,null,null)};k.D=function(){return this};k.F=function(a,b){return new Kf(b,this.ea,this.sa,this.p)};k.G=function(a,b){return M(b,this)};
	Kf.prototype[Ea]=function(){return uc(this)};function Lf(a,b,c,d,e){this.k=a;this.count=b;this.ea=c;this.sa=d;this.p=e;this.j=31858766;this.q=8192}k=Lf.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.L=function(){return this.count};k.La=function(){return G(this.ea)};k.Ma=function(){if(t(this.ea)){var a=K(this.ea);return a?new Lf(this.k,this.count-1,a,this.sa,null):new Lf(this.k,this.count-1,D(this.sa),Mc,null)}return this};
	k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(Mf,this.k)};k.N=function(){return G(this.ea)};k.S=function(){return H(D(this))};k.D=function(){var a=D(this.sa),b=this.ea;return t(t(b)?b:a)?new Kf(null,this.ea,D(a),null):null};k.F=function(a,b){return new Lf(b,this.count,this.ea,this.sa,this.p)};
	k.G=function(a,b){var c;t(this.ea)?(c=this.sa,c=new Lf(this.k,this.count+1,this.ea,Nc.a(t(c)?c:Mc,b),null)):c=new Lf(this.k,this.count+1,Nc.a(this.ea,b),Mc,null);return c};var Mf=new Lf(null,0,null,Mc,0);Lf.prototype[Ea]=function(){return uc(this)};function Nf(){this.q=0;this.j=2097152}Nf.prototype.A=function(){return!1};var Of=new Nf;function Pf(a,b){return md(dd(b)?Q(a)===Q(b)?Ee(ud,Oe.a(function(a){return sc.a(S.c(b,G(a),Of),Lc(a))},a)):null:null)}
	function Qf(a,b){var c=a.e;if(b instanceof U)a:{for(var d=c.length,e=b.pa,f=0;;){if(d<=f){c=-1;break a}var g=c[f];if(g instanceof U&&e===g.pa){c=f;break a}f+=2}c=void 0}else if(d="string"==typeof b,t(t(d)?d:"number"===typeof b))a:{d=c.length;for(e=0;;){if(d<=e){c=-1;break a}if(b===c[e]){c=e;break a}e+=2}c=void 0}else if(b instanceof qc)a:{d=c.length;e=b.ta;for(f=0;;){if(d<=f){c=-1;break a}g=c[f];if(g instanceof qc&&e===g.ta){c=f;break a}f+=2}c=void 0}else if(null==b)a:{d=c.length;for(e=0;;){if(d<=
	e){c=-1;break a}if(null==c[e]){c=e;break a}e+=2}c=void 0}else a:{d=c.length;for(e=0;;){if(d<=e){c=-1;break a}if(sc.a(b,c[e])){c=e;break a}e+=2}c=void 0}return c}function Rf(a,b,c){this.e=a;this.m=b;this.Z=c;this.q=0;this.j=32374990}k=Rf.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.Z};k.T=function(){return this.m<this.e.length-2?new Rf(this.e,this.m+2,this.Z):null};k.L=function(){return(this.e.length-this.m)/2};k.B=function(){return wc(this)};
	k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.Z)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return new W(null,2,5,uf,[this.e[this.m],this.e[this.m+1]],null)};k.S=function(){return this.m<this.e.length-2?new Rf(this.e,this.m+2,this.Z):J};k.D=function(){return this};k.F=function(a,b){return new Rf(this.e,this.m,b)};k.G=function(a,b){return M(b,this)};Rf.prototype[Ea]=function(){return uc(this)};
	function Sf(a,b,c){this.e=a;this.m=b;this.g=c}Sf.prototype.ga=function(){return this.m<this.g};Sf.prototype.next=function(){var a=new W(null,2,5,uf,[this.e[this.m],this.e[this.m+1]],null);this.m+=2;return a};function pa(a,b,c,d){this.k=a;this.g=b;this.e=c;this.p=d;this.j=16647951;this.q=8196}k=pa.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){a=Qf(this,b);return-1===a?c:this.e[a+1]};
	k.gb=function(a,b,c){a=this.e.length;for(var d=0;;)if(d<a){var e=this.e[d],f=this.e[d+1];c=b.c?b.c(c,e,f):b.call(null,c,e,f);if(Ac(c))return b=c,L.b?L.b(b):L.call(null,b);d+=2}else return c};k.vb=!0;k.fb=function(){return new Sf(this.e,0,2*this.g)};k.H=function(){return this.k};k.L=function(){return this.g};k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};
	k.A=function(a,b){if(b&&(b.j&1024||b.ic)){var c=this.e.length;if(this.g===b.L(null))for(var d=0;;)if(d<c){var e=b.s(null,this.e[d],jd);if(e!==jd)if(sc.a(this.e[d+1],e))d+=2;else return!1;else return!1}else return!0;else return!1}else return Pf(this,b)};k.$a=function(){return new Tf({},this.e.length,Fa(this.e))};k.J=function(){return ub(Uf,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};
	k.wb=function(a,b){if(0<=Qf(this,b)){var c=this.e.length,d=c-2;if(0===d)return Na(this);for(var d=Array(d),e=0,f=0;;){if(e>=c)return new pa(this.k,this.g-1,d,null);sc.a(b,this.e[e])||(d[f]=this.e[e],d[f+1]=this.e[e+1],f+=2);e+=2}}else return this};
	k.Ka=function(a,b,c){a=Qf(this,b);if(-1===a){if(this.g<Vf){a=this.e;for(var d=a.length,e=Array(d+2),f=0;;)if(f<d)e[f]=a[f],f+=1;else break;e[d]=b;e[d+1]=c;return new pa(this.k,this.g+1,e,null)}return ub(cb(af.a(Qc,this),b,c),this.k)}if(c===this.e[a+1])return this;b=Fa(this.e);b[a+1]=c;return new pa(this.k,this.g,b,null)};k.rb=function(a,b){return-1!==Qf(this,b)};k.D=function(){var a=this.e;return 0<=a.length-2?new Rf(a,0,null):null};k.F=function(a,b){return new pa(b,this.g,this.e,this.p)};
	k.G=function(a,b){if(ed(b))return cb(this,C.a(b,0),C.a(b,1));for(var c=this,d=D(b);;){if(null==d)return c;var e=G(d);if(ed(e))c=cb(c,C.a(e,0),C.a(e,1)),d=K(d);else throw Error("conj on a map takes map entries or seqables of map entries");}};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};var Uf=new pa(null,0,[],null),Vf=8;pa.prototype[Ea]=function(){return uc(this)};
	function Tf(a,b,c){this.Va=a;this.qa=b;this.e=c;this.q=56;this.j=258}k=Tf.prototype;k.Jb=function(a,b){if(t(this.Va)){var c=Qf(this,b);0<=c&&(this.e[c]=this.e[this.qa-2],this.e[c+1]=this.e[this.qa-1],c=this.e,c.pop(),c.pop(),this.qa-=2);return this}throw Error("dissoc! after persistent!");};
	k.kb=function(a,b,c){var d=this;if(t(d.Va)){a=Qf(this,b);if(-1===a)return d.qa+2<=2*Vf?(d.qa+=2,d.e.push(b),d.e.push(c),this):ee.c(function(){var a=d.qa,b=d.e;return Xf.a?Xf.a(a,b):Xf.call(null,a,b)}(),b,c);c!==d.e[a+1]&&(d.e[a+1]=c);return this}throw Error("assoc! after persistent!");};
	k.Sa=function(a,b){if(t(this.Va)){if(b?b.j&2048||b.jc||(b.j?0:w(fb,b)):w(fb,b))return Rb(this,Yf.b?Yf.b(b):Yf.call(null,b),Zf.b?Zf.b(b):Zf.call(null,b));for(var c=D(b),d=this;;){var e=G(c);if(t(e))var f=e,c=K(c),d=Rb(d,function(){var a=f;return Yf.b?Yf.b(a):Yf.call(null,a)}(),function(){var a=f;return Zf.b?Zf.b(a):Zf.call(null,a)}());else return d}}else throw Error("conj! after persistent!");};
	k.Ta=function(){if(t(this.Va))return this.Va=!1,new pa(null,Cd(this.qa,2),this.e,null);throw Error("persistent! called twice");};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){if(t(this.Va))return a=Qf(this,b),-1===a?c:this.e[a+1];throw Error("lookup after persistent!");};k.L=function(){if(t(this.Va))return Cd(this.qa,2);throw Error("count after persistent!");};function Xf(a,b){for(var c=Ob(Qc),d=0;;)if(d<a)c=ee.c(c,b[d],b[d+1]),d+=2;else return c}function $f(){this.o=!1}
	function ag(a,b){return a===b?!0:Nd(a,b)?!0:sc.a(a,b)}var bg=function(){function a(a,b,c,g,h){a=Fa(a);a[b]=c;a[g]=h;return a}function b(a,b,c){a=Fa(a);a[b]=c;return a}var c=null,c=function(c,e,f,g,h){switch(arguments.length){case 3:return b.call(this,c,e,f);case 5:return a.call(this,c,e,f,g,h)}throw Error("Invalid arity: "+arguments.length);};c.c=b;c.r=a;return c}();function cg(a,b){var c=Array(a.length-2);hd(a,0,c,0,2*b);hd(a,2*(b+1),c,2*b,c.length-2*b);return c}
	var dg=function(){function a(a,b,c,g,h,l){a=a.Na(b);a.e[c]=g;a.e[h]=l;return a}function b(a,b,c,g){a=a.Na(b);a.e[c]=g;return a}var c=null,c=function(c,e,f,g,h,l){switch(arguments.length){case 4:return b.call(this,c,e,f,g);case 6:return a.call(this,c,e,f,g,h,l)}throw Error("Invalid arity: "+arguments.length);};c.n=b;c.P=a;return c}();
	function eg(a,b,c){for(var d=a.length,e=0,f=c;;)if(e<d){c=a[e];if(null!=c){var g=a[e+1];c=b.c?b.c(f,c,g):b.call(null,f,c,g)}else c=a[e+1],c=null!=c?c.Xa(b,f):f;if(Ac(c))return a=c,L.b?L.b(a):L.call(null,a);e+=2;f=c}else return f}function fg(a,b,c){this.u=a;this.w=b;this.e=c}k=fg.prototype;k.Na=function(a){if(a===this.u)return this;var b=Dd(this.w),c=Array(0>b?4:2*(b+1));hd(this.e,0,c,0,2*b);return new fg(a,this.w,c)};
	k.nb=function(a,b,c,d,e){var f=1<<(c>>>b&31);if(0===(this.w&f))return this;var g=Dd(this.w&f-1),h=this.e[2*g],l=this.e[2*g+1];return null==h?(b=l.nb(a,b+5,c,d,e),b===l?this:null!=b?dg.n(this,a,2*g+1,b):this.w===f?null:gg(this,a,f,g)):ag(d,h)?(e[0]=!0,gg(this,a,f,g)):this};function gg(a,b,c,d){if(a.w===c)return null;a=a.Na(b);b=a.e;var e=b.length;a.w^=c;hd(b,2*(d+1),b,2*d,e-2*(d+1));b[e-2]=null;b[e-1]=null;return a}k.lb=function(){var a=this.e;return hg.b?hg.b(a):hg.call(null,a)};
	k.Xa=function(a,b){return eg(this.e,a,b)};k.Oa=function(a,b,c,d){var e=1<<(b>>>a&31);if(0===(this.w&e))return d;var f=Dd(this.w&e-1),e=this.e[2*f],f=this.e[2*f+1];return null==e?f.Oa(a+5,b,c,d):ag(c,e)?f:d};
	k.la=function(a,b,c,d,e,f){var g=1<<(c>>>b&31),h=Dd(this.w&g-1);if(0===(this.w&g)){var l=Dd(this.w);if(2*l<this.e.length){var m=this.Na(a),p=m.e;f.o=!0;id(p,2*h,p,2*(h+1),2*(l-h));p[2*h]=d;p[2*h+1]=e;m.w|=g;return m}if(16<=l){g=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null];g[c>>>b&31]=ig.la(a,b+5,c,d,e,f);for(m=h=0;;)if(32>h)0!==(this.w>>>h&1)&&(g[h]=null!=this.e[m]?ig.la(a,b+5,nc(this.e[m]),
	this.e[m],this.e[m+1],f):this.e[m+1],m+=2),h+=1;else break;return new jg(a,l+1,g)}p=Array(2*(l+4));hd(this.e,0,p,0,2*h);p[2*h]=d;p[2*h+1]=e;hd(this.e,2*h,p,2*(h+1),2*(l-h));f.o=!0;m=this.Na(a);m.e=p;m.w|=g;return m}var q=this.e[2*h],s=this.e[2*h+1];if(null==q)return l=s.la(a,b+5,c,d,e,f),l===s?this:dg.n(this,a,2*h+1,l);if(ag(d,q))return e===s?this:dg.n(this,a,2*h+1,e);f.o=!0;return dg.P(this,a,2*h,null,2*h+1,function(){var f=b+5;return kg.ia?kg.ia(a,f,q,s,c,d,e):kg.call(null,a,f,q,s,c,d,e)}())};
	k.ka=function(a,b,c,d,e){var f=1<<(b>>>a&31),g=Dd(this.w&f-1);if(0===(this.w&f)){var h=Dd(this.w);if(16<=h){f=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null];f[b>>>a&31]=ig.ka(a+5,b,c,d,e);for(var l=g=0;;)if(32>g)0!==(this.w>>>g&1)&&(f[g]=null!=this.e[l]?ig.ka(a+5,nc(this.e[l]),this.e[l],this.e[l+1],e):this.e[l+1],l+=2),g+=1;else break;return new jg(null,h+1,f)}l=Array(2*(h+1));hd(this.e,
	0,l,0,2*g);l[2*g]=c;l[2*g+1]=d;hd(this.e,2*g,l,2*(g+1),2*(h-g));e.o=!0;return new fg(null,this.w|f,l)}var m=this.e[2*g],p=this.e[2*g+1];if(null==m)return h=p.ka(a+5,b,c,d,e),h===p?this:new fg(null,this.w,bg.c(this.e,2*g+1,h));if(ag(c,m))return d===p?this:new fg(null,this.w,bg.c(this.e,2*g+1,d));e.o=!0;return new fg(null,this.w,bg.r(this.e,2*g,null,2*g+1,function(){var e=a+5;return kg.P?kg.P(e,m,p,b,c,d):kg.call(null,e,m,p,b,c,d)}()))};
	k.mb=function(a,b,c){var d=1<<(b>>>a&31);if(0===(this.w&d))return this;var e=Dd(this.w&d-1),f=this.e[2*e],g=this.e[2*e+1];return null==f?(a=g.mb(a+5,b,c),a===g?this:null!=a?new fg(null,this.w,bg.c(this.e,2*e+1,a)):this.w===d?null:new fg(null,this.w^d,cg(this.e,e))):ag(c,f)?new fg(null,this.w^d,cg(this.e,e)):this};var ig=new fg(null,0,[]);
	function lg(a,b,c){var d=a.e,e=d.length;a=Array(2*(a.g-1));for(var f=0,g=1,h=0;;)if(f<e)f!==c&&null!=d[f]&&(a[g]=d[f],g+=2,h|=1<<f),f+=1;else return new fg(b,h,a)}function jg(a,b,c){this.u=a;this.g=b;this.e=c}k=jg.prototype;k.Na=function(a){return a===this.u?this:new jg(a,this.g,Fa(this.e))};
	k.nb=function(a,b,c,d,e){var f=c>>>b&31,g=this.e[f];if(null==g)return this;b=g.nb(a,b+5,c,d,e);if(b===g)return this;if(null==b){if(8>=this.g)return lg(this,a,f);a=dg.n(this,a,f,b);a.g-=1;return a}return dg.n(this,a,f,b)};k.lb=function(){var a=this.e;return mg.b?mg.b(a):mg.call(null,a)};k.Xa=function(a,b){for(var c=this.e.length,d=0,e=b;;)if(d<c){var f=this.e[d];if(null!=f&&(e=f.Xa(a,e),Ac(e)))return c=e,L.b?L.b(c):L.call(null,c);d+=1}else return e};
	k.Oa=function(a,b,c,d){var e=this.e[b>>>a&31];return null!=e?e.Oa(a+5,b,c,d):d};k.la=function(a,b,c,d,e,f){var g=c>>>b&31,h=this.e[g];if(null==h)return a=dg.n(this,a,g,ig.la(a,b+5,c,d,e,f)),a.g+=1,a;b=h.la(a,b+5,c,d,e,f);return b===h?this:dg.n(this,a,g,b)};k.ka=function(a,b,c,d,e){var f=b>>>a&31,g=this.e[f];if(null==g)return new jg(null,this.g+1,bg.c(this.e,f,ig.ka(a+5,b,c,d,e)));a=g.ka(a+5,b,c,d,e);return a===g?this:new jg(null,this.g,bg.c(this.e,f,a))};
	k.mb=function(a,b,c){var d=b>>>a&31,e=this.e[d];return null!=e?(a=e.mb(a+5,b,c),a===e?this:null==a?8>=this.g?lg(this,null,d):new jg(null,this.g-1,bg.c(this.e,d,a)):new jg(null,this.g,bg.c(this.e,d,a))):this};function ng(a,b,c){b*=2;for(var d=0;;)if(d<b){if(ag(c,a[d]))return d;d+=2}else return-1}function og(a,b,c,d){this.u=a;this.Ia=b;this.g=c;this.e=d}k=og.prototype;k.Na=function(a){if(a===this.u)return this;var b=Array(2*(this.g+1));hd(this.e,0,b,0,2*this.g);return new og(a,this.Ia,this.g,b)};
	k.nb=function(a,b,c,d,e){b=ng(this.e,this.g,d);if(-1===b)return this;e[0]=!0;if(1===this.g)return null;a=this.Na(a);e=a.e;e[b]=e[2*this.g-2];e[b+1]=e[2*this.g-1];e[2*this.g-1]=null;e[2*this.g-2]=null;a.g-=1;return a};k.lb=function(){var a=this.e;return hg.b?hg.b(a):hg.call(null,a)};k.Xa=function(a,b){return eg(this.e,a,b)};k.Oa=function(a,b,c,d){a=ng(this.e,this.g,c);return 0>a?d:ag(c,this.e[a])?this.e[a+1]:d};
	k.la=function(a,b,c,d,e,f){if(c===this.Ia){b=ng(this.e,this.g,d);if(-1===b){if(this.e.length>2*this.g)return a=dg.P(this,a,2*this.g,d,2*this.g+1,e),f.o=!0,a.g+=1,a;c=this.e.length;b=Array(c+2);hd(this.e,0,b,0,c);b[c]=d;b[c+1]=e;f.o=!0;f=this.g+1;a===this.u?(this.e=b,this.g=f,a=this):a=new og(this.u,this.Ia,f,b);return a}return this.e[b+1]===e?this:dg.n(this,a,b+1,e)}return(new fg(a,1<<(this.Ia>>>b&31),[null,this,null,null])).la(a,b,c,d,e,f)};
	k.ka=function(a,b,c,d,e){return b===this.Ia?(a=ng(this.e,this.g,c),-1===a?(a=2*this.g,b=Array(a+2),hd(this.e,0,b,0,a),b[a]=c,b[a+1]=d,e.o=!0,new og(null,this.Ia,this.g+1,b)):sc.a(this.e[a],d)?this:new og(null,this.Ia,this.g,bg.c(this.e,a+1,d))):(new fg(null,1<<(this.Ia>>>a&31),[null,this])).ka(a,b,c,d,e)};k.mb=function(a,b,c){a=ng(this.e,this.g,c);return-1===a?this:1===this.g?null:new og(null,this.Ia,this.g-1,cg(this.e,Cd(a,2)))};
	var kg=function(){function a(a,b,c,g,h,l,m){var p=nc(c);if(p===h)return new og(null,p,2,[c,g,l,m]);var q=new $f;return ig.la(a,b,p,c,g,q).la(a,b,h,l,m,q)}function b(a,b,c,g,h,l){var m=nc(b);if(m===g)return new og(null,m,2,[b,c,h,l]);var p=new $f;return ig.ka(a,m,b,c,p).ka(a,g,h,l,p)}var c=null,c=function(c,e,f,g,h,l,m){switch(arguments.length){case 6:return b.call(this,c,e,f,g,h,l);case 7:return a.call(this,c,e,f,g,h,l,m)}throw Error("Invalid arity: "+arguments.length);};c.P=b;c.ia=a;return c}();
	function pg(a,b,c,d,e){this.k=a;this.Pa=b;this.m=c;this.C=d;this.p=e;this.q=0;this.j=32374860}k=pg.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return null==this.C?new W(null,2,5,uf,[this.Pa[this.m],this.Pa[this.m+1]],null):G(this.C)};
	k.S=function(){if(null==this.C){var a=this.Pa,b=this.m+2;return hg.c?hg.c(a,b,null):hg.call(null,a,b,null)}var a=this.Pa,b=this.m,c=K(this.C);return hg.c?hg.c(a,b,c):hg.call(null,a,b,c)};k.D=function(){return this};k.F=function(a,b){return new pg(b,this.Pa,this.m,this.C,this.p)};k.G=function(a,b){return M(b,this)};pg.prototype[Ea]=function(){return uc(this)};
	var hg=function(){function a(a,b,c){if(null==c)for(c=a.length;;)if(b<c){if(null!=a[b])return new pg(null,a,b,null,null);var g=a[b+1];if(t(g)&&(g=g.lb(),t(g)))return new pg(null,a,b+2,g,null);b+=2}else return null;else return new pg(null,a,b,c,null)}function b(a){return c.c(a,0,null)}var c=null,c=function(c,e,f){switch(arguments.length){case 1:return b.call(this,c);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.c=a;return c}();
	function qg(a,b,c,d,e){this.k=a;this.Pa=b;this.m=c;this.C=d;this.p=e;this.q=0;this.j=32374860}k=qg.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return G(this.C)};
	k.S=function(){var a=this.Pa,b=this.m,c=K(this.C);return mg.n?mg.n(null,a,b,c):mg.call(null,null,a,b,c)};k.D=function(){return this};k.F=function(a,b){return new qg(b,this.Pa,this.m,this.C,this.p)};k.G=function(a,b){return M(b,this)};qg.prototype[Ea]=function(){return uc(this)};
	var mg=function(){function a(a,b,c,g){if(null==g)for(g=b.length;;)if(c<g){var h=b[c];if(t(h)&&(h=h.lb(),t(h)))return new qg(a,b,c+1,h,null);c+=1}else return null;else return new qg(a,b,c,g,null)}function b(a){return c.n(null,a,0,null)}var c=null,c=function(c,e,f,g){switch(arguments.length){case 1:return b.call(this,c);case 4:return a.call(this,c,e,f,g)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.n=a;return c}();
	function rg(a,b,c,d,e,f){this.k=a;this.g=b;this.root=c;this.U=d;this.da=e;this.p=f;this.j=16123663;this.q=8196}k=rg.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return null==b?this.U?this.da:c:null==this.root?c:this.root.Oa(0,nc(b),b,c)};k.gb=function(a,b,c){this.U&&(a=this.da,c=b.c?b.c(c,null,a):b.call(null,c,null,a));return Ac(c)?L.b?L.b(c):L.call(null,c):null!=this.root?this.root.Xa(b,c):c};k.H=function(){return this.k};k.L=function(){return this.g};
	k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};k.A=function(a,b){return Pf(this,b)};k.$a=function(){return new sg({},this.root,this.g,this.U,this.da)};k.J=function(){return ub(Qc,this.k)};k.wb=function(a,b){if(null==b)return this.U?new rg(this.k,this.g-1,this.root,!1,null,null):this;if(null==this.root)return this;var c=this.root.mb(0,nc(b),b);return c===this.root?this:new rg(this.k,this.g-1,c,this.U,this.da,null)};
	k.Ka=function(a,b,c){if(null==b)return this.U&&c===this.da?this:new rg(this.k,this.U?this.g:this.g+1,this.root,!0,c,null);a=new $f;b=(null==this.root?ig:this.root).ka(0,nc(b),b,c,a);return b===this.root?this:new rg(this.k,a.o?this.g+1:this.g,b,this.U,this.da,null)};k.rb=function(a,b){return null==b?this.U:null==this.root?!1:this.root.Oa(0,nc(b),b,jd)!==jd};k.D=function(){if(0<this.g){var a=null!=this.root?this.root.lb():null;return this.U?M(new W(null,2,5,uf,[null,this.da],null),a):a}return null};
	k.F=function(a,b){return new rg(b,this.g,this.root,this.U,this.da,this.p)};k.G=function(a,b){if(ed(b))return cb(this,C.a(b,0),C.a(b,1));for(var c=this,d=D(b);;){if(null==d)return c;var e=G(d);if(ed(e))c=cb(c,C.a(e,0),C.a(e,1)),d=K(d);else throw Error("conj on a map takes map entries or seqables of map entries");}};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};var Qc=new rg(null,0,null,!1,null,0);rg.prototype[Ea]=function(){return uc(this)};
	function sg(a,b,c,d,e){this.u=a;this.root=b;this.count=c;this.U=d;this.da=e;this.q=56;this.j=258}k=sg.prototype;k.Jb=function(a,b){if(this.u)if(null==b)this.U&&(this.U=!1,this.da=null,this.count-=1);else{if(null!=this.root){var c=new $f,d=this.root.nb(this.u,0,nc(b),b,c);d!==this.root&&(this.root=d);t(c[0])&&(this.count-=1)}}else throw Error("dissoc! after persistent!");return this};k.kb=function(a,b,c){return tg(this,b,c)};k.Sa=function(a,b){return ug(this,b)};
	k.Ta=function(){var a;if(this.u)this.u=null,a=new rg(null,this.count,this.root,this.U,this.da,null);else throw Error("persistent! called twice");return a};k.t=function(a,b){return null==b?this.U?this.da:null:null==this.root?null:this.root.Oa(0,nc(b),b)};k.s=function(a,b,c){return null==b?this.U?this.da:c:null==this.root?c:this.root.Oa(0,nc(b),b,c)};k.L=function(){if(this.u)return this.count;throw Error("count after persistent!");};
	function ug(a,b){if(a.u){if(b?b.j&2048||b.jc||(b.j?0:w(fb,b)):w(fb,b))return tg(a,Yf.b?Yf.b(b):Yf.call(null,b),Zf.b?Zf.b(b):Zf.call(null,b));for(var c=D(b),d=a;;){var e=G(c);if(t(e))var f=e,c=K(c),d=tg(d,function(){var a=f;return Yf.b?Yf.b(a):Yf.call(null,a)}(),function(){var a=f;return Zf.b?Zf.b(a):Zf.call(null,a)}());else return d}}else throw Error("conj! after persistent");}
	function tg(a,b,c){if(a.u){if(null==b)a.da!==c&&(a.da=c),a.U||(a.count+=1,a.U=!0);else{var d=new $f;b=(null==a.root?ig:a.root).la(a.u,0,nc(b),b,c,d);b!==a.root&&(a.root=b);d.o&&(a.count+=1)}return a}throw Error("assoc! after persistent!");}function vg(a,b,c){for(var d=b;;)if(null!=a)b=c?a.left:a.right,d=Nc.a(d,a),a=b;else return d}function wg(a,b,c,d,e){this.k=a;this.stack=b;this.pb=c;this.g=d;this.p=e;this.q=0;this.j=32374862}k=wg.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};
	k.L=function(){return 0>this.g?Q(K(this))+1:this.g};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return Wc(this.stack)};k.S=function(){var a=G(this.stack),a=vg(this.pb?a.right:a.left,K(this.stack),this.pb);return null!=a?new wg(null,a,this.pb,this.g-1,null):J};k.D=function(){return this};
	k.F=function(a,b){return new wg(b,this.stack,this.pb,this.g,this.p)};k.G=function(a,b){return M(b,this)};wg.prototype[Ea]=function(){return uc(this)};function xg(a,b,c){return new wg(null,vg(a,null,b),b,c,null)}
	function yg(a,b,c,d){return c instanceof X?c.left instanceof X?new X(c.key,c.o,c.left.ua(),new Z(a,b,c.right,d,null),null):c.right instanceof X?new X(c.right.key,c.right.o,new Z(c.key,c.o,c.left,c.right.left,null),new Z(a,b,c.right.right,d,null),null):new Z(a,b,c,d,null):new Z(a,b,c,d,null)}
	function zg(a,b,c,d){return d instanceof X?d.right instanceof X?new X(d.key,d.o,new Z(a,b,c,d.left,null),d.right.ua(),null):d.left instanceof X?new X(d.left.key,d.left.o,new Z(a,b,c,d.left.left,null),new Z(d.key,d.o,d.left.right,d.right,null),null):new Z(a,b,c,d,null):new Z(a,b,c,d,null)}
	function Ag(a,b,c,d){if(c instanceof X)return new X(a,b,c.ua(),d,null);if(d instanceof Z)return zg(a,b,c,d.ob());if(d instanceof X&&d.left instanceof Z)return new X(d.left.key,d.left.o,new Z(a,b,c,d.left.left,null),zg(d.key,d.o,d.left.right,d.right.ob()),null);throw Error("red-black tree invariant violation");}
	var Cg=function Bg(b,c,d){d=null!=b.left?Bg(b.left,c,d):d;if(Ac(d))return L.b?L.b(d):L.call(null,d);var e=b.key,f=b.o;d=c.c?c.c(d,e,f):c.call(null,d,e,f);if(Ac(d))return L.b?L.b(d):L.call(null,d);b=null!=b.right?Bg(b.right,c,d):d;return Ac(b)?L.b?L.b(b):L.call(null,b):b};function Z(a,b,c,d,e){this.key=a;this.o=b;this.left=c;this.right=d;this.p=e;this.q=0;this.j=32402207}k=Z.prototype;k.Mb=function(a){return a.Ob(this)};k.ob=function(){return new X(this.key,this.o,this.left,this.right,null)};
	k.ua=function(){return this};k.Lb=function(a){return a.Nb(this)};k.replace=function(a,b,c,d){return new Z(a,b,c,d,null)};k.Nb=function(a){return new Z(a.key,a.o,this,a.right,null)};k.Ob=function(a){return new Z(a.key,a.o,a.left,this,null)};k.Xa=function(a,b){return Cg(this,a,b)};k.t=function(a,b){return C.c(this,b,null)};k.s=function(a,b,c){return C.c(this,b,c)};k.Q=function(a,b){return 0===b?this.key:1===b?this.o:null};k.$=function(a,b,c){return 0===b?this.key:1===b?this.o:c};
	k.Ua=function(a,b,c){return(new W(null,2,5,uf,[this.key,this.o],null)).Ua(null,b,c)};k.H=function(){return null};k.L=function(){return 2};k.hb=function(){return this.key};k.ib=function(){return this.o};k.La=function(){return this.o};k.Ma=function(){return new W(null,1,5,uf,[this.key],null)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return Mc};k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){return Cc.c(this,b,c)};
	k.Ka=function(a,b,c){return Rc.c(new W(null,2,5,uf,[this.key,this.o],null),b,c)};k.D=function(){return Ra(Ra(J,this.o),this.key)};k.F=function(a,b){return O(new W(null,2,5,uf,[this.key,this.o],null),b)};k.G=function(a,b){return new W(null,3,5,uf,[this.key,this.o,b],null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};Z.prototype[Ea]=function(){return uc(this)};
	function X(a,b,c,d,e){this.key=a;this.o=b;this.left=c;this.right=d;this.p=e;this.q=0;this.j=32402207}k=X.prototype;k.Mb=function(a){return new X(this.key,this.o,this.left,a,null)};k.ob=function(){throw Error("red-black tree invariant violation");};k.ua=function(){return new Z(this.key,this.o,this.left,this.right,null)};k.Lb=function(a){return new X(this.key,this.o,a,this.right,null)};k.replace=function(a,b,c,d){return new X(a,b,c,d,null)};
	k.Nb=function(a){return this.left instanceof X?new X(this.key,this.o,this.left.ua(),new Z(a.key,a.o,this.right,a.right,null),null):this.right instanceof X?new X(this.right.key,this.right.o,new Z(this.key,this.o,this.left,this.right.left,null),new Z(a.key,a.o,this.right.right,a.right,null),null):new Z(a.key,a.o,this,a.right,null)};
	k.Ob=function(a){return this.right instanceof X?new X(this.key,this.o,new Z(a.key,a.o,a.left,this.left,null),this.right.ua(),null):this.left instanceof X?new X(this.left.key,this.left.o,new Z(a.key,a.o,a.left,this.left.left,null),new Z(this.key,this.o,this.left.right,this.right,null),null):new Z(a.key,a.o,a.left,this,null)};k.Xa=function(a,b){return Cg(this,a,b)};k.t=function(a,b){return C.c(this,b,null)};k.s=function(a,b,c){return C.c(this,b,c)};
	k.Q=function(a,b){return 0===b?this.key:1===b?this.o:null};k.$=function(a,b,c){return 0===b?this.key:1===b?this.o:c};k.Ua=function(a,b,c){return(new W(null,2,5,uf,[this.key,this.o],null)).Ua(null,b,c)};k.H=function(){return null};k.L=function(){return 2};k.hb=function(){return this.key};k.ib=function(){return this.o};k.La=function(){return this.o};k.Ma=function(){return new W(null,1,5,uf,[this.key],null)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};
	k.A=function(a,b){return Ic(this,b)};k.J=function(){return Mc};k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){return Cc.c(this,b,c)};k.Ka=function(a,b,c){return Rc.c(new W(null,2,5,uf,[this.key,this.o],null),b,c)};k.D=function(){return Ra(Ra(J,this.o),this.key)};k.F=function(a,b){return O(new W(null,2,5,uf,[this.key,this.o],null),b)};k.G=function(a,b){return new W(null,3,5,uf,[this.key,this.o,b],null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};X.prototype[Ea]=function(){return uc(this)};
	var Eg=function Dg(b,c,d,e,f){if(null==c)return new X(d,e,null,null,null);var g;g=c.key;g=b.a?b.a(d,g):b.call(null,d,g);if(0===g)return f[0]=c,null;if(0>g)return b=Dg(b,c.left,d,e,f),null!=b?c.Lb(b):null;b=Dg(b,c.right,d,e,f);return null!=b?c.Mb(b):null},Gg=function Fg(b,c){if(null==b)return c;if(null==c)return b;if(b instanceof X){if(c instanceof X){var d=Fg(b.right,c.left);return d instanceof X?new X(d.key,d.o,new X(b.key,b.o,b.left,d.left,null),new X(c.key,c.o,d.right,c.right,null),null):new X(b.key,
	b.o,b.left,new X(c.key,c.o,d,c.right,null),null)}return new X(b.key,b.o,b.left,Fg(b.right,c),null)}if(c instanceof X)return new X(c.key,c.o,Fg(b,c.left),c.right,null);d=Fg(b.right,c.left);return d instanceof X?new X(d.key,d.o,new Z(b.key,b.o,b.left,d.left,null),new Z(c.key,c.o,d.right,c.right,null),null):Ag(b.key,b.o,b.left,new Z(c.key,c.o,d,c.right,null))},Ig=function Hg(b,c,d,e){if(null!=c){var f;f=c.key;f=b.a?b.a(d,f):b.call(null,d,f);if(0===f)return e[0]=c,Gg(c.left,c.right);if(0>f)return b=Hg(b,
	c.left,d,e),null!=b||null!=e[0]?c.left instanceof Z?Ag(c.key,c.o,b,c.right):new X(c.key,c.o,b,c.right,null):null;b=Hg(b,c.right,d,e);if(null!=b||null!=e[0])if(c.right instanceof Z)if(e=c.key,d=c.o,c=c.left,b instanceof X)c=new X(e,d,c,b.ua(),null);else if(c instanceof Z)c=yg(e,d,c.ob(),b);else if(c instanceof X&&c.right instanceof Z)c=new X(c.right.key,c.right.o,yg(c.key,c.o,c.left.ob(),c.right.left),new Z(e,d,c.right.right,b,null),null);else throw Error("red-black tree invariant violation");else c=
	new X(c.key,c.o,c.left,b,null);else c=null;return c}return null},Kg=function Jg(b,c,d,e){var f=c.key,g=b.a?b.a(d,f):b.call(null,d,f);return 0===g?c.replace(f,e,c.left,c.right):0>g?c.replace(f,c.o,Jg(b,c.left,d,e),c.right):c.replace(f,c.o,c.left,Jg(b,c.right,d,e))};function Lg(a,b,c,d,e){this.aa=a;this.na=b;this.g=c;this.k=d;this.p=e;this.j=418776847;this.q=8192}k=Lg.prototype;k.toString=function(){return ec(this)};
	function Mg(a,b){for(var c=a.na;;)if(null!=c){var d;d=c.key;d=a.aa.a?a.aa.a(b,d):a.aa.call(null,b,d);if(0===d)return c;c=0>d?c.left:c.right}else return null}k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){a=Mg(this,b);return null!=a?a.o:c};k.gb=function(a,b,c){return null!=this.na?Cg(this.na,b,c):c};k.H=function(){return this.k};k.L=function(){return this.g};k.ab=function(){return 0<this.g?xg(this.na,!1,this.g):null};k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};
	k.A=function(a,b){return Pf(this,b)};k.J=function(){return new Lg(this.aa,null,0,this.k,0)};k.wb=function(a,b){var c=[null],d=Ig(this.aa,this.na,b,c);return null==d?null==R.a(c,0)?this:new Lg(this.aa,null,0,this.k,null):new Lg(this.aa,d.ua(),this.g-1,this.k,null)};k.Ka=function(a,b,c){a=[null];var d=Eg(this.aa,this.na,b,c,a);return null==d?(a=R.a(a,0),sc.a(c,a.o)?this:new Lg(this.aa,Kg(this.aa,this.na,b,c),this.g,this.k,null)):new Lg(this.aa,d.ua(),this.g+1,this.k,null)};
	k.rb=function(a,b){return null!=Mg(this,b)};k.D=function(){return 0<this.g?xg(this.na,!0,this.g):null};k.F=function(a,b){return new Lg(this.aa,this.na,this.g,b,this.p)};k.G=function(a,b){if(ed(b))return cb(this,C.a(b,0),C.a(b,1));for(var c=this,d=D(b);;){if(null==d)return c;var e=G(d);if(ed(e))c=cb(c,C.a(e,0),C.a(e,1)),d=K(d);else throw Error("conj on a map takes map entries or seqables of map entries");}};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};k.Hb=function(a,b){return 0<this.g?xg(this.na,b,this.g):null};
	k.Ib=function(a,b,c){if(0<this.g){a=null;for(var d=this.na;;)if(null!=d){var e;e=d.key;e=this.aa.a?this.aa.a(b,e):this.aa.call(null,b,e);if(0===e)return new wg(null,Nc.a(a,d),c,-1,null);t(c)?0>e?(a=Nc.a(a,d),d=d.left):d=d.right:0<e?(a=Nc.a(a,d),d=d.right):d=d.left}else return null==a?null:new wg(null,a,c,-1,null)}else return null};k.Gb=function(a,b){return Yf.b?Yf.b(b):Yf.call(null,b)};k.Fb=function(){return this.aa};var Ng=new Lg(od,null,0,null,0);Lg.prototype[Ea]=function(){return uc(this)};
	var Og=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){a=D(a);for(var b=Ob(Qc);;)if(a){var e=K(K(a)),b=ee.c(b,G(a),Lc(a));a=e}else return Qb(b)}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}(),Pg=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,
	d)}function b(a){a:{a=T.a(Ha,a);for(var b=a.length,e=0,f=Ob(Uf);;)if(e<b)var g=e+2,f=Rb(f,a[e],a[e+1]),e=g;else{a=Qb(f);break a}a=void 0}return a}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}(),Qg=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){a=D(a);for(var b=Ng;;)if(a){var e=K(K(a)),b=Rc.c(b,G(a),Lc(a));a=e}else return b}a.i=0;a.f=function(a){a=D(a);
	return b(a)};a.d=b;return a}(),Rg=function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,b){for(var e=D(b),f=new Lg(qd(a),null,0,null,0);;)if(e)var g=K(K(e)),f=Rc.c(f,G(e),Lc(e)),e=g;else return f}a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}();function Sg(a,b){this.Y=a;this.Z=b;this.q=0;this.j=32374988}k=Sg.prototype;k.toString=function(){return ec(this)};
	k.H=function(){return this.Z};k.T=function(){var a=this.Y,a=(a?a.j&128||a.xb||(a.j?0:w(Xa,a)):w(Xa,a))?this.Y.T(null):K(this.Y);return null==a?null:new Sg(a,this.Z)};k.B=function(){return wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.Z)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return this.Y.N(null).hb(null)};
	k.S=function(){var a=this.Y,a=(a?a.j&128||a.xb||(a.j?0:w(Xa,a)):w(Xa,a))?this.Y.T(null):K(this.Y);return null!=a?new Sg(a,this.Z):J};k.D=function(){return this};k.F=function(a,b){return new Sg(this.Y,b)};k.G=function(a,b){return M(b,this)};Sg.prototype[Ea]=function(){return uc(this)};function Tg(a){return(a=D(a))?new Sg(a,null):null}function Yf(a){return hb(a)}function Ug(a,b){this.Y=a;this.Z=b;this.q=0;this.j=32374988}k=Ug.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.Z};
	k.T=function(){var a=this.Y,a=(a?a.j&128||a.xb||(a.j?0:w(Xa,a)):w(Xa,a))?this.Y.T(null):K(this.Y);return null==a?null:new Ug(a,this.Z)};k.B=function(){return wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.Z)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return this.Y.N(null).ib(null)};k.S=function(){var a=this.Y,a=(a?a.j&128||a.xb||(a.j?0:w(Xa,a)):w(Xa,a))?this.Y.T(null):K(this.Y);return null!=a?new Ug(a,this.Z):J};
	k.D=function(){return this};k.F=function(a,b){return new Ug(this.Y,b)};k.G=function(a,b){return M(b,this)};Ug.prototype[Ea]=function(){return uc(this)};function Vg(a){return(a=D(a))?new Ug(a,null):null}function Zf(a){return ib(a)}
	var Wg=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return t(Fe(ud,a))?A.a(function(a,b){return Nc.a(t(a)?a:Uf,b)},a):null}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}(),Xg=function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,
	b){return t(Fe(ud,b))?A.a(function(a){return function(b,c){return A.c(a,t(b)?b:Uf,D(c))}}(function(b,d){var g=G(d),h=Lc(d);return nd(b,g)?Rc.c(b,g,function(){var d=S.a(b,g);return a.a?a.a(d,h):a.call(null,d,h)}()):Rc.c(b,g,h)}),b):null}a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}();function Yg(a,b){for(var c=Uf,d=D(b);;)if(d)var e=G(d),f=S.c(a,e,Zg),c=je.a(f,Zg)?Rc.c(c,e,f):c,d=K(d);else return O(c,Vc(a))}
	function $g(a,b,c){this.k=a;this.Wa=b;this.p=c;this.j=15077647;this.q=8196}k=$g.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return bb(this.Wa,b)?b:c};k.H=function(){return this.k};k.L=function(){return Ma(this.Wa)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};k.A=function(a,b){return ad(b)&&Q(this)===Q(b)&&Ee(function(a){return function(b){return nd(a,b)}}(this),b)};k.$a=function(){return new ah(Ob(this.Wa))};
	k.J=function(){return O(bh,this.k)};k.Eb=function(a,b){return new $g(this.k,eb(this.Wa,b),null)};k.D=function(){return Tg(this.Wa)};k.F=function(a,b){return new $g(b,this.Wa,this.p)};k.G=function(a,b){return new $g(this.k,Rc.c(this.Wa,b,null),null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};var bh=new $g(null,Uf,0);$g.prototype[Ea]=function(){return uc(this)};
	function ah(a){this.ma=a;this.j=259;this.q=136}k=ah.prototype;k.call=function(){function a(a,b,c){return $a.c(this.ma,b,jd)===jd?c:b}function b(a,b){return $a.c(this.ma,b,jd)===jd?null:b}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};
	k.b=function(a){return $a.c(this.ma,a,jd)===jd?null:a};k.a=function(a,b){return $a.c(this.ma,a,jd)===jd?b:a};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return $a.c(this.ma,b,jd)===jd?c:b};k.L=function(){return Q(this.ma)};k.Tb=function(a,b){this.ma=fe.a(this.ma,b);return this};k.Sa=function(a,b){this.ma=ee.c(this.ma,b,null);return this};k.Ta=function(){return new $g(null,Qb(this.ma),null)};function ch(a,b,c){this.k=a;this.ja=b;this.p=c;this.j=417730831;this.q=8192}k=ch.prototype;
	k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){a=Mg(this.ja,b);return null!=a?a.key:c};k.H=function(){return this.k};k.L=function(){return Q(this.ja)};k.ab=function(){return 0<Q(this.ja)?Oe.a(Yf,Gb(this.ja)):null};k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};k.A=function(a,b){return ad(b)&&Q(this)===Q(b)&&Ee(function(a){return function(b){return nd(a,b)}}(this),b)};k.J=function(){return new ch(this.k,Na(this.ja),0)};
	k.Eb=function(a,b){return new ch(this.k,Sc.a(this.ja,b),null)};k.D=function(){return Tg(this.ja)};k.F=function(a,b){return new ch(b,this.ja,this.p)};k.G=function(a,b){return new ch(this.k,Rc.c(this.ja,b,null),null)};k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();
	k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};k.Hb=function(a,b){return Oe.a(Yf,Hb(this.ja,b))};k.Ib=function(a,b,c){return Oe.a(Yf,Ib(this.ja,b,c))};k.Gb=function(a,b){return b};k.Fb=function(){return Kb(this.ja)};var eh=new ch(null,Ng,0);ch.prototype[Ea]=function(){return uc(this)};
	function fh(a){a=D(a);if(null==a)return bh;if(a instanceof F&&0===a.m){a=a.e;a:{for(var b=0,c=Ob(bh);;)if(b<a.length)var d=b+1,c=c.Sa(null,a[b]),b=d;else{a=c;break a}a=void 0}return a.Ta(null)}for(d=Ob(bh);;)if(null!=a)b=a.T(null),d=d.Sa(null,a.N(null)),a=b;else return d.Ta(null)}
	var gh=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return A.c(Ra,eh,a)}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}(),hh=function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,b){return A.c(Ra,new ch(null,Rg(a),0),b)}
	a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}();function Od(a){if(a&&(a.q&4096||a.lc))return a.name;if("string"===typeof a)return a;throw Error([z("Doesn't support name: "),z(a)].join(""));}
	var ih=function(){function a(a,b,c){return(a.b?a.b(b):a.call(null,b))>(a.b?a.b(c):a.call(null,c))?b:c}var b=null,c=function(){function a(b,d,h,l){var m=null;if(3<arguments.length){for(var m=0,p=Array(arguments.length-3);m<p.length;)p[m]=arguments[m+3],++m;m=new F(p,0)}return c.call(this,b,d,h,m)}function c(a,d,e,l){return A.c(function(c,d){return b.c(a,c,d)},b.c(a,d,e),l)}a.i=3;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=K(a);var l=G(a);a=H(a);return c(b,d,l,a)};a.d=c;return a}(),b=function(b,
	e,f,g){switch(arguments.length){case 2:return e;case 3:return a.call(this,b,e,f);default:var h=null;if(3<arguments.length){for(var h=0,l=Array(arguments.length-3);h<l.length;)l[h]=arguments[h+3],++h;h=new F(l,0)}return c.d(b,e,f,h)}throw Error("Invalid arity: "+arguments.length);};b.i=3;b.f=c.f;b.a=function(a,b){return b};b.c=a;b.d=c.d;return b}();function jh(a){this.e=a}jh.prototype.add=function(a){return this.e.push(a)};jh.prototype.size=function(){return this.e.length};
	jh.prototype.clear=function(){return this.e=[]};
	var kh=function(){function a(a,b,c){return new V(null,function(){var h=D(c);return h?M(Pe.a(a,h),d.c(a,b,Qe.a(b,h))):null},null,null)}function b(a,b){return d.c(a,a,b)}function c(a){return function(b){return function(c){return function(){function d(h,l){c.add(l);if(a===c.size()){var m=zf(c.e);c.clear();return b.a?b.a(h,m):b.call(null,h,m)}return h}function l(a){if(!t(0===c.e.length)){var d=zf(c.e);c.clear();a=Bc(b.a?b.a(a,d):b.call(null,a,d))}return b.b?b.b(a):b.call(null,a)}function m(){return b.l?
	b.l():b.call(null)}var p=null,p=function(a,b){switch(arguments.length){case 0:return m.call(this);case 1:return l.call(this,a);case 2:return d.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};p.l=m;p.b=l;p.a=d;return p}()}(new jh([]))}}var d=null,d=function(d,f,g){switch(arguments.length){case 1:return c.call(this,d);case 2:return b.call(this,d,f);case 3:return a.call(this,d,f,g)}throw Error("Invalid arity: "+arguments.length);};d.b=c;d.a=b;d.c=a;return d}(),lh=function(){function a(a,
	b){return new V(null,function(){var f=D(b);if(f){var g;g=G(f);g=a.b?a.b(g):a.call(null,g);f=t(g)?M(G(f),c.a(a,H(f))):null}else f=null;return f},null,null)}function b(a){return function(b){return function(){function c(f,g){return t(a.b?a.b(g):a.call(null,g))?b.a?b.a(f,g):b.call(null,f,g):new yc(f)}function g(a){return b.b?b.b(a):b.call(null,a)}function h(){return b.l?b.l():b.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);case 1:return g.call(this,a);case 2:return c.call(this,
	a,b)}throw Error("Invalid arity: "+arguments.length);};l.l=h;l.b=g;l.a=c;return l}()}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();function mh(a,b,c){return function(d){var e=Kb(a);d=Jb(a,d);e=e.a?e.a(d,c):e.call(null,d,c);return b.a?b.a(e,0):b.call(null,e,0)}}
	var nh=function(){function a(a,b,c,g,h){var l=Ib(a,c,!0);if(t(l)){var m=R.c(l,0,null);return lh.a(mh(a,g,h),t(mh(a,b,c).call(null,m))?l:K(l))}return null}function b(a,b,c){var g=mh(a,b,c),h;a:{h=[Ad,Bd];var l=h.length;if(l<=Vf)for(var m=0,p=Ob(Uf);;)if(m<l)var q=m+1,p=Rb(p,h[m],null),m=q;else{h=new $g(null,Qb(p),null);break a}else for(m=0,p=Ob(bh);;)if(m<l)q=m+1,p=Pb(p,h[m]),m=q;else{h=Qb(p);break a}h=void 0}return t(h.call(null,b))?(a=Ib(a,c,!0),t(a)?(b=R.c(a,0,null),t(g.b?g.b(b):g.call(null,b))?
	a:K(a)):null):lh.a(g,Hb(a,!0))}var c=null,c=function(c,e,f,g,h){switch(arguments.length){case 3:return b.call(this,c,e,f);case 5:return a.call(this,c,e,f,g,h)}throw Error("Invalid arity: "+arguments.length);};c.c=b;c.r=a;return c}();function oh(a,b,c){this.m=a;this.end=b;this.step=c}oh.prototype.ga=function(){return 0<this.step?this.m<this.end:this.m>this.end};oh.prototype.next=function(){var a=this.m;this.m+=this.step;return a};
	function ph(a,b,c,d,e){this.k=a;this.start=b;this.end=c;this.step=d;this.p=e;this.j=32375006;this.q=8192}k=ph.prototype;k.toString=function(){return ec(this)};k.Q=function(a,b){if(b<Ma(this))return this.start+b*this.step;if(this.start>this.end&&0===this.step)return this.start;throw Error("Index out of bounds");};k.$=function(a,b,c){return b<Ma(this)?this.start+b*this.step:this.start>this.end&&0===this.step?this.start:c};k.vb=!0;k.fb=function(){return new oh(this.start,this.end,this.step)};k.H=function(){return this.k};
	k.T=function(){return 0<this.step?this.start+this.step<this.end?new ph(this.k,this.start+this.step,this.end,this.step,null):null:this.start+this.step>this.end?new ph(this.k,this.start+this.step,this.end,this.step,null):null};k.L=function(){if(Aa(Cb(this)))return 0;var a=(this.end-this.start)/this.step;return Math.ceil.b?Math.ceil.b(a):Math.ceil.call(null,a)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};
	k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){for(a=this.start;;)if(0<this.step?a<this.end:a>this.end){var d=a;c=b.a?b.a(c,d):b.call(null,c,d);if(Ac(c))return b=c,L.b?L.b(b):L.call(null,b);a+=this.step}else return c};k.N=function(){return null==Cb(this)?null:this.start};k.S=function(){return null!=Cb(this)?new ph(this.k,this.start+this.step,this.end,this.step,null):J};k.D=function(){return 0<this.step?this.start<this.end?this:null:this.start>this.end?this:null};
	k.F=function(a,b){return new ph(b,this.start,this.end,this.step,this.p)};k.G=function(a,b){return M(b,this)};ph.prototype[Ea]=function(){return uc(this)};
	var qh=function(){function a(a,b,c){return new ph(null,a,b,c,null)}function b(a,b){return e.c(a,b,1)}function c(a){return e.c(0,a,1)}function d(){return e.c(0,Number.MAX_VALUE,1)}var e=null,e=function(e,g,h){switch(arguments.length){case 0:return d.call(this);case 1:return c.call(this,e);case 2:return b.call(this,e,g);case 3:return a.call(this,e,g,h)}throw Error("Invalid arity: "+arguments.length);};e.l=d;e.b=c;e.a=b;e.c=a;return e}(),rh=function(){function a(a,b){return new V(null,function(){var f=
	D(b);return f?M(G(f),c.a(a,Qe.a(a,f))):null},null,null)}function b(a){return function(b){return function(c){return function(){function g(g,h){var l=c.bb(0,c.Ra(null)+1),m=Cd(l,a);return 0===l-a*m?b.a?b.a(g,h):b.call(null,g,h):g}function h(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return h.call(this,a);case 2:return g.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);
	};m.l=l;m.b=h;m.a=g;return m}()}(new Me(-1))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),th=function(){function a(a,b){return new V(null,function(){var f=D(b);if(f){var g=G(f),h=a.b?a.b(g):a.call(null,g),g=M(g,lh.a(function(b,c){return function(b){return sc.a(c,a.b?a.b(b):a.call(null,b))}}(g,h,f,f),K(f)));return M(g,c.a(a,D(Qe.a(Q(g),f))))}return null},null,
	null)}function b(a){return function(b){return function(c,g){return function(){function h(h,l){var m=L.b?L.b(g):L.call(null,g),p=a.b?a.b(l):a.call(null,l);ac(g,p);if(Nd(m,sh)||sc.a(p,m))return c.add(l),h;m=zf(c.e);c.clear();m=b.a?b.a(h,m):b.call(null,h,m);Ac(m)||c.add(l);return m}function l(a){if(!t(0===c.e.length)){var d=zf(c.e);c.clear();a=Bc(b.a?b.a(a,d):b.call(null,a,d))}return b.b?b.b(a):b.call(null,a)}function m(){return b.l?b.l():b.call(null)}var p=null,p=function(a,b){switch(arguments.length){case 0:return m.call(this);
	case 1:return l.call(this,a);case 2:return h.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};p.l=m;p.b=l;p.a=h;return p}()}(new jh([]),new Me(sh))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),uh=function(){function a(a,b){for(;;)if(D(b)&&0<a){var c=a-1,g=K(b);a=c;b=g}else return null}function b(a){for(;;)if(D(a))a=K(a);else return null}var c=
	null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),vh=function(){function a(a,b){uh.a(a,b);return b}function b(a){uh.b(a);return a}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();
	function wh(a,b,c,d,e,f,g){var h=ma;try{ma=null==ma?null:ma-1;if(null!=ma&&0>ma)return Lb(a,"#");Lb(a,c);if(D(g)){var l=G(g);b.c?b.c(l,a,f):b.call(null,l,a,f)}for(var m=K(g),p=za.b(f)-1;;)if(!m||null!=p&&0===p){D(m)&&0===p&&(Lb(a,d),Lb(a,"..."));break}else{Lb(a,d);var q=G(m);c=a;g=f;b.c?b.c(q,c,g):b.call(null,q,c,g);var s=K(m);c=p-1;m=s;p=c}return Lb(a,e)}finally{ma=h}}
	var xh=function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,b){for(var e=D(b),f=null,g=0,h=0;;)if(h<g){var l=f.Q(null,h);Lb(a,l);h+=1}else if(e=D(e))f=e,fd(f)?(e=Yb(f),g=Zb(f),f=e,l=Q(e),e=g,g=l):(l=G(f),Lb(a,l),e=K(f),f=null,g=0),h=0;else return null}a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}(),yh={'"':'\\"',"\\":"\\\\","\b":"\\b","\f":"\\f",
	"\n":"\\n","\r":"\\r","\t":"\\t"};function zh(a){return[z('"'),z(a.replace(RegExp('[\\\\"\b\f\n\r\t]',"g"),function(a){return yh[a]})),z('"')].join("")}
	var $=function Ah(b,c,d){if(null==b)return Lb(c,"nil");if(void 0===b)return Lb(c,"#\x3cundefined\x3e");t(function(){var c=S.a(d,wa);return t(c)?(c=b?b.j&131072||b.kc?!0:b.j?!1:w(rb,b):w(rb,b))?Vc(b):c:c}())&&(Lb(c,"^"),Ah(Vc(b),c,d),Lb(c," "));if(null==b)return Lb(c,"nil");if(b.Yb)return b.nc(c);if(b&&(b.j&2147483648||b.I))return b.v(null,c,d);if(Ba(b)===Boolean||"number"===typeof b)return Lb(c,""+z(b));if(null!=b&&b.constructor===Object){Lb(c,"#js ");var e=Oe.a(function(c){return new W(null,2,5,
	uf,[Pd.b(c),b[c]],null)},gd(b));return Bh.n?Bh.n(e,Ah,c,d):Bh.call(null,e,Ah,c,d)}return b instanceof Array?wh(c,Ah,"#js ["," ","]",d,b):t("string"==typeof b)?t(ua.b(d))?Lb(c,zh(b)):Lb(c,b):Tc(b)?xh.d(c,Kc(["#\x3c",""+z(b),"\x3e"],0)):b instanceof Date?(e=function(b,c){for(var d=""+z(b);;)if(Q(d)<c)d=[z("0"),z(d)].join("");else return d},xh.d(c,Kc(['#inst "',""+z(b.getUTCFullYear()),"-",e(b.getUTCMonth()+1,2),"-",e(b.getUTCDate(),2),"T",e(b.getUTCHours(),2),":",e(b.getUTCMinutes(),2),":",e(b.getUTCSeconds(),
	2),".",e(b.getUTCMilliseconds(),3),"-",'00:00"'],0))):b instanceof RegExp?xh.d(c,Kc(['#"',b.source,'"'],0)):(b?b.j&2147483648||b.I||(b.j?0:w(Mb,b)):w(Mb,b))?Nb(b,c,d):xh.d(c,Kc(["#\x3c",""+z(b),"\x3e"],0))},Ch=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){var b=oa();if(Yc(a))b="";else{var e=z,f=new fa;a:{var g=new dc(f);$(G(a),g,b);a=D(K(a));for(var h=null,l=0,
	m=0;;)if(m<l){var p=h.Q(null,m);Lb(g," ");$(p,g,b);m+=1}else if(a=D(a))h=a,fd(h)?(a=Yb(h),l=Zb(h),h=a,p=Q(a),a=l,l=p):(p=G(h),Lb(g," "),$(p,g,b),a=K(h),h=null,l=0),m=0;else break a}b=""+e(f)}return b}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}();function Bh(a,b,c,d){return wh(c,function(a,c,d){var h=hb(a);b.c?b.c(h,c,d):b.call(null,h,c,d);Lb(c," ");a=ib(a);return b.c?b.c(a,c,d):b.call(null,a,c,d)},"{",", ","}",d,D(a))}Me.prototype.I=!0;
	Me.prototype.v=function(a,b,c){Lb(b,"#\x3cVolatile: ");$(this.state,b,c);return Lb(b,"\x3e")};F.prototype.I=!0;F.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};V.prototype.I=!0;V.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};wg.prototype.I=!0;wg.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};pg.prototype.I=!0;pg.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Z.prototype.I=!0;
	Z.prototype.v=function(a,b,c){return wh(b,$,"["," ","]",c,this)};Rf.prototype.I=!0;Rf.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};ch.prototype.I=!0;ch.prototype.v=function(a,b,c){return wh(b,$,"#{"," ","}",c,this)};Bf.prototype.I=!0;Bf.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Ld.prototype.I=!0;Ld.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Hc.prototype.I=!0;Hc.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};
	rg.prototype.I=!0;rg.prototype.v=function(a,b,c){return Bh(this,$,b,c)};qg.prototype.I=!0;qg.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Df.prototype.I=!0;Df.prototype.v=function(a,b,c){return wh(b,$,"["," ","]",c,this)};Lg.prototype.I=!0;Lg.prototype.v=function(a,b,c){return Bh(this,$,b,c)};$g.prototype.I=!0;$g.prototype.v=function(a,b,c){return wh(b,$,"#{"," ","}",c,this)};Vd.prototype.I=!0;Vd.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Ug.prototype.I=!0;
	Ug.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};X.prototype.I=!0;X.prototype.v=function(a,b,c){return wh(b,$,"["," ","]",c,this)};W.prototype.I=!0;W.prototype.v=function(a,b,c){return wh(b,$,"["," ","]",c,this)};Kf.prototype.I=!0;Kf.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Hd.prototype.I=!0;Hd.prototype.v=function(a,b){return Lb(b,"()")};ze.prototype.I=!0;ze.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Lf.prototype.I=!0;
	Lf.prototype.v=function(a,b,c){return wh(b,$,"#queue ["," ","]",c,D(this))};pa.prototype.I=!0;pa.prototype.v=function(a,b,c){return Bh(this,$,b,c)};ph.prototype.I=!0;ph.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Sg.prototype.I=!0;Sg.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Fd.prototype.I=!0;Fd.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};W.prototype.sb=!0;W.prototype.tb=function(a,b){return pd.a(this,b)};Df.prototype.sb=!0;
	Df.prototype.tb=function(a,b){return pd.a(this,b)};U.prototype.sb=!0;U.prototype.tb=function(a,b){return Md(this,b)};qc.prototype.sb=!0;qc.prototype.tb=function(a,b){return pc(this,b)};var Dh=function(){function a(a,d,e){var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.call(this,a,d,f)}function b(a,b,e){return a.k=T.c(b,a.k,e)}a.i=2;a.f=function(a){var d=G(a);a=K(a);var e=G(a);a=H(a);return b(d,e,a)};a.d=b;return a}();
	function Eh(a){return function(b,c){var d=a.a?a.a(b,c):a.call(null,b,c);return Ac(d)?new yc(d):d}}
	function Ve(a){return function(b){return function(){function c(a,c){return A.c(b,a,c)}function d(b){return a.b?a.b(b):a.call(null,b)}function e(){return a.l?a.l():a.call(null)}var f=null,f=function(a,b){switch(arguments.length){case 0:return e.call(this);case 1:return d.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};f.l=e;f.b=d;f.a=c;return f}()}(Eh(a))}
	var Fh=function(){function a(a){return Ce.a(c.l(),a)}function b(){return function(a){return function(b){return function(){function c(f,g){var h=L.b?L.b(b):L.call(null,b);ac(b,g);return sc.a(h,g)?f:a.a?a.a(f,g):a.call(null,f,g)}function g(b){return a.b?a.b(b):a.call(null,b)}function h(){return a.l?a.l():a.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);case 1:return g.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);
	};l.l=h;l.b=g;l.a=c;return l}()}(new Me(sh))}}var c=null,c=function(c){switch(arguments.length){case 0:return b.call(this);case 1:return a.call(this,c)}throw Error("Invalid arity: "+arguments.length);};c.l=b;c.b=a;return c}();function Gh(a,b){this.fa=a;this.Zb=b;this.q=0;this.j=2173173760}Gh.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Gh.prototype.O=function(a,b,c){return wd.n(this.fa,b,c,this.Zb)};Gh.prototype.D=function(){return D(Ce.a(this.fa,this.Zb))};Gh.prototype[Ea]=function(){return uc(this)};
	var Hh={};function Ih(a){if(a?a.gc:a)return a.gc(a);var b;b=Ih[n(null==a?null:a)];if(!b&&(b=Ih._,!b))throw x("IEncodeJS.-clj-\x3ejs",a);return b.call(null,a)}function Jh(a){return(a?t(t(null)?null:a.fc)||(a.yb?0:w(Hh,a)):w(Hh,a))?Ih(a):"string"===typeof a||"number"===typeof a||a instanceof U||a instanceof qc?Kh.b?Kh.b(a):Kh.call(null,a):Ch.d(Kc([a],0))}
	var Kh=function Lh(b){if(null==b)return null;if(b?t(t(null)?null:b.fc)||(b.yb?0:w(Hh,b)):w(Hh,b))return Ih(b);if(b instanceof U)return Od(b);if(b instanceof qc)return""+z(b);if(dd(b)){var c={};b=D(b);for(var d=null,e=0,f=0;;)if(f<e){var g=d.Q(null,f),h=R.c(g,0,null),g=R.c(g,1,null);c[Jh(h)]=Lh(g);f+=1}else if(b=D(b))fd(b)?(e=Yb(b),b=Zb(b),d=e,e=Q(e)):(e=G(b),d=R.c(e,0,null),e=R.c(e,1,null),c[Jh(d)]=Lh(e),b=K(b),d=null,e=0),f=0;else break;return c}if($c(b)){c=[];b=D(Oe.a(Lh,b));d=null;for(f=e=0;;)if(f<
	e)h=d.Q(null,f),c.push(h),f+=1;else if(b=D(b))d=b,fd(d)?(b=Yb(d),f=Zb(d),d=b,e=Q(b),b=f):(b=G(d),c.push(b),b=K(d),d=null,e=0),f=0;else break;return c}return b},Mh={};function Nh(a,b){if(a?a.ec:a)return a.ec(a,b);var c;c=Nh[n(null==a?null:a)];if(!c&&(c=Nh._,!c))throw x("IEncodeClojure.-js-\x3eclj",a);return c.call(null,a,b)}
	var Ph=function(){function a(a){return b.d(a,Kc([new pa(null,1,[Oh,!1],null)],0))}var b=null,c=function(){function a(c,d){var h=null;if(1<arguments.length){for(var h=0,l=Array(arguments.length-1);h<l.length;)l[h]=arguments[h+1],++h;h=new F(l,0)}return b.call(this,c,h)}function b(a,c){var d=kd(c)?T.a(Og,c):c,e=S.a(d,Oh);return function(a,b,d,e){return function v(f){return(f?t(t(null)?null:f.uc)||(f.yb?0:w(Mh,f)):w(Mh,f))?Nh(f,T.a(Pg,c)):kd(f)?vh.b(Oe.a(v,f)):$c(f)?af.a(Oc(f),Oe.a(v,f)):f instanceof
	Array?zf(Oe.a(v,f)):Ba(f)===Object?af.a(Uf,function(){return function(a,b,c,d){return function Pa(e){return new V(null,function(a,b,c,d){return function(){for(;;){var a=D(e);if(a){if(fd(a)){var b=Yb(a),c=Q(b),g=Td(c);return function(){for(var a=0;;)if(a<c){var e=C.a(b,a),h=g,l=uf,m;m=e;m=d.b?d.b(m):d.call(null,m);e=new W(null,2,5,l,[m,v(f[e])],null);h.add(e);a+=1}else return!0}()?Wd(g.ca(),Pa(Zb(a))):Wd(g.ca(),null)}var h=G(a);return M(new W(null,2,5,uf,[function(){var a=h;return d.b?d.b(a):d.call(null,
	a)}(),v(f[h])],null),Pa(H(a)))}return null}}}(a,b,c,d),null,null)}}(a,b,d,e)(gd(f))}()):f}}(c,d,e,t(e)?Pd:z)(a)}a.i=1;a.f=function(a){var c=G(a);a=H(a);return b(c,a)};a.d=b;return a}(),b=function(b,e){switch(arguments.length){case 1:return a.call(this,b);default:var f=null;if(1<arguments.length){for(var f=0,g=Array(arguments.length-1);f<g.length;)g[f]=arguments[f+1],++f;f=new F(g,0)}return c.d(b,f)}throw Error("Invalid arity: "+arguments.length);};b.i=1;b.f=c.f;b.b=a;b.d=c.d;return b}();var wa=new U(null,"meta","meta",1499536964),ya=new U(null,"dup","dup",556298533),sh=new U("cljs.core","none","cljs.core/none",926646439),pe=new U(null,"file","file",-1269645878),le=new U(null,"end-column","end-column",1425389514),sa=new U(null,"flush-on-newline","flush-on-newline",-151457939),ne=new U(null,"column","column",2078222095),ua=new U(null,"readably","readably",1129599760),oe=new U(null,"line","line",212345235),za=new U(null,"print-length","print-length",1931866356),me=new U(null,"end-line",
	"end-line",1837326455),Oh=new U(null,"keywordize-keys","keywordize-keys",1310784252),Zg=new U("cljs.core","not-found","cljs.core/not-found",-1572889185);function Qh(a,b){var c=T.c(ih,a,b);return M(c,Ye.a(function(a){return function(b){return a===b}}(c),b))}
	var Rh=function(){function a(a,b){return Q(a)<Q(b)?A.c(Nc,b,a):A.c(Nc,a,b)}var b=null,c=function(){function a(c,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return b.call(this,c,d,l)}function b(a,c,d){a=Qh(Q,Nc.d(d,c,Kc([a],0)));return A.c(af,G(a),H(a))}a.i=2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),b=function(b,e,f){switch(arguments.length){case 0:return bh;case 1:return b;
	case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.l=function(){return bh};b.b=function(a){return a};b.a=a;b.d=c.d;return b}(),Sh=function(){function a(a,b){for(;;)if(Q(b)<Q(a)){var c=a;a=b;b=c}else return A.c(function(a,b){return function(a,c){return nd(b,c)?a:Xc.a(a,c)}}(a,b),a,a)}var b=null,c=function(){function a(b,
	d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){a=Qh(function(a){return-Q(a)},Nc.d(e,d,Kc([a],0)));return A.c(b,G(a),H(a))}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return b;case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-
	2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(a){return a};b.a=a;b.d=c.d;return b}(),Th=function(){function a(a,b){return Q(a)<Q(b)?A.c(function(a,c){return nd(b,c)?Xc.a(a,c):a},a,a):A.c(Xc,a,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,
	e){return A.c(b,a,Nc.a(e,d))}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return b;case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(a){return a};b.a=a;b.d=c.d;return b}();
	function Uh(a,b){return A.c(function(b,d){var e=R.c(d,0,null),f=R.c(d,1,null);return nd(a,e)?Rc.c(b,f,S.a(a,e)):b},T.c(Sc,a,Tg(b)),b)}function Vh(a,b){return A.c(function(a,d){var e=Yg(d,b);return Rc.c(a,e,Nc.a(S.c(a,e,bh),d))},Uf,a)}function Wh(a){return A.c(function(a,c){var d=R.c(c,0,null),e=R.c(c,1,null);return Rc.c(a,e,d)},Uf,a)}
	var Xh=function(){function a(a,b,c){a=Q(a)<=Q(b)?new W(null,3,5,uf,[a,b,Wh(c)],null):new W(null,3,5,uf,[b,a,c],null);b=R.c(a,0,null);c=R.c(a,1,null);var g=R.c(a,2,null),h=Vh(b,Vg(g));return A.c(function(a,b,c,d,e){return function(f,g){var h=function(){var a=Uh(Yg(g,Tg(d)),d);return e.b?e.b(a):e.call(null,a)}();return t(h)?A.c(function(){return function(a,b){return Nc.a(a,Wg.d(Kc([b,g],0)))}}(h,a,b,c,d,e),f,h):f}}(a,b,c,g,h),bh,c)}function b(a,b){if(D(a)&&D(b)){var c=Sh.a(fh(Tg(G(a))),fh(Tg(G(b)))),
	g=Q(a)<=Q(b)?new W(null,2,5,uf,[a,b],null):new W(null,2,5,uf,[b,a],null),h=R.c(g,0,null),l=R.c(g,1,null),m=Vh(h,c);return A.c(function(a,b,c,d,e){return function(f,g){var h=function(){var b=Yg(g,a);return e.b?e.b(b):e.call(null,b)}();return t(h)?A.c(function(){return function(a,b){return Nc.a(a,Wg.d(Kc([b,g],0)))}}(h,a,b,c,d,e),f,h):f}}(c,g,h,l,m),bh,l)}return bh}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+
	arguments.length);};c.a=b;c.c=a;return c}();r("mori.apply",T);r("mori.apply.f2",T.a);r("mori.apply.f3",T.c);r("mori.apply.f4",T.n);r("mori.apply.f5",T.r);r("mori.apply.fn",T.K);r("mori.count",Q);r("mori.distinct",function(a){return function c(a,e){return new V(null,function(){return function(a,d){for(;;){var e=a,l=R.c(e,0,null);if(e=D(e))if(nd(d,l))l=H(e),e=d,a=l,d=e;else return M(l,c(H(e),Nc.a(d,l)));else return null}}.call(null,a,e)},null,null)}(a,bh)});r("mori.empty",Oc);r("mori.first",G);r("mori.second",Lc);r("mori.next",K);
	r("mori.rest",H);r("mori.seq",D);r("mori.conj",Nc);r("mori.conj.f0",Nc.l);r("mori.conj.f1",Nc.b);r("mori.conj.f2",Nc.a);r("mori.conj.fn",Nc.K);r("mori.cons",M);r("mori.find",function(a,b){return null!=a&&bd(a)&&nd(a,b)?new W(null,2,5,uf,[b,S.a(a,b)],null):null});r("mori.nth",R);r("mori.nth.f2",R.a);r("mori.nth.f3",R.c);r("mori.last",function(a){for(;;){var b=K(a);if(null!=b)a=b;else return G(a)}});r("mori.assoc",Rc);r("mori.assoc.f3",Rc.c);r("mori.assoc.fn",Rc.K);r("mori.dissoc",Sc);
	r("mori.dissoc.f1",Sc.b);r("mori.dissoc.f2",Sc.a);r("mori.dissoc.fn",Sc.K);r("mori.getIn",cf);r("mori.getIn.f2",cf.a);r("mori.getIn.f3",cf.c);r("mori.updateIn",df);r("mori.updateIn.f3",df.c);r("mori.updateIn.f4",df.n);r("mori.updateIn.f5",df.r);r("mori.updateIn.f6",df.P);r("mori.updateIn.fn",df.K);r("mori.assocIn",function Yh(b,c,d){var e=R.c(c,0,null);return(c=Ed(c))?Rc.c(b,e,Yh(S.a(b,e),c,d)):Rc.c(b,e,d)});r("mori.fnil",Ke);r("mori.fnil.f2",Ke.a);r("mori.fnil.f3",Ke.c);r("mori.fnil.f4",Ke.n);
	r("mori.disj",Xc);r("mori.disj.f1",Xc.b);r("mori.disj.f2",Xc.a);r("mori.disj.fn",Xc.K);r("mori.pop",function(a){return null==a?null:mb(a)});r("mori.peek",Wc);r("mori.hash",nc);r("mori.get",S);r("mori.get.f2",S.a);r("mori.get.f3",S.c);r("mori.hasKey",nd);r("mori.isEmpty",Yc);r("mori.reverse",Jd);r("mori.take",Pe);r("mori.take.f1",Pe.b);r("mori.take.f2",Pe.a);r("mori.drop",Qe);r("mori.drop.f1",Qe.b);r("mori.drop.f2",Qe.a);r("mori.takeNth",rh);r("mori.takeNth.f1",rh.b);r("mori.takeNth.f2",rh.a);
	r("mori.partition",bf);r("mori.partition.f2",bf.a);r("mori.partition.f3",bf.c);r("mori.partition.f4",bf.n);r("mori.partitionAll",kh);r("mori.partitionAll.f1",kh.b);r("mori.partitionAll.f2",kh.a);r("mori.partitionAll.f3",kh.c);r("mori.partitionBy",th);r("mori.partitionBy.f1",th.b);r("mori.partitionBy.f2",th.a);r("mori.iterate",function Zh(b,c){return M(c,new V(null,function(){return Zh(b,b.b?b.b(c):b.call(null,c))},null,null))});r("mori.into",af);r("mori.into.f2",af.a);r("mori.into.f3",af.c);
	r("mori.merge",Wg);r("mori.mergeWith",Xg);r("mori.subvec",Cf);r("mori.subvec.f2",Cf.a);r("mori.subvec.f3",Cf.c);r("mori.takeWhile",lh);r("mori.takeWhile.f1",lh.b);r("mori.takeWhile.f2",lh.a);r("mori.dropWhile",Re);r("mori.dropWhile.f1",Re.b);r("mori.dropWhile.f2",Re.a);r("mori.groupBy",function(a,b){return ce(A.c(function(b,d){var e=a.b?a.b(d):a.call(null,d);return ee.c(b,e,Nc.a(S.c(b,e,Mc),d))},Ob(Uf),b))});r("mori.interpose",function(a,b){return Qe.a(1,Ue.a(Se.b(a),b))});r("mori.interleave",Ue);
	r("mori.interleave.f2",Ue.a);r("mori.interleave.fn",Ue.K);r("mori.concat",ae);r("mori.concat.f0",ae.l);r("mori.concat.f1",ae.b);r("mori.concat.f2",ae.a);r("mori.concat.fn",ae.K);function $e(a){return a instanceof Array||cd(a)}r("mori.flatten",function(a){return Xe.a(function(a){return!$e(a)},H(Ze(a)))});r("mori.lazySeq",function(a){return new V(null,a,null,null)});r("mori.keys",Tg);r("mori.selectKeys",Yg);r("mori.vals",Vg);r("mori.primSeq",Jc);r("mori.primSeq.f1",Jc.b);r("mori.primSeq.f2",Jc.a);
	r("mori.map",Oe);r("mori.map.f1",Oe.b);r("mori.map.f2",Oe.a);r("mori.map.f3",Oe.c);r("mori.map.f4",Oe.n);r("mori.map.fn",Oe.K);
	r("mori.mapIndexed",function(a,b){return function d(b,f){return new V(null,function(){var g=D(f);if(g){if(fd(g)){for(var h=Yb(g),l=Q(h),m=Td(l),p=0;;)if(p<l)Xd(m,function(){var d=b+p,f=C.a(h,p);return a.a?a.a(d,f):a.call(null,d,f)}()),p+=1;else break;return Wd(m.ca(),d(b+l,Zb(g)))}return M(function(){var d=G(g);return a.a?a.a(b,d):a.call(null,b,d)}(),d(b+1,H(g)))}return null},null,null)}(0,b)});r("mori.mapcat",We);r("mori.mapcat.f1",We.b);r("mori.mapcat.fn",We.K);r("mori.reduce",A);
	r("mori.reduce.f2",A.a);r("mori.reduce.f3",A.c);r("mori.reduceKV",function(a,b,c){return null!=c?xb(c,a,b):b});r("mori.keep",Le);r("mori.keep.f1",Le.b);r("mori.keep.f2",Le.a);r("mori.keepIndexed",Ne);r("mori.keepIndexed.f1",Ne.b);r("mori.keepIndexed.f2",Ne.a);r("mori.filter",Xe);r("mori.filter.f1",Xe.b);r("mori.filter.f2",Xe.a);r("mori.remove",Ye);r("mori.remove.f1",Ye.b);r("mori.remove.f2",Ye.a);r("mori.some",Fe);r("mori.every",Ee);r("mori.equals",sc);r("mori.equals.f1",sc.b);
	r("mori.equals.f2",sc.a);r("mori.equals.fn",sc.K);r("mori.range",qh);r("mori.range.f0",qh.l);r("mori.range.f1",qh.b);r("mori.range.f2",qh.a);r("mori.range.f3",qh.c);r("mori.repeat",Se);r("mori.repeat.f1",Se.b);r("mori.repeat.f2",Se.a);r("mori.repeatedly",Te);r("mori.repeatedly.f1",Te.b);r("mori.repeatedly.f2",Te.a);r("mori.sort",sd);r("mori.sort.f1",sd.b);r("mori.sort.f2",sd.a);r("mori.sortBy",td);r("mori.sortBy.f2",td.a);r("mori.sortBy.f3",td.c);r("mori.intoArray",Ia);r("mori.intoArray.f1",Ia.b);
	r("mori.intoArray.f2",Ia.a);r("mori.subseq",nh);r("mori.subseq.f3",nh.c);r("mori.subseq.f5",nh.r);r("mori.dedupe",Fh);r("mori.dedupe.f0",Fh.l);r("mori.dedupe.f1",Fh.b);r("mori.transduce",wd);r("mori.transduce.f3",wd.c);r("mori.transduce.f4",wd.n);r("mori.eduction",function(a,b){return new Gh(a,b)});r("mori.sequence",Ce);r("mori.sequence.f1",Ce.b);r("mori.sequence.f2",Ce.a);r("mori.sequence.fn",Ce.K);r("mori.completing",vd);r("mori.completing.f1",vd.b);r("mori.completing.f2",vd.a);r("mori.list",Kd);
	r("mori.vector",Af);r("mori.hashMap",Pg);r("mori.set",fh);r("mori.sortedSet",gh);r("mori.sortedSetBy",hh);r("mori.sortedMap",Qg);r("mori.sortedMapBy",Rg);r("mori.queue",function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return af.a?af.a(Mf,a):af.call(null,Mf,a)}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}());r("mori.keyword",Pd);r("mori.keyword.f1",Pd.b);
	r("mori.keyword.f2",Pd.a);r("mori.symbol",rc);r("mori.symbol.f1",rc.b);r("mori.symbol.f2",rc.a);r("mori.zipmap",function(a,b){for(var c=Ob(Uf),d=D(a),e=D(b);;)if(d&&e)c=ee.c(c,G(d),G(e)),d=K(d),e=K(e);else return Qb(c)});r("mori.isList",function(a){return a?a.j&33554432||a.wc?!0:a.j?!1:w(Eb,a):w(Eb,a)});r("mori.isSeq",kd);r("mori.isVector",ed);r("mori.isMap",dd);r("mori.isSet",ad);r("mori.isKeyword",function(a){return a instanceof U});r("mori.isSymbol",function(a){return a instanceof qc});
	r("mori.isCollection",$c);r("mori.isSequential",cd);r("mori.isAssociative",bd);r("mori.isCounted",Ec);r("mori.isIndexed",Fc);r("mori.isReduceable",function(a){return a?a.j&524288||a.Sb?!0:a.j?!1:w(vb,a):w(vb,a)});r("mori.isSeqable",ld);r("mori.isReversible",Id);r("mori.union",Rh);r("mori.union.f0",Rh.l);r("mori.union.f1",Rh.b);r("mori.union.f2",Rh.a);r("mori.union.fn",Rh.K);r("mori.intersection",Sh);r("mori.intersection.f1",Sh.b);r("mori.intersection.f2",Sh.a);r("mori.intersection.fn",Sh.K);
	r("mori.difference",Th);r("mori.difference.f1",Th.b);r("mori.difference.f2",Th.a);r("mori.difference.fn",Th.K);r("mori.join",Xh);r("mori.join.f2",Xh.a);r("mori.join.f3",Xh.c);r("mori.index",Vh);r("mori.project",function(a,b){return fh(Oe.a(function(a){return Yg(a,b)},a))});r("mori.mapInvert",Wh);r("mori.rename",function(a,b){return fh(Oe.a(function(a){return Uh(a,b)},a))});r("mori.renameKeys",Uh);r("mori.isSubset",function(a,b){return Q(a)<=Q(b)&&Ee(function(a){return nd(b,a)},a)});
	r("mori.isSuperset",function(a,b){return Q(a)>=Q(b)&&Ee(function(b){return nd(a,b)},b)});r("mori.notEquals",je);r("mori.notEquals.f1",je.b);r("mori.notEquals.f2",je.a);r("mori.notEquals.fn",je.K);r("mori.gt",Ad);r("mori.gt.f1",Ad.b);r("mori.gt.f2",Ad.a);r("mori.gt.fn",Ad.K);r("mori.gte",Bd);r("mori.gte.f1",Bd.b);r("mori.gte.f2",Bd.a);r("mori.gte.fn",Bd.K);r("mori.lt",yd);r("mori.lt.f1",yd.b);r("mori.lt.f2",yd.a);r("mori.lt.fn",yd.K);r("mori.lte",zd);r("mori.lte.f1",zd.b);r("mori.lte.f2",zd.a);
	r("mori.lte.fn",zd.K);r("mori.compare",od);r("mori.partial",Je);r("mori.partial.f1",Je.b);r("mori.partial.f2",Je.a);r("mori.partial.f3",Je.c);r("mori.partial.f4",Je.n);r("mori.partial.fn",Je.K);r("mori.comp",Ie);r("mori.comp.f0",Ie.l);r("mori.comp.f1",Ie.b);r("mori.comp.f2",Ie.a);r("mori.comp.f3",Ie.c);r("mori.comp.fn",Ie.K);
	r("mori.pipeline",function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){function b(a,c){return c.b?c.b(a):c.call(null,a)}return A.a?A.a(b,a):A.call(null,b,a)}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}());
	r("mori.curry",function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,b){return function(e){return T.a(a,M.a?M.a(e,b):M.call(null,e,b))}}a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}());
	r("mori.juxt",function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return function(){function b(a){var c=null;if(0<arguments.length){for(var c=0,d=Array(arguments.length-0);c<d.length;)d[c]=arguments[c+0],++c;c=new F(d,0)}return e.call(this,c)}function e(b){var d=function(){function d(a){return T.a(a,b)}return Oe.a?Oe.a(d,a):Oe.call(null,d,a)}();return Ia.b?Ia.b(d):Ia.call(null,
	d)}b.i=0;b.f=function(a){a=D(a);return e(a)};b.d=e;return b}()}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}());
	r("mori.knit",function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return function(b){var e=function(){function e(a,b){return a.b?a.b(b):a.call(null,b)}return Oe.c?Oe.c(e,a,b):Oe.call(null,e,a,b)}();return Ia.b?Ia.b(e):Ia.call(null,e)}}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}());r("mori.sum",xd);r("mori.sum.f0",xd.l);r("mori.sum.f1",xd.b);
	r("mori.sum.f2",xd.a);r("mori.sum.fn",xd.K);r("mori.inc",function(a){return a+1});r("mori.dec",function(a){return a-1});r("mori.isEven",Ge);r("mori.isOdd",function(a){return!Ge(a)});r("mori.each",function(a,b){for(var c=D(a),d=null,e=0,f=0;;)if(f<e){var g=d.Q(null,f);b.b?b.b(g):b.call(null,g);f+=1}else if(c=D(c))fd(c)?(e=Yb(c),c=Zb(c),d=e,e=Q(e)):(d=g=G(c),b.b?b.b(d):b.call(null,d),c=K(c),d=null,e=0),f=0;else return null});r("mori.identity",ud);
	r("mori.constantly",function(a){return function(){function b(b){if(0<arguments.length)for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;return a}b.i=0;b.f=function(b){D(b);return a};b.d=function(){return a};return b}()});r("mori.toJs",Kh);
	r("mori.toClj",function(){function a(a,b){return Ph.d(a,Kc([Oh,b],0))}function b(a){return Ph.b(a)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}());r("mori.configure",function(a,b){switch(a){case "print-length":return la=b;case "print-level":return ma=b;default:throw Error([z("No matching clause: "),z(a)].join(""));}});r("mori.meta",Vc);r("mori.withMeta",O);
	r("mori.varyMeta",ie);r("mori.varyMeta.f2",ie.a);r("mori.varyMeta.f3",ie.c);r("mori.varyMeta.f4",ie.n);r("mori.varyMeta.f5",ie.r);r("mori.varyMeta.f6",ie.P);r("mori.varyMeta.fn",ie.K);r("mori.alterMeta",Dh);r("mori.resetMeta",function(a,b){return a.k=b});V.prototype.inspect=function(){return this.toString()};F.prototype.inspect=function(){return this.toString()};Hc.prototype.inspect=function(){return this.toString()};wg.prototype.inspect=function(){return this.toString()};pg.prototype.inspect=function(){return this.toString()};
	qg.prototype.inspect=function(){return this.toString()};Fd.prototype.inspect=function(){return this.toString()};Ld.prototype.inspect=function(){return this.toString()};Hd.prototype.inspect=function(){return this.toString()};W.prototype.inspect=function(){return this.toString()};Vd.prototype.inspect=function(){return this.toString()};Bf.prototype.inspect=function(){return this.toString()};Df.prototype.inspect=function(){return this.toString()};Z.prototype.inspect=function(){return this.toString()};
	X.prototype.inspect=function(){return this.toString()};pa.prototype.inspect=function(){return this.toString()};rg.prototype.inspect=function(){return this.toString()};Lg.prototype.inspect=function(){return this.toString()};$g.prototype.inspect=function(){return this.toString()};ch.prototype.inspect=function(){return this.toString()};ph.prototype.inspect=function(){return this.toString()};U.prototype.inspect=function(){return this.toString()};qc.prototype.inspect=function(){return this.toString()};
	Lf.prototype.inspect=function(){return this.toString()};Kf.prototype.inspect=function(){return this.toString()};r("mori.mutable.thaw",function(a){return Ob(a)});r("mori.mutable.freeze",ce);r("mori.mutable.conj",de);r("mori.mutable.conj.f0",de.l);r("mori.mutable.conj.f1",de.b);r("mori.mutable.conj.f2",de.a);r("mori.mutable.conj.fn",de.K);r("mori.mutable.assoc",ee);r("mori.mutable.assoc.f3",ee.c);r("mori.mutable.assoc.fn",ee.K);r("mori.mutable.dissoc",fe);r("mori.mutable.dissoc.f2",fe.a);r("mori.mutable.dissoc.fn",fe.K);r("mori.mutable.pop",function(a){return Ub(a)});r("mori.mutable.disj",ge);
	r("mori.mutable.disj.f2",ge.a);r("mori.mutable.disj.fn",ge.K);;return this.mori;}.call({});});


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Setting up configuration constants
	 */
	
	// Values we need to parse the google docs
	var sheetParseConfig = exports.sheetParseConfig = {
	  configHeader: '1',
	  dataHeader: 'A',
	  configTitles: ['config', 'notes', 'sources'],
	  sourceTypes: ['notes', 'sources', 'definitions'],
	  headerTypes: ['characteristic', 'type'],
	  headerSymbols: {
	    'percent-unformatted': /\%|percent/,
	    'currency': /\$|USD|currency/
	  },
	  // These are special options on the config which apply to components at
	  // many levels regardless of context. For example, locked will change the
	  // behavior of table and filter rendering and the types of options that can
	  // be selected
	  globalRules: ['locked', 'graph', 'map', 'geomulti', 'context', 'map base column', 'link column', 'link target', 'related columns'],
	  // This serves as a reverse dictionary for data types, enabling look up and
	  // type assignment by alias
	  dataTypes: {
	    'text': ['urban area', 'name', 'zip code', 'city', 'county', 'msa'],
	    'year': ['year'],
	    'percent': ['% of us total', '% of fpl', 'percent change', '% change', 'mlr', 'ratio'],
	    'currency': ['income'],
	    'number': ['rate', 'net change', 'rank'],
	    'date-format': ['mm/dd/yyyy', 'mon dd, yyyy', 'month yyyy', 'month dd yyyy'],
	    'fiscal year': null,
	    'default': null,
	    'geography': ['state'],
	    'yes/no': null
	  }
	};
	
	// Defaults and special case configuration for Datacenter app
	var appDefault = exports.appDefault = {
	  distributionName: 'Characteristics',
	  hideMap: false,
	  hideGraph: false,
	  isLocked: false,
	  // Values which can be selected on their own as rows, and should be given
	  // checkboxes outside the fieldgroup list
	  specialWrapups: ['United States', 'World', 'All Urban Counties', 'All Rural Counties', 'All MSAs'],
	  // The values which are used to represent N/A, and the order in which
	  // they should appear when in the same collection
	  dataNotAvailable: ['*', '**', 'NSD', '(NSD)', 'NR', 'NA', '(NA)', 'N/A', '-', '--', ''],
	  // Territories, for categorization when sorting
	  kffTerritories: ['Puerto Rico', 'Virgin Islands', 'Guam', 'Northern Mariana Islands', 'American Samoa', 'Residence Unknown', 'Federated States of Micronesia', 'Marshall Islands', 'Republic of Palau', 'U.S. Virgin Islands'],
	  countyOrder: ['states', 'counties', 'msas', 'ma-regions', 'pdp-regions'],
	  wrapupOrder: ['united-states', 'world', 'all-urban-counties', 'all-rural-counties', 'all-msas', 'all-ma-regions', 'all-pdp-regions'],
	  normalizedKffTerritories: ['puerto-rico', 'virgin-islands', 'guam', 'northern-mariana-islands', 'american-samoa', 'residence-unknown', 'federated-states-of-micronesia', 'marshall-islands', 'republic-of-palau', 'us-virgin-islands'],
	  // Tests for a few different common row types
	  isSpecialGeo: /^MA\sRegion|PDP\sRegion/,
	  isStateCategory: /^All\s/,
	  isSummaryRow: /[\s+]?\(All\)[\s+]?$/,
	  decimalPlacesMap: {
	    10000: -4,
	    1000: -3,
	    100: -2,
	    10: -1,
	    1: 0,
	    0.1: 1,
	    0.01: 2,
	    0.001: 3,
	    0.0001: 4,
	    0.00001: 5,
	    0.000001: 6,
	    0.0000001: 7
	  },
	  // CSS for padding Table Header Cells
	  // We need to take this into account when wrapping header text
	  // right and left padding: 20 and 10, respectively
	  //
	  headerPadding: 30,
	
	  // CSS for padding Table Cells
	  // We need to take this into account when wrapping cell text
	  // right and left padding: 10 and 10, respectively
	  //
	  cellPadding: 20,
	
	  // Max number of natural breaks for map
	  maxBreaks: 4,
	
	  // For known data types, we want to sort descending first.
	  descSortFirst: ['number', 'percent', 'currency', 'year'],
	
	  defaultWidths: {
	    'text': {
	      'default': 225,
	      'narrow': 175,
	      'wide': 300
	    },
	    'year': {
	      'default': 80,
	      'narrow': 60,
	      'wide': 140
	    },
	    'percent': {
	      'default': 100,
	      'narrow': 75,
	      'wide': 150
	    },
	    'currency': {
	      'default': 140,
	      'narrow': 100,
	      'wide': 180
	    },
	    'number': {
	      'default': 140,
	      'narrow': 100,
	      'wide': 180
	    },
	    'date-format': {
	      'default': 100,
	      'narrow': 75,
	      'wide': 150
	    },
	    'fiscal year': {
	      'default': 100,
	      'narrow': 75,
	      'wide': 150
	    },
	    'default': {
	      'default': 125
	    },
	    'geography': {
	      'default': 160
	    },
	    'yes/no': {
	      'default': 70,
	      'narrow': 50,
	      'wide': 125
	    }
	  },
	
	  // State Lookup For SHF Landing Page
	  stateLookup: {
	    'AL': 'Alabama',
	    'AK': 'Alaska',
	    'AZ': 'Arizona',
	    'AR': 'Arkansas',
	    'CA': 'California',
	    'CO': 'Colorado',
	    'CT': 'Connecticut',
	    'DE': 'Delaware',
	    'DC': 'District Of Columbia',
	    'FL': 'Florida',
	    'GA': 'Georgia',
	    'HI': 'Hawaii',
	    'ID': 'Idaho',
	    'IL': 'Illinois',
	    'IN': 'Indiana',
	    'IA': 'Iowa',
	    'KS': 'Kansas',
	    'KY': 'Kentucky',
	    'LA': 'Louisiana',
	    'ME': 'Maine',
	    'MD': 'Maryland',
	    'MA': 'Massachusetts',
	    'MI': 'Michigan',
	    'MN': 'Minnesota',
	    'MS': 'Mississippi',
	    'MO': 'Missouri',
	    'MT': 'Montana',
	    'NE': 'Nebraska',
	    'NV': 'Nevada',
	    'NH': 'New Hampshire',
	    'NJ': 'New Jersey',
	    'NM': 'New Mexico',
	    'NY': 'New York',
	    'NC': 'North Carolina',
	    'ND': 'North Dakota',
	    'OH': 'Ohio',
	    'OK': 'Oklahoma',
	    'OR': 'Oregon',
	    'PA': 'Pennsylvania',
	    'RI': 'Rhode Island',
	    'SC': 'South Carolina',
	    'SD': 'South Dakota',
	    'TN': 'Tennessee',
	    'TX': 'Texas',
	    'UT': 'Utah',
	    'VT': 'Vermont',
	    'VA': 'Virginia',
	    'WA': 'Washington',
	    'WV': 'West Virginia',
	    'WI': 'Wisconsin',
	    'WY': 'Wyoming'
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(sheetParseConfig, 'sheetParseConfig', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/config.js');
	
	  __REACT_HOT_LOADER__.register(appDefault, 'appDefault', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/config.js');
	}();

	;

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.kffIsNumber = kffIsNumber;
	exports.kffNumericValue = kffNumericValue;
	exports.commatize = commatize;
	exports.getSelectedItem = getSelectedItem;
	exports.getPrecision = getPrecision;
	exports.numberPrecision = numberPrecision;
	exports.getInferredType = getInferredType;
	exports.pluck = pluck;
	exports.modZip = modZip;
	exports.getEstTextLength = getEstTextLength;
	exports.getEstTextRows = getEstTextRows;
	exports.digColumnValue = digColumnValue;
	exports.getAndCleanCSVValues = getAndCleanCSVValues;
	exports.log = log;
	exports.getScrollbarWidth = getScrollbarWidth;
	exports.safeDeepDelete = safeDeepDelete;
	exports.isObject = isObject;
	exports.deepMerge = deepMerge;
	exports.deepDelete = deepDelete;
	exports.deepFind = deepFind;
	exports.isUrlSelected = isUrlSelected;
	exports.isAllSelected = isAllSelected;
	exports.isIE = isIE;
	exports.indexOf = indexOf;
	exports.maxWordWidth = maxWordWidth;
	exports.escapeHTML = escapeHTML;
	
	var _d = __webpack_require__(23);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function round(number, precision) {
	  var factor = Math.pow(10, precision);
	  var tempNumber = number * factor;
	  var roundedTempNumber = Math.round(tempNumber);
	  return roundedTempNumber / factor;
	}
	
	function kffIsNumber(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	function kffNumericValue(n) {
	  if (!n && n !== 0) {
	    return false;
	  } else if (kffIsNumber(n)) {
	    return parseFloat(n);
	  }
	
	  var pattern = /\,|\%|\$|<|>/g;
	  var d = parseFloat(n.toString().replace(pattern, ''));
	  if (isFinite(d) && !n.toString().match(/[a-zA-Z]/g)) {
	    return d;
	  }
	  return null;
	}
	
	/**
	 * This takes a number/float and inserts the **US** formatting
	 * of a number w/ commas, ie: a comma every 3 nums and a period for a decimal
	 * @param  {Number} number number to "commatize"
	 * @param  {String} sym    symbol to insert before the number
	 * @return {String}        "commatized" number
	 */
	function commatize(number) {
	  var sym = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var negativeSign = '-';
	  return number.toString().split('').reverse() // Flip it!
	  .reduce(function (acc, str, idx, arr) {
	    var pointLoc = arr.indexOf('.');
	    if (idx > pointLoc) {
	      // Do period check
	      var loc = pointLoc > -1 ? idx - pointLoc : idx;
	
	      if (loc % 3 === 0 && loc !== 0 && str !== negativeSign) {
	        acc.push(',');
	      }
	    }
	    acc.push(str);
	    return acc;
	  }, []).concat([sym]) // push on symbole
	  .reverse() // Flip it back!
	  .join('') // Join it!
	  .replace(sym + '-', '-' + sym); // If number is negative, swap the symbol and the negative sign.
	}
	
	function getSelectedItem(items) {
	  return items.filter(function (x) {
	    return x.selected;
	  }).shift();
	}
	
	function getPrecision(column) {
	  return _config.appDefault.decimalPlacesMap[column ? column.Precision || 0 : 0] || 0;
	}
	
	function numberPrecision(value, precision, percent) {
	  var multiplier = percent ? 100 : 1;
	  var number = round(+value * multiplier, precision || 0);
	
	  // Return formatted number, accounting for possible '-0'
	  return +number.toString().replace(+number === 0 ? '-' : '', '');
	}
	
	function getInferredType(name) {
	  if (/%/.test(name) || /percent/i.test(name)) {
	    return 'percent';
	  }
	
	  if (/\$/.test(name) || /USD/.test(name) || /currency/i.test(name)) {
	    return 'currency';
	  }
	
	  if (name && name.toLowerCase() === 'year') {
	    return 'year';
	  }
	
	  if (/states in/i.test(name)) {
	    return 'geography';
	  }
	  return 'default';
	}
	
	/**
	 * Reduces an array of objects into an array of a field
	 * @param  {array} tree     object/array to reduce
	 * @param  {string} field   key of object to extract
	 * @return {array}          array of fields
	 */
	function pluck(tree, field) {
	  if ((typeof tree === 'undefined' ? 'undefined' : _typeof(tree)) !== 'object') {
	    return [];
	  }
	
	  return tree.reduce(function (arr, item) {
	    return arr.indexOf(item[field]) < 0 ? arr.concat(item[field]) : arr;
	  }, []);
	}
	
	/**
	 * Maps two arrays to an object key-value, and runs
	 * modulus on values array if it is shorter than the key array
	 * @param  {array} keyArray     Array of values that should be the keys
	 * @param  {array} valueArray   Array of values that should map to values
	 * @return {object}             key-value object
	 */
	function modZip(keyArray, valueArray) {
	  return keyArray.reduce(function (obj, d, idx) {
	    var key = idx < valueArray.length ? idx : idx % valueArray.length;
	    obj[d] = valueArray[key];
	    return obj;
	  }, {});
	}
	
	/**
	 * Uses canvas.measureText to compute and return the width
	 * of the given text of given font in pixels.
	 *
	 * @param {String} text The text to be rendered.
	 * @param {String} font The css font descriptor that text is
	 *                 to be rendered with (e.g. "bold 14px verdana").
	 * @return {int}   the width of the text element
	 */
	function getEstTextLength(text, font) {
	  // @TODO re-use canvas object for better performance
	  var canvas = document.createElement('canvas');
	  var context = canvas.getContext('2d');
	  context.font = font;
	  var metrics = context.measureText(text);
	  var width = metrics.width;
	  // cleanup
	  if (canvas.remove) {
	    canvas.remove();
	  }
	  return width;
	}
	
	/**
	 * Get the estimated amount of rows of text
	 * @param  {string}  text  the test to calculate rows of
	 * @param  {String}  font  the css font descriptor that the text is
	 *                         to be rendered with (e.g. "bold 14px verdana").
	 * @param  {int}  width  the width the text should wrap in
	 * @return {int}  the number of rows that would be needed to see all text
	 */
	function getEstTextRows(text, font, width) {
	  return !text.split ? 1 : text.split(' ').reduce(function (acc, curr) {
	    return [].concat(_toConsumableArray(acc), _toConsumableArray(curr.split('-')));
	  }, []).reduce(function (acc, curr, idx) {
	    return textRowsReducer(font, width)(acc, curr, idx);
	  }, [[]]).length;
	}
	
	/**
	 * Reducer helper for getEstTextRows
	 * @param  {String} font  the css font descriptor that the text is
	 *                        to be rendered with (e.g. "bold 14px verdana").
	 * @param  {int} width    the width the text should wrap in
	 * @return {function}     the reducer function which builds an array of text rows
	 */
	function textRowsReducer(font, width) {
	  return function (acc, curr, idx) {
	    var line = [].concat(_toConsumableArray(acc[(acc.length - 1) % idx || 0]), [curr]).join(' ');
	    if (getEstTextLength(line, font) > width) {
	      acc.push([curr]);
	    } else {
	      acc[(acc.length - 1) % idx || 0].push(curr);
	    }
	    return acc;
	  };
	}
	
	/**
	 * Digs into an object, for a property, setup for digging into columns
	 * @param {Object} the object to dig into,
	 * @param {curried strings} 2, 2+nth elements are the keys to dig.
	 *
	 * @return {ANY} value of the deepest depth
	 */
	// @TODO, replace this so it uses the `...keys` syntax vs arguments
	function digColumnValue() {
	  var args = Array.prototype.slice.call(arguments);
	  var keys = args.slice(1, args.length);
	  var ret = keys.reduce(function (prev, curr) {
	    return prev ? prev[curr] : prev;
	  }, args[0]);
	
	  if (ret === undefined) {
	    ret = ['nested'].concat(_toConsumableArray(keys)).reduce(function (prev, curr) {
	      if (prev[curr]) {
	        return prev[curr].children !== undefined ? prev[curr].children : prev[curr];
	      }
	      return prev;
	    }, args[0]);
	  }
	  return ret;
	}
	
	/**
	 * Trim csv
	 */
	function getAndCleanCSVValues(csvStr, nullValue) {
	  if (!csvStr || !csvStr.length) {
	    return nullValue;
	  }
	  if (csvStr.indexOf(' && ') > -1) {
	    return [].concat(csvStr.split(' && ').map(function (parse) {
	      return getAndCleanCSVValues(parse, nullValue);
	    }).join(' && '));
	  }
	
	  return _d2.default.csv.parseRows(csvStr).shift().map(function (value) {
	    return value.trim().replace(/"([^"]+(?="))"/g, '$1');
	  });
	}
	
	/**
	 * Logging function for mori pass through
	 */
	function log(text, immutable) {
	  /* eslint-disable no-console */
	  console.log(text + ': ', _mori2.default.toJs(immutable));
	  /* eslint-enable no-console */
	  return immutable;
	}
	
	function getScrollbarWidth() {
	  var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  var outer = document.createElement('div');
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
	
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  // force scrollbars
	  outer.style.overflow = 'scroll';
	
	  // add innerdiv
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	
	  // remove divs
	  outer.parentNode.removeChild(outer);
	
	  return widthNoScroll - widthWithScroll + padding;
	}
	
	/**
	 * Safe deep delete (don't delete parents that have children)
	 * @param  {array} targets   Keys to iterate through
	 * @param  {object} context  Object to delete from
	 * @param  {bool}   unsafe   force unsafe deletion mode
	 * @return {bool}            Returns deleted status (or itself)
	 */
	function safeDeepDelete(targets, context) {
	  var unsafe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (typeof context === 'undefined') {
	    return false;
	  }
	
	  if (unsafe && targets.length > 1) {
	    return deepDelete(targets.slice(1), context[targets[0]]);
	  } else if (!unsafe && targets.length > 1) {
	    return safeDeepDelete(targets.slice(1), context[targets[0]]);
	  }
	
	  if (context[targets[0]] && (unsafe || Object.keys(context[targets[0]]).length === 0)) {
	    delete context[targets[0]];
	    return Object.keys(context).length > 0;
	  }
	  return false;
	}
	
	/**
	 * Simple is object check.
	 * @param item
	 * @returns {boolean}
	*/
	function isObject(item) {
	  return item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && !Array.isArray(item) && item !== null;
	}
	
	/**
	 * Deep merge two objects.
	 * https://gist.github.com/Salakar/1d7137de9cb8b704e48a
	 * @param target
	 * @param source
	*/
	function deepMerge(target, source) {
	  if (isObject(target) && isObject(source)) {
	    Object.keys(source).forEach(function (key) {
	      if (isObject(source[key])) {
	        if (!target[key]) {
	          Object.assign(target, _defineProperty({}, key, {}));
	        }
	        deepMerge(target[key], source[key]);
	      } else {
	        Object.assign(target, _defineProperty({}, key, source[key]));
	      }
	    });
	  }
	  return target;
	}
	
	/**
	 * Delete a deep nested object property
	 * @param  {array} targets   Keys to iterate through
	 * @param  {object} context  Object to delete from
	 * @return {bool}            Returns deleted status (or itself)
	 */
	function deepDelete(targets, context) {
	  if (typeof context === 'undefined') {
	    return false;
	  }
	  if (targets.length > 1) {
	    return deepDelete(targets.slice(1), context[targets[0]]);
	  }
	  if (context[targets[0]]) {
	    delete context[targets[0]];
	    return Object.keys(context).length > 0;
	  }
	  return false;
	}
	
	/**
	 * Find a deep nested object value
	 * @param  {array} targets    keys to iterate through
	 * @param  {object} context   object to find in
	 * @return {bool}             if key has a solution
	 */
	function deepFind(targets, context) {
	  if (typeof context === 'undefined') {
	    return false;
	  }
	  if (targets.length > 1) {
	    return deepFind(targets.slice(1), context[targets[0]]);
	  }
	  return context[targets[0]] || false;
	}
	
	// Check if rows is url selected
	function isUrlSelected(keys, rows) {
	  return !!keys.reduce(function (prev, curr) {
	    return prev ? prev[curr] : prev;
	  }, rows);
	}
	
	// Check if rows is all selected
	function isAllSelected(keys, rows) {
	  if (typeof rows === 'undefined') {
	    return false;
	  }
	  var temp = rows;
	  return [].concat(_toConsumableArray(keys.slice(0, keys.length - 1))).some(function (curr) {
	    if (!temp) {
	      return false;
	    }
	    if (temp[curr] && (temp[curr].hasOwnProperty('all') || Object.keys(temp[curr]).length === 0)) {
	      return true;
	    }
	    temp = temp[curr];
	    return false;
	  });
	}
	
	/**
	 * Detects if browser is IE11
	 * modified from the Angular methods for doing this
	 */
	function isIE() {
	  var msie = parseInt((/msie (\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1], 10);
	  if (isNaN(msie)) {
	    msie = parseInt((/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()) || [])[1], 10);
	  }
	  return !isNaN(msie);
	}
	
	/**
	 * Use with mori.filter for an indexOf
	 * @param  {collection} haystack
	 * @param  {value} needle
	 * @return {bool}
	 */
	function indexOf(haystack, needle) {
	  return _mori2.default.some(function (x) {
	    return _mori2.default.isCollection(x) && _mori2.default.isCollection(needle) ? _mori2.default.equals(_mori2.default.first(x), _mori2.default.first(_mori2.default.first(needle))) && _mori2.default.equals(_mori2.default.last(x), _mori2.default.last(_mori2.default.first(needle))) : _mori2.default.equals(x, needle);
	  }, haystack);
	}
	
	function maxWordWidth(string, fontStyle) {
	  return string.split(' ').reduce(function (acc, text) {
	    return text.split('-').length > 1 ? text.split('-').reduce(function (acc1, text1) {
	      return Math.max(getEstTextLength(text1, fontStyle), acc1);
	    }, 0) : Math.max(getEstTextLength(text, fontStyle), acc);
	  }, 0);
	}
	
	/**
	 * Escapes HTML tags in a string of characters
	 * https://gist.github.com/cvan/2817d07ef5f17fb66365
	 *
	 * @param {String} str A string of characters.
	 * @param {Boolean} escapeQuotes (optional) Whether to escape quotation marks.
	 * @return {String} The HTML-escaped string.
	 */
	function escapeHTML(str, escapeQuotes) {
	  if (!str || typeof str !== 'string') {
	    return '';
	  }
	
	  var escaped = str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	
	  if (escapeQuotes) {
	    return escaped.replace(/"/g, '&quot;').replace(/'/g, '&apos;');
	  }
	
	  return escaped;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(round, 'round', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(kffIsNumber, 'kffIsNumber', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(kffNumericValue, 'kffNumericValue', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(commatize, 'commatize', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(getSelectedItem, 'getSelectedItem', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(getPrecision, 'getPrecision', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(numberPrecision, 'numberPrecision', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(getInferredType, 'getInferredType', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(pluck, 'pluck', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(modZip, 'modZip', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(getEstTextLength, 'getEstTextLength', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(getEstTextRows, 'getEstTextRows', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(textRowsReducer, 'textRowsReducer', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(digColumnValue, 'digColumnValue', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(getAndCleanCSVValues, 'getAndCleanCSVValues', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(log, 'log', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(getScrollbarWidth, 'getScrollbarWidth', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(safeDeepDelete, 'safeDeepDelete', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(isObject, 'isObject', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(deepMerge, 'deepMerge', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(deepDelete, 'deepDelete', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(deepFind, 'deepFind', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(isUrlSelected, 'isUrlSelected', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(isAllSelected, 'isAllSelected', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(isIE, 'isIE', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(indexOf, 'indexOf', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(maxWordWidth, 'maxWordWidth', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	
	  __REACT_HOT_LOADER__.register(escapeHTML, 'escapeHTML', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/util.js');
	}();

	;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _buildHeader = __webpack_require__(254);
	
	Object.defineProperty(exports, 'buildHeader', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buildHeader).default;
	  }
	});
	
	var _buildRowData = __webpack_require__(255);
	
	Object.defineProperty(exports, 'buildRowData', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_buildRowData).default;
	  }
	});
	
	var _cellRenderer = __webpack_require__(256);
	
	Object.defineProperty(exports, 'cellRenderer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_cellRenderer).default;
	  }
	});
	
	var _getAgColumns = __webpack_require__(258);
	
	Object.defineProperty(exports, 'getAgColumns', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getAgColumns).default;
	  }
	});
	
	var _getApplicableFootnotes = __webpack_require__(259);
	
	Object.defineProperty(exports, 'getApplicableFootnotes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getApplicableFootnotes).default;
	  }
	});
	
	var _getDataRankings = __webpack_require__(260);
	
	Object.defineProperty(exports, 'getDataRankings', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getDataRankings).default;
	  }
	});
	
	var _filterByRow = __webpack_require__(257);
	
	Object.defineProperty(exports, 'filterByRow', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_filterByRow).default;
	  }
	});
	
	var _valueGetter = __webpack_require__(261);
	
	Object.defineProperty(exports, 'valueGetter', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_valueGetter).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _territorySortFilter = __webpack_require__(139);
	
	var _territorySortFilter2 = _interopRequireDefault(_territorySortFilter);
	
	var _markdownFilter = __webpack_require__(244);
	
	var _markdownFilter2 = _interopRequireDefault(_markdownFilter);
	
	var _switchFilter = __webpack_require__(72);
	
	var _switchFilter2 = _interopRequireDefault(_switchFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global __webpack_modules__ */
	/**
	 * Check if angular is being resolved,
	 * if it isn't then this doesn't matter... because react
	 */
	if (__webpack_require__.m[/*require.resolve*/(33)]) {
	  __webpack_require__(239);
	}
	
	
	/**
	 * Check if angular is being resolved,
	 * if it isn't then this doesn't matter... because react
	 */
	if (__webpack_require__.m[/*require.resolve*/(33)]) {
	  module.exports = angular.module('datacenterFilters', ['slugifier']).filter('filterSwitch', _switchFilter2.default).filter('markdown', _markdownFilter2.default).filter('territorySort', _territorySortFilter2.default).filter('percent', function () {
	    return function (value) {
	      return value + '%';
	    };
	  }).filter('rawCurrency', function () {
	    return function (value) {
	      return '$' + value;
	    };
	  }).name;
	} else {
	  module.exports = function (filterName) {
	    return {
	      filterSwitch: _switchFilter2.default,
	      markdown: _markdownFilter2.default,
	      territorySort: _territorySortFilter2.default,
	      percent: function percent(value) {
	        return value + '%';
	      },
	      rawCurrency: function rawCurrency(value) {
	        return '$' + value;
	      }
	    }[filterName];
	  };
	}
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates an array of distributions for selecting data based on context
	 */
	var _default = function _default(data, distributions, type, isGeomulti) {
	  if (isGeomulti) {
	    return _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (distribution) {
	      return _mori2.default.equals(_mori2.default.getIn(data.config, ['globalRules', 'Map Base Column']), _mori2.default.get(distribution, 'characteristic'));
	    }), _mori2.default.map(function (distribution) {
	      return distributionSelector(data, distribution, type);
	    })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), data.immutableDistributions);
	  }
	  return _mori2.default.map(function (distribution) {
	    return distributionSelector(data, distribution, type);
	  }, distributions);
	};
	
	exports.default = _default;
	
	
	function distributionSelector(data, distribution, type) {
	  // use the globally selected dataview, or get the column specific one
	  var dataviewLabel = type ? type.label : _mori2.default.get(_mori2.default.first(_mori2.default.filter(function (header) {
	    // If the distribution has a headerGroup,
	    // match the headerGroup AND the characteristic,
	    // else, characteristic only.
	    return _mori2.default.get(distribution, 'headerGroup', false) ? _mori2.default.equals(_mori2.default.get(header, 'headerGroup'), _mori2.default.get(distribution, 'headerGroup')) && _mori2.default.equals(_mori2.default.get(header, 'characteristic'), _mori2.default.get(distribution, 'characteristic')) : _mori2.default.equals(_mori2.default.get(header, 'characteristic'), _mori2.default.get(distribution, 'characteristic'));
	  }, data.immutableHeaders)), 'label');
	  return _mori2.default.get(distribution, 'headerGroup') === null ? _mori2.default.set([_mori2.default.get(distribution, 'characteristic'), dataviewLabel]) : _mori2.default.set([_mori2.default.get(distribution, 'headerGroup'), _mori2.default.get(distribution, 'characteristic'),
	  // If label and char. are the same, make label more unique
	  // Label/Char will be same if Doc uses only Year values (2016, etc.)
	  // TODO: Find a way to handle this better.
	  // See: dataReducer.js L109
	  dataviewLabel === _mori2.default.get(distribution, 'characteristic') ? '_' + dataviewLabel : dataviewLabel]);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(distributionSelector, 'distributionSelector', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getSelectedDistributions.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getSelectedDistributions.js');
	}();

	;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildRowProperties = buildRowProperties;
	exports.sortArbitrary = sortArbitrary;
	
	var _util = __webpack_require__(15);
	
	var _config = __webpack_require__(11);
	
	/* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	/**
	 * Add properties to each row object so we know how to sort them
	 */
	function buildRowProperties(value) {
	  var props = {};
	  var val = value !== 0 && !value ? '' : value.toString();
	  var hasWords = /([a-z\s].*?\s?){1,}/i;
	  var numberVal = val.toString().replace(/[^0-9-\.]/g, '');
	  props.isTerritory = _config.appDefault.kffTerritories.indexOf(val) !== -1;
	  props.isStateCategory = _config.appDefault.isStateCategory.test(val);
	  props.isSpecialGeo = _config.appDefault.isSpecialGeo.test(val);
	  props.wrapup = _config.appDefault.specialWrapups.indexOf(val) > -1;
	  props.isSummary = _config.appDefault.isSummaryRow.test(val.toString());
	  props.naData = _config.appDefault.dataNotAvailable.indexOf(val) > -1;
	  props.rawValue = (0, _util.kffIsNumber)(numberVal) && !hasWords.test(value) ? +numberVal : false;
	
	  if (props.isSummary) {
	    props.value = val.replace(/\s+\(All\)$/, '');
	  } else {
	    props.value = val;
	  }
	
	  return props;
	}
	
	function sortArbitrary(a, b, order) {
	  var isInverted = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  var aForceSortIndex = order.indexOf(a);
	  var bForceSortIndex = order.indexOf(b);
	  if (aForceSortIndex && bForceSortIndex && aForceSortIndex !== bForceSortIndex) {
	    return (isInverted ? -1 : 1) * (aForceSortIndex > bForceSortIndex ? 1 : -1);
	  } else if (aForceSortIndex) {
	    return 1;
	  } else if (bForceSortIndex) {
	    return -1;
	  }
	  return false;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(buildRowProperties, 'buildRowProperties', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/sorters/util.js');
	
	  __REACT_HOT_LOADER__.register(sortArbitrary, 'sortArbitrary', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/sorters/util.js');
	}();

	;

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = filterSwitch;
	
	var _config = __webpack_require__(11);
	
	var _util = __webpack_require__(15);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* global __webpack_modules__ */
	
	/**
	 * Formats data point values according to the column settings and/or
	 * primitive parsing conditionals
	 */
	if (__webpack_require__.m[/*require.resolve*/(33)]) {
	  filterSwitch.$inject = ['$filter'];
	}
	function filterSwitch($filter) {
	  if (!__webpack_require__.m[/*require.resolve*/(33)]) {
	    /* eslint-disable no-param-reassign */
	    $filter = function $filter(filter) {
	      return {
	        currency: function currency(i, sym, precision) {
	          return (0, _util.commatize)(+(0, _util.numberPrecision)(i, precision, false), sym);
	        },
	        percent: function percent(i) {
	          return i + '%';
	        },
	        number: function number(_number, precision) {
	          // Taken from 'formatNumber' in angular.js
	          var fraction = ('' + _number).split('.');
	          var formattedText = fraction[0];
	          fraction = fraction[1] || '';
	
	          // Format fraction
	          fraction = '' + fraction + [].concat(_toConsumableArray(Array(precision - fraction.length))).map(function () {
	            return '0';
	          }).join('');
	
	          if (precision && precision !== '0') {
	            formattedText += '.' + fraction.substr(0, precision);
	          }
	
	          return (0, _util.commatize)(formattedText);
	        }
	      }[filter];
	    };
	    /* eslint-enable no-param-reassign */
	  }
	
	  return function (value, column) {
	    var precision = (0, _util.getPrecision)(column);
	    var valueIsString = typeof value === 'string';
	    var prefixChar = valueIsString ? value.charAt(0) : '';
	    var isPrefixed = ['<', '>'].indexOf(prefixChar) > -1;
	    // These are blank cells. Leave them blank
	    if (!value && isNaN(value) || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === undefined || typeof value === 'boolean' || value === null) {
	      return '';
	      // If it has a pipe, just return it
	    } else if (value.toString().indexOf('|') > -1) {
	      return value;
	      // Format special < or > Currency numbers
	    } else if (column.type.indexOf('currency') > -1 && valueIsString && isPrefixed) {
	      return prefixChar + $filter('currency')(value.substring(1), '$', precision);
	      // Format special < or > Percent numbers
	    } else if (/^percent/.test(column.type) && valueIsString && isPrefixed) {
	      return prefixChar + $filter('percent')((+(0, _util.numberPrecision)(value.substring(1), precision, true)).toFixed(precision));
	      // Format special < or > Regular numbers
	    } else if (/^number/.test(column.type) && valueIsString && isPrefixed) {
	      return prefixChar + $filter('number')((0, _util.numberPrecision)(value.substring(1), precision), precision);
	      // If datatype is defined, but doesn't need to be formatted
	    } else if (column.type === 'geography' || column.type === 'text' || column.type === 'year' || _config.appDefault.dataNotAvailable.indexOf(value) > -1 || isNaN(value)) {
	      return value;
	      // Percent types with possible args
	    } else if (/^percent/.test(column.type)) {
	      // @TODO replace with built in filter
	      return $filter('percent')((+(0, _util.numberPrecision)(value, precision, true)).toFixed(precision));
	      // Currency types with possible args
	    } else if (/^currency/.test(column.type)) {
	      return $filter('currency')(value, '$', precision);
	    }
	
	    var number = $filter('number')((0, _util.numberPrecision)(value, precision), precision);
	    if (column.Prefix) {
	      number = column.Prefix + number;
	    }
	    if (column.Suffix) {
	      number = number + column.Suffix;
	    }
	    if (number[number.length - 1] === '.') {
	      number = number.slice(0, -1);
	    }
	    return number;
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(filterSwitch, 'filterSwitch', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/filters/switchFilter.js');
	}();

	;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = slugify;
	/** Used Angular-slugify as a basis: https://github.com/paulsmith/angular-slugify/blob/master/angular-slugify.js */
	
	/**
	 * Unicode (non-control) characters in the Latin-1 Supplement and Latin
	 * Extended-A blocks, transliterated into ASCII characters.
	 * Disabling eslint due to weirdness's around ASCII chars
	 */
	/* eslint-disable quotes */
	var charmap = {
	  ' ': " ", '¡': "!", '¢': "c", '£': "lb", '¥': "yen", '¦': "|", '§': "SS",
	  '¨': "\"", '©': "(c)", 'ª': "a", '«': "<<", '¬': "not", '­': "-", '®': "(R)",
	  '°': "^0", '±': "+/-", '²': "^2", '³': "^3", '´': "'", 'µ': "u", '¶': "P",
	  '·': ".", '¸': ",", '¹': "^1", 'º': "o", '»': ">>", '¼': " 1/4 ",
	  '½': " 1/2 ", '¾': " 3/4 ", '¿': "?", 'À': "`A", 'Á': "'A", 'Â': "^A",
	  'Ã': "~A", 'Ä': '"A', 'Å': "A", 'Æ': "AE", 'Ç': "C", 'È': "`E", 'É': "'E",
	  'Ê': "^E", 'Ë': '"E', 'Ì': "`I", 'Í': "'I", 'Î': "^I", 'Ï': '"I', 'Ð': "D",
	  'Ñ': "~N", 'Ò': "`O", 'Ó': "'O", 'Ô': "^O", 'Õ': "~O", 'Ö': '"O', '×': "x",
	  'Ø': "O", 'Ù': "`U", 'Ú': "'U", 'Û': "^U", 'Ü': '"U', 'Ý': "'Y", 'Þ': "Th",
	  'ß': "ss", 'à': "`a", 'á': "'a", 'â': "^a", 'ã': "~a", 'ä': '"a', 'å': "a",
	  'æ': "ae", 'ç': "c", 'è': "`e", 'é': "'e", 'ê': "^e", 'ë': '"e', 'ì': "`i",
	  'í': "'i", 'î': "^i", 'ï': '"i', 'ð': "d", 'ñ': "~n", 'ò': "`o", 'ó': "'o",
	  'ô': "^o", 'õ': "~o", 'ö': '"o', '÷': ":", 'ø': "o", 'ù': "`u", 'ú': "'u",
	  'û': "^u", 'ü': '"u', 'ý': "'y", 'þ': "th", 'ÿ': '"y', 'Ā': "A", 'ā': "a",
	  'Ă': "A", 'ă': "a", 'Ą': "A", 'ą': "a", 'Ć': "'C", 'ć': "'c", 'Ĉ': "^C",
	  'ĉ': "^c", 'Ċ': "C", 'ċ': "c", 'Č': "C", 'č': "c", 'Ď': "D", 'ď': "d",
	  'Đ': "D", 'đ': "d", 'Ē': "E", 'ē': "e", 'Ĕ': "E", 'ĕ': "e", 'Ė': "E",
	  'ė': "e", 'Ę': "E", 'ę': "e", 'Ě': "E", 'ě': "e", 'Ĝ': "^G", 'ĝ': "^g",
	  'Ğ': "G", 'ğ': "g", 'Ġ': "G", 'ġ': "g", 'Ģ': "G", 'ģ': "g", 'Ĥ': "^H",
	  'ĥ': "^h", 'Ħ': "H", 'ħ': "h", 'Ĩ': "~I", 'ĩ': "~i", 'Ī': "I", 'ī': "i",
	  'Ĭ': "I", 'ĭ': "i", 'Į': "I", 'į': "i", 'İ': "I", 'ı': "i", 'Ĳ': "IJ",
	  'ĳ': "ij", 'Ĵ': "^J", 'ĵ': "^j", 'Ķ': "K", 'ķ': "k", 'Ĺ': "L", 'ĺ': "l",
	  'Ļ': "L", 'ļ': "l", 'Ľ': "L", 'ľ': "l", 'Ŀ': "L", 'ŀ': "l", 'Ł': "L",
	  'ł': "l", 'Ń': "'N", 'ń': "'n", 'Ņ': "N", 'ņ': "n", 'Ň': "N", 'ň': "n",
	  'ŉ': "'n", 'Ō': "O", 'ō': "o", 'Ŏ': "O", 'ŏ': "o", 'Ő': '"O', 'ő': '"o',
	  'Œ': "OE", 'œ': "oe", 'Ŕ': "'R", 'ŕ': "'r", 'Ŗ': "R", 'ŗ': "r", 'Ř': "R",
	  'ř': "r", 'Ś': "'S", 'ś': "'s", 'Ŝ': "^S", 'ŝ': "^s", 'Ş': "S", 'ş': "s",
	  'Š': "S", 'š': "s", 'Ţ': "T", 'ţ': "t", 'Ť': "T", 'ť': "t", 'Ŧ': "T",
	  'ŧ': "t", 'Ũ': "~U", 'ũ': "~u", 'Ū': "U", 'ū': "u", 'Ŭ': "U", 'ŭ': "u",
	  'Ů': "U", 'ů': "u", 'Ű': '"U', 'ű': '"u', 'Ų': "U", 'ų': "u", 'Ŵ': "^W",
	  'ŵ': "^w", 'Ŷ': "^Y", 'ŷ': "^y", 'Ÿ': '"Y', 'Ź': "'Z", 'ź': "'z", 'Ż': "Z",
	  'ż': "z", 'Ž': "Z", 'ž': "z", 'ſ': "s"
	};
	/* eslint-enable quotes */
	
	function slugify(text) {
	  return !text ? '' : Array(text.length).fill('').reduce(function (acc, i, idx) {
	    var charcode = text.charCodeAt(idx);
	    if (charcode < 0x180) {
	      acc.push(charmap[String.fromCharCode(charcode)] || String.fromCharCode(charcode));
	    }
	    return acc;
	  }, []).join('').replace(/[^\w\s-]/g, '').trim().toLowerCase().replace(/[-\s]+/g, '-');
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(charmap, 'charmap', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/slugify.js');
	
	  __REACT_HOT_LOADER__.register(slugify, 'slugify', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/slugify.js');
	}();

	;

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Reducer/Action Types
	 */
	
	var REQUEST_DATA = exports.REQUEST_DATA = 'REQUEST_DATA';
	var RECEIVE_DATA = exports.RECEIVE_DATA = 'RECEIVE_DATA';
	var UPDATE_SELECTED = exports.UPDATE_SELECTED = 'UPDATE_SELECTED';
	var FETCH_GDOC_DATA = exports.FETCH_GDOC_DATA = 'FETCH_GDOC_DATA';
	var FETCH_GDOC_DATA_ERROR = exports.FETCH_GDOC_DATA_ERROR = 'FETCH_GDOC_DATA_ERROR';
	var FETCH_GDOC_DATA_SUCCESS = exports.FETCH_GDOC_DATA_SUCCESS = 'FETCH_GDOC_DATA_SUCCESS';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(REQUEST_DATA, 'REQUEST_DATA', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/config/types.js');
	
	  __REACT_HOT_LOADER__.register(RECEIVE_DATA, 'RECEIVE_DATA', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/config/types.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_SELECTED, 'UPDATE_SELECTED', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/config/types.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GDOC_DATA, 'FETCH_GDOC_DATA', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/config/types.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GDOC_DATA_ERROR, 'FETCH_GDOC_DATA_ERROR', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/config/types.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_GDOC_DATA_SUCCESS, 'FETCH_GDOC_DATA_SUCCESS', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/config/types.js');
	}();

	;

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterByTimeframe = filterByTimeframe;
	exports.buildTable = buildTable;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _table = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [filterByTimeframe description]
	 * @TODO build out doc
	 * @param  {[type]} data    [description]
	 * @param  {[type]} options [description]
	 * @return {[type]}         [description]
	 */
	/* eslint id-length: [2, {"exceptions":["a","b"]}] */
	function filterByTimeframe(data, options) {
	  // Get the list of selected timeframes by name
	  // @TODO logic for selecting by timeframe gets a little weird for defaults
	  // and range vs single, could refactor this
	  var activeTimeframe = +(options.currentTimeframe || 0);
	  var endTimeframeOffset = 1;
	  if (options.activeTab === 'graph') {
	    if (!options.startTimeframe) {
	      activeTimeframe = 0;
	    }
	    var startTimeframe = +(options.startTimeframe || 0) + 1;
	    endTimeframeOffset = options.startTimeframe ? startTimeframe : data.timeframes.length;
	  } else {
	    endTimeframeOffset = +(options.startTimeframe || activeTimeframe + 1);
	  }
	
	  var timeframes = _mori2.default.set((data.timeframes || [0]).slice(activeTimeframe, endTimeframeOffset));
	
	  return _mori2.default.filter(function (sheet) {
	    return _mori2.default.hasKey(timeframes, _mori2.default.first(sheet));
	  }, data.immutableData);
	}
	
	/**
	 * [buildTable description]
	 * @TODO build out doc
	 * @param  {[type]} data            [description]
	 * @param  {[type]} options         [description]
	 * @param  {[type]} timeframes      [description]
	 * @param  {[type]} combinedColumns [description]
	 * @param  {[type]} selectedSetKeys [description]
	 * @param  {[type]} distributions   [description]
	 * @param  {[type]} dataviewType    [description]
	 * @param  {[type]} columnKeys      [description]
	 * @return {[type]}                 [description]
	 */
	
	// import { getDefaultStates } from '../config/table';
	function buildTable(data, options, timeframes, combinedColumns, selectedSetKeys, distributions, dataviewType, columnKeys) {
	  var trend = _mori2.default.count(timeframes) > 1;
	
	  var geoMulti = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti'], false);
	
	  var mapBaseColumn = _mori2.default.getIn(data.config, ['globalRules', 'Map Base Column'], false);
	
	  var linkContext = _mori2.default.getIn(data.config, ['globalRules', 'Context'], [])[1] || 'states';
	
	  var builtRowData = (0, _table.buildRowData)(timeframes, selectedSetKeys, combinedColumns, trend);
	
	  // Build the column headers and variables for agGrid
	  var columnDefs = (0, _table.getAgColumns)(data.immutableHeaders, distributions, _mori2.default.getIn(data.config, ['globalRules', 'Link Column'], false), _mori2.default.getIn(data.config, ['globalRules', 'Link Target'], false), linkContext, dataviewType, timeframes, trend, _mori2.default.first(columnKeys[0]), geoMulti && mapBaseColumn ? mapBaseColumn : false);
	
	  return _mori2.default.hashMap('tableData', _mori2.default.hashMap('rowData', builtRowData.rowData || [], 'columnDefs', columnDefs, 'selectedSetKeys', selectedSetKeys));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(filterByTimeframe, 'filterByTimeframe', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/dataFromOptions.js');
	
	  __REACT_HOT_LOADER__.register(buildTable, 'buildTable', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/dataFromOptions.js');
	}();

	;

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = actionTrigger;
	function actionTrigger(type, data) {
	  return { type: type, data: data };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(actionTrigger, "actionTrigger", "/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/actions/index.js");
	}();

	;

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mapColors = undefined;
	exports.mapDefault = mapDefault;
	exports.getGeoCodeMap = getGeoCodeMap;
	exports.setMapProjection = setMapProjection;
	exports.mapCustomLegend = mapCustomLegend;
	exports.mapCustomLabels = mapCustomLabels;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _d = __webpack_require__(23);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _datamaps = __webpack_require__(240);
	
	var _datamaps2 = _interopRequireDefault(_datamaps);
	
	var _d3 = __webpack_require__(266);
	
	var _d4 = _interopRequireDefault(_d3);
	
	var _config = __webpack_require__(11);
	
	var _countryMapCodes = __webpack_require__(241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapColors = exports.mapColors = {
	  'defaultColor': '#b6b6b6',
	  '1': ['#014f87'],
	  '2': ['#99ddff', '#014f87'],
	  '3': ['#99ddff', '#014f87', '#13283c'],
	  '4': ['#99ddff', '#2a91c2', '#014f87', '#13283c'],
	  '5': ['#d6f1ff', '#99ddff', '#2a91c2', '#014f87', '#13283c'],
	  '6': ['#d6f1ff', '#99ddff', '#2a91c2', '#0b69c1', '#014f87', '#13283c'],
	  'full': ['#d6f1ff', '#99ddff', '#47c2ff', '#2a91c2', '#0d7ee7', '#0b69c1', '#014f87', '#13283c']
	};
	
	// Datamaps default configs
	
	// Country Codes for World Map
	function mapDefault(scope) {
	  return _mori2.default.toClj({
	    geographyConfig: {
	      highlightBorderColor: '#FFFFFF',
	      popupTemplate: function popupTemplate(geography, data) {
	        var geoValue = (data || {}).formatted || 'N/A';
	        var geoName = scope === 'usa' ? geography.properties.name : _countryMapCodes.countries[_countryMapCodes.countryCodes[geography.id]];
	
	        if (data.mapBaseColumn && data.value) {
	          var nonGeoMapData = data.value[geography.id];
	
	          var items = '' + Object.keys(nonGeoMapData).map(function (key) {
	            return '<strong>' + key + '</strong><br/>' + nonGeoMapData[key].map(function (item) {
	              return '<em>' + Object.keys(item)[0] + ':</em>\n                  ' + item[Object.keys(item)[0]];
	            }).join('<br/>');
	          });
	
	          // @TODO - find better markup for these tooltips
	          return '<div class="datamaps-hover wide">\n          <span><span><p class="mapBaseColumn"><span>\n            ' + items + '\n          </span></p></span></span>\n          </div>';
	        }
	
	        return '\n  <div class="datamaps-hover">\n  <span><span>\n  <p><span>' + geoName + ': ' + geoValue + '</span></p>\n  </span></span>\n  </div>';
	      },
	      borderWidth: 1,
	      highlightBorderWidth: 2
	    },
	    options: {
	      labels: false,
	      legend: false,
	      width: 753,
	      height: 452,
	      legendHeight: 100
	    },
	    fills: {}
	  });
	}
	
	// Map the geography codes so we can assign them properly
	function getGeoCodeMap(geoContext) {
	  return _datamaps2.default.prototype[geoContext + 'Topo'].objects[geoContext].geometries.reduce(function (acc, curr) {
	    acc[curr.properties.name] = curr.id;
	    return acc;
	  }, {});
	}
	
	/**
	 * Return the proper projection for the map
	 */
	function setMapProjection(geoContext, mapConfig) {
	  if (geoContext === 'world') {
	    return function setProjection(element) {
	      var projection = _d2.default.geo.vanDerGrinten3().center([0, 10]).scale(129).translate([element.offsetWidth / 2 - 10, element.offsetHeight / 2]);
	      var path = _d2.default.geo.path().projection(projection);
	      return { path: path, projection: projection };
	    };
	  }
	  return function setProjection() {
	    var projection = _d2.default.geo.albersUsa().scale(mapConfig.options.width * 1.3).translate([mapConfig.options.width / 2, mapConfig.options.height / 2]);
	    var path = _d2.default.geo.path().projection(projection);
	    return { path: path, projection: projection };
	  };
	}
	
	/**
	 * Sets up the custom legend for KFF
	 */
	
	function mapCustomLegend() {
	  var _this2 = this;
	
	  _d2.default.select(this.options.element).select('.datamaps-legend').remove();
	
	  if (!this.options.fills) {
	    return;
	  }
	
	  var legendItems = Object.keys(this.options.fills).reduce(function (out, fillKey) {
	    var label = '';
	    if (fillKey === 'defaultFill') {
	      if (!_this2.options.labels[fillKey] || _this2.options.labels[fillKey] === 'N/A') {
	        return out;
	      }
	      label = _this2.options.labels[fillKey];
	    } else {
	      if (_this2.options.labels && _this2.options.labels[parseInt(fillKey, 10)]) {
	        label = _this2.options.labels[parseInt(fillKey, 10)];
	      } else {
	        label = fillKey;
	      }
	    }
	    out.push({
	      'name': label,
	      'color': _this2.options.fills[fillKey]
	    });
	
	    return out;
	  }, []);
	
	  var hasNoDataItems = !!Object.keys(this.options.data).filter(function (key) {
	    return _config.appDefault.dataNotAvailable.indexOf(_this2.options.data[key].raw) >= 0;
	  }).length;
	  if (hasNoDataItems && this.options.labels.hasOwnProperty('defaultFill')) {
	    legendItems.push({
	      'name': 'N/A',
	      'color': this.options.fills.defaultFill
	    });
	  }
	
	  var margin = { top: 5, right: 0, bottom: 5, left: 0 };
	  var width = 753;
	  var top = 460;
	  var left = 10;
	  var height = legendItems.length % 4 === 0 ? legendItems.length / 4 * 50 : (Math.floor(legendItems.length / 4) + 1) * 50;
	
	  (0, _d4.default)(this.options.element.children[0], legendItems, {
	    margin: margin,
	    width: width,
	    height: height,
	    top: top,
	    left: left,
	    wrapper: 'g',
	    isMap: true
	  });
	
	  var legendHeight = _d2.default.select(this.options.element.children[0]).select('.datamaps-legend').node().getBBox().height + margin.top;
	
	  // Update Height
	  _d2.default.select(this.options.element.children[0]).attr('height', top + Math.max(height, legendHeight));
	
	  // Remove bottom padding
	  var padding = height >= 100 ? 20 : 100 - height;
	  this.options.element.style.paddingBottom = padding + 'px';
	}
	
	/**
	 * Sets up custom state labels for outside boxes
	 */
	function mapCustomLabels(layer) {
	  var _this = this;
	  var labelStartCoodinates = _this.projection([-67.707617, 42.722131]);
	
	  _d2.default.selectAll('.datamaps-subunit').attr('data-foo', function (d) {
	    var center = _this.path.centroid(d);
	    var smallStateIndex = ['VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC', 'HI'].indexOf(d.id);
	    var xOffset = 7.5;
	    var yOffset = 5;
	    var x = void 0;
	    var y = void 0;
	
	    if (['FL', 'KY', 'MI'].indexOf(d.id) > -1) {
	      xOffset = -2.5;
	    }
	    if (d.id === 'NY') {
	      xOffset = -1;
	    }
	    if (d.id === 'MI') {
	      yOffset = 18;
	    }
	    if (d.id === 'LA') {
	      xOffset = 13;
	    }
	    if (d.id === 'HI') {
	      xOffset = 30;
	    }
	
	    x = center[0] - xOffset;
	    y = center[1] + yOffset;
	
	    if (smallStateIndex > -1) {
	      if (d.id !== 'HI') {
	        var yStart = labelStartCoodinates[1];
	        x = labelStartCoodinates[0];
	        y = yStart + smallStateIndex * (2 + (_this.options.fontSize || 12));
	        layer.append('line').attr('x1', x - 3).attr('y1', y - 5).attr('x2', center[0]).attr('y2', center[1]).style('stroke', _this.options.labelColor || '#DDD').style('stroke-width', _this.options.lineWidth || 1);
	      }
	
	      layer.append('rect').attr('width', '24px').attr('height', '16px').attr('fill', _this.options.fills[(_this.options.data[d.id] || {}).fillKey] || _this.options.fills.defaultFill).attr('x', x - 4).attr('y', y - 12).attr('data-info', JSON.stringify(_this.options.data[d.id])).on('mouseover', function () {
	        var $this = _d2.default.select(this).attr('data-info', JSON.stringify(_this.options.data[d.id]));
	
	        _this.options.popupTemplate = _this.options.geographyConfig.popupTemplate;
	        _this.updatePopup($this, d, _this.options, _this.svg);
	
	        var $state = _this.svg.select('.' + d.id);
	        var prevAttr = {
	          'fill': $state.style('fill'),
	          'stroke': $state.style('stroke'),
	          'stroke-width': $state.style('stroke-width'),
	          'fill-opacity': $state.style('fill-opacity')
	        };
	
	        $this.style('fill', _this.options.bubblesConfig.highlightFillColor).style('fill-opacity', _this.options.bubblesConfig.highlightFillOpacity);
	
	        $state.style('fill', _this.options.bubblesConfig.highlightFillColor).style('stroke', _this.options.bubblesConfig.highlightBorderColor).style('stroke-width', _this.options.bubblesConfig.highlightBorderWidth).style('fill-opacity', _this.options.bubblesConfig.highlightFillOpacity).attr('data-previousAttributes', JSON.stringify(prevAttr));
	      }).on('mouseout', function () {
	        var $this = _d2.default.select(this);
	        var $state = _this.svg.select('.' + d.id);
	        var prevAttr = JSON.parse($state.attr('data-previousAttributes'));
	        for (var attr in prevAttr) {
	          if (attr) {
	            $state.style(attr, prevAttr[attr]);
	            if (attr === 'fill' || attr === 'fill-opacity') {
	              $this.style(attr, prevAttr[attr]);
	            }
	          }
	        }
	        _d2.default.selectAll('.datamaps-hoverover').style('display', 'none');
	      });
	    }
	
	    layer.append('text').attr('x', x).attr('y', y).style('font-size', _this.options.fontSize || 12).style('font-weight', 'bold').style('font-family', _this.options.fontFamily || 'Arial, Helvetica, sans-serif').style('fill', ['#99ddff', '#d6f1ff'].indexOf(_this.options.fills[(_this.options.data[d.id] || {}).fillKey]) !== -1 ? '#13283c' : _this.options.labelColor || '#FFF').style('pointer-events', 'none').text(d.id);
	  });
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapColors, 'mapColors', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/maps.js');
	
	  __REACT_HOT_LOADER__.register(mapDefault, 'mapDefault', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/maps.js');
	
	  __REACT_HOT_LOADER__.register(getGeoCodeMap, 'getGeoCodeMap', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/maps.js');
	
	  __REACT_HOT_LOADER__.register(setMapProjection, 'setMapProjection', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/maps.js');
	
	  __REACT_HOT_LOADER__.register(mapCustomLegend, 'mapCustomLegend', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/maps.js');
	
	  __REACT_HOT_LOADER__.register(mapCustomLabels, 'mapCustomLabels', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/maps.js');
	}();

	;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDefaultStates = getDefaultStates;
	exports.LocationFilter = LocationFilter;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  columnDefs: [],
	  rowData: null,
	  enableSorting: true,
	  enableFilter: true,
	  enableColResize: false,
	  suppressAutoSize: true,
	  suppressMultiSort: true,
	  autoSizePadding: 50,
	  forPrint: false,
	  minColWidth: 50,
	  colWidth: 200,
	  headerHeight: 30,
	  rowBuffer: 50,
	  // Only remove if you have a good reason. Allows periods in field names
	  suppressFieldDotNotation: true,
	  // no more dragging column headers
	  suppressMovableColumns: true,
	  // Can't select cells
	  suppressCellSelection: true,
	  // Don't hide the menu
	  suppressMenuHide: true,
	  // It's faster NOT to use angluar to compile table stuff
	  angularCompileHeaders: false,
	  angularCompileRows: false,
	  unSortIcon: true,
	  icons: {
	    sortAscending: function sortAscending() {
	      return '<span />';
	    },
	    sortDescending: function sortDescending() {
	      return '<span />';
	    },
	    sortUnSort: function sortUnSort() {
	      return '<span />';
	    }
	  },
	  getRowClass: function getRowClass(params) {
	    var classes = [];
	    // @TODO We can test for summary rows in Location or State context, but
	    // not for multigeo cases base column is Parent Firm or other.
	    // Could use some expensive extended cases here, or figure out how to
	    // access the base column header context
	    var baseDistribution = params.data.Location || params.data.State;
	
	    if (_config.appDefault.specialWrapups.indexOf(baseDistribution) >= 0 || _config.appDefault.isSummaryRow.test(baseDistribution) || params.data.isSummary) {
	      classes.push('wrapup');
	    }
	
	    if (params.node.rowHeight > 30) {
	      classes.push('multiline');
	    }
	
	    return classes;
	  }
	};
	exports.default = _default;
	function getDefaultStates(columns) {
	  // Super hacky, but hey it works ¯\_(ツ)_/¯
	  // Convert US, and States in data.columns to
	  // #{"Location" "Geography"}: "[Label]"
	  return _mori2.default.into(_mori2.default.vector(_mori2.default.vector(_mori2.default.hashMap(_mori2.default.set(['Location', 'Geography']), 'United States'))), _mori2.default.map(function (item) {
	    return _mori2.default.vector(_mori2.default.hashMap(_mori2.default.set(['Location', 'Geography']), _mori2.default.get(_mori2.default.last(item), 'label')));
	  }, _mori2.default.toClj(columns.nested.states.children)));
	}
	
	// This is the locationFiltering function
	function LocationFilter() {}
	LocationFilter.prototype.init = function (params) {
	  this.field = params.colDef.field;
	  this.valueGetter = params.valueGetter;
	};
	// Required, but not used
	LocationFilter.prototype.getGui = function () {
	  return '';
	};
	LocationFilter.prototype.isFilterActive = function () {
	  return this.value.length > 0;
	};
	LocationFilter.prototype.doesFilterPass = function (params) {
	  return this.value.indexOf(params.data[this.field]) > -1;
	};
	LocationFilter.prototype.getApi = function () {
	  var _this = this;
	  return {
	    getField: function getField() {
	      return _this.field;
	    },
	    getModel: function getModel() {
	      return { 'value': _this.value };
	    },
	    setModel: function setModel(model) {
	      _this.value = model.map(function (curr) {
	        return curr.indexOf(' (All)') > -1 ? curr.split(' (All)')[0] : curr;
	      });
	    }
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getDefaultStates, 'getDefaultStates', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/table.js');
	
	  __REACT_HOT_LOADER__.register(LocationFilter, 'LocationFilter', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/table.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/table.js');
	}();

	;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.territorySort = territorySort;
	
	var _config = __webpack_require__(11);
	
	/**
	 * Does custom sorting for the checkbox lists with territories
	 */
	var _default = function _default() {
	  return function () {
	    var column = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return Object.keys(column).sort(territorySort);
	  };
	}; /* eslint id-length:[2, {"exceptions":["a", "b"]}] */
	
	
	exports.default = _default;
	function territorySort(a, b) {
	  var aIsTerritory = _config.appDefault.kffTerritories.indexOf(a) > -1 || _config.appDefault.normalizedKffTerritories.indexOf(a) > -1;
	  var bIsTerritory = _config.appDefault.kffTerritories.indexOf(b) > -1 || _config.appDefault.normalizedKffTerritories.indexOf(b) > -1;
	
	  // Check if MA Region
	  if (a.indexOf('ma-region') >= 0 && b.indexOf('ma-region') >= 0) {
	    return parseInt(a.split('-')[2], 10) - parseInt(b.split('-')[2], 10);
	  }
	
	  if (aIsTerritory && bIsTerritory) {
	    return a.localeCompare(b);
	  } else if (aIsTerritory || bIsTerritory) {
	    return aIsTerritory ? 1 : -1;
	  }
	
	  return a.localeCompare(b);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(territorySort, 'territorySort', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/filters/territorySortFilter.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/filters/territorySortFilter.js');
	}();

	;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _slugify = __webpack_require__(73);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var viewTypes = _mori2.default.vector('Map', 'Graph');
	
	var _default = function _default(headers) {
	  var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  return _mori2.default.distinct(_mori2.default.map(function (header) {
	    var characteristic = _mori2.default.get(header, 'characteristic');
	    var headerGroup = _mori2.default.get(header, 'headerGroup');
	    // nested distributions need a complex slug
	    var identifier = headerGroup ? headerGroup + '__' + characteristic : '' + characteristic;
	    var slug = (0, _slugify2.default)(identifier.replace('%', 'percent'));
	    return _mori2.default.hashMap('label', identifier.replace('__', ', '), 'characteristic', characteristic, 'slug', slug, 'selected', selected.indexOf(slug) > -1, 'headerGroup', headerGroup, 'exclude', mapExcludedViews(header));
	  }, _mori2.default.rest(headers)));
	};
	
	exports.default = _default;
	
	// Map the views where this distribution should not be shown
	
	function mapExcludedViews(header) {
	  return _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (view) {
	    return ('' + _mori2.default.get(header, view, false)).toLowerCase() === 'no';
	  }), _mori2.default.map(function (view) {
	    return view.toLowerCase();
	  })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), viewTypes);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(viewTypes, 'viewTypes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/distributionFilters.js');
	
	  __REACT_HOT_LOADER__.register(mapExcludedViews, 'mapExcludedViews', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/distributionFilters.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/distributionFilters.js');
	}();

	;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = function _default(data) {
	  // The base column is just a version of the first header column
	  var baseColumn = _mori2.default.set([_mori2.default.get(_mori2.default.first(data.immutableHeaders), 'characteristic'), _mori2.default.get(_mori2.default.first(data.immutableHeaders), 'label')]);
	
	  // For Geomulti indicators, the second column is the child, so we also need
	  // that selector
	  var childColumn = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti']) ? _mori2.default.set([_mori2.default.get(_mori2.default.nth(data.immutableHeaders, 1), 'characteristic'), _mori2.default.get(_mori2.default.nth(data.immutableHeaders, 1), 'label')]) : false;
	
	  return [baseColumn, childColumn];
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getColumnKeys.js');
	}();

	;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = composeFootnotes;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Compose the footnotes into an array of hashmaps with the following keys:
	 * Should be a composed key:
	 * * [year, location, headergroup]
	 * * [year, location, header]
	 * * [year, location, #{headergroup, header}]
	 *
	 * @param  {mori.vector} footnotes  [footnotes from config]
	 * @param  {mori.vector} timeframes [active timeframes to use]
	 * @param  {mori.vector} distributions [active distributions to use]
	 * @return {mori.vector}            [vector of composed footnote keys]
	 */
	function composeFootnotes(footnotes, timeframes, distributions) {
	  return _mori2.default.reduceKV(function (acc, year, yearData) {
	    return (0, _util.indexOf)(timeframes, year) ? _mori2.default.into(acc, _mori2.default.reduceKV(function (acc1, state, stateData) {
	      return _mori2.default.into(acc1, _mori2.default.reduceKV(function (acc2, dist, distData) {
	        return (0, _util.indexOf)(distributions, dist) ? _mori2.default.conj(acc2, _mori2.default.hashMap(_mori2.default.set([year, state, dist]), distData)) : acc2;
	      }, _mori2.default.vector(), stateData));
	    }, _mori2.default.vector(), yearData)) : acc;
	  }, _mori2.default.vector(), footnotes);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(composeFootnotes, 'composeFootnotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/composeFootnotes.js');
	}();

	;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getActiveFootnotes;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the active footnotes
	 * @param  {mori.vector} footnotes     [footnotes from sheetData]
	 * @param  {mori.vector} timeframes    [active timeframes]
	 * @param  {mori.vector} locations     [active locations]
	 * @param  {mori.vector} distributions [active distributions]
	 * @return {mori.vector}               [active footnotes]
	 */
	function getActiveFootnotes(footnotes, timeframes, locations, distributions) {
	  return _mori2.default.reduceKV(function (acc, key, val) {
	    return _mori2.default.merge(acc, val);
	  }, _mori2.default.hashMap(), _mori2.default.reduce(function (acc0, item0) {
	    return _mori2.default.assoc(acc0, _mori2.default.first(item0), _mori2.default.reduce(function (acc1, item1) {
	      return _mori2.default.assoc(acc1, _mori2.default.first(item1), _mori2.default.last(item1));
	    }, _mori2.default.hashMap(), _mori2.default.last(item0)));
	  }, _mori2.default.hashMap(), _mori2.default.filter(function (item) {
	    return (0, _util.indexOf)(timeframes, _mori2.default.first(item));
	  }, _mori2.default.reduce(function (acc0, curr0) {
	    return _mori2.default.conj(acc0, _mori2.default.vector(_mori2.default.first(curr0), _mori2.default.filter(function (item) {
	      return locations ? (0, _util.indexOf)(locations, _mori2.default.first(item)) : true;
	    }, _mori2.default.zipmap(_mori2.default.keys(_mori2.default.last(curr0)), _mori2.default.map(function (item) {
	      return _mori2.default.reduceKV(function (acc1, key, curr1) {
	        return !!(0, _util.indexOf)(distributions, key) ? _mori2.default.assoc(acc1, key, curr1) : acc1;
	      }, _mori2.default.hashMap(), item);
	    }, _mori2.default.vals(_mori2.default.last(curr0)))))));
	  }, _mori2.default.vector(), footnotes))));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getActiveFootnotes, 'getActiveFootnotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/getActiveFootnotes.js');
	}();

	;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDistributions;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get active columns (distributions) then reduce them down into:
	 *  > header group
	 *  > column
	 *  > headergroup | column
	 * @param  {[type]} distributions [description]
	 * @return {[type]}               [description]
	 */
	function getDistributions(distributions) {
	  return _mori2.default.flatten(_mori2.default.map(function (item) {
	    return _mori2.default.isVector(item) ? _mori2.default.set([_mori2.default.first(item), _mori2.default.last(item)]) : item;
	  }, _mori2.default.distinct(_mori2.default.reduce(function (acc, curr) {
	    return _mori2.default.get(curr, 0) !== null ? _mori2.default.conj(_mori2.default.conj(_mori2.default.conj(acc, _mori2.default.get(curr, 0), _mori2.default.get(curr, 1)), _mori2.default.conj(curr))) : _mori2.default.conj(acc, _mori2.default.get(curr, 1));
	  }, _mori2.default.vector(), _mori2.default.reduce(function (acc1, curr1) {
	    return _mori2.default.count(curr1) > 2 ? _mori2.default.conj(acc1, _mori2.default.vector(_mori2.default.first(curr1), _mori2.default.first(_mori2.default.rest(curr1)))) : _mori2.default.conj(acc1, _mori2.default.vector(null, _mori2.default.first(curr1)));
	  }, _mori2.default.vector(), distributions)))));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getDistributions, 'getDistributions', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/getDistributions.js');
	}();

	;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getLocations;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get active locations or false for all
	 * @param  {mori.vector} locations [locations from combinedFilters[0]]
	 * @return {mori.vector || false}  [active locations]
	 */
	function getLocations(locations) {
	  return _mori2.default.count(locations) > 0 ? _mori2.default.map(function (item) {
	    return _mori2.default.first(_mori2.default.vals(item));
	  }, _mori2.default.flatten(locations)) : false;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getLocations, 'getLocations', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/getLocations.js');
	}();

	;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getRelevantRows;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Filter the filtered data (again), to only
	 * retain rows (locations) we are interested in
	 * @param  {mori.vector} filteredData        [filtered data]
	 * @param  {mori.vector} activeLocations     [active locations in footnotes]
	 * @return {mori.vector}                     [relevent data]
	 */
	function getRelevantRows(filteredData, activeLocations) {
	  return _mori2.default.map(function (sheet) {
	    return _mori2.default.vector(_mori2.default.first(sheet), _mori2.default.filter(function (item) {
	      return _mori2.default.some(function (location) {
	        return location === _mori2.default.get(item, _mori2.default.set(['Location', 'Geography'])) || location === _mori2.default.get(item, _mori2.default.set(['State', 'Geography']));
	      }, activeLocations);
	    }, _mori2.default.flatten(_mori2.default.rest(sheet))));
	  }, filteredData);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getRelevantRows, 'getRelevantRows', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/getRelevantRows.js');
	}();

	;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimeframes;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the active timeframes from the filteredData
	 * and then append on 'any'
	 * @param  {mori.vector} data [filteredData]
	 * @return {mori.vector}      [any active timeframes + `any`]
	 */
	function getTimeframes(data) {
	  return _mori2.default.conj(_mori2.default.reduce(function (acc, curr) {
	    return _mori2.default.conj(acc, _mori2.default.first(curr));
	  }, _mori2.default.vector(), data), 'any');
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getTimeframes, 'getTimeframes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/getTimeframes.js');
	}();

	;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = labelFootnotes;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Label the footnotes with numbers weighted by reused, row, and cell
	 * @param  {mori.hashmap} footnotes [composed footnotes to access]
	 * @param  {mori.hashmap} rows      [relevant rows to use]
	 * @param  {mori.vector} headers    [headers]
	 * @param  {mori.vector} timeframes [active timeframes]
	 * @return {mori.hashmap}           [labeled footnotes]
	 */
	function labelFootnotes(footnotes, rows, headers, timeframes) {
	  // This is an object map of note hashes to labels
	  var usedFootnotes = {};
	
	  var isTrendGraph = _mori2.default.count(timeframes) > 2;
	
	  // Push a footnote into usedFootnotes
	  var pushFootnote = function pushFootnote(hash) {
	    usedFootnotes[hash] = Object.keys(usedFootnotes).length + 1;
	    return usedFootnotes[hash];
	  };
	
	  // Returns the label
	  var getLabel = function getLabel(noteHash) {
	    return usedFootnotes[noteHash] ? usedFootnotes[noteHash] : pushFootnote(noteHash);
	  };
	
	  var labeledFootnotes = _mori2.default.map(function (footnote) {
	    var notes = _mori2.default.toJs(_mori2.default.last(footnote));
	    var labeledNotes = notes.map(function (note) {
	      return Object.assign({}, note, { label: getLabel(_mori2.default.hash(note.note)) });
	    });
	
	    return _mori2.default.hashMap(
	    // Lets update the notes with labels now
	    _mori2.default.first(footnote), _mori2.default.toClj(labeledNotes));
	  },
	  // Sort It!
	  _mori2.default.sortBy(
	  // Lets grab the weights
	  function (item) {
	    var keys = _mori2.default.first(item);
	    var row = _mori2.default.count(_mori2.default.takeWhile(function (rowItem) {
	      return !_mori2.default.isSubset(_mori2.default.set([_mori2.default.get(rowItem, _mori2.default.set(['Location', 'Geography']))]), keys);
	    }, _mori2.default.get(rows, _mori2.default.first(keys))));
	    var column = _mori2.default.get(_mori2.default.first(_mori2.default.filter(
	    // If the 3rd key is a map we need to be very specific,
	    // otherwise we don't care
	    function (columnItem) {
	      return _mori2.default.isMap(_mori2.default.last(keys) && !isTrendGraph) ? _mori2.default.equals(_mori2.default.last(keys), _mori2.default.hashMap(_mori2.default.get(columnItem, 'headerGroup'), _mori2.default.get(columnItem, 'characteristic'))) : _mori2.default.last(keys) === _mori2.default.get(columnItem, 'headerGroup', false) || _mori2.default.last(keys) === _mori2.default.get(columnItem, 'characteristic', false) || _mori2.default.last(_mori2.default.last(_mori2.default.last(keys))) === _mori2.default.get(columnItem, 'characteristic', false);
	    }, headers)), 'idx');
	
	    var year = false;
	    if (isTrendGraph) {
	      // If the timeframe is not "any", and if the last key
	      // item is not a set, it's a column title.
	      // We do not want to take the year weight into account.
	      // Else, compute the year weight with timeframes.  We are adding 1
	      // to break JavaScript's 0 = falsey.
	      year = _mori2.default.first(_mori2.default.first(_mori2.default.last(keys))) !== 'any' && _mori2.default.isMap(_mori2.default.last(keys)) ? 1 + _mori2.default.count(_mori2.default.takeWhile(function (yearItem) {
	        return yearItem !== _mori2.default.first(keys);
	      }, _mori2.default.rest(_mori2.default.reverse(timeframes)) // cut off 'any'
	      )) : false;
	    }
	    return { keys: keys, row: row, column: column, year: year };
	  },
	  // Lets actually do the sorting
	  function (_ref, _ref2) {
	    var aRow = _ref.row,
	        aColumn = _ref.column,
	        _ref$year = _ref.year,
	        aYear = _ref$year === undefined ? false : _ref$year;
	    var bRow = _ref2.row,
	        bColumn = _ref2.column,
	        _ref2$year = _ref2.year,
	        bYear = _ref2$year === undefined ? false : _ref2$year;
	
	    // If the row weights are equal and there are year weights that are
	    // not equal, sort by year weights
	    if (aRow === bRow && aYear && bYear && aYear !== bYear) {
	      return aYear - bYear;
	    }
	
	    // Else, check if we should weigh by column or row.
	    return aRow === bRow ? aColumn - bColumn : aRow - bRow;
	  },
	  // Convert it to a collection
	  _mori2.default.reduceKV(function (acc, key, val) {
	    return _mori2.default.conj(acc, _mori2.default.vector(key, val));
	  }, _mori2.default.set(), prepForReduction(footnotes, timeframes))));
	  // Convert it back to a hashmap
	  return _mori2.default.reduce(function (acc, note) {
	    return _mori2.default.conj(acc, note);
	  }, _mori2.default.hashMap(), labeledFootnotes);
	}
	
	/**
	 * prep footnotes for reduction by replacing 'any' with years
	 * @param  {mori.hashMap} footnotes  [current footnotes]
	 * @param  {mori.vector} timeframes  [timeframes]
	 * @return {mori.hashMap}            [hashMap removed of 'any']
	 */
	function prepForReduction(footnotes, timeframes) {
	  return _mori2.default.reduceKV(function (acc, key, val) {
	    // If timeframes count = 2 it's just a single one, ex: [2017, 'any']
	    if (_mori2.default.first(key) !== 'any' || _mori2.default.first(key) === 'any' && _mori2.default.count(timeframes) === 2) {
	      // If 'any' use the timeframes...
	      var actualKey = _mori2.default.first(key) !== 'any' ? key : _mori2.default.set([_mori2.default.first(timeframes), _mori2.default.first(_mori2.default.rest(key)), _mori2.default.last(_mori2.default.rest(key))]);
	      // If only one timeframe count is 2. ex: [2016, 'any']
	      if (!_mori2.default.get(acc, actualKey, false)) {
	        return _mori2.default.merge(acc, _mori2.default.hashMap(actualKey, val));
	      }
	      // If 'any' we use the 'actual' set key instead
	      return _mori2.default.merge(acc, _mori2.default.hashMap(actualKey, _mori2.default.into(_mori2.default.get(acc, actualKey), val)));
	    }
	
	    // Key is any and timeframes are > 1
	    return _mori2.default.merge(acc, _mori2.default.reduce(function (acc1, time) {
	      var actualKey = _mori2.default.set([time, _mori2.default.first(_mori2.default.rest(key)), _mori2.default.last(_mori2.default.rest(key))]);
	
	      // If it exists in acc, we need to combine it
	      if (_mori2.default.get(acc, actualKey, false)) {
	        return _mori2.default.merge(acc1, _mori2.default.hashMap(actualKey, _mori2.default.into(_mori2.default.get(acc, actualKey, false), val)));
	      }
	      // Else we can just toss it in
	      return _mori2.default.merge(acc1, _mori2.default.hashMap(actualKey, val));
	    }, _mori2.default.hashMap(), _mori2.default.filter(function (time) {
	      return time !== 'any';
	    }, timeframes)));
	  }, _mori2.default.hashMap(), footnotes);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(labelFootnotes, 'labelFootnotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/labelFootnotes.js');
	
	  __REACT_HOT_LOADER__.register(prepForReduction, 'prepForReduction', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/labelFootnotes.js');
	}();

	;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = sortRows;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	var _sortComparator = __webpack_require__(151);
	
	var _sortComparator2 = _interopRequireDefault(_sortComparator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sort the rows
	 * @param  {String} options.colId: sortedKey      [the sort key of the column]
	 * @param  {String} options.sort                  [the sort direction]
	 * @param  {mori.vector} rows                     [the rows]
	 * @param  {mori.vector} headers                  [the immutable headers]
	 * @param  {string} dataType                      [combinedFilters[3].type (active datatype)]
	 * @return {mori.vector}                          [the sorted rows]
	 */
	function sortRows(_ref, rows, headers, dataType) {
	  var _ref$colId = _ref.colId,
	      sortedKey = _ref$colId === undefined ? 'Location' : _ref$colId,
	      _ref$sort = _ref.sort,
	      sort = _ref$sort === undefined ? 'asc' : _ref$sort;
	
	  var _sortedKey$split$reve = sortedKey.split('__').reverse(),
	      _sortedKey$split$reve2 = _slicedToArray(_sortedKey$split$reve, 2),
	      characteristic = _sortedKey$split$reve2[0],
	      _sortedKey$split$reve3 = _sortedKey$split$reve2[1],
	      headerGroup = _sortedKey$split$reve3 === undefined ? false : _sortedKey$split$reve3;
	
	  // Get the sort column (there should only be one...) and convert it to JS
	
	
	  var sortColumn = _mori2.default.toJs(_mori2.default.first(_mori2.default.filter(function (col) {
	    return (!dataType || _mori2.default.get(col, 'type') === 'geography' || _mori2.default.get(col, 'type') === dataType) && (_mori2.default.get(col, 'headerGroup') === headerGroup && _mori2.default.get(col, 'characteristic') === characteristic || _mori2.default.get(col, 'characteristic') === characteristic);
	  }, headers))) || {}; // handle null case for sortcolumn
	
	  var isInverted = _config.appDefault.descSortFirst.indexOf(sortColumn.type) >= 0 ? sort === 'asc' : sort === 'desc';
	
	  // sortComparator is a factory function
	  var comparator = (0, _sortComparator2.default)(sortColumn, 'Location', null);
	  // Check for geomulti tables (use 'State' instead of 'Location')
	  if (
	  // and this is why nested immutables are occasionally annoying... sorry
	  _mori2.default.first(_mori2.default.first(_mori2.default.first(_mori2.default.first(_mori2.default.last(_mori2.default.first(rows)))))) === 'State') {
	    comparator = (0, _sortComparator2.default)(sortColumn, 'State', 'State');
	  }
	
	  return _mori2.default.map(function (sheet) {
	    return _mori2.default.vector(_mori2.default.first(sheet), _mori2.default.sortBy(function (row) {
	      return _mori2.default.vector(_mori2.default.get(row, _mori2.default.set(sortColumn.headerGroup ? [sortColumn.headerGroup, sortColumn.characteristic, sortColumn.label] : [sortColumn.characteristic, sortColumn.label])), _mori2.default.get(row, _mori2.default.set(['Location', 'Geography']), false) || _mori2.default.get(row, _mori2.default.set(['State', 'Geography'])));
	    }, function (a, b) {
	      // We need to check for wrapups... because
	      // comparator is not doing it...
	      // and we always need to push wrapups to the top
	      if (sortColumn.type === 'geography') {
	        if (_config.appDefault.specialWrapups.indexOf(_mori2.default.first(a)) > -1 && _config.appDefault.specialWrapups.indexOf(_mori2.default.first(b)) === -1) {
	          return -1;
	        } else if (_config.appDefault.specialWrapups.indexOf(_mori2.default.first(a)) === -1 && _config.appDefault.specialWrapups.indexOf(_mori2.default.first(b)) > -1) {
	          return 1;
	        }
	      }
	      // Now once that's over we can sort normally...
	      // If you notice `Location` & `State` have the same value,
	      // that's fine, the reason we don't just use one
	      // (and adjust the comparator) is we are trying to keep it
	      // as close to the table sort as possible, and if we
	      // just used multiple comparator() funcs to swap between geomutli
	      // and not, it would be lots of duplicate code
	      return comparator({ text: _mori2.default.first(a) }, { text: _mori2.default.first(b) }, { data: {
	          Location: _mori2.default.first(_mori2.default.rest(a)),
	          State: _mori2.default.first(_mori2.default.rest(a)),
	          isSummary: _config.appDefault.isSummaryRow.test(a) || null
	        } }, { data: {
	          Location: _mori2.default.first(_mori2.default.rest(b)),
	          State: _mori2.default.first(_mori2.default.rest(b)),
	          isSummary: _config.appDefault.isSummaryRow.test(b) || null
	        } },
	      // Weird inverted/anti invert logic... I'm sorry
	      _config.appDefault.descSortFirst.indexOf(sortColumn.type) >= 0 ? !isInverted : isInverted) * (
	      // What follows is even more weird invert logic...
	      // this was a big headache, again I'm sorry
	      isInverted && (
	      // Because Geos don't actually sort...
	      sortColumn.type === 'geography' || sortColumn.type === 'text') || !isInverted && _config.appDefault.descSortFirst.indexOf(sortColumn.type) >= 0 ? -1 : 1);
	    }, _mori2.default.flatten(_mori2.default.rest(sheet))));
	  }, rows);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(sortRows, 'sortRows', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/sortRows.js');
	}();

	;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _territorySortFilter = __webpack_require__(139);
	
	var _getSelectedColumnsRecursive = __webpack_require__(251);
	
	var _getSelectedColumnsRecursive2 = _interopRequireDefault(_getSelectedColumnsRecursive);
	
	var _util = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _default = function _default(data, options, baseColumn, childColumn) {
	  var isGeoMulti = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti'], false);
	
	  var isMedicare = _mori2.default.getIn(data.config, ['globalRules', 'medicare'], false);
	
	  var rootSelection = Object.keys(options.selectedRows || {})[0] || false;
	  var validSelection = rootSelection !== 'nested' && (!rootSelection || data.columns[rootSelection] || data.columns.nested[rootSelection] || false);
	  var selectedRows = validSelection ? options.selectedRows || {} : null;
	  var parentColumns = void 0;
	  if (isGeoMulti) {
	    // Get Summary Values (for lookups...)
	    var summaries = _mori2.default.reduce(function (acc, sheet) {
	      return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(sheet), _mori2.default.reduce(function (acc1, row) {
	        return _mori2.default.conj(acc1, _mori2.default.hashMap(_mori2.default.get(row, baseColumn), _mori2.default.get(row, childColumn)));
	      }, _mori2.default.hashMap(), _mori2.default.remove(function (row) {
	        return _mori2.default.every(function (item) {
	          return (_mori2.default.first(_mori2.default.rest(item)) || '').toString().indexOf('(All)') < 0;
	        }, row);
	      }, _mori2.default.first(_mori2.default.rest(sheet))))));
	    }, _mori2.default.hashMap(), data.immutableData);
	
	    parentColumns = _mori2.default.into(_mori2.default.vector(), _mori2.default.mapcat(function (group) {
	      return _mori2.default.mapcat(function (row) {
	        var selectAll = _mori2.default.first(_mori2.default.first(_mori2.default.last(row))) === 'all';
	        var nestedObject = (data.columns[_mori2.default.first(group)] ? data.columns[_mori2.default.first(group)][_mori2.default.first(row)] : data.columns.nested[_mori2.default.first(group)].children[_mori2.default.first(row)]) || {};
	
	        var base = _mori2.default.hashMap(baseColumn, nestedObject.label);
	        return _mori2.default.isEmpty(_mori2.default.last(row)) || selectAll ? _mori2.default.vector(_mori2.default.vector(base)) : _mori2.default.map(function (child) {
	          // summary rows gets a rewrite
	          if (_mori2.default.first(child) === 'summary') {
	            return _mori2.default.set([_mori2.default.hashMap(baseColumn, nestedObject.label + ' (All)'), _mori2.default.hashMap(childColumn, _mori2.default.getIn(summaries, [data.timeframes[options.currentTimeframe], nestedObject.label + ' (All)'], null))]);
	          }
	          return _mori2.default.set([base, _mori2.default.hashMap(childColumn, nestedObject.children[_mori2.default.first(child)].label)]);
	        }, _mori2.default.last(row));
	      },
	      // do territory sort here
	      _mori2.default.sort(function (a, b) {
	        return (0, _territorySortFilter.territorySort)(_mori2.default.first(a), _mori2.default.first(b));
	      }, _mori2.default.filter(function (rowObj) {
	        return _mori2.default.first(rowObj) !== 'all';
	      }, _mori2.default.last(group))));
	    }, _mori2.default.toClj(Object.keys(selectedRows || {}).reduce(function (selected, group) {
	      return angular.extend({}, selected, _defineProperty({}, group, Object.keys(selectedRows[group] || {}).reduce(function (acc, column) {
	        return angular.extend({}, acc, _defineProperty({}, column, Object.keys(selectedRows[group][column] || {}).reduce(function (acc1, child) {
	          return angular.extend({}, acc1, _defineProperty({}, child, {}));
	        }, {})));
	      }, {})));
	    }, {}))));
	  } else {
	    // Medicare has a special default state... US wrapup & States
	    if (isMedicare && Object.keys(selectedRows).length === 0) {
	      var hasStates = !!data.columns.nested.states;
	      var hasWrapups = !!data.columns.wrapups;
	      if (hasStates && hasWrapups) {
	        selectedRows = {
	          'states': { 'all': {} },
	          'wrapups': { 'united-states': {} }
	        };
	      }
	    }
	    // Make an array of selected/parent selection rows
	    parentColumns = _mori2.default.into(_mori2.default.vector(), _mori2.default.mapcat(function (group) {
	      return _mori2.default.mapcat(function (row) {
	        return (0, _getSelectedColumnsRecursive2.default)(data, baseColumn, childColumn, row, group);
	      },
	      // do territory sort here
	      _mori2.default.sort(function (a, b) {
	        return (0, _territorySortFilter.territorySort)(_mori2.default.first(a), _mori2.default.first(b));
	      }, _mori2.default.filter(function (rowObj) {
	        return _mori2.default.first(rowObj) !== 'all';
	      }, _mori2.default.last(group))));
	    }, _mori2.default.toClj(Object.keys(selectedRows || {}).reduce(function (selected, group) {
	      return angular.extend({}, selected, _defineProperty({}, group, getSelectedColumns(selectedRows, group)));
	    }, {}))));
	  }
	
	  var wrapupColumns = _mori2.default.set(_mori2.default.mapcat(function (val) {
	    return _mori2.default.set([_mori2.default.first(val)]);
	  }, _mori2.default.filter(function (row) {
	    return _mori2.default.get(_mori2.default.first(_mori2.default.rest(row)), 'selected');
	  }, _mori2.default.toClj(data.columns.wrapups))));
	
	  /**
	   * Digs into selected columns to produce required data for getSelected
	   * to continue processing, it has a req of the data.columns that
	   * can't be passed in via attr since recursion is a pain...
	   * @param {object} Object to dig into
	   * @param {string} Initial key to dig
	   * @param {...string} parent keys
	   * @return {object} Object of all selectedColumns
	   */
	  function getSelectedColumns() {
	    var args = Array.prototype.slice.call(arguments);
	    var rows = args[0];
	    var key = args[1];
	    var keys = args.slice(1, args.length);
	
	    if (rows[key].all) {
	      // data.columns needs to be curried into from above
	      return Object.keys(_util.digColumnValue.apply(undefined, [data.columns].concat(_toConsumableArray(keys.reverse()))) || {}).reduce(function (acc, column) {
	        return angular.extend({}, acc, _defineProperty({}, column, {}));
	      }, {});
	    } else if (Object.keys(rows[key]).length) {
	      return Object.keys(rows[key]).reduce(function (selected, nested) {
	        return angular.extend({}, selected, _defineProperty({}, nested, getSelectedColumns.apply(undefined, [rows[key], nested].concat(_toConsumableArray(keys)))));
	      }, {});
	    }
	    // If all else doesn't matter, just return the rows/key
	    return rows[key]; // This SHOULD have a label...
	  }
	
	  return _mori2.default.into(parentColumns, wrapupColumns);
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getSelectedColumns.js');
	}();

	;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sortComparator;
	
	var _sorters = __webpack_require__(270);
	
	var _sorters2 = _interopRequireDefault(_sorters);
	
	var _config = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sortComparator(currentHeader, baseDistribution, mapBaseColumn) {
	  return function (_ref, _ref2, data1, data2, isInverted) {
	    var val1 = _ref.text;
	    var val2 = _ref2.text;
	
	    var datacenterSortResult = (0, _sorters2.default)(val1, val2, currentHeader, isInverted, data1.data[baseDistribution], data2.data[baseDistribution], data1.data.isSummary, data2.data.isSummary);
	
	    // @TODO - build geo-sorting tied no-data vals into each sort
	    var noDataSort = val1 === val2 && _config.appDefault.dataNotAvailable.indexOf(val1) > -1 && _config.appDefault.dataNotAvailable.indexOf(val2) > -1;
	
	    // If the sort returns a 0, we've tied.
	    // If we are also comparing on a header that is not the base,
	    // then we are to re-sort based on geography.
	    if ((datacenterSortResult === 0 || noDataSort) && baseDistribution !== currentHeader.characteristic) {
	      return (isInverted ? -1 : 1) * (0, _sorters2.default)(data1.data[baseDistribution], data2.data[baseDistribution], { type: 'geography' }, isInverted, data1.data[baseDistribution], data2.data[baseDistribution], data1.data.isSummary, data2.data.isSummary);
	    }
	
	    // If there is mapBaseColumn, we are in a multiGeo indicator
	    // In that case, see if we are sorting on the base distribution.
	    // If we are, then sort on geo after sorting on base w/result of 0.
	    // This indicates that sorting on base didn't change anything, but we
	    // still need to sort on geography.
	    if (mapBaseColumn && baseDistribution === currentHeader.characteristic) {
	      return datacenterSortResult === 0 ? (0, _sorters2.default)(data1.data[mapBaseColumn], data2.data[mapBaseColumn], { type: 'geography' }, isInverted, data1.data[mapBaseColumn], data2.data[mapBaseColumn], data1.data.isSummary, data2.data.isSummary) : datacenterSortResult;
	    }
	
	    // @TODO - find a better way to send in summary info
	    // this problem arises from removing the (All) string from
	    // the data for rendering purposes.  We already added an
	    // isSummary prop to the data, so we're using it here
	    return (0, _sorters2.default)(val1, val2, currentHeader, isInverted, data1.data[baseDistribution], data2.data[baseDistribution], data1.data.isSummary, data2.data.isSummary);
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(sortComparator, 'sortComparator', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/sortComparator.js');
	}();

	;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calcScrollShadow = calcScrollShadow;
	/**
	 * This file contains utils specifically for the table.
	 */
	
	/*
	 * Adds scroll shadow divs and an event listener to adjust shadow opacity
	 * @param  {array} tableHeight     calculated Table Height
	 */
	function calcScrollShadow(tableHeight) {
	  var bodyContainer = document.querySelector('.ag-body-container');
	  var vp = document.querySelector('.ag-body-viewport');
	
	  // If there is any of the shadow elements present, we've already
	  // initialized the shadow elements and scroll event
	  if (!!document.querySelector('.ag-scroll-shadow-right')) {
	    document.querySelector('.ag-scroll-shadow-bottom').style.opacity = bodyContainer.clientHeight - tableHeight <= 0 ? 0 : 1;
	
	    document.querySelector('.ag-scroll-shadow-right').style.opacity = bodyContainer.clientWidth - vp.clientWidth <= 0 ? 0 : 1;
	    return;
	  }
	
	  var shadowRight = document.querySelector('.ag-scroll-shadow-right');
	  var shadowLeft = document.querySelector('.ag-scroll-shadow-left');
	  var shadowTop = document.querySelector('.ag-scroll-shadow-top');
	  var shadowBottom = document.querySelector('.ag-scroll-shadow-bottom');
	  var marginLeft = document.querySelector('.ag-body-viewport-wrapper').style.marginLeft;
	
	  // 10 = width/height of shadow elements in CSS
	  var shadowLeftAdjust = marginLeft.replace('px', '') - 10;
	  var shadowTopAdjust = -10;
	
	  shadowTop = document.createElement('div');
	  shadowTop.className = 'ag-scroll-shadow-top';
	  shadowTop.style.width = bodyContainer.style.width;
	  shadowTop.style['z-index'] = 9999999;
	  shadowBottom = document.createElement('div');
	  shadowBottom.className = 'ag-scroll-shadow-bottom';
	  shadowBottom.style.width = bodyContainer.style.width;
	  shadowBottom.style['z-index'] = 9999999;
	  shadowRight = document.createElement('div');
	  shadowRight.className = 'ag-scroll-shadow-right';
	  shadowLeft = document.createElement('div');
	  shadowLeft.className = 'ag-scroll-shadow-left';
	  vp.appendChild(shadowTop);
	  vp.appendChild(shadowBottom);
	  vp.appendChild(shadowRight);
	  vp.appendChild(shadowLeft);
	  shadowTop.style.opacity = 0;
	  shadowLeft.style.opacity = 0;
	
	  vp.addEventListener('scroll', function () {
	    shadowBottom.style.width = bodyContainer.style.width;
	    shadowTop.style.width = bodyContainer.style.width;
	    var scrollRight = bodyContainer.clientWidth - vp.clientWidth - vp.scrollLeft;
	    var scrollBottom = bodyContainer.clientHeight - vp.clientHeight - vp.scrollTop;
	    shadowRight.style.opacity = scrollRight / 20 > 1 ? 1.0 : scrollRight / 20;
	    shadowLeft.style.opacity = vp.scrollLeft / 20 > 1 ? 1.0 : vp.scrollLeft / 20;
	    shadowTop.style.opacity = vp.scrollTop / 20 > 1 ? 1.0 : vp.scrollTop / 20;
	    shadowBottom.style.opacity = scrollBottom / 20 > 1 ? 1.0 : scrollBottom / 20;
	  });
	
	  shadowBottom.style.opacity = bodyContainer.clientHeight - tableHeight <= 0 ? 0 : 1;
	
	  shadowRight.style.opacity = bodyContainer.clientWidth - vp.clientWidth <= 0 ? 0 : 1;
	
	  shadowLeft.style.left = shadowLeftAdjust + 'px';
	  shadowTop.style.top = shadowTopAdjust + 'px';
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(calcScrollShadow, 'calcScrollShadow', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/util.js');
	}();

	;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildHeaders = buildHeaders;
	exports.getOneSheet = getOneSheet;
	exports.getConfig = getConfig;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	var _isDatatypeRow = __webpack_require__(265);
	
	var _isDatatypeRow2 = _interopRequireDefault(_isDatatypeRow);
	
	var _headerUtils = __webpack_require__(264);
	
	var _util = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function buildHeaders(data, config) {
	  var headersRaw = (0, _headerUtils.getHeadersOnly)(getOneSheet(data));
	  var headerDataTypes = (0, _headerUtils.getHeaderDataTypes)(_config.sheetParseConfig.dataTypes);
	  var rowTypes = void 0;
	  // repeats in the first row means nested
	  var nestedRow = _mori2.default.count(_mori2.default.first(headersRaw)) >= _mori2.default.count(_mori2.default.distinct(_mori2.default.first(headersRaw)));
	  var datatypeRow = _mori2.default.some(function (row) {
	    return (0, _isDatatypeRow2.default)(row, headerDataTypes);
	  }, headersRaw);
	
	  // Use this to find out what type of header setup we're dealing with
	  // and fill out the appropriate properties
	  if (nestedRow && !datatypeRow && headersRaw.length === 2) {
	    rowTypes = ['headerGroup', 'characteristic'];
	  } else if (datatypeRow && headersRaw.length === 2) {
	    rowTypes = ['characteristic', 'type'];
	  } else if (datatypeRow && headersRaw.length === 3) {
	    rowTypes = ['headerGroup', 'characteristic', 'type'];
	  } else {
	    rowTypes = ['characteristic'];
	  }
	
	  // Make sure to map defaults to types
	  var typeRow = rowTypes.indexOf('type');
	  var charRow = rowTypes.indexOf('characteristic');
	  var groupRow = rowTypes.indexOf('headerGroup');
	  if (typeRow !== -1) {
	    rowTypes.push('label');
	    rowTypes.push('width');
	    var labels = headersRaw[typeRow].map(function (item) {
	      return (item || 'Default').split('--')[0];
	    });
	    var types = headersRaw[typeRow].map(function (item) {
	      var type = (0, _headerUtils.getHeaderTypeObject)(item, headerDataTypes);
	      return type.type ? type : item;
	    });
	    // Because of the lookup these need to get flipped
	    headersRaw[typeRow] = types.map(function (x) {
	      return (x || {}).type || x;
	    });
	    headersRaw.push(labels);
	    headersRaw.push(types.map(function (x) {
	      return (x || {}).width;
	    }));
	  } else {
	    typeRow = rowTypes.length;
	    rowTypes.push('type', 'label');
	    var _types = headersRaw[charRow].map(function (item) {
	      var inferredType = (0, _util.getInferredType)(item);
	      return inferredType || 'default';
	    });
	
	    var _labels = _types;
	    headersRaw.push(_types, _labels);
	  }
	
	  // For nested rows, we want to build a compound header name
	  // to get distinct headers.  Otherwise, nested tables will mistakenly
	  // have data views listed when there is only 1 data view
	  var composedNestedHeaders = groupRow !== -1 ? headersRaw[groupRow].reduce(function (acc, curr, idx) {
	    acc.push('' + (curr + headersRaw[charRow][idx]));
	    return acc;
	  }, []) : null;
	
	  // To check for the presence of data views, we compare the distinct
	  // headers to all the headers.  If we have nested headers,
	  // use the built composed headers above to get distinct header count
	  var hasDataviews = _mori2.default.count(_mori2.default.distinct(nestedRow && composedNestedHeaders ? composedNestedHeaders : headersRaw[charRow])) < _mori2.default.count(headersRaw[charRow]);
	
	  // Add 'idx' to the generated props
	  rowTypes.push('idx');
	
	  // There are cases where the last header(s) do not have header groups.
	  // With these cases, we need to pad the group row with nulls.
	  // This will accurately build the headers based on how many characteristics
	  // there are
	  if (nestedRow && headersRaw[groupRow]) {
	    headersRaw[groupRow] = headersRaw[charRow].reduce(function (acc, curr, idx) {
	      return acc.concat(headersRaw[groupRow][idx] || null);
	    }, []);
	  }
	
	  var immutableHeaders = _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (col) {
	    return _mori2.default.zipmap(rowTypes, col);
	  }, _mori2.default.map.apply(_mori2.default, [_mori2.default.vector].concat(_toConsumableArray(headersRaw), [_mori2.default.range(_mori2.default.count(_mori2.default.first(headersRaw)))]))));
	
	  // Set default base column if not explicitly defined
	  if (!_mori2.default.get('characteristic', _mori2.default.first(immutableHeaders))) {
	    var baseType = 'geography';
	    var context = _mori2.default.getIn(config, ['globalRules', 'Context'], false);
	    if (!context) {
	      immutableHeaders = _mori2.default.assoc(immutableHeaders, 0, _mori2.default.hashMap(_config.sheetParseConfig.headerTypes[0], 'Location', _config.sheetParseConfig.headerTypes[1], baseType, 'label', baseType && baseType[0].toUpperCase() + baseType.slice(1), 'idx', 0));
	    } else {
	      if (!/^state|country$/i.test(_mori2.default.first(context))) {
	        baseType = 'text';
	      }
	      immutableHeaders = _mori2.default.assoc(immutableHeaders, 0, _mori2.default.hashMap(_config.sheetParseConfig.headerTypes[0], _mori2.default.first(context), _config.sheetParseConfig.headerTypes[1], baseType, 'label', baseType && baseType[0].toUpperCase() + baseType.slice(1), 'idx', 0));
	    }
	  }
	
	  // For settings targeted at specific columns assign them where needed
	  if (_mori2.default.count(_mori2.default.get(config, 'settings')) || _mori2.default.count(_mori2.default.get(config, 'globalSettings'))) {
	    immutableHeaders = _mori2.default.map(function (header) {
	      var characteristic = _mori2.default.get(header, 'characteristic');
	      var headerGroup = _mori2.default.get(header, 'headerGroup', false);
	      var headerType = _mori2.default.get(header, 'label', 'default');
	      var lowerHeaderType = headerType.toLowerCase();
	
	      // Progressivly determine the specificity of the selector
	      // If the column already has a type, it can't be overridden by a
	      // global rule
	      var headerTypeSelector = lowerHeaderType !== 'default' ? headerType : characteristic;
	
	      // Selector that best targets column rules
	      // For nested tables, we want the group header and the characteristic
	      // becomes the "data format"
	      var fullSelector = _mori2.default.conj(headerGroup ? _mori2.default.hashMap('Distribution', headerGroup) : _mori2.default.hashMap('Distribution', characteristic), headerTypeSelector !== 'default' && headerGroup ? _mori2.default.hashMap('Data Format', headerTypeSelector.toLowerCase()) : _mori2.default.hashMap());
	
	      // Data Format settings are special because they can be either selectors
	      // or settings. For example:
	      //
	      // any,Characteristic Name,Percent,any,Type,Setting
	      //
	      // can set the Data Format equal to "Percent" and add a Type:Setting pair
	      // to a column, or it can add the Type:Setting pair to a column by
	      // selecting on an already defined Data Format ("Percent")
	      var dataFormat = _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.hashMap('Data Format', lowerHeaderType)),
	      // if headerType doesn't have a match, also check what counts for the
	      // characteristic for this column
	      _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.assoc(fullSelector, 'Data Format', (headerGroup ? characteristic : headerTypeSelector).toLowerCase())), _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.hashMap('Data Format', (headerGroup ? characteristic : headerTypeSelector).toLowerCase())),
	      // try && syntax
	      _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.hashMap('Distribution', headerGroup + ' && ' + characteristic, 'Data Format', headerTypeSelector.toLowerCase())),
	      // try global settings as well
	      _mori2.default.getIn(config, _mori2.default.vector('settings', 'settings', _mori2.default.hashMap('Data Format', lowerHeaderType)), _mori2.default.hashMap())))));
	
	      // Using the best selector, get matching rules
	      var filteredSettings = _mori2.default.filter(
	      // don't use loose selector for now
	      /*
	      (setting) => (
	        mori.equals(mori.first(setting), fullSelector) ||
	        mori.equals(mori.dissoc(mori.first(setting), 'Data Format'),
	          fullSelector)
	      ),
	      */
	      function (setting) {
	        return _mori2.default.equals(_mori2.default.first(setting), fullSelector);
	      }, _mori2.default.getIn(config, ['settings', 'settings']));
	
	      // Finds rules that apply to only the distribution
	      var selector = _mori2.default.getIn(config, ['settings', 'settings', _mori2.default.dissoc(fullSelector, 'Data Format')], _mori2.default.hashMap());
	
	      // a hack to ensure the dataview label retains it's original formatting
	      if (_mori2.default.get(dataFormat, 'label') !== headerType) {
	        dataFormat = _mori2.default.assoc(dataFormat, 'label', headerType);
	      }
	      // Apply found rules
	      return _mori2.default.reduce(
	      // extend column def with found rules
	      function (acc, value) {
	        return _mori2.default.conj(acc, _mori2.default.first(_mori2.default.rest(value)));
	      },
	      // extend column def with global settings, then data format
	      _mori2.default.into(header, _mori2.default.vector(_mori2.default.getIn(config, ['settings', 'globalSettings'], _mori2.default.hashMap()), selector, dataFormat)), filteredSettings);
	    }, immutableHeaders);
	  }
	
	  return { immutableHeaders: immutableHeaders, hasDataviews: hasDataviews };
	}
	
	/**
	 * A transducer that grabs the first data sheet from the google doc.
	 * @param {object} data - The gdocs json data
	 * @return {array} - The "sheet" array from the data sheet
	 */
	function getOneSheet(data) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  return _mori2.default.first(_mori2.default.intoArray(_mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (x) {
	    return config ? _config.sheetParseConfig.configTitles.indexOf(x[0].toLowerCase()) > -1 : _config.sheetParseConfig.configTitles.indexOf(x[0].toLowerCase()) === -1;
	  }), _mori2.default.map(function (x) {
	    return x[1];
	  })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), data)));
	}
	
	/**
	 * Returns the config array
	 * @param {object} data - The gdocs json data
	 * @return {object} The config object
	 */
	function getConfig(data) {
	  var configSheet = getOneSheet(data, true);
	
	  return _mori2.default.reduce(function (acc, next) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(next), _mori2.default.reduce(
	    // Each type of config object get processed differently
	    getRuleReducer(_mori2.default.first(next)), _mori2.default.hashMap(), _mori2.default.first(_mori2.default.rest(next)))));
	  }, _mori2.default.hashMap(), _mori2.default.groupBy(configGroupBy, cleanAndBuildConfigSheet(configSheet)));
	}
	
	/**
	 * Return the appropriate reducing function
	 *
	 * @param {string} type The name of the bucket we're currently building
	 *
	 * @return {function} A reducer function
	 */
	function getRuleReducer(type) {
	  switch (type) {
	    case 'globalRules':
	      return buildGlobalRules;
	    case 'notesSources':
	      return buildNotesSources;
	    case 'footnotes':
	      return buildFootnotes;
	    case 'settings':
	      return buildSettings;
	    default:
	      return _mori2.default.conj;
	  }
	}
	
	/**
	 * Builds settings objects from a list of config objects
	 *
	 * @param {hashMap} acc Current accumulator value map
	 * @param {hashMap} next The current row object
	 *
	 * @return {hashMap} A map of settings objects for lookup and rendering
	 */
	function buildSettings(acc, next) {
	  var settings = _mori2.default.get(acc, 'settings', _mori2.default.hashMap());
	  var globalSettings = _mori2.default.get(acc, 'globalSettings', _mori2.default.hashMap());
	
	  /**
	   * settings stored by complex key key
	   *
	   * ("Timeframe", "Distribution", "Data Format", "Geography"): Type:Note[Setting:Value]
	   */
	  var paths = _mori2.default.reduce(function (pathAcc, key) {
	    var addValues = (0, _util.getAndCleanCSVValues)(_mori2.default.get(next, key), ['any']);
	
	    return _mori2.default.mapcat(function (val) {
	      var dataVal = key === 'Data Format' ? val.toLowerCase() : val;
	      var newTuple = dataVal !== 'any' ? _mori2.default.hashMap(key, dataVal) : _mori2.default.hashMap();
	      if (!_mori2.default.count(pathAcc)) {
	        return _mori2.default.vector(newTuple);
	      }
	      return _mori2.default.map(function (parentVal) {
	        return _mori2.default.conj(parentVal, newTuple);
	      }, pathAcc);
	    }, addValues);
	  }, _mori2.default.vector(), _mori2.default.vector('Timeframe', 'Distribution', 'Data Format', 'Geography'));
	
	  var currSetting = _mori2.default.hashMap(_mori2.default.get(next, 'Type'), _mori2.default.get(next, 'Note'));
	
	  // unspecific rules classified as global
	  if (_mori2.default.every(function (item) {
	    return item === 'any';
	  }, _mori2.default.first(paths))) {
	    globalSettings = _mori2.default.into(globalSettings, currSetting);
	  } else {
	    var headerDataTypes = (0, _headerUtils.getHeaderDataTypes)(_config.sheetParseConfig.dataTypes);
	    // extends settings objects when complex keys match
	    settings = _mori2.default.reduce(function (acc2, curr2) {
	      return _mori2.default.reduce(function (acc3, curr3) {
	        return _mori2.default.assoc(acc3, _mori2.default.first(curr3), _mori2.default.merge(_mori2.default.get(acc2, _mori2.default.first(curr3)), _mori2.default.last(curr3)));
	      }, acc2, curr2);
	    }, settings, _mori2.default.map(function (vect) {
	      return _mori2.default.hashMap(vect, getSettingWithDefaults(vect, currSetting, headerDataTypes));
	    }, paths));
	  }
	
	  return _mori2.default.hashMap('settings', settings, 'globalSettings', globalSettings);
	}
	
	/**
	 * Builds data format options by label type
	 *
	 * @param {hashMap} current The hashMap representing the path this rule will
	 *  be assigned to
	 * @param {hashMap} setting The base setting to extend
	 * @param {object} datatypes The datatypes list from config
	 *
	 * @return {hashMap} Extended setting for this rule path
	 */
	function getSettingWithDefaults(current, setting, datatypes) {
	  var dataFormat = _mori2.default.get(current, 'Data Format', 'any');
	  var dataFormatType = (0, _headerUtils.getHeaderTypeObject)(dataFormat, datatypes);
	
	  var dataFormatSetting = dataFormat && dataFormat !== 'any' ? _mori2.default.hashMap('label', dataFormat || 'Default', 'type', dataFormatType ? dataFormatType.type : 'default') : _mori2.default.hashMap();
	
	  return _mori2.default.conj(setting, dataFormatSetting);
	}
	
	/**
	 * Builds footnote reference objects from a list of config objects
	 *
	 * @param {hashMap} acc Current accumulator value map
	 * @param {hashMap} next The current row object
	 *
	 * @return {hashMap} A map of footnote reference structures for lookup
	 * and rendering
	 */
	function buildFootnotes(acc, next) {
	  var footnotes = _mori2.default.get(acc, 'footnotes', _mori2.default.hashMap());
	  var footnoteList = _mori2.default.get(acc, 'footnoteList', _mori2.default.hashMap());
	  var foundFootnotes = _mori2.default.get(acc, 'foundFootnotes', _mori2.default.hashMap());
	  var note = _mori2.default.get(next, 'Note', false);
	
	  // Footnotes go in a nested hashMap for us to look up
	  // find by the set of selectors
	  var isUsed = _mori2.default.get(foundFootnotes, _mori2.default.hash(note.toLowerCase()), false);
	  var footnoteUid = isUsed || _mori2.default.count(foundFootnotes) + 1;
	  if (isUsed === false) {
	    foundFootnotes = _mori2.default.assoc(foundFootnotes, _mori2.default.hash(note.toLowerCase()), footnoteUid);
	  }
	  var timeframes = (0, _util.getAndCleanCSVValues)(_mori2.default.get(next, 'Timeframe'), ['any']);
	  var geographies = (0, _util.getAndCleanCSVValues)(_mori2.default.get(next, 'Geography'), ['any']);
	  var distributions = (0, _util.getAndCleanCSVValues)(_mori2.default.get(next, 'Distribution'), ['any']);
	
	  timeframes.forEach(function (timeframe) {
	    geographies.forEach(function (geo) {
	      distributions.forEach(function (dist) {
	        // Normalize base column header for footnote targets
	        var mapDist = dist === 'Region' ? 'Location' : dist;
	        if (mapDist.indexOf(' && ') > -1) {
	          var splitDist = mapDist.split(' && ');
	          footnotes = _mori2.default.updateIn(footnotes, [timeframe, geo, _mori2.default.hashMap.apply(_mori2.default, _toConsumableArray(splitDist))],
	          // add multiple footnotes in place
	          function (value) {
	            return _mori2.default.conj(value || _mori2.default.vector(), _mori2.default.hashMap('note', note, 'id', footnoteUid));
	          });
	        } else {
	          footnotes = _mori2.default.updateIn(footnotes, [timeframe, geo, mapDist],
	          // add multiple footnotes in place
	          function (value) {
	            return _mori2.default.conj(value || _mori2.default.vector(), _mori2.default.hashMap('note', note, 'id', footnoteUid));
	          });
	        }
	
	        footnoteList = _mori2.default.assoc(footnoteList, footnoteUid, note);
	      });
	    });
	  });
	
	  return _mori2.default.hashMap('footnotes', footnotes, 'footnoteList', footnoteList, 'foundFootnotes', foundFootnotes);
	}
	
	/**
	 * Builds notes and sources arrays from a list of config objects
	 *
	 * @param {hashMap} acc Current accumulator value map
	 * @param {hashMap} next The current row object
	 *
	 * @return {hashMap} A map of vectors for each type of Notes/Sources
	 */
	function buildNotesSources(acc, next) {
	  var type = _mori2.default.get(next, 'Type');
	  return _mori2.default.conj(acc, _mori2.default.hashMap(type, _mori2.default.into(_mori2.default.get(acc, type, _mori2.default.vector()), _mori2.default.vector(next))));
	}
	
	/**
	 * Builds global rules hash map from a list of config objects
	 *
	 * @param {hashMap} acc Current accumulator value map
	 * @param {hashMap} next The current row object
	 *
	 * @return {hashMap} A map of rules in `Type: Note` form
	 */
	function buildGlobalRules(acc, next) {
	  var type = _mori2.default.get(next, 'Type');
	  var typeLower = type.toLowerCase();
	  var note = _mori2.default.get(next, 'Note');
	  var multiGeoTypes = ['map base column', 'link column', 'link target'];
	  var rule = void 0;
	
	  // Context rules can be joined
	  if (typeLower === 'context') {
	    rule = note.split('+');
	  } else if (typeLower === 'related columns') {
	    rule = (0, _util.getAndCleanCSVValues)(note);
	  } else if (multiGeoTypes.indexOf(typeLower) > -1) {
	    rule = note;
	  } else {
	    rule = note.toLowerCase() === 'yes';
	  }
	
	  return _mori2.default.conj(acc, _mori2.default.hashMap(type, rule));
	}
	
	/**
	 * Cleans the config sheet to remove presentational rows and builds objects
	 * from headers for parsing
	 *
	 * @param {array} sheet The config sheet removed from the original data
	 *
	 * @return {vector} A list of rows that have been mapped to headers
	 */
	function cleanAndBuildConfigSheet(sheet) {
	  // normalize Note/Notes in header keys
	  var headers = _mori2.default.map(function (key) {
	    return ['Notes', 'Note'].indexOf(key) > -1 ? 'Note' : key;
	  }, _mori2.default.first(sheet));
	  return _mori2.default.map(
	  // Create an object from the row so we can lookup by name
	  function (row) {
	    return _mori2.default.zipmap(headers, row);
	  },
	  // Discard blank dividing rows and row without a Note value
	  _mori2.default.remove(function (row) {
	    return _mori2.default.every(function (x) {
	      return x === null;
	    }, _mori2.default.rest(row)) || _mori2.default.last(row) === null;
	  }, _mori2.default.rest(sheet)));
	}
	
	/**
	 * A groupBy function to split config sheets into proper buckets.
	 *
	 * @param {hashMap} row The current row being evaluated
	 *
	 * @return {string} The bucket name for this row
	 */
	function configGroupBy(row) {
	  if (configIsGlobalRule(row)) {
	    return 'globalRules';
	  } else if (configIsNotesSources(row)) {
	    return 'notesSources';
	  } else if (configIsFootnote(row)) {
	    return 'footnotes';
	  }
	  return 'settings';
	}
	
	/**
	 * Function to test whether current row is a global rule
	 *
	 * @param {hashMap} row The current row being evaluated
	 *
	 * @return {bool} isGlobalRule?
	 */
	function configIsGlobalRule(row) {
	  var distribution = _mori2.default.get(row, 'Distribution', 'any');
	  return _mori2.default.hasKey(row, 'Type') && _mori2.default.hasKey(row, 'Note') && (!distribution || distribution === 'any') && !_mori2.default.get(row, 'Data Format', false) && _config.sheetParseConfig.globalRules.indexOf(_mori2.default.get(row, 'Type', '').toLowerCase()) > -1;
	}
	
	/**
	 * Function to test whether current row is Notes/Sources
	 *
	 * @param {hashMap} row The current row being evaluated
	 *
	 * @return {bool} isNotesSources?
	 */
	function configIsNotesSources(row) {
	  return _mori2.default.hasKey(row, 'Type') && _mori2.default.hasKey(row, 'Note') && _config.sheetParseConfig.sourceTypes.indexOf((_mori2.default.get(row, 'Type', '') || '').toLowerCase()) > -1;
	}
	
	/**
	 * Function to test whether current row is a footnote
	 *
	 * @param {hashMap} row The current row being evaluated
	 *
	 * @return {bool} isFootnote?
	 */
	function configIsFootnote(row) {
	  return (_mori2.default.get(row, 'Type', '') || '').toLowerCase() === 'footnote';
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(buildHeaders, 'buildHeaders', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(getOneSheet, 'getOneSheet', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(getConfig, 'getConfig', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(getRuleReducer, 'getRuleReducer', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(buildSettings, 'buildSettings', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(getSettingWithDefaults, 'getSettingWithDefaults', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(buildFootnotes, 'buildFootnotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(buildNotesSources, 'buildNotesSources', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(buildGlobalRules, 'buildGlobalRules', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(cleanAndBuildConfigSheet, 'cleanAndBuildConfigSheet', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(configGroupBy, 'configGroupBy', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(configIsGlobalRule, 'configIsGlobalRule', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(configIsNotesSources, 'configIsNotesSources', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	
	  __REACT_HOT_LOADER__.register(configIsFootnote, 'configIsFootnote', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducers.js');
	}();

	;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCurrentDistributions = getCurrentDistributions;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCurrentDistributions(distributions, options) {
	  // Currently selected distributions by matching slugs, or all
	  return _mori2.default.count(distributions) === 0 && (options.activeTab !== 'graph' || _mori2.default.count(distributions) === 1) ? distributions : _mori2.default.filter(function (x) {
	    return options.selectedDistributions ? [].concat(options.selectedDistributions.split('--')).indexOf(_mori2.default.get(x, 'slug')) > -1 : false;
	  }, distributions);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getCurrentDistributions, 'getCurrentDistributions', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/dataFilters.js');
	}();

	;

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	// ## Compute Matrices for Jenks
	//
	// Compute the matrices required for Jenks breaks. These matrices
	// can be used for any classing of data with `classes <= n_classes`
	function jenksMatrices(data, n_classes) {
	
	    // in the original implementation, these matrices are referred to
	    // as `LC` and `OP`
	    //
	    // * lower_class_limits (LC): optimal lower class limits
	    // * variance_combinations (OP): optimal variance combinations for all classes
	    var lower_class_limits = [],
	        variance_combinations = [],
	
	    // loop counters
	    i,
	        j,
	
	    // the variance, as computed at each step in the calculation
	    variance = 0;
	
	    // Initialize and fill each matrix with zeroes
	    for (i = 0; i < data.length + 1; i++) {
	        var tmp1 = [],
	            tmp2 = [];
	        // despite these arrays having the same values, we need
	        // to keep them separate so that changing one does not change
	        // the other
	        for (j = 0; j < n_classes + 1; j++) {
	            tmp1.push(0);
	            tmp2.push(0);
	        }
	        lower_class_limits.push(tmp1);
	        variance_combinations.push(tmp2);
	    }
	
	    for (i = 1; i < n_classes + 1; i++) {
	        lower_class_limits[1][i] = 1;
	        variance_combinations[1][i] = 0;
	        // in the original implementation, 9999999 is used but
	        // since Javascript has `Infinity`, we use that.
	        for (j = 2; j < data.length + 1; j++) {
	            variance_combinations[j][i] = Infinity;
	        }
	    }
	
	    for (var l = 2; l < data.length + 1; l++) {
	
	        // `SZ` originally. this is the sum of the values seen thus
	        // far when calculating variance.
	        var sum = 0,
	
	        // `ZSQ` originally. the sum of squares of values seen
	        // thus far
	        sum_squares = 0,
	
	        // `WT` originally. This is the number of
	        w = 0,
	
	        // `IV` originally
	        i4 = 0;
	
	        // in several instances, you could say `Math.pow(x, 2)`
	        // instead of `x * x`, but this is slower in some browsers
	        // introduces an unnecessary concept.
	        for (var m = 1; m < l + 1; m++) {
	
	            // `III` originally
	            var lower_class_limit = l - m + 1,
	                val = data[lower_class_limit - 1];
	
	            // here we're estimating variance for each potential classing
	            // of the data, for each potential number of classes. `w`
	            // is the number of data points considered so far.
	            w++;
	
	            // increase the current sum and sum-of-squares
	            sum += val;
	            sum_squares += val * val;
	
	            // the variance at this point in the sequence is the difference
	            // between the sum of squares and the total x 2, over the number
	            // of samples.
	            variance = sum_squares - sum * sum / w;
	
	            i4 = lower_class_limit - 1;
	
	            if (i4 !== 0) {
	                for (j = 2; j < n_classes + 1; j++) {
	                    // if adding this element to an existing class
	                    // will increase its variance beyond the limit, break
	                    // the class at this point, setting the `lower_class_limit`
	                    // at this point.
	                    if (variance_combinations[l][j] >= variance + variance_combinations[i4][j - 1]) {
	                        lower_class_limits[l][j] = lower_class_limit;
	                        variance_combinations[l][j] = variance + variance_combinations[i4][j - 1];
	                    }
	                }
	            }
	        }
	
	        lower_class_limits[l][1] = 1;
	        variance_combinations[l][1] = variance;
	    }
	
	    // return the two matrices. for just providing breaks, only
	    // `lower_class_limits` is needed, but variances can be useful to
	    // evaluate goodness of fit.
	    return {
	        lower_class_limits: lower_class_limits,
	        variance_combinations: variance_combinations
	    };
	}
	
	// ## Pull Breaks Values for Jenks
	//
	// the second part of the jenks recipe: take the calculated matrices
	// and derive an array of n breaks.
	function jenksBreaks(data, lower_class_limits, n_classes) {
	
	    var k = data.length - 1,
	        kclass = [],
	        countNum = n_classes;
	
	    // the calculation of classes will never include the upper and
	    // lower bounds, so we need to explicitly set them
	    kclass[n_classes] = data[data.length - 1];
	    kclass[0] = data[0];
	
	    // the lower_class_limits matrix is used as indices into itself
	    // here: the `k` variable is reused in each iteration.
	    while (countNum > 1) {
	        kclass[countNum - 1] = data[lower_class_limits[k][countNum] - 2];
	        k = lower_class_limits[k][countNum] - 1;
	        countNum--;
	    }
	
	    return kclass;
	}
	
	// # [Jenks natural breaks optimization](http://en.wikipedia.org/wiki/Jenks_natural_breaks_optimization)
	//
	// Implementations: [1](http://danieljlewis.org/files/2010/06/Jenks.pdf) (python),
	// [2](https://github.com/vvoovv/djeo-jenks/blob/master/main.js) (buggy),
	// [3](https://github.com/simogeo/geostats/blob/master/lib/geostats.js#L407) (works)
	//
	// Depends on `jenksBreaks()` and `jenksMatrices()`
	
	var _default = function _default(data, n_classes) {
	
	    if (n_classes > data.length) return null;
	
	    // sort data in numerical order, since this is expected
	    // by the matrices function
	    data = data.slice().sort(function (a, b) {
	        return a - b;
	    });
	
	    // get our basic matrices
	    var matrices = jenksMatrices(data, n_classes),
	
	    // we only need lower class limits here
	    lower_class_limits = matrices.lower_class_limits;
	
	    // extract n_classes out of the computed matrices
	    return jenksBreaks(data, lower_class_limits, n_classes);
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	
	    __REACT_HOT_LOADER__.register(jenksMatrices, "jenksMatrices", "/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/jenks.js");
	
	    __REACT_HOT_LOADER__.register(jenksBreaks, "jenksBreaks", "/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/jenks.js");
	
	    __REACT_HOT_LOADER__.register(_default, "default", "/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/jenks.js");
	}();

	;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = geoSorter;
	
	var _util = __webpack_require__(59);
	
	var _config = __webpack_require__(11);
	
	/* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	/**
	 * Geography columns are hard, here are a bunch of special cases to sort through/for
	 */
	function geoSorter(a, b, column, isInverted, aBase, bBase, aIsSummary, bIsSummary) {
	  var aProps = (0, _util.buildRowProperties)(a, column);
	  var bProps = (0, _util.buildRowProperties)(b, column);
	
	  // @TODO - remove the unneeded multiplication here
	  // @TODO - not a bad idea to revisit this sorter and the others
	
	  aProps.isSummary = aIsSummary;
	  bProps.isSummary = bIsSummary;
	
	  // Wrapups pushed to the top
	  if (aProps.wrapup && bProps.wrapup) {
	    return _config.appDefault.specialWrapups.indexOf(a) - _config.appDefault.specialWrapups.indexOf(b);
	  } else if (aProps.wrapup && !bProps.wrapup) {
	    return isInverted ? 1 : -1;
	  } else if (!aProps.wrapup && bProps.wrapup) {
	    return isInverted ? -1 : 1;
	  }
	
	  if (a.indexOf('MA Region') > -1 && b.indexOf('MA Region') > -1) {
	    return parseInt(a.split(' ')[2], 10) - parseInt(b.split(' ')[2], 10);
	  }
	
	  // For special (numbered) geos, sort by the numerical value in the characteristic
	  if (aProps.isSpecialGeo && bProps.isSpecialGeo) {
	    var anum = parseInt(a.replace(/^\D+/g, ''), 10);
	    var bnum = parseInt(b.replace(/^\D+/g, ''), 10);
	    return anum - bnum;
	  } else if (aProps.isSpecialGeo && !bProps.isSpecialGeo) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.isSpecialGeo && !aProps.isSpecialGeo) {
	    return isInverted ? 1 : -1;
	  }
	
	  // State categories (All Rural Counties, etc) pushed to the top
	  if (aProps.isStateCategory && !bProps.isStateCategory) {
	    return (isInverted ? 1 : -1) * 1;
	  } else if (bProps.isStateCategory && !aProps.isStateCategory) {
	    return (isInverted ? 1 : -1) * 1;
	    // Territories pushed to the bottom, only in US context
	  } else if (aProps.isTerritory && bProps.isTerritory) {
	    return aProps.value.localeCompare(bProps.value);
	  } else if (aProps.isTerritory && !bProps.isTerritory) {
	    return (isInverted ? -1 : 1) * 1;
	  } else if (bProps.isTerritory && !aProps.isTerritory) {
	    return (isInverted ? -1 : 1) * -1;
	  }
	
	  // Summary rows float up without matching groups
	  var aClippedValue = aProps.value.replace(_config.appDefault.isSummaryRow, '');
	  var bClippedValue = bProps.value.replace(_config.appDefault.isSummaryRow, '');
	  if (aClippedValue === bClippedValue && aProps.isSummary) {
	    return (isInverted ? -1 : 1) * -1;
	  } else if (aClippedValue === bClippedValue && bProps.isSummary) {
	    return (isInverted ? 1 : -1) * -1;
	  } else if (aClippedValue === bClippedValue) {
	    return (isInverted ? -1 : 1) * aBase.localeCompare(bBase);
	  }
	
	  return aProps.value.localeCompare(bProps.value);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(geoSorter, 'geoSorter', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/sorters/geoSort.js');
	}();

	;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mixedSorter;
	
	var _util = __webpack_require__(15);
	
	var _util2 = __webpack_require__(59);
	
	var _config = __webpack_require__(11);
	
	function mixedSorter(a, b, column, isInverted, aBase, bBase) {
	  var aProps = (0, _util2.buildRowProperties)(a, column, _config.appDefault);
	  var bProps = (0, _util2.buildRowProperties)(b, column, _config.appDefault);
	
	  // Wrapups pushed to the top
	  if (aProps.wrapup && bProps.wrapup) {
	    return (isInverted ? -1 : 1) * aProps.value.localeCompare(bProps.value);
	  } else if (aProps.wrapup) {
	    return isInverted ? 1 : -1;
	  } else if (bProps.wrapup) {
	    return isInverted ? -1 : 1;
	  }
	
	  // NAs pushed to the bottom
	  if (aProps.naData && bProps.naData) {
	    var sorted = (0, _util2.sortArbitrary)(aProps.value, bProps.value, _config.appDefault.dataNotAvailable, isInverted);
	    if (sorted) {
	      return sorted;
	    }
	  } else if (aProps.naData) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.naData) {
	    return isInverted ? 1 : -1;
	  }
	
	  // If there is an arbitrary display order, sort that way
	  if ((column.sortOrder || []).length) {
	    var _sorted = (0, _util2.sortArbitrary)(aProps.value, bProps.value, column.sortOrder);
	    if (_sorted) {
	      return _sorted;
	    }
	  }
	
	  if (aProps.value === bProps.value) {
	    if (aBase && bBase) {
	      return (isInverted ? -1 : 1) * aBase.localeCompare(bBase);
	    }
	    return 0;
	  }
	
	  // Is column needed?
	  if (aProps.rawValue !== false && bProps.rawValue !== false) {
	    var anum = parseFloat(aProps.rawValue);
	    var bnum = parseFloat(bProps.rawValue);
	
	    // Is column having < or >
	    if (!(0, _util.kffIsNumber)(a) && /<|>/g.test(a) && anum === bnum) {
	      anum = />/g.test(a) ? ++anum : anum;
	      anum = /</g.test(a) ? --anum : anum;
	    } else if (!(0, _util.kffIsNumber)(b.value) && /<|>/g.test(b) && bnum === anum) {
	      bnum = />/g.test(b) ? ++bnum : bnum;
	      bnum = /</g.test(b) ? --bnum : bnum;
	    }
	
	    return bnum - anum;
	  } else if (aProps.rawValue !== false) {
	    return -1;
	  } else if (bProps.rawValue !== false) {
	    return 1;
	  }
	
	  // Finally, push symbols below others
	  var testStr = /^[a-z0-9\s].*[a-z0-9\s]+$/i;
	  var oneWordAtStart = /^([a-z0-9\s].*?\s?){1,}/i;
	  if (testStr.test(aProps.value) && !testStr.test(bProps.value) && !oneWordAtStart.test(bProps.value)) {
	    return -1;
	  } else if (testStr.test(bProps.value) && !testStr.test(aProps.value) && !oneWordAtStart.test(aProps.value)) {
	    return 1;
	  }
	
	  // Finally give up and fallback to localeCompare
	  return aProps.value.localeCompare(bProps.value);
	} /* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mixedSorter, 'mixedSorter', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/sorters/mixedSort.js');
	}();

	;

/***/ }),
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterData = filterData;
	exports.filterDistributions = filterDistributions;
	exports.onAfterFilterChanged = onAfterFilterChanged;
	exports.onAfterSortChanged = onAfterSortChanged;
	exports.getRowHeight = getRowHeight;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _dataFromOptions = __webpack_require__(95);
	
	var _table = __webpack_require__(138);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _util = __webpack_require__(15);
	
	var _util2 = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /** This file handles table data & interactions */
	
	
	// Store for table
	var defaultHeight = '';
	
	var _default = function _default(sheetData, options, filteredData, // Data organized by timeframe
	combinedFilters, readyCb, selectedKeys) {
	  var isMultiGeo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	  var reduxCallback = arguments[7];
	  var generalCallback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
	
	  // Hash for seeing changing table data
	  this.tableHash = this.tableHash || false;
	  this.tableInit = this.tableInit || false;
	  // If no table (table init),
	  // or isDirty, lets reload the data... time to PIVOT (but not a real pivot)!
	  var isDirty = isTableDirty.bind(this)(filteredData, combinedFilters);
	  if (this.tableInit === false || isDirty) {
	    // Load the config
	    var _getData = getData(sheetData, options, filteredData, combinedFilters),
	        rowData = _getData.rowData,
	        columnDefs = _getData.columnDefs;
	
	    // Set filter for columnDefs
	    // If not multigeo, setup location filter.
	    // Multigeo filtering is handled by external filtering function
	
	
	    if (!isMultiGeo) {
	      columnDefs[0] = Object.assign({}, {
	        filter: _table.LocationFilter,
	        filterParams: {
	          apply: false,
	          newRowsAction: 'keep'
	        }
	      }, columnDefs[0]);
	    }
	
	    // Check if table has not been initialized using a known prop
	    if (!this.tableInit) {
	      this.tableInit = true;
	      // Table not initialized, so lets resetup
	      Object.assign(this, {}, _table2.default, {
	        rowData: rowData,
	        columnDefs: columnDefs,
	        'datacenterColumnKeys': _mori2.default.toJs(_mori2.default.map(function (item) {
	          return _mori2.default.first(item);
	        }, _mori2.default.filter(function (item) {
	          return item;
	        }, combinedFilters[4]))),
	        'isExternalFilterPresent': function isExternalFilterPresent() {
	          return isMultiGeo;
	        },
	        'forPrint': options.print === 'true',
	        'trend': options.activeTab === 'graph'
	      });
	
	      tableSetup.bind(this)(readyCb);
	    } else {
	      // Is Dirty
	      // If the view has changed we need to reinit column defs as well
	      // Table is already initied;
	      this.api.setRowData(rowData);
	      // @TODO, limit this to only triggger on view
	      // changes between graph/(table || map)
	      this.api.setColumnDefs(columnDefs);
	      // Refreshing
	      this.api.refreshHeader();
	      this.api.refreshView();
	      // Re-set whether this is a trend graph view
	      this.trend = options.activeTab === 'graph';
	    }
	  }
	
	  this.doesExternalFilterPass = doesExternalFilterPass.bind(this)(selectedKeys);
	  if (reduxCallback) {
	    this.reduxCallback = reduxCallback;
	  }
	  if (generalCallback) {
	    generalCallback(this);
	  }
	  return this;
	};
	
	exports.default = _default;
	
	/**
	 * Filter data
	 *
	 * Can either be imported into a file, OR they can be used via `table.X`
	 */
	
	function filterData() {
	  var _this = this;
	
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var callback = arguments[1];
	
	  if (!this.api) {
	    return;
	  } else if (data) {
	    this.datacenterColumnKeys.forEach(function (columnKey) {
	      var filter = _this.api.getFilterApi(columnKey);
	
	      var filtered = _mori2.default.intoArray(_mori2.default.flatten(_mori2.default.reduce(function (acc, item) {
	        return _mori2.default.conj(acc, _mori2.default.last(_mori2.default.last(_mori2.default.first(_mori2.default.filter(function (test) {
	          return _mori2.default.first(_mori2.default.first(_mori2.default.first(test))) === columnKey;
	        }, item)))));
	      }, _mori2.default.vector(), data)));
	      // Check that there is actually filtered response
	      if (filtered.length > 0 && filtered[0] !== null) {
	        filter.setModel(filtered);
	      } else {
	        filter.setModel([]);
	      }
	    });
	  }
	  this.api.onFilterChanged();
	  if (callback) {
	    callback();
	  }
	}
	
	/**
	 * Column hiding/showing
	 * Can either be imported into a file, OR they can be used via `table.X`
	 */
	function filterDistributions(distributions, options, timeframes, callback) {
	  if (!this.columnApi) {
	    return;
	  }
	
	  var test = _mori2.default.intoArray(_mori2.default.map(function (item) {
	    return _mori2.default.count(item) === 3 ? _mori2.default.first(item) + '__' + _mori2.default.first(_mori2.default.rest(item)) : _mori2.default.first(item);
	  }, distributions));
	
	  if (options.activeTab === 'graph') {
	    test = test.concat(timeframes.reduce(function (acc, curr) {
	      return acc.concat.apply(acc, _toConsumableArray(test.filter(function (item) {
	        return item !== 'Location';
	      }).map(function (item) {
	        return curr + '__' + item;
	      })));
	    }, []));
	  }
	
	  var columns = [].concat.apply([], (this.columnApi.getAllColumns() || []).map(function (item) {
	    return item.children ? item.children.map(function (child) {
	      return child.colId;
	    }) : item.colId;
	  }));
	
	  var hidden = columns.filter(function (def) {
	    return test.indexOf(def) === -1;
	  });
	
	  var visible = columns.filter(function (def) {
	    return test.indexOf(def) !== -1;
	  });
	
	  if (hidden.indexOf((this.api.getSortModel()[0] || { colId: [] }).colId) > -1) {
	    this.api.setSortModel([{
	      colId: 'Location',
	      sort: 'asc'
	    }]);
	  }
	
	  this.columnApi.setColumnsVisible(hidden, false);
	  this.columnApi.setColumnsVisible(visible, true);
	
	  if (callback) {
	    callback();
	  }
	}
	
	/**
	 * Based on what the user has selected, see if the table rows
	 * contain each column key for the multi-geo table
	 *
	 * This filter is used only for multi-geo tables.
	 * @param  {object}  selectedKeys    the column keys that were selected by
	 *  the user
	 * @return {Function}
	 */
	function doesExternalFilterPass(selectedKeys) {
	  // Build the filter keys based on what's been selected
	  // We default to an '@' as some cell values are null, which causes filtering
	  // to break
	  var filteredKeys = this.datacenterColumnKeys.reduce(function (acc, columnKey) {
	    acc.push({
	      key: columnKey,
	      selected: _mori2.default.intoArray(_mori2.default.flatten(_mori2.default.reduce(function (acc1, item) {
	        return _mori2.default.conj(acc1, _mori2.default.last(_mori2.default.last(_mori2.default.first(_mori2.default.filter(function (test) {
	          return _mori2.default.first(_mori2.default.first(_mori2.default.first(test))) === columnKey;
	        }, item)) || '@')));
	      }, _mori2.default.vector(), selectedKeys)))
	    });
	    return acc;
	  }, []);
	
	  // If nothing's selected, we have no need to filter.
	  var noFiltering = _mori2.default.count(selectedKeys) === 0 ? true : false;
	
	  // The filtering function.
	  return function (node) {
	    if (noFiltering) {
	      return true;
	    }
	    var passes = false;
	    var lastFilterKey = filteredKeys[filteredKeys.length - 1];
	    // For each selected item, see if the following is true:
	    // 1.  The data in the table equals what has been selected
	    // 2.  Or, the selected from the last filter is the '@' character -
	    //     This indicates we want to match on only the first column.
	    filteredKeys[0].selected.forEach(function (selectedItem, index) {
	      if (node.data[filteredKeys[0].key] === selectedItem.split(' (All)')[0] && (node.data[lastFilterKey.key] === lastFilterKey.selected[index] || lastFilterKey.selected[index] === '@')) {
	        passes = true;
	      }
	    });
	    return passes;
	  };
	}
	
	/**
	 * Table Setup
	 * Access the `table` file global directly (it's scoped to this file)
	 */
	function tableSetup(readyCb) {
	  // The initial setup for tableheight is 75% of the window's height
	  defaultHeight = window.innerHeight * 0.75;
	  // Set Iniital Height
	  this.height = defaultHeight;
	
	  // Assign functions for modification
	  this.filterDistributions = filterDistributions.bind(this);
	  this.filterData = filterData.bind(this);
	
	  this.onGridReady = readyCb;
	  this.onAfterFilterChanged = onAfterFilterChanged.bind(this);
	  this.onAfterSortChanged = onAfterSortChanged.bind(this);
	  this.getRowHeight = getRowHeight;
	}
	
	function onAfterFilterChanged() {
	  // We need to reset the width of the body
	  // immediately after filter change so the table renders correctly
	  if (!this.forPrint) {
	    this.api.gridPanel.eBody.style.width = '';
	  }
	
	  var gridPanel = this.api.gridPanel;
	
	  // Given the displayed columns, generate a unique list of header names
	  var displayedHeaderNames = (this.columnApi.getAllDisplayedColumns() || []).reduce(function (acc, column) {
	    if (acc.indexOf(column.colId.split('__')[0]) === -1) {
	      acc.push(column.colId.split('__')[0]);
	    }
	    return acc;
	  }, []);
	
	  this.displayedHeaders = (this.columnApi.getAllDisplayedColumns() || []).reduce(function (acc, column) {
	    if (column.colId.indexOf('__') === -1) {
	      acc.push(column.colDef);
	      return acc;
	    }
	
	    var headerGroup = column.colId.split('__')[0];
	    var headerIndex = displayedHeaderNames.indexOf(headerGroup);
	
	    acc[headerIndex] = acc[headerIndex] || {
	      headerName: headerGroup,
	      children: []
	    };
	    acc[headerIndex].children.push(column.colDef);
	    return acc;
	  }, []);
	
	  // Using the above header names, build a list of headers (and children)
	  // This will allow us to calculate header height on only the visible headers
	  var headerHeight = resizeHeader.bind(this)({
	    columns: this.displayedHeaders,
	    forPrint: this.forPrint
	  });
	
	  if (!this.forPrint) {
	    // Ensure top row is visible post header height adjustment
	    this.api.ensureIndexVisible(0);
	
	    // 20 is added to adjust for possible x-overflow
	    var gridHeight = Math.round(gridPanel.eBodyContainer.getBoundingClientRect().height + headerHeight + 20);
	
	    this.height = gridHeight > defaultHeight ? defaultHeight : gridHeight;
	
	    // @TODO: Hacky.  If it's a short dataset, the y-scroll will appear
	    // likely due to a height calc issue due to borders :-/
	    gridPanel.eBodyViewport.style.overflowY = gridHeight > defaultHeight ? 'auto' : 'hidden';
	
	    setBodySize(this);
	    (0, _util2.calcScrollShadow)(this.height);
	  }
	
	  this.api.refreshRows(this.api.getRenderedNodes());
	}
	
	function onAfterSortChanged() {
	  if (!this.forPrint) {
	    this.api.ensureIndexVisible(0);
	  }
	  if (this.reduxCallback) {
	    var sortModel = this.api.getSortModel()[0];
	    this.reduxCallback({ sortModel: sortModel });
	  }
	  this.api.refreshRows(this.api.getRenderedNodes());
	}
	
	function getRowHeight(params) {
	  var footnoteFontString = 'normal 5px/0 Arial, sans-serif';
	  var fontStyleString = 'bold 13px/20px "Droid Sans", helvetica, sans-serif';
	  var rowDefaultHeight = 20;
	  var height = rowDefaultHeight;
	  var displayedColumns = params.api.columnController.allDisplayedColumns.reduce(function (acc, curr) {
	    return Object.assign(acc, _defineProperty({}, curr.colId, curr.colDef.width));
	  }, {});
	  Object.keys(params.node.data).filter(function (node) {
	    return displayedColumns.hasOwnProperty(node);
	  }).forEach(function (key) {
	    // Get normal width...
	    var width = (0, _util.getEstTextLength)(params.node.data[key], fontStyleString);
	    var string = params.node.data[key];
	    // In english:
	    //  footnoteCallback() & sortMobel() are both existing
	    //  current key is a geo (location/state)
	    //  sorted row is not geo (so geo is then ranked)
	    if (params.api.footnoteCallback && params.api.getSortModel && (key === 'Location' || key === 'State') && (params.api.getSortModel()[0] || { colId: null }).colId !== key) {
	      string = '1. ' + string;
	      width = (0, _util.getEstTextLength)(string, fontStyleString);
	    }
	
	    // Get footnotes
	    if (params.api.footnoteCallback) {
	      var footnotes = params.api.footnoteCallback([params.node.data[key], key]).map(function (_ref) {
	        var label = _ref.label;
	        return ' ' + label;
	      }).join(' ');
	      // 6 is a a magic number for the `/s` char
	      width = width + (0, _util.getEstTextLength)(footnotes, footnoteFontString) + 6;
	      string = string + ' ' + footnotes;
	    }
	
	    // For the edge case where there is a fraction of a pixel difference
	    // we want to see if the width difference is less than 1, not 0.
	    if (displayedColumns[key] - width < 1) {
	      // Lets actually calculate the height in this case so we know it will work fine.
	      var heightMultiplier = (0, _util.getEstTextRows)(string, fontStyleString, displayedColumns[key]);
	      height = Math.max(rowDefaultHeight * heightMultiplier, height);
	    }
	  });
	  return height + 10; // add padding
	}
	
	/**
	 * Set body size contain when needed based on visible columns
	 *
	 * @param  {array}  displayedColumns    Array of columns currently displayed in the table
	 */
	function setBodySize(table) {
	  // Container width needs to be set.
	  // Body width should only be set if it is more narrow
	  // than the overall table wrapper.
	  var displayedColumns = table.columnApi.getAllDisplayedColumns();
	  var containerWidth = _mori2.default.intoArray(_mori2.default.rest(displayedColumns)).reduce(function (acc, curr) {
	    return acc + curr.colDef.width;
	  }, 0);
	  var bodyWidth = displayedColumns[0].colDef.width + containerWidth;
	
	  table.api.gridPanel.eBodyContainer.style.width = containerWidth + 'px';
	
	  // We need to reset the width in order for headers and table
	  // to display correctly.
	  if (bodyWidth < document.querySelector('.table-wrapper').clientWidth) {
	    table.api.gridPanel.eBody.style.width = bodyWidth + 18 + 'px';
	  }
	}
	
	/**
	 * Resize Header
	 */
	function resizeHeader(params) {
	  var parentElm = this.api.gridCore.eGridDiv.offsetParent;
	
	  // If there are no 'with-group' headers, but we have 'no-group' headers,
	  // we need to adjust the parentHeight below
	  var adjustParentHeight = !!!parentElm.querySelector('.ag-header-group-cell-with-group') && !!parentElm.querySelector('.ag-header-group-cell-no-group');
	  // Used to adjust parentHeight.  If our header container has more than
	  // 1 row, we're grouping headers.
	  var hasGroupedHeader = parentElm.querySelector('.ag-header-container').querySelectorAll('.ag-header-row').length > 1;
	  var fontStyleString = this.headerStyle ? this.headerStyle : 'bold 14px/20px "Droid Sans", helvetica, sans-serif';
	  var baseHeaderHeight = 20;
	  var heightAdjust = 10; // Adjustment for after height is calculated
	  var padding = 30;
	
	  var _reduce = (params.columns || []).reduce(function (_ref2, column) {
	    var header = _ref2.header,
	        parent = _ref2.parent;
	
	    if (column.children) {
	      // After header height calculation for parent/grouped row
	      var _heightMultiplier = (0, _util.getEstTextRows)(column.headerName, fontStyleString, column.children.reduce(function (acc, _ref3) {
	        var width = _ref3.width;
	        return acc + width;
	      }, 0) - 16);
	      var groupHeight = Math.max(parent, baseHeaderHeight * _heightMultiplier);
	      return {
	        // For each child, find the largest height for the header
	        header: column.children.reduce(function (acc, child) {
	          var childHeightMultiplier = (0, _util.getEstTextRows)(child.headerName, fontStyleString, child.width - padding);
	
	          return Math.max(acc, baseHeaderHeight * childHeightMultiplier);
	        }, header),
	        parent: groupHeight
	      };
	    }
	    // Else
	    var heightMultiplier = (0, _util.getEstTextRows)(column.headerName, fontStyleString, column.width - padding);
	    return {
	      header: Math.max(header, baseHeaderHeight * heightMultiplier),
	      parent: parent
	    };
	  }, { header: baseHeaderHeight, parent: 0 }),
	      headerHeight = _reduce.header,
	      parentHeight = _reduce.parent;
	
	  headerHeight += heightAdjust;
	
	  parentHeight = parentHeight !== 0 && parentHeight < baseHeaderHeight ? baseHeaderHeight + heightAdjust : parentHeight + (parentHeight !== 0 ? heightAdjust : 0);
	
	  // Sets value for parent height.  Used in maps tab where headers can
	  // get very tall if parentHeight is kept at 0.
	  parentHeight = adjustParentHeight && hasGroupedHeader ? baseHeaderHeight : parentHeight;
	
	  this.api.setHeaderHeight(parentHeight !== 0 ? (parentHeight + headerHeight) / 2 : headerHeight);
	
	  // If there is a parent height, we need to adjust node heights
	  // as AG-Grid does not handle this for us.
	  if (parentHeight !== 0) {
	    // Set parent height on first header row
	    [].forEach.call(parentElm.querySelectorAll('.ag-header-row:first-child'), function (row) {
	      return row.style.height = parentHeight + 'px';
	    });
	    // Set height and top on 2nd row below parent row
	    [].forEach.call(parentElm.querySelectorAll('.ag-header-row:last-child'), function (row) {
	      row.style.height = headerHeight + 'px';
	      row.style.top = parentHeight + 'px';
	
	      // If we are printing, we need to set height on
	      // All cells in the last row when there is a parent row.
	      if (params.forPrint) {
	        [].forEach.call(row.querySelectorAll('.ag-header-cell'), function (cell) {
	          return cell.style.height = headerHeight + 'px';
	        });
	      }
	    });
	
	    if (params.forPrint) {
	      [].forEach.call(parentElm.querySelectorAll('.ag-header-group-cell-with-group'), function (groupHeader) {
	        return groupHeader.style.height = parentHeight + 'px';
	      });
	    }
	  }
	
	  return parentHeight + headerHeight;
	}
	
	/**
	 * Get and set the table data
	 */
	function getData(sheetData, options, filteredData, combinedFilters) {
	  var data = _mori2.default.toJs(_dataFromOptions.buildTable.apply(undefined, [sheetData, options, filteredData].concat(_toConsumableArray(combinedFilters))));
	
	  return {
	    'rowData': data.tableData.rowData,
	    'columnDefs': data.tableData.columnDefs
	  };
	}
	
	/**
	 * See if the table actually needs to be rebuilt, uses the tablehash var
	 * 1. Change of timeframe
	 * 2. Change of datatype
	 * 3. Change of Tab (Timeframe's changing signal this due to length)
	 *   a. Table/Map -> Graph
	 *   b. Graph -> Table/Map
	 * @param  {string}  view    the current tab view ('graph', 'map', 'table')
	 * @param  {object}  filters the combined filters
	 * @return {Boolean}
	 */
	function isTableDirty(timeframes, filters) {
	  var tempHash = _mori2.default.hash(_mori2.default.into(_mori2.default.vector(filters[0]), _mori2.default.into(_mori2.default.vector(filters[3]), _mori2.default.reduce(function (acc, item) {
	    return _mori2.default.conj(acc, _mori2.default.first(item));
	  }, _mori2.default.vector(), timeframes))));
	
	  if (this.tableHash && this.tableHash === tempHash) {
	    return false;
	  }
	  this.tableHash = tempHash;
	  return true;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(defaultHeight, 'defaultHeight', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(filterData, 'filterData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(filterDistributions, 'filterDistributions', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(doesExternalFilterPass, 'doesExternalFilterPass', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(tableSetup, 'tableSetup', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(onAfterFilterChanged, 'onAfterFilterChanged', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(onAfterSortChanged, 'onAfterSortChanged', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(getRowHeight, 'getRowHeight', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(setBodySize, 'setBodySize', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(resizeHeader, 'resizeHeader', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(getData, 'getData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(isTableDirty, 'isTableDirty', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	}();

	;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = loadData;
	
	var _mori = __webpack_require__(65);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _dataReducer = __webpack_require__(284);
	
	var _dataFromOptions = __webpack_require__(285);
	
	var _getCombinedFilters = __webpack_require__(286);
	
	var _getCombinedFilters2 = _interopRequireDefault(_getCombinedFilters);
	
	var _types = __webpack_require__(87);
	
	var _updateData2 = __webpack_require__(197);
	
	var _updateData3 = _interopRequireDefault(_updateData2);
	
	var _actions = __webpack_require__(117);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function loadData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	
	  return function (dispatch) {
	    dispatch((0, _actions2.default)(_types.REQUEST_DATA));
	    var state = _extends({}, (0, _dataReducer.buildSpreadsheetData)(data));
	    state.filteredData = (0, _dataFromOptions.filterByTimeframe)(state, {});
	    state.combinedFilters = (0, _getCombinedFilters2.default)(state, {});
	    state.isMultiGeo = _mori2.default.get(state.combinedFilters[4], [1], false);
	    state.type = type;
	
	    var selectedDistribution = _mori2.default.toJs(_mori2.default.first(state.immutableDistributions)).slug;
	
	    var _updateData = (0, _updateData3.default)(state, {}),
	        table = _updateData.table,
	        datamap = _updateData.datamap;
	
	    dispatch((0, _actions2.default)(_types.RECEIVE_DATA, _extends({
	      sheetData: data
	    }, state, {
	      table: table,
	      datamap: datamap,
	      type: type,
	      selectedDistribution: selectedDistribution
	    })));
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(loadData, 'loadData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/actions/loadData.js');
	}();

	;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateData;
	
	var _mori = __webpack_require__(65);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _tableData = __webpack_require__(195);
	
	var _tableData2 = _interopRequireDefault(_tableData);
	
	var _getFootnotes = __webpack_require__(288);
	
	var _getFootnotes2 = _interopRequireDefault(_getFootnotes);
	
	var _footnoteCallback = __webpack_require__(287);
	
	var _footnoteCallback2 = _interopRequireDefault(_footnoteCallback);
	
	var _mapData = __webpack_require__(290);
	
	var _mapData2 = _interopRequireDefault(_mapData);
	
	var _getSelectedDistributions = __webpack_require__(289);
	
	var _getSelectedDistributions2 = _interopRequireDefault(_getSelectedDistributions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Update map/table data as needed
	 * @param  {Object} state current state, needs to have filteredData,
	 *                        combinedFilter, isMultiGeo, type attached
	 * @return {Object}       data updates
	 */
	function updateData(state) {
	  var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var tableProps = {};
	  var datamapProps = null;
	  var filteredData = state.filteredData,
	      combinedFilters = state.combinedFilters,
	      isMultiGeo = state.isMultiGeo,
	      type = state.type;
	
	
	  if (!filteredData || !combinedFilters || !type) {
	    /* eslint-disable */
	    console.error = console.error || console.log || function log() {};
	    console.error('Something happened, updateData() should only be called after data has been ran loaded properly');
	    /* eslint-enable */
	    return {};
	  }
	
	  // Currently footnotes on data export is not implemented.
	  // That said, we need to get the footnotes at least setup so data
	  // will render correctly in downloadCSV.js
	  var footnotes = (0, _getFootnotes2.default)(state, update, filteredData, combinedFilters);
	
	  function footnoteCb(key) {
	    return (0, _footnoteCallback2.default)(key, footnotes.labeledFootnotes, !!(update.currentTimeframe && update.startTimeframe));
	  }
	
	  tableProps.footnoteCallback = footnoteCb;
	
	  if ('all' === type || 'table' === type) {
	    _tableData2.default.bind(tableProps)(state, update, filteredData, [_mori2.default.set(), // All columns
	    _mori2.default.concat(_mori2.default.vector(state.combinedFilters[4][0]), (0, _getSelectedDistributions2.default)(state, state.immutableDistributions, state.globalSettings.hasDataviews && !_mori2.default.getIn(state.config, ['globalRules', 'Locked'], false) ? _mori2.default.nth(state.immutableDataviews, 0) : false)), state.immutableDistributions, combinedFilters[3], combinedFilters[4]], function () {}, // Ready callback... (not neede right now)
	    combinedFilters[0], // Selected Keys
	    isMultiGeo, function () {} // render.getFootnotes
	    );
	  }
	
	  if ('all' === type || 'map' === type) {
	    datamapProps = _mapData2.default.apply(undefined, [state, update, false, // Represents the treeContextSlug in Datacenter - not needed here.
	    filteredData].concat(_toConsumableArray(state.combinedFilters)));
	  }
	  return {
	    table: tableProps,
	    datamap: datamapProps
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(updateData, 'updateData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/services/updateData.js');
	}();

	;

/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports) {

	/**
	 * angular-slugify -- provides slugification for AngularJS
	 *
	 * Copyright © 2013 Paul Smith <paulsmith@pobox.com>
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the “Software”), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	(function() {
	    "use strict";
	
	    var mod = angular.module("slugifier", []);
	
	    // Unicode (non-control) characters in the Latin-1 Supplement and Latin
	    // Extended-A blocks, transliterated into ASCII characters.
	    var charmap = {
	        ' ': " ",
	        '¡': "!",
	        '¢': "c",
	        '£': "lb",
	        '¥': "yen",
	        '¦': "|",
	        '§': "SS",
	        '¨': "\"",
	        '©': "(c)",
	        'ª': "a",
	        '«': "<<",
	        '¬': "not",
	        '­': "-",
	        '®': "(R)",
	        '°': "^0",
	        '±': "+/-",
	        '²': "^2",
	        '³': "^3",
	        '´': "'",
	        'µ': "u",
	        '¶': "P",
	        '·': ".",
	        '¸': ",",
	        '¹': "^1",
	        'º': "o",
	        '»': ">>",
	        '¼': " 1/4 ",
	        '½': " 1/2 ",
	        '¾': " 3/4 ",
	        '¿': "?",
	        'À': "`A",
	        'Á': "'A",
	        'Â': "^A",
	        'Ã': "~A",
	        'Ä': '"A',
	        'Å': "A",
	        'Æ': "AE",
	        'Ç': "C",
	        'È': "`E",
	        'É': "'E",
	        'Ê': "^E",
	        'Ë': '"E',
	        'Ì': "`I",
	        'Í': "'I",
	        'Î': "^I",
	        'Ï': '"I',
	        'Ð': "D",
	        'Ñ': "~N",
	        'Ò': "`O",
	        'Ó': "'O",
	        'Ô': "^O",
	        'Õ': "~O",
	        'Ö': '"O',
	        '×': "x",
	        'Ø': "O",
	        'Ù': "`U",
	        'Ú': "'U",
	        'Û': "^U",
	        'Ü': '"U',
	        'Ý': "'Y",
	        'Þ': "Th",
	        'ß': "ss",
	        'à': "`a",
	        'á': "'a",
	        'â': "^a",
	        'ã': "~a",
	        'ä': '"a',
	        'å': "a",
	        'æ': "ae",
	        'ç': "c",
	        'è': "`e",
	        'é': "'e",
	        'ê': "^e",
	        'ë': '"e',
	        'ì': "`i",
	        'í': "'i",
	        'î': "^i",
	        'ï': '"i',
	        'ð': "d",
	        'ñ': "~n",
	        'ò': "`o",
	        'ó': "'o",
	        'ô': "^o",
	        'õ': "~o",
	        'ö': '"o',
	        '÷': ":",
	        'ø': "o",
	        'ù': "`u",
	        'ú': "'u",
	        'û': "^u",
	        'ü': '"u',
	        'ý': "'y",
	        'þ': "th",
	        'ÿ': '"y',
	        'Ā': "A",
	        'ā': "a",
	        'Ă': "A",
	        'ă': "a",
	        'Ą': "A",
	        'ą': "a",
	        'Ć': "'C",
	        'ć': "'c",
	        'Ĉ': "^C",
	        'ĉ': "^c",
	        'Ċ': "C",
	        'ċ': "c",
	        'Č': "C",
	        'č': "c",
	        'Ď': "D",
	        'ď': "d",
	        'Đ': "D",
	        'đ': "d",
	        'Ē': "E",
	        'ē': "e",
	        'Ĕ': "E",
	        'ĕ': "e",
	        'Ė': "E",
	        'ė': "e",
	        'Ę': "E",
	        'ę': "e",
	        'Ě': "E",
	        'ě': "e",
	        'Ĝ': "^G",
	        'ĝ': "^g",
	        'Ğ': "G",
	        'ğ': "g",
	        'Ġ': "G",
	        'ġ': "g",
	        'Ģ': "G",
	        'ģ': "g",
	        'Ĥ': "^H",
	        'ĥ': "^h",
	        'Ħ': "H",
	        'ħ': "h",
	        'Ĩ': "~I",
	        'ĩ': "~i",
	        'Ī': "I",
	        'ī': "i",
	        'Ĭ': "I",
	        'ĭ': "i",
	        'Į': "I",
	        'į': "i",
	        'İ': "I",
	        'ı': "i",
	        'Ĳ': "IJ",
	        'ĳ': "ij",
	        'Ĵ': "^J",
	        'ĵ': "^j",
	        'Ķ': "K",
	        'ķ': "k",
	        'Ĺ': "L",
	        'ĺ': "l",
	        'Ļ': "L",
	        'ļ': "l",
	        'Ľ': "L",
	        'ľ': "l",
	        'Ŀ': "L",
	        'ŀ': "l",
	        'Ł': "L",
	        'ł': "l",
	        'Ń': "'N",
	        'ń': "'n",
	        'Ņ': "N",
	        'ņ': "n",
	        'Ň': "N",
	        'ň': "n",
	        'ŉ': "'n",
	        'Ō': "O",
	        'ō': "o",
	        'Ŏ': "O",
	        'ŏ': "o",
	        'Ő': '"O',
	        'ő': '"o',
	        'Œ': "OE",
	        'œ': "oe",
	        'Ŕ': "'R",
	        'ŕ': "'r",
	        'Ŗ': "R",
	        'ŗ': "r",
	        'Ř': "R",
	        'ř': "r",
	        'Ś': "'S",
	        'ś': "'s",
	        'Ŝ': "^S",
	        'ŝ': "^s",
	        'Ş': "S",
	        'ş': "s",
	        'Š': "S",
	        'š': "s",
	        'Ţ': "T",
	        'ţ': "t",
	        'Ť': "T",
	        'ť': "t",
	        'Ŧ': "T",
	        'ŧ': "t",
	        'Ũ': "~U",
	        'ũ': "~u",
	        'Ū': "U",
	        'ū': "u",
	        'Ŭ': "U",
	        'ŭ': "u",
	        'Ů': "U",
	        'ů': "u",
	        'Ű': '"U',
	        'ű': '"u',
	        'Ų': "U",
	        'ų': "u",
	        'Ŵ': "^W",
	        'ŵ': "^w",
	        'Ŷ': "^Y",
	        'ŷ': "^y",
	        'Ÿ': '"Y',
	        'Ź': "'Z",
	        'ź': "'z",
	        'Ż': "Z",
	        'ż': "z",
	        'Ž': "Z",
	        'ž': "z",
	        'ſ': "s"
	    };
	
	    function _slugify(s) {
	        if (!s) return "";
	        var ascii = [];
	        var ch, cp;
	        for (var i = 0; i < s.length; i++) {
	            if ((cp = s.charCodeAt(i)) < 0x180) {
	                ch = String.fromCharCode(cp);
	                ascii.push(charmap[ch] || ch);
	            }
	        }
	        s = ascii.join("");
	        s = s.replace(/[^\w\s-]/g, "").trim().toLowerCase();
	        return s.replace(/[-\s]+/g, "-");
	    }
	
	    mod.factory("Slug", function() {
	        return {
	            slugify: _slugify
	        };
	    });
	
	    mod.directive("slug", ["Slug", function(Slug) {
	        return {
	            restrict: "E",
	            scope: {
	                to: "=",
	            },
	            transclude: true,
	            replace: true,
	            template: "<div ng-transclude></div>",
	            link: function(scope, elem, attrs) {
	                if (!attrs.from) {
	                    throw "must set attribute 'from'";
	                }
	                scope.$parent.$watch(attrs.from, function(val) {
	                    scope.to = Slug.slugify(val);
	                });
	            }
	        };
	    }]);
	
	    mod.filter("slugify", ["Slug", function(Slug) {
	        return function(input) {
	            return Slug.slugify(input);
	        };
	    }]);
	})();


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	//TODO - this was brought from node_modules to fix a very simple MS Edge bug.
	// Once a fix is in place, revert back to node_modules and update
	
	// Updated regex on Line 254
	// if ( ! /((MSIE)|(Trident)|(Edge))/.test(navigator.userAgent) ) {
	
	(function () {
	    var svg;
	
	    //save off default references
	    var d3 = window.d3,
	        topojson = window.topojson;
	
	    var defaultOptions = {
	        scope: 'world',
	        responsive: false,
	        aspectRatio: 0.5625,
	        setProjection: setProjection,
	        projection: 'equirectangular',
	        dataType: 'json',
	        data: {},
	        done: function done() {},
	        fills: {
	            defaultFill: '#ABDDA4'
	        },
	        filters: {},
	        geographyConfig: {
	            dataUrl: null,
	            hideAntarctica: true,
	            hideHawaiiAndAlaska: false,
	            borderWidth: 1,
	            borderOpacity: 1,
	            borderColor: '#FDFDFD',
	            popupTemplate: function popupTemplate(geography, data) {
	                return '<div class="hoverinfo"><strong>' + geography.properties.name + '</strong></div>';
	            },
	            popupOnHover: true,
	            highlightOnHover: true,
	            highlightFillColor: '#FC8D59',
	            highlightBorderColor: 'rgba(250, 15, 160, 0.2)',
	            highlightBorderWidth: 2,
	            highlightBorderOpacity: 1
	        },
	        projectionConfig: {
	            rotation: [97, 0]
	        },
	        bubblesConfig: {
	            borderWidth: 2,
	            borderOpacity: 1,
	            borderColor: '#FFFFFF',
	            popupOnHover: true,
	            radius: null,
	            popupTemplate: function popupTemplate(geography, data) {
	                return '<div class="hoverinfo"><strong>' + data.name + '</strong></div>';
	            },
	            fillOpacity: 0.75,
	            animate: true,
	            highlightOnHover: true,
	            highlightFillColor: '#FC8D59',
	            highlightBorderColor: 'rgba(250, 15, 160, 0.2)',
	            highlightBorderWidth: 2,
	            highlightBorderOpacity: 1,
	            highlightFillOpacity: 0.85,
	            exitDelay: 100,
	            key: JSON.stringify
	        },
	        arcConfig: {
	            strokeColor: '#DD1C77',
	            strokeWidth: 1,
	            arcSharpness: 1,
	            animationSpeed: 600
	        }
	    };
	
	    /*
	      Getter for value. If not declared on datumValue, look up the chain into optionsValue
	    */
	    function val(datumValue, optionsValue, context) {
	        if (typeof context === 'undefined') {
	            context = optionsValue;
	            optionsValues = undefined;
	        }
	        var value = typeof datumValue !== 'undefined' ? datumValue : optionsValue;
	
	        if (typeof value === 'undefined') {
	            return null;
	        }
	
	        if (typeof value === 'function') {
	            var fnContext = [context];
	            if (context.geography) {
	                fnContext = [context.geography, context.data];
	            }
	            return value.apply(null, fnContext);
	        } else {
	            return value;
	        }
	    }
	
	    function addContainer(element, height, width) {
	        this.svg = d3.select(element).append('svg').attr('width', width || element.offsetWidth).attr('data-width', width || element.offsetWidth).attr('class', 'datamap').attr('height', height || element.offsetHeight).style('overflow', 'hidden'); // IE10+ doesn't respect height/width when map is zoomed in
	
	        if (this.options.responsive) {
	            d3.select(this.options.element).style({ 'position': 'relative', 'padding-bottom': this.options.aspectRatio * 100 + '%' });
	            d3.select(this.options.element).select('svg').style({ 'position': 'absolute', 'width': '100%', 'height': '100%' });
	            d3.select(this.options.element).select('svg').select('g').selectAll('path').style('vector-effect', 'non-scaling-stroke');
	        }
	
	        return this.svg;
	    }
	
	    // setProjection takes the svg element and options
	    function setProjection(element, options) {
	        var width = options.width || element.offsetWidth;
	        var height = options.height || element.offsetHeight;
	        var projection, path;
	        var svg = this.svg;
	
	        if (options && typeof options.scope === 'undefined') {
	            options.scope = 'world';
	        }
	
	        if (options.scope === 'usa') {
	            projection = d3.geo.albersUsa().scale(width).translate([width / 2, height / 2]);
	        } else if (options.scope === 'world') {
	            projection = d3.geo[options.projection]().scale((width + 1) / 2 / Math.PI).translate([width / 2, height / (options.projection === "mercator" ? 1.45 : 1.8)]);
	        }
	
	        if (options.projection === 'orthographic') {
	
	            svg.append("defs").append("path").datum({ type: "Sphere" }).attr("id", "sphere").attr("d", path);
	
	            svg.append("use").attr("class", "stroke").attr("xlink:href", "#sphere");
	
	            svg.append("use").attr("class", "fill").attr("xlink:href", "#sphere");
	            projection.scale(250).clipAngle(90).rotate(options.projectionConfig.rotation);
	        }
	
	        path = d3.geo.path().projection(projection);
	
	        return { path: path, projection: projection };
	    }
	
	    function addStyleBlock() {
	        if (d3.select('.datamaps-style-block').empty()) {
	            d3.select('head').append('style').attr('class', 'datamaps-style-block').html('.datamap path.datamaps-graticule { fill: none; stroke: #777; stroke-width: 0.5px; stroke-opacity: .5; pointer-events: none; } .datamap .labels {pointer-events: none;} .datamap path {stroke: #FFFFFF; stroke-width: 1px;} .datamaps-legend dt, .datamaps-legend dd { float: left; margin: 0 3px 0 0;} .datamaps-legend dd {width: 20px; margin-right: 6px; border-radius: 3px;} .datamaps-legend {padding-bottom: 20px; z-index: 1001; position: absolute; left: 4px; font-size: 12px; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;} .datamaps-hoverover {display: none; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; } .hoverinfo {padding: 4px; border-radius: 1px; background-color: #FFF; box-shadow: 1px 1px 5px #CCC; font-size: 12px; border: 1px solid #CCC; } .hoverinfo hr {border:1px dotted #CCC; }');
	        }
	    }
	
	    function drawSubunits(data) {
	        var fillData = this.options.fills,
	            colorCodeData = this.options.data || {},
	            geoConfig = this.options.geographyConfig;
	
	        var subunits = this.svg.select('g.datamaps-subunits');
	        if (subunits.empty()) {
	            subunits = this.addLayer('datamaps-subunits', null, true);
	        }
	
	        var geoData = topojson.feature(data, data.objects[this.options.scope]).features;
	        if (geoConfig.hideAntarctica) {
	            geoData = geoData.filter(function (feature) {
	                return feature.id !== "ATA";
	            });
	        }
	
	        if (geoConfig.hideHawaiiAndAlaska) {
	            geoData = geoData.filter(function (feature) {
	                return feature.id !== "HI" && feature.id !== 'AK';
	            });
	        }
	
	        var geo = subunits.selectAll('path.datamaps-subunit').data(geoData);
	
	        geo.enter().append('path').attr('d', this.path).attr('class', function (d) {
	            return 'datamaps-subunit ' + d.id;
	        }).attr('data-info', function (d) {
	            return JSON.stringify(colorCodeData[d.id]);
	        }).style('fill', function (d) {
	            //if fillKey - use that
	            //otherwise check 'fill'
	            //otherwise check 'defaultFill'
	            var fillColor;
	
	            var datum = colorCodeData[d.id];
	            if (datum && datum.fillKey) {
	                fillColor = fillData[val(datum.fillKey, { data: colorCodeData[d.id], geography: d })];
	            }
	
	            if (typeof fillColor === 'undefined') {
	                fillColor = val(datum && datum.fillColor, fillData.defaultFill, { data: colorCodeData[d.id], geography: d });
	            }
	
	            return fillColor;
	        }).style('stroke-width', geoConfig.borderWidth).style('stroke-opacity', geoConfig.borderOpacity).style('stroke', geoConfig.borderColor);
	    }
	
	    function handleGeographyConfig() {
	        var hoverover;
	        var svg = this.svg;
	        var self = this;
	        var options = this.options.geographyConfig;
	
	        if (options.highlightOnHover || options.popupOnHover) {
	            svg.selectAll('.datamaps-subunit').on('mouseover', function (d) {
	                var $this = d3.select(this);
	                var datum = self.options.data[d.id] || {};
	                if (options.highlightOnHover) {
	                    var previousAttributes = {
	                        'fill': $this.style('fill'),
	                        'stroke': $this.style('stroke'),
	                        'stroke-width': $this.style('stroke-width'),
	                        'fill-opacity': $this.style('fill-opacity')
	                    };
	
	                    $this.style('fill', val(datum.highlightFillColor, options.highlightFillColor, datum)).style('stroke', val(datum.highlightBorderColor, options.highlightBorderColor, datum)).style('stroke-width', val(datum.highlightBorderWidth, options.highlightBorderWidth, datum)).style('stroke-opacity', val(datum.highlightBorderOpacity, options.highlightBorderOpacity, datum)).style('fill-opacity', val(datum.highlightFillOpacity, options.highlightFillOpacity, datum)).attr('data-previousAttributes', JSON.stringify(previousAttributes));
	
	                    //as per discussion on https://github.com/markmarkoh/datamaps/issues/19
	                    if (!/((MSIE)|(Trident)|(Edge))/.test(navigator.userAgent)) {
	                        moveToFront.call(this);
	                    }
	                }
	
	                if (options.popupOnHover) {
	                    self.updatePopup($this, d, options, svg);
	                }
	            }).on('mouseout', function () {
	                var $this = d3.select(this);
	
	                if (options.highlightOnHover) {
	                    //reapply previous attributes
	                    var previousAttributes = JSON.parse($this.attr('data-previousAttributes'));
	                    for (var attr in previousAttributes) {
	                        $this.style(attr, previousAttributes[attr]);
	                    }
	                }
	                $this.on('mousemove', null);
	                d3.selectAll('.datamaps-hoverover').style('display', 'none');
	            });
	        }
	
	        function moveToFront() {
	            this.parentNode.appendChild(this);
	        }
	    }
	
	    //plugin to add a simple map legend
	    function addLegend(layer, data, options) {
	        data = data || {};
	        if (!this.options.fills) {
	            return;
	        }
	
	        var html = '<dl>';
	        var label = '';
	        if (data.legendTitle) {
	            html = '<h2>' + data.legendTitle + '</h2>' + html;
	        }
	        for (var fillKey in this.options.fills) {
	
	            if (fillKey === 'defaultFill') {
	                if (!data.defaultFillName) {
	                    continue;
	                }
	                label = data.defaultFillName;
	            } else {
	                if (data.labels && data.labels[fillKey]) {
	                    label = data.labels[fillKey];
	                } else {
	                    label = fillKey + ': ';
	                }
	            }
	            html += '<dt>' + label + '</dt>';
	            html += '<dd style="background-color:' + this.options.fills[fillKey] + '">&nbsp;</dd>';
	        }
	        html += '</dl>';
	
	        var hoverover = d3.select(this.options.element).append('div').attr('class', 'datamaps-legend').html(html);
	    }
	
	    function addGraticule(layer, options) {
	        var graticule = d3.geo.graticule();
	        this.svg.insert("path", '.datamaps-subunits').datum(graticule).attr("class", "datamaps-graticule").attr("d", this.path);
	    }
	
	    function handleArcs(layer, data, options) {
	        var self = this,
	            svg = this.svg;
	
	        if (!data || data && !data.slice) {
	            throw "Datamaps Error - arcs must be an array";
	        }
	
	        // For some reason arc options were put in an `options` object instead of the parent arc
	        // I don't like this, so to match bubbles and other plugins I'm moving it
	        // This is to keep backwards compatability
	        for (var i = 0; i < data.length; i++) {
	            data[i] = defaults(data[i], data[i].options);
	            delete data[i].options;
	        }
	
	        if (typeof options === "undefined") {
	            options = defaultOptions.arcConfig;
	        }
	
	        var arcs = layer.selectAll('path.datamaps-arc').data(data, JSON.stringify);
	
	        var path = d3.geo.path().projection(self.projection);
	
	        arcs.enter().append('svg:path').attr('class', 'datamaps-arc').style('stroke-linecap', 'round').style('stroke', function (datum) {
	            return val(datum.strokeColor, options.strokeColor, datum);
	        }).style('fill', 'none').style('stroke-width', function (datum) {
	            return val(datum.strokeWidth, options.strokeWidth, datum);
	        }).attr('d', function (datum) {
	            var originXY = self.latLngToXY(val(datum.origin.latitude, datum), val(datum.origin.longitude, datum));
	            var destXY = self.latLngToXY(val(datum.destination.latitude, datum), val(datum.destination.longitude, datum));
	            var midXY = [(originXY[0] + destXY[0]) / 2, (originXY[1] + destXY[1]) / 2];
	            if (options.greatArc) {
	                // TODO: Move this to inside `if` clause when setting attr `d`
	                var greatArc = d3.geo.greatArc().source(function (d) {
	                    return [val(d.origin.longitude, d), val(d.origin.latitude, d)];
	                }).target(function (d) {
	                    return [val(d.destination.longitude, d), val(d.destination.latitude, d)];
	                });
	
	                return path(greatArc(datum));
	            }
	            var sharpness = val(datum.arcSharpness, options.arcSharpness, datum);
	            return "M" + originXY[0] + ',' + originXY[1] + "S" + (midXY[0] + 50 * sharpness) + "," + (midXY[1] - 75 * sharpness) + "," + destXY[0] + "," + destXY[1];
	        }).attr('data-info', function (datum) {
	            return JSON.stringify(datum);
	        }).transition().delay(100).style('fill', function (datum) {
	            /*
	              Thank you Jake Archibald, this is awesome.
	              Source: http://jakearchibald.com/2013/animated-line-drawing-svg/
	            */
	            var length = this.getTotalLength();
	            this.style.transition = this.style.WebkitTransition = 'none';
	            this.style.strokeDasharray = length + ' ' + length;
	            this.style.strokeDashoffset = length;
	            this.getBoundingClientRect();
	            this.style.transition = this.style.WebkitTransition = 'stroke-dashoffset ' + val(datum.animationSpeed, options.animationSpeed, datum) + 'ms ease-out';
	            this.style.strokeDashoffset = '0';
	            return 'none';
	        });
	
	        arcs.exit().transition().style('opacity', 0).remove();
	    }
	
	    function handleLabels(layer, options) {
	        var self = this;
	        options = options || {};
	        var labelStartCoodinates = this.projection([-67.707617, 42.722131]);
	        this.svg.selectAll(".datamaps-subunit").attr("data-foo", function (d) {
	            var center = self.path.centroid(d);
	            var xOffset = 7.5,
	                yOffset = 5;
	
	            if (["FL", "KY", "MI"].indexOf(d.id) > -1) xOffset = -2.5;
	            if (d.id === "NY") xOffset = -1;
	            if (d.id === "MI") yOffset = 18;
	            if (d.id === "LA") xOffset = 13;
	
	            var x, y;
	
	            x = center[0] - xOffset;
	            y = center[1] + yOffset;
	
	            var smallStateIndex = ["VT", "NH", "MA", "RI", "CT", "NJ", "DE", "MD", "DC"].indexOf(d.id);
	            if (smallStateIndex > -1) {
	                var yStart = labelStartCoodinates[1];
	                x = labelStartCoodinates[0];
	                y = yStart + smallStateIndex * (2 + (options.fontSize || 12));
	                layer.append("line").attr("x1", x - 3).attr("y1", y - 5).attr("x2", center[0]).attr("y2", center[1]).style("stroke", options.labelColor || "#000").style("stroke-width", options.lineWidth || 1);
	            }
	
	            layer.append("text").attr("x", x).attr("y", y).style("font-size", (options.fontSize || 10) + 'px').style("font-family", options.fontFamily || "Verdana").style("fill", options.labelColor || "#000").text(function () {
	                if (options.customLabelText && options.customLabelText[d.id]) {
	                    return options.customLabelText[d.id];
	                } else {
	                    return d.id;
	                }
	            });
	
	            return "bar";
	        });
	    }
	
	    function handleBubbles(layer, data, options) {
	        var self = this,
	            fillData = this.options.fills,
	            filterData = this.options.filters,
	            svg = this.svg;
	
	        if (!data || data && !data.slice) {
	            throw "Datamaps Error - bubbles must be an array";
	        }
	
	        var bubbles = layer.selectAll('circle.datamaps-bubble').data(data, options.key);
	
	        bubbles.enter().append('svg:circle').attr('class', 'datamaps-bubble').attr('cx', function (datum) {
	            var latLng;
	            if (datumHasCoords(datum)) {
	                latLng = self.latLngToXY(datum.latitude, datum.longitude);
	            } else if (datum.centered) {
	                latLng = self.path.centroid(svg.select('path.' + datum.centered).data()[0]);
	            }
	            if (latLng) return latLng[0];
	        }).attr('cy', function (datum) {
	            var latLng;
	            if (datumHasCoords(datum)) {
	                latLng = self.latLngToXY(datum.latitude, datum.longitude);
	            } else if (datum.centered) {
	                latLng = self.path.centroid(svg.select('path.' + datum.centered).data()[0]);
	            }
	            if (latLng) return latLng[1];
	        }).attr('r', function (datum) {
	            // if animation enabled start with radius 0, otherwise use full size.
	            return options.animate ? 0 : val(datum.radius, options.radius, datum);
	        }).attr('data-info', function (datum) {
	            return JSON.stringify(datum);
	        }).attr('filter', function (datum) {
	            var filterKey = filterData[val(datum.filterKey, options.filterKey, datum)];
	
	            if (filterKey) {
	                return filterKey;
	            }
	        }).style('stroke', function (datum) {
	            return val(datum.borderColor, options.borderColor, datum);
	        }).style('stroke-width', function (datum) {
	            return val(datum.borderWidth, options.borderWidth, datum);
	        }).style('stroke-opacity', function (datum) {
	            return val(datum.borderOpacity, options.borderOpacity, datum);
	        }).style('fill-opacity', function (datum) {
	            return val(datum.fillOpacity, options.fillOpacity, datum);
	        }).style('fill', function (datum) {
	            var fillColor = fillData[val(datum.fillKey, options.fillKey, datum)];
	            return fillColor || fillData.defaultFill;
	        }).on('mouseover', function (datum) {
	            var $this = d3.select(this);
	
	            if (options.highlightOnHover) {
	                //save all previous attributes for mouseout
	                var previousAttributes = {
	                    'fill': $this.style('fill'),
	                    'stroke': $this.style('stroke'),
	                    'stroke-width': $this.style('stroke-width'),
	                    'fill-opacity': $this.style('fill-opacity')
	                };
	
	                $this.style('fill', val(datum.highlightFillColor, options.highlightFillColor, datum)).style('stroke', val(datum.highlightBorderColor, options.highlightBorderColor, datum)).style('stroke-width', val(datum.highlightBorderWidth, options.highlightBorderWidth, datum)).style('stroke-opacity', val(datum.highlightBorderOpacity, options.highlightBorderOpacity, datum)).style('fill-opacity', val(datum.highlightFillOpacity, options.highlightFillOpacity, datum)).attr('data-previousAttributes', JSON.stringify(previousAttributes));
	            }
	
	            if (options.popupOnHover) {
	                self.updatePopup($this, datum, options, svg);
	            }
	        }).on('mouseout', function (datum) {
	            var $this = d3.select(this);
	
	            if (options.highlightOnHover) {
	                //reapply previous attributes
	                var previousAttributes = JSON.parse($this.attr('data-previousAttributes'));
	                for (var attr in previousAttributes) {
	                    $this.style(attr, previousAttributes[attr]);
	                }
	            }
	
	            d3.selectAll('.datamaps-hoverover').style('display', 'none');
	        });
	
	        bubbles.transition().duration(400).attr('r', function (datum) {
	            return val(datum.radius, options.radius, datum);
	        }).transition().duration(0).attr('data-info', function (d) {
	            return JSON.stringify(d);
	        });
	
	        bubbles.exit().transition().delay(options.exitDelay).attr("r", 0).remove();
	
	        function datumHasCoords(datum) {
	            return typeof datum !== 'undefined' && typeof datum.latitude !== 'undefined' && typeof datum.longitude !== 'undefined';
	        }
	    }
	
	    //stolen from underscore.js
	    function defaults(obj) {
	        Array.prototype.slice.call(arguments, 1).forEach(function (source) {
	            if (source) {
	                for (var prop in source) {
	                    if (obj[prop] == null) obj[prop] = source[prop];
	                }
	            }
	        });
	        return obj;
	    }
	    /**************************************
	               Public Functions
	    ***************************************/
	
	    function Datamap(options) {
	
	        if (typeof d3 === 'undefined' || typeof topojson === 'undefined') {
	            throw new Error('Include d3.js (v3.0.3 or greater) and topojson on this page before creating a new map');
	        }
	        //set options for global use
	        this.options = defaults(options, defaultOptions);
	        this.options.geographyConfig = defaults(options.geographyConfig, defaultOptions.geographyConfig);
	        this.options.projectionConfig = defaults(options.projectionConfig, defaultOptions.projectionConfig);
	        this.options.bubblesConfig = defaults(options.bubblesConfig, defaultOptions.bubblesConfig);
	        this.options.arcConfig = defaults(options.arcConfig, defaultOptions.arcConfig);
	
	        //add the SVG container
	        if (d3.select(this.options.element).select('svg').length > 0) {
	            addContainer.call(this, this.options.element, this.options.height, this.options.width);
	        }
	
	        /* Add core plugins to this instance */
	        this.addPlugin('bubbles', handleBubbles);
	        this.addPlugin('legend', addLegend);
	        this.addPlugin('arc', handleArcs);
	        this.addPlugin('labels', handleLabels);
	        this.addPlugin('graticule', addGraticule);
	
	        //append style block with basic hoverover styles
	        if (!this.options.disableDefaultStyles) {
	            addStyleBlock();
	        }
	
	        return this.draw();
	    }
	
	    // resize map
	    Datamap.prototype.resize = function () {
	
	        var self = this;
	        var options = self.options;
	
	        if (options.responsive) {
	            var newsize = options.element.clientWidth,
	                oldsize = d3.select(options.element).select('svg').attr('data-width');
	
	            d3.select(options.element).select('svg').selectAll('g').attr('transform', 'scale(' + newsize / oldsize + ')');
	        }
	    };
	
	    // actually draw the features(states & countries)
	    Datamap.prototype.draw = function () {
	        //save off in a closure
	        var self = this;
	        var options = self.options;
	
	        //set projections and paths based on scope
	        var pathAndProjection = options.setProjection.apply(self, [options.element, options]);
	
	        this.path = pathAndProjection.path;
	        this.projection = pathAndProjection.projection;
	
	        //if custom URL for topojson data, retrieve it and render
	        if (options.geographyConfig.dataUrl) {
	            d3.json(options.geographyConfig.dataUrl, function (error, results) {
	                if (error) throw new Error(error);
	                self.customTopo = results;
	                draw(results);
	            });
	        } else {
	            draw(this[options.scope + 'Topo'] || options.geographyConfig.dataJson);
	        }
	
	        return this;
	
	        function draw(data) {
	            // if fetching remote data, draw the map first then call `updateChoropleth`
	            if (self.options.dataUrl) {
	                //allow for csv or json data types
	                d3[self.options.dataType](self.options.dataUrl, function (data) {
	                    //in the case of csv, transform data to object
	                    if (self.options.dataType === 'csv' && data && data.slice) {
	                        var tmpData = {};
	                        for (var i = 0; i < data.length; i++) {
	                            tmpData[data[i].id] = data[i];
	                        }
	                        data = tmpData;
	                    }
	                    Datamaps.prototype.updateChoropleth.call(self, data);
	                });
	            }
	            drawSubunits.call(self, data);
	            handleGeographyConfig.call(self);
	
	            if (self.options.geographyConfig.popupOnHover || self.options.bubblesConfig.popupOnHover) {
	                hoverover = d3.select(self.options.element).append('div').attr('class', 'datamaps-hoverover').style('z-index', 10001).style('position', 'absolute');
	            }
	
	            //fire off finished callback
	            self.options.done(self);
	        }
	    };
	    /**************************************
	                  TopoJSON
	    ***************************************/
	    Datamap.prototype.worldTopo = {
	        "type": "Topology",
	        "objects": {
	            "world": {
	                "type": "GeometryCollection",
	                "geometries": [{
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Afghanistan"
	                    },
	                    "id": "AFG",
	                    "arcs": [[0, 1, 2, 3, 4, 5]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Angola"
	                    },
	                    "id": "AGO",
	                    "arcs": [[[6, 7, 8, 9]], [[10, 11, 12]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Albania"
	                    },
	                    "id": "ALB",
	                    "arcs": [[13, 14, 15, 16, 17]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "United Arab Emirates"
	                    },
	                    "id": "ARE",
	                    "arcs": [[18, 19, 20, 21, 22]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Argentina"
	                    },
	                    "id": "ARG",
	                    "arcs": [[[23, 24]], [[25, 26, 27, 28, 29, 30]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Armenia"
	                    },
	                    "id": "ARM",
	                    "arcs": [[31, 32, 33, 34, 35]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Antarctica"
	                    },
	                    "id": "ATA",
	                    "arcs": [[[36]], [[37]], [[38]], [[39]], [[40]], [[41]], [[42]], [[43]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "French Southern and Antarctic Lands"
	                    },
	                    "id": "ATF",
	                    "arcs": [[44]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Australia"
	                    },
	                    "id": "AUS",
	                    "arcs": [[[45]], [[46]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Austria"
	                    },
	                    "id": "AUT",
	                    "arcs": [[47, 48, 49, 50, 51, 52, 53]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Azerbaijan"
	                    },
	                    "id": "AZE",
	                    "arcs": [[[54, -35]], [[55, 56, -33, 57, 58]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Burundi"
	                    },
	                    "id": "BDI",
	                    "arcs": [[59, 60, 61]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Belgium"
	                    },
	                    "id": "BEL",
	                    "arcs": [[62, 63, 64, 65, 66]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Benin"
	                    },
	                    "id": "BEN",
	                    "arcs": [[67, 68, 69, 70, 71]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Burkina Faso"
	                    },
	                    "id": "BFA",
	                    "arcs": [[72, 73, 74, -70, 75, 76]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Bangladesh"
	                    },
	                    "id": "BGD",
	                    "arcs": [[77, 78, 79]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Bulgaria"
	                    },
	                    "id": "BGR",
	                    "arcs": [[80, 81, 82, 83, 84, 85]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "The Bahamas"
	                    },
	                    "id": "BHS",
	                    "arcs": [[[86]], [[87]], [[88]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Bosnia and Herzegovina"
	                    },
	                    "id": "BIH",
	                    "arcs": [[89, 90, 91]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Belarus"
	                    },
	                    "id": "BLR",
	                    "arcs": [[92, 93, 94, 95, 96]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Belize"
	                    },
	                    "id": "BLZ",
	                    "arcs": [[97, 98, 99]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Bolivia"
	                    },
	                    "id": "BOL",
	                    "arcs": [[100, 101, 102, 103, -31]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Brazil"
	                    },
	                    "id": "BRA",
	                    "arcs": [[-27, 104, -103, 105, 106, 107, 108, 109, 110, 111, 112]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Brunei"
	                    },
	                    "id": "BRN",
	                    "arcs": [[113, 114]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Bhutan"
	                    },
	                    "id": "BTN",
	                    "arcs": [[115, 116]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Botswana"
	                    },
	                    "id": "BWA",
	                    "arcs": [[117, 118, 119, 120]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Central African Republic"
	                    },
	                    "id": "CAF",
	                    "arcs": [[121, 122, 123, 124, 125, 126, 127]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Canada"
	                    },
	                    "id": "CAN",
	                    "arcs": [[[128]], [[129]], [[130]], [[131]], [[132]], [[133]], [[134]], [[135]], [[136]], [[137]], [[138, 139, 140, 141]], [[142]], [[143]], [[144]], [[145]], [[146]], [[147]], [[148]], [[149]], [[150]], [[151]], [[152]], [[153]], [[154]], [[155]], [[156]], [[157]], [[158]], [[159]], [[160]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Switzerland"
	                    },
	                    "id": "CHE",
	                    "arcs": [[-51, 161, 162, 163]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Chile"
	                    },
	                    "id": "CHL",
	                    "arcs": [[[-24, 164]], [[-30, 165, 166, -101]]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "China"
	                    },
	                    "id": "CHN",
	                    "arcs": [[[167]], [[168, 169, 170, 171, 172, 173, -117, 174, 175, 176, 177, -4, 178, 179, 180, 181, 182, 183]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Ivory Coast"
	                    },
	                    "id": "CIV",
	                    "arcs": [[184, 185, 186, 187, -73, 188]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Cameroon"
	                    },
	                    "id": "CMR",
	                    "arcs": [[189, 190, 191, 192, 193, 194, -128, 195]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Democratic Republic of the Congo"
	                    },
	                    "id": "COD",
	                    "arcs": [[196, 197, -60, 198, 199, -10, 200, -13, 201, -126, 202]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Republic of the Congo"
	                    },
	                    "id": "COG",
	                    "arcs": [[-12, 203, 204, -196, -127, -202]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Colombia"
	                    },
	                    "id": "COL",
	                    "arcs": [[205, 206, 207, 208, 209, -107, 210]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Costa Rica"
	                    },
	                    "id": "CRI",
	                    "arcs": [[211, 212, 213, 214]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Cuba"
	                    },
	                    "id": "CUB",
	                    "arcs": [[215]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Northern Cyprus"
	                    },
	                    "id": "-99",
	                    "arcs": [[216, 217]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Cyprus"
	                    },
	                    "id": "CYP",
	                    "arcs": [[218, -218]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Czech Republic"
	                    },
	                    "id": "CZE",
	                    "arcs": [[-53, 219, 220, 221]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Germany"
	                    },
	                    "id": "DEU",
	                    "arcs": [[222, 223, -220, -52, -164, 224, 225, -64, 226, 227, 228]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Djibouti"
	                    },
	                    "id": "DJI",
	                    "arcs": [[229, 230, 231, 232]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Denmark"
	                    },
	                    "id": "DNK",
	                    "arcs": [[[233]], [[-229, 234]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Dominican Republic"
	                    },
	                    "id": "DOM",
	                    "arcs": [[235, 236]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Algeria"
	                    },
	                    "id": "DZA",
	                    "arcs": [[237, 238, 239, 240, 241, 242, 243, 244]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Ecuador"
	                    },
	                    "id": "ECU",
	                    "arcs": [[245, -206, 246]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Egypt"
	                    },
	                    "id": "EGY",
	                    "arcs": [[247, 248, 249, 250, 251]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Eritrea"
	                    },
	                    "id": "ERI",
	                    "arcs": [[252, 253, 254, -233]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Spain"
	                    },
	                    "id": "ESP",
	                    "arcs": [[255, 256, 257, 258]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Estonia"
	                    },
	                    "id": "EST",
	                    "arcs": [[259, 260, 261]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Ethiopia"
	                    },
	                    "id": "ETH",
	                    "arcs": [[-232, 262, 263, 264, 265, 266, 267, -253]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Finland"
	                    },
	                    "id": "FIN",
	                    "arcs": [[268, 269, 270, 271]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Fiji"
	                    },
	                    "id": "FJI",
	                    "arcs": [[[272]], [[273, 274]], [[275, -275]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Falkland Islands"
	                    },
	                    "id": "FLK",
	                    "arcs": [[276]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "France"
	                    },
	                    "id": "FRA",
	                    "arcs": [[[277]], [[278, -225, -163, 279, 280, -257, 281, -66]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "French Guiana"
	                    },
	                    "id": "GUF",
	                    "arcs": [[282, 283, 284, 285, -111]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Gabon"
	                    },
	                    "id": "GAB",
	                    "arcs": [[286, 287, -190, -205]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "United Kingdom"
	                    },
	                    "id": "GBR",
	                    "arcs": [[[288, 289]], [[290]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Georgia"
	                    },
	                    "id": "GEO",
	                    "arcs": [[291, 292, -58, -32, 293]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Ghana"
	                    },
	                    "id": "GHA",
	                    "arcs": [[294, -189, -77, 295]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Guinea"
	                    },
	                    "id": "GIN",
	                    "arcs": [[296, 297, 298, 299, 300, 301, -187]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Gambia"
	                    },
	                    "id": "GMB",
	                    "arcs": [[302, 303]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Guinea Bissau"
	                    },
	                    "id": "GNB",
	                    "arcs": [[304, 305, -300]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Equatorial Guinea"
	                    },
	                    "id": "GNQ",
	                    "arcs": [[306, -191, -288]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Greece"
	                    },
	                    "id": "GRC",
	                    "arcs": [[[307]], [[308, -15, 309, -84, 310]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Greenland"
	                    },
	                    "id": "GRL",
	                    "arcs": [[311]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Guatemala"
	                    },
	                    "id": "GTM",
	                    "arcs": [[312, 313, -100, 314, 315, 316]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Guyana"
	                    },
	                    "id": "GUY",
	                    "arcs": [[317, 318, -109, 319]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Honduras"
	                    },
	                    "id": "HND",
	                    "arcs": [[320, 321, -316, 322, 323]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Croatia"
	                    },
	                    "id": "HRV",
	                    "arcs": [[324, -92, 325, 326, 327, 328]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Haiti"
	                    },
	                    "id": "HTI",
	                    "arcs": [[-237, 329]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Hungary"
	                    },
	                    "id": "HUN",
	                    "arcs": [[-48, 330, 331, 332, 333, -329, 334]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Indonesia"
	                    },
	                    "id": "IDN",
	                    "arcs": [[[335]], [[336, 337]], [[338]], [[339]], [[340]], [[341]], [[342]], [[343]], [[344, 345]], [[346]], [[347]], [[348, 349]], [[350]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "India"
	                    },
	                    "id": "IND",
	                    "arcs": [[-177, 351, -175, -116, -174, 352, -80, 353, 354]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Ireland"
	                    },
	                    "id": "IRL",
	                    "arcs": [[355, -289]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Iran"
	                    },
	                    "id": "IRN",
	                    "arcs": [[356, -6, 357, 358, 359, 360, -55, -34, -57, 361]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Iraq"
	                    },
	                    "id": "IRQ",
	                    "arcs": [[362, 363, 364, 365, 366, 367, -360]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Iceland"
	                    },
	                    "id": "ISL",
	                    "arcs": [[368]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Israel"
	                    },
	                    "id": "ISR",
	                    "arcs": [[369, 370, 371, -252, 372, 373, 374]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Italy"
	                    },
	                    "id": "ITA",
	                    "arcs": [[[375]], [[376]], [[377, 378, -280, -162, -50]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Jamaica"
	                    },
	                    "id": "JAM",
	                    "arcs": [[379]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Jordan"
	                    },
	                    "id": "JOR",
	                    "arcs": [[-370, 380, -366, 381, 382, -372, 383]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Japan"
	                    },
	                    "id": "JPN",
	                    "arcs": [[[384]], [[385]], [[386]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Kazakhstan"
	                    },
	                    "id": "KAZ",
	                    "arcs": [[387, 388, 389, 390, -181, 391]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Kenya"
	                    },
	                    "id": "KEN",
	                    "arcs": [[392, 393, 394, 395, -265, 396]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Kyrgyzstan"
	                    },
	                    "id": "KGZ",
	                    "arcs": [[-392, -180, 397, 398]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Cambodia"
	                    },
	                    "id": "KHM",
	                    "arcs": [[399, 400, 401, 402]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "South Korea"
	                    },
	                    "id": "KOR",
	                    "arcs": [[403, 404]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Kosovo"
	                    },
	                    "id": "-99",
	                    "arcs": [[-18, 405, 406, 407]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Kuwait"
	                    },
	                    "id": "KWT",
	                    "arcs": [[408, 409, -364]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Laos"
	                    },
	                    "id": "LAO",
	                    "arcs": [[410, 411, -172, 412, -401]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Lebanon"
	                    },
	                    "id": "LBN",
	                    "arcs": [[-374, 413, 414]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Liberia"
	                    },
	                    "id": "LBR",
	                    "arcs": [[415, 416, -297, -186]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Libya"
	                    },
	                    "id": "LBY",
	                    "arcs": [[417, -245, 418, 419, -250, 420, 421]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Sri Lanka"
	                    },
	                    "id": "LKA",
	                    "arcs": [[422]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Lesotho"
	                    },
	                    "id": "LSO",
	                    "arcs": [[423]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Lithuania"
	                    },
	                    "id": "LTU",
	                    "arcs": [[424, 425, 426, -93, 427]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Luxembourg"
	                    },
	                    "id": "LUX",
	                    "arcs": [[-226, -279, -65]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Latvia"
	                    },
	                    "id": "LVA",
	                    "arcs": [[428, -262, 429, -94, -427]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Morocco"
	                    },
	                    "id": "MAR",
	                    "arcs": [[-242, 430, 431]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Moldova"
	                    },
	                    "id": "MDA",
	                    "arcs": [[432, 433]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Madagascar"
	                    },
	                    "id": "MDG",
	                    "arcs": [[434]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Mexico"
	                    },
	                    "id": "MEX",
	                    "arcs": [[435, -98, -314, 436, 437]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Macedonia"
	                    },
	                    "id": "MKD",
	                    "arcs": [[-408, 438, -85, -310, -14]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Mali"
	                    },
	                    "id": "MLI",
	                    "arcs": [[439, -239, 440, -74, -188, -302, 441]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Myanmar"
	                    },
	                    "id": "MMR",
	                    "arcs": [[442, -78, -353, -173, -412, 443]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Montenegro"
	                    },
	                    "id": "MNE",
	                    "arcs": [[444, -326, -91, 445, -406, -17]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Mongolia"
	                    },
	                    "id": "MNG",
	                    "arcs": [[446, -183]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Mozambique"
	                    },
	                    "id": "MOZ",
	                    "arcs": [[447, 448, 449, 450, 451, 452, 453, 454]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Mauritania"
	                    },
	                    "id": "MRT",
	                    "arcs": [[455, 456, 457, -240, -440]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Malawi"
	                    },
	                    "id": "MWI",
	                    "arcs": [[-455, 458, 459]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Malaysia"
	                    },
	                    "id": "MYS",
	                    "arcs": [[[460, 461]], [[-349, 462, -115, 463]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Namibia"
	                    },
	                    "id": "NAM",
	                    "arcs": [[464, -8, 465, -119, 466]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "New Caledonia"
	                    },
	                    "id": "NCL",
	                    "arcs": [[467]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Niger"
	                    },
	                    "id": "NER",
	                    "arcs": [[-75, -441, -238, -418, 468, -194, 469, -71]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Nigeria"
	                    },
	                    "id": "NGA",
	                    "arcs": [[470, -72, -470, -193]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Nicaragua"
	                    },
	                    "id": "NIC",
	                    "arcs": [[471, -324, 472, -213]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Netherlands"
	                    },
	                    "id": "NLD",
	                    "arcs": [[-227, -63, 473]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Norway"
	                    },
	                    "id": "NOR",
	                    "arcs": [[[474, -272, 475, 476]], [[477]], [[478]], [[479]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Nepal"
	                    },
	                    "id": "NPL",
	                    "arcs": [[-352, -176]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "New Zealand"
	                    },
	                    "id": "NZL",
	                    "arcs": [[[480]], [[481]]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Oman"
	                    },
	                    "id": "OMN",
	                    "arcs": [[[482, 483, -22, 484]], [[-20, 485]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Pakistan"
	                    },
	                    "id": "PAK",
	                    "arcs": [[-178, -355, 486, -358, -5]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Panama"
	                    },
	                    "id": "PAN",
	                    "arcs": [[487, -215, 488, -208]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Peru"
	                    },
	                    "id": "PER",
	                    "arcs": [[-167, 489, -247, -211, -106, -102]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Philippines"
	                    },
	                    "id": "PHL",
	                    "arcs": [[[490]], [[491]], [[492]], [[493]], [[494]], [[495]], [[496]]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Papua New Guinea"
	                    },
	                    "id": "PNG",
	                    "arcs": [[[497]], [[498]], [[-345, 499]], [[500]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Poland"
	                    },
	                    "id": "POL",
	                    "arcs": [[-224, 501, 502, -428, -97, 503, 504, -221]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Puerto Rico"
	                    },
	                    "id": "PRI",
	                    "arcs": [[505]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "North Korea"
	                    },
	                    "id": "PRK",
	                    "arcs": [[506, 507, -405, 508, -169]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Portugal"
	                    },
	                    "id": "PRT",
	                    "arcs": [[-259, 509]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Paraguay"
	                    },
	                    "id": "PRY",
	                    "arcs": [[-104, -105, -26]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Qatar"
	                    },
	                    "id": "QAT",
	                    "arcs": [[510, 511]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Romania"
	                    },
	                    "id": "ROU",
	                    "arcs": [[512, -434, 513, 514, -81, 515, -333]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Russia"
	                    },
	                    "id": "RUS",
	                    "arcs": [[[516]], [[-503, 517, -425]], [[518, 519]], [[520]], [[521]], [[522]], [[523]], [[524]], [[525]], [[526, -507, -184, -447, -182, -391, 527, -59, -293, 528, 529, -95, -430, -261, 530, -269, -475, 531, -520]], [[532]], [[533]], [[534]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Rwanda"
	                    },
	                    "id": "RWA",
	                    "arcs": [[535, -61, -198, 536]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Western Sahara"
	                    },
	                    "id": "ESH",
	                    "arcs": [[-241, -458, 537, -431]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Saudi Arabia"
	                    },
	                    "id": "SAU",
	                    "arcs": [[538, -382, -365, -410, 539, -512, 540, -23, -484, 541]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Sudan"
	                    },
	                    "id": "SDN",
	                    "arcs": [[542, 543, -123, 544, -421, -249, 545, -254, -268, 546]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "South Sudan"
	                    },
	                    "id": "SSD",
	                    "arcs": [[547, -266, -396, 548, -203, -125, 549, -543]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Senegal"
	                    },
	                    "id": "SEN",
	                    "arcs": [[550, -456, -442, -301, -306, 551, -304]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Solomon Islands"
	                    },
	                    "id": "SLB",
	                    "arcs": [[[552]], [[553]], [[554]], [[555]], [[556]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Sierra Leone"
	                    },
	                    "id": "SLE",
	                    "arcs": [[557, -298, -417]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "El Salvador"
	                    },
	                    "id": "SLV",
	                    "arcs": [[558, -317, -322]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Somaliland"
	                    },
	                    "id": "-99",
	                    "arcs": [[-263, -231, 559, 560]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Somalia"
	                    },
	                    "id": "SOM",
	                    "arcs": [[-397, -264, -561, 561]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Republic of Serbia"
	                    },
	                    "id": "SRB",
	                    "arcs": [[-86, -439, -407, -446, -90, -325, -334, -516]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Suriname"
	                    },
	                    "id": "SUR",
	                    "arcs": [[562, -285, 563, -283, -110, -319]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Slovakia"
	                    },
	                    "id": "SVK",
	                    "arcs": [[-505, 564, -331, -54, -222]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Slovenia"
	                    },
	                    "id": "SVN",
	                    "arcs": [[-49, -335, -328, 565, -378]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Sweden"
	                    },
	                    "id": "SWE",
	                    "arcs": [[-476, -271, 566]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Swaziland"
	                    },
	                    "id": "SWZ",
	                    "arcs": [[567, -451]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Syria"
	                    },
	                    "id": "SYR",
	                    "arcs": [[-381, -375, -415, 568, 569, -367]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Chad"
	                    },
	                    "id": "TCD",
	                    "arcs": [[-469, -422, -545, -122, -195]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Togo"
	                    },
	                    "id": "TGO",
	                    "arcs": [[570, -296, -76, -69]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Thailand"
	                    },
	                    "id": "THA",
	                    "arcs": [[571, -462, 572, -444, -411, -400]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Tajikistan"
	                    },
	                    "id": "TJK",
	                    "arcs": [[-398, -179, -3, 573]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Turkmenistan"
	                    },
	                    "id": "TKM",
	                    "arcs": [[-357, 574, -389, 575, -1]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "East Timor"
	                    },
	                    "id": "TLS",
	                    "arcs": [[576, -337]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Trinidad and Tobago"
	                    },
	                    "id": "TTO",
	                    "arcs": [[577]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Tunisia"
	                    },
	                    "id": "TUN",
	                    "arcs": [[-244, 578, -419]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Turkey"
	                    },
	                    "id": "TUR",
	                    "arcs": [[[-294, -36, -361, -368, -570, 579]], [[-311, -83, 580]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Taiwan"
	                    },
	                    "id": "TWN",
	                    "arcs": [[581]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "United Republic of Tanzania"
	                    },
	                    "id": "TZA",
	                    "arcs": [[-394, 582, -448, -460, 583, -199, -62, -536, 584]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Uganda"
	                    },
	                    "id": "UGA",
	                    "arcs": [[-537, -197, -549, -395, -585]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Ukraine"
	                    },
	                    "id": "UKR",
	                    "arcs": [[-530, 585, -514, -433, -513, -332, -565, -504, -96]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Uruguay"
	                    },
	                    "id": "URY",
	                    "arcs": [[-113, 586, -28]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "United States of America"
	                    },
	                    "id": "USA",
	                    "arcs": [[[587]], [[588]], [[589]], [[590]], [[591]], [[592, -438, 593, -139]], [[594]], [[595]], [[596]], [[-141, 597]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Uzbekistan"
	                    },
	                    "id": "UZB",
	                    "arcs": [[-576, -388, -399, -574, -2]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Venezuela"
	                    },
	                    "id": "VEN",
	                    "arcs": [[598, -320, -108, -210]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Vietnam"
	                    },
	                    "id": "VNM",
	                    "arcs": [[599, -402, -413, -171]]
	                }, {
	                    "type": "MultiPolygon",
	                    "properties": {
	                        "name": "Vanuatu"
	                    },
	                    "id": "VUT",
	                    "arcs": [[[600]], [[601]]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "West Bank"
	                    },
	                    "id": "PSE",
	                    "arcs": [[-384, -371]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Yemen"
	                    },
	                    "id": "YEM",
	                    "arcs": [[602, -542, -483]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "South Africa"
	                    },
	                    "id": "ZAF",
	                    "arcs": [[-467, -118, 603, -452, -568, -450, 604], [-424]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Zambia"
	                    },
	                    "id": "ZMB",
	                    "arcs": [[-459, -454, 605, -120, -466, -7, -200, -584]]
	                }, {
	                    "type": "Polygon",
	                    "properties": {
	                        "name": "Zimbabwe"
	                    },
	                    "id": "ZWE",
	                    "arcs": [[-604, -121, -606, -453]]
	                }]
	            }
	        },
	        "arcs": [[[6700, 7164], [28, -23], [21, 8], [6, 27], [22, 9], [15, 18], [6, 47], [23, 11], [5, 21], [13, -15], [8, -2]], [[6847, 7265], [16, -1], [20, -12]], [[6883, 7252], [9, -7], [20, 19], [9, -12], [9, 27], [17, -1], [4, 9], [3, 24], [12, 20], [15, -13], [-3, -18], [9, -3], [-3, -50], [11, -19], [10, 12], [12, 6], [17, 27], [19, -5], [29, 0]], [[7082, 7268], [5, -17]], [[7087, 7251], [-16, -6], [-14, -11], [-32, -7], [-30, -13], [-16, -25], [6, -25], [4, -30], [-14, -25], [1, -22], [-8, -22], [-26, 2], [11, -39], [-18, -15], [-12, -35], [2, -36], [-11, -16], [-10, 5], [-22, -8], [-3, -16], [-20, 0], [-16, -34], [-1, -50], [-36, -24], [-19, 5], [-6, -13], [-16, 7], [-28, -8], [-47, 30]], [[6690, 6820], [25, 53], [-2, 38], [-21, 10], [-2, 38], [-9, 47], [12, 32], [-12, 9], [7, 43], [12, 74]], [[5664, 4412], [3, -18], [-4, -29], [5, -28], [-4, -22], [3, -20], [-58, 1], [-2, -188], [19, -49], [18, -37]], [[5644, 4022], [-51, -24], [-67, 9], [-19, 28], [-113, -3], [-4, -4], [-17, 27], [-18, 2], [-16, -10], [-14, -12]], [[5325, 4035], [-2, 38], [4, 51], [9, 55], [2, 25], [9, 53], [6, 24], [16, 39], [9, 26], [3, 44], [-1, 34], [-9, 21], [-7, 36], [-7, 35], [2, 12], [8, 24], [-8, 57], [-6, 39], [-14, 38], [3, 11]], [[5342, 4697], [11, 8], [8, -1], [10, 7], [82, -1], [7, -44], [8, -35], [6, -19], [11, -31], [18, 5], [9, 8], [16, -8], [4, 14], [7, 35], [17, 2], [2, 10], [14, 1], [-3, -22], [34, 1], [1, -37], [5, -23], [-4, -36], [2, -36], [9, -22], [-1, -70], [7, 5], [12, -1], [17, 8], [13, -3]], [[5338, 4715], [-8, 45]], [[5330, 4760], [12, 25], [8, 10], [10, -20]], [[5360, 4775], [-10, -12], [-4, -16], [-1, -25], [-7, -7]], [[5571, 7530], [-3, -20], [4, -25], [11, -15]], [[5583, 7470], [0, -15], [-9, -9], [-2, -19], [-13, -29]], [[5559, 7398], [-5, 5], [0, 13], [-15, 19], [-3, 29], [2, 40], [4, 18], [-4, 10]], [[5538, 7532], [-2, 18], [12, 29], [1, -11], [8, 6]], [[5557, 7574], [6, -16], [7, -6], [1, -22]], [[6432, 6490], [5, 3], [1, -16], [22, 9], [23, -2], [17, -1], [19, 39], [20, 38], [18, 37]], [[6557, 6597], [5, -20]], [[6562, 6577], [4, -47]], [[6566, 6530], [-14, 0], [-3, -39], [5, -8], [-12, -12], [0, -24], [-8, -24], [-1, -24]], [[6533, 6399], [-6, -12], [-83, 29], [-11, 60], [-1, 14]], [[3140, 1814], [-17, 2], [-30, 0], [0, 132]], [[3093, 1948], [11, -27], [14, -45], [36, -35], [39, -15], [-13, -30], [-26, -2], [-14, 20]], [[3258, 3743], [51, -96], [23, -9], [34, -44], [29, -23], [4, -26], [-28, -90], [28, -16], [32, -9], [22, 10], [25, 45], [4, 52]], [[3482, 3537], [14, 11], [14, -34], [-1, -47], [-23, -33], [-19, -24], [-31, -57], [-37, -81]], [[3399, 3272], [-7, -47], [-7, -61], [0, -58], [-6, -14], [-2, -38]], [[3377, 3054], [-2, -31], [35, -50], [-4, -41], [18, -26], [-2, -29], [-26, -75], [-42, -32], [-55, -12], [-31, 6], [6, -36], [-6, -44], [5, -30], [-16, -20], [-29, -8], [-26, 21], [-11, -15], [4, -59], [18, -18], [16, 19], [8, -31], [-26, -18], [-22, -37], [-4, -59], [-7, -32], [-26, 0], [-22, -31], [-8, -44], [28, -43], [26, -12], [-9, -53], [-33, -33], [-18, -70], [-25, -23], [-12, -28], [9, -61], [19, -34], [-12, 3]], [[3095, 1968], [-26, 9], [-67, 8], [-11, 34], [0, 45], [-18, -4], [-10, 21], [-3, 63], [22, 26], [9, 37], [-4, 30], [15, 51], [10, 78], [-3, 35], [12, 11], [-3, 22], [-13, 12], [10, 25], [-13, 22], [-6, 68], [11, 12], [-5, 72], [7, 61], [7, 52], [17, 22], [-9, 58], [0, 54], [21, 38], [-1, 50], [16, 57], [0, 55], [-7, 11], [-13, 102], [17, 60], [-2, 58], [10, 53], [18, 56], [20, 36], [-9, 24], [6, 19], [-1, 98], [30, 29], [10, 62], [-3, 14]], [[3136, 3714], [23, 54], [36, -15], [16, -42], [11, 47], [32, -2], [4, -13]], [[6210, 7485], [39, 9]], [[6249, 7494], [5, -15], [11, -10], [-6, -15], [15, -21], [-8, -18], [12, -16], [13, -10], [0, -41]], [[6291, 7348], [-10, -2]], [[6281, 7346], [-11, 34], [0, 10], [-12, -1], [-9, 16], [-5, -1]], [[6244, 7404], [-11, 17], [-21, 15], [3, 28], [-5, 21]], [[3345, 329], [-8, -30], [-8, -27], [-59, 8], [-62, -3], [-34, 20], [0, 2], [-16, 17], [63, -2], [60, -6], [20, 24], [15, 21], [29, -24]], [[577, 361], [-53, -8], [-36, 21], [-17, 21], [-1, 3], [-18, 16], [17, 22], [52, -9], [28, -18], [21, -21], [7, -27]], [[3745, 447], [35, -26], [12, -36], [3, -25], [1, -30], [-43, -19], [-45, -15], [-52, -14], [-59, -11], [-65, 3], [-37, 20], [5, 24], [59, 16], [24, 20], [18, 26], [12, 22], [17, 20], [18, 25], [14, 0], [41, 12], [42, -12]], [[1633, 715], [36, -9], [33, 10], [-16, -20], [-26, -15], [-39, 4], [-27, 21], [6, 20], [33, -11]], [[1512, 716], [43, -23], [-17, 3], [-36, 5], [-38, 17], [20, 12], [28, -14]], [[2250, 808], [31, -8], [30, 7], [17, -34], [-22, 5], [-34, -2], [-34, 2], [-38, -4], [-28, 12], [-15, 24], [18, 11], [35, -8], [40, -5]], [[3098, 866], [4, -27], [-5, -23], [-8, -22], [-33, -8], [-31, -12], [-36, 1], [14, 24], [-33, -9], [-31, -8], [-21, 18], [-2, 24], [30, 23], [20, 7], [32, -2], [8, 30], [1, 22], [0, 47], [16, 28], [25, 9], [15, -22], [6, -22], [12, -26], [10, -26], [7, -26]], [[3371, 1268], [-11, -13], [-21, 9], [-23, -6], [-19, -14], [-20, -15], [-14, -17], [-4, -23], [2, -22], [13, -20], [-19, -14], [-26, -4], [-15, -20], [-17, -19], [-17, -25], [-4, -22], [9, -24], [15, -19], [23, -14], [21, -18], [12, -23], [6, -22], [8, -24], [13, -19], [8, -22], [4, -55], [8, -22], [2, -23], [9, -23], [-4, -31], [-15, -24], [-17, -20], [-37, -8], [-12, -21], [-17, -20], [-42, -22], [-37, -9], [-35, -13], [-37, -13], [-22, -24], [-45, -2], [-49, 2], [-44, -4], [-47, 0], [9, -24], [42, -10], [31, -16], [18, -21], [-31, -19], [-48, 6], [-40, -15], [-2, -24], [-1, -23], [33, -20], [6, -22], [35, -22], [59, -9], [50, -16], [40, -19], [50, -18], [70, -10], [68, -16], [47, -17], [52, -20], [27, -28], [13, -22], [34, 21], [46, 17], [48, 19], [58, 15], [49, 16], [69, 1], [68, -8], [56, -14], [18, 26], [39, 17], [70, 1], [55, 13], [52, 13], [58, 8], [62, 10], [43, 15], [-20, 21], [-12, 21], [0, 22], [-54, -2], [-57, -10], [-54, 0], [-8, 22], [4, 44], [12, 13], [40, 14], [47, 14], [34, 17], [33, 18], [25, 23], [38, 10], [38, 8], [19, 5], [43, 2], [41, 8], [34, 12], [34, 14], [30, 14], [39, 18], [24, 20], [26, 17], [9, 24], [-30, 13], [10, 25], [18, 18], [29, 12], [31, 14], [28, 18], [22, 23], [13, 28], [21, 16], [33, -3], [13, -20], [34, -2], [1, 22], [14, 23], [30, -6], [7, -22], [33, -3], [36, 10], [35, 7], [31, -3], [12, -25], [31, 20], [28, 10], [31, 9], [31, 8], [29, 14], [31, 9], [24, 13], [17, 20], [20, -15], [29, 8], [20, -27], [16, -21], [32, 11], [12, 24], [28, 16], [37, -4], [11, -22], [22, 22], [30, 7], [33, 3], [29, -2], [31, -7], [30, -3], [13, -20], [18, -17], [31, 10], [32, 3], [32, 0], [31, 1], [28, 8], [29, 7], [25, 16], [26, 11], [28, 5], [21, 17], [15, 32], [16, 20], [29, -10], [11, -21], [24, -13], [29, 4], [19, -21], [21, -15], [28, 14], [10, 26], [25, 10], [29, 20], [27, 8], [33, 11], [22, 13], [22, 14], [22, 13], [26, -7], [25, 21], [18, 16], [26, -1], [23, 14], [6, 21], [23, 16], [23, 11], [28, 10], [25, 4], [25, -3], [26, -6], [22, -16], [3, -26], [24, -19], [17, -17], [33, -7], [19, -16], [23, -16], [26, -3], [23, 11], [24, 24], [26, -12], [27, -7], [26, -7], [27, -5], [28, 0], [23, -61], [-1, -15], [-4, -27], [-26, -15], [-22, -22], [4, -23], [31, 1], [-4, -23], [-14, -22], [-13, -24], [21, -19], [32, -6], [32, 11], [15, 23], [10, 22], [15, 18], [17, 18], [7, 21], [15, 29], [18, 5], [31, 3], [28, 7], [28, 9], [14, 23], [8, 22], [19, 22], [27, 15], [23, 12], [16, 19], [15, 11], [21, 9], [27, -6], [25, 6], [28, 7], [30, -4], [20, 17], [14, 39], [11, -16], [13, -28], [23, -12], [27, -4], [26, 7], [29, -5], [26, -1], [17, 6], [24, -4], [21, -12], [25, 8], [30, 0], [25, 8], [29, -8], [19, 19], [14, 20], [19, 16], [35, 44], [18, -8], [21, -16], [18, -21], [36, -36], [27, -1], [25, 0], [30, 7], [30, 8], [23, 16], [19, 18], [31, 2], [21, 13], [22, -12], [14, -18], [19, -19], [31, 2], [19, -15], [33, -15], [35, -5], [29, 4], [21, 19], [19, 18], [25, 5], [25, -8], [29, -6], [26, 9], [25, 0], [24, -6], [26, -5], [25, 10], [30, 9], [28, 3], [32, 0], [25, 5], [25, 5], [8, 29], [1, 24], [17, -16], [5, -27], [10, -24], [11, -20], [23, -10], [32, 4], [36, 1], [25, 3], [37, 0], [26, 1], [36, -2], [31, -5], [20, -18], [-5, -22], [18, -18], [30, -13], [31, -15], [35, -11], [38, -9], [28, -9], [32, -2], [18, 20], [24, -16], [21, -19], [25, -13], [34, -6], [32, -7], [13, -23], [32, -14], [21, -21], [31, -9], [32, 1], [30, -4], [33, 1], [34, -4], [31, -8], [28, -14], [29, -12], [20, -17], [-3, -23], [-15, -21], [-13, -27], [-9, -21], [-14, -24], [-36, -9], [-16, -21], [-36, -13], [-13, -23], [-19, -22], [-20, -18], [-11, -25], [-7, -22], [-3, -26], [0, -22], [16, -23], [6, -22], [13, -21], [52, -8], [11, -26], [-50, -9], [-43, -13], [-52, -2], [-24, -34], [-5, -27], [-12, -22], [-14, -22], [37, -20], [14, -24], [24, -22], [33, -20], [39, -19], [42, -18], [64, -19], [14, -29], [80, -12], [5, -5], [21, -17], [77, 15], [63, -19], [48, -14], [-9997, -1], [24, 35], [50, -19], [3, 2], [30, 19], [4, 0], [3, -1], [40, -25], [35, 25], [7, 3], [81, 11], [27, -14], [13, -7], [41, -20], [79, -15], [63, -18], [107, -14], [80, 16], [118, -11], [67, -19], [73, 17], [78, 17], [6, 27], [-110, 3], [-89, 14], [-24, 23], [-74, 12], [5, 27], [10, 24], [10, 22], [-5, 25], [-46, 16], [-22, 21], [-43, 18], [68, -3], [64, 9], [40, -20], [50, 18], [45, 22], [23, 19], [-10, 25], [-36, 16], [-41, 17], [-57, 4], [-50, 8], [-54, 6], [-18, 22], [-36, 18], [-21, 21], [-9, 67], [14, -6], [25, -18], [45, 6], [44, 8], [23, -26], [44, 6], [37, 13], [35, 16], [32, 20], [41, 5], [-1, 22], [-9, 22], [8, 21], [36, 11], [16, -20], [42, 12], [32, 15], [40, 1], [38, 6], [37, 13], [30, 13], [34, 13], [22, -4], [19, -4], [41, 8], [37, -10], [38, 1], [37, 8], [37, -6], [41, -6], [39, 3], [40, -2], [42, -1], [38, 3], [28, 17], [34, 9], [35, -13], [33, 11], [30, 21], [18, -19], [9, -21], [18, -19], [29, 17], [33, -22], [38, -7], [32, -16], [39, 3], [36, 11], [41, -3], [38, -8], [38, -10], [15, 25], [-18, 20], [-14, 21], [-36, 5], [-15, 22], [-6, 22], [-10, 43], [21, -8], [36, -3], [36, 3], [33, -9], [28, -17], [12, -21], [38, -4], [36, 9], [38, 11], [34, 7], [28, -14], [37, 5], [24, 45], [23, -27], [32, -10], [34, 6], [23, -23], [37, -3], [33, -7], [34, -12], [21, 22], [11, 20], [28, -23], [38, 6], [28, -13], [19, -19], [37, 5], [29, 13], [29, 15], [33, 8], [39, 7], [36, 8], [27, 13], [16, 19], [7, 25], [-3, 24], [-9, 24], [-10, 23], [-9, 23], [-7, 21], [-1, 23], [2, 23], [13, 22], [11, 24], [5, 23], [-6, 26], [-3, 23], [14, 27], [15, 17], [18, 22], [19, 19], [22, 17], [11, 25], [15, 17], [18, 15], [26, 3], [18, 19], [19, 11], [23, 7], [20, 15], [16, 19], [22, 7], [16, -15], [-10, -20], [-29, -17]], [[6914, 2185], [18, -19], [26, -7], [1, -11], [-7, -27], [-43, -4], [-1, 31], [4, 25], [2, 12]], [[9038, 2648], [27, -21], [15, 8], [22, 12], [16, -4], [2, -70], [-9, -21], [-3, -47], [-10, 16], [-19, -41], [-6, 3], [-17, 2], [-17, 50], [-4, 39], [-16, 52], [1, 27], [18, -5]], [[8987, 4244], [10, -46], [18, 22], [9, -25], [13, -23], [-3, -26], [6, -51], [5, -29], [7, -7], [7, -51], [-3, -30], [9, -40], [31, -31], [19, -28], [19, -26], [-4, -14], [16, -37], [11, -64], [11, 13], [11, -26], [7, 9], [5, -63], [19, -36], [13, -22], [22, -48], [8, -48], [1, -33], [-2, -37], [13, -50], [-2, -52], [-5, -28], [-7, -52], [1, -34], [-6, -43], [-12, -53], [-21, -29], [-10, -46], [-9, -29], [-8, -51], [-11, -30], [-7, -44], [-4, -41], [2, -18], [-16, -21], [-31, -2], [-26, -24], [-13, -23], [-17, -26], [-23, 27], [-17, 10], [5, 31], [-15, -11], [-25, -43], [-24, 16], [-15, 9], [-16, 4], [-27, 17], [-18, 37], [-5, 45], [-7, 30], [-13, 24], [-27, 7], [9, 28], [-7, 44], [-13, -41], [-25, -11], [14, 33], [5, 34], [10, 29], [-2, 44], [-22, -50], [-18, -21], [-10, -47], [-22, 25], [1, 31], [-18, 43], [-14, 22], [5, 14], [-36, 35], [-19, 2], [-27, 29], [-50, -6], [-36, -21], [-31, -20], [-27, 4], [-29, -30], [-24, -14], [-6, -31], [-10, -24], [-23, -1], [-18, -5], [-24, 10], [-20, -6], [-19, -3], [-17, -31], [-8, 2], [-14, -16], [-13, -19], [-21, 2], [-18, 0], [-30, 38], [-15, 11], [1, 34], [14, 8], [4, 14], [-1, 21], [4, 41], [-3, 35], [-15, 60], [-4, 33], [1, 34], [-11, 38], [-1, 18], [-12, 23], [-4, 47], [-16, 46], [-4, 26], [13, -26], [-10, 55], [14, -17], [8, -23], [0, 30], [-14, 47], [-3, 18], [-6, 18], [3, 34], [6, 15], [4, 29], [-3, 35], [11, 42], [2, -45], [12, 41], [22, 20], [14, 25], [21, 22], [13, 4], [7, -7], [22, 22], [17, 6], [4, 13], [8, 6], [15, -2], [29, 18], [15, 26], [7, 31], [17, 30], [1, 24], [1, 32], [19, 50], [12, -51], [12, 12], [-10, 28], [9, 29], [12, -13], [3, 45], [15, 29], [7, 23], [14, 10], [0, 17], [13, -7], [0, 15], [12, 8], [14, 8], [20, -27], [16, -35], [17, 0], [18, -6], [-6, 33], [13, 47], [13, 15], [-5, 15], [12, 34], [17, 21], [14, -7], [24, 11], [-1, 30], [-20, 19], [15, 9], [18, -15], [15, -24], [23, -15], [8, 6], [17, -18], [17, 17], [10, -5], [7, 11], [12, -29], [-7, -32], [-11, -24], [-9, -2], [3, -23], [-8, -30], [-10, -29], [2, -17], [22, -32], [21, -19], [15, -20], [20, -35], [8, 0], [14, -15], [4, -19], [27, -20], [18, 20], [6, 32], [5, 26], [4, 33], [8, 47], [-4, 28], [2, 17], [-3, 34], [4, 45], [5, 12], [-4, 20], [7, 31], [5, 32], [1, 17], [10, 22], [8, -29], [2, -37], [7, -7], [1, -25], [10, -30], [2, -33], [-1, -22]], [[5471, 7900], [-2, -24], [-16, 0], [6, -13], [-9, -38]], [[5450, 7825], [-6, -10], [-24, -1], [-14, -13], [-23, 4]], [[5383, 7805], [-40, 15], [-6, 21], [-27, -10], [-4, -12], [-16, 9]], [[5290, 7828], [-15, 1], [-12, 11], [4, 15], [-1, 10]], [[5266, 7865], [8, 3], [14, -16], [4, 16], [25, -3], [20, 11], [13, -2], [9, -12], [2, 10], [-4, 38], [10, 8], [10, 27]], [[5377, 7945], [21, -19], [15, 24], [10, 5], [22, -18], [13, 3], [13, -12]], [[5471, 7928], [-3, -7], [3, -21]], [[6281, 7346], [-19, 8], [-14, 27], [-4, 23]], [[6349, 7527], [15, -31], [14, -42], [13, -2], [8, -16], [-23, -5], [-5, -46], [-4, -21], [-11, -13], [1, -30]], [[6357, 7321], [-7, -3], [-17, 31], [10, 30], [-9, 17], [-10, -4], [-33, -44]], [[6249, 7494], [6, 10], [21, -17], [15, -4], [4, 7], [-14, 32], [7, 9]], [[6288, 7531], [8, -2], [19, -36], [13, -4], [4, 15], [17, 23]], [[5814, 4792], [-1, 71], [-7, 27]], [[5806, 4890], [17, -5], [8, 34], [15, -4]], [[5846, 4915], [1, -23], [6, -14], [1, -19], [-7, -12], [-11, -31], [-10, -22], [-12, -2]], [[5092, 8091], [20, -5], [26, 12], [17, -25], [16, -14]], [[5171, 8059], [-4, -40]], [[5167, 8019], [-7, -2], [-3, -33]], [[5157, 7984], [-24, 26], [-14, -4], [-20, 28], [-13, 23], [-13, 1], [-4, 21]], [[5069, 8079], [23, 12]], [[5074, 5427], [-23, -7]], [[5051, 5420], [-7, 41], [2, 136], [-6, 12], [-1, 29], [-10, 21], [-8, 17], [3, 31]], [[5024, 5707], [10, 7], [6, 26], [13, 5], [6, 18]], [[5059, 5763], [10, 17], [10, 0], [21, -34]], [[5100, 5746], [-1, -19], [6, -35], [-6, -24], [3, -16], [-13, -37], [-9, -18], [-5, -37], [1, -38], [-2, -95]], [[4921, 5627], [-19, 15], [-13, -2], [-10, -15], [-12, 13], [-5, 19], [-13, 13]], [[4849, 5670], [-1, 34], [7, 26], [-1, 20], [23, 48], [4, 41], [7, 14], [14, -8], [11, 12], [4, 16], [22, 26], [5, 19], [26, 24], [15, 9], [7, -12], [18, 0]], [[5010, 5939], [-2, -28], [3, -27], [16, -39], [1, -28], [32, -14], [-1, -40]], [[5024, 5707], [-24, 1]], [[5000, 5708], [-13, 5], [-9, -9], [-12, 4], [-48, -3], [-1, -33], [4, -45]], [[7573, 6360], [0, -43], [-10, 9], [2, -47]], [[7565, 6279], [-8, 30], [-1, 31], [-6, 28], [-11, 34], [-26, 3], [3, -25], [-9, -32], [-12, 12], [-4, -11], [-8, 6], [-11, 5]], [[7472, 6360], [-4, 49], [-10, 45], [5, 35], [-17, 16], [6, 22], [18, 22], [-20, 31], [9, 40], [22, -26], [14, -3], [2, -41], [26, -8], [26, 1], [16, -10], [-13, -50], [-12, -3], [-9, -34], [16, -31], [4, 38], [8, 0], [14, -93]], [[5629, 7671], [8, -25], [11, 5], [21, -9], [41, -4], [13, 16], [33, 13], [20, -21], [17, -6]], [[5793, 7640], [-15, -25], [-10, -42], [9, -34]], [[5777, 7539], [-24, 8], [-28, -18]], [[5725, 7529], [0, -30], [-26, -5], [-19, 20], [-22, -16], [-21, 2]], [[5637, 7500], [-2, 39], [-14, 19]], [[5621, 7558], [5, 8], [-3, 7], [4, 19], [11, 18], [-14, 26], [-2, 21], [7, 14]], [[2846, 6461], [-7, -3], [-7, 34], [-10, 17], [6, 38], [8, -3], [10, -49], [0, -34]], [[2838, 6628], [-30, -10], [-2, 22], [13, 5], [18, -2], [1, -15]], [[2861, 6628], [-5, -42], [-5, 8], [0, 31], [-12, 23], [0, 7], [22, -27]], [[5527, 7708], [10, 0], [-7, -26], [14, -23], [-4, -28], [-7, -2]], [[5533, 7629], [-5, -6], [-9, -13], [-4, -33]], [[5515, 7577], [-25, 23], [-10, 24], [-11, 13], [-12, 22], [-6, 19], [-14, 27], [6, 25], [10, -14], [6, 12], [13, 2], [24, -10], [19, 1], [12, -13]], [[5652, 8242], [27, 0], [30, 22], [6, 34], [23, 19], [-3, 26]], [[5735, 8343], [17, 10], [30, 23]], [[5782, 8376], [29, -15], [4, -15], [15, 7], [27, -14], [3, -27], [-6, -16], [17, -39], [12, -11], [-2, -11], [19, -10], [8, -16], [-11, -13], [-23, 2], [-5, -5], [7, -20], [6, -37]], [[5882, 8136], [-23, -4], [-9, -13], [-2, -30], [-11, 6], [-25, -3], [-7, 14], [-11, -10], [-10, 8], [-22, 1], [-31, 15], [-28, 4], [-22, -1], [-15, -16], [-13, -2]], [[5653, 8105], [-1, 26], [-8, 27], [17, 12], [0, 24], [-8, 22], [-1, 26]], [[2524, 6110], [-1, 8], [4, 3], [5, -7], [10, 36], [5, 0]], [[2547, 6150], [0, -8], [5, -1], [0, -16], [-5, -25], [3, -9], [-3, -21], [2, -6], [-4, -30], [-5, -16], [-5, -1], [-6, -21]], [[2529, 5996], [-8, 0], [2, 67], [1, 47]], [[3136, 3714], [-20, -8], [-11, 82], [-15, 66], [9, 57], [-15, 25], [-4, 43], [-13, 40]], [[3067, 4019], [17, 64], [-12, 49], [7, 20], [-5, 22], [10, 30], [1, 50], [1, 41], [6, 20], [-24, 96]], [[3068, 4411], [21, -5], [14, 1], [6, 18], [25, 24], [14, 22], [37, 10], [-3, -44], [3, -23], [-2, -40], [30, -53], [31, -9], [11, -23], [19, -11], [11, -17], [18, 0], [16, -17], [1, -34], [6, -18], [0, -25], [-8, -1], [11, -69], [53, -2], [-4, -35], [3, -23], [15, -16], [6, -37], [-4, -47], [-8, -26], [3, -33], [-9, -12]], [[3384, 3866], [-1, 18], [-25, 30], [-26, 1], [-49, -17], [-13, -52], [-1, -32], [-11, -71]], [[3482, 3537], [6, 34], [3, 35], [1, 32], [-10, 11], [-11, -9], [-10, 2], [-4, 23], [-2, 54], [-5, 18], [-19, 16], [-11, -12], [-30, 11], [2, 81], [-8, 33]], [[3068, 4411], [-15, -11], [-13, 7], [2, 90], [-23, -35], [-24, 2], [-11, 31], [-18, 4], [5, 25], [-15, 36], [-11, 53], [7, 11], [0, 25], [17, 17], [-3, 32], [7, 20], [2, 28], [32, 40], [22, 11], [4, 9], [25, -2]], [[3058, 4804], [13, 162], [0, 25], [-4, 34], [-12, 22], [0, 42], [15, 10], [6, -6], [1, 23], [-16, 6], [-1, 37], [54, -2], [10, 21], [7, -19], [6, -35], [5, 8]], [[3142, 5132], [15, -32], [22, 4], [5, 18], [21, 14], [11, 10], [4, 25], [19, 17], [-1, 12], [-24, 5], [-3, 37], [1, 40], [-13, 15], [5, 6], [21, -8], [22, -15], [8, 14], [20, 9], [31, 23], [10, 22], [-3, 17]], [[3313, 5365], [14, 2], [7, -13], [-4, -26], [9, -9], [7, -28], [-8, -20], [-4, -51], [7, -30], [2, -27], [17, -28], [14, -3], [3, 12], [8, 3], [13, 10], [9, 16], [15, -5], [7, 2]], [[3429, 5170], [15, -5], [3, 12], [-5, 12], [3, 17], [11, -5], [13, 6], [16, -13]], [[3485, 5194], [12, -12], [9, 16], [6, -3], [4, -16], [13, 4], [11, 22], [8, 44], [17, 54]], [[3565, 5303], [9, 3], [7, -33], [16, -103], [14, -10], [1, -41], [-21, -48], [9, -18], [49, -9], [1, -60], [21, 39], [35, -21], [46, -36], [14, -35], [-5, -32], [33, 18], [54, -32], [41, 3], [41, -49], [36, -66], [21, -17], [24, -3], [10, -18], [9, -76], [5, -35], [-11, -98], [-14, -39], [-39, -82], [-18, -67], [-21, -51], [-7, -1], [-7, -43], [2, -111], [-8, -91], [-3, -39], [-9, -23], [-5, -79], [-28, -77], [-5, -61], [-22, -26], [-7, -35], [-30, 0], [-44, -23], [-19, -26], [-31, -18], [-33, -47], [-23, -58], [-5, -44], [5, -33], [-5, -60], [-6, -28], [-20, -33], [-31, -104], [-24, -47], [-19, -27], [-13, -57], [-18, -33]], [[3517, 3063], [-8, 33], [13, 28], [-16, 40], [-22, 33], [-29, 38], [-10, -2], [-28, 46], [-18, -7]], [[8172, 5325], [11, 22], [23, 32]], [[8206, 5379], [-1, -29], [-2, -37], [-13, 1], [-6, -20], [-12, 31]], [[7546, 6698], [12, -19], [-2, -36], [-23, -2], [-23, 4], [-18, -9], [-25, 22], [-1, 12]], [[7466, 6670], [19, 44], [15, 15], [20, -14], [14, -1], [12, -16]], [[5817, 3752], [-39, -43], [-25, -44], [-10, -40], [-8, -22], [-15, -4], [-5, -29], [-3, -18], [-17, -14], [-23, 3], [-13, 17], [-12, 7], [-14, -14], [-6, -28], [-14, -18], [-13, -26], [-20, -6], [-6, 20], [2, 36], [-16, 56], [-8, 9]], [[5552, 3594], [0, 173], [27, 2], [1, 210], [21, 2], [43, 21], [10, -24], [18, 23], [9, 0], [15, 13]], [[5696, 4014], [5, -4]], [[5701, 4010], [11, -48], [5, -10], [9, -34], [32, -65], [12, -7], [0, -20], [8, -38], [21, -9], [18, -27]], [[5424, 5496], [23, 4], [5, 16], [5, -2], [7, -13], [34, 23], [12, 23], [15, 20], [-3, 21], [8, 6], [27, -4], [26, 27], [20, 65], [14, 24], [18, 10]], [[5635, 5716], [3, -26], [16, -36], [0, -25], [-5, -24], [2, -18], [10, -18]], [[5661, 5569], [21, -25]], [[5682, 5544], [15, -24], [0, -19], [19, -31], [12, -26], [7, -35], [20, -24], [5, -18]], [[5760, 5367], [-9, -7], [-18, 2], [-21, 6], [-10, -5], [-5, -14], [-9, -2], [-10, 12], [-31, -29], [-13, 6], [-4, -5], [-8, -35], [-21, 11], [-20, 6], [-18, 22], [-23, 20], [-15, -19], [-10, -30], [-3, -41]], [[5512, 5265], [-18, 3], [-19, 10], [-16, -32], [-15, -55]], [[5444, 5191], [-3, 18], [-1, 27], [-13, 19], [-10, 30], [-2, 21], [-13, 31], [2, 18], [-3, 25], [2, 45], [7, 11], [14, 60]], [[3231, 7808], [20, -8], [26, 1], [-14, -24], [-10, -4], [-35, 25], [-7, 20], [10, 18], [10, -28]], [[3283, 7958], [-14, -1], [-36, 19], [-26, 28], [10, 5], [37, -15], [28, -25], [1, -11]], [[1569, 7923], [-14, -8], [-46, 27], [-8, 21], [-25, 21], [-5, 16], [-28, 11], [-11, 32], [2, 14], [30, -13], [17, -9], [26, -6], [9, -21], [14, -28], [28, -24], [11, -33]], [[3440, 8052], [-18, -52], [18, 20], [19, -12], [-10, -21], [25, -16], [12, 14], [28, -18], [-8, -43], [19, 10], [4, -32], [8, -36], [-11, -52], [-13, -2], [-18, 11], [6, 48], [-8, 8], [-32, -52], [-17, 2], [20, 28], [-27, 14], [-30, -3], [-54, 2], [-4, 17], [17, 21], [-12, 16], [24, 36], [28, 94], [18, 33], [24, 21], [13, -3], [-6, -16], [-15, -37]], [[1313, 8250], [27, 5], [-8, -67], [24, -48], [-11, 0], [-17, 27], [-10, 27], [-14, 19], [-5, 26], [1, 19], [13, -8]], [[2798, 8730], [-11, -31], [-12, 5], [-8, 17], [2, 4], [10, 18], [12, -1], [7, -12]], [[2725, 8762], [-33, -32], [-19, 1], [-6, 16], [20, 27], [38, 0], [0, -12]], [[2634, 8936], [5, -26], [15, 9], [16, -15], [30, -20], [32, -19], [2, -28], [21, 5], [20, -20], [-25, -18], [-43, 14], [-16, 26], [-27, -31], [-40, -31], [-9, 35], [-38, -6], [24, 30], [4, 46], [9, 54], [20, -5]], [[2892, 9024], [-31, -3], [-7, 29], [12, 34], [26, 8], [21, -17], [1, -25], [-4, -8], [-18, -18]], [[2343, 9140], [-17, -21], [-38, 18], [-22, -6], [-38, 26], [24, 19], [19, 25], [30, -16], [17, -11], [8, -11], [17, -23]], [[3135, 7724], [-18, 33], [0, 81], [-13, 17], [-18, -10], [-10, 16], [-21, -45], [-8, -46], [-10, -27], [-12, -9], [-9, -3], [-3, -15], [-51, 0], [-42, 0], [-12, -11], [-30, -42], [-3, -5], [-9, -23], [-26, 0], [-27, 0], [-12, -10], [4, -11], [2, -18], [0, -6], [-36, -30], [-29, -9], [-32, -31], [-7, 0], [-10, 9], [-3, 8], [1, 6], [6, 21], [13, 33], [8, 35], [-5, 51], [-6, 53], [-29, 28], [3, 11], [-4, 7], [-8, 0], [-5, 9], [-2, 14], [-5, -6], [-7, 2], [1, 6], [-6, 6], [-3, 15], [-21, 19], [-23, 20], [-27, 23], [-26, 21], [-25, -17], [-9, 0], [-34, 15], [-23, -8], [-27, 19], [-28, 9], [-19, 4], [-9, 10], [-5, 32], [-9, 0], [-1, -23], [-57, 0], [-95, 0], [-94, 0], [-84, 0], [-83, 0], [-82, 0], [-85, 0], [-27, 0], [-82, 0], [-79, 0]], [[1588, 7952], [-4, 0], [-54, 58], [-20, 26], [-50, 24], [-15, 53], [3, 36], [-35, 25], [-5, 48], [-34, 43], [0, 30]], [[1374, 8295], [15, 29], [0, 37], [-48, 37], [-28, 68], [-17, 42], [-26, 27], [-19, 24], [-14, 31], [-28, -20], [-27, -33], [-25, 39], [-19, 26], [-27, 16], [-28, 2], [0, 337], [1, 219]], [[1084, 9176], [51, -14], [44, -29], [29, -5], [24, 24], [34, 19], [41, -7], [42, 26], [45, 14], [20, -24], [20, 14], [6, 27], [20, -6], [47, -53], [37, 40], [3, -45], [34, 10], [11, 17], [34, -3], [42, -25], [65, -22], [38, -10], [28, 4], [37, -30], [-39, -29], [50, -13], [75, 7], [24, 11], [29, -36], [31, 30], [-29, 25], [18, 20], [34, 3], [22, 6], [23, -14], [28, -32], [31, 5], [49, -27], [43, 9], [40, -1], [-3, 37], [25, 10], [43, -20], [0, -56], [17, 47], [23, -1], [12, 59], [-30, 36], [-32, 24], [2, 65], [33, 43], [37, -9], [28, -26], [38, -67], [-25, -29], [52, -12], [-1, -60], [38, 46], [33, -38], [-9, -44], [27, -40], [29, 43], [21, 51], [1, 65], [40, -5], [41, -8], [37, -30], [2, -29], [-21, -31], [20, -32], [-4, -29], [-54, -41], [-39, -9], [-29, 18], [-8, -30], [-27, -50], [-8, -26], [-32, -40], [-40, -4], [-22, -25], [-2, -38], [-32, -7], [-34, -48], [-30, -67], [-11, -46], [-1, -69], [40, -10], [13, -55], [13, -45], [39, 12], [51, -26], [28, -22], [20, -28], [35, -17], [29, -24], [46, -4], [30, -6], [-4, -51], [8, -59], [21, -66], [41, -56], [21, 19], [15, 61], [-14, 93], [-20, 31], [45, 28], [31, 41], [16, 41], [-3, 40], [-19, 50], [-33, 44], [32, 62], [-12, 54], [-9, 92], [19, 14], [48, -16], [29, -6], [23, 15], [25, -20], [35, -34], [8, -23], [50, -4], [-1, -50], [9, -74], [25, -10], [21, -35], [40, 33], [26, 65], [19, 28], [21, -53], [36, -75], [31, -71], [-11, -37], [37, -33], [25, -34], [44, -15], [18, -19], [11, -50], [22, -8], [11, -22], [2, -67], [-20, -22], [-20, -21], [-46, -21], [-35, -48], [-47, -10], [-59, 13], [-42, 0], [-29, -4], [-23, -43], [-35, -26], [-40, -78], [-32, -54], [23, 9], [45, 78], [58, 49], [42, 6], [24, -29], [-26, -40], [9, -63], [9, -45], [36, -29], [46, 8], [28, 67], [2, -43], [17, -22], [-34, -38], [-61, -36], [-28, -23], [-31, -43], [-21, 4], [-1, 50], [48, 49], [-44, -2], [-31, -7]], [[1829, 9377], [-14, -27], [61, 17], [39, -29], [31, 30], [26, -20], [23, -58], [14, 25], [-20, 60], [24, 9], [28, -9], [31, -24], [17, -58], [9, -41], [47, -30], [50, -28], [-3, -26], [-46, -4], [18, -23], [-9, -22], [-51, 9], [-48, 16], [-32, -3], [-52, -20], [-70, -9], [-50, -6], [-15, 28], [-38, 16], [-24, -6], [-35, 47], [19, 6], [43, 10], [39, -3], [36, 11], [-54, 13], [-59, -4], [-39, 1], [-15, 22], [64, 23], [-42, -1], [-49, 16], [23, 44], [20, 24], [74, 36], [29, -12]], [[2097, 9395], [-24, -39], [-44, 41], [10, 9], [37, 2], [21, -13]], [[2879, 9376], [3, -16], [-30, 2], [-30, 1], [-30, -8], [-8, 3], [-31, 32], [1, 21], [14, 4], [63, -6], [48, -33]], [[2595, 9379], [22, -36], [26, 47], [70, 24], [48, -61], [-4, -38], [55, 17], [26, 23], [62, -30], [38, -28], [3, -25], [52, 13], [29, -38], [67, -23], [24, -24], [26, -55], [-51, -28], [66, -38], [44, -13], [40, -55], [44, -3], [-9, -42], [-49, -69], [-34, 26], [-44, 57], [-36, -8], [-3, -34], [29, -34], [38, -27], [11, -16], [18, -58], [-9, -43], [-35, 16], [-70, 47], [39, -51], [29, -35], [5, -21], [-76, 24], [-59, 34], [-34, 29], [10, 17], [-42, 30], [-40, 29], [0, -18], [-80, -9], [-23, 20], [18, 44], [52, 1], [57, 7], [-9, 21], [10, 30], [36, 57], [-8, 27], [-11, 20], [-42, 29], [-57, 20], [18, 15], [-29, 36], [-25, 4], [-22, 20], [-14, -18], [-51, -7], [-101, 13], [-59, 17], [-45, 9], [-23, 21], [29, 27], [-39, 0], [-9, 60], [21, 53], [29, 24], [72, 16], [-21, -39]], [[2212, 9420], [33, -12], [50, 7], [7, -17], [-26, -28], [42, -26], [-5, -53], [-45, -23], [-27, 5], [-19, 23], [-69, 45], [0, 19], [57, -7], [-31, 38], [33, 29]], [[2411, 9357], [-30, -45], [-32, 3], [-17, 52], [1, 29], [14, 25], [28, 16], [58, -2], [53, -14], [-42, -53], [-33, -11]], [[1654, 9275], [-73, -29], [-15, 26], [-64, 31], [12, 25], [19, 43], [24, 39], [-27, 36], [94, 10], [39, -13], [71, -3], [27, -17], [30, -25], [-35, -15], [-68, -41], [-34, -42], [0, -25]], [[2399, 9487], [-15, -23], [-40, 5], [-34, 15], [15, 27], [40, 16], [24, -21], [10, -19]], [[2264, 9590], [21, -27], [1, -31], [-13, -44], [-46, -6], [-30, 10], [1, 34], [-45, -4], [-2, 45], [30, -2], [41, 21], [40, -4], [2, 8]], [[1994, 9559], [11, -21], [25, 10], [29, -2], [5, -29], [-17, -28], [-94, -10], [-70, -25], [-43, -2], [-3, 20], [57, 26], [-125, -7], [-39, 10], [38, 58], [26, 17], [78, -20], [50, -35], [48, -5], [-40, 57], [26, 21], [29, -7], [9, -28]], [[2370, 9612], [30, -19], [55, 0], [24, -19], [-6, -22], [32, -14], [17, -14], [38, -2], [40, -5], [44, 13], [57, 5], [45, -5], [30, -22], [6, -24], [-17, -16], [-42, -13], [-35, 8], [-80, -10], [-57, -1], [-45, 8], [-74, 19], [-9, 32], [-4, 29], [-27, 26], [-58, 7], [-32, 19], [10, 24], [58, -4]], [[1772, 9645], [-4, -46], [-21, -20], [-26, -3], [-52, -26], [-44, -9], [-38, 13], [47, 44], [57, 39], [43, -1], [38, 9]], [[2393, 9637], [-13, -2], [-52, 4], [-7, 17], [56, -1], [19, -11], [-3, -7]], [[1939, 9648], [-52, -17], [-41, 19], [23, 19], [40, 6], [39, -10], [-9, -17]], [[1954, 9701], [-34, -11], [-46, 0], [0, 8], [29, 18], [14, -3], [37, -12]], [[2338, 9669], [-41, -12], [-23, 13], [-12, 23], [-2, 24], [36, -2], [16, -4], [33, -21], [-7, -21]], [[2220, 9685], [11, -25], [-45, 7], [-46, 19], [-62, 2], [27, 18], [-34, 14], [-2, 22], [55, -8], [75, -21], [21, -28]], [[2583, 9764], [33, -20], [-38, -17], [-51, -45], [-50, -4], [-57, 8], [-30, 24], [0, 21], [22, 16], [-50, 0], [-31, 19], [-18, 27], [20, 26], [19, 18], [28, 4], [-12, 14], [65, 3], [35, -32], [47, -12], [46, -11], [22, -39]], [[3097, 9967], [74, -4], [60, -8], [51, -16], [-2, -16], [-67, -25], [-68, -12], [-25, -14], [61, 1], [-66, -36], [-45, -17], [-48, -48], [-57, -10], [-18, -12], [-84, -6], [39, -8], [-20, -10], [23, -29], [-26, -21], [-43, -16], [-13, -24], [-39, -17], [4, -14], [48, 3], [0, -15], [-74, -35], [-73, 16], [-81, -9], [-42, 7], [-52, 3], [-4, 29], [52, 13], [-14, 43], [17, 4], [74, -26], [-38, 38], [-45, 11], [23, 23], [49, 14], [8, 21], [-39, 23], [-12, 31], [76, -3], [22, -6], [43, 21], [-62, 7], [-98, -4], [-49, 20], [-23, 24], [-32, 17], [-6, 21], [41, 11], [32, 2], [55, 9], [41, 22], [34, -3], [30, -16], [21, 32], [37, 9], [50, 7], [85, 2], [14, -6], [81, 10], [60, -4], [60, -4]], [[5290, 7828], [-3, -24], [-12, -10], [-20, 7], [-6, -24], [-14, -2], [-5, 10], [-15, -20], [-13, -3], [-12, 13]], [[5190, 7775], [-10, 25], [-13, -9], [0, 27], [21, 33], [-1, 15], [12, -5], [8, 10]], [[5207, 7871], [24, -1], [5, 13], [30, -18]], [[3140, 1814], [-10, -24], [-23, -18], [-14, 2], [-16, 5], [-21, 18], [-29, 8], [-35, 33], [-28, 32], [-38, 66], [23, -12], [39, -40], [36, -21], [15, 27], [9, 41], [25, 24], [20, -7]], [[3095, 1968], [-25, 0], [-13, -14], [-25, -22], [-5, -55], [-11, -1], [-32, 19], [-32, 41], [-34, 34], [-9, 37], [8, 35], [-14, 39], [-4, 101], [12, 57], [30, 45], [-43, 18], [27, 52], [9, 98], [31, -21], [15, 123], [-19, 15], [-9, -73], [-17, 8], [9, 84], [9, 110], [13, 40], [-8, 58], [-2, 66], [11, 2], [17, 96], [20, 94], [11, 88], [-6, 89], [8, 49], [-3, 72], [16, 73], [5, 114], [9, 123], [9, 132], [-2, 96], [-6, 84]], [[3045, 3974], [14, 15], [8, 30]], [[8064, 6161], [-24, -28], [-23, 18], [0, 51], [13, 26], [31, 17], [16, -1], [6, -23], [-12, -26], [-7, -34]], [[8628, 7562], [-18, 35], [-11, -33], [-43, -26], [4, -31], [-24, 2], [-13, 19], [-19, -42], [-30, -32], [-23, -38]], [[8451, 7416], [-39, -17], [-20, -27], [-30, -17], [15, 28], [-6, 23], [22, 40], [-15, 30], [-24, -20], [-32, -41], [-17, -39], [-27, -2], [-14, -28], [15, -40], [22, -10], [1, -26], [22, -17], [31, 42], [25, -23], [18, -2], [4, -31], [-39, -16], [-13, -32], [-27, -30], [-14, -41], [30, -33], [11, -58], [17, -54], [18, -45], [0, -44], [-17, -16], [6, -32], [17, -18], [-5, -48], [-7, -47], [-15, -5], [-21, -64], [-22, -78], [-26, -70], [-38, -55], [-39, -50], [-31, -6], [-17, -27], [-10, 20], [-15, -30], [-39, -29], [-29, -9], [-10, -63], [-15, -3], [-8, 43], [7, 22], [-37, 19], [-13, -9]], [[8001, 6331], [-28, 15], [-14, 24], [5, 34], [-26, 11], [-13, 22], [-24, -31], [-27, -7], [-22, 0], [-15, -14]], [[7837, 6385], [-14, -9], [4, -68], [-15, 2], [-2, 14]], [[7810, 6324], [-1, 24], [-20, -17], [-12, 11], [-21, 22], [8, 49], [-18, 12], [-6, 54], [-30, -10], [4, 70], [26, 50], [1, 48], [-1, 46], [-12, 14], [-9, 35], [-16, -5]], [[7703, 6727], [-30, 9], [9, 25], [-13, 36], [-20, -24], [-23, 14], [-32, -37], [-25, -44], [-23, -8]], [[7466, 6670], [-2, 47], [-17, -13]], [[7447, 6704], [-32, 6], [-32, 14], [-22, 26], [-22, 11], [-9, 29], [-16, 8], [-28, 39], [-22, 18], [-12, -14]], [[7252, 6841], [-38, 41], [-28, 37], [-7, 65], [20, -7], [1, 30], [-12, 30], [3, 48], [-30, 69]], [[7161, 7154], [-45, 24], [-8, 46], [-21, 27]], [[7082, 7268], [-4, 34], [1, 23], [-17, 13], [-9, -6], [-7, 55]], [[7046, 7387], [8, 13], [-4, 14], [26, 28], [20, 12], [29, -8], [11, 38], [35, 7], [10, 23], [44, 32], [4, 13]], [[7229, 7559], [-2, 34], [19, 15], [-25, 103], [55, 24], [14, 13], [20, 106], [55, -20], [15, 27], [2, 59], [23, 6], [21, 39]], [[7426, 7965], [11, 5]], [[7437, 7970], [7, -41], [23, -32], [40, -22], [19, -47], [-10, -70], [10, -25], [33, -10], [37, -8], [33, -37], [18, -7], [12, -54], [17, -35], [30, 1], [58, -13], [36, 8], [28, -9], [41, -36], [34, 0], [12, -18], [32, 32], [45, 20], [42, 2], [32, 21], [20, 32], [20, 20], [-5, 19], [-9, 23], [15, 38], [15, -5], [29, -12], [28, 31], [42, 23], [20, 39], [20, 17], [40, 8], [22, -7], [3, 21], [-25, 41], [-22, 19], [-22, -22], [-27, 10], [-16, -8], [-7, 24], [20, 59], [13, 45]], [[8240, 8005], [34, -23], [39, 38], [-1, 26], [26, 62], [15, 19], [0, 33], [-16, 14], [23, 29], [35, 11], [37, 2], [41, -18], [25, -22], [17, -59], [10, -26], [10, -36], [10, -58], [49, -19], [32, -42], [12, -55], [42, 0], [24, 23], [46, 17], [-15, -53], [-11, -21], [-9, -65], [-19, -58], [-33, 11], [-24, -21], [7, -51], [-4, -69], [-14, -2], [0, -30]], [[4920, 5353], [-12, -1], [-20, 12], [-18, -1], [-33, -10], [-19, -18], [-27, -21], [-6, 1]], [[4785, 5315], [2, 49], [3, 7], [-1, 24], [-12, 24], [-8, 4], [-8, 17], [6, 26], [-3, 28], [1, 18]], [[4765, 5512], [5, 0], [1, 25], [-2, 12], [3, 8], [10, 7], [-7, 47], [-6, 25], [2, 20], [5, 4]], [[4776, 5660], [4, 6], [8, -9], [21, -1], [5, 18], [5, -1], [8, 6], [4, -25], [7, 7], [11, 9]], [[4921, 5627], [7, -84], [-11, -50], [-8, -66], [12, -51], [-1, -23]], [[5363, 5191], [-4, 4], [-16, -8], [-17, 8], [-13, -4]], [[5313, 5191], [-45, 1]], [[5268, 5192], [4, 47], [-11, 39], [-13, 10], [-6, 27], [-7, 8], [1, 16]], [[5236, 5339], [7, 42], [13, 57], [8, 1], [17, 34], [10, 1], [16, -24], [19, 20], [2, 25], [7, 23], [4, 30], [15, 25], [5, 41], [6, 13], [4, 31], [7, 37], [24, 46], [1, 20], [3, 10], [-11, 24]], [[5393, 5795], [1, 19], [8, 3]], [[5402, 5817], [11, -38], [2, -39], [-1, -39], [15, -54], [-15, 1], [-8, -4], [-13, 6], [-6, -28], [16, -35], [13, -10], [3, -24], [9, -41], [-4, -16]], [[5444, 5191], [-2, -31], [-22, 14], [-22, 15], [-35, 2]], [[5856, 5265], [-2, -69], [11, -8], [-9, -21], [-10, -16], [-11, -31], [-6, -27], [-1, -48], [-7, -22], [0, -45]], [[5821, 4978], [-8, -16], [-1, -35], [-4, -5], [-2, -32]], [[5814, 4792], [5, -55], [-2, -30], [5, -35], [16, -33], [15, -74]], [[5853, 4565], [-11, 6], [-37, -10], [-7, -7], [-8, -38], [6, -26], [-5, -70], [-3, -59], [7, -11], [19, -23], [8, 11], [2, -64], [-21, 1], [-11, 32], [-10, 25], [-22, 9], [-6, 31], [-17, -19], [-22, 8], [-10, 27], [-17, 6], [-13, -2], [-2, 19], [-9, 1]], [[5342, 4697], [-4, 18]], [[5360, 4775], [8, -6], [9, 23], [15, -1], [2, -17], [11, -10], [16, 37], [16, 29], [7, 19], [-1, 48], [12, 58], [13, 30], [18, 29], [3, 18], [1, 22], [5, 21], [-2, 33], [4, 52], [5, 37], [8, 32], [2, 36]], [[5760, 5367], [17, -49], [12, -7], [8, 10], [12, -4], [16, 12], [6, -25], [25, -39]], [[5330, 4760], [-22, 62]], [[5308, 4822], [21, 33], [-11, 39], [10, 15], [19, 7], [2, 26], [15, -28], [24, -2], [9, 27], [3, 40], [-3, 46], [-13, 35], [12, 68], [-7, 12], [-21, -5], [-7, 31], [2, 25]], [[2906, 5049], [-12, 14], [-14, 19], [-7, -9], [-24, 8], [-7, 25], [-5, -1], [-28, 34]], [[2809, 5139], [-3, 18], [10, 5], [-1, 29], [6, 22], [14, 4], [12, 37], [10, 31], [-10, 14], [5, 34], [-6, 54], [6, 16], [-4, 50], [-12, 31]], [[2836, 5484], [4, 29], [9, -4], [5, 17], [-6, 35], [3, 9]], [[2851, 5570], [14, -2], [21, 41], [12, 6], [0, 20], [5, 50], [16, 27], [17, 1], [3, 13], [21, -5], [22, 30], [11, 13], [14, 28], [9, -3], [8, -16], [-6, -20]], [[3018, 5753], [-18, -10], [-7, -29], [-10, -17], [-8, -22], [-4, -42], [-8, -35], [15, -4], [3, -27], [6, -13], [3, -24], [-4, -22], [1, -12], [7, -5], [7, -20], [36, 5], [16, -7], [19, -51], [11, 6], [20, -3], [16, 7], [10, -10], [-5, -32], [-6, -20], [-2, -42], [5, -40], [8, -17], [1, -13], [-14, -30], [10, -13], [8, -21], [8, -58]], [[3058, 4804], [-14, 31], [-8, 1], [18, 61], [-21, 27], [-17, -5], [-10, 10], [-15, -15], [-21, 7], [-16, 62], [-13, 15], [-9, 28], [-19, 28], [-7, -5]], [[2695, 5543], [-15, 14], [-6, 12], [4, 10], [-1, 13], [-8, 14], [-11, 12], [-10, 8], [-1, 17], [-8, 10], [2, -17], [-5, -14], [-7, 17], [-9, 5], [-4, 12], [1, 18], [3, 19], [-8, 8], [7, 12]], [[2619, 5713], [4, 7], [18, -15], [7, 7], [9, -5], [4, -12], [8, -4], [7, 13]], [[2676, 5704], [7, -32], [11, -24], [13, -25]], [[2707, 5623], [-11, -6], [0, -23], [6, -9], [-4, -7], [1, -11], [-2, -12], [-2, -12]], [[2715, 6427], [23, -4], [22, 0], [26, -21], [11, -21], [26, 6], [10, -13], [24, -37], [17, -27], [9, 1], [17, -12], [-2, -17], [20, -2], [21, -24], [-3, -14], [-19, -7], [-18, -3], [-19, 4], [-40, -5], [18, 32], [-11, 16], [-18, 4], [-9, 17], [-7, 33], [-16, -2], [-26, 16], [-8, 12], [-36, 10], [-10, 11], [11, 15], [-28, 3], [-20, -31], [-11, -1], [-4, -14], [-14, -7], [-12, 6], [15, 18], [6, 22], [13, 13], [14, 11], [21, 6], [7, 6]], [[5909, 7133], [2, 1], [4, 14], [20, -1], [25, 18], [-19, -25], [2, -11]], [[5943, 7129], [-3, 2], [-5, -5], [-4, 1], [-2, -2], [0, 6], [-2, 4], [-6, 0], [-7, -5], [-5, 3]], [[5943, 7129], [1, -5], [-28, -24], [-14, 8], [-7, 23], [14, 2]], [[5377, 7945], [-16, 25], [-14, 15], [-3, 25], [-5, 17], [21, 13], [10, 15], [20, 11], [7, 11], [7, -6], [13, 6]], [[5417, 8077], [13, -19], [21, -5], [-2, -17], [15, -12], [4, 15], [19, -6], [3, -19], [20, -3], [13, -29]], [[5523, 7982], [-8, 0], [-4, -11], [-7, -3], [-2, -13], [-5, -3], [-1, -5], [-9, -7], [-12, 1], [-4, -13]], [[5275, 8306], [1, -23], [28, -14], [-1, -21], [29, 11], [15, 16], [32, -23], [13, -19]], [[5392, 8233], [6, -30], [-8, -16], [11, -21], [6, -31], [-2, -21], [12, -37]], [[5207, 7871], [3, 42], [14, 40], [-40, 11], [-13, 16]], [[5171, 7980], [2, 26], [-6, 13]], [[5171, 8059], [-5, 62], [17, 0], [7, 22], [6, 54], [-5, 20]], [[5191, 8217], [6, 13], [23, 3], [5, -13], [19, 29], [-6, 22], [-2, 34]], [[5236, 8305], [21, -8], [18, 9]], [[6196, 5808], [7, -19], [-1, -24], [-16, -14], [12, -16]], [[6198, 5735], [-10, -32]], [[6188, 5703], [-7, 11], [-6, -5], [-16, 1], [0, 18], [-2, 17], [9, 27], [10, 26]], [[6176, 5798], [12, -5], [8, 15]], [[5352, 8343], [-17, -48], [-29, 33], [-4, 25], [41, 19], [9, -29]], [[5236, 8305], [-11, 32], [-1, 61], [5, 16], [8, 17], [24, 4], [10, 16], [22, 17], [-1, -30], [-8, -20], [4, -16], [15, -9], [-7, -22], [-8, 6], [-20, -42], [7, -29]], [[3008, 6222], [3, 10], [22, 0], [16, -15], [8, 1], [5, -21], [15, 1], [-1, -17], [12, -2], [14, -22], [-10, -24], [-14, 13], [-12, -3], [-9, 3], [-5, -11], [-11, -3], [-4, 14], [-10, -8], [-11, -41], [-7, 10], [-1, 17]], [[3008, 6124], [0, 16], [-7, 17], [7, 10], [2, 23], [-2, 32]], [[5333, 6444], [-95, -112], [-81, -117], [-39, -26]], [[5118, 6189], [-31, -6], [0, 38], [-13, 10], [-17, 16], [-7, 28], [-94, 129], [-93, 129]], [[4863, 6533], [-105, 143]], [[4758, 6676], [1, 11], [0, 4]], [[4759, 6691], [0, 70], [44, 44], [28, 9], [23, 16], [11, 29], [32, 24], [1, 44], [16, 5], [13, 22], [36, 9], [5, 23], [-7, 13], [-10, 62], [-1, 36], [-11, 38]], [[4939, 7135], [27, 32], [30, 11], [17, 24], [27, 18], [47, 11], [46, 4], [14, -8], [26, 23], [30, 0], [11, -13], [19, 3]], [[5233, 7240], [-5, -30], [4, -56], [-6, -49], [-18, -33], [3, -45], [23, -35], [0, -14], [17, -24], [12, -106]], [[5263, 6848], [9, -52], [1, -28], [-5, -48], [2, -27], [-3, -32], [2, -37], [-11, -25], [17, -43], [1, -25], [10, -33], [13, 11], [22, -28], [12, -37]], [[2769, 4856], [15, 45], [-6, 25], [-11, -27], [-16, 26], [5, 16], [-4, 54], [9, 9], [5, 37], [11, 38], [-2, 24], [15, 13], [19, 23]], [[2906, 5049], [4, -45], [-9, -39], [-30, -62], [-33, -23], [-17, -51], [-6, -40], [-15, -24], [-12, 29], [-11, 7], [-12, -5], [-1, 22], [8, 14], [-3, 24]], [[5969, 6800], [-7, -23], [-6, -45], [-8, -31], [-6, -10], [-10, 19], [-12, 26], [-20, 85], [-3, -5], [12, -63], [17, -59], [21, -92], [10, -32], [9, -34], [25, -65], [-6, -10], [1, -39], [33, -53], [4, -12]], [[6023, 6357], [-110, 0], [-107, 0], [-112, 0]], [[5694, 6357], [0, 218], [0, 210], [-8, 47], [7, 37], [-5, 25], [10, 29]], [[5698, 6923], [37, 0], [27, -15], [28, -18], [13, -9], [21, 19], [11, 17], [25, 5], [20, -8], [7, -29], [7, 19], [22, -14], [22, -3], [13, 15]], [[5951, 6902], [18, -102]], [[6176, 5798], [-10, 20], [-11, 34], [-12, 19], [-8, 21], [-24, 23], [-19, 1], [-7, 12], [-16, -14], [-17, 27], [-8, -44], [-33, 13]], [[6011, 5910], [-3, 23], [12, 87], [3, 39], [9, 18], [20, 10], [14, 34]], [[6066, 6121], [16, -69], [8, -54], [15, -29], [38, -55], [16, -34], [15, -34], [8, -20], [14, -18]], [[4749, 7532], [1, 42], [-11, 25], [39, 43], [34, -11], [37, 1], [30, -10], [23, 3], [45, -2]], [[4947, 7623], [11, -23], [51, -27], [10, 13], [31, -27], [32, 8]], [[5082, 7567], [2, -35], [-26, -39], [-36, -12], [-2, -20], [-18, -33], [-10, -48], [11, -34], [-16, -26], [-6, -39], [-21, -11], [-20, -46], [-35, -1], [-27, 1], [-17, -21], [-11, -22], [-13, 5], [-11, 20], [-8, 34], [-26, 9]], [[4792, 7249], [-2, 20], [10, 22], [4, 16], [-9, 17], [7, 39], [-11, 36], [12, 5], [1, 27], [5, 9], [0, 46], [13, 16], [-8, 30], [-16, 2], [-5, -8], [-16, 0], [-7, 29], [-11, -8], [-10, -15]], [[5675, 8472], [3, 35], [-10, -8], [-18, 21], [-2, 34], [35, 17], [35, 8], [30, -10], [29, 2]], [[5777, 8571], [4, -10], [-20, -34], [8, -55], [-12, -19]], [[5757, 8453], [-22, 0], [-24, 22], [-13, 7], [-23, -10]], [[6188, 5703], [-6, -21], [10, -32], [10, -29], [11, -21], [90, -70], [24, 0]], [[6327, 5530], [-79, -177], [-36, -3], [-25, -41], [-17, -1], [-8, -19]], [[6162, 5289], [-19, 0], [-11, 20], [-26, -25], [-8, -24], [-18, 4], [-6, 7], [-7, -1], [-9, 0], [-35, 50], [-19, 0], [-10, 20], [0, 33], [-14, 10]], [[5980, 5383], [-17, 64], [-12, 14], [-5, 23], [-14, 29], [-17, 4], [9, 34], [15, 2], [4, 18]], [[5943, 5571], [0, 53]], [[5943, 5624], [8, 62], [13, 16], [3, 24], [12, 45], [17, 30], [11, 58], [4, 51]], [[5794, 9138], [-4, -42], [42, -39], [-26, -45], [33, -67], [-19, -51], [25, -43], [-11, -39], [41, -40], [-11, -31], [-25, -34], [-60, -75]], [[5779, 8632], [-50, -5], [-49, -21], [-45, -13], [-16, 32], [-27, 20], [6, 58], [-14, 53], [14, 35], [25, 37], [63, 64], [19, 12], [-3, 25], [-39, 28]], [[5663, 8957], [-9, 23], [-1, 91], [-43, 40], [-37, 29]], [[5573, 9140], [17, 16], [30, -32], [37, 3], [30, -14], [26, 26], [14, 44], [43, 20], [35, -24], [-11, -41]], [[9954, 4033], [9, -17], [-4, -31], [-17, -8], [-16, 7], [-2, 26], [10, 21], [13, -8], [7, 10]], [[0, 4079], [9981, -14], [-17, -13], [-4, 23], [14, 12], [9, 3], [-9983, 18]], [[0, 4108], [0, -29]], [[0, 4108], [6, 3], [-4, -28], [-2, -4]], [[3300, 1994], [33, 36], [24, -15], [16, 24], [22, -27], [-8, -21], [-37, -17], [-13, 20], [-23, -26], [-14, 26]], [[5265, 7548], [-9, -46], [-13, 12], [-6, 40], [5, 22], [18, 22], [5, -50]], [[5157, 7984], [6, -6], [8, 2]], [[5190, 7775], [-2, -17], [9, -22], [-10, -18], [7, -46], [15, -8], [-3, -25]], [[5206, 7639], [-25, -34], [-55, 16], [-40, -19], [-4, -35]], [[4947, 7623], [14, 35], [5, 118], [-28, 62], [-21, 30], [-42, 23], [-3, 43], [36, 12], [47, -15], [-9, 67], [26, -25], [65, 46], [8, 48], [24, 12]], [[3485, 5194], [7, 25], [3, 27]], [[3495, 5246], [4, 26], [-10, 34]], [[3489, 5306], [-3, 41], [15, 51]], [[3501, 5398], [9, -7], [21, -14], [29, -50], [5, -24]], [[5308, 4822], [-29, 60], [-18, 49], [-17, 61], [1, 19], [6, 19], [7, 43], [5, 44]], [[5263, 5117], [10, 4], [40, -1], [0, 71]], [[4827, 8240], [-21, 12], [-17, -1], [6, 32], [-6, 32]], [[4789, 8315], [23, 2], [30, -37], [-15, -40]], [[4916, 8521], [-30, -63], [29, 8], [30, -1], [-7, -48], [-25, -53], [29, -4], [2, -6], [25, -69], [19, -10], [17, -67], [8, -24], [33, -11], [-3, -38], [-14, -17], [11, -30], [-25, -31], [-37, 0], [-48, -16], [-13, 12], [-18, -28], [-26, 7], [-19, -23], [-15, 12], [41, 62], [25, 13], [-1, 0], [-43, 9], [-8, 24], [29, 18], [-15, 32], [5, 39], [42, -6], [4, 35], [-19, 36], [0, 1], [-34, 10], [-7, 16], [10, 27], [-9, 16], [-15, -28], [-1, 57], [-14, 30], [10, 61], [21, 48], [23, -4], [33, 4]], [[6154, 7511], [4, 26], [-7, 40], [-16, 22], [-16, 6], [-10, 19]], [[6109, 7624], [4, 6], [23, -10], [41, -9], [38, -28], [5, -11], [17, 9], [25, -13], [9, -24], [17, -13]], [[6210, 7485], [-27, 29], [-29, -3]], [[5029, 5408], [-44, -35], [-15, -20], [-25, -17], [-25, 17]], [[5000, 5708], [-2, -18], [12, -30], [0, -43], [2, -47], [7, -21], [-6, -54], [2, -29], [8, -37], [6, -21]], [[4765, 5512], [-8, 1], [-5, -24], [-8, 1], [-6, 12], [2, 24], [-11, 36], [-8, -7], [-6, -1]], [[4715, 5554], [-7, -3], [0, 21], [-4, 16], [0, 17], [-6, 25], [-7, 21], [-23, 0], [-6, -11], [-8, -1], [-4, -13], [-4, -17], [-14, -26]], [[4632, 5583], [-13, 35], [-10, 24], [-8, 7], [-6, 12], [-4, 26], [-4, 13], [-8, 10]], [[4579, 5710], [13, 29], [8, -2], [7, 10], [6, 0], [5, 8], [-3, 20], [3, 6], [1, 20]], [[4619, 5801], [13, -1], [20, -14], [6, 1], [3, 7], [15, -5], [4, 4]], [[4680, 5793], [1, -22], [5, 0], [7, 8], [5, -2], [7, -15], [12, -5], [8, 13], [9, 8], [6, 8], [6, -1], [6, -13], [3, -17], [12, -24], [-6, -16], [-1, -19], [6, 6], [3, -7], [-1, -17], [8, -18]], [[4532, 5834], [3, 27]], [[4535, 5861], [31, 1], [6, 14], [9, 1], [11, -14], [8, -1], [9, 10], [6, -17], [-12, -13], [-12, 1], [-12, 13], [-10, -14], [-5, -1], [-7, -8], [-25, 1]], [[4579, 5710], [-15, 24], [-11, 4], [-7, 17], [1, 9], [-9, 13], [-2, 12]], [[4536, 5789], [15, 10], [9, -2], [8, 7], [51, -3]], [[5263, 5117], [-5, 9], [10, 66]], [[5658, 7167], [15, -20], [22, 3], [20, -4], [0, -10], [15, 7], [-4, -18], [-40, -5], [1, 10], [-34, 12], [5, 25]], [[5723, 7469], [-17, 2], [-14, 6], [-34, -16], [19, -33], [-14, -10], [-15, 0], [-15, 31], [-5, -13], [6, -36], [14, -27], [-10, -13], [15, -27], [14, -18], [0, -33], [-25, 16], [8, -30], [-18, -7], [11, -52], [-19, -1], [-23, 26], [-10, 47], [-5, 40], [-11, 27], [-14, 34], [-2, 16]], [[5583, 7470], [18, 6], [11, 13], [15, -2], [5, 11], [5, 2]], [[5725, 7529], [13, -16], [-8, -37], [-7, -7]], [[3701, 9939], [93, 35], [97, -2], [36, 21], [98, 6], [222, -7], [174, -47], [-52, -23], [-106, -3], [-150, -5], [14, -11], [99, 7], [83, -21], [54, 18], [23, -21], [-30, -34], [71, 22], [135, 23], [83, -12], [15, -25], [-113, -42], [-16, -14], [-88, -10], [64, -3], [-32, -43], [-23, -38], [1, -66], [33, -38], [-43, -3], [-46, -19], [52, -31], [6, -50], [-30, -6], [36, -50], [-61, -5], [32, -24], [-9, -20], [-39, -10], [-39, 0], [35, -40], [0, -26], [-55, 24], [-14, -15], [37, -15], [37, -36], [10, -48], [-49, -11], [-22, 22], [-34, 34], [10, -40], [-33, -31], [73, -2], [39, -3], [-75, -52], [-75, -46], [-81, -21], [-31, 0], [-29, -23], [-38, -62], [-60, -42], [-19, -2], [-37, -15], [-40, -13], [-24, -37], [0, -41], [-15, -39], [-45, -47], [11, -47], [-12, -48], [-14, -58], [-39, -4], [-41, 49], [-56, 0], [-27, 32], [-18, 58], [-49, 73], [-14, 39], [-3, 53], [-39, 54], [10, 44], [-18, 21], [27, 69], [42, 22], [11, 25], [6, 46], [-32, -21], [-15, -9], [-25, -8], [-34, 19], [-2, 40], [11, 31], [25, 1], [57, -15], [-48, 37], [-24, 20], [-28, -8], [-23, 15], [31, 55], [-17, 22], [-22, 41], [-34, 62], [-35, 23], [0, 25], [-74, 34], [-59, 5], [-74, -3], [-68, -4], [-32, 19], [-49, 37], [73, 19], [56, 3], [-119, 15], [-62, 24], [3, 23], [106, 28], [101, 29], [11, 21], [-75, 22], [24, 23], [97, 41], [40, 7], [-12, 26], [66, 16], [86, 9], [85, 1], [30, -19], [74, 33], [66, -22], [39, -5], [58, -19], [-66, 32], [4, 25]], [[2497, 5869], [-14, 10], [-17, 1], [-13, 12], [-15, 24]], [[2438, 5916], [1, 18], [3, 13], [-4, 12], [13, 48], [36, 0], [1, 20], [-5, 4], [-3, 12], [-10, 14], [-11, 20], [13, 0], [0, 33], [26, 0], [26, 0]], [[2529, 5996], [10, -11], [2, 9], [8, -7]], [[2549, 5987], [-13, -23], [-13, -16], [-2, -12], [2, -11], [-5, -15]], [[2518, 5910], [-7, -4], [2, -7], [-6, -6], [-9, -15], [-1, -9]], [[3340, 5552], [18, -22], [17, -38], [1, -31], [10, -1], [15, -29], [11, -21]], [[3412, 5410], [-4, -53], [-17, -15], [1, -14], [-5, -31], [13, -42], [9, -1], [3, -33], [17, -51]], [[3313, 5365], [-19, 45], [7, 16], [0, 27], [17, 10], [7, 11], [-10, 22], [3, 21], [22, 35]], [[2574, 5825], [-5, 18], [-8, 5]], [[2561, 5848], [2, 24], [-4, 6], [-6, 4], [-12, -7], [-1, 8], [-8, 10], [-6, 12], [-8, 5]], [[2549, 5987], [3, -3], [6, 11], [8, 1], [3, -5], [4, 3], [13, -6], [13, 2], [9, 6], [3, 7], [9, -3], [6, -4], [8, 1], [5, 5], [13, -8], [4, -1], [9, -11], [8, -13], [10, -9], [7, -17]], [[2690, 5943], [-9, 2], [-4, -8], [-10, -8], [-7, 0], [-6, -8], [-6, 3], [-4, 9], [-3, -2], [-4, -14], [-3, 1], [0, -12], [-10, -17], [-5, -7], [-3, -7], [-8, 12], [-6, -16], [-6, 1], [-6, -2], [0, -29], [-4, 0], [-3, -14], [-9, -2]], [[5522, 7770], [7, -23], [9, -17], [-11, -22]], [[5515, 7577], [-3, -10]], [[5512, 7567], [-26, 22], [-16, 21], [-26, 18], [-23, 43], [6, 5], [-13, 25], [-1, 19], [-17, 10], [-9, -26], [-8, 20], [0, 21], [1, 1]], [[5380, 7746], [20, -2], [5, 9], [9, -9], [11, -1], [0, 16], [10, 6], [2, 24], [23, 16]], [[5460, 7805], [8, -7], [21, -26], [23, -11], [10, 9]], [[3008, 6124], [-19, 10], [-13, -5], [-17, 5], [-13, -11], [-15, 18], [3, 19], [25, -8], [21, -5], [10, 13], [-12, 26], [0, 23], [-18, 9], [7, 16], [17, -3], [24, -9]], [[5471, 7900], [14, -15], [10, -6], [24, 7], [2, 12], [11, 2], [14, 9], [3, -4], [13, 8], [6, 13], [9, 4], [30, -18], [6, 6]], [[5613, 7918], [15, -16], [2, -16]], [[5630, 7886], [-17, -12], [-13, -40], [-17, -40], [-22, -11]], [[5561, 7783], [-17, 2], [-22, -15]], [[5460, 7805], [-6, 20], [-4, 0]], [[8352, 4453], [-11, -2], [-37, 42], [26, 11], [14, -18], [10, -17], [-2, -16]], [[8471, 4532], [2, -11], [1, -18]], [[8474, 4503], [-18, -45], [-24, -13], [-3, 8], [2, 20], [12, 36], [28, 23]], [[8274, 4579], [10, -16], [17, 5], [7, -25], [-32, -12], [-19, -8], [-15, 1], [10, 34], [15, 0], [7, 21]], [[8413, 4579], [-4, -32], [-42, -17], [-37, 7], [0, 22], [22, 12], [18, -18], [18, 5], [25, 21]], [[8017, 4657], [53, -6], [6, 25], [51, -29], [10, -38], [42, -11], [34, -35], [-31, -23], [-31, 24], [-25, -1], [-29, 4], [-26, 11], [-32, 22], [-21, 6], [-11, -7], [-51, 24], [-5, 25], [-25, 5], [19, 56], [34, -3], [22, -23], [12, -5], [4, -21]], [[8741, 4690], [-14, -40], [-3, 45], [5, 21], [6, 20], [7, -17], [-1, -29]], [[8534, 4853], [-11, -19], [-19, 10], [-5, 26], [28, 3], [7, -20]], [[8623, 4875], [10, -45], [-23, 24], [-23, 5], [-16, -4], [-19, 2], [6, 33], [35, 2], [30, -17]], [[8916, 4904], [0, -193], [1, -192]], [[8917, 4519], [-25, 48], [-28, 12], [-7, -17], [-35, -1], [12, 48], [17, 16], [-7, 64], [-14, 50], [-53, 50], [-23, 5], [-42, 54], [-8, -28], [-11, -5], [-6, 21], [0, 26], [-21, 29], [29, 21], [20, -1], [-2, 16], [-41, 0], [-11, 35], [-25, 11], [-11, 29], [37, 14], [14, 20], [45, -25], [4, -22], [8, -95], [29, -35], [23, 62], [32, 36], [25, 0], [23, -21], [21, -21], [30, -11]], [[8478, 5141], [-22, -58], [-21, -12], [-27, 12], [-46, -3], [-24, -8], [-4, -45], [24, -53], [15, 27], [52, 20], [-2, -27], [-12, 9], [-12, -35], [-25, -23], [27, -76], [-5, -20], [25, -68], [-1, -39], [-14, -17], [-11, 20], [13, 49], [-27, -23], [-7, 16], [3, 23], [-20, 35], [3, 57], [-19, -18], [2, -69], [1, -84], [-17, -9], [-12, 18], [8, 54], [-4, 57], [-12, 1], [-9, 40], [12, 39], [4, 47], [14, 89], [5, 24], [24, 44], [22, -18], [35, -8], [32, 3], [27, 43], [5, -14]], [[8574, 5124], [-2, -51], [-14, 6], [-4, -36], [11, -32], [-8, -7], [-11, 38], [-8, 75], [6, 47], [9, 22], [2, -32], [16, -5], [3, -25]], [[8045, 5176], [5, -39], [19, -34], [18, 12], [18, -4], [16, 30], [13, 5], [26, -17], [23, 13], [14, 82], [11, 21], [10, 67], [32, 0], [24, -10]], [[8274, 5302], [-16, -53], [20, -56], [-5, -28], [32, -54], [-33, -7], [-10, -40], [2, -54], [-27, -40], [-1, -59], [-10, -91], [-5, 21], [-31, -26], [-11, 36], [-20, 3], [-14, 19], [-33, -21], [-10, 29], [-18, -4], [-23, 7], [-4, 79], [-14, 17], [-13, 50], [-4, 52], [3, 55], [16, 39]], [[7939, 4712], [-31, -1], [-24, 49], [-35, 48], [-12, 36], [-21, 48], [-14, 44], [-21, 83], [-24, 49], [-9, 51], [-10, 46], [-25, 37], [-14, 51], [-21, 33], [-29, 65], [-3, 30], [18, -2], [43, -12], [25, -57], [21, -40], [16, -25], [26, -63], [28, -1], [23, -41], [16, -49], [22, -27], [-12, -49], [16, -20], [10, -2], [5, -41], [10, -33], [20, -5], [14, -37], [-7, -74], [-1, -91]], [[7252, 6841], [-17, -27], [-11, -55], [27, -23], [26, -29], [36, -33], [38, -8], [16, -30], [22, -5], [33, -14], [23, 1], [4, 23], [-4, 38], [2, 25]], [[7703, 6727], [2, -22], [-10, -11], [2, -36], [-19, 10], [-36, -41], [0, -33], [-15, -50], [-1, -29], [-13, -48], [-21, 13], [-1, -61], [-7, -20], [3, -25], [-14, -14]], [[7472, 6360], [-4, -21], [-19, 1], [-34, -13], [2, -44], [-15, -35], [-40, -40], [-31, -69], [-21, -38], [-28, -38], [0, -27], [-13, -15], [-26, -21], [-12, -3], [-9, -45], [6, -77], [1, -49], [-11, -56], [0, -101], [-15, -2], [-12, -46], [8, -19], [-25, -17], [-10, -40], [-11, -17], [-26, 55], [-13, 83], [-11, 60], [-9, 28], [-15, 56], [-7, 74], [-5, 37], [-25, 81], [-12, 115], [-8, 75], [0, 72], [-5, 55], [-41, -35], [-19, 7], [-36, 71], [13, 22], [-8, 23], [-33, 50]], [[6893, 6457], [19, 40], [61, -1], [-6, 51], [-15, 30], [-4, 46], [-18, 26], [31, 62], [32, -4], [29, 61], [18, 60], [27, 60], [-1, 42], [24, 34], [-23, 29], [-9, 40], [-10, 52], [14, 25], [42, -14], [31, 9], [26, 49]], [[4827, 8240], [5, -42], [-21, -53], [-49, -35], [-40, 9], [23, 62], [-15, 60], [38, 46], [21, 28]], [[6497, 7255], [25, 12], [19, 33], [19, -1], [12, 11], [20, -6], [31, -30], [22, -6], [31, -53], [21, -2], [3, -49]], [[6690, 6820], [14, -31], [11, -36], [27, -26], [1, -52], [13, -10], [2, -27], [-40, -30], [-10, -69]], [[6708, 6539], [-53, 18], [-30, 13], [-31, 8], [-12, 73], [-13, 10], [-22, -11], [-28, -28], [-34, 20], [-28, 45], [-27, 17], [-18, 56], [-21, 79], [-15, -10], [-17, 20], [-11, -24]], [[6348, 6825], [-15, 32], [0, 31], [-9, 0], [5, 43], [-15, 45], [-34, 32], [-19, 56], [6, 46], [14, 21], [-2, 34], [-18, 18], [-18, 70]], [[6243, 7253], [-15, 48], [5, 18], [-8, 68], [19, 17]], [[6357, 7321], [9, -43], [26, -13], [20, -29], [39, -10], [44, 15], [2, 14]], [[6348, 6825], [-16, 3]], [[6332, 6828], [-19, 5], [-20, -56]], [[6293, 6777], [-52, 4], [-78, 119], [-41, 41], [-34, 16]], [[6088, 6957], [-11, 72]], [[6077, 7029], [61, 62], [11, 71], [-3, 43], [16, 15], [14, 37]], [[6176, 7257], [12, 9], [32, -8], [10, -15], [13, 10]], [[4597, 8984], [-7, -39], [31, -40], [-36, -45], [-80, -41], [-24, -10], [-36, 8], [-78, 19], [28, 26], [-61, 29], [49, 12], [-1, 17], [-58, 14], [19, 38], [42, 9], [43, -40], [42, 32], [35, -17], [45, 32], [47, -4]], [[5992, 6990], [-5, -19]], [[5987, 6971], [-10, 8], [-6, -39], [7, -7], [-7, -8], [-1, -15], [13, 8]], [[5983, 6918], [0, -23], [-14, -95]], [[5951, 6902], [8, 19], [-2, 4], [8, 27], [5, 45], [4, 15], [1, 0]], [[5975, 7012], [9, 0], [3, 11], [7, 0]], [[5994, 7023], [1, -24], [-4, -9], [1, 0]], [[5431, 7316], [-10, -46], [4, -19], [-6, -30], [-21, 22], [-14, 7], [-39, 30], [4, 30], [32, -6], [28, 7], [22, 5]], [[5255, 7492], [17, -42], [-4, -78], [-13, 4], [-11, -20], [-10, 16], [-2, 71], [-6, 34], [15, -3], [14, 18]], [[5383, 7805], [-3, -29], [7, -25]], [[5387, 7751], [-22, 8], [-23, -20], [1, -30], [-3, -17], [9, -30], [26, -29], [14, -49], [31, -48], [22, 0], [7, -13], [-8, -11], [25, -22], [20, -18], [24, -30], [3, -11], [-5, -22], [-16, 28], [-24, 10], [-12, -39], [20, -21], [-3, -31], [-11, -4], [-15, -50], [-12, -5], [0, 18], [6, 32], [6, 12], [-11, 35], [-8, 29], [-12, 8], [-8, 25], [-18, 11], [-12, 24], [-21, 4], [-21, 26], [-26, 39], [-19, 34], [-8, 58], [-14, 7], [-23, 20], [-12, -8], [-16, -28], [-12, -4]], [[2845, 6150], [19, -5], [14, -15], [5, -16], [-19, -1], [-9, -10], [-15, 10], [-16, 21], [3, 14], [12, 4], [6, -2]], [[5992, 6990], [31, -24], [54, 63]], [[6088, 6957], [-5, -8], [-56, -30], [28, -59], [-9, -10], [-5, -20], [-21, -8], [-7, -21], [-12, -19], [-31, 10]], [[5970, 6792], [-1, 8]], [[5983, 6918], [4, 17], [0, 36]], [[8739, 7075], [4, -20], [-16, -36], [-11, 19], [-15, -14], [-7, -34], [-18, 16], [0, 28], [15, 36], [16, -7], [12, 25], [20, -13]], [[8915, 7252], [-10, -47], [4, -30], [-14, -42], [-35, -27], [-49, -4], [-40, -67], [-19, 22], [-1, 44], [-48, -13], [-33, -27], [-32, -2], [28, -43], [-19, -101], [-18, -24], [-13, 23], [7, 53], [-18, 17], [-11, 41], [26, 18], [15, 37], [28, 30], [20, 41], [55, 17], [30, -12], [29, 105], [19, -28], [40, 59], [16, 23], [18, 72], [-5, 67], [11, 37], [30, 11], [15, -82], [-1, -48], [-25, -59], [0, -61]], [[8997, 7667], [19, -12], [20, 25], [6, -67], [-41, -16], [-25, -59], [-43, 41], [-15, -65], [-31, -1], [-4, 59], [14, 46], [29, 3], [8, 82], [9, 46], [32, -62], [22, -20]], [[6970, 7554], [-15, -10], [-37, -42], [-12, -42], [-11, 0], [-7, 28], [-36, 2], [-5, 48], [-14, 0], [2, 60], [-33, 43], [-48, -5], [-32, -8], [-27, 53], [-22, 22], [-43, 43], [-6, 5], [-71, -35], [1, -218]], [[6554, 7498], [-14, -3], [-20, 46], [-18, 17], [-32, -12], [-12, -20]], [[6458, 7526], [-2, 14], [7, 25], [-5, 21], [-32, 20], [-13, 53], [-15, 15], [-1, 19], [27, -6], [1, 44], [23, 9], [25, -9], [5, 58], [-5, 36], [-28, -2], [-24, 14], [-32, -26], [-26, -12]], [[6363, 7799], [-14, 9], [3, 31], [-18, 39], [-20, -2], [-24, 40], [16, 45], [-8, 12], [22, 65], [29, -34], [3, 43], [58, 64], [43, 2], [61, -41], [33, -24], [30, 25], [44, 1], [35, -30], [8, 17], [39, -2], [7, 28], [-45, 40], [27, 29], [-5, 16], [26, 15], [-20, 41], [13, 20], [104, 21], [13, 14], [70, 22], [25, 24], [50, -12], [9, -61], [29, 14], [35, -20], [-2, -32], [27, 3], [69, 56], [-10, -19], [35, -46], [62, -150], [15, 31], [39, -34], [39, 16], [16, -11], [13, -34], [20, -12], [11, -25], [36, 8], [15, -36]], [[7229, 7559], [-17, 9], [-14, 21], [-42, 6], [-46, 2], [-10, -6], [-39, 24], [-16, -12], [-4, -35], [-46, 21], [-18, -9], [-7, -26]], [[6155, 4958], [-20, -24], [-7, -24], [-10, -4], [-4, -42], [-9, -24], [-5, -39], [-12, -20]], [[6088, 4781], [-40, 59], [-1, 35], [-101, 120], [-5, 6]], [[5941, 5001], [0, 63], [8, 24], [14, 39], [10, 43], [-13, 68], [-3, 30], [-13, 41]], [[5944, 5309], [17, 35], [19, 39]], [[6162, 5289], [-24, -67], [0, -215], [17, -49]], [[7046, 7387], [-53, -9], [-34, 19], [-30, -4], [3, 34], [30, -10], [10, 18]], [[6972, 7435], [21, -6], [36, 43], [-33, 31], [-20, -15], [-21, 22], [24, 39], [-9, 5]], [[7849, 5777], [-7, 72], [18, 49], [36, 11], [26, -8]], [[7922, 5901], [23, -23], [12, 40], [25, -21]], [[7982, 5897], [6, -40], [-3, -71], [-47, -45], [13, -36], [-30, -4], [-24, -24]], [[7897, 5677], [-23, 9], [-11, 30], [-14, 61]], [[8564, 7339], [24, -70], [7, -38], [0, -68], [-10, -33], [-25, -11], [-22, -25], [-25, -5], [-3, 32], [5, 45], [-13, 61], [21, 10], [-19, 51]], [[8504, 7288], [2, 5], [12, -2], [11, 27], [20, 2], [11, 4], [4, 15]], [[5557, 7574], [5, 13]], [[5562, 7587], [7, 4], [4, 20], [5, 3], [4, -8], [5, -4], [3, -10], [5, -2], [5, -11], [4, 0], [-3, -14], [-3, -7], [1, -5]], [[5599, 7553], [-6, -2], [-17, -9], [-1, -12], [-4, 0]], [[6332, 6828], [6, -26], [-3, -13], [9, -45]], [[6344, 6744], [-19, -1], [-7, 28], [-25, 6]], [[7922, 5901], [9, 26], [1, 50], [-22, 52], [-2, 58], [-21, 48], [-21, 4], [-6, -20], [-16, -2], [-8, 10], [-30, -35], [0, 53], [7, 62], [-19, 3], [-2, 36], [-12, 18]], [[7780, 6264], [6, 21], [24, 39]], [[7837, 6385], [17, -47], [12, -54], [34, 0], [11, -52], [-18, -15], [-8, -21], [34, -36], [23, -70], [17, -52], [21, -41], [7, -41], [-5, -59]], [[5975, 7012], [10, 49], [14, 41], [0, 2]], [[5999, 7104], [13, -3], [4, -23], [-15, -22], [-7, -33]], [[4785, 5315], [-7, 0], [-29, 28], [-25, 45], [-24, 32], [-18, 38]], [[4682, 5458], [6, 19], [2, 17], [12, 33], [13, 27]], [[5412, 6408], [-20, -22], [-15, 33], [-44, 25]], [[5263, 6848], [13, 14], [3, 25], [-3, 24], [19, 23], [8, 19], [14, 17], [2, 45]], [[5319, 7015], [32, -20], [12, 5], [23, -10], [37, -26], [13, -53], [25, -11], [39, -25], [30, -29], [13, 15], [13, 27], [-6, 45], [9, 29], [20, 28], [19, 8], [37, -12], [10, -27], [10, 0], [9, -10], [28, -7], [6, -19]], [[5694, 6357], [0, -118], [-32, 0], [0, -25]], [[5662, 6214], [-111, 113], [-111, 113], [-28, -32]], [[7271, 5502], [-4, -62], [-12, -16], [-24, -14], [-13, 47], [-5, 85], [13, 96], [19, -33], [13, -42], [13, -61]], [[5804, 3347], [10, -18], [-9, -29], [-4, -19], [-16, -9], [-5, -19], [-10, -6], [-21, 46], [15, 37], [15, 23], [13, 12], [12, -18]], [[5631, 8267], [-2, 15], [3, 16], [-13, 10], [-29, 10]], [[5590, 8318], [-6, 50]], [[5584, 8368], [32, 18], [47, -4], [27, 6], [4, -12], [15, -4], [26, -29]], [[5652, 8242], [-7, 19], [-14, 6]], [[5584, 8368], [1, 44], [14, 37], [26, 20], [22, -44], [22, 1], [6, 46]], [[5757, 8453], [14, -14], [2, -28], [9, -35]], [[4759, 6691], [-4, 0], [0, -31], [-17, -2], [-9, -14], [-13, 0], [-10, 8], [-23, -6], [-9, -46], [-9, -5], [-13, -74], [-38, -64], [-9, -81], [-12, -27], [-3, -21], [-63, -5]], [[4527, 6323], [1, 27], [11, 17], [9, 30], [-2, 20], [10, 42], [15, 38], [9, 9], [8, 35], [0, 31], [10, 37], [19, 21], [18, 60], [0, 1], [14, 23], [26, 6], [22, 41], [14, 16], [23, 49], [-7, 73], [10, 51], [4, 31], [18, 40], [28, 27], [21, 25], [18, 61], [9, 36], [20, 0], [17, -25], [26, 4], [29, -13], [12, -1]], [[5739, 7906], [6, 9], [19, 6], [20, -19], [12, -2], [12, -16], [-2, -20], [11, -9], [4, -25], [9, -15], [-2, -9], [5, -6], [-7, -4], [-16, 1], [-3, 9], [-6, -5], [2, -11], [-7, -19], [-5, -20], [-7, -6]], [[5784, 7745], [-5, 27], [3, 25], [-1, 26], [-16, 35], [-9, 25], [-9, 17], [-8, 6]], [[6376, 4321], [7, -25], [7, -39], [4, -71], [7, -28], [-2, -28], [-5, -18], [-10, 35], [-5, -18], [5, -43], [-2, -25], [-8, -14], [-1, -50], [-11, -69], [-14, -81], [-17, -112], [-11, -82], [-12, -69], [-23, -14], [-24, -25], [-16, 15], [-22, 21], [-8, 31], [-2, 53], [-10, 47], [-2, 42], [5, 43], [13, 10], [0, 20], [13, 45], [2, 37], [-6, 28], [-5, 38], [-2, 54], [9, 33], [4, 38], [14, 2], [15, 12], [11, 10], [12, 1], [16, 34], [23, 36], [8, 30], [-4, 25], [12, -7], [15, 41], [1, 36], [9, 26], [10, -25]], [[2301, 6586], [-10, -52], [-5, -43], [-2, -79], [-3, -29], [5, -32], [9, -29], [5, -45], [19, -44], [6, -34], [11, -29], [29, -16], [12, -25], [24, 17], [21, 6], [21, 11], [18, 10], [17, 24], [7, 34], [2, 50], [5, 17], [19, 16], [29, 13], [25, -2], [17, 5], [6, -12], [-1, -29], [-15, -35], [-6, -36], [5, -10], [-4, -26], [-7, -46], [-7, 15], [-6, -1]], [[2438, 5916], [-32, 64], [-14, 19], [-23, 16], [-15, -5], [-22, -22], [-14, -6], [-20, 16], [-21, 11], [-26, 27], [-21, 8], [-31, 28], [-23, 28], [-7, 16], [-16, 3], [-28, 19], [-12, 27], [-30, 34], [-14, 37], [-6, 29], [9, 5], [-3, 17], [7, 16], [0, 20], [-10, 27], [-2, 23], [-9, 30], [-25, 59], [-28, 46], [-13, 37], [-24, 24], [-5, 14], [4, 37], [-14, 13], [-17, 29], [-7, 41], [-14, 5], [-17, 31], [-13, 29], [-1, 19], [-15, 44], [-10, 45], [1, 23], [-20, 23], [-10, -2], [-15, 16], [-5, -24], [5, -28], [2, -45], [10, -24], [21, -41], [4, -14], [4, -4], [4, -20], [5, 1], [6, -38], [8, -15], [6, -21], [17, -30], [10, -55], [8, -26], [8, -28], [1, -31], [13, -2], [12, -27], [10, -26], [-1, -11], [-12, -21], [-5, 0], [-7, 36], [-18, 33], [-20, 29], [-14, 15], [1, 43], [-5, 32], [-13, 19], [-19, 26], [-4, -8], [-7, 16], [-17, 14], [-16, 34], [2, 5], [11, -4], [11, 22], [1, 27], [-22, 42], [-16, 17], [-10, 36], [-11, 39], [-12, 47], [-12, 54]], [[1746, 6980], [32, 4], [35, 7], [-2, -12], [41, -29], [64, -41], [55, 0], [22, 0], [0, 24], [48, 0], [10, -20], [15, -19], [16, -26], [9, -31], [7, -32], [15, -18], [23, -18], [17, 47], [23, 1], [19, -24], [14, -40], [10, -35], [16, -34], [6, -41], [8, -28], [22, -18], [20, -13], [10, 2]], [[5599, 7553], [9, 4], [13, 1]], [[4661, 5921], [10, 11], [4, 35], [9, 1], [20, -16], [15, 11], [11, -4], [4, 13], [112, 1], [6, 42], [-5, 7], [-13, 255], [-14, 255], [43, 1]], [[5118, 6189], [0, -136], [-15, -39], [-2, -37], [-25, -9], [-38, -5], [-10, -21], [-18, -3]], [[4680, 5793], [1, 18], [-2, 23], [-11, 16], [-5, 34], [-2, 37]], [[7737, 5644], [-3, 44], [9, 45], [-10, 35], [3, 65], [-12, 30], [-9, 71], [-5, 75], [-12, 49], [-18, -30], [-32, -42], [-15, 5], [-17, 14], [9, 73], [-6, 56], [-21, 68], [3, 21], [-16, 7], [-20, 49]], [[7780, 6264], [-16, -14], [-16, -26], [-20, -2], [-12, -64], [-12, -11], [14, -52], [17, -43], [12, -39], [-11, -51], [-9, -11], [6, -30], [19, -47], [3, -33], [0, -27], [11, -54], [-16, -55], [-13, -61]], [[5538, 7532], [-6, 4], [-8, 19], [-12, 12]], [[5533, 7629], [8, -10], [4, -9], [9, -6], [10, -12], [-2, -5]], [[7437, 7970], [29, 10], [53, 51], [42, 28], [24, -18], [29, -1], [19, -28], [28, -2], [40, -15], [27, 41], [-11, 35], [28, 61], [31, -24], [26, -7], [32, -15], [6, -44], [39, -25], [26, 11], [36, 7], [27, -7], [28, -29], [16, -30], [26, 1], [35, -10], [26, 15], [36, 9], [41, 42], [17, -6], [14, -20], [33, 5]], [[5959, 4377], [21, 5], [34, -17], [7, 8], [19, 1], [10, 18], [17, -1], [30, 23], [22, 34]], [[6119, 4448], [5, -26], [-1, -59], [3, -52], [1, -92], [5, -29], [-8, -43], [-11, -41], [-18, -36], [-25, -23], [-31, -28], [-32, -64], [-10, -11], [-20, -42], [-11, -13], [-3, -42], [14, -45], [5, -35], [0, -17], [5, 3], [-1, -58], [-4, -28], [6, -10], [-4, -25], [-11, -21], [-23, -20], [-34, -32], [-12, -21], [3, -25], [7, -4], [-3, -31]], [[5911, 3478], [-21, 0]], [[5890, 3478], [-2, 26], [-4, 27]], [[5884, 3531], [-3, 21], [5, 66], [-7, 42], [-13, 83]], [[5866, 3743], [29, 67], [7, 43], [5, 5], [3, 35], [-5, 17], [1, 44], [6, 41], [0, 75], [-15, 19], [-13, 4], [-6, 15], [-13, 12], [-23, -1], [-2, 22]], [[5840, 4141], [-2, 42], [84, 49]], [[5922, 4232], [16, -28], [8, 5], [11, -15], [1, -23], [-6, -28], [2, -42], [19, -36], [8, 41], [12, 12], [-2, 76], [-12, 43], [-10, 19], [-10, -1], [-7, 77], [7, 45]], [[4661, 5921], [-18, 41], [-17, 43], [-18, 16], [-13, 17], [-16, -1], [-13, -12], [-14, 5], [-10, -19]], [[4542, 6011], [-2, 32], [8, 29], [3, 55], [-3, 59], [-3, 29], [2, 30], [-7, 28], [-14, 25]], [[4526, 6298], [6, 20], [108, -1], [-5, 86], [7, 30], [26, 5], [-1, 152], [91, -4], [0, 90]], [[5922, 4232], [-15, 15], [9, 55], [9, 21], [-6, 49], [6, 48], [5, 16], [-7, 50], [-14, 26]], [[5909, 4512], [28, -11], [5, -16], [10, -28], [7, -80]], [[7836, 5425], [7, -5], [16, -36], [12, -40], [2, -39], [-3, -27], [2, -21], [2, -35], [10, -16], [11, -52], [-1, -20], [-19, -4], [-27, 44], [-32, 47], [-4, 30], [-16, 39], [-4, 49], [-10, 32], [4, 43], [-7, 25]], [[7779, 5439], [5, 11], [23, -26], [2, -30], [18, 7], [9, 24]], [[8045, 5176], [21, -20], [21, 11], [6, 50], [12, 11], [33, 13], [20, 47], [14, 37]], [[8206, 5379], [22, 41], [14, 47], [11, 0], [14, -30], [1, -26], [19, -16], [23, -18], [-2, -23], [-19, -3], [5, -29], [-20, -20]], [[5453, 3369], [-20, 45], [-11, 43], [-6, 58], [-7, 42], [-9, 91], [-1, 71], [-3, 32], [-11, 25], [-15, 48], [-14, 71], [-6, 37], [-23, 58], [-2, 45]], [[5644, 4022], [23, 14], [18, -4], [11, -13], [0, -5]], [[5552, 3594], [0, -218], [-25, -30], [-15, -4], [-17, 11], [-13, 4], [-4, 25], [-11, 17], [-14, -30]], [[9604, 3812], [23, -36], [14, -28], [-10, -14], [-16, 16], [-19, 27], [-18, 31], [-19, 42], [-4, 20], [12, -1], [16, -20], [12, -20], [9, -17]], [[5412, 6408], [7, -92], [10, -15], [1, -19], [11, -20], [-6, -25], [-11, -120], [-1, -77], [-35, -56], [-12, -78], [11, -22], [0, -38], [18, -1], [-3, -28]], [[5393, 5795], [-5, -1], [-19, 64], [-6, 3], [-22, -33], [-21, 17], [-15, 3], [-8, -8], [-17, 2], [-16, -25], [-14, -2], [-34, 31], [-13, -15], [-14, 1], [-10, 23], [-28, 22], [-30, -7], [-7, -13], [-4, -34], [-8, -24], [-2, -53]], [[5236, 5339], [-29, -21], [-11, 3], [-10, -13], [-23, 1], [-15, 37], [-9, 43], [-19, 39], [-21, -1], [-25, 0]], [[2619, 5713], [-10, 18], [-13, 24], [-6, 20], [-12, 19], [-13, 26], [3, 9], [4, -9], [2, 5]], [[2690, 5943], [-2, -5], [-2, -13], [3, -22], [-6, -20], [-3, -24], [-1, -26], [1, -15], [1, -27], [-4, -6], [-3, -25], [2, -15], [-6, -16], [2, -16], [4, -9]], [[5092, 8091], [14, 16], [24, 87], [38, 25], [23, -2]], [[5863, 9167], [-47, -24], [-22, -5]], [[5573, 9140], [-17, -2], [-4, -39], [-53, 9], [-7, -33], [-27, 1], [-18, -42], [-28, -66], [-43, -83], [10, -20], [-10, -24], [-27, 1], [-18, -55], [2, -79], [17, -29], [-9, -70], [-23, -40], [-12, -34]], [[5306, 8535], [-19, 36], [-55, -69], [-37, -13], [-38, 30], [-10, 63], [-9, 137], [26, 38], [73, 49], [55, 61], [51, 82], [66, 115], [47, 44], [76, 74], [61, 26], [46, -3], [42, 49], [51, -3], [50, 12], [87, -43], [-36, -16], [30, -37]], [[5686, 9657], [-62, -24], [-49, 13], [19, 16], [-16, 19], [57, 11], [11, -22], [40, -13]], [[5506, 9766], [92, -44], [-70, -23], [-15, -44], [-25, -11], [-13, -49], [-34, -2], [-59, 36], [25, 21], [-42, 17], [-54, 50], [-21, 46], [75, 21], [16, -20], [39, 0], [11, 21], [40, 2], [35, -21]], [[5706, 9808], [55, -21], [-41, -32], [-81, -7], [-82, 10], [-5, 16], [-40, 1], [-30, 27], [86, 17], [40, -14], [28, 17], [70, -14]], [[9805, 2640], [6, -24], [20, 24], [8, -25], [0, -25], [-10, -27], [-18, -44], [-14, -24], [10, -28], [-22, -1], [-23, -22], [-8, -39], [-16, -60], [-21, -26], [-14, -17], [-26, 1], [-18, 20], [-30, 4], [-5, 22], [15, 43], [35, 59], [18, 11], [20, 22], [24, 31], [16, 31], [13, 44], [10, 15], [5, 33], [19, 27], [6, -25]], [[9849, 2922], [20, -63], [1, 41], [13, -16], [4, -45], [22, -19], [19, -5], [16, 22], [14, -6], [-7, -53], [-8, -34], [-22, 1], [-7, -18], [3, -25], [-4, -11], [-11, -32], [-14, -41], [-21, -23], [-5, 15], [-12, 9], [16, 48], [-9, 33], [-30, 23], [1, 22], [20, 20], [5, 46], [-1, 38], [-12, 40], [1, 10], [-13, 25], [-22, 52], [-12, 42], [11, 4], [15, -33], [21, -15], [8, -52]], [[6475, 6041], [-9, 41], [-22, 98]], [[6444, 6180], [83, 59], [19, 118], [-13, 42]], [[6566, 6530], [12, -40], [16, -22], [20, -8], [17, -10], [12, -34], [8, -20], [10, -7], [0, -13], [-10, -36], [-5, -16], [-12, -19], [-10, -41], [-13, 3], [-5, -14], [-5, -30], [4, -39], [-3, -7], [-13, 0], [-17, -22], [-3, -29], [-6, -12], [-18, 0], [-10, -15], [0, -24], [-14, -16], [-15, 5], [-19, -19], [-12, -4]], [[6557, 6597], [8, 20], [3, -5], [-2, -25], [-4, -10]], [[6893, 6457], [-20, 15], [-9, 43], [-21, 45], [-51, -12], [-45, -1], [-39, -8]], [[2836, 5484], [-9, 17], [-6, 32], [7, 16], [-7, 4], [-5, 20], [-14, 16], [-12, -4], [-6, -20], [-11, -15], [-6, -2], [-3, -13], [13, -32], [-7, -7], [-4, -9], [-13, -3], [-5, 35], [-4, -10], [-9, 4], [-5, 24], [-12, 3], [-7, 7], [-12, 0], [-1, -13], [-3, 9]], [[2707, 5623], [10, -22], [-1, -12], [11, -3], [3, 5], [8, -14], [13, 4], [12, 15], [17, 12], [9, 17], [16, -3], [-1, -6], [15, -2], [12, -10], [10, -18], [10, -16]], [[3045, 3974], [-28, 33], [-2, 25], [-55, 59], [-50, 65], [-22, 36], [-11, 49], [4, 17], [-23, 77], [-28, 109], [-26, 118], [-11, 27], [-9, 43], [-21, 39], [-20, 24], [9, 26], [-14, 57], [9, 41], [22, 37]], [[8510, 5555], [2, -40], [2, -33], [-9, -54], [-11, 60], [-13, -30], [9, -43], [-8, -28], [-32, 35], [-8, 42], [8, 28], [-17, 28], [-9, -24], [-13, 2], [-21, -33], [-4, 17], [11, 50], [17, 17], [15, 22], [10, -27], [21, 17], [5, 26], [19, 1], [-1, 46], [22, -28], [3, -30], [2, -21]], [[8443, 5665], [-10, -20], [-9, -37], [-8, -17], [-17, 40], [5, 16], [7, 17], [3, 36], [16, 4], [-5, -40], [21, 57], [-3, -56]], [[8291, 5608], [-37, -56], [14, 41], [20, 37], [16, 41], [15, 58], [5, -48], [-18, -33], [-15, -40]], [[8385, 5760], [16, -18], [18, 0], [0, -25], [-13, -25], [-18, -18], [-1, 28], [2, 30], [-4, 28]], [[8485, 5776], [8, -66], [-21, 16], [0, -20], [7, -37], [-13, -13], [-1, 42], [-9, 3], [-4, 36], [16, -5], [0, 22], [-17, 45], [27, -1], [7, -22]], [[8375, 5830], [-7, -51], [-12, 29], [-15, 45], [24, -2], [10, -21]], [[8369, 6151], [17, -17], [9, 15], [2, -15], [-4, -24], [9, -43], [-7, -49], [-16, -19], [-5, -48], [7, -47], [14, -7], [13, 7], [34, -32], [-2, -32], [9, -15], [-3, -27], [-22, 29], [-10, 31], [-7, -22], [-18, 36], [-25, -9], [-14, 13], [1, 25], [9, 15], [-8, 13], [-4, -21], [-14, 34], [-4, 26], [-1, 56], [11, -19], [3, 92], [9, 54], [17, 0]], [[9329, 4655], [-8, -6], [-12, 22], [-12, 38], [-6, 45], [4, 6], [3, -18], [8, -13], [14, -38], [13, -20], [-4, -16]], [[9221, 4734], [-15, -5], [-4, -17], [-15, -14], [-15, -14], [-14, 0], [-23, 18], [-16, 16], [2, 18], [25, -8], [15, 4], [5, 29], [4, 1], [2, -31], [16, 4], [8, 20], [16, 21], [-4, 35], [17, 1], [6, -9], [-1, -33], [-9, -36]], [[8916, 4904], [48, -41], [51, -34], [19, -30], [16, -30], [4, -34], [46, -37], [7, -31], [-25, -7], [6, -39], [25, -39], [18, -62], [15, 2], [-1, -27], [22, -10], [-9, -11], [30, -25], [-3, -17], [-18, -4], [-7, 16], [-24, 6], [-28, 9], [-22, 38], [-16, 32], [-14, 52], [-36, 26], [-24, -17], [-17, -20], [4, -43], [-22, -20], [-16, 9], [-28, 3]], [[9253, 4792], [-9, -16], [-5, 35], [-6, 23], [-13, 19], [-16, 25], [-20, 18], [8, 14], [15, -17], [9, -13], [12, -14], [11, -25], [11, -19], [3, -30]], [[5392, 8233], [19, 18], [43, 27], [35, 20], [28, -10], [2, -14], [27, -1]], [[5546, 8273], [34, -7], [51, 1]], [[5653, 8105], [14, -52], [-3, -17], [-14, -6], [-25, -50], [7, -26], [-6, 3]], [[5626, 7957], [-26, 23], [-20, -8], [-13, 6], [-17, -13], [-14, 21], [-11, -8], [-2, 4]], [[3159, 6151], [14, -5], [5, -12], [-7, -15], [-21, 1], [-17, -2], [-1, 25], [4, 9], [23, -1]], [[8628, 7562], [4, -10]], [[8632, 7552], [-11, 3], [-12, -20], [-8, -20], [1, -42], [-14, -13], [-5, -11], [-11, -17], [-18, -10], [-12, -16], [-1, -25], [-3, -7], [11, -9], [15, -26]], [[8504, 7288], [-13, 11], [-4, -11], [-8, -5], [-1, 11], [-7, 5], [-8, 10], [8, 26], [7, 7], [-3, 11], [7, 31], [-2, 10], [-16, 7], [-13, 15]], [[4792, 7249], [-11, -15], [-14, 8], [-15, -6], [5, 46], [-3, 36], [-12, 6], [-7, 22], [2, 39], [11, 21], [2, 24], [6, 36], [-1, 25], [-5, 21], [-1, 20]], [[6411, 6520], [-2, 43], [7, 31], [8, 6], [8, -18], [1, -35], [-6, -35]], [[6427, 6512], [-8, -4], [-8, 12]], [[5630, 7886], [12, 13], [17, -7], [18, 0], [13, -14], [10, 9], [20, 5], [7, 14], [12, 0]], [[5784, 7745], [12, -11], [13, 9], [13, -10]], [[5822, 7733], [0, -15], [-13, -13], [-9, 6], [-7, -71]], [[5629, 7671], [-5, 10], [6, 10], [-7, 7], [-8, -13], [-17, 17], [-2, 25], [-17, 14], [-3, 18], [-15, 24]], [[8989, 8056], [28, -105], [-41, 19], [-17, -85], [27, -61], [-1, -41], [-21, 36], [-18, -46], [-5, 50], [3, 57], [-3, 64], [6, 45], [2, 79], [-17, 58], [3, 80], [25, 28], [-11, 27], [13, 8], [7, -39], [10, -57], [-1, -58], [11, -59]], [[5546, 8273], [6, 26], [38, 19]], [[0, 9132], [68, -45], [73, -59], [-3, -37], [19, -15], [-6, 43], [75, -8], [55, -56], [-28, -26], [-46, -6], [0, -57], [-11, -13], [-26, 2], [-22, 21], [-36, 17], [-7, 26], [-28, 9], [-31, -7], [-16, 20], [6, 22], [-33, -14], [13, -28], [-16, -25]], [[0, 8896], [0, 236]], [[0, 9282], [9999, -40], [-30, -3], [-5, 19], [-9964, 24]], [[0, 9282], [4, 3], [23, 0], [40, -17], [-2, -8], [-29, -14], [-36, -4], [0, 40]], [[8988, 9383], [-42, -1], [-57, 7], [-5, 3], [27, 23], [34, 6], [40, -23], [3, -15]], [[9186, 9493], [-32, -23], [-44, 5], [-52, 23], [7, 20], [51, -9], [70, -16]], [[9029, 9522], [-22, -44], [-102, 1], [-46, -14], [-55, 39], [15, 40], [37, 11], [73, -2], [100, -31]], [[6598, 9235], [-17, -5], [-91, 8], [-7, 26], [-50, 16], [-4, 32], [28, 13], [-1, 32], [55, 50], [-25, 7], [66, 52], [-7, 27], [62, 31], [91, 38], [93, 11], [48, 22], [54, 8], [19, -23], [-19, -19], [-98, -29], [-85, -28], [-86, -57], [-42, -57], [-43, -57], [5, -49], [54, -49]], [[0, 8896], [9963, -26], [-36, 4], [25, -31], [17, -49], [13, -16], [3, -24], [-7, -16], [-52, 13], [-78, -44], [-25, -7], [-42, -42], [-40, -36], [-11, -27], [-39, 41], [-73, -46], [-12, 22], [-27, -26], [-37, 8], [-9, -38], [-33, -58], [1, -24], [31, -13], [-4, -86], [-25, -2], [-12, -49], [11, -26], [-48, -30], [-10, -67], [-41, -15], [-9, -60], [-40, -55], [-10, 41], [-12, 86], [-15, 131], [13, 82], [23, 35], [2, 28], [43, 13], [50, 75], [47, 60], [50, 48], [23, 83], [-34, -5], [-17, -49], [-70, -65], [-23, 73], [-72, -20], [-69, -99], [23, -36], [-62, -16], [-43, -6], [2, 43], [-43, 9], [-35, -29], [-85, 10], [-91, -18], [-90, -115], [-106, -139], [43, -8], [14, -37], [27, -13], [18, 30], [30, -4], [40, -65], [1, -50], [-21, -59], [-3, -71], [-12, -94], [-42, -86], [-9, -41], [-38, -69], [-38, -68], [-18, -35], [-37, -34], [-17, -1], [-17, 29], [-38, -44], [-4, -19]], [[6363, 7799], [-12, -35], [-27, -10], [-28, -61], [25, -56], [-2, -40], [30, -70]], [[6109, 7624], [-35, 49], [-32, 23], [-24, 34], [20, 10], [23, 49], [-15, 24], [41, 24], [-1, 13], [-25, -10]], [[6061, 7840], [1, 26], [14, 17], [27, 4], [5, 20], [-7, 33], [12, 30], [-1, 18], [-41, 19], [-16, -1], [-17, 28], [-21, -9], [-35, 20], [0, 12], [-10, 26], [-22, 3], [-2, 18], [7, 12], [-18, 33], [-29, -5], [-8, 3], [-7, -14], [-11, 3]], [[5777, 8571], [31, 33], [-29, 28]], [[5863, 9167], [29, 20], [46, -35], [76, -14], [105, -67], [21, -28], [2, -40], [-31, -31], [-45, -15], [-124, 44], [-21, -7], [45, -43], [2, -28], [2, -60], [36, -18], [22, -15], [3, 28], [-17, 26], [18, 22], [67, -37], [24, 15], [-19, 43], [65, 58], [25, -4], [26, -20], [16, 40], [-23, 35], [14, 36], [-21, 36], [78, -18], [16, -34], [-35, -7], [0, -33], [22, -20], [43, 13], [7, 38], [58, 28], [97, 50], [20, -3], [-27, -35], [35, -7], [19, 21], [52, 1], [42, 25], [31, -36], [32, 39], [-29, 35], [14, 19], [82, -18], [39, -18], [100, -68], [19, 31], [-28, 31], [-1, 13], [-34, 6], [10, 28], [-15, 46], [-1, 19], [51, 53], [18, 54], [21, 11], [74, -15], [5, -33], [-26, -48], [17, -19], [9, -41], [-6, -81], [31, -36], [-12, -40], [-55, -84], [32, -8], [11, 21], [31, 15], [7, 29], [24, 29], [-16, 33], [13, 39], [-31, 5], [-6, 33], [22, 59], [-36, 48], [50, 40], [-7, 42], [14, 2], [15, -33], [-11, -57], [29, -11], [-12, 43], [46, 23], [58, 3], [51, -34], [-25, 49], [-2, 63], [48, 12], [67, -2], [60, 7], [-23, 31], [33, 39], [31, 2], [54, 29], [74, 8], [9, 16], [73, 6], [23, -14], [62, 32], [51, -1], [8, 25], [26, 25], [66, 25], [48, -19], [-38, -15], [63, -9], [7, -29], [25, 14], [82, -1], [62, -29], [23, -22], [-7, -30], [-31, -18], [-73, -33], [-21, -17], [35, -8], [41, -15], [25, 11], [14, -38], [12, 15], [44, 10], [90, -10], [6, -28], [116, -9], [2, 46], [59, -11], [44, 1], [45, -32], [13, -37], [-17, -25], [35, -47], [44, -24], [27, 62], [44, -26], [48, 16], [53, -18], [21, 16], [45, -8], [-20, 55], [37, 25], [251, -38], [24, -35], [72, -45], [112, 11], [56, -10], [23, -24], [-4, -44], [35, -16], [37, 12], [49, 1], [52, -11], [53, 6], [49, -52], [34, 19], [-23, 37], [13, 27], [88, -17], [58, 4], [80, -29], [-9960, -25]], [[7918, 9684], [-157, -23], [51, 77], [23, 7], [21, -4], [70, -33], [-8, -24]], [[6420, 9816], [-37, -8], [-25, -4], [-4, -10], [-33, -10], [-30, 14], [16, 19], [-62, 2], [54, 10], [43, 1], [5, -16], [16, 14], [26, 10], [42, -13], [-11, -9]], [[7775, 9718], [-60, -8], [-78, 17], [-46, 23], [-21, 42], [-38, 12], [72, 40], [60, 14], [54, -30], [64, -57], [-7, -53]], [[5844, 4990], [11, -33], [-1, -35], [-8, -7]], [[5821, 4978], [7, -6], [16, 18]], [[4526, 6298], [1, 25]], [[6188, 6023], [-4, 26], [-8, 17], [-2, 24], [-15, 21], [-15, 50], [-7, 48], [-20, 40], [-12, 10], [-18, 56], [-4, 41], [2, 35], [-16, 66], [-13, 23], [-15, 12], [-10, 34], [2, 13], [-8, 31], [-8, 13], [-11, 44], [-17, 48], [-14, 40], [-14, 0], [5, 33], [1, 20], [3, 24]], [[6344, 6744], [11, -51], [14, -13], [5, -21], [18, -25], [2, -24], [-3, -20], [4, -20], [8, -16], [4, -20], [4, -14]], [[6427, 6512], [5, -22]], [[6444, 6180], [-80, -23], [-26, -26], [-20, -62], [-13, -10], [-7, 20], [-11, -3], [-27, 6], [-5, 5], [-32, -1], [-7, -5], [-12, 15], [-7, -29], [3, -25], [-12, -19]], [[5943, 5617], [-4, 1], [0, 29], [-3, 20], [-14, 24], [-4, 42], [4, 44], [-13, 4], [-2, -13], [-17, -3], [7, -17], [2, -36], [-15, -32], [-14, -43], [-14, -6], [-23, 34], [-11, -12], [-3, -17], [-14, -11], [-1, -12], [-28, 0], [-3, 12], [-20, 2], [-10, -10], [-8, 5], [-14, 34], [-5, 17], [-20, -9], [-8, -27], [-7, -53], [-10, -11], [-8, -6]], [[5663, 5567], [-2, 2]], [[5635, 5716], [0, 14], [-10, 17], [-1, 35], [-5, 23], [-10, -4], [3, 22], [7, 25], [-3, 24], [9, 18], [-6, 14], [7, 36], [13, 44], [24, -4], [-1, 234]], [[6023, 6357], [9, -58], [-6, -10], [4, -61], [11, -71], [10, -14], [15, -22]], [[5943, 5624], [0, -7]], [[5943, 5617], [0, -46]], [[5944, 5309], [-17, -28], [-20, 1], [-22, -14], [-18, 13], [-11, -16]], [[5682, 5544], [-19, 23]], [[4535, 5861], [-11, 46], [-14, 21], [12, 11], [14, 41], [6, 31]], [[4536, 5789], [-4, 45]], [[9502, 4438], [8, -20], [-19, 0], [-11, 37], [17, -15], [5, -2]], [[9467, 4474], [-11, -1], [-17, 6], [-5, 9], [1, 23], [19, -9], [9, -12], [4, -16]], [[9490, 4490], [-4, -11], [-21, 52], [-5, 35], [9, 0], [10, -47], [11, -29]], [[9440, 4565], [1, -12], [-22, 25], [-15, 21], [-10, 20], [4, 6], [13, -14], [23, -27], [6, -19]], [[9375, 4623], [-5, -3], [-13, 14], [-11, 24], [1, 10], [17, -25], [11, -20]], [[4682, 5458], [-8, 5], [-20, 24], [-14, 31], [-5, 22], [-3, 43]], [[2561, 5848], [-3, -14], [-16, 1], [-10, 6], [-12, 12], [-15, 3], [-8, 13]], [[6198, 5735], [9, -11], [5, -25], [13, -24], [14, -1], [26, 16], [30, 7], [25, 18], [13, 4], [10, 11], [16, 2]], [[6359, 5732], [0, -1], [0, -25], [0, -59], [0, -31], [-13, -36], [-19, -50]], [[6359, 5732], [9, 1], [13, 9], [14, 6], [14, 20], [10, 0], [1, -16], [-3, -35], [0, -31], [-6, -21], [-7, -64], [-14, -66], [-17, -75], [-24, -87], [-23, -66], [-33, -81], [-28, -48], [-42, -58], [-25, -45], [-31, -72], [-6, -31], [-6, -14]], [[3412, 5410], [34, -11], [2, 10], [23, 4], [30, -15]], [[3489, 5306], [10, -35], [-4, -25]], [[5626, 7957], [-8, -15], [-5, -24]], [[5380, 7746], [7, 5]], [[5663, 8957], [-47, -17], [-27, -41], [4, -36], [-44, -48], [-54, -50], [-20, -84], [20, -41], [26, -33], [-25, -67], [-29, -14], [-11, -99], [-15, -55], [-34, 6], [-16, -47], [-32, -3], [-9, 56], [-23, 67], [-21, 84]], [[5890, 3478], [-5, -26], [-17, -6], [-16, 32], [0, 20], [7, 22], [3, 17], [8, 5], [14, -11]], [[5999, 7104], [-2, 45], [7, 25]], [[6004, 7174], [7, 13], [7, 13], [2, 33], [9, -12], [31, 17], [14, -12], [23, 1], [32, 22], [15, -1], [32, 9]], [[5051, 5420], [-22, -12]], [[7849, 5777], [-25, 28], [-24, -2], [4, 47], [-24, 0], [-2, -65], [-15, -87], [-10, -52], [2, -43], [18, -2], [12, -53], [5, -52], [15, -33], [17, -7], [14, -31]], [[7779, 5439], [-11, 23], [-4, 29], [-15, 34], [-14, 28], [-4, -35], [-5, 33], [3, 37], [8, 56]], [[6883, 7252], [16, 60], [-6, 44], [-20, 14], [7, 26], [23, -3], [13, 33], [9, 38], [37, 13], [-6, -27], [4, -17], [12, 2]], [[6497, 7255], [-5, 42], [4, 62], [-22, 20], [8, 40], [-19, 4], [6, 49], [26, -14], [25, 19], [-20, 35], [-8, 34], [-23, -15], [-3, -43], [-8, 38]], [[6554, 7498], [31, 1], [-4, 29], [24, 21], [23, 34], [37, -31], [3, -47], [11, -12], [30, 2], [9, -10], [14, -61], [32, -41], [18, -28], [29, -29], [37, -25], [-1, -36]], [[8471, 4532], [3, 14], [24, 13], [19, 2], [9, 8], [10, -8], [-10, -16], [-29, -25], [-23, -17]], [[3286, 5693], [16, 8], [6, -2], [-1, -44], [-23, -7], [-5, 6], [8, 16], [-1, 23]], [[5233, 7240], [31, 24], [19, -7], [-1, -30], [24, 22], [2, -12], [-14, -29], [0, -27], [9, -15], [-3, -51], [-19, -29], [6, -33], [14, -1], [7, -28], [11, -9]], [[6004, 7174], [-11, 27], [11, 22], [-17, -5], [-23, 13], [-19, -34], [-43, -6], [-22, 31], [-30, 2], [-6, -24], [-20, -7], [-26, 31], [-31, -1], [-16, 59], [-21, 33], [14, 46], [-18, 28], [31, 56], [43, 3], [12, 45], [53, -8], [33, 38], [32, 17], [46, 1], [49, -42], [40, -22], [32, 9], [24, -6], [33, 31]], [[5777, 7539], [3, -23], [25, -19], [-5, -14], [-33, -3], [-12, -19], [-23, -31], [-9, 27], [0, 12]], [[8382, 6499], [-17, -95], [-12, -49], [-14, 50], [-4, 44], [17, 58], [22, 45], [13, -18], [-5, -35]], [[6088, 4781], [-12, -73], [1, -33], [18, -22], [1, -15], [-8, -36], [2, -18], [-2, -28], [10, -37], [11, -58], [10, -13]], [[5909, 4512], [-15, 18], [-18, 10], [-11, 10], [-12, 15]], [[5844, 4990], [10, 8], [31, -1], [56, 4]], [[6061, 7840], [-22, -5], [-18, -19], [-26, -3], [-24, -22], [1, -37], [14, -14], [28, 4], [-5, -21], [-31, -11], [-37, -34], [-16, 12], [6, 28], [-30, 17], [5, 12], [26, 19], [-8, 14], [-43, 15], [-2, 22], [-25, -8], [-11, -32], [-21, -44]], [[3517, 3063], [-12, -38], [-31, -32], [-21, 11], [-15, -6], [-26, 25], [-18, -1], [-17, 32]], [[679, 6185], [-4, -10], [-7, 8], [1, 17], [-4, 21], [1, 7], [5, 10], [-2, 11], [1, 6], [3, -1], [10, -10], [5, -5], [5, -8], [7, -21], [-1, -3], [-11, -13], [-9, -9]], [[664, 6277], [-9, -4], [-5, 12], [-3, 5], [0, 4], [3, 5], [9, -6], [8, -9], [-3, -7]], [[646, 6309], [-1, -7], [-15, 2], [2, 7], [14, -2]], [[621, 6317], [-2, -3], [-2, 1], [-9, 2], [-4, 13], [-1, 2], [7, 8], [3, -3], [8, -20]], [[574, 6356], [-4, -6], [-9, 11], [1, 4], [5, 6], [6, -1], [1, -14]], [[3135, 7724], [5, -19], [-30, -29], [-29, -20], [-29, -18], [-15, -35], [-4, -13], [-1, -31], [10, -32], [11, -1], [-3, 21], [8, -13], [-2, -17], [-19, -9], [-13, 1], [-20, -10], [-12, -3], [-17, -3], [-23, -17], [41, 11], [8, -11], [-39, -18], [-17, 0], [0, 7], [-8, -16], [8, -3], [-6, -43], [-20, -45], [-2, 15], [-6, 3], [-9, 15], [5, -32], [7, -10], [1, -23], [-9, -23], [-16, -47], [-2, 3], [8, 40], [-14, 22], [-3, 49], [-5, -25], [5, -38], [-18, 10], [19, -19], [1, -57], [8, -4], [3, -20], [4, -59], [-17, -44], [-29, -18], [-18, -34], [-14, -4], [-14, -22], [-4, -20], [-31, -38], [-16, -28], [-13, -35], [-4, -42], [5, -41], [9, -51], [13, -41], [0, -26], [13, -69], [-1, -39], [-1, -23], [-7, -36], [-8, -8], [-14, 7], [-4, 26], [-11, 14], [-15, 51], [-13, 45], [-4, 23], [6, 39], [-8, 33], [-22, 49], [-10, 9], [-28, -27], [-5, 3], [-14, 28], [-17, 14], [-32, -7], [-24, 7], [-21, -5], [-12, -9], [5, -15], [0, -24], [5, -12], [-5, -8], [-10, 9], [-11, -11], [-20, 2], [-20, 31], [-25, -8], [-20, 14], [-17, -4], [-24, -14], [-25, -44], [-27, -25], [-16, -28], [-6, -27], [0, -41], [1, -28], [5, -20]], [[1746, 6980], [-4, 30], [-18, 34], [-13, 7], [-3, 17], [-16, 3], [-10, 16], [-26, 6], [-7, 9], [-3, 32], [-27, 60], [-23, 82], [1, 14], [-13, 19], [-21, 50], [-4, 48], [-15, 32], [6, 49], [-1, 51], [-8, 45], [10, 56], [4, 53], [3, 54], [-5, 79], [-9, 51], [-8, 27], [4, 12], [40, -20], [15, -56], [7, 15], [-5, 49], [-9, 48]], [[750, 8432], [-28, -23], [-14, 15], [-4, 28], [25, 21], [15, 9], [18, -4], [12, -18], [-24, -28]], [[401, 8597], [-18, -9], [-18, 11], [-17, 16], [28, 10], [22, -6], [3, -22]], [[230, 8826], [17, -12], [17, 6], [23, -15], [27, -8], [-2, -7], [-21, -12], [-21, 13], [-11, 11], [-24, -4], [-7, 5], [2, 23]], [[1374, 8295], [-15, 22], [-25, 19], [-8, 52], [-36, 47], [-15, 56], [-26, 4], [-44, 2], [-33, 17], [-57, 61], [-27, 11], [-49, 21], [-38, -5], [-55, 27], [-33, 25], [-30, -12], [5, -41], [-15, -4], [-32, -12], [-25, -20], [-30, -13], [-4, 35], [12, 58], [30, 18], [-8, 15], [-35, -33], [-19, -39], [-40, -42], [20, -29], [-26, -42], [-30, -25], [-28, -18], [-7, -26], [-43, -31], [-9, -28], [-32, -25], [-20, 5], [-25, -17], [-29, -20], [-23, -20], [-47, -16], [-5, 9], [31, 28], [27, 18], [29, 33], [35, 6], [14, 25], [38, 35], [6, 12], [21, 21], [5, 44], [14, 35], [-32, -18], [-9, 11], [-15, -22], [-18, 30], [-8, -21], [-10, 29], [-28, -23], [-17, 0], [-3, 35], [5, 21], [-17, 22], [-37, -12], [-23, 28], [-19, 14], [0, 34], [-22, 25], [11, 34], [23, 33], [10, 30], [22, 4], [19, -9], [23, 28], [20, -5], [21, 19], [-5, 27], [-16, 10], [21, 23], [-17, -1], [-30, -13], [-8, -13], [-22, 13], [-39, -6], [-41, 14], [-12, 24], [-35, 34], [39, 25], [62, 29], [23, 0], [-4, -30], [59, 2], [-23, 37], [-34, 23], [-20, 29], [-26, 25], [-38, 19], [15, 31], [49, 2], [35, 27], [7, 29], [28, 28], [28, 6], [52, 27], [26, -4], [42, 31], [42, -12], [21, -27], [12, 11], [47, -3], [-2, -14], [43, -10], [28, 6], [59, -18], [53, -6], [21, -8], [37, 10], [42, -18], [31, -8]], [[3018, 5753], [-1, -14], [-16, -7], [9, -26], [0, -31], [-12, -35], [10, -47], [12, 4], [6, 43], [-8, 21], [-2, 45], [35, 24], [-4, 27], [10, 19], [10, -41], [19, -1], [18, -33], [1, -20], [25, 0], [30, 6], [16, -27], [21, -7], [16, 18], [0, 15], [34, 4], [34, 1], [-24, -18], [10, -28], [22, -4], [21, -29], [4, -48], [15, 2], [11, -14]], [[8001, 6331], [-37, -51], [-24, -56], [-6, -41], [22, -62], [25, -77], [26, -37], [17, -47], [12, -109], [-3, -104], [-24, -39], [-31, -38], [-23, -49], [-35, -55], [-10, 37], [8, 40], [-21, 34]], [[9661, 4085], [-9, -8], [-9, 26], [1, 16], [17, -34]], [[9641, 4175], [4, -47], [-7, 7], [-6, -3], [-4, 16], [0, 45], [13, -18]], [[6475, 6041], [-21, -16], [-5, -26], [-1, -20], [-27, -25], [-45, -28], [-24, -41], [-13, -3], [-8, 3], [-16, -25], [-18, -11], [-23, -3], [-7, -3], [-6, -16], [-8, -4], [-4, -15], [-14, 1], [-9, -8], [-19, 3], [-7, 35], [1, 32], [-5, 17], [-5, 44], [-8, 24], [5, 3], [-2, 27], [3, 12], [-1, 25]], [[5817, 3752], [11, 0], [14, -10], [9, 7], [15, -6]], [[5911, 3478], [-7, -43], [-3, -49], [-7, -27], [-19, -30], [-5, -8], [-12, -30], [-8, -31], [-16, -42], [-31, -61], [-20, -36], [-21, -26], [-29, -23], [-14, -3], [-3, -17], [-17, 9], [-14, -11], [-30, 11], [-17, -7], [-12, 3], [-28, -23], [-24, -10], [-17, -22], [-13, -1], [-11, 21], [-10, 1], [-12, 26], [-1, -8], [-4, 16], [0, 34], [-9, 40], [9, 11], [0, 45], [-19, 55], [-14, 50], [0, 1], [-20, 76]], [[5840, 4141], [-21, -8], [-15, -23], [-4, -21], [-10, -4], [-24, -49], [-15, -38], [-10, -2], [-9, 7], [-31, 7]]],
	        "transform": {
	            "scale": [0.036003600360036005, 0.016927109510951093],
	            "translate": [-180, -85.609038]
	        }
	    };
	    Datamap.prototype.abwTopo = '__ABW__';
	    Datamap.prototype.afgTopo = '__AFG__';
	    Datamap.prototype.agoTopo = '__AGO__';
	    Datamap.prototype.aiaTopo = '__AIA__';
	    Datamap.prototype.albTopo = '__ALB__';
	    Datamap.prototype.aldTopo = '__ALD__';
	    Datamap.prototype.andTopo = '__AND__';
	    Datamap.prototype.areTopo = '__ARE__';
	    Datamap.prototype.argTopo = '__ARG__';
	    Datamap.prototype.armTopo = '__ARM__';
	    Datamap.prototype.asmTopo = '__ASM__';
	    Datamap.prototype.ataTopo = '__ATA__';
	    Datamap.prototype.atcTopo = '__ATC__';
	    Datamap.prototype.atfTopo = '__ATF__';
	    Datamap.prototype.atgTopo = '__ATG__';
	    Datamap.prototype.ausTopo = '__AUS__';
	    Datamap.prototype.autTopo = '__AUT__';
	    Datamap.prototype.azeTopo = '__AZE__';
	    Datamap.prototype.bdiTopo = '__BDI__';
	    Datamap.prototype.belTopo = '__BEL__';
	    Datamap.prototype.benTopo = '__BEN__';
	    Datamap.prototype.bfaTopo = '__BFA__';
	    Datamap.prototype.bgdTopo = '__BGD__';
	    Datamap.prototype.bgrTopo = '__BGR__';
	    Datamap.prototype.bhrTopo = '__BHR__';
	    Datamap.prototype.bhsTopo = '__BHS__';
	    Datamap.prototype.bihTopo = '__BIH__';
	    Datamap.prototype.bjnTopo = '__BJN__';
	    Datamap.prototype.blmTopo = '__BLM__';
	    Datamap.prototype.blrTopo = '__BLR__';
	    Datamap.prototype.blzTopo = '__BLZ__';
	    Datamap.prototype.bmuTopo = '__BMU__';
	    Datamap.prototype.bolTopo = '__BOL__';
	    Datamap.prototype.braTopo = '__BRA__';
	    Datamap.prototype.brbTopo = '__BRB__';
	    Datamap.prototype.brnTopo = '__BRN__';
	    Datamap.prototype.btnTopo = '__BTN__';
	    Datamap.prototype.norTopo = '__NOR__';
	    Datamap.prototype.bwaTopo = '__BWA__';
	    Datamap.prototype.cafTopo = '__CAF__';
	    Datamap.prototype.canTopo = '__CAN__';
	    Datamap.prototype.cheTopo = '__CHE__';
	    Datamap.prototype.chlTopo = '__CHL__';
	    Datamap.prototype.chnTopo = '__CHN__';
	    Datamap.prototype.civTopo = '__CIV__';
	    Datamap.prototype.clpTopo = '__CLP__';
	    Datamap.prototype.cmrTopo = '__CMR__';
	    Datamap.prototype.codTopo = '__COD__';
	    Datamap.prototype.cogTopo = '__COG__';
	    Datamap.prototype.cokTopo = '__COK__';
	    Datamap.prototype.colTopo = '__COL__';
	    Datamap.prototype.comTopo = '__COM__';
	    Datamap.prototype.cpvTopo = '__CPV__';
	    Datamap.prototype.criTopo = '__CRI__';
	    Datamap.prototype.csiTopo = '__CSI__';
	    Datamap.prototype.cubTopo = '__CUB__';
	    Datamap.prototype.cuwTopo = '__CUW__';
	    Datamap.prototype.cymTopo = '__CYM__';
	    Datamap.prototype.cynTopo = '__CYN__';
	    Datamap.prototype.cypTopo = '__CYP__';
	    Datamap.prototype.czeTopo = '__CZE__';
	    Datamap.prototype.deuTopo = '__DEU__';
	    Datamap.prototype.djiTopo = '__DJI__';
	    Datamap.prototype.dmaTopo = '__DMA__';
	    Datamap.prototype.dnkTopo = '__DNK__';
	    Datamap.prototype.domTopo = '__DOM__';
	    Datamap.prototype.dzaTopo = '__DZA__';
	    Datamap.prototype.ecuTopo = '__ECU__';
	    Datamap.prototype.egyTopo = '__EGY__';
	    Datamap.prototype.eriTopo = '__ERI__';
	    Datamap.prototype.esbTopo = '__ESB__';
	    Datamap.prototype.espTopo = '__ESP__';
	    Datamap.prototype.estTopo = '__EST__';
	    Datamap.prototype.ethTopo = '__ETH__';
	    Datamap.prototype.finTopo = '__FIN__';
	    Datamap.prototype.fjiTopo = '__FJI__';
	    Datamap.prototype.flkTopo = '__FLK__';
	    Datamap.prototype.fraTopo = '__FRA__';
	    Datamap.prototype.froTopo = '__FRO__';
	    Datamap.prototype.fsmTopo = '__FSM__';
	    Datamap.prototype.gabTopo = '__GAB__';
	    Datamap.prototype.psxTopo = '__PSX__';
	    Datamap.prototype.gbrTopo = '__GBR__';
	    Datamap.prototype.geoTopo = '__GEO__';
	    Datamap.prototype.ggyTopo = '__GGY__';
	    Datamap.prototype.ghaTopo = '__GHA__';
	    Datamap.prototype.gibTopo = '__GIB__';
	    Datamap.prototype.ginTopo = '__GIN__';
	    Datamap.prototype.gmbTopo = '__GMB__';
	    Datamap.prototype.gnbTopo = '__GNB__';
	    Datamap.prototype.gnqTopo = '__GNQ__';
	    Datamap.prototype.grcTopo = '__GRC__';
	    Datamap.prototype.grdTopo = '__GRD__';
	    Datamap.prototype.grlTopo = '__GRL__';
	    Datamap.prototype.gtmTopo = '__GTM__';
	    Datamap.prototype.gumTopo = '__GUM__';
	    Datamap.prototype.guyTopo = '__GUY__';
	    Datamap.prototype.hkgTopo = '__HKG__';
	    Datamap.prototype.hmdTopo = '__HMD__';
	    Datamap.prototype.hndTopo = '__HND__';
	    Datamap.prototype.hrvTopo = '__HRV__';
	    Datamap.prototype.htiTopo = '__HTI__';
	    Datamap.prototype.hunTopo = '__HUN__';
	    Datamap.prototype.idnTopo = '__IDN__';
	    Datamap.prototype.imnTopo = '__IMN__';
	    Datamap.prototype.indTopo = '__IND__';
	    Datamap.prototype.ioaTopo = '__IOA__';
	    Datamap.prototype.iotTopo = '__IOT__';
	    Datamap.prototype.irlTopo = '__IRL__';
	    Datamap.prototype.irnTopo = '__IRN__';
	    Datamap.prototype.irqTopo = '__IRQ__';
	    Datamap.prototype.islTopo = '__ISL__';
	    Datamap.prototype.isrTopo = '__ISR__';
	    Datamap.prototype.itaTopo = '__ITA__';
	    Datamap.prototype.jamTopo = '__JAM__';
	    Datamap.prototype.jeyTopo = '__JEY__';
	    Datamap.prototype.jorTopo = '__JOR__';
	    Datamap.prototype.jpnTopo = '__JPN__';
	    Datamap.prototype.kabTopo = '__KAB__';
	    Datamap.prototype.kasTopo = '__KAS__';
	    Datamap.prototype.kazTopo = '__KAZ__';
	    Datamap.prototype.kenTopo = '__KEN__';
	    Datamap.prototype.kgzTopo = '__KGZ__';
	    Datamap.prototype.khmTopo = '__KHM__';
	    Datamap.prototype.kirTopo = '__KIR__';
	    Datamap.prototype.knaTopo = '__KNA__';
	    Datamap.prototype.korTopo = '__KOR__';
	    Datamap.prototype.kosTopo = '__KOS__';
	    Datamap.prototype.kwtTopo = '__KWT__';
	    Datamap.prototype.laoTopo = '__LAO__';
	    Datamap.prototype.lbnTopo = '__LBN__';
	    Datamap.prototype.lbrTopo = '__LBR__';
	    Datamap.prototype.lbyTopo = '__LBY__';
	    Datamap.prototype.lcaTopo = '__LCA__';
	    Datamap.prototype.lieTopo = '__LIE__';
	    Datamap.prototype.lkaTopo = '__LKA__';
	    Datamap.prototype.lsoTopo = '__LSO__';
	    Datamap.prototype.ltuTopo = '__LTU__';
	    Datamap.prototype.luxTopo = '__LUX__';
	    Datamap.prototype.lvaTopo = '__LVA__';
	    Datamap.prototype.macTopo = '__MAC__';
	    Datamap.prototype.mafTopo = '__MAF__';
	    Datamap.prototype.marTopo = '__MAR__';
	    Datamap.prototype.mcoTopo = '__MCO__';
	    Datamap.prototype.mdaTopo = '__MDA__';
	    Datamap.prototype.mdgTopo = '__MDG__';
	    Datamap.prototype.mdvTopo = '__MDV__';
	    Datamap.prototype.mexTopo = '__MEX__';
	    Datamap.prototype.mhlTopo = '__MHL__';
	    Datamap.prototype.mkdTopo = '__MKD__';
	    Datamap.prototype.mliTopo = '__MLI__';
	    Datamap.prototype.mltTopo = '__MLT__';
	    Datamap.prototype.mmrTopo = '__MMR__';
	    Datamap.prototype.mneTopo = '__MNE__';
	    Datamap.prototype.mngTopo = '__MNG__';
	    Datamap.prototype.mnpTopo = '__MNP__';
	    Datamap.prototype.mozTopo = '__MOZ__';
	    Datamap.prototype.mrtTopo = '__MRT__';
	    Datamap.prototype.msrTopo = '__MSR__';
	    Datamap.prototype.musTopo = '__MUS__';
	    Datamap.prototype.mwiTopo = '__MWI__';
	    Datamap.prototype.mysTopo = '__MYS__';
	    Datamap.prototype.namTopo = '__NAM__';
	    Datamap.prototype.nclTopo = '__NCL__';
	    Datamap.prototype.nerTopo = '__NER__';
	    Datamap.prototype.nfkTopo = '__NFK__';
	    Datamap.prototype.ngaTopo = '__NGA__';
	    Datamap.prototype.nicTopo = '__NIC__';
	    Datamap.prototype.niuTopo = '__NIU__';
	    Datamap.prototype.nldTopo = '__NLD__';
	    Datamap.prototype.nplTopo = '__NPL__';
	    Datamap.prototype.nruTopo = '__NRU__';
	    Datamap.prototype.nulTopo = '__NUL__';
	    Datamap.prototype.nzlTopo = '__NZL__';
	    Datamap.prototype.omnTopo = '__OMN__';
	    Datamap.prototype.pakTopo = '__PAK__';
	    Datamap.prototype.panTopo = '__PAN__';
	    Datamap.prototype.pcnTopo = '__PCN__';
	    Datamap.prototype.perTopo = '__PER__';
	    Datamap.prototype.pgaTopo = '__PGA__';
	    Datamap.prototype.phlTopo = '__PHL__';
	    Datamap.prototype.plwTopo = '__PLW__';
	    Datamap.prototype.pngTopo = '__PNG__';
	    Datamap.prototype.polTopo = '__POL__';
	    Datamap.prototype.priTopo = '__PRI__';
	    Datamap.prototype.prkTopo = '__PRK__';
	    Datamap.prototype.prtTopo = '__PRT__';
	    Datamap.prototype.pryTopo = '__PRY__';
	    Datamap.prototype.pyfTopo = '__PYF__';
	    Datamap.prototype.qatTopo = '__QAT__';
	    Datamap.prototype.rouTopo = '__ROU__';
	    Datamap.prototype.rusTopo = '__RUS__';
	    Datamap.prototype.rwaTopo = '__RWA__';
	    Datamap.prototype.sahTopo = '__SAH__';
	    Datamap.prototype.sauTopo = '__SAU__';
	    Datamap.prototype.scrTopo = '__SCR__';
	    Datamap.prototype.sdnTopo = '__SDN__';
	    Datamap.prototype.sdsTopo = '__SDS__';
	    Datamap.prototype.senTopo = '__SEN__';
	    Datamap.prototype.serTopo = '__SER__';
	    Datamap.prototype.sgpTopo = '__SGP__';
	    Datamap.prototype.sgsTopo = '__SGS__';
	    Datamap.prototype.shnTopo = '__SHN__';
	    Datamap.prototype.slbTopo = '__SLB__';
	    Datamap.prototype.sleTopo = '__SLE__';
	    Datamap.prototype.slvTopo = '__SLV__';
	    Datamap.prototype.smrTopo = '__SMR__';
	    Datamap.prototype.solTopo = '__SOL__';
	    Datamap.prototype.somTopo = '__SOM__';
	    Datamap.prototype.spmTopo = '__SPM__';
	    Datamap.prototype.srbTopo = '__SRB__';
	    Datamap.prototype.stpTopo = '__STP__';
	    Datamap.prototype.surTopo = '__SUR__';
	    Datamap.prototype.svkTopo = '__SVK__';
	    Datamap.prototype.svnTopo = '__SVN__';
	    Datamap.prototype.sweTopo = '__SWE__';
	    Datamap.prototype.swzTopo = '__SWZ__';
	    Datamap.prototype.sxmTopo = '__SXM__';
	    Datamap.prototype.sycTopo = '__SYC__';
	    Datamap.prototype.syrTopo = '__SYR__';
	    Datamap.prototype.tcaTopo = '__TCA__';
	    Datamap.prototype.tcdTopo = '__TCD__';
	    Datamap.prototype.tgoTopo = '__TGO__';
	    Datamap.prototype.thaTopo = '__THA__';
	    Datamap.prototype.tjkTopo = '__TJK__';
	    Datamap.prototype.tkmTopo = '__TKM__';
	    Datamap.prototype.tlsTopo = '__TLS__';
	    Datamap.prototype.tonTopo = '__TON__';
	    Datamap.prototype.ttoTopo = '__TTO__';
	    Datamap.prototype.tunTopo = '__TUN__';
	    Datamap.prototype.turTopo = '__TUR__';
	    Datamap.prototype.tuvTopo = '__TUV__';
	    Datamap.prototype.twnTopo = '__TWN__';
	    Datamap.prototype.tzaTopo = '__TZA__';
	    Datamap.prototype.ugaTopo = '__UGA__';
	    Datamap.prototype.ukrTopo = '__UKR__';
	    Datamap.prototype.umiTopo = '__UMI__';
	    Datamap.prototype.uryTopo = '__URY__';
	    Datamap.prototype.usaTopo = { "type": "Topology", "transform": { "scale": [0.03514630243024302, 0.005240860686068607], "translate": [-178.123152, 18.948267] }, "objects": { "usa": { "type": "GeometryCollection", "geometries": [{ "type": "Polygon", "id": "AL", "arcs": [[0, 1, 2, 3, 4]], "properties": { "name": "Alabama" } }, { "type": "MultiPolygon", "id": "AK", "arcs": [[[5]], [[6]], [[7]], [[8]], [[9]], [[10]], [[11]], [[12]], [[13]], [[14]], [[15]], [[16]], [[17]], [[18]], [[19]], [[20]], [[21]], [[22]], [[23]], [[24]], [[25]], [[26]], [[27]], [[28]], [[29]], [[30]], [[31]], [[32]], [[33]], [[34]], [[35]], [[36]], [[37]], [[38]], [[39]], [[40]], [[41]], [[42]], [[43]]], "properties": { "name": "Alaska" } }, { "type": "Polygon", "id": "AZ", "arcs": [[44, 45, 46, 47, 48]], "properties": { "name": "Arizona" } }, { "type": "Polygon", "id": "AR", "arcs": [[49, 50, 51, 52, 53, 54]], "properties": { "name": "Arkansas" } }, { "type": "Polygon", "id": "CA", "arcs": [[55, -47, 56, 57]], "properties": { "name": "California" } }, { "type": "Polygon", "id": "CO", "arcs": [[58, 59, 60, 61, 62, 63]], "properties": { "name": "Colorado" } }, { "type": "Polygon", "id": "CT", "arcs": [[64, 65, 66, 67]], "properties": { "name": "Connecticut" } }, { "type": "Polygon", "id": "DE", "arcs": [[68, 69, 70, 71]], "properties": { "name": "Delaware" } }, { "type": "Polygon", "id": "DC", "arcs": [[72, 73]], "properties": { "name": "District of Columbia" } }, { "type": "Polygon", "id": "FL", "arcs": [[74, 75, -2]], "properties": { "name": "Florida" } }, { "type": "Polygon", "id": "GA", "arcs": [[76, 77, -75, -1, 78, 79]], "properties": { "name": "Georgia" } }, { "type": "MultiPolygon", "id": "HI", "arcs": [[[80]], [[81]], [[82]], [[83]], [[84]]], "properties": { "name": "Hawaii" } }, { "type": "Polygon", "id": "ID", "arcs": [[85, 86, 87, 88, 89, 90, 91]], "properties": { "name": "Idaho" } }, { "type": "Polygon", "id": "IL", "arcs": [[92, 93, 94, 95, 96, 97]], "properties": { "name": "Illinois" } }, { "type": "Polygon", "id": "IN", "arcs": [[98, 99, -95, 100, 101]], "properties": { "name": "Indiana" } }, { "type": "Polygon", "id": "IA", "arcs": [[102, -98, 103, 104, 105, 106]], "properties": { "name": "Iowa" } }, { "type": "Polygon", "id": "KS", "arcs": [[107, 108, -60, 109]], "properties": { "name": "Kansas" } }, { "type": "Polygon", "id": "KY", "arcs": [[110, 111, 112, 113, -96, -100, 114]], "properties": { "name": "Kentucky" } }, { "type": "Polygon", "id": "LA", "arcs": [[115, 116, 117, -52]], "properties": { "name": "Louisiana" } }, { "type": "Polygon", "id": "ME", "arcs": [[118, 119]], "properties": { "name": "Maine" } }, { "type": "MultiPolygon", "id": "MD", "arcs": [[[120]], [[-71, 121, 122, 123, 124, -74, 125, 126, 127]]], "properties": { "name": "Maryland" } }, { "type": "Polygon", "id": "MA", "arcs": [[128, 129, 130, 131, -68, 132, 133, 134]], "properties": { "name": "Massachusetts" } }, { "type": "MultiPolygon", "id": "MI", "arcs": [[[-102, 135, 136]], [[137]], [[138, 139]], [[140]]], "properties": { "name": "Michigan" } }, { "type": "Polygon", "id": "MN", "arcs": [[-107, 141, 142, 143, 144]], "properties": { "name": "Minnesota" } }, { "type": "Polygon", "id": "MS", "arcs": [[-4, 145, -116, -51, 146]], "properties": { "name": "Mississippi" } }, { "type": "Polygon", "id": "MO", "arcs": [[-97, -114, 147, -55, 148, -108, 149, -104]], "properties": { "name": "Missouri" } }, { "type": "Polygon", "id": "MT", "arcs": [[150, 151, -92, 152, 153]], "properties": { "name": "Montana" } }, { "type": "Polygon", "id": "NE", "arcs": [[-105, -150, -110, -59, 154, 155]], "properties": { "name": "Nebraska" } }, { "type": "Polygon", "id": "NV", "arcs": [[156, -48, -56, 157, -88]], "properties": { "name": "Nevada" } }, { "type": "Polygon", "id": "NH", "arcs": [[-135, 158, 159, -120, 160]], "properties": { "name": "New Hampshire" } }, { "type": "Polygon", "id": "NJ", "arcs": [[161, -69, 162, 163]], "properties": { "name": "New Jersey" } }, { "type": "Polygon", "id": "NM", "arcs": [[164, 165, 166, -45, -62]], "properties": { "name": "New Mexico" } }, { "type": "Polygon", "id": "NY", "arcs": [[-133, -67, 167, -164, 168, 169, 170]], "properties": { "name": "New York" } }, { "type": "Polygon", "id": "NC", "arcs": [[171, 172, -80, 173, 174]], "properties": { "name": "North Carolina" } }, { "type": "Polygon", "id": "ND", "arcs": [[175, -154, 176, -143]], "properties": { "name": "North Dakota" } }, { "type": "Polygon", "id": "OH", "arcs": [[177, -115, -99, -137, 178, 179]], "properties": { "name": "Ohio" } }, { "type": "Polygon", "id": "OK", "arcs": [[-149, -54, 180, -165, -61, -109]], "properties": { "name": "Oklahoma" } }, { "type": "Polygon", "id": "OR", "arcs": [[-89, -158, -58, 181, 182]], "properties": { "name": "Oregon" } }, { "type": "Polygon", "id": "PA", "arcs": [[-163, -72, -128, 183, -180, 184, -169]], "properties": { "name": "Pennsylvania" } }, { "type": "MultiPolygon", "id": "RI", "arcs": [[[185, -130]], [[186, -65, -132]]], "properties": { "name": "Rhode Island" } }, { "type": "Polygon", "id": "SC", "arcs": [[187, -77, -173]], "properties": { "name": "South Carolina" } }, { "type": "Polygon", "id": "SD", "arcs": [[-142, -106, -156, 188, -151, -176]], "properties": { "name": "South Dakota" } }, { "type": "Polygon", "id": "TN", "arcs": [[189, -174, -79, -5, -147, -50, -148, -113]], "properties": { "name": "Tennessee" } }, { "type": "Polygon", "id": "TX", "arcs": [[-53, -118, 190, -166, -181]], "properties": { "name": "Texas" } }, { "type": "Polygon", "id": "UT", "arcs": [[191, -63, -49, -157, -87]], "properties": { "name": "Utah" } }, { "type": "Polygon", "id": "VT", "arcs": [[-134, -171, 192, -159]], "properties": { "name": "Vermont" } }, { "type": "MultiPolygon", "id": "VA", "arcs": [[[193, -123]], [[120]], [[-126, -73, -125, 194, -175, -190, -112, 195]]], "properties": { "name": "Virginia" } }, { "type": "MultiPolygon", "id": "WA", "arcs": [[[-183, 196, -90]], [[197]], [[198]]], "properties": { "name": "Washington" } }, { "type": "Polygon", "id": "WV", "arcs": [[-184, -127, -196, -111, -178]], "properties": { "name": "West Virginia" } }, { "type": "Polygon", "id": "WI", "arcs": [[199, -93, -103, -145, 200, -140]], "properties": { "name": "Wisconsin" } }, { "type": "Polygon", "id": "WY", "arcs": [[-189, -155, -64, -192, -86, -152]], "properties": { "name": "Wyoming" } }] } }, "arcs": [[[2632, 3060], [5, -164], [7, -242], [4, -53], [3, -30], [-2, -19], [4, -11], [-5, -25], [0, -24], [-2, -32], [2, -57], [-2, -51], [3, -52]], [[2649, 2300], [-14, -1], [-59, 0], [-1, -25], [6, -37], [-1, -31], [2, -16], [-4, -28]], [[2578, 2162], [-4, -6], [-7, 31], [-1, 47], [-2, 6], [-3, -36], [-1, -34], [-7, 9]], [[2553, 2179], [-2, 291], [6, 363], [4, 209], [-3, 20]], [[2558, 3062], [24, 1], [50, -3]], [[1324, 6901], [1, 32], [6, -19], [-1, -32], [-8, 4], [2, 15]], [[1317, 6960], [5, -23], [-3, -33], [-2, 11], [0, 45]], [[1285, 7153], [6, 5], [3, -8], [-1, -28], [-6, -6], [-5, 17], [3, 20]], [[1267, 7137], [12, -7], [3, -36], [13, -41], [4, -25], [0, -21], [3, -4], [1, -27], [5, -27], [0, -25], [3, 8], [2, -19], [1, -74], [-3, -17], [-7, 3], [-3, 38], [-2, -3], [-6, 28], [-2, -10], [-5, 10], [1, -28], [5, 7], [3, -10], [-2, -39], [-5, 4], [-9, 49], [-2, 25], [1, 26], [-7, -2], [0, 20], [5, 2], [5, 18], [-2, 31], [-6, 7], [-1, 50], [-2, 25], [-4, -18], [-2, 28], [4, 14], [-3, 32], [2, 8]], [[1263, 6985], [5, -12], [4, 15], [4, -7], [-4, -28], [-6, 8], [-3, 24]], [[1258, 7247], [-4, 19], [5, 13], [15, -18], [7, 1], [5, -36], [9, -29], [-1, -22], [-5, -11], [-6, 5], [-5, -14], [-6, 9], [-7, -9], [-1, 45], [0, 30], [-5, 1], [-1, 16]], [[1252, 7162], [-4, 14], [-4, 32], [0, 24], [3, 11], [4, -11], [0, 20], [12, -35], [1, -33], [-4, -5], [-3, -37], [3, -11], [-3, -43], [-5, 9], [0, -27], [-3, 13], [-2, 54], [5, 25]], [[1207, 7331], [8, 38], [3, -16], [7, -13], [6, -2], [0, -30], [6, -99], [0, -85], [-1, -22], [-4, 13], [-10, 84], [-7, 25], [3, 20], [-3, 48], [-8, 39]], [[1235, 7494], [10, -15], [5, 2], [0, -14], [8, -52], [-5, 8], [-2, -18], [6, -27], [2, -48], [-6, -13], [-2, -16], [-10, -35], [-3, 1], [-1, 37], [2, 22], [-1, 32], [-3, 40], [0, 21], [-2, 51], [-4, 22], [-1, 38], [7, -36]], [[1203, 7324], [4, 0], [4, -35], [-2, -24], [-6, -5], [0, 38], [0, 26]], [[1207, 7331], [-5, 7], [-3, 26], [-6, 18], [-5, 37], [-6, 17], [1, 30], [4, 10], [1, 26], [3, -11], [8, -1], [6, 17], [8, -23], [-5, -26], [2, -9], [4, 28], [10, -9], [5, -21], [-3, -38], [3, -3], [3, -50], [-7, -7], [-14, 41], [0, -42], [-4, -17]], [[883, 7871], [-12, -48], [-1, -19], [-9, -12], [2, 29], [10, 30], [7, 34], [3, -14]], [[870, 7943], [-2, -39], [-4, -41], [-6, 14], [5, 47], [7, 19]], [[863, 9788], [3, -8], [15, -9], [8, 5], [10, 0], [12, -7], [7, 4], [7, -15], [12, -18], [16, -4], [5, 10], [11, 6], [4, 14], [12, 2], [0, -9], [7, 5], [15, -15], [9, -24], [10, -11], [2, -11], [8, -2], [8, -18], [1, -11], [5, 9], [6, -7], [0, -1783], [13, -16], [2, 17], [14, -24], [8, 30], [18, 4], [-3, -52], [4, -17], [10, -17], [2, -27], [29, -101], [4, -63], [6, 17], [12, 31], [7, 1], [3, 23], [0, 34], [5, 0], [1, 31], [9, 7], [13, 26], [13, -45], [-1, -27], [3, -27], [7, -7], [10, -40], [-1, -12], [4, -22], [12, -25], [19, -110], [3, -29], [6, -29], [8, -65], [9, -55], [-3, -23], [9, -9], [-2, -33], [7, -14], [1, -38], [7, 2], [14, -40], [9, -7], [5, -19], [4, -5], [1, -19], [9, -5], [3, -23], [-4, -43], [1, -36], [4, -58], [-4, -15], [-6, -53], [-10, -39], [-3, 20], [-4, -6], [-3, 39], [1, 17], [-3, 20], [7, 21], [-2, 7], [-7, -26], [-3, 17], [-4, -10], [-12, 42], [4, 46], [-8, -15], [0, -23], [-6, 17], [-1, 22], [4, 24], [-1, 24], [-6, -19], [-6, 42], [-3, -8], [-2, 36], [5, 23], [6, 0], [-2, 28], [3, 36], [-5, -1], [-9, 32], [-6, 37], [-15, 27], [0, 77], [-4, 9], [1, 31], [-5, 9], [-8, 42], [-2, 22], [-12, 7], [-14, 56], [-6, 132], [-3, -30], [1, -27], [6, -53], [-1, -8], [3, -43], [0, -28], [-6, 6], [-4, 31], [-6, 6], [-8, -9], [0, 45], [-5, 38], [-5, -12], [-17, 40], [-2, -11], [10, -13], [7, -31], [3, -1], [1, -25], [4, -30], [-10, -16], [-5, 10], [0, -26], [-8, 20], [-2, 14], [-5, 0], [-13, 38], [-10, 33], [-1, 20], [-5, 30], [-14, 21], [-9, 21], [-14, 26], [-9, 24], [1, 26], [2, -9], [3, 17], [-3, 38], [4, 21], [-2, 9], [-7, -40], [-14, -26], [-18, 10], [-14, 24], [-1, 18], [-7, -4], [-7, 14], [-17, 12], [-9, 1], [-21, -10], [-8, -7], [-10, 27], [-12, 12], [-3, 17], [-2, 28], [-8, -2], [-3, -25], [-15, 34], [-2, 14], [-15, -27], [-7, -32], [-3, 30], [3, 17], [4, -5], [14, 22], [-2, 17], [-6, -8], [-3, 22], [-6, 3], [-6, 55], [-3, -13], [-8, -8], [-3, 8], [-3, -18], [-11, 6], [-1, -20], [-7, -5], [-3, 7], [2, 36], [-3, -1], [-5, -38], [7, -12], [1, -27], [4, -30], [-3, -31], [-5, 10], [-2, -15], [6, -7], [3, -41], [-8, -9], [-4, 9], [-7, -12], [-3, 10], [-9, -2], [0, 16], [-4, -10], [-3, -20], [-3, 18], [-5, -25], [2, -12], [-6, -15], [-6, -2], [-3, -20], [-6, -17], [-4, 6], [-5, -21], [-4, 1], [-8, -43], [-9, -3], [-3, 14], [-5, -23], [-11, 17], [2, 33], [8, 11], [4, -2], [2, 13], [8, 25], [0, 21], [-11, -28], [-9, 16], [-1, 12], [5, 48], [8, 34], [1, 29], [2, 5], [1, 30], [-4, 34], [10, 12], [19, 48], [4, -19], [6, -5], [9, 20], [-10, 26], [-4, 20], [-7, -2], [-5, 9], [-2, -8], [-9, -14], [-4, -26], [-9, -6], [-9, -30], [-1, -20], [-7, -11], [-2, -22], [-5, -13], [-2, -39], [-10, -25], [5, -20], [-4, -29], [-9, -5], [-1, -38], [-8, -13], [-3, 15], [-4, -29], [-5, -1], [1, -21], [-11, -13], [-2, -57], [12, -3], [10, -16], [3, -19], [-4, -30], [-7, -19], [-6, -1], [0, -17], [-4, -6], [1, -21], [-4, -31], [-9, -29], [-5, 0], [-5, -11], [-5, 2], [-4, -11], [2, -16], [-7, -8], [-2, -23], [-5, 14], [-5, -45], [-9, 4], [1, -24], [-6, 6], [-3, -11], [0, -32], [-6, -50], [-10, -6], [-7, -23], [-2, -13], [-5, 18], [-8, -48], [-2, 13], [-5, -4], [-1, -27], [-5, -10], [-6, 4], [-4, -27], [8, -9], [-9, -60], [-25, -20], [-6, -54], [-2, 12], [1, 33], [-5, 6], [-6, -13], [-1, -14], [-10, -22], [-4, -25], [-1, 18], [-2, -21], [-6, 14], [-10, -33], [-8, 2], [1, 25], [-4, 24], [-3, -20], [1, -21], [-11, -64], [-3, 16], [-1, -24], [-8, 4], [-1, 38], [-4, 8], [-2, -14], [4, -16], [-2, -27], [-5, -13], [-5, 29], [-5, 2], [-1, -11], [5, -17], [-9, -27], [6, -7], [0, -13], [-5, 9], [-7, -25], [-15, 1], [-7, -16], [0, -13], [-8, -15], [-6, 6], [-2, 35], [6, 12], [4, 43], [6, 1], [13, 28], [10, 1], [4, -27], [3, 20], [-1, 23], [6, 10], [7, 0], [8, 50], [10, 45], [12, 40], [15, 18], [6, -9], [6, 12], [1, -17], [-3, -19], [4, -14], [1, 23], [7, 2], [2, -15], [5, -5], [0, 18], [-8, 15], [0, 11], [5, 49], [6, 28], [9, 27], [15, 24], [10, 35], [5, -13], [4, 5], [-1, 22], [1, 21], [8, 44], [11, 28], [8, 38], [0, 21], [7, 148], [11, 40], [-1, 31], [-27, -45], [-8, 6], [-2, 18], [-5, 9], [-1, 21], [-4, -10], [-3, -32], [5, -41], [-6, -18], [-5, 7], [-9, 64], [-6, 33], [-4, 0], [-2, -24], [-3, -4], [-4, 19], [-5, 4], [-2, 32], [-16, -37], [-13, -26], [-1, -14], [-11, -22], [-6, 20], [5, 23], [-1, 54], [-4, 57], [7, 24], [-6, 49], [-5, 27], [-4, 39], [-6, 17], [-2, -34], [-7, -8], [-12, -22], [-14, -9], [-7, 2], [-7, 12], [-1, 30], [-5, 9], [-9, 42], [-8, 8], [-8, 46], [6, 21], [1, 39], [-5, -8], [0, 24], [2, 19], [-6, 18], [0, -19], [-7, 8], [-1, 32], [-6, 4], [-3, 22], [0, 27], [-5, -12], [-1, 26], [7, 6], [-6, 30], [10, 2], [0, 35], [2, 24], [18, 77], [4, 23], [3, -5], [-2, 33], [7, 55], [6, 22], [11, 9], [8, -9], [12, -33], [8, 4], [11, 32], [11, 49], [6, 6], [1, -13], [13, 0], [12, 10], [11, 52], [0, 12], [-5, 48], [-1, 28], [-8, 31], [-3, 26], [8, -7], [8, 22], [0, 20], [-10, 39], [-8, -30], [-7, 5], [-6, -17], [-8, -4], [-2, -11], [-9, -17], [-2, -28], [-5, -12], [-2, 34], [-5, 7], [-4, -26], [-2, 12], [-10, 19], [-20, -1], [-14, -21], [-6, -3], [-11, 13], [-22, 14], [-6, 12], [-3, 19], [2, 26], [-8, 22], [2, 24], [5, 12], [-2, 31], [-8, 0], [-6, 8], [-13, 6], [-7, 16], [-10, 16], [-1, 19], [16, 27], [20, 43], [15, 27], [8, -15], [8, -3], [2, 21], [-5, 3], [-1, 18], [20, 29], [22, 22], [12, 2], [7, -7], [-4, -32], [2, -22], [-3, -15], [4, -26], [8, 5], [10, -5], [11, 6], [4, -10], [7, -2], [7, 10], [8, -11], [9, 42], [5, 2], [5, -8], [2, 24], [-12, 11], [-11, -9], [1, 31], [-8, 34], [-10, 10], [-2, 30], [7, 8], [9, -31], [-1, -24], [4, -18], [10, -22], [2, 23], [-11, 30], [5, 54], [-4, 10], [-11, -12], [-11, 3], [-2, 10], [-6, -10], [-24, 23], [0, 24], [-7, 54], [-6, 19], [-9, 17], [-19, 46], [-9, 18], [-8, 4], [-13, 31], [-12, 18], [-1, 6], [9, 10], [4, 29], [1, 59], [25, -4], [31, 13], [8, 11], [12, 29], [12, 45], [3, 45], [5, 38], [10, 33], [5, 24], [13, 38], [2, -10], [11, -3], [16, 20], [10, 21], [24, 64], [9, 4], [1, -10], [9, 7], [9, -2], [18, 9], [17, 28], [17, 58], [7, 13], [2, -10], [26, -24], [2, -17], [-9, -22], [-4, -1], [0, -29], [14, 9], [0, 16], [6, 14], [2, -8], [5, 33], [13, -30], [-2, -23], [8, -6], [5, -14], [7, 22], [13, 1], [7, 7], [18, -7], [10, -8], [-5, -45], [17, -12], [2, -11], [16, -20], [1, 9], [12, 13], [11, -1], [0, -11], [7, -1], [7, 15], [11, 2], [9, -6], [11, -16], [5, 3], [7, -22], [4, 9], [7, -7], [5, -13]], [[717, 7456], [-1, -8], [-9, 13], [7, 49], [6, 4], [4, 45], [5, -40], [4, 14], [8, -22], [0, -31], [-11, -4], [-5, -13], [-8, -7]], [[688, 7363], [8, 25], [-8, 6], [0, 22], [6, 14], [5, -10], [0, -22], [3, 15], [0, 32], [5, -15], [1, 21], [5, -12], [5, 0], [5, 11], [7, -20], [0, -55], [9, 4], [-6, -37], [-11, 15], [4, -24], [-3, -20], [-6, 10], [0, -38], [-8, -10], [-3, -16], [-5, 15], [-6, -40], [-4, -4], [-5, -18], [-2, 43], [-6, -23], [-1, 13], [-6, 14], [0, 39], [-6, 15], [4, 45], [11, 28], [7, -2], [1, -21]], [[671, 7185], [-6, -39], [-2, 6], [8, 33]], [[640, 7055], [4, -2], [-1, -40], [-8, 6], [-1, 13], [6, 23]], [[519, 6933], [-2, -41], [-9, -33], [5, 51], [2, -5], [4, 28]], [[501, 6947], [5, 0], [0, -20], [-5, -23], [-5, 15], [-3, -14], [-2, 35], [2, 12], [8, -5]], [[451, 6875], [1, -16], [-3, -11], [-3, 18], [5, 9]], [[447, 8527], [-4, -19], [-2, 16], [6, 3]], [[436, 6781], [6, -7], [-1, -16], [-5, 1], [0, 22]], [[358, 6745], [2, -22], [-5, -10], [-1, 23], [4, 9]], [[352, 6718], [-8, -21], [-2, 14], [3, 19], [7, -12]], [[335, 7902], [6, 7], [2, -14], [5, 3], [6, -12], [1, -54], [-3, -18], [-7, -11], [-2, -18], [-11, 20], [-5, -1], [-10, 28], [-4, 0], [-6, 15], [-3, 25], [4, 7], [10, -7], [5, 20], [5, 2], [3, 14], [4, -6]], [[334, 6690], [5, -14], [-10, -36], [1, -6], [12, 26], [0, -15], [-5, -17], [-8, -12], [-1, -18], [-8, -18], [-7, -1], [-5, -18], [-9, -16], [-5, 17], [9, 20], [3, -3], [8, 16], [-2, 19], [4, 20], [6, -9], [1, 12], [-7, 4], [-4, 14], [4, 23], [11, 13], [2, -26], [5, 25]], [[266, 6527], [10, 37], [1, 16], [4, 17], [7, 9], [3, -10], [1, -25], [-12, -27], [-6, -40], [-6, -13], [-2, 36]], [[238, 6477], [2, -19], [-8, -1], [-1, 13], [7, 7]], [[227, 7303], [-4, -18], [-1, 18], [5, 0]], [[212, 6440], [2, -18], [-5, -13], [-1, 19], [4, 12]], [[182, 8542], [22, -28], [13, 24], [6, -2], [5, -14], [2, -23], [11, -12], [4, -12], [15, -5], [8, -8], [-4, -28], [-7, 6], [-8, -5], [-4, -13], [-4, -28], [-5, 26], [-6, 18], [-6, 2], [-3, 20], [-15, 25], [-6, 1], [-11, -22], [-7, 11], [-4, 23], [4, 44]], [[162, 6381], [0, -22], [-5, -4], [1, 19], [4, 7]], [[128, 6335], [4, -8], [10, 1], [1, -7], [-13, -9], [-2, 23]], [[108, 6360], [0, 19], [4, 7], [6, -19], [-2, -17], [-4, 1], [1, -20], [-5, -2], [-12, -21], [-6, 6], [2, 15], [7, -2], [9, 33]], [[47, 6279], [5, 3], [0, -24], [-6, 3], [-8, -28], [-4, 37], [4, 1], [0, 29], [5, 1], [0, -21], [4, -1]], [[28, 6296], [3, -9], [-2, -32], [-5, -10], [0, 20], [4, 31]], [[0, 6291], [5, -1], [4, -23], [-4, -27], [-5, 51]], [[9993, 6496], [6, -13], [0, -19], [-11, -12], [-8, 31], [0, 15], [13, -2]], [[1966, 3444], [-1, -1081]], [[1965, 2363], [-57, 0], [-34, 71], [-73, 150], [3, 43]], [[1804, 2627], [6, 8], [1, 16], [-1, 36], [-4, 1], [-2, 71], [6, 27], [0, 28], [-1, 45], [4, 34], [4, 12], [4, 25], [-6, 27], [-4, 51], [-5, 31], [0, 24]], [[1806, 3063], [2, 26], [0, 36], [-3, 36], [-2, 112], [11, 7], [3, -23], [3, 1], [3, 33], [0, 153]], [[1823, 3444], [101, 2], [42, -2]], [[2515, 3253], [-1, -35], [-4, -11], [-1, -29], [-5, -31], [0, -46], [-3, -34], [-3, -5]], [[2498, 3062], [2, -17], [-4, -14], [-2, -33], [-3, -8], [0, -38], [-5, -10], [0, -13], [-6, -31], [2, -21], [-5, -30], [-5, -59], [5, -25], [-2, -16], [1, -39], [-2, -26]], [[2474, 2682], [-69, 3], [-13, 0]], [[2392, 2685], [0, 101], [-4, 8], [-5, -9], [-3, 18]], [[2380, 2803], [1, 335], [-5, 211]], [[2376, 3349], [4, 0], [123, -1], [2, -36], [-4, -23], [-4, -36], [18, 0]], [[1654, 4398], [0, -331], [0, -241], [36, -171], [35, -169], [27, -137], [20, -101], [34, -185]], [[1804, 2627], [-38, -18], [-30, -16], [-4, 25], [0, 40], [-2, 47], [-4, 33], [-9, 46], [-12, 43], [-2, -12], [-4, 8], [1, 18], [-5, 39], [-7, -8], [-12, 28], [-2, 23], [-8, 28], [-9, -1], [-7, 13], [-10, -6], [-5, 26], [1, 53], [-1, 8], [1, 38], [-8, 28], [0, 39], [-3, 2], [-4, 33], [-4, 8], [-1, 20], [-11, 79], [-5, 23], [-1, 61], [2, -5], [2, 37], [-4, 33], [-5, -4], [-7, 30], [-2, 24], [0, 23], [-3, 31], [0, 50], [5, 0], [-2, 70], [-2, -7], [-1, -35], [-5, -7], [-7, 26], [-1, 45], [-4, 35], [-6, 22], [-3, 25], [-9, 50], [2, 14], [-4, 64], [2, 35], [-3, 54], [-7, 52], [-7, 29], [-2, 35], [7, 83], [2, 29], [-2, 22], [3, 57], [-2, 52], [-3, 13], [1, 42]], [[1534, 4399], [28, 1], [24, 1], [38, -3], [30, 0]], [[2107, 4208], [57, 0], [0, -191]], [[2164, 4017], [1, -574]], [[2165, 3443], [-28, 1]], [[2137, 3444], [-38, -1], [-72, 0], [-15, 1], [-46, 0]], [[1966, 3444], [0, 223], [-1, 21], [0, 162], [0, 357]], [[1965, 4207], [32, 1], [63, -1], [47, 1]], [[3025, 4400], [0, -113], [-2, -18]], [[3023, 4269], [-2, 3], [-12, -14], [-15, 4], [-7, -26], [-7, -9], [-8, -22]], [[2972, 4205], [-2, 22], [7, 21], [-2, 16], [2, 144]], [[2977, 4408], [12, -2], [36, -3], [0, -3]], [[2922, 3980], [-2, -23]], [[2920, 3957], [-3, -13], [0, -30], [5, -29], [1, -47], [6, -49], [3, -2], [1, -66]], [[2933, 3721], [-19, 2], [-2, 241]], [[2912, 3964], [5, 21], [5, -5]], [[2876, 3786], [-2, 27]], [[2874, 3813], [2, 12], [4, -19], [-4, -20]], [[2649, 2300], [4, -55], [39, -13], [37, -14], [1, -41], [4, 1], [1, 39], [-1, 35], [2, 15], [7, -16], [8, -7]], [[2751, 2244], [1, -83], [4, -93], [8, -122], [13, -131], [-2, -9], [1, -61], [5, -68], [8, -137], [2, -42], [0, -44], [-3, -158], [-3, -3], [-3, -49], [1, -16], [-5, -36], [-2, 9], [-6, -15], [-9, -8], [-2, 20], [1, 29], [-7, 85], [-5, 15], [-4, -11], [-3, 47], [-1, 38], [-6, 43], [-2, 28], [1, 41], [-3, 8], [1, -24], [-3, -7], [-9, 104], [-4, 26], [9, 76], [-6, -4], [-4, -24], [-3, 38], [5, 104], [1, 87], [-4, 21], [-1, 28], [-5, 6], [-7, 46], [-5, 19], [0, 28], [-4, 11], [-3, 31], [-11, 42], [-9, -10], [0, -29], [-3, 5], [-12, -35], [-12, -9], [0, 21], [-3, 25], [-15, 57], [-10, 24], [-10, 6], [-8, -4], [-17, -18]], [[2703, 3063], [-6, -41], [0, -20], [9, -40], [3, 3], [5, -42], [1, -22], [4, -40], [7, -24], [3, -35], [8, -33], [0, -22], [5, -35], [7, -29], [2, -32], [1, -40], [3, -14], [5, -51], [0, -33], [7, -16]], [[2767, 2497], [-7, -65], [-2, -34], [-3, -29], [0, -30], [-3, -14], [-1, -81]], [[2632, 3060], [37, 1]], [[2669, 3061], [20, -1], [14, 3]], [[640, 0], [-7, 17], [-1, 16], [1, 43], [-5, 73], [4, 24], [2, 34], [-2, 22], [1, 23], [8, -27], [9, -20], [5, -29], [0, -26], [8, -40], [-5, -34], [-8, -15], [-7, -25], [-3, -36]], [[613, 397], [3, -26], [4, 11], [9, -30], [-1, -27], [-9, -14], [-2, 6], [-1, 33], [-5, 7], [-1, 19], [3, 21]], [[602, 432], [-3, -20], [-7, 0], [2, 22], [8, -2]], [[574, 525], [3, -45], [-2, -26], [-6, -5], [-4, 54], [4, 1], [5, 21]], [[531, 626], [3, -2], [2, -20], [-1, -28], [-4, -18], [-9, 22], [1, 31], [8, 15]], [[1908, 4871], [0, -472]], [[1908, 4399], [-31, -1], [-54, 0]], [[1823, 4398], [-85, 1]], [[1738, 4399], [0, 349], [4, 62], [-2, 16], [-6, 3], [-2, 26], [6, 68], [3, 6], [3, 29], [-1, 17], [4, 23], [1, 34], [6, 56], [-2, 26], [-7, 14], [-4, 32]], [[1741, 5160], [0, 34], [-3, 33], [0, 16], [0, 255], [0, 236]], [[1738, 5734], [28, 0]], [[1766, 5734], [0, -195], [9, -54], [1, -52], [5, -23], [6, -8], [0, -14], [11, -51], [1, -21], [8, -20], [0, -12], [8, 1], [-4, -71], [-1, -45], [3, -29], [-5, -21], [2, -20], [-1, -21], [6, -20], [7, 26], [3, 21], [5, -19], [-1, -15], [3, -37], [5, -39], [3, -13], [0, -37], [3, -16], [6, -2], [4, -61], [3, -11], [3, 18], [9, -1], [7, 17], [3, -10], [7, 9], [2, -11], [5, 8], [7, 39], [4, -33], [5, -20]], [[2489, 4496], [53, -3], [28, 0]], [[2570, 4493], [-1, -37], [4, -43], [5, -70]], [[2578, 4343], [0, -450], [-3, -35], [3, -40], [1, -34], [-4, -27], [-1, -25], [-5, -41], [-3, -3], [0, -24], [-2, -9], [-1, -45], [0, -13]], [[2563, 3597], [-3, -27], [2, -34], [-11, -17], [-1, -20], [2, -25], [-3, -16], [-11, 29], [-3, -2], [-4, -33], [1, -11]], [[2532, 3441], [-5, 2], [-6, 55], [2, 12], [-2, 37], [0, 29], [-9, 41], [-3, -4], [-3, 25], [-9, 38], [0, 31], [5, 49], [-1, 18], [3, 23], [-4, 13], [-6, 9], [-3, -18], [-3, 11], [-1, 63], [-10, 41], [-9, 49], [-3, 58], [-1, 39], [3, 27]], [[2467, 4089], [0, 35], [8, 21], [1, 29], [4, 19], [0, 33], [-4, 27], [2, 34], [11, 9], [9, 24], [0, 29], [4, 13], [1, 37], [0, 24], [-7, 18], [-1, 20], [-6, 35]], [[2655, 4340], [0, -228], [0, -266]], [[2655, 3846], [-2, -9], [2, -52], [-5, -1], [-5, -18], [-8, 9], [1, -38], [-5, -16], [-2, -24], [-5, -9], [-3, -48], [-3, -13], [-6, 18], [-1, 22], [-7, -24], [1, -21], [-7, -7], [-1, 19], [-8, -19], [-2, -20], [-7, 28], [-4, -6], [-2, 13], [-3, -13], [-7, -2], [-3, -18]], [[2578, 4343], [3, -12], [8, 0], [9, 22]], [[2598, 4353], [23, 0], [34, 0], [0, -13]], [[2473, 4685], [0, -28], [4, -19], [-3, -23], [1, -43], [2, -30], [10, -22], [2, -24]], [[2467, 4089], [-3, 7], [-6, 38], [-3, -1], [-40, -5], [-39, -2], [-33, 3]], [[2343, 4129], [-3, 25], [2, 49], [-3, 43], [0, 48], [-5, 17], [-1, 26], [2, 23], [-2, 33], [-4, 13], [-5, 86]], [[2324, 4492], [-5, 41], [2, 29], [1, 37], [2, 14], [-3, 19], [1, 33], [-2, 16], [4, 4]], [[2324, 4685], [144, 0], [5, 0]], [[2356, 4017], [3, -18], [9, -14], [-6, -56], [4, -18], [4, -45], [6, -10], [0, -412]], [[2376, 3444], [-156, 0], [-55, -1]], [[2164, 4017], [5, 0], [187, 0]], [[2718, 3716], [-1, -57], [4, -37], [4, -28], [2, -22], [5, -22], [4, -3]], [[2736, 3547], [-11, -51], [-11, -29], [0, -14], [-4, -13], [0, -16], [-6, -8], [-1, -21], [-16, -27]], [[2687, 3368], [0, -3], [-24, 2], [-22, 6], [-5, -2], [-32, 8], [-36, -5], [-6, 9], [1, -35], [-36, 2], [-3, -2]], [[2524, 3348], [1, 24], [5, -8], [2, 77]], [[2655, 3846], [11, 0], [5, -40], [1, -17], [9, -7], [6, -26], [5, 13], [10, -14], [4, 19], [4, 6], [1, -32], [3, -6], [4, -26]], [[2474, 2682], [3, -22], [-2, -9], [-1, -38], [5, -24], [0, -57], [-3, -44], [-7, -27], [-2, -43], [-2, 4], [-1, -70], [-3, -2], [2, -37], [-2, -14], [54, 0], [-3, -63], [4, -41], [1, -32], [4, -20]], [[2521, 2143], [-9, -26], [0, -19], [7, -12], [3, 30], [6, -30], [-1, -24], [-3, -11], [-7, 10], [1, -18], [-2, -27], [5, -24], [9, -7], [3, -29], [3, -4], [-5, -32], [-5, 6], [-4, 33], [-10, 18], [0, 33], [-6, -11], [1, -27], [-3, -25], [-3, -4], [-3, 28], [-7, 1], [-2, -29], [-4, -9], [-5, 18], [-4, 2], [-3, 47], [-7, 21], [-2, -3], [-3, 40], [-7, -5], [0, 24], [-8, -23], [1, -18], [-5, -17], [-9, 8], [-10, 27], [-7, 11], [-16, -9], [-2, -8]], [[2398, 2049], [-2, 19], [6, 68], [-2, 37], [2, 20], [-1, 26], [3, 19], [3, 50], [0, 40], [-8, 78], [0, 41], [-7, 42], [0, 196]], [[3046, 5029], [12, 26], [-2, 13], [5, 30], [4, 13], [-1, 12], [5, 18], [-1, 33], [2, 50], [5, 17], [1, 53], [22, 147], [6, -7], [0, -35], [4, -13], [9, 21], [6, 0], [4, 14], [8, -31], [4, -25], [1, -214], [-1, -51], [10, -14], [-2, -22], [3, -21], [-2, -18], [4, -30], [5, 7], [5, -68], [-6, -31], [-3, 12], [-3, -21], [-4, 5], [0, -18], [-6, 2], [-8, -40], [-2, 28], [-3, 2], [1, -30], [-6, -15], [-2, 24], [-3, -12], [-7, 0], [0, 28], [-5, -6], [1, -20], [-4, -42], [1, -12], [-6, -23], [-5, 9], [-3, -24], [-4, -3], [-4, -20], [-4, 4], [-1, 21], [-7, -34], [2, -21], [-5, -7], [0, -18], [-5, -22], [-5, -50]], [[3056, 4600], [-3, 14], [0, 19], [-4, 22], [-2, 250], [-1, 124]], [[2904, 3626], [2, 0], [-1, 0], [-1, 0]], [[2933, 3721], [-6, -80]], [[2927, 3641], [-4, -3], [-8, -12]], [[2915, 3626], [-6, -8], [0, 31], [-2, 13], [3, 13], [-4, 32], [-2, -14], [-6, 3], [-2, 35], [2, 0], [0, 45], [2, 18], [-2, 60], [3, 36], [5, 6], [0, 37], [-3, -5], [0, -18], [-8, -25], [-2, -21], [0, -56], [-3, -26], [1, -44], [4, -30], [-1, -23], [3, -23], [-2, -16], [-6, 30], [-10, 15], [-2, 29], [-6, -16], [-2, 23], [5, 29]], [[2874, 3756], [2, 30]], [[2874, 3813], [-4, 18], [-6, 10], [0, 28], [-3, 15], [-4, 4]], [[2857, 3888], [-4, 53], [-4, 0], [-5, 18], [-3, -15], [-5, 1], [-1, -21], [-8, 14], [-6, -28], [-3, 6], [-6, -33], [-6, -17], [1, 98]], [[2807, 3964], [105, 0]], [[3053, 4565], [1, -34], [-1, -27], [-5, -25], [0, -29], [6, -4], [4, -31], [0, -24], [3, -6], [0, -22], [8, -19], [9, 18], [-2, -26], [-13, -23], [-5, -1], [-3, 18], [-5, -6], [0, -13], [-5, -9]], [[3045, 4302], [-3, 35]], [[3042, 4337], [0, 6]], [[3042, 4343], [-3, 14], [-2, 45], [-4, 0], [-8, -2]], [[2977, 4408], [0, 7], [6, 126]], [[2983, 4541], [23, -3]], [[3006, 4538], [34, -7], [3, 18], [7, 19], [3, -3]], [[2598, 4353], [5, 25], [4, 43], [4, 26], [3, 36], [1, 52], [0, 57], [-9, 111], [3, 42], [-2, 50], [6, 51], [2, 43], [-1, 23], [5, 9], [0, 31], [8, 9], [5, 34], [0, -69], [3, -3], [3, 35], [1, 58], [2, 15], [8, 9], [-3, 41], [5, 35], [7, 2], [7, -22], [7, -3], [3, -28], [6, -2], [9, -25], [3, 1], [4, -41], [-3, -21], [3, -29], [2, -32], [-2, -71], [-6, -18], [-1, -37], [-7, -12], [-4, -44], [2, -17], [6, -15], [6, 24], [6, 49], [10, 19], [5, -15], [3, -27], [3, -80], [0, -39], [3, -48], [-3, -69], [-4, -11], [-1, 25], [-3, -7], [-3, -58], [-6, -21], [-2, -44], [-7, -37], [0, -16]], [[2694, 4347], [-39, -7]], [[2635, 5110], [1, -23], [-4, -4], [1, 33], [2, -6]], [[2496, 5270], [11, 20], [5, 23], [12, 9], [8, 29], [4, 1], [3, 20], [9, 28], [4, 24], [7, 15], [6, -13], [-11, -59], [-2, -19], [0, -36], [5, 27], [10, -4], [8, -19], [7, -52], [3, -10], [7, 9], [2, -12], [7, -6], [16, 44], [8, 4], [10, -2], [7, 15], [6, 1], [1, -54], [5, -7], [6, 8], [2, -12], [4, 16], [8, 5], [1, -67], [3, -28], [6, -8], [1, 19], [5, 0], [3, -20], [-3, -14], [-15, 12], [-8, -8], [-8, 23], [-2, -21], [1, -18], [-4, 4], [-5, 27], [-9, 15], [-5, 1], [-4, -25], [-8, -6], [-8, 5], [-3, -10], [-1, -21], [-9, -18], [1, 25], [-4, 5], [-2, -26], [-6, -1], [-3, -11], [-5, -45], [-8, -58], [1, -5]], [[2576, 4989], [-4, 20], [2, 27], [-7, 4], [3, 26], [0, 34], [-5, 23], [-4, 24], [-12, 19], [-4, -7], [-12, 29], [-29, 38], [-3, 33], [-5, 11]], [[2541, 5539], [-7, -24], [-4, -3], [1, 19], [18, 45], [-4, -31], [-4, -6]], [[2324, 4685], [0, 343], [-7, 22], [-5, 36], [8, 41], [1, 22]], [[2321, 5149], [-1, 76], [-4, 20], [-2, 42], [0, 51], [-1, 8], [-1, 123], [-5, 65], [-3, 36], [0, 77], [1, 27], [-3, 60]], [[2302, 5734], [59, 0], [0, 73], [5, -2], [4, -14], [4, -100], [3, -11], [9, -3], [1, -10], [11, -4], [1, -21], [10, 5], [0, 9], [7, 10], [6, -4], [8, -16], [2, -19], [4, 2], [4, -43], [2, 18], [7, 8], [1, -18], [9, -12], [0, -17], [4, -14], [8, 8], [5, 18], [8, 12], [2, -28], [5, 6], [6, -6], [6, 4], [8, -24], [7, 4], [0, -10], [-10, -24], [-13, -19], [-9, -20], [-12, -49], [-5, -31], [-8, -34], [-13, -46], [2, -16]], [[2450, 5296], [-2, 9], [-6, -16], [0, -113], [-2, -11], [-8, -16], [-6, -41], [-1, -27], [3, -2], [4, -24], [-3, -29], [0, -33], [-2, -70], [8, -34], [6, -3], [3, -21], [8, -21], [2, -25], [8, -33], [5, -7], [5, -42], [-1, -30], [2, -22]], [[2553, 2179], [-3, -8], [-7, 4], [-3, 12], [-7, -8], [-9, -22], [-3, -14]], [[2498, 3062], [53, 0], [7, 0]], [[2524, 3348], [-2, 0], [-2, 0], [1, -47], [-6, -48]], [[2376, 3349], [0, 95]], [[2356, 4017], [-7, 50], [-6, 62]], [[2108, 5151], [0, -181], [-1, 0]], [[2107, 4970], [-53, 1], [-90, 0], [-56, 0], [0, -100]], [[1766, 5734], [130, -1], [58, 1], [154, 0]], [[2108, 5734], [0, -217], [0, -366]], [[2107, 4208], [0, 382]], [[2107, 4590], [21, 0], [49, -1], [88, 0], [1, -10], [15, -34], [4, 19], [4, -4], [13, 0], [15, -36], [2, -27], [5, -5]], [[1823, 4398], [0, -954]], [[1654, 4398], [37, -1], [47, 2]], [[3006, 4538], [-2, 14], [0, 28], [3, 11], [-1, 27], [3, 81], [5, 37], [2, 43], [3, 16], [-1, 47], [10, 17], [5, 33], [-3, 31], [4, 32], [0, 18]], [[3034, 4973], [4, 49], [6, -5], [2, 12]], [[3056, 4600], [-3, -35]], [[2962, 4152], [-5, -13], [-2, -29], [8, -14], [0, -22], [-3, -103], [-9, -76], [-6, -22], [-5, -48], [-3, 31], [-8, 16], [-10, 42], [-1, 28], [0, 4], [2, 11]], [[2922, 3980], [8, 15], [0, 15], [9, 31], [2, 17], [-9, 39], [0, 24], [-3, 6], [-1, 22], [5, 33], [-3, 20], [7, 40], [2, 21], [4, 13]], [[2943, 4276], [13, -41], [9, -28], [-3, -55]], [[2137, 3444], [0, -95]], [[2137, 3349], [-1, 0], [0, -474], [0, -193], [0, -192], [-101, 0], [-1, -18], [3, -22]], [[2037, 2450], [-48, 0], [0, -87], [-24, 0]], [[2972, 4205], [13, -15], [2, 11], [10, 0], [6, 6], [8, 31], [1, -22], [5, -10], [-11, -28], [-22, -42], [-9, -8], [-6, 2], [-5, -9], [-2, 31]], [[2943, 4276], [-2, 14], [-4, 1], [-5, 32], [1, 29], [-4, 22], [-2, -2], [-3, 27], [-125, 0], [0, 48], [0, 3]], [[2799, 4450], [17, 54], [3, 26], [5, 18], [-2, 32], [-2, 7], [-2, 52], [17, 22], [15, -1], [6, -5], [6, -21], [4, 8], [12, -1], [8, 14], [8, 34], [5, 1], [0, 52], [3, 31], [-7, 21], [2, 24], [11, 32], [4, 28], [14, 64], [13, 32], [19, -5], [23, 4]], [[2981, 4973], [1, -39], [-2, -36], [3, -34], [-1, -37], [-3, -39], [2, -52], [-1, -16], [4, -31], [-1, -132], [0, -16]], [[2909, 3359], [4, -77], [-8, 8], [-1, -10], [-10, -11], [-1, -11], [-7, -3], [0, -13], [8, 9], [1, -8], [9, 9], [3, -18], [5, 8], [2, -46], [-2, -22], [-3, -2], [-8, -47], [-9, -2], [-2, -33], [4, -32], [4, -6], [-6, -54], [-6, 7], [-9, -6], [-6, -11], [-10, -37], [-7, -48], [-4, -60], [-6, 13], [-11, -12]], [[2833, 2844], [-32, 181], [-32, 4], [1, 21], [-5, 33], [-3, -12], [0, 20], [-35, 10], [-8, -8], [-6, -17], [-10, -13]], [[2669, 3061], [1, 45], [5, 4], [3, 31], [7, 29], [7, 1], [7, 29], [8, 10], [6, 43], [4, 13], [1, -19], [11, 37], [5, -8], [4, 36], [5, 9], [1, 45]], [[2744, 3366], [20, -5], [19, -3], [23, -1], [103, 2]], [[2321, 5149], [-213, 2]], [[2108, 5734], [194, 0]], [[2777, 4138], [-4, -10], [2, -21], [0, -29], [-4, -46], [-3, -70], [-11, -62], [-3, -8], [-4, 12], [-3, -27], [-3, 1], [-4, -36], [1, -22], [-3, -18], [-4, 29], [-5, -46], [1, -29], [-3, -11], [-1, -25], [-8, -4]], [[2694, 4347], [11, -26], [3, -15], [3, 14], [6, -30], [4, -9], [14, 25], [7, -6], [9, 36], [12, 34], [14, 24]], [[2777, 4394], [0, -256]], [[2380, 2803], [-11, 21], [-3, 22], [-7, 18], [-2, -16], [-8, 1], [-1, 10], [-7, -19], [-3, 11], [-6, -10], [-5, -29], [-2, 17], [-6, 14], [-7, 0], [-2, 21], [-7, -42], [-2, 24], [-3, -8], [-3, 16], [-7, 15], [-5, -25], [-2, 26], [-4, 3], [-2, 21], [-6, 8], [-3, -18], [-3, 16], [-5, -2], [-6, 17], [-6, -2], [-2, 36], [-9, 2], [-4, -6], [-6, 37], [-2, -3], [0, 370], [-52, 0], [-34, 0]], [[1534, 4399], [-4, 22], [-2, 61], [0, 43], [-4, 33], [3, 32], [2, 51], [4, 54], [2, 48], [3, 162], [0, 22], [3, 71], [1, 99], [-2, 54], [1, 32], [12, 29]], [[1553, 5212], [5, -22], [4, 5], [3, 2], [6, -20], [3, -23], [1, -57], [15, -21], [12, 30], [8, 3], [9, -10], [1, -13], [16, 27], [3, -9], [9, 5], [7, 19], [12, 17], [12, 4], [4, 12], [58, -1]], [[2807, 3964], [-30, 0], [0, 174]], [[2777, 4394], [5, 11], [17, 45]], [[3045, 4302], [-6, -4], [3, 39]], [[3042, 4343], [-4, 3], [-3, -28], [-1, -40], [-11, -9]], [[2833, 2844], [-5, -10], [-6, -31], [-6, -49], [-1, -40], [-5, -31], [-6, 0], [-2, -23], [-6, -25], [-4, -28], [-6, -11], [-6, -29], [-1, -14], [-6, -16], [-6, -40]], [[2107, 4590], [0, 380]], [[2687, 3368], [57, -2]], [[2398, 2049], [-5, -1], [-14, -26], [-6, 15], [-1, 31], [-3, -22], [-3, 5], [-1, -27], [3, -11], [0, -36], [-5, -37], [-9, -47], [-17, -51], [-2, 9], [-5, -13], [0, 12], [-7, -9], [-3, 24], [-2, -5], [7, -49], [-5, -16], [-5, 10], [-1, -35], [-7, -35], [-6, -66], [-4, -69], [-3, 5], [-1, -25], [3, 6], [-2, -50], [-2, -2], [0, -28], [3, -16], [1, -57], [3, -20], [0, -37], [3, -32], [-9, -20], [-3, 25], [-7, 10], [-9, -3], [-8, 32], [-5, 3], [-5, 25], [-6, 8], [-4, 24], [-2, 58], [-5, 34], [0, 30], [-2, 31], [1, 27], [-4, 30], [-3, 4], [-5, 27], [-1, 34], [-5, 32], [-6, 26], [-3, 57], [-2, 16], [-4, 46], [-1, 38], [-4, 27], [-6, 24], [-1, 16], [-6, 15], [-4, 42], [-13, 9], [-7, -2], [-7, 15], [-1, -20], [-7, -6], [-5, -40], [-3, -64], [-2, -1], [-4, -37], [-5, -1], [-7, 29], [-17, 47], [-4, 25], [-6, 24], [-5, 54], [-1, 49], [-4, 40], [-2, 35], [-3, 22], [-11, 32], [-6, 44], [-4, 15], [-6, 38], [-7, 20], [-5, 50], [-4, 11]], [[1908, 4399], [0, -192], [57, 0]], [[2981, 4973], [30, -2], [23, 2]], [[2927, 3641], [-4, -32], [-3, -12], [-3, -44], [-6, -71], [-5, -15], [-1, 27], [2, 58], [8, 74]], [[2874, 3756], [-4, -8], [-2, -28], [1, -19], [8, 6], [1, -31], [10, -12], [3, -24], [8, -26], [-4, -54], [4, -41], [-4, -20], [-1, -24], [4, -15], [-4, -23], [-6, 30], [-1, -10], [5, -22], [14, -5], [3, -71]], [[2736, 3547], [-1, -16], [4, -32], [5, -16], [4, 1], [5, 25], [4, -20], [7, 11], [13, 36], [1, -11], [5, 17], [0, 34], [4, 30], [5, 29], [2, 34], [6, 36], [2, 44], [5, -27], [4, -8], [3, 16], [6, 68], [4, -17], [13, 77], [2, 57], [15, -64], [3, 37]], [[1553, 5212], [-5, 7], [-4, -12], [-6, 17], [1, 26], [4, 14], [-6, 40], [-4, 103], [-2, 14], [-3, 73], [-6, 28], [-2, 56], [3, 38], [6, -18], [11, -24], [8, 1], [8, -9], [8, 9], [3, -16], [7, 1], [5, -42], [3, 3], [1, -56], [2, -52], [3, 6], [-3, 43], [1, 43], [4, 44], [-3, 18], [-1, 31], [-3, 35], [2, 25], [-2, 29], [-5, 4], [-4, 22], [1, 21], [163, 0]], [[1576, 5602], [4, 9], [0, -39], [-5, 15], [1, 15]], [[1568, 5655], [3, 25], [4, -30], [-1, -27], [-7, 8], [1, 24]], [[2576, 4989], [-1, -23], [-6, -4], [-4, -44], [-2, -30], [3, -6], [5, 20], [4, 38], [6, 15], [5, 48], [6, 10], [-1, -25], [-4, -23], [-8, -79], [-2, -44], [0, -32], [-3, -10], [-2, -43], [1, -37], [-3, -24], [-3, -59], [0, -47], [4, -42], [-1, -55]], [[2450, 5296], [6, -2], [20, 33], [8, 17], [2, -13], [-4, -25], [9, -33], [5, -3]]] };
	    Datamap.prototype.usgTopo = '__USG__';
	    Datamap.prototype.uzbTopo = '__UZB__';
	    Datamap.prototype.vatTopo = '__VAT__';
	    Datamap.prototype.vctTopo = '__VCT__';
	    Datamap.prototype.venTopo = '__VEN__';
	    Datamap.prototype.vgbTopo = '__VGB__';
	    Datamap.prototype.virTopo = '__VIR__';
	    Datamap.prototype.vnmTopo = '__VNM__';
	    Datamap.prototype.vutTopo = '__VUT__';
	    Datamap.prototype.wlfTopo = '__WLF__';
	    Datamap.prototype.wsbTopo = '__WSB__';
	    Datamap.prototype.wsmTopo = '__WSM__';
	    Datamap.prototype.yemTopo = '__YEM__';
	    Datamap.prototype.zafTopo = '__ZAF__';
	    Datamap.prototype.zmbTopo = '__ZMB__';
	    Datamap.prototype.zweTopo = '__ZWE__';
	
	    /**************************************
	                  Utilities
	    ***************************************/
	
	    //convert lat/lng coords to X / Y coords
	    Datamap.prototype.latLngToXY = function (lat, lng) {
	        return this.projection([lng, lat]);
	    };
	
	    //add <g> layer to root SVG
	    Datamap.prototype.addLayer = function (className, id, first) {
	        var layer;
	        if (first) {
	            layer = this.svg.insert('g', ':first-child');
	        } else {
	            layer = this.svg.append('g');
	        }
	        return layer.attr('id', id || '').attr('class', className || '');
	    };
	
	    Datamap.prototype.updateChoropleth = function (data, options) {
	        var svg = this.svg;
	        var that = this;
	
	        // when options.reset = true, reset all the fill colors to the defaultFill and kill all data-info
	        if (options && options.reset === true) {
	            svg.selectAll('.datamaps-subunit').attr('data-info', function () {
	                return "{}";
	            }).transition().style('fill', this.options.fills.defaultFill);
	        }
	
	        for (var subunit in data) {
	            if (data.hasOwnProperty(subunit)) {
	                var color;
	                var subunitData = data[subunit];
	                if (!subunit) {
	                    continue;
	                } else if (typeof subunitData === "string") {
	                    color = subunitData;
	                } else if (typeof subunitData.color === "string") {
	                    color = subunitData.color;
	                } else if (typeof subunitData.fillColor === "string") {
	                    color = subunitData.fillColor;
	                } else {
	                    color = this.options.fills[subunitData.fillKey];
	                }
	                //if it's an object, overriding the previous data
	                if (subunitData === Object(subunitData)) {
	                    this.options.data[subunit] = defaults(subunitData, this.options.data[subunit] || {});
	                    var geo = this.svg.select('.' + subunit).attr('data-info', JSON.stringify(this.options.data[subunit]));
	                }
	                svg.selectAll('.' + subunit).transition().style('fill', color);
	            }
	        }
	    };
	
	    Datamap.prototype.updatePopup = function (element, d, options) {
	        var self = this;
	        element.on('mousemove', null);
	        element.on('mousemove', function () {
	            var position = d3.mouse(self.options.element);
	            d3.select(self.svg[0][0].parentNode).select('.datamaps-hoverover').style('top', position[1] + 30 + "px").html(function () {
	                var data = JSON.parse(element.attr('data-info'));
	                try {
	                    return options.popupTemplate(d, data);
	                } catch (e) {
	                    return "";
	                }
	            }).style('left', position[0] + "px");
	        });
	
	        d3.select(self.svg[0][0].parentNode).select('.datamaps-hoverover').style('display', 'block');
	    };
	
	    Datamap.prototype.addPlugin = function (name, pluginFn) {
	        var self = this;
	        if (typeof Datamap.prototype[name] === "undefined") {
	            Datamap.prototype[name] = function (data, options, callback, createNewLayer) {
	                var layer;
	                if (typeof createNewLayer === "undefined") {
	                    createNewLayer = false;
	                }
	
	                if (typeof options === 'function') {
	                    callback = options;
	                    options = undefined;
	                }
	
	                options = defaults(options || {}, self.options[name + 'Config']);
	
	                //add a single layer, reuse the old layer
	                if (!createNewLayer && this.options[name + 'Layer']) {
	                    layer = this.options[name + 'Layer'];
	                    options = options || this.options[name + 'Options'];
	                } else {
	                    layer = this.addLayer(name);
	                    this.options[name + 'Layer'] = layer;
	                    this.options[name + 'Options'] = options;
	                }
	                pluginFn.apply(this, [layer, data, options]);
	                if (callback) {
	                    callback(layer);
	                }
	            };
	        }
	    };
	
	    // expose library
	    if (( false ? 'undefined' : _typeof(exports)) === 'object') {
	        d3 = __webpack_require__(23);
	        topojson = __webpack_require__(47);
	        module.exports = Datamap;
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, __webpack_require__(23), __webpack_require__(47)], __WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	            d3 = __webpack_require__(23);
	            topojson = __webpack_require__(47);
	
	            return Datamap;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        window.Datamap = window.Datamaps = Datamap;
	    }
	
	    if (window.jQuery) {
	        window.jQuery.fn.datamaps = function (options, callback) {
	            options = options || {};
	            options.element = this[0];
	            var datamap = new Datamap(options);
	            if (typeof callback === "function") {
	                callback(datamap, options);
	            }
	            return this;
	        };
	    }
	})();
	;

	var _temp = function () {
	    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	        return;
	    }
	}();

	;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var countries = exports.countries = {
	  'AD': 'Andorra',
	  'AE': 'United Arab Emirates',
	  'AF': 'Afghanistan',
	  'AG': 'Antigua and Barbuda',
	  'AI': 'Anguilla',
	  'AL': 'Albania',
	  'AM': 'Armenia',
	  'AO': 'Angola',
	  'AQ': 'Antarctica',
	  'AR': 'Argentina',
	  'AS': 'American Samoa',
	  'AT': 'Austria',
	  'AU': 'Australia',
	  'AW': 'Aruba',
	  'AX': 'Åland Islands',
	  'AZ': 'Azerbaijan',
	  'BA': 'Bosnia and Herzegovina',
	  'BB': 'Barbados',
	  'BD': 'Bangladesh',
	  'BE': 'Belgium',
	  'BF': 'Burkina Faso',
	  'BG': 'Bulgaria',
	  'BH': 'Bahrain',
	  'BI': 'Burundi',
	  'BJ': 'Benin',
	  'BL': 'Saint Barthélemy',
	  'BM': 'Bermuda',
	  'BN': 'Brunei Darussalam',
	  'BO': 'Bolivia, Plurinational State of',
	  'BQ': 'Bonaire, Sint Eustatius and Saba',
	  'BR': 'Brazil',
	  'BS': 'Bahamas',
	  'BT': 'Bhutan',
	  'BV': 'Bouvet Island',
	  'BW': 'Botswana',
	  'BY': 'Belarus',
	  'BZ': 'Belize',
	  'CA': 'Canada',
	  'CC': 'Cocos (Keeling) Islands',
	  'CD': 'Congo, the Democratic Republic of the',
	  'CF': 'Central African Republic',
	  'CG': 'Congo',
	  'CH': 'Switzerland',
	  'CI': 'Côte d\'Ivoire',
	  'CK': 'Cook Islands',
	  'CL': 'Chile',
	  'CM': 'Cameroon',
	  'CN': 'China',
	  'CO': 'Colombia',
	  'CR': 'Costa Rica',
	  'CU': 'Cuba',
	  'CV': 'Cape Verde',
	  'CW': 'Curaçao',
	  'CX': 'Christmas Island',
	  'CY': 'Cyprus',
	  'CZ': 'Czech Republic',
	  'DE': 'Germany',
	  'DJ': 'Djibouti',
	  'DK': 'Denmark',
	  'DM': 'Dominica',
	  'DO': 'Dominican Republic',
	  'DZ': 'Algeria',
	  'EC': 'Ecuador',
	  'EE': 'Estonia',
	  'EG': 'Egypt',
	  'EH': 'Western Sahara',
	  'ER': 'Eritrea',
	  'ES': 'Spain',
	  'ET': 'Ethiopia',
	  'FI': 'Finland',
	  'FJ': 'Fiji',
	  'FK': 'Falkland Islands (Malvinas)',
	  'FM': 'Micronesia, Federated States of',
	  'FO': 'Faroe Islands',
	  'FR': 'France',
	  'GA': 'Gabon',
	  'GB': 'United Kingdom',
	  'GD': 'Grenada',
	  'GE': 'Georgia',
	  'GF': 'French Guiana',
	  'GG': 'Guernsey',
	  'GH': 'Ghana',
	  'GI': 'Gibraltar',
	  'GL': 'Greenland',
	  'GM': 'Gambia',
	  'GN': 'Guinea',
	  'GP': 'Guadeloupe',
	  'GQ': 'Equatorial Guinea',
	  'GR': 'Greece',
	  'GS': 'South Georgia and the South Sandwich Islands',
	  'GT': 'Guatemala',
	  'GU': 'Guam',
	  'GW': 'Guinea-Bissau',
	  'GY': 'Guyana',
	  'HK': 'Hong Kong',
	  'HM': 'Heard Island and McDonald Islands',
	  'HN': 'Honduras',
	  'HR': 'Croatia',
	  'HT': 'Haiti',
	  'HU': 'Hungary',
	  'ID': 'Indonesia',
	  'IE': 'Ireland',
	  'IL': 'Israel',
	  'IM': 'Isle of Man',
	  'IN': 'India',
	  'IO': 'British Indian Ocean Territory',
	  'IQ': 'Iraq',
	  'IR': 'Iran, Islamic Republic of',
	  'IS': 'Iceland',
	  'IT': 'Italy',
	  'JE': 'Jersey',
	  'JM': 'Jamaica',
	  'JO': 'Jordan',
	  'JP': 'Japan',
	  'KE': 'Kenya',
	  'KG': 'Kyrgyzstan',
	  'KH': 'Cambodia',
	  'KI': 'Kiribati',
	  'KM': 'Comoros',
	  'KN': 'Saint Kitts and Nevis',
	  'KP': 'Korea, Democratic People\'s Republic of',
	  'KR': 'Korea, Republic of',
	  'KW': 'Kuwait',
	  'KY': 'Cayman Islands',
	  'KZ': 'Kazakhstan',
	  'LA': 'Lao People\'s Democratic Republic',
	  'LB': 'Lebanon',
	  'LC': 'Saint Lucia',
	  'LI': 'Liechtenstein',
	  'LK': 'Sri Lanka',
	  'LR': 'Liberia',
	  'LS': 'Lesotho',
	  'LT': 'Lithuania',
	  'LU': 'Luxembourg',
	  'LV': 'Latvia',
	  'LY': 'Libya',
	  'MA': 'Morocco',
	  'MC': 'Monaco',
	  'MD': 'Moldova, Republic of',
	  'ME': 'Montenegro',
	  'MF': 'Saint Martin (French part)',
	  'MG': 'Madagascar',
	  'MH': 'Marshall Islands',
	  'MK': 'Macedonia, the former Yugoslav Republic of',
	  'ML': 'Mali',
	  'MM': 'Myanmar',
	  'MN': 'Mongolia',
	  'MO': 'Macao',
	  'MP': 'Northern Mariana Islands',
	  'MQ': 'Martinique',
	  'MR': 'Mauritania',
	  'MS': 'Montserrat',
	  'MT': 'Malta',
	  'MU': 'Mauritius',
	  'MV': 'Maldives',
	  'MW': 'Malawi',
	  'MX': 'Mexico',
	  'MY': 'Malaysia',
	  'MZ': 'Mozambique',
	  'NA': 'Namibia',
	  'NC': 'New Caledonia',
	  'NE': 'Niger',
	  'NF': 'Norfolk Island',
	  'NG': 'Nigeria',
	  'NI': 'Nicaragua',
	  'NL': 'Netherlands',
	  'NO': 'Norway',
	  'NP': 'Nepal',
	  'NR': 'Nauru',
	  'NU': 'Niue',
	  'NZ': 'New Zealand',
	  'OM': 'Oman',
	  'PA': 'Panama',
	  'PE': 'Peru',
	  'PF': 'French Polynesia',
	  'PG': 'Papua New Guinea',
	  'PH': 'Philippines',
	  'PK': 'Pakistan',
	  'PL': 'Poland',
	  'PM': 'Saint Pierre and Miquelon',
	  'PN': 'Pitcairn',
	  'PR': 'Puerto Rico',
	  'PS': 'Palestinian Territory, Occupied',
	  'PT': 'Portugal',
	  'PW': 'Palau',
	  'PY': 'Paraguay',
	  'QA': 'Qatar',
	  'RE': 'Réunion',
	  'RO': 'Romania',
	  'RS': 'Serbia',
	  'RU': 'Russian Federation',
	  'RW': 'Rwanda',
	  'SA': 'Saudi Arabia',
	  'SB': 'Solomon Islands',
	  'SC': 'Seychelles',
	  'SD': 'Sudan',
	  'SE': 'Sweden',
	  'SG': 'Singapore',
	  'SH': 'Saint Helena, Ascension and Tristan da Cunha',
	  'SI': 'Slovenia',
	  'SJ': 'Svalbard and Jan Mayen',
	  'SK': 'Slovakia',
	  'SL': 'Sierra Leone',
	  'SM': 'San Marino',
	  'SN': 'Senegal',
	  'SO': 'Somalia',
	  'SR': 'Suriname',
	  'SS': 'South Sudan',
	  'ST': 'Sao Tome and Principe',
	  'SV': 'El Salvador',
	  'SX': 'Sint Maarten (Dutch part)',
	  'SY': 'Syrian Arab Republic',
	  'SZ': 'Swaziland',
	  'TC': 'Turks and Caicos Islands',
	  'TD': 'Chad',
	  'TF': 'French Southern Territories',
	  'TG': 'Togo',
	  'TH': 'Thailand',
	  'TJ': 'Tajikistan',
	  'TK': 'Tokelau',
	  'TL': 'Timor-Leste',
	  'TM': 'Turkmenistan',
	  'TN': 'Tunisia',
	  'TO': 'Tonga',
	  'TR': 'Turkey',
	  'TT': 'Trinidad and Tobago',
	  'TV': 'Tuvalu',
	  'TW': 'Taiwan, Province of China',
	  'TZ': 'Tanzania, United Republic of',
	  'UA': 'Ukraine',
	  'UG': 'Uganda',
	  'UM': 'United States Minor Outlying Islands',
	  'US': 'United States',
	  'UY': 'Uruguay',
	  'UZ': 'Uzbekistan',
	  'VA': 'Holy See (Vatican City State)',
	  'VC': 'Saint Vincent and the Grenadines',
	  'VE': 'Venezuela, Bolivarian Republic of',
	  'VG': 'Virgin Islands, British',
	  'VI': 'Virgin Islands, U.S.',
	  'VN': 'Viet Nam',
	  'VU': 'Vanuatu',
	  'WF': 'Wallis and Futuna',
	  'WS': 'Samoa',
	  'YE': 'Yemen',
	  'YT': 'Mayotte',
	  'ZA': 'South Africa',
	  'ZM': 'Zambia',
	  'ZW': 'Zimbabwe'
	};
	
	var countryCodes = exports.countryCodes = {
	  'AFG': 'AF',
	  'ALA': 'AX',
	  'ALB': 'AL',
	  'DZA': 'DZ',
	  'ASM': 'AS',
	  'AGO': 'AO',
	  'AIA': 'AI',
	  'ATA': 'AQ',
	  'ATG': 'AG',
	  'ARG': 'AR',
	  'ARM': 'AM',
	  'ABW': 'AW',
	  'AUS': 'AU',
	  'AUT': 'AT',
	  'AZE': 'AZ',
	  'BHS': 'BS',
	  'BHR': 'BH',
	  'BGD': 'BD',
	  'BRB': 'BB',
	  'BLR': 'BY',
	  'BEL': 'BE',
	  'BLZ': 'BZ',
	  'BEN': 'BJ',
	  'BMU': 'BM',
	  'BTN': 'BT',
	  'BOL': 'BO',
	  'BES': 'BQ',
	  'BIH': 'BA',
	  'BWA': 'BW',
	  'BVT': 'BV',
	  'BRA': 'BR',
	  'IOT': 'IO',
	  'BRN': 'BN',
	  'BGR': 'BG',
	  'BFA': 'BF',
	  'BDI': 'BI',
	  'KHM': 'KH',
	  'CMR': 'CM',
	  'CAN': 'CA',
	  'CPV': 'CV',
	  'CYM': 'KY',
	  'CAF': 'CF',
	  'TCD': 'TD',
	  'CHL': 'CL',
	  'CHN': 'CN',
	  'CXR': 'CX',
	  'CCK': 'CC',
	  'COL': 'CO',
	  'COM': 'KM',
	  'COG': 'CG',
	  'COD': 'CD',
	  'COK': 'CK',
	  'CRI': 'CR',
	  'CIV': 'CI',
	  'HRV': 'HR',
	  'CUB': 'CU',
	  'CUW': 'CW',
	  'CYP': 'CY',
	  'CZE': 'CZ',
	  'DNK': 'DK',
	  'DJI': 'DJ',
	  'DMA': 'DM',
	  'DOM': 'DO',
	  'ECU': 'EC',
	  'EGY': 'EG',
	  'SLV': 'SV',
	  'GNQ': 'GQ',
	  'ERI': 'ER',
	  'EST': 'EE',
	  'ETH': 'ET',
	  'FLK': 'FK',
	  'FRO': 'FO',
	  'FJI': 'FJ',
	  'FIN': 'FI',
	  'FRA': 'FR',
	  'GUF': 'GF',
	  'PYF': 'PF',
	  'ATF': 'TF',
	  'GAB': 'GA',
	  'GMB': 'GM',
	  'GEO': 'GE',
	  'DEU': 'DE',
	  'GHA': 'GH',
	  'GIB': 'GI',
	  'GRC': 'GR',
	  'GRL': 'GL',
	  'GRD': 'GD',
	  'GLP': 'GP',
	  'GUM': 'GU',
	  'GTM': 'GT',
	  'GGY': 'GG',
	  'GIN': 'GN',
	  'GNB': 'GW',
	  'GUY': 'GY',
	  'HTI': 'HT',
	  'HMD': 'HM',
	  'VAT': 'VA',
	  'HND': 'HN',
	  'HKG': 'HK',
	  'HUN': 'HU',
	  'ISL': 'IS',
	  'IND': 'IN',
	  'IDN': 'ID',
	  'IRN': 'IR',
	  'IRQ': 'IQ',
	  'IRL': 'IE',
	  'IMN': 'IM',
	  'ISR': 'IL',
	  'ITA': 'IT',
	  'JAM': 'JM',
	  'JPN': 'JP',
	  'JEY': 'JE',
	  'JOR': 'JO',
	  'KAZ': 'KZ',
	  'KEN': 'KE',
	  'KIR': 'KI',
	  'PRK': 'KP',
	  'KOR': 'KR',
	  'KWT': 'KW',
	  'KGZ': 'KG',
	  'LAO': 'LA',
	  'LVA': 'LV',
	  'LBN': 'LB',
	  'LSO': 'LS',
	  'LBR': 'LR',
	  'LBY': 'LY',
	  'LIE': 'LI',
	  'LTU': 'LT',
	  'LUX': 'LU',
	  'MAC': 'MO',
	  'MKD': 'MK',
	  'MDG': 'MG',
	  'MWI': 'MW',
	  'MYS': 'MY',
	  'MDV': 'MV',
	  'MLI': 'ML',
	  'MLT': 'MT',
	  'MHL': 'MH',
	  'MTQ': 'MQ',
	  'MRT': 'MR',
	  'MUS': 'MU',
	  'MYT': 'YT',
	  'MEX': 'MX',
	  'FSM': 'FM',
	  'MDA': 'MD',
	  'MCO': 'MC',
	  'MNG': 'MN',
	  'MNE': 'ME',
	  'MSR': 'MS',
	  'MAR': 'MA',
	  'MOZ': 'MZ',
	  'MMR': 'MM',
	  'NAM': 'NA',
	  'NRU': 'NR',
	  'NPL': 'NP',
	  'NLD': 'NL',
	  'NCL': 'NC',
	  'NZL': 'NZ',
	  'NIC': 'NI',
	  'NER': 'NE',
	  'NGA': 'NG',
	  'NIU': 'NU',
	  'NFK': 'NF',
	  'MNP': 'MP',
	  'NOR': 'NO',
	  'OMN': 'OM',
	  'PAK': 'PK',
	  'PLW': 'PW',
	  'PSE': 'PS',
	  'PAN': 'PA',
	  'PNG': 'PG',
	  'PRY': 'PY',
	  'PER': 'PE',
	  'PHL': 'PH',
	  'PCN': 'PN',
	  'POL': 'PL',
	  'PRT': 'PT',
	  'PRI': 'PR',
	  'QAT': 'QA',
	  'REU': 'RE',
	  'ROU': 'RO',
	  'RUS': 'RU',
	  'RWA': 'RW',
	  'BLM': 'BL',
	  'SHN': 'SH',
	  'KNA': 'KN',
	  'LCA': 'LC',
	  'MAF': 'MF',
	  'SPM': 'PM',
	  'VCT': 'VC',
	  'WSM': 'WS',
	  'SMR': 'SM',
	  'STP': 'ST',
	  'SAU': 'SA',
	  'SEN': 'SN',
	  'SRB': 'RS',
	  'SYC': 'SC',
	  'SLE': 'SL',
	  'SGP': 'SG',
	  'SXM': 'SX',
	  'SVK': 'SK',
	  'SVN': 'SI',
	  'SLB': 'SB',
	  'SOM': 'SO',
	  'ZAF': 'ZA',
	  'SGS': 'GS',
	  'SSD': 'SS',
	  'ESP': 'ES',
	  'LKA': 'LK',
	  'SDN': 'SD',
	  'SUR': 'SR',
	  'SJM': 'SJ',
	  'SWZ': 'SZ',
	  'SWE': 'SE',
	  'CHE': 'CH',
	  'SYR': 'SY',
	  'TWN': 'TW',
	  'TJK': 'TJ',
	  'TZA': 'TZ',
	  'THA': 'TH',
	  'TLS': 'TL',
	  'TGO': 'TG',
	  'TKL': 'TK',
	  'TON': 'TO',
	  'TTO': 'TT',
	  'TUN': 'TN',
	  'TUR': 'TR',
	  'TKM': 'TM',
	  'TCA': 'TC',
	  'TUV': 'TV',
	  'UGA': 'UG',
	  'UKR': 'UA',
	  'ARE': 'AE',
	  'GBR': 'GB',
	  'USA': 'US',
	  'UMI': 'UM',
	  'URY': 'UY',
	  'UZB': 'UZ',
	  'VUT': 'VU',
	  'VEN': 'VE',
	  'VNM': 'VN',
	  'VGB': 'VG',
	  'VIR': 'VI',
	  'WLF': 'WF',
	  'ESH': 'EH',
	  'YEM': 'YE',
	  'ZMB': 'ZM',
	  'ZWE': 'ZW'
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(countries, 'countries', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/countryMapCodes.js');
	
	  __REACT_HOT_LOADER__.register(countryCodes, 'countryCodes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/countryMapCodes.js');
	}();

	;

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var legendOptions = exports.legendOptions = {
	  width: 758,
	  height: 30, // Default height of without multiple distributions
	  margin: {
	    bottom: 20,
	    top: 5,
	    right: 0,
	    left: 0
	  },
	  wrapper: 'svg',
	  top: 0,
	  left: 0,
	  isMap: false,
	  maxSplit: 4,
	  distributions: 1,
	  textPadding: {
	    top: 15,
	    left: 30
	  },
	  rowSpacing: 10,
	  font: {
	    'font-size': '12px',
	    'font-weight': 'bold',
	    'font-family': 'Arial, Helvetica, sans-serif'
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(legendOptions, 'legendOptions', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/config/legend.js');
	}();

	;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var LOADING_DATA = exports.LOADING_DATA = 'LOADING_DATA';
	var BUILD_DATA = exports.BUILD_DATA = 'BUILD_DATA';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(LOADING_DATA, 'LOADING_DATA', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/constants/index.js');
	
	  __REACT_HOT_LOADER__.register(BUILD_DATA, 'BUILD_DATA', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/constants/index.js');
	}();

	;

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = markdown;
	/**
	 * Cribbed from datacenter.js. Parses simple markdown.
	 * @param {string} txt - Directly from the google sheet cell
	 * @return {string} - markdown->html string
	 */
	function markdown() {
	  return function (txt) {
	    if (txt === null) {
	      return txt;
	    }
	
	    var _txt = txt;
	    // parse the string otherwise do it recursively
	    if (typeof _txt !== 'string') {
	      Object.keys(_txt).forEach(function (i) {
	        _txt[i] = markdown()(_txt[i]);
	      });
	      return _txt;
	    }
	    _txt = _txt.replace(/(^|\W)\*(.*?)\*($|\W)/mg, '$1<strong>$2</strong>$3').replace(/(^|\W)_(.*?)_($|\W)/mg, '$1<em>$2</em>$3').replace(/\[(.*?)\]\((.*?)\)/mg, '<a href="$2" target="_self">$1</a>').replace(/\n\s*\n\s*/mg, '</p><p>');
	    return '<p>' + _txt + '</p>';
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(markdown, 'markdown', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/filters/markdownFilter.js');
	}();

	;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _distributionFilters = __webpack_require__(140);
	
	var _distributionFilters2 = _interopRequireDefault(_distributionFilters);
	
	var _config = __webpack_require__(11);
	
	var _util = __webpack_require__(15);
	
	var _slugify = __webpack_require__(73);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = function _default(data) {
	  // @TODO make county data processor
	  // the easiest way is probably to do some conditional processing of these
	  // medicare json files in place of the other function assignments in
	  // buildSpreadsheetData. The json is ~close to what you need, but will
	  // require some massaging.
	
	  /**
	   * Lets format sheetData into a wonderful style of:
	   * mori.vector(
	   *   mori.hashMap(
	   *     'year', 0000,
	   *     'location', XXXX
	   *     'value', 000000000
	   *   )
	   * )
	   */
	  var timeframes = _mori2.default.toClj(data.data.timeframes);
	
	  var immutableHeaders = getHeaders(_mori2.default.first(timeframes));
	  var immutableDistributions = (0, _distributionFilters2.default)(immutableHeaders);
	  var sheetData = _mori2.default.flatten(_mori2.default.map(function (parent) {
	    return _mori2.default.map(function (row) {
	      return _mori2.default.hashMap('year', _mori2.default.get(parent, 'timeframe_title'), 'label', _mori2.default.first(row).toString() === 'Dist. of Columbia' ? 'District of Columbia' : _mori2.default.first(row).toString(), 'values', _mori2.default.zipmap(_mori2.default.map(function (item) {
	        return _mori2.default.set([_mori2.default.get(item, 'characteristic'), _mori2.default.get(item, 'type')]);
	      }, _mori2.default.sort(function (a, b) {
	        return _mori2.default.get(a, 'idx') - _mori2.default.get(b, 'idx');
	      }, _mori2.default.rest(immutableHeaders))), _mori2.default.map(function (item) {
	        return (0, _util.kffIsNumber)(item) ? (0, _util.kffNumericValue)(item) : item;
	      }, _mori2.default.rest(row))));
	    }, _mori2.default.drop(2, _mori2.default.get(parent, 'grid')));
	  }, timeframes));
	
	  /**
	   * Flatten out the sheet definitions so we can pluck them later...
	   */
	  var definitions = buildGeoDefinitions(sheetData, _mori2.default.toClj(data.geoDefinitions));
	
	  var flatData = _mori2.default.groupBy(function (item) {
	    return _mori2.default.get(item, 'year');
	  }, _mori2.default.filter(
	  // need to check to remove any data sets without definitions
	  function (item) {
	    return !(!_mori2.default.hasKey(item, 'header') && /\d/.test(_mori2.default.get(item, 'label')));
	  }, _mori2.default.map(function (item) {
	    return _mori2.default.merge(item, _mori2.default.get(definitions, _mori2.default.get(item, 'label')));
	  }, sheetData)));
	
	  var immutableData = buildData(flatData);
	  var columns = buildColumnData(flatData);
	  var config = _mori2.default.hashMap('notesSources', _mori2.default.hashMap('Notes', _mori2.default.set([_mori2.default.hashMap('Data Format', null, 'Distribution', null, 'Geography', null, 'Note', data.data.notes, 'Timeframe', 'any', 'Type', 'Notes')]), 'Sources', _mori2.default.set([_mori2.default.hashMap('Data Format', null, 'Distribution', null, 'Geography', null, 'Note', data.data.source, 'Timeframe', 'any', 'Type', 'Sources')]), 'Definitions', _mori2.default.set([_mori2.default.hashMap('Data Format', null, 'Distribution', null, 'Geography', null, 'Note', data.data.definitions, 'Timeframe', 'any', 'Type', 'Definitions')])), 'globalRules', _mori2.default.hashMap('medicare', true, 'Locked', false, 'Graph', false, 'Map', true), 'settings', _mori2.default.hashMap('globalSettings', _mori2.default.hashMap('Precision', '1', 'hasDataviews', false)));
	
	  return {
	    config: config,
	    immutableHeaders: immutableHeaders,
	    immutableData: immutableData,
	    immutableDataviews: [{
	      'label': 'default',
	      'type': 'default'
	    }],
	    immutableDistributions: immutableDistributions,
	    columns: columns,
	    timeframes: _mori2.default.intoArray(_mori2.default.map(function (item) {
	      return _mori2.default.get(item, 'timeframe_title').toString();
	    }, timeframes)),
	    globalRules: _mori2.default.toJs(_mori2.default.get(config, 'globalRules')),
	    globalSettings: _mori2.default.toJs(_mori2.default.getIn(config, ['settings', 'globalSettings'])),
	    distributionCount: _mori2.default.count(immutableDistributions)
	  };
	  // return data;
	};
	
	exports.default = _default;
	
	/**
	 * Build the list of geodefinitions to use
	 * @param  {mori func} sheetData      sheet data (parse labels out of it)
	 * @param  {mori func} geoDefinitions geo definition hashmap
	 * @return {mori func}                map of geo definitions which are valid
	 */
	
	function buildGeoDefinitions(sheetData, geoDefinitions) {
	  return _mori2.default.reduce(function (acc, row) {
	    return _mori2.default.conj(acc, reduceDefinitions(row, _mori2.default.map(function (next) {
	      return _mori2.default.get(next, 'label');
	    }, sheetData)));
	  }, _mori2.default.hashMap(), geoDefinitions);
	}
	
	/**
	 * Build the column data
	 * @param  {mori func} flatData     datasheet
	 * @return { nested, wrapups}       nested and wrapups
	 */
	function buildColumnData(flatData) {
	  var nested = _mori2.default.toJs(_mori2.default.reduce(function (acc, item) {
	    return _mori2.default.conj(acc, ['Counties', 'MSAs'].indexOf(_mori2.default.first(item)) < 0 ? _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(item)), _mori2.default.hashMap('label', _mori2.default.first(item), 'children', _mori2.default.reduce(function (acc1, next) {
	      return _mori2.default.conj(acc1, _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.get(next, 'label')), _mori2.default.hashMap('label', _mori2.default.get(next, 'label'))));
	    }, _mori2.default.hashMap(), _mori2.default.last(item)))) : _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(item)), _mori2.default.hashMap('label', _mori2.default.first(item), 'children', _mori2.default.reduce(function (acc1, next) {
	      return _mori2.default.conj(acc1, _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(next)), _mori2.default.hashMap('label', _mori2.default.first(next), 'children', _mori2.default.reduce(function (acc2, next1) {
	        return _mori2.default.conj(acc2, _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.get(next1, 'label')), _mori2.default.hashMap('colLabel', _mori2.default.get(next1, 'label'), 'label', _mori2.default.first(item) !== 'Counties' ? _mori2.default.get(next1, 'label') : _mori2.default.first(next) + ', ' + _mori2.default.get(next1, 'label'))));
	      }, _mori2.default.hashMap(), _mori2.default.last(next)))));
	    }, _mori2.default.hashMap(), _mori2.default.groupBy(function (nest) {
	      return _mori2.default.get(nest, 'state');
	    },
	    // Map data items to get list of all states in which each item exists
	    _mori2.default.flatten(_mori2.default.map(function (item1) {
	      return _mori2.default.map(function (state) {
	        return _mori2.default.into(item1, _mori2.default.hashMap('state', state));
	      }, _mori2.default.get(item1, 'states'));
	    },
	    // All data associated with each column section: MSA,, Counties, PDPs, etc
	    _mori2.default.last(item))))))));
	  }, _mori2.default.hashMap(), _mori2.default.groupBy(function (item) {
	    return _mori2.default.get(item, 'header') || 'States';
	  }, _mori2.default.filter(function (item) {
	    return _config.appDefault.specialWrapups.indexOf(_mori2.default.get(item, 'label')) === -1;
	  }, _mori2.default.first(_mori2.default.rest(_mori2.default.first(flatData)))))));
	
	  var wrapups = _mori2.default.toJs(_mori2.default.reduce(function (acc, next) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.get(next, 'label')), _mori2.default.hashMap('label', _mori2.default.get(next, 'label'))));
	  }, _mori2.default.hashMap(), _mori2.default.filter(function (item) {
	    return _config.appDefault.specialWrapups.indexOf(_mori2.default.get(item, 'label')) > -1;
	  }, _mori2.default.first(_mori2.default.rest(_mori2.default.first(flatData))))));
	
	  return { nested: nested, wrapups: wrapups };
	}
	
	/**
	 * Assemble the data in a way which DC expects it
	 * @param  {mori obj} data    flat data sheet
	 * @return {mori obj}         immutable data setup
	 */
	function buildData(data) {
	  return _mori2.default.reduce(function (acc, item1) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(item1).toString(), _mori2.default.flatten(_mori2.default.map(function (item2) {
	      return _mori2.default.map(function (item3) {
	        return _mori2.default.into(_mori2.default.hasKey(item3, 'states') && _mori2.default.get(item3, 'header') === 'Counties' ? _mori2.default.hashMap(_mori2.default.set(['Location', 'Geography']), _mori2.default.first(_mori2.default.get(item3, 'states')) + ', ' + _mori2.default.get(item3, 'label')) : _mori2.default.hashMap(_mori2.default.set(['Location', 'Geography']), _mori2.default.get(item3, 'label')), _mori2.default.get(item3, 'values'));
	      }, item2);
	    }, _mori2.default.rest(item1)))));
	  }, _mori2.default.hashMap(), data);
	}
	
	/**
	 * Get the headers, using only the first sheet
	 * @param  {mori func} timeframe    single timeframe/datasheet
	 * @return {mori func}              immutable headers map
	 */
	function getHeaders(timeframe) {
	  return _mori2.default.reduce(function (acc, next) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap('type', _mori2.default.count(acc) === 0 ? 'geography' : _mori2.default.get(_mori2.default.nth(_mori2.default.get(timeframe, 'grid'), 1), _mori2.default.count(acc)).toLowerCase(), 'label', _mori2.default.count(acc) === 0 ? 'Geography' : _mori2.default.get(_mori2.default.nth(_mori2.default.get(timeframe, 'grid'), 1), _mori2.default.count(acc)).toLowerCase(), 'characteristic', next === '' ? 'Location' : next, 'Precision', '1', 'idx', _mori2.default.count(acc)));
	  }, _mori2.default.vector(), _mori2.default.first(_mori2.default.get(timeframe, 'grid')));
	}
	
	/**
	 * Take in a definition row, and return it mapped to data
	 * @param  {mori object} row              Geo Definition row
	 * @param  {mori function} existingIds    IDs which exist in the dataset
	 * @return {mori function}                Mapped IDs w/ Props
	 */
	function reduceDefinitions(row, existingIds) {
	  // Check if nested
	  if (_mori2.default.isMap(_mori2.default.first(_mori2.default.rest(_mori2.default.first(_mori2.default.first(_mori2.default.rest(row))))))) {
	    return _mori2.default.reduce(function (acc, row1) {
	      return _mori2.default.conj(acc, _mori2.default.reduce(function (acc1, item) {
	        return _mori2.default.some(function (id) {
	          return id === _mori2.default.first(item);
	        }, existingIds) ? _mori2.default.conj(acc1, _mori2.default.hashMap(_mori2.default.first(item), _mori2.default.hashMap('label', _mori2.default.last(item), 'states', _mori2.default.into(_mori2.default.get(_mori2.default.get(acc, _mori2.default.first(item)), 'states', _mori2.default.list()), _mori2.default.list(_mori2.default.first(row1))), 'header', _mori2.default.first(row)))) : acc1;
	      }, _mori2.default.hashMap(), _mori2.default.last(row1)));
	    }, _mori2.default.hashMap(), _mori2.default.last(row));
	  }
	
	  // Else do this simple remap
	  return _mori2.default.reduce(function (acc, item) {
	    return _mori2.default.some(function (id) {
	      return id === _mori2.default.first(item);
	    }, existingIds) ? _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(item), _mori2.default.hashMap('label', _mori2.default.last(item), 'header', _mori2.default.first(row)))) : acc;
	  }, _mori2.default.hashMap(), _mori2.default.first(_mori2.default.rest(row)));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(buildGeoDefinitions, 'buildGeoDefinitions', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/countyReducer.js');
	
	  __REACT_HOT_LOADER__.register(buildColumnData, 'buildColumnData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/countyReducer.js');
	
	  __REACT_HOT_LOADER__.register(buildData, 'buildData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/countyReducer.js');
	
	  __REACT_HOT_LOADER__.register(getHeaders, 'getHeaders', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/countyReducer.js');
	
	  __REACT_HOT_LOADER__.register(reduceDefinitions, 'reduceDefinitions', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/countyReducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/countyReducer.js');
	}();

	;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _transducers = __webpack_require__(153);
	
	var _config = __webpack_require__(11);
	
	var _slugify = __webpack_require__(73);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a map for nested columns
	 *
	 * @param {array} sheet - The flattened google document
	 * @param {hashMap} config - Global config options parsed from the google document
	 * @param {object} options - The current state ie router.currentParams
	 *
	 * @return {object} A nested map of parent column objects
	 */
	var _default = function _default(sheet, config, options) {
	  var context = _mori2.default.getIn(config, ['globalRules', 'Context'], false);
	  var label = context ? context[1] : 'States';
	
	  return _mori2.default.toJs(_mori2.default.into(_mori2.default.hashMap(), _mori2.default.map(function (group) {
	    return _mori2.default.hashMap(_mori2.default.first(group), _mori2.default.first(group) === 'nested' ? _mori2.default.hashMap((0, _slugify2.default)(label), _mori2.default.hashMap('children', buildBaseColumns(_mori2.default.first(_mori2.default.rest(group)), options, config), 'label', label)) : buildBaseColumns(_mori2.default.first(_mori2.default.rest(group)), options, config)
	    // create the base column selector for each row
	    );
	  },
	  // nested vs wrapups
	  _mori2.default.groupBy(function (row) {
	    return isWrapup(row);
	  }, _mori2.default.dropWhile(function (x) {
	    return !x[0];
	  }, (0, _transducers.getOneSheet)(sheet))))));
	};
	
	exports.default = _default;
	
	/**
	 * Create base column selectors for each row. These looks a little different
	 * depending on the nesting level of the indicator sheet.
	 *
	 * @example single-level-geographical data
	 * { nested: { Alabama: { selected: bool } } }
	 *
	 * @example n-plus-level-geographical data
	 * { nested: { Alabama: { children: { [Child]: { selected: bool } } } } }
	 *
	 * @example summary rows
	 * { nested: { Alabama: { selected: bool, summary: { Alabama (All): {} } } } }
	 */
	
	function buildBaseColumns(items, options, config) {
	  var isGeomulti = _mori2.default.getIn(config, ['globalRules', 'Geomulti'], false);
	
	  // group by base column, normalizing summary rows
	  var byState = _mori2.default.groupBy(function (row) {
	    return summaryItem(row, isGeomulti) ? _mori2.default.first(row).replace(_config.appDefault.isSummaryRow, '') : _mori2.default.first(row);
	  }, items);
	  return _mori2.default.into(_mori2.default.hashMap(), _mori2.default.map(function (row) {
	    if (!isGeomulti) {
	      return _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(row)), _mori2.default.hashMap('label', _mori2.default.first(row)));
	    }
	    return _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(row)), _mori2.default.into(_mori2.default.hashMap('label', _mori2.default.first(row)), _mori2.default.map(function (item) {
	      return buildNested(item);
	    }, _mori2.default.groupBy(function (item) {
	      return summaryItem(item, isGeomulti) ? 'summary' : 'children';
	    }, _mori2.default.last(row)))));
	  }, byState));
	}
	
	/**
	 * Builds the tree of subitems in the column selector tree
	 *
	 * @param {vector} item The subgroup of rows for summary or children
	 *
	 * @return {hashMap} Node with summary and children collections
	 */
	function buildNested(item) {
	  if (_mori2.default.first(item) === 'summary') {
	    return _mori2.default.hashMap('summary', _mori2.default.hashMap('label', 'Summary'));
	  }
	  return _mori2.default.hashMap('children', _mori2.default.into(_mori2.default.hashMap(), _mori2.default.map(function (child) {
	    return _mori2.default.hashMap((0, _slugify2.default)(_mori2.default.first(_mori2.default.rest(child))), _mori2.default.hashMap('label', _mori2.default.first(_mori2.default.rest(child))));
	  }, _mori2.default.last(item))));
	}
	
	/**
	 * Test whether a row is a wrapup row
	 *
	 * @param {vector|array} x The current row
	 *
	 * @return {bool} isWrapup?
	 */
	function isWrapup(x) {
	  return _config.appDefault.specialWrapups.indexOf(_mori2.default.first(x)) > -1 ? 'wrapups' : 'nested';
	}
	
	/**
	 * Test whether a row is a summary row
	 *
	 * @param {vector|array} x The current row
	 * @param {bool} isGeomulti If we're in a geomulti indicator
	 *
	 * @return {bool} isSummaryItem?
	 */
	function summaryItem(x, isGeomulti) {
	  return isGeomulti && _config.appDefault.isSummaryRow.test(_mori2.default.first(x));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(buildBaseColumns, 'buildBaseColumns', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/columnFilters.js');
	
	  __REACT_HOT_LOADER__.register(buildNested, 'buildNested', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/columnFilters.js');
	
	  __REACT_HOT_LOADER__.register(isWrapup, 'isWrapup', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/columnFilters.js');
	
	  __REACT_HOT_LOADER__.register(summaryItem, 'summaryItem', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/columnFilters.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/columnFilters.js');
	}();

	;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A transducer that creates the dataview list
	 *
	 * @param {array} sheets - The headers array
	 * @return {array} A list of available dataviews
	 */
	var _default = function _default(headers, config) {
	  // parse the display order
	  var displayOrder = _mori2.default.getIn(config, ['settings', 'globalSettings', 'Display Order'], '').split(',').map(function (dataview) {
	    return dataview.trim();
	  });
	
	  // pluck dataviews from headers where applicable
	  var foundDataviews = _mori2.default.toJs(_mori2.default.distinct(_mori2.default.map(function (header) {
	    return _mori2.default.hashMap('label', _mori2.default.get(header, 'label'), 'type', _mori2.default.get(header, 'type'));
	  }, _mori2.default.rest(headers))));
	
	  // sort the views that are listed in the display order
	  var sorted = foundDataviews.filter(function (dataview) {
	    return displayOrder.indexOf(dataview.label) > -1;
	  }).sort(function (a, b) {
	    return displayOrder.indexOf(a.label) - displayOrder.indexOf(b.label);
	  });
	
	  // add any more views that don't have a specified display order
	  return sorted.concat(foundDataviews.filter(function (dataview) {
	    return displayOrder.indexOf(dataview.label) === -1;
	  }));
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/dataviewFilters.js');
	}();

	;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _dataFilters = __webpack_require__(154);
	
	var _getSelectedDistributions = __webpack_require__(58);
	
	var _getSelectedDistributions2 = _interopRequireDefault(_getSelectedDistributions);
	
	var _getSelectedColumns = __webpack_require__(150);
	
	var _getSelectedColumns2 = _interopRequireDefault(_getSelectedColumns);
	
	var _getColumnKeys = __webpack_require__(141);
	
	var _getColumnKeys2 = _interopRequireDefault(_getColumnKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Generates selection keys and filters which are used by rendering functions
	 *
	 * @param {object} data The data store
	 * @param {object} options Options from the url
	 *
	 * @return {array}
	 */
	var _default = function _default(data, options) {
	  var isLocked = _mori2.default.getIn(data.config, ['globalRules', 'Locked'], false);
	
	  var shouldGetDistributions = options.selectedDistributions && (!isLocked || options.activeTab);
	
	  // Get the current data view object by index
	  var dataviewType = (data.globalSettings || {}).hasDataviews && !isLocked ? _mori2.default.nth(data.immutableDataviews, +(options.dataView || 0)) : false;
	
	  // Get currently selected distributions, or all
	  var distributions = shouldGetDistributions ? (0, _dataFilters.getCurrentDistributions)(data.immutableDistributions, options) : data.immutableDistributions;
	
	  // Create sets as keys for data
	  var selected = (0, _getSelectedDistributions2.default)(data, distributions, dataviewType);
	
	  var columnKeys = (0, _getColumnKeys2.default)(data);
	
	  // Join the base column and the selected sets
	  var selectedSetKeys = _mori2.default.concat(_mori2.default.vector(columnKeys[0]), selected);
	
	  // due to nesting we need to fix select all boxes...
	  if (options.selectedRows) {
	    options.selectedRows = assembleAllRows(data.columns, options.selectedRows);
	  }
	  // Return an array of arguments so we can apply it to other rendering
	  // functions by using ...spread
	  return [_getSelectedColumns2.default.apply(undefined, [data, options].concat(_toConsumableArray(columnKeys))), selectedSetKeys, distributions, dataviewType, columnKeys];
	};
	
	exports.default = _default;
	
	// this rewrites nested select alls
	
	function assembleAllRows(columns, rows) {
	  var newTree = {};
	  Object.keys(rows).forEach(function (curr) {
	    if (rows[curr].hasOwnProperty('all')) {
	      var children = columns.nested && curr !== 'nested' ? columns.nested[curr].children : columns[curr].children;
	      if (typeof children === 'undefined' || !children[Object.keys(children)[0]].hasOwnProperty('children')) {
	        newTree[curr] = rows[curr];
	      } else {
	        newTree[curr] = Object.keys(children).reduce(function (acc, item) {
	          acc[item] = { all: {} };
	          return acc;
	        }, {});
	      }
	    } else {
	      newTree[curr] = rows[curr];
	    }
	  });
	  return newTree;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(assembleAllRows, 'assembleAllRows', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getCombinedFilters.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getCombinedFilters.js');
	}();

	;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = footnoteCallback;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Filter footnotes per cell and flatten them
	 * @param  {Array} key                [key array for footnotes]
	 * @param  {mori.hashMap} footnotes   [footnotes]
	 * @return {Array}                    [footnotes for key]
	 */
	function footnoteCallback(key, footnotes) {
	  var isTrend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!isLocationInFootnotes(key, footnotes)) {
	    // Location isn't in footnotes
	    return [];
	  }
	
	  return _mori2.default.toJs(_mori2.default.distinct(_mori2.default.flatten(_mori2.default.map(function (row) {
	    return _mori2.default.flatten(_mori2.default.rest(row));
	  }, _mori2.default.filter(
	  // We need to open this up to multiple if there is a parent
	  function (note) {
	    return !Array.isArray(key[1]) ? _mori2.default.isSubset(_mori2.default.set(key), _mori2.default.first(note)) :
	    // We need to include only headerGroup, only columnTile, and combined
	    _mori2.default.isSubset(_mori2.default.set([key[0], _mori2.default.hashMap(key[1][0], key[1][1])]), _mori2.default.first(note)) || _mori2.default.isSubset(_mori2.default.set([key[0], key[1][0]]), !isTrend ? _mori2.default.first(note) : _mori2.default.rest(_mori2.default.first(note))) || _mori2.default.isSubset(_mori2.default.set([key[0], key[1][1]]), !isTrend ? _mori2.default.first(note) : _mori2.default.rest(_mori2.default.first(note))) || _mori2.default.first(_mori2.default.first(_mori2.default.last(_mori2.default.first(note)))) === 'any' && _mori2.default.equals(_mori2.default.set([key[0], key[1][1]]), _mori2.default.set([_mori2.default.first(_mori2.default.rest(_mori2.default.first(note))), _mori2.default.last(_mori2.default.last(_mori2.default.last(_mori2.default.first(note))))]) // set
	    ) // equals
	    // !Array.isArray
	    ;
	  }, footnotes)))));
	}
	
	/**
	 * Check if location is in footnotes
	 * @param  {Array} key                [key array for footnotes]
	 * @param  {mori.hashMap} footnotes   [footnotes]
	 * @return {Boolean}                  [if location is in footnotes]
	 */
	function isLocationInFootnotes(key, footnotes) {
	  return _mori2.default.count(_mori2.default.filter(function (item) {
	    return item === key[0];
	  }, _mori2.default.distinct(_mori2.default.reduceKV(
	  // accumulator, key, value (value isn't needed here)
	  function (acc, rKey) {
	    return _mori2.default.conj(acc, _mori2.default.first(_mori2.default.rest(rKey)));
	  }, _mori2.default.vector(), footnotes)))) > 0;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(footnoteCallback, 'footnoteCallback', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/footnoteCallback.js');
	
	  __REACT_HOT_LOADER__.register(isLocationInFootnotes, 'isLocationInFootnotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/footnoteCallback.js');
	}();

	;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFootnotes;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _composeFootnotes = __webpack_require__(142);
	
	var _composeFootnotes2 = _interopRequireDefault(_composeFootnotes);
	
	var _getActiveFootnotes = __webpack_require__(143);
	
	var _getActiveFootnotes2 = _interopRequireDefault(_getActiveFootnotes);
	
	var _getDistributions = __webpack_require__(144);
	
	var _getDistributions2 = _interopRequireDefault(_getDistributions);
	
	var _getLocations = __webpack_require__(145);
	
	var _getLocations2 = _interopRequireDefault(_getLocations);
	
	var _getRelevantRows = __webpack_require__(146);
	
	var _getRelevantRows2 = _interopRequireDefault(_getRelevantRows);
	
	var _getTimeframes = __webpack_require__(147);
	
	var _getTimeframes2 = _interopRequireDefault(_getTimeframes);
	
	var _labelFootnotes = __webpack_require__(148);
	
	var _labelFootnotes2 = _interopRequireDefault(_labelFootnotes);
	
	var _sortRows = __webpack_require__(149);
	
	var _sortRows2 = _interopRequireDefault(_sortRows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get footnotes for the current "view"
	 *
	 * If the tab is table, the footnotes need to be:
	 *   #{year, #{parent-column, child-column}, location}
	 *
	 * If the tab is map or graph, the footnotes need to be:
	 *   #{#{parent-column, child-column}, location}
	 *
	 * Parent-column or child-column can be null
	 */
	function getFootnotes(sheetData, options, filteredData, combinedFilters) {
	  var footnotes = _mori2.default.getIn(sheetData.config, ['footnotes', 'footnotes'], false);
	
	  // If there are no footnotes, just return an empty hashMap
	  if (!footnotes) {
	    return _mori2.default.hashMap();
	  }
	
	  // Get the timeframes, locations, and distributions
	  var timeframes = (0, _getTimeframes2.default)(filteredData);
	  var locations = (0, _getLocations2.default)(combinedFilters[0]);
	  var distributions = (0, _getDistributions2.default)(combinedFilters[1]);
	  // Using the actives above, get the footnotes
	  var activeFootnotes = (0, _getActiveFootnotes2.default)(footnotes, timeframes, locations, distributions);
	  // Is a trend graph when there is more than two timeframes (timeframe & any)
	  var isTrendGraph = _mori2.default.count(timeframes) > 2;
	  // Pull out active locations (locations with footnotes);
	  var activeLocations = _mori2.default.keys(activeFootnotes);
	  // Pull out rows of data that have active locations
	  var relevantRows = (0, _getRelevantRows2.default)(filteredData, activeLocations);
	  // Sort the data, to match the table sort
	  var sortedRows = _mori2.default.reduce(function (acc, row) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(row), _mori2.default.last(row)));
	  }, _mori2.default.hashMap(), (0, _sortRows2.default)(options.sortModel || {}, relevantRows, sheetData.immutableHeaders, combinedFilters[3].type));
	  // Compose the footnotes over the sorted data
	  var composedFootnotes = _mori2.default.reduce(function (acc, item) {
	    return _mori2.default.conj(acc, item);
	  }, _mori2.default.hashMap(), _mori2.default.filter(function (note) {
	    return !locations || _mori2.default.some(function (loc) {
	      return loc === _mori2.default.first(_mori2.default.rest(_mori2.default.first(_mori2.default.first(note))));
	    }, locations);
	  }, (0, _composeFootnotes2.default)(footnotes, timeframes, distributions)));
	
	  if (isTrendGraph) {
	    // If trendGraph view we need to do a secondary compose
	    composedFootnotes = _mori2.default.reduceKV(function (acc, key, val) {
	      return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.last(_mori2.default.rest(key)) !== 'Location' ? _mori2.default.set([_mori2.default.first(key), _mori2.default.first(_mori2.default.rest(key)), _mori2.default.hashMap(_mori2.default.first(key), _mori2.default.last(_mori2.default.rest(key)))]) : key, val));
	    }, _mori2.default.hashMap(), composedFootnotes);
	  }
	  // Go though and label the footnotes
	  var labeledFootnotes = (0, _labelFootnotes2.default)(composedFootnotes, sortedRows, sheetData.immutableHeaders, timeframes);
	  // Filter (dedup), the footnotes for other useage.
	  var filteredFootnotes = _mori2.default.reduceKV(function (acc, key, val) {
	    return _mori2.default.into(acc, val);
	  }, _mori2.default.set(), labeledFootnotes);
	
	  return {
	    labeledFootnotes: labeledFootnotes,
	    filteredFootnotes: filteredFootnotes
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getFootnotes, 'getFootnotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/index.js');
	}();

	;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectedColumnsRecursive;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * @param data
	 * @param baseColumn
	 * @param childColumn
	 * @param ...key
	 */
	function getSelectedColumnsRecursive() {
	  var args = Array.prototype.slice.call(arguments);
	  var data = args[0];
	  var baseColumn = args[1];
	  var childColumn = args[2];
	  var keys = args.slice(3, args.length);
	
	  if (_mori2.default.count(_mori2.default.keys(_mori2.default.last(keys[0]))) > 0) {
	    return _mori2.default.into(_mori2.default.vector(), _mori2.default.mapcat(function (row) {
	      return getSelectedColumnsRecursive.apply(undefined, [data, baseColumn, childColumn, row].concat(_toConsumableArray(keys)));
	    }, _mori2.default.last(keys[0])));
	  }
	  var nestedObject = _util.digColumnValue.apply(undefined, [data.columns].concat(_toConsumableArray(keys.map(function (item) {
	    return _mori2.default.first(item);
	  }).reverse()))) || {};
	
	  // KFF-2245.  If no label, the key does not exist in the data.
	  // Simply return to prevent parsing `undefined` later
	  if (!nestedObject.label) {
	    return null;
	  }
	
	  return getColumn(keys[0], nestedObject, baseColumn, childColumn);
	}
	
	function getColumn(row, nestedObject, baseColumn, childColumn) {
	  var base = _mori2.default.hashMap(baseColumn, nestedObject.label);
	  return _mori2.default.isEmpty(_mori2.default.last(row)) ? _mori2.default.vector(_mori2.default.vector(base)) : _mori2.default.map(function (child) {
	    // summary rows gets a rewrite
	    if (_mori2.default.first(child) === 'summary') {
	      return _mori2.default.set([_mori2.default.hashMap(baseColumn, nestedObject.label + ' (All)'), _mori2.default.hashMap(childColumn, null)]);
	    }
	    return _mori2.default.set([base, _mori2.default.hashMap(childColumn, nestedObject.children[_mori2.default.first(child)].label)]);
	  }, _mori2.default.last(row));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getSelectedColumnsRecursive, 'getSelectedColumnsRecursive', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getSelectedColumnsRecursive.js');
	
	  __REACT_HOT_LOADER__.register(getColumn, 'getColumn', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getSelectedColumnsRecursive.js');
	}();

	;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(15);
	
	var _filters = __webpack_require__(57);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filterSwitch = null; /* global __webpack_modules__ */
	
	/* eslint id-length: [2, {"exceptions":["a","b","x","y"]}] */
	
	
	if (__webpack_require__.m[/*require.resolve*/(33)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  filterSwitch = _filters2.default;
	}
	/**
	 * Output should appear like:
	 * Options from ../config/linechart
	 * @example:
	   var graph.data = [{
	     key: 'State Name - Distribution',
	     state: 'State Name',
	     characteristic: 'Distribution',
	     values: [
	       { x: [x], y: [value] },
	       { x: [x], y: [value] }
	     ]
	   },
	   {
	     key: 'State Name - Distribution',
	     state: 'State Name',
	     characteristic: 'Distribution',
	     values: []
	   }];
	 */
	function buildGraphData(timeframes, keys, combined, selectedHeaders) {
	  // Filter timeframe data by baseColumn selections
	  return _mori2.default.mapcat(function (baseColumn) {
	    return _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (distribution) {
	      var sheetIndex = 0;
	      var formatted = _mori2.default.first(_mori2.default.filter(function (header) {
	        return _mori2.default.get(header, 'characteristic') === _mori2.default.first(distribution);
	      }, selectedHeaders));
	      var state = _mori2.default.last(_mori2.default.last(_mori2.default.first(baseColumn)));
	      return _mori2.default.hashMap('key', state + ' - ' + _mori2.default.first(distribution), 'state', state, 'characteristic', _mori2.default.first(distribution), 'type', _mori2.default.last(distribution).toLowerCase(), 'Prefix', _mori2.default.get(_mori2.default.first(selectedHeaders), 'Prefix'), 'Precision', _mori2.default.get(_mori2.default.first(selectedHeaders), 'Precision'), 'tickValues', _mori2.default.map(function (timeframe) {
	        return _mori2.default.first(timeframe);
	      }, _mori2.default.reverse(timeframes)), 'selectedHeader', _mori2.default.first(selectedHeaders), 'values', _mori2.default.sort(function (a, b) {
	        return _mori2.default.get(a, 'x') - _mori2.default.get(b, 'x');
	      }, _mori2.default.into(_mori2.default.vector(), _mori2.default.mapcat(function (timeframe) {
	        return _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (row) {
	          return _mori2.default.every(function (selected) {
	            return _mori2.default.equals(_mori2.default.last(_mori2.default.first(selected)), _mori2.default.get(row, _mori2.default.first(_mori2.default.first(selected))));
	          }, baseColumn);
	        }), _mori2.default.map(function (row) {
	          var value = _mori2.default.get(row, distribution);
	          // pulled from switchFilter.js
	          var prefixChar = typeof value === 'string' ? value.charAt(0) : '';
	          var isPrefixed = ['<', '>'].indexOf(prefixChar) > -1;
	
	          var y = (value === 0 ? '0' : false) || (0, _util.kffNumericValue)(value) || null;
	          return _mori2.default.hashMap('x', sheetIndex++, 'y', !y ? undefined : (0, _util.kffNumericValue)(filterSwitch(y, _mori2.default.toJs(formatted))) / (_mori2.default.toJs(formatted).type === 'percent' ? 100 : 1), 'formatted', '' + (isPrefixed ? prefixChar : '') + filterSwitch(y, _mori2.default.toJs(formatted)));
	        })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), _mori2.default.last(timeframe));
	      }, _mori2.default.reverse(timeframes)))));
	    }, _mori2.default.rest(keys)));
	  }, combined);
	}
	
	// passes in sheets
	
	var _default = function _default(data, options, timeframes, combined, selected, distributions) {
	  var selectedHeaders = _mori2.default.filter(function (header) {
	    var characteristic = _mori2.default.get(header, 'characteristic');
	    var label = _mori2.default.get(header, 'label');
	
	    return _mori2.default.some(function (currentSelected) {
	      return _mori2.default.first(currentSelected) === characteristic && _mori2.default.last(currentSelected) === label;
	    }, _mori2.default.rest(selected));
	  }, data.immutableHeaders);
	
	  return _mori2.default.count(distributions) ? buildGraphData(timeframes, selected, combined, selectedHeaders) : [];
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(filterSwitch, 'filterSwitch', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/linechartData.js');
	
	  __REACT_HOT_LOADER__.register(buildGraphData, 'buildGraphData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/linechartData.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/linechartData.js');
	}();

	;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	var _maps = __webpack_require__(137);
	
	var maps = _interopRequireWildcard(_maps);
	
	var _util = __webpack_require__(15);
	
	var util = _interopRequireWildcard(_util);
	
	var _jenks = __webpack_require__(155);
	
	var _jenks2 = _interopRequireDefault(_jenks);
	
	var _getSelectedDistributions = __webpack_require__(58);
	
	var _getSelectedDistributions2 = _interopRequireDefault(_getSelectedDistributions);
	
	var _filters = __webpack_require__(57);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _switchFilter = __webpack_require__(72);
	
	var _switchFilter2 = _interopRequireDefault(_switchFilter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global __webpack_modules__ */
	
	/* eslint id-length: [2, {"exceptions": ["a","b","t","m","x"]}] */
	var filterSwitch = null;
	
	if (__webpack_require__.m[/*require.resolve*/(33)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  //  This is react's territory
	  filterSwitch = (0, _switchFilter2.default)();
	}
	
	var _default = function _default(data, options, treeContextSlug, timeframes) {
	  // Get geography code map from topojson
	  var geoContext = 'usa';
	  var geoCodeMap = maps.getGeoCodeMap(geoContext);
	  var mapConfig = _mori2.default.toJs(maps.mapDefault(geoContext));
	  var isLocked = _mori2.default.getIn(data.config, ['globalRules', 'Locked'], false);
	  var isGeomulti = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti'], false);
	  var mapBaseColumn = _mori2.default.getIn(data.config, ['globalRules', 'Map Base Column'], false);
	  var baseColumn = void 0;
	
	  // Get the current data view object by index
	  var dataviewType = data.globalSettings.hasDataviews && !isLocked ? _mori2.default.nth(data.immutableDataviews, +(options.dataView || 0)) : false;
	
	  // Currently selected distributions by matching slugs, or all
	  var distributions = options.selectedDistributions ? _mori2.default.filter(function (x) {
	    return options.selectedDistributions === _mori2.default.get(x, 'slug');
	  }, data.immutableDistributions) : data.immutableDistributions;
	
	  // Create sets as keys for data
	  var selected = (0, _getSelectedDistributions2.default)(data, distributions, dataviewType, isGeomulti);
	
	  // Map selected headers by distribution name and type
	  // Pluck distribution names from the selected distributions array
	  var distributionNames = _mori2.default.set(_mori2.default.map(function (characteristic) {
	    return _mori2.default.get(characteristic, 'characteristic');
	  }, distributions));
	  var selectedHeader = _mori2.default.first(_mori2.default.rest(_mori2.default.filter(function (header) {
	    return _mori2.default.get(header, 'idx') === 0 || _mori2.default.hasKey(distributionNames, _mori2.default.get(header, 'characteristic')) && (!dataviewType || dataviewType.type === _mori2.default.get(header, 'type') || dataviewType.label === _mori2.default.get(header, 'label'));
	  }, data.immutableHeaders)));
	
	  // Normally the base column is just the first
	  if (!isGeomulti) {
	    baseColumn = _mori2.default.vector(_mori2.default.set([_mori2.default.get(_mori2.default.first(data.immutableHeaders), 'characteristic'), _mori2.default.get(_mori2.default.first(data.immutableHeaders), 'label')]));
	    // otherwise get the base column specified by config
	  } else {
	    baseColumn = _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (header) {
	      return _mori2.default.equals(_mori2.default.get(header, 'characteristic'), _mori2.default.getIn(data.config, ['globalRules', 'Link Column']));
	    }), _mori2.default.map(function (header) {
	      var dataviewLabel = dataviewType ? dataviewType.label : _mori2.default.get(header, 'label');
	      return _mori2.default.set([_mori2.default.get(header, 'characteristic'), dataviewLabel]);
	    })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), data.immutableHeaders);
	  }
	
	  // Make an array of selected/parent selection rows
	  var parentColumns = isGeomulti ? _mori2.default.map(function (row) {
	    var rowKey = _mori2.default.first(row);
	    var columns = data.columns.nested[treeContextSlug] || {};
	    var currentChild = (columns.children || {})[rowKey];
	    return currentChild.label || rowKey;
	  }, _mori2.default.toClj((options.selectedRows || {})[treeContextSlug] || {})) : false;
	
	  // Join the base column and the selected sets
	  var selectedSetKeys = _mori2.default.into(baseColumn, selected);
	
	  // Set map constructor values
	  mapConfig.scope = geoContext;
	  mapConfig.data = buildMapData(timeframes, selectedSetKeys, geoCodeMap, selectedHeader, baseColumn, parentColumns, isGeomulti, mapBaseColumn);
	  mapConfig.setProjection = maps.setMapProjection(geoContext, mapConfig);
	  mapConfig.fills = {};
	
	  // Calculate and apply fill and legend
	
	  var _buildMapFills = buildMapFills(mapConfig.fills, mapConfig.data),
	      fills = _buildMapFills.fills,
	      labels = _buildMapFills.labels,
	      mapDataProcessed = _buildMapFills.mapDataProcessed;
	
	  mapConfig.fills = fills;
	  mapConfig.labels = labels;
	  mapConfig.labels.defaultFill = mapBaseColumn ? 'Firm is Not Operating in State' : mapConfig.labels.defaultFill;
	  mapConfig.data = mapDataProcessed;
	
	  return {
	    data: mapConfig,
	    plugins: buildMapPlugins(geoContext)
	  };
	};
	
	exports.default = _default;
	
	
	function buildMapData(timeframes, selected, codes, selectedHeader, baseColumn, parentColumns, isGeomulti, mapBaseColumn) {
	  var firstKey = _mori2.default.first(selected);
	  var secondKey = _mori2.default.first(_mori2.default.rest(selected));
	
	  var baseKey = isGeomulti ? secondKey : firstKey;
	  var dataKey = isGeomulti ? firstKey : secondKey;
	
	  return _mori2.default.into(_mori2.default.hashMap(), _mori2.default.map(function (x) {
	    // geomulti datapoints are simply the header title as the value in all
	    // states that exist
	    if (isGeomulti) {
	      var title = _mori2.default.get(selectedHeader, 'characteristic');
	
	      var value = mapBaseColumn ? _mori2.default.hashMap(codes[_mori2.default.get(x, baseKey)], _mori2.default.hashMap(_mori2.default.get(x, dataKey), _mori2.default.map(function (item) {
	        return _mori2.default.hashMap(_mori2.default.first(item), _mori2.default.get(x, item));
	      }, _mori2.default.filter(function (item) {
	        return _mori2.default.first(item) !== _mori2.default.first(baseKey) && _mori2.default.first(item) !== _mori2.default.first(dataKey);
	      }, _mori2.default.keys(x))))) : title;
	
	      return _mori2.default.hashMap(codes[_mori2.default.get(x, baseKey)], _mori2.default.hashMap('value', value, 'raw', mapBaseColumn ? 'Firm is Operating in State' : title, 'formatted', mapBaseColumn ? 'Firm is Operating in State' : title, 'mapBaseColumn', mapBaseColumn));
	    }
	    var rawNum = util.kffNumericValue(_mori2.default.get(x, dataKey));
	    if (rawNum !== null && /^percent/.test(_mori2.default.get(selectedHeader, 'type'))) {
	      // @TODO replace with built in filter
	      rawNum = util.numberPrecision(rawNum, util.getPrecision(_mori2.default.toJs(selectedHeader)), true);
	    }
	    var formatted = filterSwitch(_mori2.default.get(x, dataKey), _mori2.default.toJs(selectedHeader));
	    return _mori2.default.hashMap(codes[_mori2.default.get(x, baseKey)], _mori2.default.hashMap('value', _mori2.default.get(x, dataKey), 'raw', rawNum !== null ? rawNum : _mori2.default.get(x, dataKey), 'formatted', formatted));
	  }, _mori2.default.filter(function (x) {
	    return !parentColumns ?
	    // filter by actual states
	    codes[_mori2.default.get(x, baseKey)] :
	    // filter by selected row values
	    _mori2.default.equals(_mori2.default.get(x, _mori2.default.first(baseColumn)), _mori2.default.first(parentColumns));
	  }, _mori2.default.first(_mori2.default.rest(_mori2.default.first(timeframes))))));
	}
	
	/**
	 * Apply fill and legend calculation for datamap constructor
	 */
	function buildMapFills(mapFills, mapData) {
	  // Calculate breaks using jenks
	  var breaks = buildBreaks(mapData);
	
	  // Build fills and legend using breaks data
	
	  var _buildLegend = buildLegend(breaks, mapFills),
	      fills = _buildLegend.fills,
	      labels = _buildLegend.labels;
	
	  // Apply fills to map data
	
	
	  var mapDataProcessed = annotateData(mapData, breaks);
	
	  return { fills: fills, labels: labels, mapDataProcessed: mapDataProcessed };
	}
	
	/**
	 * Apply the correct fill keys to map data objects
	 */
	function annotateData(data, breaks) {
	  return _mori2.default.toJs(_mori2.default.transduce(_mori2.default.map(function (x) {
	    var _x = _mori2.default.hashMap(_mori2.default.first(x), _mori2.default.first(_mori2.default.rest(x)));
	    var fillKey = getFillKey(_mori2.default.get(breaks, 'useTextForFill') ? _mori2.default.get(_mori2.default.first(_mori2.default.rest(x)), 'formatted') : _mori2.default.get(_mori2.default.first(_mori2.default.rest(x)), 'raw'), breaks);
	    _x = _mori2.default.assocIn(_x, [_mori2.default.first(x), 'fillKey'], fillKey);
	    return _x;
	  }), _mori2.default.completing(_mori2.default.conj), _mori2.default.hashMap(), data));
	}
	
	/**
	 * Get the fill key for given data value
	 */
	function getFillKey(value, breaks) {
	  if (_mori2.default.some(function (val) {
	    return val === value;
	  }, _mori2.default.get(breaks, 'text'))) {
	    return _config.appDefault.dataNotAvailable.indexOf(value) > -1 || !value ? 'defaultFill' : value;
	  } else if (_mori2.default.get(breaks, 'useTextForFill') && _mori2.default.intoArray(_mori2.default.get(breaks, 'text')).indexOf(value) > -1) {
	    return _mori2.default.intoArray(_mori2.default.get(breaks, 'text')).indexOf(value);
	  } else if (!isNaN(value)) {
	    // If we have fewer than the max number of breaks,
	    // we need to map data to the break points exactly.
	    // This way, we are not grouping small data sets into
	    // one break point.
	    //
	    // If there are more than max breaks, we need to build a
	    // set of ranges.
	    var breakIndex = _mori2.default.intoArray(_mori2.default.get(breaks, 'fewerThanMaxBreaks') ? _mori2.default.get(breaks, 'values') : _mori2.default.rest(_mori2.default.get(breaks, 'values'))).reduce(function (acc, point, index) {
	      if (_mori2.default.get(breaks, 'fewerThanMaxBreaks')) {
	        return +value === point && acc < 0 ? index : acc;
	      }
	      return +value < point && acc < 0 ? index : acc;
	    }, -1);
	    if (breakIndex === -1) {
	      return _mori2.default.count(_mori2.default.get(breaks, 'values')) - 2;
	    }
	    return '' + breakIndex;
	  }
	  return 'defaultFill';
	}
	
	/**
	 * Constuct breaks arrays for numerical and text values,
	 * so they can be combined.
	 */
	function buildBreaks(data) {
	  var values = _mori2.default.groupBy(function (value) {
	    return util.kffIsNumber(_mori2.default.get(value, 'raw')) ? 'numeric' : 'text';
	  }, _mori2.default.map(function (row) {
	    return _mori2.default.first(_mori2.default.rest(row));
	  }, data));
	
	  // sort numeric
	  values = _mori2.default.assocIn(values, ['numeric'], _mori2.default.sort(function (a, b) {
	    return _mori2.default.get(a, 'raw') - _mori2.default.get(b, 'raw');
	  }, _mori2.default.get(values, 'numeric')));
	
	  var textBreaks = _mori2.default.distinct(_mori2.default.map(function (value) {
	    return _config.appDefault.dataNotAvailable.indexOf(_mori2.default.get(value, 'raw')) > -1 ? 'N/A' : _mori2.default.get(value, 'raw');
	  }, _mori2.default.get(values, 'text')));
	
	  var numeralBreaks = [];
	
	  // If we have few than 5 numeric values, we need to let
	  // the fillKey lookup code know that it has to look at
	  // the rawValues for data, else no key would be found
	  var useTextForFill = _mori2.default.count(_mori2.default.get(values, 'numeric')) < 5;
	
	  if (useTextForFill) {
	    textBreaks = _mori2.default.into(textBreaks, _mori2.default.distinct(_mori2.default.map(function (value) {
	      return _mori2.default.get(value, 'formatted');
	    }, _mori2.default.get(values, 'numeric'))));
	  } else {
	    var separated = _mori2.default.groupBy(function (value) {
	      return +_mori2.default.get(value, 'raw') < 0 ? 'negative' : 'positive';
	    }, _mori2.default.get(values, 'numeric'));
	    var offset = _mori2.default.hasKey(separated, 'negative') ? 1 : 0;
	
	    // Get Positive Breaks
	    var positiveNumeralBreaks = _mori2.default.count(_mori2.default.distinct(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'positive')))) < _config.appDefault.maxBreaks ? _mori2.default.toJs(_mori2.default.distinct(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'positive')))) : (0, _jenks2.default)(_mori2.default.toJs(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'positive'))), _config.appDefault.maxBreaks - offset) || [];
	
	    numeralBreaks = positiveNumeralBreaks.concat(offset ? (0, _jenks2.default)(_mori2.default.toJs(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'negative'))), _config.appDefault.maxBreaks - _mori2.default.count(_mori2.default.distinct(positiveNumeralBreaks.filter(function (x) {
	      return x || x === 0;
	    })))) : []).sort(function (a, b) {
	      return a > b;
	    });
	  }
	
	  // in case the sample is too small, or doesn't have unique values
	  // TODO: test if this is necessary
	  var realBreaks = _mori2.default.distinct(numeralBreaks.filter(function (x) {
	    return x || x === 0;
	  }));
	
	  if (_mori2.default.count(realBreaks) >= 1) {
	    // Find the longest decimal position, so we can pad all values
	    var numeralPrecisionMax = numeralBreaks.reduce(function (max, curr) {
	      var stringValue = curr + '';
	      if (stringValue.indexOf('.') === -1) {
	        return max;
	      }
	      var precision = stringValue.split('.')[1].length;
	      if (precision > max) {
	        return precision;
	      }
	      return max;
	    }, 0);
	    // Pad
	    numeralBreaks = _mori2.default.distinct(_mori2.default.map(function (value) {
	      return value === 0 || typeof value === 'undefined' ? 0 : +value.toFixed(numeralPrecisionMax);
	    }, numeralBreaks));
	  }
	
	  return _mori2.default.hashMap('text', textBreaks, 'values', numeralBreaks, 'rawValues', values, 'useTextForFill', useTextForFill, 'fewerThanMaxBreaks', _mori2.default.count(numeralBreaks) < _config.appDefault.maxBreaks);
	}
	
	/**
	 * Process breaks for legend and fills, combining if necessary.
	 */
	function buildLegend(breaks, fills) {
	  var labels = {};
	  // Don't include default fills
	  var textBreaks = _mori2.default.filter(function (x) {
	    return x && x.length && _config.appDefault.dataNotAvailable.indexOf(x) === -1;
	  }, _mori2.default.get(breaks, 'text'));
	
	  var lengthOffset = _mori2.default.get(breaks, 'fewerThanMaxBreaks') ? 0 : 1;
	
	  var legendLength = (!_mori2.default.isEmpty(_mori2.default.get(breaks, 'values')) ? _mori2.default.count(_mori2.default.get(breaks, 'values')) - lengthOffset : 0) + _mori2.default.count(textBreaks);
	  var colorIndex = 0;
	
	  if (legendLength > 6) {
	    legendLength = 'full';
	  }
	
	  // Map breaks for numerical values to legend + fills
	  if (!_mori2.default.isEmpty(_mori2.default.get(breaks, 'values'))) {
	    // Group values by breakpoint
	    var grouped = _mori2.default.toJs(_mori2.default.groupBy(function (row) {
	      var group = _mori2.default.peek(_mori2.default.into(_mori2.default.vector(), _mori2.default.takeWhile(function (breakValue) {
	        return breakValue <= _mori2.default.get(row, 'raw');
	      }, _mori2.default.get(breaks, 'values'))));
	      // The last breakpoint is a bound, not a group
	      if (!_mori2.default.get(breaks, 'fewerThanMaxBreaks') && group === _mori2.default.last(_mori2.default.get(breaks, 'values'))) {
	        return _mori2.default.count(_mori2.default.get(breaks, 'values')) - 2;
	      }
	      return _mori2.default.toJs(_mori2.default.get(breaks, 'values')).indexOf(group);
	    }, _mori2.default.getIn(breaks, ['rawValues', 'numeric'])));
	
	    Object.keys(grouped).forEach(function (idx) {
	      var startBreak = grouped[idx][0].formatted;
	      var endBreak = grouped[idx][grouped[idx].length - 1].formatted;
	      labels[idx] = '' + startBreak;
	      if (startBreak !== endBreak) {
	        labels[idx] += '- ' + endBreak;
	      }
	      fills[idx] = maps.mapColors[legendLength][colorIndex];
	      colorIndex++;
	    });
	  }
	
	  // Map breaks for text values to legend + fills
	  if (_mori2.default.count(_mori2.default.get(breaks, 'text'))) {
	    _mori2.default.each(_mori2.default.sort(function (a, b) {
	      return a.localeCompare(b);
	    }, _mori2.default.filter(function (x) {
	      return x && _config.appDefault.dataNotAvailable.indexOf(x) === -1 && x.length;
	    }, _mori2.default.get(breaks, 'text'))), function (x) {
	      labels[_mori2.default.count(_mori2.default.get(breaks, 'values')) + colorIndex] = x;
	      fills[x] = maps.mapColors[legendLength][colorIndex];
	      colorIndex++;
	    });
	  }
	
	  // Make sure we set the defaultFill
	  fills.defaultFill = maps.mapColors.defaultColor;
	  labels.defaultFill = 'N/A';
	
	  return { fills: fills, labels: labels };
	}
	
	/**
	 * Set up plugins object for the map
	 */
	function buildMapPlugins(geoContext) {
	  var plugins = {
	    mapCustomLegend: maps.mapCustomLegend
	  };
	  if (geoContext === 'usa') {
	    plugins.mapCustomLabels = maps.mapCustomLabels;
	  }
	  return plugins;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(filterSwitch, 'filterSwitch', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildMapData, 'buildMapData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildMapFills, 'buildMapFills', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(annotateData, 'annotateData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(getFillKey, 'getFillKey', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildBreaks, 'buildBreaks', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildLegend, 'buildLegend', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildMapPlugins, 'buildMapPlugins', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	}();

	;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	var _ = __webpack_require__(46);
	
	var _util = __webpack_require__(15);
	
	var _sortComparator = __webpack_require__(151);
	
	var _sortComparator2 = _interopRequireDefault(_sortComparator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Assemble the ag-grid header
	 * @TODO finish building out this docblock
	 * @param  {[type]} header           [description]
	 * @param  {[type]} linkColumn       [description]
	 * @param  {[type]} linkTarget       [description]
	 * @param  {[type]} linkContext      Used when building the selectedRows tree
	 *                                   for inter-indicator linking
	 * @param  {[type]} timeframe        [description]
	 * @param  {[type]} trend            [description]
	 * @param  {[type]} baseDistribution [description]
	 * @param  {[type]} mapBaseColumn    [description]
	 * @param  {[type]} selectedHeaders  [description]
	 * @param  {[type]} headerGroupTitle The text displayed in the header group table cell.
	 * @param  {[type]} currentGroup     The header group this header belongs to.
	 * @return {[type]}                  [description]
	 */
	var _default = function _default(header, linkColumn, linkTarget, linkContext, timeframe, trend, baseDistribution, mapBaseColumn) {
	  var selectedHeaders = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
	  var headerGroupTitle = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
	  var currentGroup = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
	
	  var currentHeader = _mori2.default.toJs(header);
	  var characteristic = currentHeader.characteristic;
	
	  // align numeric columns right
	  var numericColumn = ['number', 'percent', 'currency', 'year', 'rate', 'default'].indexOf(currentHeader.type) > -1 || currentHeader.Prefix || currentHeader.Suffix;
	
	  // Take into account space needed for sorting arrows in columns
	  var colWidthAdjust = 35;
	
	  var field = (trend ? _mori2.default.first(timeframe) + '__' : '') + characteristic;
	
	  // Font style used to more accurately estimate width of text in headers
	  var fontStyleString = 'bold 14px/20px "Droid Sans", helvetica, sans-serif';
	
	  // For Grouped Headers, we need to accurately account for long words
	  // in the header group cell.  We'll find the longest word and adjust
	  // the widths of the header group children appropriately.
	
	  // Find base width for the current header
	  var baseHeaderWidth = _config.appDefault.defaultWidths[currentHeader.type][currentHeader.width || 'default'] || _config.appDefault.defaultWidths[currentHeader.type].default;
	
	  // Find the longest word in the group header
	  var estHeaderGroupWidth = currentHeader.headerGroup ? (0, _util.maxWordWidth)(currentHeader.headerGroup, fontStyleString) + colWidthAdjust : 0;
	
	  // Find the width of all children columns under a header group.
	  // This is needed, to ensure we size children columns correctly.
	  // Reduce the group of children columns down to a cummulative default width.
	  var defaultHeaderGroupWidth = _mori2.default.reduce(function (acc, item) {
	    return acc + _config.appDefault.defaultWidths[_mori2.default.get(item, 'type')][_mori2.default.get(item, 'width') || 'default'] || _config.appDefault.defaultWidths[_mori2.default.get(item, 'type')].default;
	  }, 0, currentGroup);
	
	  // Get the proportion of the current header width to the group's width
	  var headerWidthFactor = baseHeaderWidth / (defaultHeaderGroupWidth || 1);
	
	  // If longest word in group header is wider than entire header group
	  // compare which is wider:
	  // 1.  The base header width plus a proporition of the width difference
	  // 2.  The widest word in the current header
	  var estWidth = Math.max(defaultHeaderGroupWidth > estHeaderGroupWidth ? 0 : baseHeaderWidth + (estHeaderGroupWidth - defaultHeaderGroupWidth) * headerWidthFactor, (0, _util.maxWordWidth)(characteristic, fontStyleString) + colWidthAdjust);
	
	  var comparator = (0, _sortComparator2.default)(currentHeader, baseDistribution, mapBaseColumn);
	
	  var agHeader = _mori2.default.hashMap('cellRenderer', _.cellRenderer, 'field', headerGroupTitle ? headerGroupTitle + '__' + field : field, 'headerName', characteristic, 'sortingOrder', _config.appDefault.descSortFirst.indexOf(currentHeader.type) !== -1 ? ['desc', 'asc'] : ['asc', 'desc'], 'cellStyle', function () {
	    // Some times prefix/suffix get added to geo headers and appear "Numeric"
	    return numericColumn && currentHeader.type !== 'geography' && currentHeader.idx !== 0 ? { 'text-align': 'right' } : null;
	  }, 'width', estWidth > baseHeaderWidth ? estWidth : baseHeaderWidth, 'cellRendererParams', _mori2.default.hashMap('currentHeader', currentHeader, 'linkTarget', linkTarget, 'linkColumn', linkColumn, 'linkContext', linkContext, 'selectedHeaders', selectedHeaders), 'comparator', comparator, 'valueGetter', _.valueGetter);
	
	  // adds a default sort to the base column
	  if (characteristic === baseDistribution) {
	    agHeader = _mori2.default.assoc(agHeader, 'sort', 'asc', 'pinned', 'left');
	  }
	
	  if (characteristic === 'Location' || characteristic === 'State') {
	    agHeader = _mori2.default.assoc(_mori2.default.assoc(agHeader, 'width', 160), 'suppressSizeToFit', true);
	  }
	
	  return agHeader;
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/buildHeader.js');
	}();

	;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	var _ = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * [buildRowData description]
	 * @TODO finish documenting this out
	 * @param  {[type]} timeframes    [description]
	 * @param  {[type]} keys          [description]
	 * @param  {[type]} combined      [description]
	 * @param  {[type]} footnotes     [description]
	 * @param  {[type]} trend         [description]
	 * @param  {[type]} distributions [description]
	 * @return {[type]}               [description]
	 */
	var _default = function _default(timeframes, keys, combined, trend) {
	  // Build a map of footnotes ids by order of assignment in the table
	  var shouldFilter = !_mori2.default.isEmpty(combined);
	  var withSummary = _mori2.default.some(function (base) {
	    return _mori2.default.reduce(function (acc, sel) {
	      return acc ? acc : _config.appDefault.isSummaryRow.test(_mori2.default.last(_mori2.default.first(sel)));
	    }, false, base);
	  }, combined) || false;
	
	  var test = _mori2.default.map(function (timeframe) {
	    return _mori2.default.transduce(_mori2.default.comp(_mori2.default.map(function (row) {
	      return _config.appDefault.isSummaryRow.test(_mori2.default.get(row, _mori2.default.first(_mori2.default.keys(row)))) ? _mori2.default.assoc(_mori2.default.assoc(row, _mori2.default.first(_mori2.default.keys(row)), _mori2.default.get(row, _mori2.default.first(_mori2.default.keys(row))).replace(_config.appDefault.isSummaryRow, '')), 'isSummary', true) : row;
	    }), _mori2.default.filter(function (row) {
	      return (0, _.filterByRow)(row, combined, shouldFilter, withSummary);
	    }), _mori2.default.map(function (row) {
	      return _mori2.default.assoc(_mori2.default.into(_mori2.default.hashMap(_mori2.default.first(_mori2.default.first(keys)), _mori2.default.get(row, _mori2.default.first(keys))), _mori2.default.map(function (select) {
	        return _mori2.default.hashMap((trend ? _mori2.default.first(timeframe) + '__' : '') + (_mori2.default.count(select) === 3 ? _mori2.default.first(select) + '__' + _mori2.default.first(_mori2.default.rest(select)) : _mori2.default.first(select)), _mori2.default.get(row, select));
	      }, _mori2.default.rest(keys))), 'isSummary', _mori2.default.get(row, 'isSummary'));
	    })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), _mori2.default.last(timeframe));
	  }, timeframes);
	
	  // Filter timeframe data by baseColumn selections
	  var rowData = _mori2.default.map(function (group) {
	    return _mori2.default.into(_mori2.default.hashMap(), _mori2.default.toClj(group));
	  }, _mori2.default.map.apply(_mori2.default, [_mori2.default.vector].concat(_toConsumableArray(_mori2.default.toJs(test)))));
	
	  return _mori2.default.toJs(_mori2.default.hashMap('rowData', rowData));
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/buildRowData.js');
	}();

	;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _ = __webpack_require__(46);
	
	var _filters = __webpack_require__(57);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _config = __webpack_require__(11);
	
	var _slugify2 = __webpack_require__(73);
	
	var _slugify3 = _interopRequireDefault(_slugify2);
	
	var _switchFilter = __webpack_require__(72);
	
	var _switchFilter2 = _interopRequireDefault(_switchFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* global __webpack_modules__ */
	
	var filterSwitch = null;
	
	if (__webpack_require__.m[/*require.resolve*/(33)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  //  This is react's territory
	  filterSwitch = (0, _switchFilter2.default)();
	}
	
	var cellRendererVars = {
	  rankings: {}
	};
	
	var _default = function _default(_ref2) {
	  var api = _ref2.api,
	      value = _ref2.value,
	      column = _ref2.column,
	      rowIndex = _ref2.rowIndex,
	      linkTarget = _ref2.linkTarget,
	      linkColumn = _ref2.linkColumn,
	      linkContext = _ref2.linkContext,
	      currentHeader = _ref2.currentHeader,
	      selectedHeaders = _ref2.selectedHeaders;
	  var text = value.text,
	      data = value.data,
	      child = value.child,
	      group = value.group;
	  var characteristic = currentHeader.characteristic;
	
	
	  var footnotes = [];
	  if (api.footnoteCallback) {
	    footnotes = api.footnoteCallback([data.Location || data.State, // State for geomulti
	    child !== false ? [group, child] : group]);
	  }
	
	  var notes = footnotes.sort(function (_ref3, _ref4) {
	    var a = _ref3.label;
	    var b = _ref4.label;
	    return a - b;
	  }).map(footnoteMark).join(', ');
	
	  var formattedValue = filterSwitch(text, currentHeader);
	  var cellAnchor = linkTarget && linkColumn && linkColumn === characteristic ? getLinkTargetUrl(linkTarget, linkContext, formattedValue) : null;
	
	  // Only rank geos w/ sorting on different column
	  // If column.sort is null it means it's sorted on different column
	  var rank = '';
	  if (currentHeader.idx === 0 && column.sort === null) {
	    var colIdx = 0;
	    var sortDir = void 0;
	    var headerName = void 0;
	    var rowsToDisplay = api.rowModel.rowsToDisplay.length;
	    var isWrapup = _config.appDefault.specialWrapups.indexOf(text) >= 0;
	    var currentSortColumn = api.columnController.allDisplayedColumns.reduce(function (acc, curr, index) {
	      return curr.sort && !acc ? (colIdx = index) && (headerName = curr.colDef.headerName) && (sortDir = curr.sort) && curr.colId : acc;
	    }, false);
	    var dataValue = api.rowModel.rowsToDisplay[rowIndex].data[currentSortColumn];
	
	    var isNaData = _config.appDefault.dataNotAvailable.indexOf(dataValue !== null ? dataValue : '') >= 0;
	    var sortKey = currentSortColumn + '-' + sortDir;
	
	    // Catches for Linechart data maps
	    if (_mori2.default.count(selectedHeaders) - 1 < colIdx) {
	      colIdx = colIdx % (_mori2.default.count(selectedHeaders) - 1) + 1;
	    }
	
	    // Check if rankings for this sort exist, and store the length.
	    // If the # of rows to render has changed (not equal to rankings)
	    // we need to re-rank, as we cannot tell exactly what changed.
	    var rankingsExist = !!cellRendererVars.rankings[sortKey];
	    var rankingsLength = rankingsExist ? cellRendererVars.rankings[sortKey].length : 0;
	    cellRendererVars.rankings[sortKey] = rankingsExist && rankingsLength === rowsToDisplay ? cellRendererVars.rankings[sortKey] : (0, _.getDataRankings)(api, currentSortColumn, _mori2.default.toJs(
	    // Getting the nth selectedHeader is not reliable if we are
	    // on the trend graph view.  We want to get the header
	    // based on what the current sort column is - using headerName.
	    _mori2.default.first(_mori2.default.filter(function (item) {
	      return item.characteristic === headerName;
	    }, selectedHeaders))));
	
	    rank = isWrapup || isNaData ? '' : cellRendererVars.rankings[sortKey][rowIndex] + '. ';
	  }
	
	  return '<span title="' + formattedValue + '">\n      ' + rank + (cellAnchor ? cellAnchor : '') + '\n      ' + formattedValue + ' <sup>' + notes + '</sup>\n      ' + (cellAnchor ? '</a>' : '') + '\n    </span>';
	};
	
	exports.default = _default;
	
	
	function getLinkTargetUrl(url, linkContext, value) {
	  var tree = encodeURIComponent(JSON.stringify(_defineProperty({}, (0, _slugify3.default)(linkContext), _defineProperty({}, (0, _slugify3.default)(value), {}))));
	
	  return '<a href="' + url + '?selectedRows=' + tree + '" target="_self">';
	}
	
	function footnoteMark(_ref) {
	  var label = _ref.label;
	
	  return '<a href="#note-' + label + '">' + label + '</a>';
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(filterSwitch, 'filterSwitch', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/cellRenderer.js');
	
	  __REACT_HOT_LOADER__.register(cellRendererVars, 'cellRendererVars', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/cellRenderer.js');
	
	  __REACT_HOT_LOADER__.register(getLinkTargetUrl, 'getLinkTargetUrl', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/cellRenderer.js');
	
	  __REACT_HOT_LOADER__.register(footnoteMark, 'footnoteMark', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/cellRenderer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/cellRenderer.js');
	}();

	;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [filterByRow]
	 * @TODO finish documenting this out
	 * @param  {[type]} row          [description]
	 * @param  {[type]} combined     [description]
	 * @param  {[type]} shouldFilter [description]
	 * @param  {[type]} withSummary  [description]
	 * @return {[type]}              [description]
	 */
	var _default = function _default(row, combined, shouldFilter, withSummary) {
	  return shouldFilter ? _mori2.default.some(function (baseColumn) {
	    return _mori2.default.every(function (selected) {
	      return _mori2.default.equals(_mori2.default.last(_mori2.default.first(selected)), _mori2.default.get(row, _mori2.default.first(_mori2.default.first(selected)))) || _mori2.default.get(row, 'isSummary', false) && withSummary && _mori2.default.equals(_mori2.default.last(_mori2.default.first(_mori2.default.first(baseColumn))).replace(_config.appDefault.isSummaryRow, ''), _mori2.default.get(row, _mori2.default.first(_mori2.default.first(_mori2.default.first(baseColumn)))));
	    }, baseColumn);
	  }, combined) : row;
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/filterByRow.js');
	}();

	;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _ = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [getAgColumns description]
	 * @TODO: finish documenting this out
	 * @param  {[type]} headers          [description]
	 * @param  {[type]} distributions    [description]
	 * @param  {[type]} linkColumn       [description]
	 * @param  {[type]} linkTarget       [description]
	 * @param  {[type]} linkContext      Used when building the selectedRows tree
	 *                                   for inter-indicator linking
	 * @param  {[type]} type             [description]
	 * @param  {[type]} timeframes       [description]
	 * @param  {[type]} trend            [description]
	 * @param  {[type]} baseDistribution [description]
	 * @param  {[type]} mapBaseColumn    [description]
	 * @return {[type]}                  [description]
	 */
	var _default = function _default(headers, distributions, linkColumn, linkTarget, linkContext, type, timeframes, trend, baseDistribution, mapBaseColumn) {
	  // Pluck distribution names from the selected distributions array
	  var distributionNames = _mori2.default.set(_mori2.default.map(function (characteristic) {
	    return _mori2.default.get(characteristic, 'characteristic');
	  }, distributions));
	  var headerGroups = _mori2.default.set(_mori2.default.map(function (group) {
	    return _mori2.default.get(group, 'headerGroup', false);
	  }, distributions));
	
	  // Map selected headers by distribution name and type
	  var selectedHeaders = _mori2.default.filter(function (header) {
	    return _mori2.default.get(header, 'idx') === 0 || (_mori2.default.hasKey(header, 'headerGroup') && _mori2.default.get(header, 'headerGroup', null) !== null ? _mori2.default.hasKey(distributionNames, _mori2.default.get(header, 'characteristic')) && _mori2.default.hasKey(headerGroups, _mori2.default.get(header, 'headerGroup')) : _mori2.default.hasKey(distributionNames, _mori2.default.get(header, 'characteristic'))) && (!type || type.type === 'default' || type.label === _mori2.default.get(header, 'label'));
	  }, headers);
	
	  // Build the header object required by ag-grid
	  var columnDefs = void 0;
	  var initialColumn = (0, _.buildHeader)(_mori2.default.first(selectedHeaders), linkColumn, linkTarget, linkContext, _mori2.default.first(timeframes), undefined, baseDistribution, mapBaseColumn, selectedHeaders);
	
	  // clusters the timeframe header groups
	  if (trend) {
	    columnDefs = _mori2.default.into(_mori2.default.vector(initialColumn), _mori2.default.map(function (timeframe) {
	      return _mori2.default.hashMap('headerName', _mori2.default.first(timeframe), 'children', _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (header) {
	        return (0, _.buildHeader)(header, linkColumn, linkTarget, linkContext, timeframe, trend, baseDistribution, mapBaseColumn);
	      }, _mori2.default.rest(selectedHeaders))));
	    }, _mori2.default.reverse(timeframes)));
	  } else {
	    var isGrouped = _mori2.default.some(function (header) {
	      return _mori2.default.hasKey(header, 'headerGroup');
	    }, _mori2.default.rest(selectedHeaders));
	    if (!isGrouped) {
	      columnDefs = _mori2.default.into(_mori2.default.vector(initialColumn), _mori2.default.mapcat(function (header) {
	        return _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (timeframe) {
	          return (0, _.buildHeader)(header, linkColumn, linkTarget, linkContext, timeframe, trend, baseDistribution, mapBaseColumn);
	        }, _mori2.default.reverse(timeframes)));
	      }, _mori2.default.rest(selectedHeaders)));
	    } else {
	      var groupedHeaders = [];
	      columnDefs = _mori2.default.into(_mori2.default.vector(initialColumn), _mori2.default.mapcat(function (header) {
	        var headerGroup = _mori2.default.get(header, 'headerGroup');
	        if (!headerGroup) {
	          return _mori2.default.vector((0, _.buildHeader)(header, linkColumn, linkTarget, linkContext, _mori2.default.first(timeframes), trend, baseDistribution, mapBaseColumn));
	        }
	
	        if (groupedHeaders.indexOf(headerGroup) < 0) {
	          groupedHeaders.push(headerGroup);
	          return _mori2.default.vector(_mori2.default.hashMap('headerName', headerGroup, 'children', _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (headerItem) {
	            return (0, _.buildHeader)(headerItem, linkColumn, linkTarget, linkContext, _mori2.default.first(timeframes), trend, baseDistribution, mapBaseColumn, null, headerGroup, _mori2.default.filter(function (item) {
	              return _mori2.default.get(item, 'headerGroup') === headerGroup;
	            }, _mori2.default.rest(selectedHeaders)));
	          }, _mori2.default.filter(function (item) {
	            return _mori2.default.get(item, 'headerGroup') === headerGroup;
	          }, _mori2.default.rest(selectedHeaders))))));
	        }
	      }, _mori2.default.rest(selectedHeaders)));
	    }
	  }
	
	  return columnDefs;
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/getAgColumns.js');
	}();

	;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [getApplicableFootnotes description]
	 * @TODO finish building out this doc
	 * @param  {[type]} footnotes     [description]
	 * @param  {[type]} row           [description]
	 * @param  {[type]} keys          [description]
	 * @param  {[type]} select        [description]
	 * @param  {[type]} timeframe     [description]
	 * @param  {[type]} distributions [description]
	 * @return {[type]}               [description]
	 */
	var _default = function _default(footnotes, row, keys, select, timeframe, distributions) {
	  var footnotesForTimeframe = _mori2.default.reduce(function (acc, curr) {
	    return _mori2.default.hasKey(acc, _mori2.default.first(curr)) ? _mori2.default.conj(acc, _mori2.default.assoc(acc, _mori2.default.first(curr), _mori2.default.reduce(function (acc1, curr1) {
	      return _mori2.default.hasKey(acc1, _mori2.default.first(_mori2.default.first(curr1))) ? _mori2.default.updateIn(acc1, [_mori2.default.first(_mori2.default.first(curr1))], function () {
	        return _mori2.default.flatten(_mori2.default.into(_mori2.default.get(acc1, _mori2.default.first(_mori2.default.first(curr1))), _mori2.default.rest(_mori2.default.first(curr1))));
	      }) : _mori2.default.conj(acc1, curr1);
	    }, _mori2.default.get(acc, _mori2.default.first(curr)), _mori2.default.rest(curr)))) : _mori2.default.conj(acc, curr);
	  }, _mori2.default.get(footnotes, 'any', _mori2.default.hashMap()), _mori2.default.get(footnotes, _mori2.default.first(timeframe), _mori2.default.hashMap()));
	
	  var foundFootnotes = _mori2.default.getIn(footnotesForTimeframe, [_mori2.default.get(row, _mori2.default.first(keys)), _mori2.default.first(select)], _mori2.default.vector());
	
	  if (_mori2.default.some(function (curr) {
	    return _mori2.default.get(curr, 'headerGroup') === _mori2.default.first(select);
	  }, distributions)) {
	    foundFootnotes = _mori2.default.flatten(_mori2.default.conj(foundFootnotes, _mori2.default.getIn(footnotesForTimeframe, [_mori2.default.get(row, _mori2.default.first(keys)), _mori2.default.first(_mori2.default.rest(select))], _mori2.default.vector()), _mori2.default.getIn(footnotesForTimeframe, [_mori2.default.get(row, _mori2.default.first(keys)), _mori2.default.hashMap(_mori2.default.first(select), _mori2.default.first(_mori2.default.rest(select)))], _mori2.default.vector())));
	  }
	
	  return _mori2.default.toJs(foundFootnotes);
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/getApplicableFootnotes.js');
	}();

	;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(11);
	
	var _filters = __webpack_require__(57);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global __webpack_modules__ */
	
	var filterSwitch = null;
	
	if (__webpack_require__.m[/*require.resolve*/(33)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  filterSwitch = (0, _filters2.default)('filterSwitch');
	}
	
	/**
	 * getDataRankings function
	 * @TODO finish building this out
	 * @param  {[type]} api       [description]
	 * @param  {[type]} sortColumn [description]
	 * @param  {[type]} sortHeader [description]
	 * @return {[type]}            [description]
	 */
	
	var _default = function _default(api, sortColumn, sortHeader) {
	  var groupRankArray = [];
	  var wrapupsArray = [];
	  var accountForWrapup = false;
	  var currItem = void 0;
	
	  // Switch to using the event `afterSortChanged`
	  return api.rowModel.rowsToDisplay.map(function (row) {
	    var formatted = filterSwitch(row.data[sortColumn], sortHeader);
	    var isWrapup = _config.appDefault.specialWrapups.indexOf(row.data.Location) >= 0;
	
	    if (!isWrapup) {
	      groupRankArray.push(currItem !== formatted ? 0 : 1);
	      wrapupsArray.push(0);
	    } else {
	      groupRankArray.push(1);
	      wrapupsArray.push(1);
	    }
	
	    var groupRankSubset = groupRankArray.slice(0, row.childIndex + 1);
	
	    var tieRank = groupRankSubset.reduce(function (acc, curr) {
	      return acc + curr;
	    }, 0);
	
	    var tieRankRowAdjust = groupRankSubset.slice(0, groupRankSubset.lastIndexOf(0)).reduce(function (acc, curr) {
	      return acc + curr;
	    }, 0);
	
	    accountForWrapup = accountForWrapup ? true : tieRank === tieRankRowAdjust && wrapupsArray.indexOf(1) > -1;
	
	    var wrapupAdjust = accountForWrapup ? wrapupsArray.slice(0, row.childIndex + 1).reduce(function (acc, curr) {
	      return acc + curr;
	    }, 0) : 0;
	
	    currItem = isWrapup ? currItem : formatted;
	
	    return row.childIndex + 1 - tieRank + tieRankRowAdjust - wrapupAdjust;
	  });
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(filterSwitch, 'filterSwitch', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/getDataRankings.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/getDataRankings.js');
	}();

	;

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = valueGetter;
	function valueGetter(_ref) {
	  var data = _ref.data,
	      colDef = _ref.colDef;
	
	  var _colDef$field$split = colDef.field.split('__'),
	      _colDef$field$split2 = _slicedToArray(_colDef$field$split, 2),
	      group = _colDef$field$split2[0],
	      _colDef$field$split2$ = _colDef$field$split2[1],
	      child = _colDef$field$split2$ === undefined ? false : _colDef$field$split2$;
	
	  return {
	    data: data,
	    group: group,
	    child: child,
	    text: typeof data[colDef.field] !== 'undefined' ? data[colDef.field] : ''
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(valueGetter, 'valueGetter', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/table/valueGetter.js');
	}();

	;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterData = filterData;
	exports.filterDistributions = filterDistributions;
	exports.onAfterFilterChanged = onAfterFilterChanged;
	exports.onAfterSortChanged = onAfterSortChanged;
	exports.getRowHeight = getRowHeight;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _dataFromOptions = __webpack_require__(95);
	
	var _table = __webpack_require__(138);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _util = __webpack_require__(15);
	
	var _util2 = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /** This file handles table data & interactions */
	
	
	// Store for table
	var defaultHeight = '';
	
	var _default = function _default(sheetData, options, filteredData, // Data organized by timeframe
	combinedFilters, readyCb, selectedKeys) {
	  var isMultiGeo = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
	  var reduxCallback = arguments[7];
	  var generalCallback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
	
	  // Hash for seeing changing table data
	  this.tableHash = this.tableHash || false;
	  this.tableInit = this.tableInit || false;
	  // If no table (table init),
	  // or isDirty, lets reload the data... time to PIVOT (but not a real pivot)!
	  var isDirty = isTableDirty.bind(this)(filteredData, combinedFilters);
	  if (this.tableInit === false || isDirty) {
	    // Load the config
	    var _getData = getData(sheetData, options, filteredData, combinedFilters),
	        rowData = _getData.rowData,
	        columnDefs = _getData.columnDefs;
	
	    // Set filter for columnDefs
	    // If not multigeo, setup location filter.
	    // Multigeo filtering is handled by external filtering function
	
	
	    if (!isMultiGeo) {
	      columnDefs[0] = Object.assign({}, {
	        filter: _table.LocationFilter,
	        filterParams: {
	          apply: false,
	          newRowsAction: 'keep'
	        }
	      }, columnDefs[0]);
	    }
	
	    // Check if table has not been initialized using a known prop
	    if (!this.tableInit) {
	      this.tableInit = true;
	      // Table not initialized, so lets resetup
	      Object.assign(this, {}, _table2.default, {
	        rowData: rowData,
	        columnDefs: columnDefs,
	        'datacenterColumnKeys': _mori2.default.toJs(_mori2.default.map(function (item) {
	          return _mori2.default.first(item);
	        }, _mori2.default.filter(function (item) {
	          return item;
	        }, combinedFilters[4]))),
	        'isExternalFilterPresent': function isExternalFilterPresent() {
	          return isMultiGeo;
	        },
	        'forPrint': options.print === 'true',
	        'trend': options.activeTab === 'graph'
	      });
	
	      tableSetup.bind(this)(readyCb);
	    } else {
	      // Is Dirty
	      // If the view has changed we need to reinit column defs as well
	      // Table is already initied;
	      this.api.setRowData(rowData);
	      // @TODO, limit this to only triggger on view
	      // changes between graph/(table || map)
	      this.api.setColumnDefs(columnDefs);
	      // Refreshing
	      this.api.refreshHeader();
	      this.api.refreshView();
	      // Re-set whether this is a trend graph view
	      this.trend = options.activeTab === 'graph';
	    }
	  }
	
	  this.doesExternalFilterPass = doesExternalFilterPass.bind(this)(selectedKeys);
	  if (reduxCallback) {
	    this.reduxCallback = reduxCallback;
	  }
	  if (generalCallback) {
	    generalCallback(this);
	  }
	  return this;
	};
	
	exports.default = _default;
	
	/**
	 * Filter data
	 *
	 * Can either be imported into a file, OR they can be used via `table.X`
	 */
	
	function filterData() {
	  var _this = this;
	
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	  var callback = arguments[1];
	
	  if (!this.api) {
	    return;
	  } else if (data) {
	    this.datacenterColumnKeys.forEach(function (columnKey) {
	      var filter = _this.api.getFilterApi(columnKey);
	
	      var filtered = _mori2.default.intoArray(_mori2.default.flatten(_mori2.default.reduce(function (acc, item) {
	        return _mori2.default.conj(acc, _mori2.default.last(_mori2.default.last(_mori2.default.first(_mori2.default.filter(function (test) {
	          return _mori2.default.first(_mori2.default.first(_mori2.default.first(test))) === columnKey;
	        }, item)))));
	      }, _mori2.default.vector(), data)));
	      // Check that there is actually filtered response
	      if (filtered.length > 0 && filtered[0] !== null) {
	        filter.setModel(filtered);
	      } else {
	        filter.setModel([]);
	      }
	    });
	  }
	  this.api.onFilterChanged();
	  if (callback) {
	    callback();
	  }
	}
	
	/**
	 * Column hiding/showing
	 * Can either be imported into a file, OR they can be used via `table.X`
	 */
	function filterDistributions(distributions, options, timeframes, callback) {
	  if (!this.columnApi) {
	    return;
	  }
	
	  var test = _mori2.default.intoArray(_mori2.default.map(function (item) {
	    return _mori2.default.count(item) === 3 ? _mori2.default.first(item) + '__' + _mori2.default.first(_mori2.default.rest(item)) : _mori2.default.first(item);
	  }, distributions));
	
	  if (options.activeTab === 'graph') {
	    test = test.concat(timeframes.reduce(function (acc, curr) {
	      return acc.concat.apply(acc, _toConsumableArray(test.filter(function (item) {
	        return item !== 'Location';
	      }).map(function (item) {
	        return curr + '__' + item;
	      })));
	    }, []));
	  }
	
	  var columns = [].concat.apply([], (this.columnApi.getAllColumns() || []).map(function (item) {
	    return item.children ? item.children.map(function (child) {
	      return child.colId;
	    }) : item.colId;
	  }));
	
	  var hidden = columns.filter(function (def) {
	    return test.indexOf(def) === -1;
	  });
	
	  var visible = columns.filter(function (def) {
	    return test.indexOf(def) !== -1;
	  });
	
	  if (hidden.indexOf((this.api.getSortModel()[0] || { colId: [] }).colId) > -1) {
	    this.api.setSortModel([{
	      colId: 'Location',
	      sort: 'asc'
	    }]);
	  }
	
	  this.columnApi.setColumnsVisible(hidden, false);
	  this.columnApi.setColumnsVisible(visible, true);
	
	  if (callback) {
	    callback();
	  }
	}
	
	/**
	 * Based on what the user has selected, see if the table rows
	 * contain each column key for the multi-geo table
	 *
	 * This filter is used only for multi-geo tables.
	 * @param  {object}  selectedKeys    the column keys that were selected by
	 *  the user
	 * @return {Function}
	 */
	function doesExternalFilterPass(selectedKeys) {
	  // Build the filter keys based on what's been selected
	  // We default to an '@' as some cell values are null, which causes filtering
	  // to break
	  var filteredKeys = this.datacenterColumnKeys.reduce(function (acc, columnKey) {
	    acc.push({
	      key: columnKey,
	      selected: _mori2.default.intoArray(_mori2.default.flatten(_mori2.default.reduce(function (acc1, item) {
	        return _mori2.default.conj(acc1, _mori2.default.last(_mori2.default.last(_mori2.default.first(_mori2.default.filter(function (test) {
	          return _mori2.default.first(_mori2.default.first(_mori2.default.first(test))) === columnKey;
	        }, item)) || '@')));
	      }, _mori2.default.vector(), selectedKeys)))
	    });
	    return acc;
	  }, []);
	
	  // If nothing's selected, we have no need to filter.
	  var noFiltering = _mori2.default.count(selectedKeys) === 0 ? true : false;
	
	  // The filtering function.
	  return function (node) {
	    if (noFiltering) {
	      return true;
	    }
	    var passes = false;
	    var lastFilterKey = filteredKeys[filteredKeys.length - 1];
	    // For each selected item, see if the following is true:
	    // 1.  The data in the table equals what has been selected
	    // 2.  Or, the selected from the last filter is the '@' character -
	    //     This indicates we want to match on only the first column.
	    filteredKeys[0].selected.forEach(function (selectedItem, index) {
	      if (node.data[filteredKeys[0].key] === selectedItem.split(' (All)')[0] && (node.data[lastFilterKey.key] === lastFilterKey.selected[index] || lastFilterKey.selected[index] === '@')) {
	        passes = true;
	      }
	    });
	    return passes;
	  };
	}
	
	/**
	 * Table Setup
	 * Access the `table` file global directly (it's scoped to this file)
	 */
	function tableSetup(readyCb) {
	  // The initial setup for tableheight is 75% of the window's height
	  defaultHeight = window.innerHeight * 0.75;
	  // Set Iniital Height
	  this.height = defaultHeight;
	
	  // Assign functions for modification
	  this.filterDistributions = filterDistributions.bind(this);
	  this.filterData = filterData.bind(this);
	
	  this.onGridReady = readyCb;
	  this.onAfterFilterChanged = onAfterFilterChanged.bind(this);
	  this.onAfterSortChanged = onAfterSortChanged.bind(this);
	  this.getRowHeight = getRowHeight;
	}
	
	function onAfterFilterChanged() {
	  // We need to reset the width of the body
	  // immediately after filter change so the table renders correctly
	  if (!this.forPrint) {
	    this.api.gridPanel.eBody.style.width = '';
	  }
	
	  var gridPanel = this.api.gridPanel;
	
	  // Given the displayed columns, generate a unique list of header names
	  var displayedHeaderNames = (this.columnApi.getAllDisplayedColumns() || []).reduce(function (acc, column) {
	    if (acc.indexOf(column.colId.split('__')[0]) === -1) {
	      acc.push(column.colId.split('__')[0]);
	    }
	    return acc;
	  }, []);
	
	  this.displayedHeaders = (this.columnApi.getAllDisplayedColumns() || []).reduce(function (acc, column) {
	    if (column.colId.indexOf('__') === -1) {
	      acc.push(column.colDef);
	      return acc;
	    }
	
	    var headerGroup = column.colId.split('__')[0];
	    var headerIndex = displayedHeaderNames.indexOf(headerGroup);
	
	    acc[headerIndex] = acc[headerIndex] || {
	      headerName: headerGroup,
	      children: []
	    };
	    acc[headerIndex].children.push(column.colDef);
	    return acc;
	  }, []);
	
	  // Using the above header names, build a list of headers (and children)
	  // This will allow us to calculate header height on only the visible headers
	  var headerHeight = resizeHeader.bind(this)({
	    columns: this.displayedHeaders,
	    forPrint: this.forPrint
	  });
	
	  if (!this.forPrint) {
	    // Ensure top row is visible post header height adjustment
	    this.api.ensureIndexVisible(0);
	
	    // 20 is added to adjust for possible x-overflow
	    var gridHeight = Math.round(gridPanel.eBodyContainer.getBoundingClientRect().height + headerHeight + 20);
	
	    this.height = gridHeight > defaultHeight ? defaultHeight : gridHeight;
	
	    // @TODO: Hacky.  If it's a short dataset, the y-scroll will appear
	    // likely due to a height calc issue due to borders :-/
	    gridPanel.eBodyViewport.style.overflowY = gridHeight > defaultHeight ? 'auto' : 'hidden';
	
	    setBodySize(this);
	    (0, _util2.calcScrollShadow)(this.height);
	  }
	
	  this.api.refreshRows(this.api.getRenderedNodes());
	}
	
	function onAfterSortChanged() {
	  if (!this.forPrint) {
	    this.api.ensureIndexVisible(0);
	  }
	  if (this.reduxCallback) {
	    var sortModel = this.api.getSortModel()[0];
	    this.reduxCallback({ sortModel: sortModel });
	  }
	  this.api.refreshRows(this.api.getRenderedNodes());
	}
	
	function getRowHeight(params) {
	  var footnoteFontString = 'normal 5px/0 Arial, sans-serif';
	  var fontStyleString = 'bold 13px/20px "Droid Sans", helvetica, sans-serif';
	  var rowDefaultHeight = 20;
	  var height = rowDefaultHeight;
	  var displayedColumns = params.api.columnController.allDisplayedColumns.reduce(function (acc, curr) {
	    return Object.assign(acc, _defineProperty({}, curr.colId, curr.colDef.width));
	  }, {});
	  Object.keys(params.node.data).filter(function (node) {
	    return displayedColumns.hasOwnProperty(node);
	  }).forEach(function (key) {
	    // Get normal width...
	    var width = (0, _util.getEstTextLength)(params.node.data[key], fontStyleString);
	    var string = params.node.data[key];
	    // In english:
	    //  footnoteCallback() & sortMobel() are both existing
	    //  current key is a geo (location/state)
	    //  sorted row is not geo (so geo is then ranked)
	    if (params.api.footnoteCallback && params.api.getSortModel && (key === 'Location' || key === 'State') && (params.api.getSortModel()[0] || { colId: null }).colId !== key) {
	      string = '1. ' + string;
	      width = (0, _util.getEstTextLength)(string, fontStyleString);
	    }
	
	    // Get footnotes
	    if (params.api.footnoteCallback) {
	      var footnotes = params.api.footnoteCallback([params.node.data[key], key]).map(function (_ref) {
	        var label = _ref.label;
	        return ' ' + label;
	      }).join(' ');
	      // 6 is a a magic number for the `/s` char
	      width = width + (0, _util.getEstTextLength)(footnotes, footnoteFontString) + 6;
	      string = string + ' ' + footnotes;
	    }
	
	    // For the edge case where there is a fraction of a pixel difference
	    // we want to see if the width difference is less than 1, not 0.
	    if (displayedColumns[key] - width < 1) {
	      // Lets actually calculate the height in this case so we know it will work fine.
	      var heightMultiplier = (0, _util.getEstTextRows)(string, fontStyleString, displayedColumns[key]);
	      height = Math.max(rowDefaultHeight * heightMultiplier, height);
	    }
	  });
	  return height + 10; // add padding
	}
	
	/**
	 * Set body size contain when needed based on visible columns
	 *
	 * @param  {array}  displayedColumns    Array of columns currently displayed in the table
	 */
	function setBodySize(table) {
	  // Container width needs to be set.
	  // Body width should only be set if it is more narrow
	  // than the overall table wrapper.
	  var displayedColumns = table.columnApi.getAllDisplayedColumns();
	  var containerWidth = _mori2.default.intoArray(_mori2.default.rest(displayedColumns)).reduce(function (acc, curr) {
	    return acc + curr.colDef.width;
	  }, 0);
	  var bodyWidth = displayedColumns[0].colDef.width + containerWidth;
	
	  table.api.gridPanel.eBodyContainer.style.width = containerWidth + 'px';
	
	  // We need to reset the width in order for headers and table
	  // to display correctly.
	  if (bodyWidth < document.querySelector('.table-wrapper').clientWidth) {
	    table.api.gridPanel.eBody.style.width = bodyWidth + 18 + 'px';
	  }
	}
	
	/**
	 * Resize Header
	 */
	function resizeHeader(params) {
	  var parentElm = this.api.gridCore.eGridDiv.offsetParent;
	
	  // If there are no 'with-group' headers, but we have 'no-group' headers,
	  // we need to adjust the parentHeight below
	  var adjustParentHeight = !!!parentElm.querySelector('.ag-header-group-cell-with-group') && !!parentElm.querySelector('.ag-header-group-cell-no-group');
	  // Used to adjust parentHeight.  If our header container has more than
	  // 1 row, we're grouping headers.
	  var hasGroupedHeader = parentElm.querySelector('.ag-header-container').querySelectorAll('.ag-header-row').length > 1;
	  var fontStyleString = this.headerStyle ? this.headerStyle : 'bold 14px/20px "Droid Sans", helvetica, sans-serif';
	  var baseHeaderHeight = 20;
	  var heightAdjust = 10; // Adjustment for after height is calculated
	  var padding = 30;
	
	  var _reduce = (params.columns || []).reduce(function (_ref2, column) {
	    var header = _ref2.header,
	        parent = _ref2.parent;
	
	    if (column.children) {
	      // After header height calculation for parent/grouped row
	      var _heightMultiplier = (0, _util.getEstTextRows)(column.headerName, fontStyleString, column.children.reduce(function (acc, _ref3) {
	        var width = _ref3.width;
	        return acc + width;
	      }, 0) - 16);
	      var groupHeight = Math.max(parent, baseHeaderHeight * _heightMultiplier);
	      return {
	        // For each child, find the largest height for the header
	        header: column.children.reduce(function (acc, child) {
	          var childHeightMultiplier = (0, _util.getEstTextRows)(child.headerName, fontStyleString, child.width - padding);
	
	          return Math.max(acc, baseHeaderHeight * childHeightMultiplier);
	        }, header),
	        parent: groupHeight
	      };
	    }
	    // Else
	    var heightMultiplier = (0, _util.getEstTextRows)(column.headerName, fontStyleString, column.width - padding);
	    return {
	      header: Math.max(header, baseHeaderHeight * heightMultiplier),
	      parent: parent
	    };
	  }, { header: baseHeaderHeight, parent: 0 }),
	      headerHeight = _reduce.header,
	      parentHeight = _reduce.parent;
	
	  headerHeight += heightAdjust;
	
	  parentHeight = parentHeight !== 0 && parentHeight < baseHeaderHeight ? baseHeaderHeight + heightAdjust : parentHeight + (parentHeight !== 0 ? heightAdjust : 0);
	
	  // Sets value for parent height.  Used in maps tab where headers can
	  // get very tall if parentHeight is kept at 0.
	  parentHeight = adjustParentHeight && hasGroupedHeader ? baseHeaderHeight : parentHeight;
	
	  this.api.setHeaderHeight(parentHeight !== 0 ? (parentHeight + headerHeight) / 2 : headerHeight);
	
	  // If there is a parent height, we need to adjust node heights
	  // as AG-Grid does not handle this for us.
	  if (parentHeight !== 0) {
	    // Set parent height on first header row
	    [].forEach.call(parentElm.querySelectorAll('.ag-header-row:first-child'), function (row) {
	      return row.style.height = parentHeight + 'px';
	    });
	    // Set height and top on 2nd row below parent row
	    [].forEach.call(parentElm.querySelectorAll('.ag-header-row:last-child'), function (row) {
	      row.style.height = headerHeight + 'px';
	      row.style.top = parentHeight + 'px';
	
	      // If we are printing, we need to set height on
	      // All cells in the last row when there is a parent row.
	      if (params.forPrint) {
	        [].forEach.call(row.querySelectorAll('.ag-header-cell'), function (cell) {
	          return cell.style.height = headerHeight + 'px';
	        });
	      }
	    });
	
	    if (params.forPrint) {
	      [].forEach.call(parentElm.querySelectorAll('.ag-header-group-cell-with-group'), function (groupHeader) {
	        return groupHeader.style.height = parentHeight + 'px';
	      });
	    }
	  }
	
	  return parentHeight + headerHeight;
	}
	
	/**
	 * Get and set the table data
	 */
	function getData(sheetData, options, filteredData, combinedFilters) {
	  var data = _mori2.default.toJs(_dataFromOptions.buildTable.apply(undefined, [sheetData, options, filteredData].concat(_toConsumableArray(combinedFilters))));
	
	  return {
	    'rowData': data.tableData.rowData,
	    'columnDefs': data.tableData.columnDefs
	  };
	}
	
	/**
	 * See if the table actually needs to be rebuilt, uses the tablehash var
	 * 1. Change of timeframe
	 * 2. Change of datatype
	 * 3. Change of Tab (Timeframe's changing signal this due to length)
	 *   a. Table/Map -> Graph
	 *   b. Graph -> Table/Map
	 * @param  {string}  view    the current tab view ('graph', 'map', 'table')
	 * @param  {object}  filters the combined filters
	 * @return {Boolean}
	 */
	function isTableDirty(timeframes, filters) {
	  var tempHash = _mori2.default.hash(_mori2.default.into(_mori2.default.vector(filters[0]), _mori2.default.into(_mori2.default.vector(filters[3]), _mori2.default.reduce(function (acc, item) {
	    return _mori2.default.conj(acc, _mori2.default.first(item));
	  }, _mori2.default.vector(), timeframes))));
	
	  if (this.tableHash && this.tableHash === tempHash) {
	    return false;
	  }
	  this.tableHash = tempHash;
	  return true;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(defaultHeight, 'defaultHeight', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(filterData, 'filterData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(filterDistributions, 'filterDistributions', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(doesExternalFilterPass, 'doesExternalFilterPass', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(tableSetup, 'tableSetup', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(onAfterFilterChanged, 'onAfterFilterChanged', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(onAfterSortChanged, 'onAfterSortChanged', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(getRowHeight, 'getRowHeight', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(setBodySize, 'setBodySize', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(resizeHeader, 'resizeHeader', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(getData, 'getData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(isTableDirty, 'isTableDirty', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/tableData.js');
	}();

	;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A transducer that creates the timeframe list
	 * @param {array} sheets - The flat gdocs json data
	 * @return {array} An array of timeframes
	 */
	var _default = function _default(sheets) {
	  return _mori2.default.intoArray(_mori2.default.transduce(_mori2.default.comp(
	  // exclude config sheets
	  _mori2.default.filter(function (x) {
	    return _config.sheetParseConfig.configTitles.indexOf(x[0].toLowerCase()) === -1;
	  }), _mori2.default.map(function (x) {
	    return x[0];
	  })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), sheets));
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/timeframeFilters.js');
	}();

	;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHeaderDataTypes = getHeaderDataTypes;
	exports.getHeadersOnly = getHeadersOnly;
	exports.getHeaderTypeObject = getHeaderTypeObject;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A reducer that unfolds the default datatypes map so we can look up
	 * all possible types and their parent.
	 * @param {object} defaultDatatypes - An object containing parent type keys
	 *  and arrays of input options
	 * @return {array} An array of tuples containing child and parent
	 */
	function getHeaderDataTypes(defaultDatatypes) {
	  return _mori2.default.intoArray(_mori2.default.transduce(_mori2.default.mapcat(function (x) {
	    if (_mori2.default.first(_mori2.default.rest(x))) {
	      return _mori2.default.intoArray(_mori2.default.transduce(_mori2.default.map(function (y) {
	        return [y, _mori2.default.first(x)];
	      }), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector([_mori2.default.first(x), _mori2.default.first(x)]), // start with the parent
	      _mori2.default.first(_mori2.default.rest(x))));
	    }
	    return [[_mori2.default.first(x), _mori2.default.first(x)]];
	  }), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), _mori2.default.toClj(defaultDatatypes)));
	}
	
	/**
	 * A transducer that slices the header rows from the given datasheet
	 * @param {array} sheet - A datasheet from the gdoc
	 * @return {array} An array of only header rows
	 */
	/* eslint no-loop-func: 1 */
	function getHeadersOnly(sheet) {
	  return _mori2.default.intoArray(_mori2.default.takeWhile(function (x) {
	    return !x[0] || x[0].toLowerCase() === 'location';
	  }, sheet));
	}
	
	function getHeaderTypeObject(type, types) {
	  if (!type) {
	    return false;
	  }
	
	  var typeSplit = type.split('--');
	  var typeValue = typeSplit.length === 2 && ['narrow', 'wide'].indexOf(typeSplit[1].toLowerCase()) > -1 ? typeSplit[0] : type;
	  var mappedType = types.filter(function (x) {
	    return x[0] === typeValue.toLowerCase();
	  }).shift();
	
	  if (mappedType) {
	    return {
	      type: mappedType[1],
	      label: typeValue,
	      width: (typeSplit[1] || '').toLowerCase()
	    };
	  }
	
	  return false;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getHeaderDataTypes, 'getHeaderDataTypes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducerUtils/headerUtils.js');
	
	  __REACT_HOT_LOADER__.register(getHeadersOnly, 'getHeadersOnly', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducerUtils/headerUtils.js');
	
	  __REACT_HOT_LOADER__.register(getHeaderTypeObject, 'getHeaderTypeObject', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducerUtils/headerUtils.js');
	}();

	;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Tests whether the given row is a datatype row, by testing against possible
	 * datatypes.
	 * @param {array} row - An array of cell values for the row
	 * @param {array} types - The expanded list of datatype tuples
	 * @return {bool} Whether this is a datatype row or not
	 */
	var _default = function _default(row, types) {
	  if (!types) {
	    return false;
	  }
	  return _mori2.default.every(function (x) {
	    var tempX = (x || '').split('--');
	    var rowValue = tempX.length === 2 && ['narrow', 'wide'].indexOf(tempX[1].toLowerCase()) > -1 ? tempX[0] : x;
	    return rowValue === null || _mori2.default.some(function (type) {
	      return _mori2.default.first(type) === rowValue.toLowerCase();
	    }, types) || /^Date-/.test(rowValue);
	  }, _mori2.default.rest(row));
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/transducerUtils/isDatatypeRow.js');
	}();

	;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d = __webpack_require__(23);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _rows = __webpack_require__(268);
	
	var _rows2 = _interopRequireDefault(_rows);
	
	var _util = __webpack_require__(269);
	
	var util = _interopRequireWildcard(_util);
	
	var _legend = __webpack_require__(242);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Function which builds the d3 legend
	 * @param  {string} selector  dom element which should contain the svg
	 * @param  {array} data       array of data objects to setup legend
	 * @param  {object} options   sepecific option types
	 * @return {null}
	 *
	 */
	// This is a custom legend for KFF Datacenter
	
	var _default = function _default(selector, data) {
	  var inputOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  // Setup default options and information needed for the build
	  var options = Object.assign({}, _legend.legendOptions, inputOptions);
	
	  options.availableWidth = options.width - options.margin.left - options.margin.right;
	
	  options.columnWidth = Math.floor(options.availableWidth / options.maxSplit);
	
	  // Initialize the legend
	  init(selector, util.buildData(data, options), options);
	};
	
	exports.default = _default;
	
	
	function init(selector, data, options) {
	  if (!options.isMap) {
	    _d2.default.select(selector).select(options.wrapper).remove();
	  } else {
	    _d2.default.select(selector).select('g.datamaps-legend').remove();
	  }
	
	  var container = _d2.default.select(selector).append(options.wrapper).classed('datamaps-legend', function () {
	    return options.isMap;
	  }).attr('width', options.width).attr('transform', 'translate(' + options.left + ', ' + options.top + ')');
	
	  var legend = container.selectAll('g.legend').data(data);
	
	  var legendEnter = legend.enter().append('g').classed('legend', true).attr('transform', 'translate(' + options.margin.right + ', ' + options.margin.top + ')');
	
	  // draw distribution selections for linechart
	  if (!options.isMap) {
	    (0, _rows2.default)(legendEnter, options, true);
	  }
	
	  // draw both base column selections
	  (0, _rows2.default)(legendEnter, options);
	
	  util.wrapText(legendEnter.selectAll('text'), options.columnWidth - 30, options);
	
	  util.heightizer(legendEnter, options);
	
	  container.attr('height', legend.node().getBBox().height + options.margin.top + options.margin.bottom);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(init, 'init', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/d3.legend/d3.legend.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/d3.legend/d3.legend.js');
	}();

	;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d = __webpack_require__(23);
	
	var _d2 = _interopRequireDefault(_d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = function _default(rowEnter, options) {
	  var isDistribution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var item = rowEnter.selectAll('.legend-item').data(function (d) {
	    return d;
	  });
	
	  var itemEnter = item.enter().append('g').classed('legend-item', true).attr('transform', function (d, i) {
	    var x = i % 4 * options.columnWidth;
	    return 'translate(' + x + ',0)';
	  });
	
	  var itemText = itemEnter.append('text').classed({
	    'legend-text': true,
	    'legend-text-distribution': isDistribution
	  }).attr('fill', '#000').attr('transform', 'translate(' + options.textPadding.left + ', ' + options.textPadding.top + ')').style(options.font);
	
	  itemEnter.append('g').classed({
	    'legend-symbol': true,
	    'legend-symbol-distribution': isDistribution
	  }).attr('height', 30).attr('width', 30).style({
	    'stroke-width': 0
	  });
	
	  var itemSymbol = itemEnter.select('.legend-symbol');
	
	  if (isDistribution) {
	    itemText.text(function (d) {
	      return d.characteristic;
	    });
	
	    itemSymbol.append('path').classed('distributions-symbol', true).attr('transform', 'translate(10, 11)').attr('d', _d2.default.svg.symbol().type(function (d) {
	      return d.shape;
	    }).size(15)).attr('fill', '#fff').attr('stroke', '#000').style({
	      'stroke-width': 2
	    });
	  } else {
	    itemText.text(function (d) {
	      return d.state || d.name;
	    });
	
	    itemSymbol.append('rect').classed('legend-symbol-bg', true).attr('height', 20).attr('width', 20).attr('transform', 'translate(3,3)').style({
	      'stroke-width': 0,
	      'fill': '#e7e7e7'
	    });
	
	    itemSymbol.append('rect').classed('legend-symbol', true).attr('height', 20).attr('width', 20).attr('transform', 'translate(0,0)').style({
	      'fill': function fill(d) {
	        return d.color;
	      },
	      'stroke-width': 0
	    });
	  }
	
	  item.exit();
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/d3.legend/items.js');
	}();

	;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _items = __webpack_require__(267);
	
	var _items2 = _interopRequireDefault(_items);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Builds out the rows for the legend */
	var _default = function _default(legendEnter, options) {
	  var isDistribution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var row = legendEnter.selectAll(isDistribution ? '.legend-row.legend-row-distribution' : '.legend-row.legend-row-item').data(function (d) {
	    return isDistribution ? d.distributions : d.states;
	  });
	
	  var rowEnter = row.enter().append('g').classed({
	    'legend-row': true,
	    'legend-row-item': !isDistribution,
	    'legend-row-distribution': isDistribution
	  });
	
	  (0, _items2.default)(rowEnter, options, isDistribution);
	  row.exit();
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/d3.legend/rows.js');
	}();

	;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.heightizer = heightizer;
	exports.wrapText = wrapText;
	exports.buildData = buildData;
	
	var _d = __webpack_require__(23);
	
	var _d2 = _interopRequireDefault(_d);
	
	var _geoSort = __webpack_require__(156);
	
	var _geoSort2 = _interopRequireDefault(_geoSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	 * Set proper heights so spacing works
	 */
	function heightizer(container, options) {
	  var siblingAdjustment = 0;
	  var legendRows = container.selectAll('g.legend-row');
	  legendRows.each(function (d, idx) {
	    var actingRow = _d2.default.select(this);
	    actingRow.attr('transform', 'translate(0, ' + (idx !== 0 ? siblingAdjustment : 0) + ')');
	
	    var legendItems = actingRow.selectAll('g.legend-item');
	    legendItems.each(function () {
	      var actingItem = _d2.default.select(this);
	      var childSiblingAdjustment = options.rowSpacing;
	      childSiblingAdjustment += actingItem.select('.legend-text').node().getBBox().height;
	    });
	
	    siblingAdjustment += actingRow.node().getBBox().height + options.rowSpacing;
	  });
	}
	
	function wrapText(texts, width, options) {
	  texts.each(function () {
	    var text = _d2.default.select(this);
	    // check if we even need to do wrapping
	    if (text.node().getComputedTextLength() > width) {
	      var words = text.text().split(/\s+/);
	      var line = [];
	      var lineHeight = 1.1; // ems
	      var y = text.attr('y');
	      var dy = parseFloat(text.attr('dy')) || 0;
	      var tspan = text.text(null).append('tspan').attr('x', 0).attr('y', y).attr('dy', dy + 'em');
	
	      words.forEach(function (word) {
	        line.push(word);
	        tspan.text(line.join(' '));
	        if (tspan.node().getComputedTextLength() > width) {
	          text.attr('transform', 'translate(' + options.textPadding.left + ', ' + options.textPadding.top + ')');
	          line.pop();
	          tspan.text(line.join(' '));
	          line = [word];
	          tspan = text.append('tspan').attr('x', 0).attr('y', y).attr('dy', lineHeight + dy + 'em').text(word);
	        }
	      });
	    }
	  });
	}
	
	/**
	 * Sorts the data and transforms it into:
	
	 * [
	 *   {
	 *     'states': [
	 *       {
	 *         'state': 'Texas'
	 *         'color': '#e7e7e7',
	 *       },
	 *       {..},
	 *       {..},
	 *     ]
	 *   }, {
	 *     'characteristic': [
	 *       {
	 *         'characteristic': 'Average GDP',
	 *         'shape': 'circle',
	 *       },
	 *       {..},
	 *       {..},
	 *     ]
	 *   }
	 * ]
	 *
	 * *****************************
	 * ** OR if generating for a map legend **
	 * *****************************
	 *
	 * [
	 *   {
	 *     'states': [
	 *       {
	 *         'state': 'Texas'
	 *         'color': '#e7e7e7',
	 *         'characteristics': [
	 *           {
	 *             'characteristic': 'Average GDP',
	 *             'shape': 'circle',
	 *             'color': '#e7e7e7',
	 *           },
	 *           {..},
	 *           {..},
	 *         ],
	 *       },
	 *       {..},
	 *       {..},
	 *     ]
	 *   }
	 * ]
	*/
	function buildData(data, options) {
	  if (options.isMap) {
	    return [{ 'states': _splitData(data, options.maxSplit) }];
	  }
	
	  var distributionsMap = data.reduce(function (acc, item) {
	    return angular.extend({}, acc, _defineProperty({}, item.characteristic, item.shape));
	  }, {});
	  var statesMap = data.reduce(function (acc, item) {
	    return angular.extend({}, acc, _defineProperty({}, item.state, item.color));
	  }, {});
	
	  var states = Object.keys(statesMap).map(function (val) {
	    return {
	      state: val,
	      color: statesMap[val]
	    };
	  }).sort(function (a, b) {
	    return (0, _geoSort2.default)(a.state, b.state, {
	      // Default header for geos...
	      characteristic: 'Location',
	      type: 'geography',
	      'label': 'Geography',
	      idx: 0
	    }, false, a.state, b.state);
	  });
	
	  var distributions = Object.keys(distributionsMap).map(function (val) {
	    return {
	      characteristic: val,
	      shape: distributionsMap[val]
	    };
	  });
	
	  return [{
	    states: _splitData(states, options.maxSplit),
	    distributions: _splitData(distributions, options.maxSplit)
	  }];
	}
	
	/* Converts Array into 2d array
	 * w/ split = 2...
	 * [1,2,3,4,5]
	 * to
	 * [[1,2],[3,4],[5]]
	 */
	function _splitData(data) {
	  var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var newArray = [];
	  for (var i = 0; i < data.length; i += split) {
	    newArray.push(data.slice(i, i + split));
	  }
	  return newArray;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(heightizer, 'heightizer', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/d3.legend/util.js');
	
	  __REACT_HOT_LOADER__.register(wrapText, 'wrapText', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/d3.legend/util.js');
	
	  __REACT_HOT_LOADER__.register(buildData, 'buildData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/d3.legend/util.js');
	
	  __REACT_HOT_LOADER__.register(_splitData, '_splitData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/d3.legend/util.js');
	}();

	;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _geoSort = __webpack_require__(156);
	
	var _geoSort2 = _interopRequireDefault(_geoSort);
	
	var _textSort = __webpack_require__(273);
	
	var _textSort2 = _interopRequireDefault(_textSort);
	
	var _numberSort = __webpack_require__(272);
	
	var _numberSort2 = _interopRequireDefault(_numberSort);
	
	var _mixedSort = __webpack_require__(157);
	
	var _mixedSort2 = _interopRequireDefault(_mixedSort);
	
	var _dateSort = __webpack_require__(271);
	
	var _dateSort2 = _interopRequireDefault(_dateSort);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = function _default(a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary) {
	  // console.log({
	  //   a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary
	  // });
	  switch (header.type) {
	    case 'geography':
	      return (0, _geoSort2.default)(a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary);
	    case 'number':
	    case 'percent':
	    case 'currency':
	      return (0, _numberSort2.default)(a, b, header, isInverted, aBase, bBase);
	    case 'text':
	      return (0, _textSort2.default)(a, b, header, isInverted, aBase, bBase, aIsSummary, bIsSummary);
	    case 'date-format':
	      return (0, _dateSort2.default)(a, b, header, isInverted);
	    default:
	      return (0, _mixedSort2.default)(a, b, header, isInverted, aBase, bBase);
	  }
	}; /* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/sorters.js');
	}();

	;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = dateSort;
	
	var _util = __webpack_require__(59);
	
	var _config = __webpack_require__(11);
	
	/* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	function dateSort(a, b, column, isInverted) {
	  var aVal = Date.parse(a);
	  var bVal = Date.parse(b);
	  var aNotAvailable = _config.appDefault.dataNotAvailable.indexOf(a) !== -1;
	  var bNotAvailable = _config.appDefault.dataNotAvailable.indexOf(b) !== -1;
	  var aInvalid = isNaN(aVal) || aNotAvailable;
	  var bInvalid = isNaN(bVal) || bNotAvailable;
	  var aProps = (0, _util.buildRowProperties)(a, column, _config.appDefault);
	  var bProps = (0, _util.buildRowProperties)(b, column, _config.appDefault);
	
	  // NAs pushed to the bottom
	  if (aProps.naData && bProps.naData) {
	    var sorted = (0, _util.sortArbitrary)(aProps.value, bProps.value, _config.appDefault.dataNotAvailable, isInverted);
	    if (sorted) {
	      return sorted;
	    }
	  } else if (aProps.naData) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.naData) {
	    return isInverted ? 1 : -1;
	  }
	
	  if (aInvalid && bInvalid) {
	    return (isInverted ? 1 : -1) * a.localeCompare(b);
	  } else if (aInvalid) {
	    return (isInverted ? -1 : 1) * 1;
	  } else if (bInvalid) {
	    return (isInverted ? -1 : 1) * -1;
	  }
	
	  return isInverted ? aVal - bVal : bVal - aVal;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(dateSort, 'dateSort', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/sorters/dateSort.js');
	}();

	;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = numberSort;
	
	var _util = __webpack_require__(15);
	
	var _util2 = __webpack_require__(59);
	
	var _config = __webpack_require__(11);
	
	function numberSort(a, b, column, isInverted, aBase, bBase) {
	  var aNumber = (0, _util.kffNumericValue)(a);
	  var bNumber = (0, _util.kffNumericValue)(b);
	  var aNotAvailable = _config.appDefault.dataNotAvailable.indexOf(a) !== -1;
	  var bNotAvailable = _config.appDefault.dataNotAvailable.indexOf(b) !== -1;
	  // KFF-2244 If we do not check for null, +null will equal 0 lower
	  // lower in the function, causing an improper sort
	  var aInvalid = isNaN(aNumber) || aNumber === null || aNotAvailable;
	  var bInvalid = isNaN(bNumber) || bNumber === null || bNotAvailable;
	  var aProps = (0, _util2.buildRowProperties)(a, column, _config.appDefault);
	  var bProps = (0, _util2.buildRowProperties)(b, column, _config.appDefault);
	
	  // NAs pushed to the bottom
	  if (aProps.naData && bProps.naData) {
	    var sorted = (0, _util2.sortArbitrary)(aProps.value, bProps.value, _config.appDefault.dataNotAvailable, isInverted);
	    if (sorted) {
	      return sorted;
	    }
	  } else if (aProps.naData) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.naData) {
	    return isInverted ? 1 : -1;
	  }
	
	  if (aInvalid && bInvalid) {
	    return (isInverted ? 1 : -1) * a.localeCompare(b);
	  } else if (aInvalid) {
	    return (isInverted ? -1 : 1) * 1;
	  } else if (bInvalid) {
	    return (isInverted ? -1 : 1) * -1;
	  }
	
	  if (!(0, _util.kffIsNumber)(a) && /<|>/g.test(a) && aNumber === bNumber) {
	    aNumber = />/g.test(a) ? ++aNumber : aNumber;
	    aNumber = /</g.test(a) ? --aNumber : aNumber;
	  } else if (!(0, _util.kffIsNumber)(b) && /<|>/g.test(b) && bNumber === aNumber) {
	    bNumber = />/g.test(b) ? ++bNumber : bNumber;
	    bNumber = /</g.test(b) ? --bNumber : bNumber;
	  }
	
	  if (+aNumber === +bNumber) {
	    return (isInverted ? -1 : 1) * aBase.localeCompare(bBase);
	  }
	
	  return +aNumber - +bNumber;
	} /* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(numberSort, 'numberSort', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/sorters/numberSort.js');
	}();

	;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = textSorter;
	
	var _util = __webpack_require__(59);
	
	var _mixedSort = __webpack_require__(157);
	
	var _mixedSort2 = _interopRequireDefault(_mixedSort);
	
	var _config = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function textSorter(a, b, column, isInverted, aBase, bBase, aIsSummary, bIsSummary) {
	  var aProps = (0, _util.buildRowProperties)(a, column, _config.appDefault);
	  var bProps = (0, _util.buildRowProperties)(b, column, _config.appDefault);
	
	  // NAs pushed to the bottom
	  if (aProps.naData && bProps.naData) {
	    var sorted = (0, _util.sortArbitrary)(aProps.value, bProps.value, _config.appDefault.dataNotAvailable, isInverted);
	    if (sorted) {
	      return sorted;
	    }
	  } else if (aProps.naData) {
	    return isInverted ? -1 : 1;
	  } else if (bProps.naData) {
	    return isInverted ? 1 : -1;
	  }
	
	  if (!a.localeCompare || !b.localeCompare || a === b) {
	    return (0, _mixedSort2.default)(a, b, column, isInverted, aBase, bBase);
	  }
	
	  // Summary rows float up without matching groups
	  if (a === b && aIsSummary) {
	    return (isInverted ? -1 : 1) * -1;
	  } else if (a === b && bIsSummary) {
	    return (isInverted ? 1 : -1) * -1;
	  } else if (a === b) {
	    return a.localeCompare(b);
	  }
	
	  // Umm, and if there is an arbitrary display order, sort that way
	  if ((column.sortOrder || []).length) {
	    var _sorted = (0, _util.sortArbitrary)(a, b, column.sortOrder);
	    if (_sorted) {
	      return (isInverted ? -1 : 1) * _sorted;
	    }
	  }
	
	  if (a === b && aBase !== undefined && bBase !== undefined) {
	    return aBase.localeCompare(bBase);
	  }
	
	  return a.localeCompare(b);
	} /* eslint id-length: [2, {"exceptions":["a","b"]}] */
	
	/**
	 * Text columns are easy, just push N/A data to the bottom
	 */
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(textSorter, 'textSorter', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/util/sorters/textSort.js');
	}();

	;

/***/ }),
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buildSpreadsheetData = buildSpreadsheetData;
	
	var _constants = __webpack_require__(243);
	
	var types = _interopRequireWildcard(_constants);
	
	var _config = __webpack_require__(11);
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _transducers = __webpack_require__(153);
	
	var _columnFilters = __webpack_require__(246);
	
	var _columnFilters2 = _interopRequireDefault(_columnFilters);
	
	var _timeframeFilters = __webpack_require__(263);
	
	var _timeframeFilters2 = _interopRequireDefault(_timeframeFilters);
	
	var _dataviewFilters = __webpack_require__(247);
	
	var _dataviewFilters2 = _interopRequireDefault(_dataviewFilters);
	
	var _distributionFilters = __webpack_require__(140);
	
	var _distributionFilters2 = _interopRequireDefault(_distributionFilters);
	
	var _countyReducer = __webpack_require__(245);
	
	var _countyReducer2 = _interopRequireDefault(_countyReducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	// Set up an initial state to hold data. Use count to assign ids so we can
	// remove items from the collection
	var initialState = {
	  items: [],
	  count: 0
	}; /**
	    * Reducers update a specific prop in the application state, by operating
	    * after the action which describes what to change.
	    * To add a new action, add it to the switch statement in the dataReducer function
	    *
	    * @example
	    * case NEW_ACTION_CONSTANT:
	    *   return assign({}, state, {
	    *     stateVariable: action.var,
	    *   });
	    *
	    * To add a new reducer, add another file like this to the reducers folder, and
	    * add it in rootReducer.js.
	    */
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    // Assign the next id and add the item to data collection
	    case types.BUILD_DATA:
	      return buildSpreadsheetData(action.data.data, action.data.options);
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	function buildSpreadsheetData(data, options) {
	  if (data.geoDefinitions) {
	    return (0, _countyReducer2.default)(data);
	  }
	
	  var config = (0, _transducers.getConfig)(data);
	  var timeframes = (0, _timeframeFilters2.default)(data);
	
	  var _buildHeaders = (0, _transducers.buildHeaders)(data, config),
	      immutableHeaders = _buildHeaders.immutableHeaders,
	      hasDataviews = _buildHeaders.hasDataviews;
	
	  var immutableDataviews = (0, _dataviewFilters2.default)(immutableHeaders, config);
	  var immutableData = buildData(data, immutableHeaders);
	
	  config = _mori2.default.assocIn(config, ['settings', 'globalSettings', 'hasDataviews'], hasDataviews);
	  if (timeframes.length < 2) {
	    config = _mori2.default.assocIn(config, ['globalRules', 'Graph'], false);
	  }
	
	  var immutableDistributions = (0, _distributionFilters2.default)(immutableHeaders);
	  return {
	    config: config,
	    immutableHeaders: immutableHeaders,
	    immutableData: immutableData,
	    immutableDataviews: immutableDataviews,
	    immutableDistributions: immutableDistributions,
	    // vanilla js objects for template binding
	    columns: (0, _columnFilters2.default)(data, config, options),
	    timeframes: timeframes,
	    globalRules: _mori2.default.toJs(_mori2.default.get(config, 'globalRules', _mori2.default.hashMap())),
	    globalSettings: _mori2.default.toJs(_mori2.default.getIn(config, ['settings', 'globalSettings'], _mori2.default.hashMap())),
	    distributionCount: _mori2.default.count(immutableDistributions)
	  };
	}
	
	/**
	 * ***************
	 * Sheets are transduced into an arrays of objects with complex keys
	 * so it's easier to filter by dataview and type
	 * @example
	 * [ 'js#{ "Location" "geography" }': 'Alaska', 'js#{ "Marketplace Type" "text"}': 'State' ]
	 * ***************
	 */
	function buildData(data, headers) {
	  // a set of header tuples to use as data keys
	  var headerMap = _mori2.default.mapcat(function (header) {
	    return _mori2.default.vector(_mori2.default.set(_mori2.default.get(header, 'headerGroup') === null ? [_mori2.default.get(header, 'characteristic'), _mori2.default.get(header, 'label')] : [_mori2.default.get(header, 'headerGroup'), _mori2.default.get(header, 'characteristic'),
	    // If label and char. are the same (ie. years - make the label unique)
	    // Label/Char will be same if Doc uses only Year values (2016, etc.)
	    // TODO: find a better way to handle this
	    _mori2.default.get(header, 'label') === _mori2.default.get(header, 'characteristic') ? '_' + _mori2.default.get(header, 'label') : _mori2.default.get(header, 'label')]));
	  }, headers);
	  return _mori2.default.into(_mori2.default.vector(), _mori2.default.map(function (sheet) {
	    return _mori2.default.set([_mori2.default.first(sheet), _mori2.default.map(function (row) {
	      return _mori2.default.zipmap(headerMap,
	      // Pass through everything except cell values that are explicitly
	      // ints or floats. Everything else should be kept as a string.
	      _mori2.default.map(function (x) {
	        return (/^(-)?[\d]+(\.[\d]+)?[\s+]?$/.test(x) ? parseFloat(x) : x
	        );
	      }, row));
	    }, _mori2.default.dropWhile(function (x) {
	      return !_mori2.default.first(x);
	    }, _mori2.default.first(_mori2.default.rest(sheet))))]);
	  },
	  // remove config sheet
	  _mori2.default.filter(function (x) {
	    return _config.sheetParseConfig.configTitles.indexOf(x[0].toLowerCase()) === -1;
	  }, data)));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/dataReducer.js');
	
	  __REACT_HOT_LOADER__.register(buildSpreadsheetData, 'buildSpreadsheetData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/dataReducer.js');
	
	  __REACT_HOT_LOADER__.register(buildData, 'buildData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/dataReducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/reducers/dataReducer.js');
	}();

	;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.filterByTimeframe = filterByTimeframe;
	exports.buildTable = buildTable;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _table = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [filterByTimeframe description]
	 * @TODO build out doc
	 * @param  {[type]} data    [description]
	 * @param  {[type]} options [description]
	 * @return {[type]}         [description]
	 */
	/* eslint id-length: [2, {"exceptions":["a","b"]}] */
	function filterByTimeframe(data, options) {
	  // Get the list of selected timeframes by name
	  // @TODO logic for selecting by timeframe gets a little weird for defaults
	  // and range vs single, could refactor this
	  var activeTimeframe = +(options.currentTimeframe || 0);
	  var endTimeframeOffset = 1;
	  if (options.activeTab === 'graph') {
	    if (!options.startTimeframe) {
	      activeTimeframe = 0;
	    }
	    var startTimeframe = +(options.startTimeframe || 0) + 1;
	    endTimeframeOffset = options.startTimeframe ? startTimeframe : data.timeframes.length;
	  } else {
	    endTimeframeOffset = +(options.startTimeframe || activeTimeframe + 1);
	  }
	
	  var timeframes = _mori2.default.set((data.timeframes || [0]).slice(activeTimeframe, endTimeframeOffset));
	
	  return _mori2.default.filter(function (sheet) {
	    return _mori2.default.hasKey(timeframes, _mori2.default.first(sheet));
	  }, data.immutableData);
	}
	
	/**
	 * [buildTable description]
	 * @TODO build out doc
	 * @param  {[type]} data            [description]
	 * @param  {[type]} options         [description]
	 * @param  {[type]} timeframes      [description]
	 * @param  {[type]} combinedColumns [description]
	 * @param  {[type]} selectedSetKeys [description]
	 * @param  {[type]} distributions   [description]
	 * @param  {[type]} dataviewType    [description]
	 * @param  {[type]} columnKeys      [description]
	 * @return {[type]}                 [description]
	 */
	
	// import { getDefaultStates } from '../config/table';
	function buildTable(data, options, timeframes, combinedColumns, selectedSetKeys, distributions, dataviewType, columnKeys) {
	  var trend = _mori2.default.count(timeframes) > 1;
	
	  var geoMulti = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti'], false);
	
	  var mapBaseColumn = _mori2.default.getIn(data.config, ['globalRules', 'Map Base Column'], false);
	
	  var linkContext = _mori2.default.getIn(data.config, ['globalRules', 'Context'], [])[1] || 'states';
	
	  var builtRowData = (0, _table.buildRowData)(timeframes, selectedSetKeys, combinedColumns, trend);
	
	  // Build the column headers and variables for agGrid
	  var columnDefs = (0, _table.getAgColumns)(data.immutableHeaders, distributions, _mori2.default.getIn(data.config, ['globalRules', 'Link Column'], false), _mori2.default.getIn(data.config, ['globalRules', 'Link Target'], false), linkContext, dataviewType, timeframes, trend, _mori2.default.first(columnKeys[0]), geoMulti && mapBaseColumn ? mapBaseColumn : false);
	
	  return _mori2.default.hashMap('tableData', _mori2.default.hashMap('rowData', builtRowData.rowData || [], 'columnDefs', columnDefs, 'selectedSetKeys', selectedSetKeys));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(filterByTimeframe, 'filterByTimeframe', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/dataFromOptions.js');
	
	  __REACT_HOT_LOADER__.register(buildTable, 'buildTable', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/dataFromOptions.js');
	}();

	;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _dataFilters = __webpack_require__(154);
	
	var _getSelectedDistributions = __webpack_require__(58);
	
	var _getSelectedDistributions2 = _interopRequireDefault(_getSelectedDistributions);
	
	var _getSelectedColumns = __webpack_require__(150);
	
	var _getSelectedColumns2 = _interopRequireDefault(_getSelectedColumns);
	
	var _getColumnKeys = __webpack_require__(141);
	
	var _getColumnKeys2 = _interopRequireDefault(_getColumnKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Generates selection keys and filters which are used by rendering functions
	 *
	 * @param {object} data The data store
	 * @param {object} options Options from the url
	 *
	 * @return {array}
	 */
	var _default = function _default(data, options) {
	  var isLocked = _mori2.default.getIn(data.config, ['globalRules', 'Locked'], false);
	
	  var shouldGetDistributions = options.selectedDistributions && (!isLocked || options.activeTab);
	
	  // Get the current data view object by index
	  var dataviewType = (data.globalSettings || {}).hasDataviews && !isLocked ? _mori2.default.nth(data.immutableDataviews, +(options.dataView || 0)) : false;
	
	  // Get currently selected distributions, or all
	  var distributions = shouldGetDistributions ? (0, _dataFilters.getCurrentDistributions)(data.immutableDistributions, options) : data.immutableDistributions;
	
	  // Create sets as keys for data
	  var selected = (0, _getSelectedDistributions2.default)(data, distributions, dataviewType);
	
	  var columnKeys = (0, _getColumnKeys2.default)(data);
	
	  // Join the base column and the selected sets
	  var selectedSetKeys = _mori2.default.concat(_mori2.default.vector(columnKeys[0]), selected);
	
	  // due to nesting we need to fix select all boxes...
	  if (options.selectedRows) {
	    options.selectedRows = assembleAllRows(data.columns, options.selectedRows);
	  }
	  // Return an array of arguments so we can apply it to other rendering
	  // functions by using ...spread
	  return [_getSelectedColumns2.default.apply(undefined, [data, options].concat(_toConsumableArray(columnKeys))), selectedSetKeys, distributions, dataviewType, columnKeys];
	};
	
	exports.default = _default;
	
	// this rewrites nested select alls
	
	function assembleAllRows(columns, rows) {
	  var newTree = {};
	  Object.keys(rows).forEach(function (curr) {
	    if (rows[curr].hasOwnProperty('all')) {
	      var children = columns.nested && curr !== 'nested' ? columns.nested[curr].children : columns[curr].children;
	      if (typeof children === 'undefined' || !children[Object.keys(children)[0]].hasOwnProperty('children')) {
	        newTree[curr] = rows[curr];
	      } else {
	        newTree[curr] = Object.keys(children).reduce(function (acc, item) {
	          acc[item] = { all: {} };
	          return acc;
	        }, {});
	      }
	    } else {
	      newTree[curr] = rows[curr];
	    }
	  });
	  return newTree;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(assembleAllRows, 'assembleAllRows', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getCombinedFilters.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getCombinedFilters.js');
	}();

	;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = footnoteCallback;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Filter footnotes per cell and flatten them
	 * @param  {Array} key                [key array for footnotes]
	 * @param  {mori.hashMap} footnotes   [footnotes]
	 * @return {Array}                    [footnotes for key]
	 */
	function footnoteCallback(key, footnotes) {
	  var isTrend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!isLocationInFootnotes(key, footnotes)) {
	    // Location isn't in footnotes
	    return [];
	  }
	
	  return _mori2.default.toJs(_mori2.default.distinct(_mori2.default.flatten(_mori2.default.map(function (row) {
	    return _mori2.default.flatten(_mori2.default.rest(row));
	  }, _mori2.default.filter(
	  // We need to open this up to multiple if there is a parent
	  function (note) {
	    return !Array.isArray(key[1]) ? _mori2.default.isSubset(_mori2.default.set(key), _mori2.default.first(note)) :
	    // We need to include only headerGroup, only columnTile, and combined
	    _mori2.default.isSubset(_mori2.default.set([key[0], _mori2.default.hashMap(key[1][0], key[1][1])]), _mori2.default.first(note)) || _mori2.default.isSubset(_mori2.default.set([key[0], key[1][0]]), !isTrend ? _mori2.default.first(note) : _mori2.default.rest(_mori2.default.first(note))) || _mori2.default.isSubset(_mori2.default.set([key[0], key[1][1]]), !isTrend ? _mori2.default.first(note) : _mori2.default.rest(_mori2.default.first(note))) || _mori2.default.first(_mori2.default.first(_mori2.default.last(_mori2.default.first(note)))) === 'any' && _mori2.default.equals(_mori2.default.set([key[0], key[1][1]]), _mori2.default.set([_mori2.default.first(_mori2.default.rest(_mori2.default.first(note))), _mori2.default.last(_mori2.default.last(_mori2.default.last(_mori2.default.first(note))))]) // set
	    ) // equals
	    // !Array.isArray
	    ;
	  }, footnotes)))));
	}
	
	/**
	 * Check if location is in footnotes
	 * @param  {Array} key                [key array for footnotes]
	 * @param  {mori.hashMap} footnotes   [footnotes]
	 * @return {Boolean}                  [if location is in footnotes]
	 */
	function isLocationInFootnotes(key, footnotes) {
	  return _mori2.default.count(_mori2.default.filter(function (item) {
	    return item === key[0];
	  }, _mori2.default.distinct(_mori2.default.reduceKV(
	  // accumulator, key, value (value isn't needed here)
	  function (acc, rKey) {
	    return _mori2.default.conj(acc, _mori2.default.first(_mori2.default.rest(rKey)));
	  }, _mori2.default.vector(), footnotes)))) > 0;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(footnoteCallback, 'footnoteCallback', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/footnoteCallback.js');
	
	  __REACT_HOT_LOADER__.register(isLocationInFootnotes, 'isLocationInFootnotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/footnoteCallback.js');
	}();

	;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFootnotes;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _composeFootnotes = __webpack_require__(142);
	
	var _composeFootnotes2 = _interopRequireDefault(_composeFootnotes);
	
	var _getActiveFootnotes = __webpack_require__(143);
	
	var _getActiveFootnotes2 = _interopRequireDefault(_getActiveFootnotes);
	
	var _getDistributions = __webpack_require__(144);
	
	var _getDistributions2 = _interopRequireDefault(_getDistributions);
	
	var _getLocations = __webpack_require__(145);
	
	var _getLocations2 = _interopRequireDefault(_getLocations);
	
	var _getRelevantRows = __webpack_require__(146);
	
	var _getRelevantRows2 = _interopRequireDefault(_getRelevantRows);
	
	var _getTimeframes = __webpack_require__(147);
	
	var _getTimeframes2 = _interopRequireDefault(_getTimeframes);
	
	var _labelFootnotes = __webpack_require__(148);
	
	var _labelFootnotes2 = _interopRequireDefault(_labelFootnotes);
	
	var _sortRows = __webpack_require__(149);
	
	var _sortRows2 = _interopRequireDefault(_sortRows);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get footnotes for the current "view"
	 *
	 * If the tab is table, the footnotes need to be:
	 *   #{year, #{parent-column, child-column}, location}
	 *
	 * If the tab is map or graph, the footnotes need to be:
	 *   #{#{parent-column, child-column}, location}
	 *
	 * Parent-column or child-column can be null
	 */
	function getFootnotes(sheetData, options, filteredData, combinedFilters) {
	  var footnotes = _mori2.default.getIn(sheetData.config, ['footnotes', 'footnotes'], false);
	
	  // If there are no footnotes, just return an empty hashMap
	  if (!footnotes) {
	    return _mori2.default.hashMap();
	  }
	
	  // Get the timeframes, locations, and distributions
	  var timeframes = (0, _getTimeframes2.default)(filteredData);
	  var locations = (0, _getLocations2.default)(combinedFilters[0]);
	  var distributions = (0, _getDistributions2.default)(combinedFilters[1]);
	  // Using the actives above, get the footnotes
	  var activeFootnotes = (0, _getActiveFootnotes2.default)(footnotes, timeframes, locations, distributions);
	  // Is a trend graph when there is more than two timeframes (timeframe & any)
	  var isTrendGraph = _mori2.default.count(timeframes) > 2;
	  // Pull out active locations (locations with footnotes);
	  var activeLocations = _mori2.default.keys(activeFootnotes);
	  // Pull out rows of data that have active locations
	  var relevantRows = (0, _getRelevantRows2.default)(filteredData, activeLocations);
	  // Sort the data, to match the table sort
	  var sortedRows = _mori2.default.reduce(function (acc, row) {
	    return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.first(row), _mori2.default.last(row)));
	  }, _mori2.default.hashMap(), (0, _sortRows2.default)(options.sortModel || {}, relevantRows, sheetData.immutableHeaders, combinedFilters[3].type));
	  // Compose the footnotes over the sorted data
	  var composedFootnotes = _mori2.default.reduce(function (acc, item) {
	    return _mori2.default.conj(acc, item);
	  }, _mori2.default.hashMap(), _mori2.default.filter(function (note) {
	    return !locations || _mori2.default.some(function (loc) {
	      return loc === _mori2.default.first(_mori2.default.rest(_mori2.default.first(_mori2.default.first(note))));
	    }, locations);
	  }, (0, _composeFootnotes2.default)(footnotes, timeframes, distributions)));
	
	  if (isTrendGraph) {
	    // If trendGraph view we need to do a secondary compose
	    composedFootnotes = _mori2.default.reduceKV(function (acc, key, val) {
	      return _mori2.default.conj(acc, _mori2.default.hashMap(_mori2.default.last(_mori2.default.rest(key)) !== 'Location' ? _mori2.default.set([_mori2.default.first(key), _mori2.default.first(_mori2.default.rest(key)), _mori2.default.hashMap(_mori2.default.first(key), _mori2.default.last(_mori2.default.rest(key)))]) : key, val));
	    }, _mori2.default.hashMap(), composedFootnotes);
	  }
	  // Go though and label the footnotes
	  var labeledFootnotes = (0, _labelFootnotes2.default)(composedFootnotes, sortedRows, sheetData.immutableHeaders, timeframes);
	  // Filter (dedup), the footnotes for other useage.
	  var filteredFootnotes = _mori2.default.reduceKV(function (acc, key, val) {
	    return _mori2.default.into(acc, val);
	  }, _mori2.default.set(), labeledFootnotes);
	
	  return {
	    labeledFootnotes: labeledFootnotes,
	    filteredFootnotes: filteredFootnotes
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getFootnotes, 'getFootnotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getFootnotes/index.js');
	}();

	;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generates an array of distributions for selecting data based on context
	 */
	var _default = function _default(data, distributions, type, isGeomulti) {
	  if (isGeomulti) {
	    return _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (distribution) {
	      return _mori2.default.equals(_mori2.default.getIn(data.config, ['globalRules', 'Map Base Column']), _mori2.default.get(distribution, 'characteristic'));
	    }), _mori2.default.map(function (distribution) {
	      return distributionSelector(data, distribution, type);
	    })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), data.immutableDistributions);
	  }
	  return _mori2.default.map(function (distribution) {
	    return distributionSelector(data, distribution, type);
	  }, distributions);
	};
	
	exports.default = _default;
	
	
	function distributionSelector(data, distribution, type) {
	  // use the globally selected dataview, or get the column specific one
	  var dataviewLabel = type ? type.label : _mori2.default.get(_mori2.default.first(_mori2.default.filter(function (header) {
	    // If the distribution has a headerGroup,
	    // match the headerGroup AND the characteristic,
	    // else, characteristic only.
	    return _mori2.default.get(distribution, 'headerGroup', false) ? _mori2.default.equals(_mori2.default.get(header, 'headerGroup'), _mori2.default.get(distribution, 'headerGroup')) && _mori2.default.equals(_mori2.default.get(header, 'characteristic'), _mori2.default.get(distribution, 'characteristic')) : _mori2.default.equals(_mori2.default.get(header, 'characteristic'), _mori2.default.get(distribution, 'characteristic'));
	  }, data.immutableHeaders)), 'label');
	  return _mori2.default.get(distribution, 'headerGroup') === null ? _mori2.default.set([_mori2.default.get(distribution, 'characteristic'), dataviewLabel]) : _mori2.default.set([_mori2.default.get(distribution, 'headerGroup'), _mori2.default.get(distribution, 'characteristic'),
	  // If label and char. are the same, make label more unique
	  // Label/Char will be same if Doc uses only Year values (2016, etc.)
	  // TODO: Find a way to handle this better.
	  // See: dataReducer.js L109
	  dataviewLabel === _mori2.default.get(distribution, 'characteristic') ? '_' + dataviewLabel : dataviewLabel]);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(distributionSelector, 'distributionSelector', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getSelectedDistributions.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/getSelectedDistributions.js');
	}();

	;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _config = __webpack_require__(11);
	
	var _maps = __webpack_require__(137);
	
	var maps = _interopRequireWildcard(_maps);
	
	var _util = __webpack_require__(15);
	
	var util = _interopRequireWildcard(_util);
	
	var _jenks = __webpack_require__(155);
	
	var _jenks2 = _interopRequireDefault(_jenks);
	
	var _getSelectedDistributions = __webpack_require__(58);
	
	var _getSelectedDistributions2 = _interopRequireDefault(_getSelectedDistributions);
	
	var _filters = __webpack_require__(57);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _switchFilter = __webpack_require__(72);
	
	var _switchFilter2 = _interopRequireDefault(_switchFilter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global __webpack_modules__ */
	
	/* eslint id-length: [2, {"exceptions": ["a","b","t","m","x"]}] */
	var filterSwitch = null;
	
	if (__webpack_require__.m[/*require.resolve*/(33)]) {
	  filterSwitch = angular.injector(['ng', _filters2.default]).get('filterSwitchFilter');
	} else {
	  //  This is react's territory
	  filterSwitch = (0, _switchFilter2.default)();
	}
	
	var _default = function _default(data, options, treeContextSlug, timeframes) {
	  // Get geography code map from topojson
	  var geoContext = 'usa';
	  var geoCodeMap = maps.getGeoCodeMap(geoContext);
	  var mapConfig = _mori2.default.toJs(maps.mapDefault(geoContext));
	  var isLocked = _mori2.default.getIn(data.config, ['globalRules', 'Locked'], false);
	  var isGeomulti = _mori2.default.getIn(data.config, ['globalRules', 'Geomulti'], false);
	  var mapBaseColumn = _mori2.default.getIn(data.config, ['globalRules', 'Map Base Column'], false);
	  var baseColumn = void 0;
	
	  // Get the current data view object by index
	  var dataviewType = data.globalSettings.hasDataviews && !isLocked ? _mori2.default.nth(data.immutableDataviews, +(options.dataView || 0)) : false;
	
	  // Currently selected distributions by matching slugs, or all
	  var distributions = options.selectedDistributions ? _mori2.default.filter(function (x) {
	    return options.selectedDistributions === _mori2.default.get(x, 'slug');
	  }, data.immutableDistributions) : data.immutableDistributions;
	
	  // Create sets as keys for data
	  var selected = (0, _getSelectedDistributions2.default)(data, distributions, dataviewType, isGeomulti);
	
	  // Map selected headers by distribution name and type
	  // Pluck distribution names from the selected distributions array
	  var distributionNames = _mori2.default.set(_mori2.default.map(function (characteristic) {
	    return _mori2.default.get(characteristic, 'characteristic');
	  }, distributions));
	  var selectedHeader = _mori2.default.first(_mori2.default.rest(_mori2.default.filter(function (header) {
	    return _mori2.default.get(header, 'idx') === 0 || _mori2.default.hasKey(distributionNames, _mori2.default.get(header, 'characteristic')) && (!dataviewType || dataviewType.type === _mori2.default.get(header, 'type') || dataviewType.label === _mori2.default.get(header, 'label'));
	  }, data.immutableHeaders)));
	
	  // Normally the base column is just the first
	  if (!isGeomulti) {
	    baseColumn = _mori2.default.vector(_mori2.default.set([_mori2.default.get(_mori2.default.first(data.immutableHeaders), 'characteristic'), _mori2.default.get(_mori2.default.first(data.immutableHeaders), 'label')]));
	    // otherwise get the base column specified by config
	  } else {
	    baseColumn = _mori2.default.transduce(_mori2.default.comp(_mori2.default.filter(function (header) {
	      return _mori2.default.equals(_mori2.default.get(header, 'characteristic'), _mori2.default.getIn(data.config, ['globalRules', 'Link Column']));
	    }), _mori2.default.map(function (header) {
	      var dataviewLabel = dataviewType ? dataviewType.label : _mori2.default.get(header, 'label');
	      return _mori2.default.set([_mori2.default.get(header, 'characteristic'), dataviewLabel]);
	    })), _mori2.default.completing(_mori2.default.conj), _mori2.default.vector(), data.immutableHeaders);
	  }
	
	  // Make an array of selected/parent selection rows
	  var parentColumns = isGeomulti ? _mori2.default.map(function (row) {
	    var rowKey = _mori2.default.first(row);
	    var columns = data.columns.nested[treeContextSlug] || {};
	    var currentChild = (columns.children || {})[rowKey];
	    return currentChild.label || rowKey;
	  }, _mori2.default.toClj((options.selectedRows || {})[treeContextSlug] || {})) : false;
	
	  // Join the base column and the selected sets
	  var selectedSetKeys = _mori2.default.into(baseColumn, selected);
	
	  // Set map constructor values
	  mapConfig.scope = geoContext;
	  mapConfig.data = buildMapData(timeframes, selectedSetKeys, geoCodeMap, selectedHeader, baseColumn, parentColumns, isGeomulti, mapBaseColumn);
	  mapConfig.setProjection = maps.setMapProjection(geoContext, mapConfig);
	  mapConfig.fills = {};
	
	  // Calculate and apply fill and legend
	
	  var _buildMapFills = buildMapFills(mapConfig.fills, mapConfig.data),
	      fills = _buildMapFills.fills,
	      labels = _buildMapFills.labels,
	      mapDataProcessed = _buildMapFills.mapDataProcessed;
	
	  mapConfig.fills = fills;
	  mapConfig.labels = labels;
	  mapConfig.labels.defaultFill = mapBaseColumn ? 'Firm is Not Operating in State' : mapConfig.labels.defaultFill;
	  mapConfig.data = mapDataProcessed;
	
	  return {
	    data: mapConfig,
	    plugins: buildMapPlugins(geoContext)
	  };
	};
	
	exports.default = _default;
	
	
	function buildMapData(timeframes, selected, codes, selectedHeader, baseColumn, parentColumns, isGeomulti, mapBaseColumn) {
	  var firstKey = _mori2.default.first(selected);
	  var secondKey = _mori2.default.first(_mori2.default.rest(selected));
	
	  var baseKey = isGeomulti ? secondKey : firstKey;
	  var dataKey = isGeomulti ? firstKey : secondKey;
	
	  return _mori2.default.into(_mori2.default.hashMap(), _mori2.default.map(function (x) {
	    // geomulti datapoints are simply the header title as the value in all
	    // states that exist
	    if (isGeomulti) {
	      var title = _mori2.default.get(selectedHeader, 'characteristic');
	
	      var value = mapBaseColumn ? _mori2.default.hashMap(codes[_mori2.default.get(x, baseKey)], _mori2.default.hashMap(_mori2.default.get(x, dataKey), _mori2.default.map(function (item) {
	        return _mori2.default.hashMap(_mori2.default.first(item), _mori2.default.get(x, item));
	      }, _mori2.default.filter(function (item) {
	        return _mori2.default.first(item) !== _mori2.default.first(baseKey) && _mori2.default.first(item) !== _mori2.default.first(dataKey);
	      }, _mori2.default.keys(x))))) : title;
	
	      return _mori2.default.hashMap(codes[_mori2.default.get(x, baseKey)], _mori2.default.hashMap('value', value, 'raw', mapBaseColumn ? 'Firm is Operating in State' : title, 'formatted', mapBaseColumn ? 'Firm is Operating in State' : title, 'mapBaseColumn', mapBaseColumn));
	    }
	    var rawNum = util.kffNumericValue(_mori2.default.get(x, dataKey));
	    if (rawNum !== null && /^percent/.test(_mori2.default.get(selectedHeader, 'type'))) {
	      // @TODO replace with built in filter
	      rawNum = util.numberPrecision(rawNum, util.getPrecision(_mori2.default.toJs(selectedHeader)), true);
	    }
	    var formatted = filterSwitch(_mori2.default.get(x, dataKey), _mori2.default.toJs(selectedHeader));
	    return _mori2.default.hashMap(codes[_mori2.default.get(x, baseKey)], _mori2.default.hashMap('value', _mori2.default.get(x, dataKey), 'raw', rawNum !== null ? rawNum : _mori2.default.get(x, dataKey), 'formatted', formatted));
	  }, _mori2.default.filter(function (x) {
	    return !parentColumns ?
	    // filter by actual states
	    codes[_mori2.default.get(x, baseKey)] :
	    // filter by selected row values
	    _mori2.default.equals(_mori2.default.get(x, _mori2.default.first(baseColumn)), _mori2.default.first(parentColumns));
	  }, _mori2.default.first(_mori2.default.rest(_mori2.default.first(timeframes))))));
	}
	
	/**
	 * Apply fill and legend calculation for datamap constructor
	 */
	function buildMapFills(mapFills, mapData) {
	  // Calculate breaks using jenks
	  var breaks = buildBreaks(mapData);
	
	  // Build fills and legend using breaks data
	
	  var _buildLegend = buildLegend(breaks, mapFills),
	      fills = _buildLegend.fills,
	      labels = _buildLegend.labels;
	
	  // Apply fills to map data
	
	
	  var mapDataProcessed = annotateData(mapData, breaks);
	
	  return { fills: fills, labels: labels, mapDataProcessed: mapDataProcessed };
	}
	
	/**
	 * Apply the correct fill keys to map data objects
	 */
	function annotateData(data, breaks) {
	  return _mori2.default.toJs(_mori2.default.transduce(_mori2.default.map(function (x) {
	    var _x = _mori2.default.hashMap(_mori2.default.first(x), _mori2.default.first(_mori2.default.rest(x)));
	    var fillKey = getFillKey(_mori2.default.get(breaks, 'useTextForFill') ? _mori2.default.get(_mori2.default.first(_mori2.default.rest(x)), 'formatted') : _mori2.default.get(_mori2.default.first(_mori2.default.rest(x)), 'raw'), breaks);
	    _x = _mori2.default.assocIn(_x, [_mori2.default.first(x), 'fillKey'], fillKey);
	    return _x;
	  }), _mori2.default.completing(_mori2.default.conj), _mori2.default.hashMap(), data));
	}
	
	/**
	 * Get the fill key for given data value
	 */
	function getFillKey(value, breaks) {
	  if (_mori2.default.some(function (val) {
	    return val === value;
	  }, _mori2.default.get(breaks, 'text'))) {
	    return _config.appDefault.dataNotAvailable.indexOf(value) > -1 || !value ? 'defaultFill' : value;
	  } else if (_mori2.default.get(breaks, 'useTextForFill') && _mori2.default.intoArray(_mori2.default.get(breaks, 'text')).indexOf(value) > -1) {
	    return _mori2.default.intoArray(_mori2.default.get(breaks, 'text')).indexOf(value);
	  } else if (!isNaN(value)) {
	    // If we have fewer than the max number of breaks,
	    // we need to map data to the break points exactly.
	    // This way, we are not grouping small data sets into
	    // one break point.
	    //
	    // If there are more than max breaks, we need to build a
	    // set of ranges.
	    var breakIndex = _mori2.default.intoArray(_mori2.default.get(breaks, 'fewerThanMaxBreaks') ? _mori2.default.get(breaks, 'values') : _mori2.default.rest(_mori2.default.get(breaks, 'values'))).reduce(function (acc, point, index) {
	      if (_mori2.default.get(breaks, 'fewerThanMaxBreaks')) {
	        return +value === point && acc < 0 ? index : acc;
	      }
	      return +value < point && acc < 0 ? index : acc;
	    }, -1);
	    if (breakIndex === -1) {
	      return _mori2.default.count(_mori2.default.get(breaks, 'values')) - 2;
	    }
	    return '' + breakIndex;
	  }
	  return 'defaultFill';
	}
	
	/**
	 * Constuct breaks arrays for numerical and text values,
	 * so they can be combined.
	 */
	function buildBreaks(data) {
	  var values = _mori2.default.groupBy(function (value) {
	    return util.kffIsNumber(_mori2.default.get(value, 'raw')) ? 'numeric' : 'text';
	  }, _mori2.default.map(function (row) {
	    return _mori2.default.first(_mori2.default.rest(row));
	  }, data));
	
	  // sort numeric
	  values = _mori2.default.assocIn(values, ['numeric'], _mori2.default.sort(function (a, b) {
	    return _mori2.default.get(a, 'raw') - _mori2.default.get(b, 'raw');
	  }, _mori2.default.get(values, 'numeric')));
	
	  var textBreaks = _mori2.default.distinct(_mori2.default.map(function (value) {
	    return _config.appDefault.dataNotAvailable.indexOf(_mori2.default.get(value, 'raw')) > -1 ? 'N/A' : _mori2.default.get(value, 'raw');
	  }, _mori2.default.get(values, 'text')));
	
	  var numeralBreaks = [];
	
	  // If we have few than 5 numeric values, we need to let
	  // the fillKey lookup code know that it has to look at
	  // the rawValues for data, else no key would be found
	  var useTextForFill = _mori2.default.count(_mori2.default.get(values, 'numeric')) < 5;
	
	  if (useTextForFill) {
	    textBreaks = _mori2.default.into(textBreaks, _mori2.default.distinct(_mori2.default.map(function (value) {
	      return _mori2.default.get(value, 'formatted');
	    }, _mori2.default.get(values, 'numeric'))));
	  } else {
	    var separated = _mori2.default.groupBy(function (value) {
	      return +_mori2.default.get(value, 'raw') < 0 ? 'negative' : 'positive';
	    }, _mori2.default.get(values, 'numeric'));
	    var offset = _mori2.default.hasKey(separated, 'negative') ? 1 : 0;
	
	    // Get Positive Breaks
	    var positiveNumeralBreaks = _mori2.default.count(_mori2.default.distinct(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'positive')))) < _config.appDefault.maxBreaks ? _mori2.default.toJs(_mori2.default.distinct(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'positive')))) : (0, _jenks2.default)(_mori2.default.toJs(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'positive'))), _config.appDefault.maxBreaks - offset) || [];
	
	    numeralBreaks = positiveNumeralBreaks.concat(offset ? (0, _jenks2.default)(_mori2.default.toJs(_mori2.default.map(function (value) {
	      return +_mori2.default.get(value, 'raw');
	    }, _mori2.default.get(separated, 'negative'))), _config.appDefault.maxBreaks - _mori2.default.count(_mori2.default.distinct(positiveNumeralBreaks.filter(function (x) {
	      return x || x === 0;
	    })))) : []).sort(function (a, b) {
	      return a > b;
	    });
	  }
	
	  // in case the sample is too small, or doesn't have unique values
	  // TODO: test if this is necessary
	  var realBreaks = _mori2.default.distinct(numeralBreaks.filter(function (x) {
	    return x || x === 0;
	  }));
	
	  if (_mori2.default.count(realBreaks) >= 1) {
	    // Find the longest decimal position, so we can pad all values
	    var numeralPrecisionMax = numeralBreaks.reduce(function (max, curr) {
	      var stringValue = curr + '';
	      if (stringValue.indexOf('.') === -1) {
	        return max;
	      }
	      var precision = stringValue.split('.')[1].length;
	      if (precision > max) {
	        return precision;
	      }
	      return max;
	    }, 0);
	    // Pad
	    numeralBreaks = _mori2.default.distinct(_mori2.default.map(function (value) {
	      return value === 0 || typeof value === 'undefined' ? 0 : +value.toFixed(numeralPrecisionMax);
	    }, numeralBreaks));
	  }
	
	  return _mori2.default.hashMap('text', textBreaks, 'values', numeralBreaks, 'rawValues', values, 'useTextForFill', useTextForFill, 'fewerThanMaxBreaks', _mori2.default.count(numeralBreaks) < _config.appDefault.maxBreaks);
	}
	
	/**
	 * Process breaks for legend and fills, combining if necessary.
	 */
	function buildLegend(breaks, fills) {
	  var labels = {};
	  // Don't include default fills
	  var textBreaks = _mori2.default.filter(function (x) {
	    return x && x.length && _config.appDefault.dataNotAvailable.indexOf(x) === -1;
	  }, _mori2.default.get(breaks, 'text'));
	
	  var lengthOffset = _mori2.default.get(breaks, 'fewerThanMaxBreaks') ? 0 : 1;
	
	  var legendLength = (!_mori2.default.isEmpty(_mori2.default.get(breaks, 'values')) ? _mori2.default.count(_mori2.default.get(breaks, 'values')) - lengthOffset : 0) + _mori2.default.count(textBreaks);
	  var colorIndex = 0;
	
	  if (legendLength > 6) {
	    legendLength = 'full';
	  }
	
	  // Map breaks for numerical values to legend + fills
	  if (!_mori2.default.isEmpty(_mori2.default.get(breaks, 'values'))) {
	    // Group values by breakpoint
	    var grouped = _mori2.default.toJs(_mori2.default.groupBy(function (row) {
	      var group = _mori2.default.peek(_mori2.default.into(_mori2.default.vector(), _mori2.default.takeWhile(function (breakValue) {
	        return breakValue <= _mori2.default.get(row, 'raw');
	      }, _mori2.default.get(breaks, 'values'))));
	      // The last breakpoint is a bound, not a group
	      if (!_mori2.default.get(breaks, 'fewerThanMaxBreaks') && group === _mori2.default.last(_mori2.default.get(breaks, 'values'))) {
	        return _mori2.default.count(_mori2.default.get(breaks, 'values')) - 2;
	      }
	      return _mori2.default.toJs(_mori2.default.get(breaks, 'values')).indexOf(group);
	    }, _mori2.default.getIn(breaks, ['rawValues', 'numeric'])));
	
	    Object.keys(grouped).forEach(function (idx) {
	      var startBreak = grouped[idx][0].formatted;
	      var endBreak = grouped[idx][grouped[idx].length - 1].formatted;
	      labels[idx] = '' + startBreak;
	      if (startBreak !== endBreak) {
	        labels[idx] += '- ' + endBreak;
	      }
	      fills[idx] = maps.mapColors[legendLength][colorIndex];
	      colorIndex++;
	    });
	  }
	
	  // Map breaks for text values to legend + fills
	  if (_mori2.default.count(_mori2.default.get(breaks, 'text'))) {
	    _mori2.default.each(_mori2.default.sort(function (a, b) {
	      return a.localeCompare(b);
	    }, _mori2.default.filter(function (x) {
	      return x && _config.appDefault.dataNotAvailable.indexOf(x) === -1 && x.length;
	    }, _mori2.default.get(breaks, 'text'))), function (x) {
	      labels[_mori2.default.count(_mori2.default.get(breaks, 'values')) + colorIndex] = x;
	      fills[x] = maps.mapColors[legendLength][colorIndex];
	      colorIndex++;
	    });
	  }
	
	  // Make sure we set the defaultFill
	  fills.defaultFill = maps.mapColors.defaultColor;
	  labels.defaultFill = 'N/A';
	
	  return { fills: fills, labels: labels };
	}
	
	/**
	 * Set up plugins object for the map
	 */
	function buildMapPlugins(geoContext) {
	  var plugins = {
	    mapCustomLegend: maps.mapCustomLegend
	  };
	  if (geoContext === 'usa') {
	    plugins.mapCustomLabels = maps.mapCustomLabels;
	  }
	  return plugins;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(filterSwitch, 'filterSwitch', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildMapData, 'buildMapData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildMapFills, 'buildMapFills', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(annotateData, 'annotateData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(getFillKey, 'getFillKey', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildBreaks, 'buildBreaks', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildLegend, 'buildLegend', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(buildMapPlugins, 'buildMapPlugins', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/mapData.js');
	}();

	;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.processCellCallback = processCellCallback;
	exports.cleanCSV = cleanCSV;
	exports.downloader = downloader;
	exports.escapeCSVQuotes = escapeCSVQuotes;
	exports.escapeNewLines = escapeNewLines;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _util = __webpack_require__(15);
	
	var _config = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function processCellCallback(columnDefs) {
	  var defs = _mori2.default.toJs(columnDefs).reduce(function (prev, curr) {
	    prev[curr.headerGroup ? curr.headerGroup + '__' + curr.characteristic : curr.characteristic] = curr;
	    return prev;
	  }, {});
	
	  return function (params) {
	    var colId = params.column.colId.replace(/^[0-9]{4}-/g, '');
	    var colDef = Object.assign({}, {
	      // Defaults to prevent undefined issues
	      type: '',
	      Precision: '',
	      Suffix: ''
	    }, defs[colId]);
	
	    var value = params.value.text;
	    var precision = (0, _util.getPrecision)(colDef);
	
	    if (_config.appDefault.dataNotAvailable.indexOf(value) > -1 || params.column.colId === 'Location') {
	      return escapeNewLines(attachFootnotes(escapeCSVQuotes(value), params));
	    }
	
	    if (colDef.type === 'percent') {
	      // 2 Additional places are added to account for the decimal
	      // place difference between raw and formatted percent values.
	      var percentPrecision = precision === 0 && value < 0.1 ? 2 : precision + 2;
	      if (!(0, _util.kffIsNumber)(value)) {
	        return escapeNewLines(attachFootnotes(escapeCSVQuotes(value), params));
	      }
	      value = (0, _util.numberPrecision)(value, percentPrecision, false).toFixed(percentPrecision);
	    } else if (colDef.Precision) {
	      value = (0, _util.numberPrecision)(value, (0, _util.getPrecision)(colDef), false);
	    }
	
	    if (colDef.type === 'currency' && !isNaN(value)) {
	      return escapeNewLines(attachFootnotes('$' + escapeCSVQuotes((0, _util.numberPrecision)(value, precision, false).toFixed(precision)), params));
	    }
	
	    if (colDef.Suffix) {
	      value = value + colDef.Suffix;
	    }
	
	    return escapeNewLines(attachFootnotes(escapeCSVQuotes(value), params));
	  };
	}
	
	// export function processHeaderCallback() {
	//   return ({ column }) => colId)}
	//   //   return params.column.colId
	//   //     .replace('__', '\n')
	//   //     .replace(/^([0-9]{4})-(.*)/, '$1\n$2');
	//   // };
	// }
	
	/**
	 * Attach footnotes to each applicable cell... yay!
	 * @param  {string} value  cell value
	 * @param  {object} params ag grid params object
	 * @return {string}        string with footnotes attached (if applicable)
	 */
	function attachFootnotes(value, params) {
	  if (params.api.footnoteCallback) {
	    var _params$value = params.value,
	        data = _params$value.data,
	        group = _params$value.group,
	        child = _params$value.child;
	
	    var footnotes = params.api.footnoteCallback([data.Location || data.State, // State for geomulti,
	    child !== false ? [group, child] : group]).map(function (_ref) {
	      var label = _ref.label;
	      return label;
	    });
	    if (footnotes.length > 0) {
	      return value + '#!#' + footnotes.join(',') + '#!#';
	    }
	    return value;
	  }
	}
	
	/**
	 * Clean up and modify the CSV as needed
	 * @param  {string} csv csv string
	 * @return {[type]}     [description]
	 */
	function cleanCSV(csv) {
	  // Split csv on new line
	  // Iterate through each line
	  // check line for existance of `#!#`
	  // if has existance, split on `#!#`
	  // take split into two array
	  // dedupe second, prepend to end of first with a `,`
	  // join('')
	  return csv.split('\n').map(function (line, idx) {
	    // headers are the 3rd row
	    if (idx === 2) {
	      return line.replace(/^([0-9]{4})-(.*)/g, '$1\n$2').slice(0, -1) // remove `\n` at end of line
	      + ',Footnotes';
	    }
	    if (line.match(/#!#/g) !== null) {
	      var _splitArray = splitArray(line.split('#!#')),
	          _splitArray2 = _slicedToArray(_splitArray, 2),
	          data = _splitArray2[0],
	          notes = _splitArray2[1];
	
	      var footnotes = notes.reduce(function (prev, note) {
	        return prev.concat(note.split(','));
	      }, []).filter(function (note, key, self) {
	        return self.indexOf(note) === key;
	      }) // dedup
	      .sort(function (a, b) {
	        return a - b;
	      }) // sort
	      .join(', ');
	      return data.join('').slice(0, -1) + ',"' + footnotes + '"';
	    }
	
	    return line;
	  }).join('\n');
	}
	
	/**
	 * Creator and downloader for the csv data (taken from AG-grids implimentation)
	 * @param  {string} fileName [filename]
	 * @param  {string} content  [content for file (csv, json, etc)]
	 */
	function downloader(fileName, content) {
	  // We need to use a form submission so browsers will properly download the file...
	  var form = document.createElement('form');
	  form.setAttribute('id', 'raw-data-form');
	  form.setAttribute('action', 'http://util.kff.org:8081');
	  // form.setAttribute('action', 'http://localhost:8081'); // For local debugging
	  form.setAttribute('method', 'post');
	  form.appendChild(buildInput('file-name', fileName));
	  form.appendChild(buildInput('content-type', 'text/csv'));
	  form.appendChild(buildInput('data', content));
	  var submit = document.createElement('button');
	  submit.setAttribute('type', 'submit');
	  form.appendChild(submit);
	
	  document.body.appendChild(form);
	  submit.click();
	  document.body.removeChild(form);
	
	  function buildInput(name, value) {
	    var input = document.createElement('input');
	    input.setAttribute('type', 'hidden');
	    input.setAttribute('name', name);
	    input.setAttribute('value', value);
	    return input;
	  }
	}
	
	/**
	 * Escape CSV quotes
	 * @param  {string} str [string to escape]
	 * @return {string}     [escaped string]
	 */
	function escapeCSVQuotes(str) {
	  if (typeof str !== 'string') {
	    return str;
	  }
	  return str.replace(/"|“|”|\u201C|\u201D/g, '""');
	}
	
	/**
	 * Check string for newlines, if they exist wrap in quotes
	 * @param  {string} str [string to check]
	 * @return {string}     [string wrapped in quotes]
	 */
	function escapeNewLines(str) {
	  if (typeof str !== 'string') {
	    return str;
	  }
	  if (str.match('\n|\r')) {
	    return str.replace(/(\r\n|\n|\r)/gm, ' ');
	  }
	  return str;
	}
	
	/**
	 * Convience function for splitting an array every other item
	 * @param  {array} arr array to split
	 * @return {array}     2d array, first one is the evens (including 0), second is odds (not including 0)
	 */
	function splitArray(arr) {
	  return [arr.filter(function (item, idx) {
	    return idx % 2 === 0;
	  }), arr.filter(function (item, idx) {
	    return idx % 2 !== 0;
	  })];
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(processCellCallback, 'processCellCallback', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/processTableDataForDownload.js');
	
	  __REACT_HOT_LOADER__.register(attachFootnotes, 'attachFootnotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/processTableDataForDownload.js');
	
	  __REACT_HOT_LOADER__.register(cleanCSV, 'cleanCSV', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/processTableDataForDownload.js');
	
	  __REACT_HOT_LOADER__.register(downloader, 'downloader', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/processTableDataForDownload.js');
	
	  __REACT_HOT_LOADER__.register(escapeCSVQuotes, 'escapeCSVQuotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/processTableDataForDownload.js');
	
	  __REACT_HOT_LOADER__.register(escapeNewLines, 'escapeNewLines', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/processTableDataForDownload.js');
	
	  __REACT_HOT_LOADER__.register(splitArray, 'splitArray', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/processTableDataForDownload.js');
	}();

	;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderNotes = renderNotes;
	
	var _mori = __webpack_require__(4);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _mapData = __webpack_require__(253);
	
	var _mapData2 = _interopRequireDefault(_mapData);
	
	var _linechartData = __webpack_require__(252);
	
	var _linechartData2 = _interopRequireDefault(_linechartData);
	
	var _tableData = __webpack_require__(262);
	
	var _tableData2 = _interopRequireDefault(_tableData);
	
	var _getCombinedFilters = __webpack_require__(248);
	
	var _getCombinedFilters2 = _interopRequireDefault(_getCombinedFilters);
	
	var _getSelectedDistributions = __webpack_require__(58);
	
	var _getSelectedDistributions2 = _interopRequireDefault(_getSelectedDistributions);
	
	var _getFootnotes = __webpack_require__(250);
	
	var _getFootnotes2 = _interopRequireDefault(_getFootnotes);
	
	var _footnoteCallback = __webpack_require__(249);
	
	var _footnoteCallback2 = _interopRequireDefault(_footnoteCallback);
	
	var _dataFromOptions = __webpack_require__(95);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint id-length: [2, {"exceptions":["a","b","i"]}] */
	
	
	var cachedOptions = {};
	var footnoteHash = null;
	
	var _default = function _default(sheetData, render) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var reduxCallback = arguments[3];
	
	  if (!render.table) {
	    render.table = {};
	  }
	
	  // @TODO - add a check/default for options.selectedRows.  Main reason
	  // being that we are checking if it exists || {} in a number of places.
	
	  var filteredData = (0, _dataFromOptions.filterByTimeframe)(sheetData, options);
	  var combinedFilters = (0, _getCombinedFilters2.default)(sheetData, options);
	  var isMultiGeo = _mori2.default.get(combinedFilters[4], [1], false);
	
	  // Gets the first key in the selected rows tree
	  var treeContextSlug = Object.keys(options.selectedRows || {})[0] || false;
	
	  var footnotes = (0, _getFootnotes2.default)(sheetData, options, filteredData, combinedFilters);
	
	  function footnoteCb(key) {
	    return (0, _footnoteCallback2.default)(key, footnotes.labeledFootnotes, !!(options.currentTimeframe && options.startTimeframe));
	  }
	
	  _tableData2.default.bind(render.table)(sheetData, options, filteredData, [_mori2.default.set(), // All columns
	  _mori2.default.concat(_mori2.default.vector(combinedFilters[4][0]), (0, _getSelectedDistributions2.default)(sheetData, sheetData.immutableDistributions, sheetData.globalSettings.hasDataviews && !_mori2.default.getIn(sheetData.config, ['globalRules', 'Locked'], false) ? _mori2.default.nth(sheetData.immutableDataviews, +(options.dataView || 0)) : false)), sheetData.immutableDistributions, combinedFilters[3], combinedFilters[4]], function () {
	    // Ready callback
	    render.table.api.footnoteCallback = footnoteCb;
	
	    render.table.filterDistributions(combinedFilters[1], options, _mori2.default.intoArray(_mori2.default.map(function (item) {
	      return _mori2.default.first(item);
	    }, filteredData)));
	    render.table.filterData(!isMultiGeo ? combinedFilters[0] : null);
	    render.table.api.setSortModel([options.sortModel || {
	      colId: isMultiGeo ? 'State' : 'Location',
	      sort: 'asc'
	    }]);
	  }, combinedFilters[0], // Selected Keys
	  isMultiGeo, reduxCallback,
	  // Callback general post X actions
	  function (table) {
	    table.filterDistributions(combinedFilters[1], options, _mori2.default.intoArray(_mori2.default.map(function (item) {
	      return _mori2.default.first(item);
	    }, filteredData)));
	
	    table.filterData(!isMultiGeo ? combinedFilters[0] : null);
	
	    if (table.api && options.activeTab === 'graph') {
	      table.api.setSortModel([options.sortModel || {
	        colId: isMultiGeo ? 'State' : 'Location',
	        sort: 'asc'
	      }]);
	    }
	  });
	
	  if (footnoteHash !== _mori2.default.hash(footnotes.labeledFootnotes) && render.table.api) {
	    render.table.api.footnoteCallback = footnoteCb;
	    footnoteHash = _mori2.default.hash(footnotes.labeledFootnotes);
	    render.table.api.refreshHeader();
	    render.table.api.refreshView();
	    if (render.table.onAfterFilterChanged) {
	      render.table.onAfterFilterChanged(); // We need to fire this to reset headers
	    }
	  }
	
	  render.footnotes = _mori2.default.toJs(footnotes.filteredFootnotes);
	
	  // We want to build the map data if we are on the map tab
	  // and certain options have changed
	  if (options.activeTab === 'map' && (typeof render.mapData === 'undefined' || // check that map has rendered at least once
	  isMultiGeo || // force map refresh if multigeo as selection could have changed
	  options.dataView !== cachedOptions.dataView || options.selectedDistributions !== cachedOptions.selectedDistributions || options.currentTimeframe !== cachedOptions.currentTimeframe)) {
	    render.mapData = _mapData2.default.apply(undefined, [sheetData, options, treeContextSlug, filteredData].concat(_toConsumableArray(combinedFilters)));
	  } else if (options.activeTab === 'graph') {
	    render.graph = _linechartData2.default.apply(undefined, [sheetData, options, filteredData].concat(_toConsumableArray(combinedFilters)));
	    // can't use ng-if on an immutable
	    render.graphHasData = !_mori2.default.isEmpty(render.graph);
	  }
	
	  render.notes = renderNotes(sheetData.config, sheetData.timeframes, options);
	
	  cachedOptions = Object.assign({}, options);
	
	  // From getSelectedColumns:  If the selected rows is invalid,
	  // we need to reset the selectedRows tree in the URL
	  var validSelection = treeContextSlug !== 'nested' && (!!sheetData.columns[treeContextSlug] || !!sheetData.columns.nested[treeContextSlug]);
	
	  if (!validSelection) {
	    reduxCallback({ selectedRows: undefined });
	    return;
	  }
	};
	
	exports.default = _default;
	
	/**
	 * Given the confige, timeframes, and options, find which notes should be shown
	 *
	 * @param  {object} config        Datasheet config
	 * @param  {array} allTimeframes  Datasheet timeframes
	 * @param  {object} options       Options object
	 * @return {array}                Array of notes to show
	 */
	
	function renderNotes(config, allTimeframes, options) {
	  return _mori2.default.toJs(_mori2.default.map(function (item) {
	    return _mori2.default.hashMap('name', _mori2.default.first(item), 'val', _mori2.default.filter(function (val) {
	      return _mori2.default.count(_mori2.default.intersection(_mori2.default.conj(_mori2.default.set(allTimeframes.slice(+options.currentTimeframe || 0, (+options.currentTimeframe || 0) + 1).map(function (curr) {
	        return curr.replace(/\s+/g, '');
	      })), 'any', ''), _mori2.default.set((_mori2.default.get(val, 'Timeframe', '') || '').replace(/\s+/g, '').split(',')))) > 0;
	    }, _mori2.default.last(item)));
	  }, _mori2.default.get(config, 'notesSources')));
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(cachedOptions, 'cachedOptions', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/renderData.js');
	
	  __REACT_HOT_LOADER__.register(footnoteHash, 'footnoteHash', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/renderData.js');
	
	  __REACT_HOT_LOADER__.register(renderNotes, 'renderNotes', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/renderData.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/datacenter/app/js/services/renderData.js');
	}();

	;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fetchData;
	
	var _isomorphicFetch = __webpack_require__(202);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _types = __webpack_require__(87);
	
	var _actions = __webpack_require__(117);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _loadData = __webpack_require__(196);
	
	var _loadData2 = _interopRequireDefault(_loadData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Need to disable import/first rule for polyfilling fetch... */
	/* eslint-disable import/first */
	__webpack_require__(198).polyfill(); // eslint-disable-line
	function fetchData(key) {
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
	
	  return function (dispatch) {
	    // Alert data is fetching
	    dispatch((0, _actions2.default)(_types.FETCH_GDOC_DATA));
	
	    return (0, _isomorphicFetch2.default)('https://gdocs.kff.alley.ws/spreadsheets/' + key).then(function (response) {
	      return response.json();
	    }).then(function (data) {
	      dispatch((0, _actions2.default)(_types.FETCH_GDOC_DATA_SUCCESS, data));
	      // Now lets load the data!
	      dispatch((0, _loadData2.default)(data, type));
	    });
	    // .catch((error) =>
	    //   dispatch(actionTrigger(FETCH_GDOC_DATA_ERROR, { error }))
	    // );
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fetchData, 'fetchData', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/actions/fetchData.js');
	}();

	;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(21);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(54);
	
	var _table = __webpack_require__(299);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _datamap = __webpack_require__(295);
	
	var _datamap2 = _interopRequireDefault(_datamap);
	
	var _distributionSelector = __webpack_require__(297);
	
	var _distributionSelector2 = _interopRequireDefault(_distributionSelector);
	
	var _app = __webpack_require__(426);
	
	var styles = _interopRequireWildcard(_app);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
	
	    _this.state = {};
	
	    _this.renderError = _this.renderError.bind(_this);
	    _this.renderLoading = _this.renderLoading.bind(_this);
	    _this.renderMap = _this.renderMap.bind(_this);
	    _this.renderTable = _this.renderTable.bind(_this);
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'renderError',
	    value: function renderError() {
	      if (this.props.error) {
	        return _react2.default.createElement(
	          'div',
	          { className: styles.loadingPlaceholder },
	          _react2.default.createElement(
	            'h4',
	            { className: styles.text },
	            'An error has occured when loading the data.',
	            _react2.default.createElement(
	              'span',
	              { className: styles.sub },
	              'Please refresh your page, or try again later.'
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderLoading',
	    value: function renderLoading() {
	      if (this.props.fetching) {
	        return _react2.default.createElement(
	          'div',
	          { className: styles.loadingPlaceholder },
	          _react2.default.createElement(
	            'h4',
	            { className: styles.text },
	            _react2.default.createElement('i', {
	              className: 'fa fa-circle-o-notch fa-spin fa-2x ' + styles.fa
	            }),
	            'Data are loading'
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderMap',
	    value: function renderMap() {
	      if (!this.props.fetching && !this.props.error && ('map' === this.props.type || 'all' === this.props.type)) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_distributionSelector2.default, null),
	          _react2.default.createElement(_datamap2.default, null)
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      if (!this.props.fetching && !this.props.error && ('table' === this.props.type || 'all' === this.props.type)) {
	        return _react2.default.createElement(_table2.default, null);
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderLoading(),
	        this.renderError(),
	        this.renderMap(),
	        this.renderTable()
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.propTypes = {
	  error: _react2.default.PropTypes.bool,
	  fetching: _react2.default.PropTypes.bool,
	  type: _react2.default.PropTypes.string
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return {
	    type: state.data.type,
	    error: state.data.error,
	    fetching: state.data.isFetching
	  };
	})(App);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(App, 'App', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/app.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/app.js');
	}();

	;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(21);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatamaps = __webpack_require__(296);
	
	var _reactDatamaps2 = _interopRequireDefault(_reactDatamaps);
	
	var _index = __webpack_require__(427);
	
	var styles = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Datamap = function (_Component) {
	  _inherits(Datamap, _Component);
	
	  function Datamap() {
	    _classCallCheck(this, Datamap);
	
	    var _this = _possibleConstructorReturn(this, (Datamap.__proto__ || Object.getPrototypeOf(Datamap)).call(this));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Datamap, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: styles.dataMap },
	        _react2.default.createElement(_reactDatamaps2.default, null)
	      );
	    }
	  }]);
	
	  return Datamap;
	}(_react.Component);
	
	Datamap.propTypes = {
	  datamap: _react2.default.PropTypes.object
	};
	
	var _default = Datamap;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Datamap, 'Datamap', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/datamap/index.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/datamap/index.js');
	}();

	;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(21);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(54);
	
	var _datamaps = __webpack_require__(194);
	
	var _datamaps2 = _interopRequireDefault(_datamaps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// eslint-disable-next-line
	
	
	var ReactDatamaps = function (_Component) {
	  _inherits(ReactDatamaps, _Component);
	
	  function ReactDatamaps() {
	    _classCallCheck(this, ReactDatamaps);
	
	    var _this = _possibleConstructorReturn(this, (ReactDatamaps.__proto__ || Object.getPrototypeOf(ReactDatamaps)).call(this));
	
	    _this.clear = _this.clear.bind(_this);
	    _this.drawMap = _this.drawMap.bind(_this);
	    _this.updateData = _this.updateData.bind(_this);
	    _this.styleFixes = _this.styleFixes.bind(_this);
	    _this.mapBaseHeight = 445;
	    return _this;
	  }
	
	  _createClass(ReactDatamaps, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.drawMap();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.clear();
	      this.drawMap();
	      this.updateData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clear();
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.container.querySelector('.dataMap').innerHTML = '';
	      delete this.map;
	    }
	  }, {
	    key: 'drawMap',
	    value: function drawMap() {
	      this.map = new _datamaps2.default(_extends({}, this.props.datamap.data, {
	        element: this.container.querySelector('.dataMap')
	        // KFF-2323
	        // We are passing in data even though we are going to be updating it
	        // via updateChoropleth.  This is due to a hover issue in datamaps
	        // where the previous fill color was being stored.
	      }));
	      this.updateData();
	      this.styleFixes();
	    }
	  }, {
	    key: 'updateData',
	    value: function updateData() {
	      var _this2 = this;
	
	      var _props$datamap = this.props.datamap,
	          data = _props$datamap.data,
	          plugins = _props$datamap.plugins,
	          pluginData = _props$datamap.pluginData;
	
	      this.map.updateChoropleth(data.data);
	
	      if (plugins) {
	        Object.keys(plugins).forEach(function (plugin) {
	          _this2.map.addPlugin(plugin, plugins[plugin]);
	          _this2.map[plugin](pluginData || {});
	        });
	      }
	      this.styleFixes();
	    }
	  }, {
	    key: 'styleFixes',
	    value: function styleFixes() {
	      var element = this.container.querySelector('.dataMap');
	      var legendRect = element.querySelector('.datamaps-legend').getBoundingClientRect();
	      // For some reason in IE & FF the font-size isn't set, so we need to do that
	      // Override OG DC's padding-bottom
	      element.style['padding-bottom'] = 0;
	      [].forEach.call(element.querySelectorAll('text'), function (item) {
	        if ('12px' !== item.style['font-size']) {
	          // eslint-disable-next-line no-param-reassign
	          item.style['font-size'] = '12px';
	        }
	      });
	      element.style.height = this.mapBaseHeight + (legendRect.bottom - legendRect.top) + 30 + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var style = _extends({
	        position: 'relative',
	        width: '753px'
	      }, this.props.style);
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(container) {
	            _this3.container = container;
	          } },
	        _react2.default.createElement('div', {
	          style: style,
	          className: 'dataMap'
	        })
	      );
	    }
	  }]);
	
	  return ReactDatamaps;
	}(_react.Component);
	
	ReactDatamaps.propTypes = {
	  datamap: _react2.default.PropTypes.object.isRequired,
	  style: _react2.default.PropTypes.object
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return {
	    datamap: state.data.datamap
	  };
	})(ReactDatamaps);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ReactDatamaps, 'ReactDatamaps', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/datamap/reactDatamaps.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/datamap/reactDatamaps.js');
	}();

	;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(21);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(54);
	
	var _mori = __webpack_require__(65);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _types = __webpack_require__(87);
	
	var _actions = __webpack_require__(117);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DistributionSelector = function (_Component) {
	  _inherits(DistributionSelector, _Component);
	
	  _createClass(DistributionSelector, null, [{
	    key: 'renderOption',
	    value: function renderOption(option) {
	      return _react2.default.createElement(
	        'option',
	        {
	          value: option.slug,
	          key: option.slug
	        },
	        option.label
	      );
	    }
	  }]);
	
	  function DistributionSelector() {
	    _classCallCheck(this, DistributionSelector);
	
	    var _this = _possibleConstructorReturn(this, (DistributionSelector.__proto__ || Object.getPrototypeOf(DistributionSelector)).call(this));
	
	    _this.state = {};
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(DistributionSelector, [{
	    key: 'handleChange',
	    value: function handleChange(evt) {
	      evt.preventDefault();
	      this.props.dispatch((0, _actions2.default)(_types.UPDATE_SELECTED, { selectedDistributions: evt.target.value }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (1 >= this.props.distributions.length) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: function onSubmit() {} },
	        _react2.default.createElement(
	          'select',
	          {
	            value: this.props.selectedDistributions,
	            onChange: this.handleChange
	          },
	          this.props.distributions.map(function (distribution) {
	            return _this2.constructor.renderOption(distribution);
	          })
	        )
	      );
	    }
	  }]);
	
	  return DistributionSelector;
	}(_react.Component);
	
	DistributionSelector.propTypes = {
	  dispatch: _react2.default.PropTypes.func,
	  distributions: _react2.default.PropTypes.array,
	  selectedDistributions: _react2.default.PropTypes.string
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return {
	    distributions: _mori2.default.toJs(state.data.immutableDistributions),
	    selectedDistributions: state.data.selectedDistributions
	  };
	})(DistributionSelector);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DistributionSelector, 'DistributionSelector', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/distributionSelector/index.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/distributionSelector/index.js');
	}();

	;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(21);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(428);
	
	var styles = _interopRequireWildcard(_index);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prefer-stateless-function */
	
	
	var Lightbox = function (_Component) {
	  _inherits(Lightbox, _Component);
	
	  function Lightbox() {
	    _classCallCheck(this, Lightbox);
	
	    var _this = _possibleConstructorReturn(this, (Lightbox.__proto__ || Object.getPrototypeOf(Lightbox)).call(this));
	
	    _this.componentDidMount = _this.componentDidMount.bind(_this);
	    _this.componentWillUnmount = _this.componentWillUnmount.bind(_this);
	
	    _this.docBod = document.querySelector('body');
	    return _this;
	  }
	
	  _createClass(Lightbox, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Save the parent
	      this.parent = this.lightbox.parentNode;
	      // Now move this to body
	      this.docBod.appendChild(this.lightbox);
	      this.docBod.style.overflow = 'hidden';
	
	      this.elm.style.left = (this.docBod.getBoundingClientRect().width - this.elm.getBoundingClientRect().width) / 2 + 'px';
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Move back to parent
	      this.parent.appendChild(this.lightbox);
	      this.docBod.style.overflow = 'auto';
	    }
	
	    /* eslint-disable jsx-a11y/no-static-element-interactions */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: styles.lightboxWrapper,
	          ref: function ref(lightbox) {
	            _this2.lightbox = lightbox;
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: styles.wrapperClick,
	            onClick: this.props.onClose
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: styles.lightbox,
	              style: this.props.wrapperStyle,
	              ref: function ref(elm) {
	                _this2.elm = elm;
	              }
	            },
	            this.props.children
	          )
	        )
	      );
	    }
	    /* eslint-enable */
	
	  }]);
	
	  return Lightbox;
	}(_react.Component);
	
	Lightbox.propTypes = {
	  children: _react2.default.PropTypes.node,
	  onClose: _react2.default.PropTypes.func,
	  wrapperStyle: _react2.default.PropTypes.object
	};
	
	var _default = Lightbox;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Lightbox, 'Lightbox', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/lightbox/index.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/lightbox/index.js');
	}();

	;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(21);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(54);
	
	var _agGridReact = __webpack_require__(160);
	
	var _tableData = __webpack_require__(195);
	
	var _downloadCSV = __webpack_require__(304);
	
	var _downloadCSV2 = _interopRequireDefault(_downloadCSV);
	
	var _util = __webpack_require__(305);
	
	var _index = __webpack_require__(429);
	
	var styles = _interopRequireWildcard(_index);
	
	var _lightbox = __webpack_require__(298);
	
	var _lightbox2 = _interopRequireDefault(_lightbox);
	
	__webpack_require__(425);
	
	__webpack_require__(423);
	
	__webpack_require__(424);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * CSS got to disable eslint, as the import catchers yell at you...
	 */
	/* eslint-disable */
	
	
	/* eslint-enable */
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table() {
	    _classCallCheck(this, Table);
	
	    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this));
	
	    _this.state = {
	      lightbox: false
	    };
	
	    // Local Events & Functions
	    _this.onOpen = _this.onOpen.bind(_this);
	    _this.renderLightbox = _this.renderLightbox.bind(_this);
	    _this.exportCSV = _this.exportCSV.bind(_this);
	    _this.adjustToolBar = _this.adjustToolBar.bind(_this);
	
	    // AG Grid Jazz
	    _this.onGridReady = _this.onGridReady.bind(_this);
	    _this.lightboxOnGridReady = _this.lightboxOnGridReady.bind(_this);
	    /**
	     * We need to refresh the view for ranking...
	     * should probably do this differntly
	     */
	    _this.onAfterSortChanged = function () {
	      return _this.__onAfterSortChanged__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	    _this.onAfterFilterChanged = _tableData.onAfterFilterChanged.bind(_this);
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: '__onAfterSortChanged__REACT_HOT_LOADER__',
	    value: function __onAfterSortChanged__REACT_HOT_LOADER__() {
	      this.api.refreshView();
	      _tableData.onAfterSortChanged.bind(this)();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _util.waitTillExists)('.ag-body-container', function () {
	        return _this2.adjustToolBar();
	      });
	    }
	  }, {
	    key: 'onGridReady',
	    value: function onGridReady(_ref) {
	      var api = _ref.api,
	          columnApi = _ref.columnApi;
	
	      this.api = api;
	      this.api.footnoteCallback = this.props.table.footnoteCallback;
	      this.columnApi = columnApi;
	      this.headerStyle = 'bold 14px/18px "Droid Sans", helvetica, sans-serif';
	      /**
	       * Because we don't have have a filter to trigger this,
	       * trigger filter change to set column headers
	       */
	      this.onAfterFilterChanged();
	    }
	  }, {
	    key: 'onOpen',
	    value: function onOpen() {
	      this.setState({
	        lightbox: !this.state.lightbox
	      });
	    }
	  }, {
	    key: 'lightboxOnGridReady',
	    value: function lightboxOnGridReady(_ref2) {
	      var api = _ref2.api,
	          columnApi = _ref2.columnApi;
	
	      var lightboxGrid = { api: api, columnApi: columnApi };
	      lightboxGrid.api.footnoteCallback = this.props.table.footnoteCallback;
	      lightboxGrid.headerStyle = 'bold 14px/18px "Droid Sans", helvetica, sans-serif';
	
	      // Can't override a .bind call - so using imported onAfterFilterChanged
	      _tableData.onAfterFilterChanged.call(lightboxGrid);
	    }
	  }, {
	    key: 'adjustToolBar',
	    value: function adjustToolBar() {
	      // Adjust button nav here
	      var width = Array.prototype.reduce.call(this.parentElm.querySelector('.ag-body-container .ag-row').querySelectorAll('.ag-cell'), function (acc, curr) {
	        return acc + curr.getBoundingClientRect().width;
	      }, 0) + this.parentElm.querySelector('.ag-pinned-left-cols-viewport').getBoundingClientRect().width;
	      if (800 > width) {
	        this.parentElm.querySelector('.' + styles.toolBar).style.width = width + 'px';
	      }
	    }
	
	    /* eslint-disable no-alert */
	
	  }, {
	    key: 'exportCSV',
	    value: function exportCSV() {
	      if (-1 < window.navigator.userAgent.indexOf('Safari') && 0 > window.navigator.userAgent.indexOf('Chrome')) {
	        if (!confirm('CSV will open in a new browser window, please save as a CSV')) {
	          return;
	        }
	      }
	      (0, _downloadCSV2.default)(this.api, this.props.table, this.props.timeframes, this.props.config, this.props.immutableHeaders, this.props.immutableDataviews);
	    }
	    /* eslint-enable no-alert */
	
	  }, {
	    key: 'renderLightbox',
	    value: function renderLightbox() {
	      var _this3 = this;
	
	      if (!this.state.lightbox) {
	        return null;
	      }
	      var header = this.container.querySelector('.ag-header');
	      var body = this.container.querySelector('.ag-body-container');
	      var leftCols = this.container.querySelector('.ag-pinned-left-cols-viewport');
	
	      var wrapperStyle = {
	        height: header.getBoundingClientRect().height + body.getBoundingClientRect().height + 10,
	        width: body.getBoundingClientRect().width + leftCols.getBoundingClientRect().width
	      };
	
	      var style = { height: 'inherit', width: 'inherit' };
	      var lightboxOnAfterFilterChanged = this.onAfterFilterChanged.bind(_extends({}, this, { forPrint: true }));
	
	      return _react2.default.createElement(
	        _lightbox2.default,
	        {
	          onClose: this.onOpen,
	          wrapperStyle: wrapperStyle
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: styles.tableWrapperLightbox,
	            style: wrapperStyle,
	            ref: function ref(container) {
	              _this3.container = container;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'ag-datacenter print',
	              style: style
	            },
	            _react2.default.createElement(_agGridReact.AgGridReact, _extends({}, this.props.table, {
	              onGridReady: this.lightboxOnGridReady,
	              onAfterSortChanged: this.onAfterSortChanged,
	              onAfterFilterChanged: lightboxOnAfterFilterChanged,
	              getRowHeight: _tableData.getRowHeight
	            }))
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var wrapperStyle = {
	        height: window.innerHeight * 0.75
	      };
	
	      var style = {
	        height: 'inherit',
	        width: 'inherit'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { ref: function ref(parent) {
	            _this4.parentElm = parent;
	          } },
	        this.renderLightbox(),
	        _react2.default.createElement(
	          'div',
	          { className: styles.toolBar },
	          _react2.default.createElement(
	            'span',
	            { className: styles.note },
	            'Scroll in table'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: styles.btnBar },
	            _react2.default.createElement(
	              'button',
	              {
	                className: styles.btn,
	                onClick: this.onOpen
	              },
	              'View Full Table'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: styles.btn,
	                onClick: this.exportCSV
	              },
	              'Export CSV'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'table-wrapper ' + styles.tableWrapper,
	            style: wrapperStyle,
	            ref: function ref(container) {
	              _this4.container = container;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'ag-datacenter',
	              style: style
	            },
	            _react2.default.createElement(_agGridReact.AgGridReact, _extends({}, this.props.table, {
	              onGridReady: this.onGridReady,
	              onAfterSortChanged: this.onAfterSortChanged,
	              onAfterFilterChanged: this.onAfterFilterChanged,
	              getRowHeight: _tableData.getRowHeight
	            }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.propTypes = {
	  table: _react2.default.PropTypes.object,
	  config: _react2.default.PropTypes.any,
	  immutableHeaders: _react2.default.PropTypes.any,
	  immutableDataviews: _react2.default.PropTypes.any,
	  timeframes: _react2.default.PropTypes.array
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return {
	    table: state.data.table,
	    config: state.data.config,
	    immutableHeaders: state.data.immutableHeaders,
	    immutableDataviews: state.data.immutableDataviews,
	    timeframes: state.data.timeframes
	  };
	})(Table);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Table, 'Table', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/table/index.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/components/table/index.js');
	}();

	;

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	
	/**
	 * Object().assign() polyfill for IE11
	 */
	if (typeof Object.assign != 'function') {
	  (function () {
	    Object.assign = function (target) {
	      'use strict';
	
	      if (target === undefined || target === null) {
	        throw new TypeError('Cannot convert undefined or null to object');
	      }
	
	      var output = Object(target);
	      for (var index = 1; index < arguments.length; index++) {
	        var source = arguments[index];
	        if (source !== undefined && source !== null) {
	          for (var nextKey in source) {
	            if (source.hasOwnProperty(nextKey)) {
	              output[nextKey] = source[nextKey];
	            }
	          }
	        }
	      }
	      return output;
	    };
	  })();
	}
	
	/**
	 * Array().fill polyfill for IE11
	 */
	if (!Array.prototype.fill) {
	  Array.prototype.fill = function (value) {
	    // Steps 1-2.
	    if (this === null) {
	      throw new TypeError('this is null or not defined');
	    }
	
	    var O = Object(this);
	
	    // Steps 3-5.
	    var len = O.length >>> 0;
	
	    // Steps 6-7.
	    var start = arguments[1];
	    var relativeStart = start >> 0;
	
	    // Step 8.
	    var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);
	
	    // Steps 9-10.
	    var end = arguments[2];
	    var relativeEnd = end === undefined ? len : end >> 0;
	
	    // Step 11.
	    var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);
	
	    // Step 12.
	    while (k < final) {
	      O[k] = value;
	      k++;
	    }
	
	    // Step 13.
	    return O;
	  };
	}
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(21);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(89);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(54);
	
	var _redux = __webpack_require__(71);
	
	var _reduxThunk = __webpack_require__(235);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxDevtoolsExtension = __webpack_require__(419);
	
	var _app = __webpack_require__(294);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _loadData = __webpack_require__(196);
	
	var _loadData2 = _interopRequireDefault(_loadData);
	
	var _fetchData = __webpack_require__(293);
	
	var _fetchData2 = _interopRequireDefault(_fetchData);
	
	var _reducers = __webpack_require__(303);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(300);
	
	var stores = [];
	
	/** We need to do this over EVERY INSTANCE OF COMPONENTS... */
	[].forEach.call(document.querySelectorAll('[kff-indicator-components]'), function (component, idx) {
	  // Create store with redux-thunk middleware,
	  // which allows us to async things in the actions
	  stores[idx] = (0, _redux.createStore)(_reducers2.default, (0, _reduxDevtoolsExtension.composeWithDevTools)((0, _redux.applyMiddleware)(_reduxThunk2.default)));
	
	  // Make reducers hot reloadable, see http://stackoverflow.com/questions/34243684/make-redux-reducers-and-other-non-components-hot-loadable
	  if (false) {
	    module.hot.accept('./reducers/', function () {
	      var nextRoootReducer = require('./reducers/').default; // eslint-disable-line global-require
	      stores[idx].replaceReducer(nextRoootReducer);
	    });
	  }
	
	  /**
	   * We load in initial data from the dom, because this is generated from a
	   * shortcode we cannot expect unique data in a global...
	   */
	  var appJs = JSON.parse(component.getAttribute('data-app-js'));
	  var gdocsObject = appJs.gdocs_object,
	      gdocsKey = appJs.gdocs_key,
	      type = appJs.type;
	
	  /**
	   * Check if gdocsObject has data (did wordpress save it in transient),
	   * if not we need to fetch the data ourselves
	   */
	
	  if (false !== gdocsObject) {
	    stores[idx].dispatch((0, _loadData2.default)(gdocsObject, type));
	  } else {
	    stores[idx].dispatch((0, _fetchData2.default)(gdocsKey, type));
	  }
	
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: stores[idx] },
	    _react2.default.createElement(_app2.default, null)
	  ), component);
	});
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(stores, 'stores', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/main.js');
	}();

	;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = dataReducer;
	
	var _types = __webpack_require__(87);
	
	var _updateData = __webpack_require__(197);
	
	var _updateData2 = _interopRequireDefault(_updateData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function dataReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _types.REQUEST_DATA:
	      return state;
	    case _types.RECEIVE_DATA:
	      {
	        return _extends({}, state, action.data, {
	          isFetching: false
	        });
	      }
	    case _types.UPDATE_SELECTED:
	      {
	        return _extends({}, state, {
	          selectedDistributions: action.data.selectedDistributions
	        }, (0, _updateData2.default)(state, _extends({}, state.selected, action.data)));
	      }
	    case _types.FETCH_GDOC_DATA:
	      {
	        return _extends({}, state, {
	          didInvalidate: true,
	          isFetching: true
	        });
	      }
	    case _types.FETCH_GDOC_DATA_ERROR:
	      {
	        return _extends({}, state, {
	          didInvalidate: false,
	          isFetching: false,
	          error: true,
	          lastUpdated: action.receivedAt
	        });
	      }
	    case _types.FETCH_GDOC_DATA_SUCCESS:
	      {
	        return _extends({}, state, {
	          gdocData: action.data,
	          didInvalidate: false,
	          isFetching: false,
	          lastUpdated: action.receivedAt
	        });
	      }
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(dataReducer, 'dataReducer', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/reducers/default.js');
	}();

	;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(71);
	
	var _default2 = __webpack_require__(302);
	
	var _default3 = _interopRequireDefault(_default2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Combine all reducers in this file and export the combined reducers.
	 * If we were to do this in store.js, reducers would not be hot-reloadable
	 */
	
	var _default = (0, _redux.combineReducers)({
	  data: _default3.default
	});
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/reducers/index.js');
	}();

	;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = downloadCSV;
	
	var _mori = __webpack_require__(65);
	
	var _mori2 = _interopRequireDefault(_mori);
	
	var _processTableDataForDownload = __webpack_require__(291);
	
	var _renderData = __webpack_require__(292);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function downloadCSV(api, table, timeframes, config, immutableHeaders, immutableDataviews) {
	  var notes = _mori2.default.intoArray((0, _renderData.renderNotes)(config, timeframes, {})).reduce(function (prev, curr) {
	    return prev + '"' + curr.name + '"\n' + curr.val.reduce(function (prev1, curr1) {
	      return prev1 + '"' + curr1.Note.replace(/["\u201C\u201D]/g, '""').split('\n').join('"\n"') + '"\n';
	    }, '') + '\n';
	  }, '\n');
	
	  var headers = _mori2.default.filter(function (item) {
	    return 'Location' === _mori2.default.get(item, 'type') || _mori2.default.get(item, 'type') === _mori2.default.get(immutableDataviews,
	    /* this.router.currentParams.dataView || */0).type;
	  }, immutableHeaders);
	
	  var customHeader = ['"Title: ' + document.title + '"', '"Timeframe: ' + timeframes[0] + '"', ''].join('\n');
	
	  var customFooter = [notes].join('\n');
	
	  var dataAsCsv = api.getDataAsCsv({
	    customFooter: customFooter,
	    customHeader: customHeader,
	    processCellCallback: (0, _processTableDataForDownload.processCellCallback)(headers)
	  });
	
	  (0, _processTableDataForDownload.downloader)('raw_data.csv', dataAsCsv);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(downloadCSV, 'downloadCSV', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/services/downloadCSV.js');
	}();

	;

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDisplayName = getDisplayName;
	exports.waitTillExists = waitTillExists;
	/* eslint-disable import/prefer-default-export */
	/**
	 * Misc util functions that don't belong anywhere else.
	 * Each util function MUST HAVE a JSDoc description on them
	 */
	
	/**
	 * Return the components display name (eases debugging with high order components)
	 * @param  {class} Component  [React Component]
	 * @return {string}           [display name of component]
	 */
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || 'Component';
	}
	
	/**
	 * Wait till an element exists on the page to execute a callback
	 * @param  {string} selector [CSS selector]
	 * @param  {func} callback   [callback]
	 * @return {null}
	 */
	function waitTillExists(selector, callback) {
	  var check = setInterval(function () {
	    if (null !== document.querySelector(selector)) {
	      callback();
	      clearInterval(check);
	    }
	  }, 10);
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getDisplayName, 'getDisplayName', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/services/util.js');
	
	  __REACT_HOT_LOADER__.register(waitTillExists, 'waitTillExists', '/Users/danbowles/broadway/themes/vip/kaiser-foundation-2016/build/apps/react-datacenter/app/services/util.js');
	}();

	;

/***/ }),
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(43)();
	// imports
	
	
	// module
	exports.push([module.id, ".ag-datacenter{color:#000;line-height:20px}.ag-datacenter div{color:inherit;font:inherit;line-height:inherit}.ag-datacenter img{border:0;vertical-align:middle}.ag-datacenter div.ag-root{font:13px/20px Droid Sans,helvetica,sans-serif}.ag-datacenter .ag-cell,.ag-datacenter .ag-no-scrolls .ag-header-container,.ag-datacenter .ag-scrolls .ag-header-container,.ag-datacenter .ag-scrolls .ag-row{white-space:normal}.ag-datacenter .ag-cell{background:#fff;border-right:1px solid #ccc;padding:5px}.ag-datacenter .ag-cell.ag-cell-no-focus{border-bottom:1px solid #ccc}.ag-datacenter .ag-cell.ag-cell-first-right-pinned{border-left:1px solid #ccc}.ag-datacenter .ag-cell.ag-cell-last-left-pinned{border-right:1px solid #ccc}.ag-datacenter .wrapup .ag-cell{color:#464646;background-color:#efefef;font-weight:700}.ag-datacenter .multiline .ag-cell{white-space:normal}.ag-datacenter .ag-pinned-left-cols-container{border-left:1px solid #ccc}.ag-datacenter div.ag-header,.ag-datacenter div.ag-header-container{border-left:1px solid #ccc;color:#fff;font:700 14px/20px Droid Sans,helvetica,sans-serif!important}.ag-datacenter .ag-header-container{position:relative}.ag-datacenter .ag-filter-icon{display:none}.ag-datacenter .ag-header-cell,.ag-datacenter .ag-header-group-cell{background:#024f88;border-right:1px solid #ccc;border-top:1px solid #ccc}.ag-datacenter .ag-header-cell.ag-header-group-cell-with-group,.ag-datacenter .ag-header-group-cell.ag-header-group-cell-with-group{border-bottom:1px solid #ccc}.ag-datacenter .ag-header-container .ag-header-row:nth-child(2) .ag-header-cell,.ag-datacenter .ag-pinned-left-header .ag-header-row:nth-child(2) .ag-header-cell{border-top:none}.ag-datacenter .ag-header-cell-label{box-sizing:border-box;cursor:pointer;height:100%;padding:15px 20px 0 8px;position:absolute;width:100%}.ag-datacenter .ag-header-cell-text{bottom:5px;left:8px;line-height:20px;position:absolute;width:calc(100% - 30px)}.ag-datacenter .ag-header-group-cell-label{line-height:20px;padding:5px 8px;text-align:center}.ag-datacenter .ag-header-cell-menu-button{display:none}.ag-datacenter .ag-pinned-left-header{border-right:1px solid #ccc}.ag-datacenter .ag-pinned-right-header{border-left:1px solid #ccc}.ag-datacenter .ag-header-icon{position:absolute;content:\"\";top:auto;bottom:16px;height:0;width:0;right:5px;border-left:4px solid transparent;border-right:4px solid transparent}.ag-datacenter .ag-header-icon span{display:block}.ag-datacenter .ag-header-icon span:after{position:absolute;content:\"\";top:8px;left:-4px;height:0;width:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:6px solid #959595}.ag-datacenter .ag-header-icon.ag-sort-ascending-icon{border-bottom:6px solid #de5a02}.ag-datacenter .ag-header-icon.ag-sort-descending-icon{border-bottom:6px solid #959595}.ag-datacenter .ag-header-icon.ag-sort-descending-icon span:after{border-top:6px solid #de5a02}.ag-datacenter .ag-header-icon.ag-sort-none-icon{border-bottom:6px solid #959595}.ag-datacenter .ag-body{background-color:#fff}.ag-datacenter .ag-overlay-loading-wrapper{background-color:hsla(0,0%,100%,.5)}.ag-datacenter .ag-overlay-loading-center{color:#000}.ag-datacenter .ag-overlay-loading-center,.ag-datacenter .ag-overlay-no-rows-center{background-color:#fff;border:1px solid #ccc;border-radius:10px;padding:10px}.ag-datacenter .ag-scroll-shadow-bottom,.ag-datacenter .ag-scroll-shadow-top{height:10px;position:absolute;width:100%}.ag-datacenter .ag-scroll-shadow-left,.ag-datacenter .ag-scroll-shadow-right{height:100%;position:absolute;top:0;width:10px}.ag-datacenter .ag-scroll-shadow-left{box-shadow:8px 0 10px -4px rgba(0,0,0,.25)}.ag-datacenter .ag-scroll-shadow-right{right:-10px;box-shadow:-8px 0 10px -4px rgba(0,0,0,.25)}.ag-datacenter .ag-scroll-shadow-top{box-shadow:0 8px 10px -4px rgba(0,0,0,.25);top:0}.ag-datacenter .ag-scroll-shadow-bottom{bottom:-10px;box-shadow:0 -8px 10px -4px rgba(0,0,0,.25)}", ""]);
	
	// exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(43)();
	// imports
	
	
	// module
	exports.push([module.id, ".ag-datacenter .ag-header-cell-label .ag-header-cell-text{font-size:14px;font-weight:700;line-height:18px}.ag-datacenter .ag-cell.ag-cell-last-left-pinned{border-right:2px solid #ccc}.ag-datacenter.print .ag-header-icon{display:none}", ""]);
	
	// exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(43)();
	// imports
	
	
	// module
	exports.push([module.id, "ag-grid-ng2{display:inline-block}.ag-rtl{direction:rtl}.ag-ltr{direction:ltr}.ag-select-agg-func-popup{position:absolute}.ag-body-no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ag-root{position:relative;box-sizing:border-box;overflow:hidden}.ag-font-style{cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ag-no-scrolls{white-space:nowrap;display:inline-block}.ag-scrolls{height:100%}.ag-popup-backdrop{position:fixed;left:0;top:0;width:100%;height:100%}.ag-header{position:absolute;top:0;left:0;white-space:nowrap;box-sizing:border-box;overflow:hidden;width:100%}.ag-pinned-left-header{float:left}.ag-pinned-left-header,.ag-pinned-right-header{box-sizing:border-box;display:inline-block;overflow:hidden;height:100%}.ag-pinned-right-header{float:right}.ag-header-viewport{box-sizing:border-box;overflow:hidden;height:100%}.ag-scrolls .ag-header-row{position:absolute}.ag-scrolls .ag-header-container{box-sizing:border-box;position:relative;white-space:nowrap;height:100%}.ag-no-scrolls .ag-header-container{white-space:nowrap}.ag-header-overlay{display:block;position:absolute}.ag-header-cell{vertical-align:bottom;text-align:center;display:inline-block;height:100%}.ag-dnd-ghost,.ag-header-cell{box-sizing:border-box;position:absolute}.ag-dnd-ghost{font-size:14px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;background:#e5e5e5;border:1px solid #000;cursor:move;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;overflow:hidden;text-overflow:ellipsis;padding:3px;line-height:1.4}.ag-dnd-ghost-icon{float:left;padding-left:2px;padding-right:2px}.ag-dnd-ghost-icon,.ag-dnd-ghost-label{display:inline-block}.ag-header-group-cell{height:100%;display:inline-block;box-sizing:border-box;position:absolute}.ag-header-cell-label,.ag-header-group-cell,.ag-header-group-cell-label{text-overflow:ellipsis;overflow:hidden}.ag-header-cell-resize{height:100%;width:4px;cursor:col-resize}.ag-ltr .ag-header-cell-resize{float:right}.ag-ltr .ag-pinned-right-header .ag-header-cell-resize,.ag-rtl .ag-header-cell-resize{float:left}.ag-rtl .ag-pinned-left-header .ag-header-cell-resize{float:right}.ag-header-expand-icon{padding-left:4px}.ag-header-cell-menu-button{float:right}.ag-overlay-panel{display:table;width:100%;height:100%;pointer-events:none}.ag-overlay-wrapper{display:table-cell;vertical-align:middle;text-align:center}.ag-bl-overlay{pointer-events:none;position:absolute;height:100%;width:100%;top:0;left:0}.ag-bl-full-height{height:100%;overflow:auto;position:relative}.ag-bl-full-height-west{height:100%;float:left}.ag-bl-full-height-east{height:100%;float:right}.ag-bl-full-height-center{height:100%}.ag-bl-normal{height:100%;position:relative}.ag-bl-normal-center-row{height:100%;overflow:hidden}.ag-bl-normal-west{height:100%;float:left}.ag-bl-normal-east{height:100%;float:right}.ag-bl-normal-center{height:100%}.ag-bl-dont-fill{position:relative}.ag-body{height:100%}.ag-body,.ag-floating-top{width:100%;box-sizing:border-box;position:absolute}.ag-floating-top{left:0;white-space:nowrap;overflow:hidden}.ag-pinned-left-floating-top{float:left}.ag-pinned-left-floating-top,.ag-pinned-right-floating-top{box-sizing:border-box;display:inline-block;overflow:hidden;height:100%;position:relative}.ag-pinned-right-floating-top{float:right}.ag-floating-top-viewport{box-sizing:border-box;overflow:hidden;height:100%}.ag-floating-top-container{box-sizing:border-box;position:relative;white-space:nowrap}.ag-floating-bottom{position:absolute;left:0;width:100%;white-space:nowrap;box-sizing:border-box;overflow:hidden}.ag-pinned-left-floating-bottom{float:left}.ag-pinned-left-floating-bottom,.ag-pinned-right-floating-bottom{box-sizing:border-box;display:inline-block;overflow:hidden;height:100%;position:relative}.ag-pinned-right-floating-bottom{float:right}.ag-floating-bottom-viewport{box-sizing:border-box;overflow:hidden;height:100%}.ag-floating-bottom-container{box-sizing:border-box;position:relative;white-space:nowrap}.ag-pinned-left-cols-viewport{float:left}.ag-pinned-left-cols-container{display:inline-block;position:relative}.ag-pinned-right-cols-viewport{float:right}.ag-ltr .ag-pinned-right-cols-viewport{overflow-x:hidden;overflow-y:auto}.ag-ltr .ag-pinned-left-cols-viewport,.ag-rtl .ag-pinned-right-cols-viewport{overflow:hidden}.ag-rtl .ag-pinned-left-cols-viewport{overflow-x:hidden;overflow-y:auto}.ag-pinned-right-cols-container{display:inline-block;position:relative}.ag-body-viewport-wrapper{height:100%}.ag-body-viewport{overflow-x:auto;overflow-y:auto;height:100%}.ag-full-width-viewport{height:100%;width:100%;position:absolute;top:0;left:0;display:inline;pointer-events:none;box-sizing:border-box;overflow:hidden}.ag-full-width-container{overflow:hidden;position:relative;width:100%}.ag-floating-bottom-full-width-container,.ag-floating-top-full-width-container{height:100%;width:100%;position:absolute;top:0;left:0;pointer-events:none;overflow:hidden;display:inline}.ag-full-width-row{pointer-events:all;overflow:hidden}.ag-scrolls .ag-body-container{position:relative;display:inline-block}.ag-row-animation{transition:top .4s,height .4s,background-color .1s,opacity .2s}.ag-row-no-animation{transition:background-color .1s}.ag-row{box-sizing:border-box}.ag-scrolls .ag-row{white-space:nowrap;position:absolute;width:100%}.ag-no-scrolls .ag-row{position:relative}.ag-column-drop{width:100%;box-sizing:border-box}.ag-column-drop-vertical .ag-column-drop-cell,.ag-column-drop-vertical .ag-column-drop-empty-message{display:block}.ag-column-drop-vertical .ag-column-drop-cell-button{line-height:16px}.ag-ltr .ag-column-drop-vertical .ag-column-drop-cell-button{float:right}.ag-rtl .ag-column-drop-vertical .ag-column-drop-cell-button{float:left}.ag-column-drop-horizontal{white-space:nowrap}.ag-cell,.ag-column-drop-horizontal .ag-column-drop-cell,.ag-column-drop-horizontal .ag-column-drop-empty-message{display:inline-block}.ag-cell{white-space:nowrap;height:100%;box-sizing:border-box;text-overflow:ellipsis;overflow:hidden;position:absolute}.ag-value-slide-out{opacity:1;-ms-filter:none;-webkit-filter:none;filter:none;margin-right:5px;transition:opacity 3s,margin-right 3s;transition-timing-function:linear}.ag-value-slide-out-end{margin-right:10px}.ag-opacity-zero,.ag-value-slide-out-end{opacity:0;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";filter:alpha(opacity=0)}.ag-cell-edit-input{width:100%;height:100%}.ag-footer-cell-entire-row,.ag-group-cell-entire-row{width:100%;display:inline-block;white-space:nowrap;height:100%;box-sizing:border-box;text-overflow:ellipsis;overflow:hidden}.ag-large .ag-root{font-size:20px}.ag-menu,.ag-popup-editor{position:absolute;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ag-menu-column-select-wrapper{width:200px;height:300px;overflow:auto}.ag-menu-list{display:table;border-collapse:collapse}.ag-menu-option{display:table-row}.ag-menu-option-icon,.ag-menu-option-popup-pointer,.ag-menu-option-shortcut,.ag-menu-option-text{display:table-cell}.ag-menu-separator{display:table-row}.ag-menu-separator-cell{display:table-cell}.ag-virtual-list-viewport{overflow-x:auto;height:100%;width:100%}.ag-virtual-list-container{position:relative;overflow:hidden}.ag-rich-select{outline:none}.ag-rich-select-list,.ag-set-filter-list{width:200px;height:200px}.ag-set-filter-item{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.ag-virtual-list-item{position:absolute;width:100%}.ag-filter-filter{width:170px;margin:4px}.ag-filter-select{width:110px;margin:4px 4px 0}.ag-no-vertical-scroll .ag-body,.ag-no-vertical-scroll .ag-body-viewport,.ag-no-vertical-scroll .ag-body-viewport-wrapper,.ag-no-vertical-scroll .ag-scrolls{height:unset}.ag-list-selection,.ag-tool-panel{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.ag-tool-panel{width:200px;height:100%;box-sizing:border-box;overflow:auto}.ag-column-select-indent{display:inline-block}.ag-column-select-column{white-space:nowrap}.ag-ltr .ag-column-select-column{margin-left:14px}.ag-rtl .ag-column-select-column{margin-right:14px}.ag-column-select-column-group{white-space:nowrap}.ag-hidden{display:none!important}.ag-faded{opacity:.3;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=30)\";filter:alpha(opacity=30)}.ag-width-half{width:50%;display:inline-block}.ag-shake-left-to-right{-webkit-animation-name:ag-shake-left-to-right;animation-name:ag-shake-left-to-right;-webkit-animation-duration:.2s;animation-duration:.2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-direction:alternate;animation-direction:alternate}@-webkit-keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}@keyframes ag-shake-left-to-right{0%{padding-left:6px;padding-right:2px}to{padding-left:2px;padding-right:6px}}", ""]);
	
	// exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(43)();
	// imports
	
	
	// module
	exports.push([module.id, ".app__loadingPlaceholder___2oLG-{position:relative}.app__loadingPlaceholder___2oLG- .app__text___3UtEM{color:#000!important;padding-top:60px;text-align:center;position:relative}.app__loadingPlaceholder___2oLG- .app__sub___1Olta{display:block;font-size:1em;font-weight:400;text-transform:none}.app__loadingPlaceholder___2oLG- .app__fa___2DuXs{font-style:normal;left:47.5%;position:absolute;top:0}", ""]);
	
	// exports
	exports.locals = {
		"loadingPlaceholder": "app__loadingPlaceholder___2oLG-",
		"text": "app__text___3UtEM",
		"sub": "app__sub___1Olta",
		"fa": "app__fa___2DuXs"
	};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(43)();
	// imports
	
	
	// module
	exports.push([module.id, ".index__dataMap___2HW3W{position:relative;display:block}", ""]);
	
	// exports
	exports.locals = {
		"dataMap": "index__dataMap___2HW3W"
	};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(43)();
	// imports
	
	
	// module
	exports.push([module.id, ".index__lightboxWrapper___3Dtat{background:hsla(0,0%,100%,.8);display:block;height:100%;left:0;overflow:scroll;position:fixed;top:0;width:100%;z-index:99999}.index__lightbox___T8OqW{display:block;margin:10px;position:relative;z-index:2}.index__wrapperClick___N5X53{background:none;display:block;height:100%;position:absolute;width:100%;z-index:1}", ""]);
	
	// exports
	exports.locals = {
		"lightboxWrapper": "index__lightboxWrapper___3Dtat",
		"lightbox": "index__lightbox___T8OqW",
		"wrapperClick": "index__wrapperClick___N5X53"
	};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(43)();
	// imports
	
	
	// module
	exports.push([module.id, ".index__tableWrapper____Ke27{display:block;margin-bottom:20px;position:relative;width:800px}.index__tableWrapperLightbox___3PGtR{display:block;margin-bottom:0;position:relative}.index__toolBar___16qNL{background:#efefef;padding:5px 0;width:800px}.index__btnBar___UEY1D{display:inline-block;float:right}.index__note___1tqxq{line-height:18px}.index__btn___L6bMD,.index__note___1tqxq{background:#efefef;color:#464646;font-size:12px;font-family:Droid Sans,helvetica,sans-serif;padding:5px}.index__btn___L6bMD{border:1px solid #464646;border-radius:0;cursor:pointer;display:inline-block;line-height:14px;margin-right:5px}.index__btn___L6bMD:hover{color:#fff;background:#024f88}", ""]);
	
	// exports
	exports.locals = {
		"tableWrapper": "index__tableWrapper____Ke27",
		"tableWrapperLightbox": "index__tableWrapperLightbox___3PGtR",
		"toolBar": "index__toolBar___16qNL",
		"btnBar": "index__btnBar___UEY1D",
		"note": "index__note___1tqxq",
		"btn": "index__btn___L6bMD"
	};

/***/ }),
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.composeWithDevTools = (
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
	    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
	    function() {
	      if (arguments.length === 0) return undefined;
	      var compose = __webpack_require__(71).compose;
	      if (typeof arguments[0] === 'object') return compose;
	      return compose.apply(null, arguments);
	    }
	);


/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(308);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(45)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../react-datacenter/node_modules/css-loader/index.js!../../../react-datacenter/node_modules/postcss-loader/index.js!../../../react-datacenter/node_modules/sass-loader/index.js!./datacenter-ng-theme.scss", function() {
				var newContent = require("!!../../../react-datacenter/node_modules/css-loader/index.js!../../../react-datacenter/node_modules/postcss-loader/index.js!../../../react-datacenter/node_modules/sass-loader/index.js!./datacenter-ng-theme.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(309);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(45)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./ng-theme-overrides.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./ng-theme-overrides.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(310);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(45)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!../../../sass-loader/index.js!./ag-grid.css", function() {
				var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!../../../sass-loader/index.js!./ag-grid.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(311);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(45)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[name]__[local]___[hash:base64:5]!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./app.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[name]__[local]___[hash:base64:5]!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js!./app.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(312);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(45)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[name]__[local]___[hash:base64:5]!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./index.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[name]__[local]___[hash:base64:5]!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(313);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(45)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[name]__[local]___[hash:base64:5]!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./index.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[name]__[local]___[hash:base64:5]!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(314);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(45)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[name]__[local]___[hash:base64:5]!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./index.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?modules&localIdentName=[name]__[local]___[hash:base64:5]!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js!./index.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })
]);


// WEBPACK FOOTER //
// app-1.0.16.bundle.js